(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree635"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree635"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8Qls7", function(module, exports) {
(function() {
    const state = {
        basket: {},
        delay: {},
        compare: {},
        loaded: false,
        loadPromise: null,
        readyCallbacks: [],
        updateListeners: [],
        init () {
            const iblockId = this.getCurrentIblockId();
            this.loadPromise = this.fetchBasketData(iblockId).then((data)=>{
                this.basket = data.BASKET || {};
                this.delay = data.DELAY || {};
                this.compare = data.COMPARE || {};
                this.loaded = true;
                this._notifyReady();
                this._notifyUpdate();
            }).catch(()=>{
                this.loaded = true;
                this._notifyReady();
            });
            if (window.BX && typeof window.BX.addCustomEvent === 'function') window.BX.addCustomEvent('onCompleteAction', (eventData)=>{
                if (eventData && eventData.action && String(eventData.action).indexOf('loadBasket') === 0) this.refresh();
            });
        },
        refresh () {
            const iblockId = this.getCurrentIblockId();
            this.loadPromise = this.fetchBasketData(iblockId).then((data)=>{
                this.basket = data.BASKET || {};
                this.delay = data.DELAY || {};
                this.compare = data.COMPARE || {};
                this._notifyUpdate();
            }).catch(()=>{
            // ignore
            });
        },
        getCurrentIblockId () {
            const card = document.querySelector('#product-info-block');
            return card ? card.getAttribute('data-iblock-id') : 31;
        },
        fetchBasketData (iblockId) {
            return fetch(`/ajax/actualBasket.php?iblockID=${iblockId}`).then((response)=>response.text()).then((html)=>{
                const match = html.match(/var arBasketAspro = ({.*?});/s);
                if (match && match[1]) return eval('(' + match[1] + ')');
                return {};
            });
        },
        onReady (callback) {
            if (this.loaded) callback();
            else this.readyCallbacks.push(callback);
        },
        addUpdateListener (fn) {
            this.updateListeners.push(fn);
        },
        _notifyReady () {
            this.readyCallbacks.forEach((cb)=>cb());
            this.readyCallbacks = [];
        },
        _notifyUpdate () {
            this.updateListeners.forEach((fn)=>fn());
        }
    };
    window.CatalogCardState = state;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ()=>state.init());
    else state.init();
})();

});



(()=>{
    'use strict';
    const getSiteId = ()=>{
        if (window.arNextOptions?.SITE_ID) return window.arNextOptions.SITE_ID;
        if (window.BX && typeof window.BX.message === 'function') return window.BX.message('SITE_ID') || 's1';
        return 's1';
    };
    const escapeRegExp = (value)=>value.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&');
    const getCookie = (name)=>{
        const matches = document.cookie.match(new RegExp(`(?:^|; )${escapeRegExp(name)}=([^;]*)`));
        return matches ? decodeURIComponent(matches[1]) : null;
    };
    const setCookie = (name, value, days)=>{
        const date = new Date();
        date.setTime(date.getTime() + days * 86400000);
        document.cookie = `${name}=${encodeURIComponent(value)}; expires=${date.toUTCString()}; path=/`;
    };
    const readJsonCookie = (name)=>{
        const value = getCookie(name);
        return value ? JSON.parse(value) : {};
    };
    const readStorage = (key)=>{
        if (window.BX?.localStorage && typeof window.BX.localStorage.get === 'function') return window.BX.localStorage.get(key) || {};
        const value = window.localStorage.getItem(key);
        return value ? JSON.parse(value) : {};
    };
    const writeStorage = (key, value)=>{
        if (window.BX?.localStorage && typeof window.BX.localStorage.set === 'function') {
            window.BX.localStorage.set(key, value, 2592000);
            return;
        }
        window.localStorage.setItem(key, JSON.stringify(value));
    };
    window.setViewedProduct = (id, productData)=>{
        try {
            if (!id || !productData) return;
            const siteId = getSiteId();
            const localKey = `NEXT_VIEWED_ITEMS_${siteId}`;
            const productId = productData.PRODUCT_ID || id;
            const time = Date.now();
            const viewedLocal = readStorage(localKey);
            const viewedCookie = readJsonCookie(localKey);
            Object.keys(viewedLocal).forEach((itemId)=>{
                viewedLocal[itemId].IS_LAST = false;
                if (typeof viewedCookie[itemId] === 'undefined') delete viewedLocal[itemId];
            });
            Object.keys(viewedCookie).forEach((itemId)=>{
                if (typeof viewedLocal[itemId] === 'undefined') delete viewedCookie[itemId];
            });
            if (viewedLocal[productId] && viewedLocal[productId].ID && String(viewedLocal[productId].ID) !== String(id)) {
                delete viewedLocal[productId];
                delete viewedCookie[productId];
            }
            const nextProductData = {
                ...productData,
                ID: id,
                ACTIVE_FROM: time,
                IS_LAST: true
            };
            viewedLocal[productId] = nextProductData;
            viewedCookie[productId] = [
                String(time),
                productData.PICTURE_ID || false
            ];
            writeStorage(localKey, viewedLocal);
            setCookie(localKey, JSON.stringify(viewedCookie), 30);
        } catch (error) {
            console.error(error);
        }
    };
})();


/* global arNextOptions */ (()=>{
    const getCookieDomain = ()=>{
        if (window.arNextOptions && arNextOptions.SITE_ADDRESS) return arNextOptions.SITE_ADDRESS;
        return location.hostname;
    };
    const setCookie = (name, value, options = {})=>{
        let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
        if (options.path) cookie += `; path=${options.path}`;
        if (options.domain) cookie += `; domain=${options.domain}`;
        if (options.maxAge != null) cookie += `; max-age=${options.maxAge}`;
        if (options.expires instanceof Date) cookie += `; expires=${options.expires.toUTCString()}`;
        if (options.sameSite) cookie += `; samesite=${options.sameSite}`;
        if (options.secure) cookie += '; secure';
        document.cookie = cookie;
    };
    const deleteCookie = (name, domain)=>{
        setCookie(name, '', {
            path: '/',
            domain: domain,
            expires: new Date(0)
        });
    };
    document.addEventListener('click', (e)=>{
        const link = e.target.closest('.city_item');
        if (!link) return;
        e.preventDefault();
        const regionId = link.getAttribute('data-id');
        const href = link.getAttribute('href') || location.href;
        const domain = getCookieDomain();
        deleteCookie('current_region', domain);
        setCookie('current_region', regionId, {
            path: '/',
            domain: domain,
            sameSite: 'Lax',
            secure: location.protocol === 'https:'
        });
        location.href = href;
    });
})();


class $270d42601e2df068$export$2e2bcd8739ae039 {
    constructor(button){
        this.button = button;
        this.mobileMenuContainer = document.querySelector('.mobile-menu__container');
        this.html = document.querySelector('html');
        this.body = document.querySelector('body');
        this.header = document.querySelector('header');
        this.menu = document.querySelector('.mobile-menu');
        this.substitute = document.querySelector('.header-mobile__substitute');
        this.overlay = document.querySelector('.header-mobile__overlay-menu');
        this.modalUndefineRegion = document?.querySelector('.mobile-modal-regions-undefine');
        this.maxDepth = 3;
        this.depth = 0;
        this.eventRegister();
    }
    eventRegister() {
        this.button.addEventListener('click', ()=>this.toggleMenu());
        this.overlay.addEventListener('click', ()=>this.toggleMenu());
        this.overlay.addEventListener('touchmove', (e)=>{
            e.preventDefault();
        }, {
            passive: false
        });
        this.menu.addEventListener('click', (e)=>this.handleMenuClick(e));
    }
    toggleMenu() {
        if (!this.menu) return;
        this.menu.classList.toggle('mobile-menu__is-open');
        const isOpen = this.menu.classList.contains('mobile-menu__is-open');
        if (this.button) this.button.setAttribute('aria-expanded', String(isOpen));
        if (!isOpen) {
            this.mobileMenuContainer.style.position = '';
            this.header.style.position = '';
            this.header.style.height = '';
            this.overlay.style.backgroundColor = '';
            this.overlay.style.display = '';
            this.substitute.style.display = '';
            this.substitute.style.height = '';
            this.html.classList.remove('scroll-lock');
            this.body.classList.remove('scroll-lock');
            document.documentElement.overflowY = '';
            if (this.modalUndefineRegion) this.modalUndefineRegion.style.display = '';
            this.reset();
            return;
        }
        this.mobileMenuContainer.style.position = 'static';
        this.header.style.position = 'absolute';
        this.header.style.top = '0';
        this.overlay.style.backgroundColor = '#00000099';
        this.overlay.style.display = 'block';
        this.header.style.height = 'fit-content';
        this.substitute.style.display = 'block';
        this.substitute.style.height = '72px';
        this.html.classList.add('scroll-lock');
        this.body.classList.add('scroll-lock');
        document.documentElement.overflowY = 'hidden';
        if (this.modalUndefineRegion) this.modalUndefineRegion.style.display = 'none';
    }
    handleMenuClick(e) {
        const link = e.target?.closest('.mobile-menu__link');
        if (!link) return;
        if (link.dataset.menuBack === '1') {
            e.preventDefault();
            this.closeLevel(link);
            return;
        }
        const parentLi = link.closest('.mobile-menu__parent-li');
        this.parentUl = parentLi?.parentElement;
        if (!parentLi) return;
        const childUl = parentLi.querySelector(':scope > .mobile-menu__children-ul');
        if (!childUl || this.depth >= this.maxDepth - 1) return;
        e.preventDefault();
        this.openLevel(parentLi, childUl);
    }
    openLevel(parentLi, childUl) {
        this.depth += 1;
        this.savedScrollTop = this.menu.scrollTop;
        if (this.parentUl) {
            this.savedScrollTopParentUl = this.parentUl.scrollTop;
            setTimeout(()=>{
                this.parentUl.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }, 1);
            this.parentUl.style.overflowY = 'hidden';
        }
        setTimeout(()=>{
            this.menu.scrollTo({
                top: 0
            });
        }, 200);
        setTimeout(()=>{
            this.menu.style.overflowY = 'hidden';
        }, 200);
        this.header.style.overflow = 'hidden';
        if (childUl.parentElement !== this.menu) {
            const placeholder = document.createElement('span');
            placeholder.style.display = 'none';
            childUl.after(placeholder);
            childUl._placeholder = placeholder;
        }
        childUl.classList.remove('mobile-menu__is-open', 'mobile-menu__is-closing');
        childUl.offsetWidth;
        requestAnimationFrame(()=>{
            childUl.classList.add('mobile-menu__is-open');
        });
    }
    closeLevel(backLink) {
        const currentUl = backLink.closest('.mobile-menu__children-ul');
        if (!currentUl) return;
        currentUl.classList.remove('mobile-menu__is-open');
        currentUl.classList.add('mobile-menu__is-closing');
        if (this.depth > 0) this.depth -= 1;
        if (this.depth === 0) {
            this.header.style.overflowY = '';
            this.menu.style.overflowY = '';
            this.menu.scrollTo({
                top: this.savedScrollTop,
                behavior: 'smooth'
            });
        }
        if (this.parentUl) {
            setTimeout(()=>{
                this.parentUl.scrollTo({
                    top: this.savedScrollTopParentUl,
                    behavior: 'smooth'
                });
            }, 1);
            this.parentUl.style.overflowY = 'auto';
        }
        setTimeout(()=>{
            if (currentUl._placeholder && currentUl._placeholder.parentElement) {
                currentUl._placeholder.before(currentUl);
                currentUl._placeholder.remove();
                delete currentUl._placeholder;
            }
            currentUl.scrollTop = 0;
            currentUl.style.top = '';
            currentUl.style.height = '';
        }, 300);
    }
    reset() {
        this.depth = 0;
        this.savedScrollTop = 0;
        this.savedScrollTopParentUl = 0;
        if (this.header) this.header.style.overflowY = '';
        if (this.menu) {
            this.menu.style.overflowY = '';
            this.menu.scrollTo({
                top: 0
            });
        }
        if (this.parentUl) {
            this.parentUl.style.overflowY = '';
            this.parentUl.scrollTo({
                top: 0
            });
        }
        if (!this.menu) return;
        const container = this.menu;
        container.querySelectorAll('.mobile-menu__children-ul').forEach((ul)=>{
            ul.classList.remove('mobile-menu__is-open', 'mobile-menu__is-closing');
            if (ul._placeholder && ul._placeholder.parentElement) {
                ul._placeholder.before(ul);
                ul._placeholder.remove();
                delete ul._placeholder;
            }
            ul.style.top = '';
            ul.style.height = '';
        });
    }
    closeMenu() {
        if (!this.menu) return;
        if (!this.menu.classList.contains('mobile-menu__is-open')) return;
        this.toggleMenu();
    }
}


class $fa902256f55a54d3$export$2e2bcd8739ae039 {
    constructor(button){
        this.button = button;
        this.phonesContainer = document.querySelector('.header-mobile__phones');
        this.overlay = document.querySelector('.header__overlay');
        this.buttonClose = this.phonesContainer.querySelector('.header-mobile__phones-close');
        this.buttonMenu = document.querySelector('.header-mobile__burger');
        this.mobileMenu = document.querySelector('.mobile-menu');
        this.eventRegister();
    }
    openPhoneList() {
        let height = this.phonesContainer.scrollHeight + 'px';
        if (this.mobileMenu.classList.contains('mobile-menu__is-open')) return;
        this.phonesContainer.style.height = height;
        this.overlay.style.display = 'block';
        this.overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
        this.overlay.style.zIndex = '100';
    }
    closePhoneList() {
        this.phonesContainer.style.height = '';
        this.overlay.style.display = '';
        this.overlay.style.zIndex = '';
        this.overlay.style.removeProperty('background-color');
    }
    eventRegister() {
        this.button.addEventListener('click', ()=>{
            this.openPhoneList();
        });
        this.overlay.addEventListener('click', ()=>{
            this.closePhoneList();
        });
        this.buttonClose.addEventListener('click', ()=>{
            this.closePhoneList();
        });
        this.buttonMenu.addEventListener('click', ()=>{
            this.closePhoneList();
        });
    }
}


class $e0d3a195495f772f$export$2e2bcd8739ae039 {
    constructor(catalog, mobileMenu){
        this.catalog = catalog;
        this.mobileMenu = mobileMenu;
        this.sections = catalog.querySelector('.header-desktop__catalog-left');
        this.headerDesktopContainer = document.querySelector('.header-desktop__container');
        this.wrapperClass = 'header-desktop__catalog-modal';
        this.containerClass = 'header-desktop__catalog-modal-container';
        this.eventRegister();
        this.handleResize(false);
    }
    eventRegister() {
        window.addEventListener('resize', ()=>this.handleResize(true));
    }
    createWrapper() {
        if (!this.sections) return;
        if (window.innerWidth < 992) return;
        if (this.sections.closest(`.${this.wrapperClass}`)) return;
        if (!this.headerDesktopContainer.classList.contains('main__container')) this.headerDesktopContainer.classList.add('main__container');
        const wrapper = document.createElement('div');
        wrapper.classList.add(this.wrapperClass);
        const container = document.createElement('div');
        container.classList.add(this.containerClass);
        const parent = this.sections.parentNode;
        parent.insertBefore(wrapper, this.sections);
        wrapper.appendChild(container);
        container.appendChild(this.sections);
    }
    removeWrapper() {
        if (!this.sections) return;
        if (this.headerDesktopContainer.classList.contains('main__container')) this.headerDesktopContainer.classList.remove('main__container');
        const wrapper = this.sections.closest(`.${this.wrapperClass}`);
        const container = this.sections.closest(`.${this.containerClass}`);
        if (!wrapper || !container) return;
        const parent = wrapper.parentNode;
        parent.insertBefore(this.sections, wrapper);
        wrapper.remove();
    }
    handleResize(shouldCloseMenu = false) {
        if (!this.sections) return;
        if (shouldCloseMenu) this.mobileMenu?.closeMenu?.();
        const isWrapped = !!this.sections.closest(`.${this.wrapperClass}`);
        if (window.innerWidth >= 992 && !isWrapped) {
            this.createWrapper();
            return;
        }
        if (window.innerWidth < 992 && isWrapped) this.removeWrapper();
    }
}


class $0405be755c2e9247$export$2e2bcd8739ae039 {
    constructor(categories){
        this.parentList = categories;
        this.parents = this.parentList.querySelectorAll(':scope > .menu-catalog-category');
        this.eventRegister();
    }
    eventRegister() {
        this.parents.forEach((item)=>{
            item.onmouseenter = ()=>{
                this.openChildList(item);
            };
        });
        document.addEventListener('closeModalCatalog', ()=>{
            this.reset();
        });
    }
    openChildList(parent) {
        this.reset();
        const childUl = parent.querySelector('.header-desktop__catalog-right');
        const rightContainer = document?.querySelector('.header-desktop__container-right');
        if (!childUl || !rightContainer) return;
        const placeholder = document.createElement('span');
        placeholder.style.display = 'none';
        childUl.after(placeholder);
        childUl._placeholder = placeholder;
        if (rightContainer) {
            rightContainer.append(childUl);
            childUl.style.display = 'flex';
            this.addHoverStyle(parent);
        }
    }
    addHoverStyle(element) {
        element.classList.add('header-desktop__catalog-left_active');
    }
    reset() {
        const rightContainer = document?.querySelector('.header-desktop__container-right');
        const childUl = rightContainer?.querySelector(':scope > .header-desktop__catalog-right');
        if (!childUl) return;
        const placeholder = childUl._placeholder;
        if (!placeholder) return;
        placeholder.before(childUl);
        childUl.parentElement.classList.remove('header-desktop__catalog-left_active');
        childUl.style.display = '';
    }
    addRightContainer() {
        const modalContainer = document.querySelector('.header-desktop__catalog-modal-container');
        if (!modalContainer) return;
        const possibleDuplicate = modalContainer.querySelector('.header-desktop__container-right');
        if (possibleDuplicate) return;
        const containerRight = document.createElement('div');
        containerRight.classList.add('header-desktop__container-right');
        modalContainer.appendChild(containerRight);
    }
    deleteRightContainer() {
        const rightContainer = document?.querySelector('.header-desktop__container-right');
        if (rightContainer) rightContainer.remove();
    }
}


class $08bfd85442043415$export$2e2bcd8739ae039 {
    constructor(button){
        this.button = button;
        this.modal = document.querySelector('.header-desktop__catalog-modal');
        this.close = document.querySelector('.header__overlay-catalog');
        this.categoryDepthLevelOne = document.querySelector('.header-desktop__catalog-left');
        this.modalCatalog = new (0, $0405be755c2e9247$export$2e2bcd8739ae039)(this.categoryDepthLevelOne);
        this.closeTimeout = null;
        this.eventRegister();
    }
    openModal() {
        const modal = document.querySelector('.header-desktop__catalog-modal');
        if (!modal || !this.close) return;
        modal.style.display = 'block';
        this.close.style.display = 'block';
        this.modalCatalog.addRightContainer();
    }
    closeModal() {
        const modal = document.querySelector('.header-desktop__catalog-modal');
        if (!modal || !this.close) return;
        modal.style.display = 'none';
        this.close.style.display = 'none';
        document.dispatchEvent(new CustomEvent('closeModalCatalog'));
        this.modalCatalog.deleteRightContainer();
    }
    addHoverButton() {
        this.button.classList.add('btn-catalog--active');
    }
    deleteHoverButton() {
        this.button.classList.remove('btn-catalog--active');
    }
    eventRegister() {
        this.button.addEventListener('mouseenter', ()=>{
            this.openTimeout = setTimeout(()=>{
                this.openModal();
                this.addHoverButton();
            }, 100);
        });
        this.button.addEventListener('mouseleave', ()=>{
            clearTimeout(this.openTimeout);
        });
        this.close.addEventListener('mouseenter', ()=>{
            this.closeTimeout = setTimeout(()=>{
                this.closeModal();
                this.deleteHoverButton();
            }, 300);
        });
        this.close.addEventListener('mouseleave', ()=>{
            clearTimeout(this.closeTimeout);
        });
    }
}


class $3a15d8fbfda7b37f$export$2e2bcd8739ae039 {
    constructor(button){
        this.button = button;
        this.regionsModal = document.querySelector('.modal-regions-other');
        this.buttonClose = document.querySelector('.modal-regions-other-close');
        this.overlay = document.querySelector('.header__overlay-region');
        this.eventRegister();
    }
    eventRegister() {
        this.button.addEventListener('click', (e)=>{
            e.preventDefault();
            this.openRegioModal();
        });
        this.buttonClose.addEventListener('click', ()=>{
            this.closeRegionModal();
        });
        this.overlay.addEventListener('click', ()=>{
            this.closeRegionModal();
        });
    }
    openRegioModal() {
        this.regionsModal.style.display = 'flex';
        this.overlay.style.display = 'block';
    }
    closeRegionModal() {
        this.regionsModal.style.display = '';
        this.overlay.style.display = '';
    }
}



class $21402ae12b57d773$export$2e2bcd8739ae039 {
    constructor(selector){
        this.button = document.querySelectorAll(selector);
        this.button.forEach((btn)=>{
            new (0, $3a15d8fbfda7b37f$export$2e2bcd8739ae039)(btn);
        });
        this.undefineRegion = document?.querySelectorAll('.modal-regions-undefined');
        this.buttonClose = this.undefineRegion;
        this.checkSelectedRegion();
        this.eventRegister();
    }
    eventRegister() {
        if (this.undefineRegion) this.undefineRegion.forEach((item)=>{
            const closeBtn = item.querySelector('.modal-regions-undefined__close');
            if (!closeBtn) return;
            closeBtn.addEventListener('click', ()=>{
                this.closeModalUndefine(item);
            });
        });
    }
    checkSelectedRegion() {
        const isRegionSelected = document.cookie.split('; ').some((item)=>item.startsWith('current_region='));
        if (isRegionSelected) return;
        this.undefineRegion.forEach((item)=>{
            item.style.display = 'flex';
        });
    }
    closeModalUndefine(modal) {
        if (modal) modal.style.display = 'none';
    }
}


window.addEventListener('DOMContentLoaded', ()=>{
    const buttonOpenClose = document.querySelector('.header-mobile__burger');
    const buttonPhone = document.querySelector('.header-mobile__phone-open');
    const buttonModalCatalog = document.getElementById('header-desktop__catalog-button');
    const modalDOM = document.querySelector('.header__nav-item-catalog');
    const buttonsChangeRegions = document.querySelector('.header-desktop__regions-current');
    const mobileButtonsChangeRegions = document.querySelector('.mobile-menu__change-region-submit');
    const mobileMenu = new (0, $270d42601e2df068$export$2e2bcd8739ae039)(buttonOpenClose);
    new (0, $21402ae12b57d773$export$2e2bcd8739ae039)('.modal-regions-undefined__choose');
    new (0, $3a15d8fbfda7b37f$export$2e2bcd8739ae039)(mobileButtonsChangeRegions);
    new (0, $3a15d8fbfda7b37f$export$2e2bcd8739ae039)(buttonsChangeRegions);
    new (0, $08bfd85442043415$export$2e2bcd8739ae039)(buttonModalCatalog);
    new (0, $e0d3a195495f772f$export$2e2bcd8739ae039)(modalDOM, mobileMenu);
    new (0, $fa902256f55a54d3$export$2e2bcd8739ae039)(buttonPhone);
});


(function() {
    const initBasketCounters = ()=>{
        const safeCount = (obj)=>obj && typeof obj === 'object' ? Object.keys(obj).length : 0;
        const setText = (id, value)=>{
            const el = document.getElementById(id);
            if (el) el.textContent = String(value);
        };
        const refreshBasketCounters = ()=>{
            const siteDir = window.arNextOptions && window.arNextOptions.SITE_DIR ? window.arNextOptions.SITE_DIR : '/';
            const url = siteDir.replace(/\/?$/, '/') + 'ajax/getAjaxBasket.php';
            fetch(url, {
                method: 'GET',
                credentials: 'same-origin',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            }).then((res)=>{
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                return res.json();
            }).then((data)=>{
                setText('mobile-menu-basket-count', safeCount(data.BASKET));
                setText('header-mobile-basket-count', safeCount(data.BASKET));
                setText('mobile-menu-delay-count', safeCount(data.DELAY));
                setText('mobile-menu-compare-count', safeCount(data.COMPARE));
            }).catch((e)=>{
                console.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F \u043A\u043E\u0440\u0437\u0438\u043D\u044B:", e);
            });
        };
        refreshBasketCounters();
        if (window.BX && typeof window.BX.addCustomEvent === 'function') window.BX.addCustomEvent('onCompleteAction', (eventData)=>{
            if (!eventData || !eventData.action) return;
            // Если событие связано с корзиной - обновляем цифры
            if (String(eventData.action).indexOf('loadBasket') === 0) refreshBasketCounters();
        });
    };
    const startCounters = ()=>{
        if (typeof window.BX !== 'undefined' && typeof window.BX.ready === 'function') window.BX.ready(initBasketCounters);
        else initBasketCounters();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startCounters);
    else startCounters();
})();


document.addEventListener('DOMContentLoaded', function() {
    var form = document.querySelector('[data-subscribe-form]');
    if (!form) return;
    var emailInput = form.querySelector('input[name="sf_EMAIL"]');
    var messageBox = form.parentElement.querySelector('.footer__subscribe-message');
    function isValidEmail(value) {
        return value.trim() && value.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
    }
    function showError() {
        if (isValidEmail(emailInput.value)) return;
        messageBox.style.display = 'block';
        messageBox.textContent = "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 e-mail";
        messageBox.className = 'footer__subscribe-message footer__subscribe-message--error';
    }
    function hideMessage() {
        messageBox.style.display = 'none';
        messageBox.textContent = '';
        messageBox.className = 'footer__subscribe-message';
    }
    document.addEventListener('click', function(e) {
        if (!form.contains(e.target)) {
            if (emailInput.value.trim() && !isValidEmail(emailInput.value)) showError();
        }
    });
    form.addEventListener('submit', function(e) {
        hideMessage();
        if (!emailInput.value.trim()) {
            e.preventDefault();
            showError();
            emailInput.focus();
            return;
        }
        if (!isValidEmail(emailInput.value)) {
            e.preventDefault();
            showError();
            emailInput.focus();
            return;
        }
    });
    emailInput.addEventListener('input', function() {
        hideMessage();
    });
    emailInput.addEventListener('blur', function() {
        if (emailInput.value.trim() && !isValidEmail(emailInput.value)) showError();
    });
});


/**
 * Swiper 12.2.0
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2026 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: May 27, 2026
 */ /**
 * SSR Window 5.0.1
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2025, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: June 27, 2025
 */ /* eslint-disable no-param-reassign */ function $6b317c2177284918$var$isObject(obj) {
    return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function $6b317c2177284918$var$extend(target = {}, src = {}) {
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    Object.keys(src).filter((key)=>noExtend.indexOf(key) < 0).forEach((key)=>{
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if ($6b317c2177284918$var$isObject(src[key]) && $6b317c2177284918$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $6b317c2177284918$var$extend(target[key], src[key]);
    });
}
const $6b317c2177284918$var$ssrDocument = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ''
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    }
};
function $6b317c2177284918$export$39b482c5e57630a8() {
    const doc = typeof document !== 'undefined' ? document : {};
    $6b317c2177284918$var$extend(doc, $6b317c2177284918$var$ssrDocument);
    return doc;
}
const $6b317c2177284918$var$ssrWindow = {
    document: $6b317c2177284918$var$ssrDocument,
    navigator: {
        userAgent: ''
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return '';
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === 'undefined') return;
        clearTimeout(id);
    }
};
function $6b317c2177284918$export$407448d2b89b1813() {
    const win = typeof window !== 'undefined' ? window : {};
    $6b317c2177284918$var$extend(win, $6b317c2177284918$var$ssrWindow);
    return win;
}



function $36f917fbf2efdd6b$export$342063e11d6c3cad(classes = '') {
    return classes.trim().split(' ').filter((c)=>!!c.trim());
}
function $36f917fbf2efdd6b$export$4a5767248b18ef41(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5(callback, delay = 0) {
    return setTimeout(callback, delay);
}
function $36f917fbf2efdd6b$export$dda1d9f60106f0e9() {
    return Date.now();
}
function $36f917fbf2efdd6b$var$getComputedStyle(el) {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $36f917fbf2efdd6b$export$882b5998b3b9117c(el, axis = 'x') {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $36f917fbf2efdd6b$var$getComputedStyle(el);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) curTransform = curTransform.split(', ').map((a)=>a.replace(',', '.')).join(', ');
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
    }
    if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $36f917fbf2efdd6b$export$ffb5f4729a158638(o) {
    return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function $36f917fbf2efdd6b$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $36f917fbf2efdd6b$export$d141bba7fdc215a3(...args) {
    const to = Object(args[0]);
    for(let i = 1; i < args.length; i += 1){
        const nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null && !$36f917fbf2efdd6b$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>key !== '__proto__' && key !== 'constructor' && key !== 'prototype');
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($36f917fbf2efdd6b$export$ffb5f4729a158638(to[nextKey]) && $36f917fbf2efdd6b$export$ffb5f4729a158638(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $36f917fbf2efdd6b$export$d141bba7fdc215a3(to[nextKey], nextSource[nextKey]);
                    } else if (!$36f917fbf2efdd6b$export$ffb5f4729a158638(to[nextKey]) && $36f917fbf2efdd6b$export$ffb5f4729a158638(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $36f917fbf2efdd6b$export$d141bba7fdc215a3(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $36f917fbf2efdd6b$export$8b22cf2602fb60ce(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $36f917fbf2efdd6b$export$3b14a55fb2447963({ swiper: swiper, targetPosition: targetPosition, side: side }) {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = 'none';
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? 'next' : 'prev';
    const isOutOfBound = (current, target)=>{
        return dir === 'next' && current >= target || dir === 'prev' && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.scrollSnapType = '';
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = '';
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function $36f917fbf2efdd6b$export$39b482c5e57630a8(slideEl) {
    return slideEl.querySelector('.swiper-slide-transform') || slideEl.shadowRoot && slideEl.shadowRoot.querySelector('.swiper-slide-transform') || slideEl;
}
function $36f917fbf2efdd6b$export$f1e1789686576879(element, selector = '') {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    const children = [
        ...element.children
    ];
    if (window1.HTMLSlotElement && element instanceof HTMLSlotElement) children.push(...element.assignedElements());
    if (!selector) return children;
    return children.filter((el)=>el.matches(selector));
}
function $36f917fbf2efdd6b$var$elementIsChildOfSlot(el, slot) {
    // Breadth-first search through all parent's children and assigned elements
    const elementsQueue = [
        slot
    ];
    while(elementsQueue.length > 0){
        const elementToCheck = elementsQueue.shift();
        if (el === elementToCheck) return true;
        elementsQueue.push(...elementToCheck.children, ...elementToCheck.shadowRoot ? elementToCheck.shadowRoot.children : [], ...elementToCheck.assignedElements ? elementToCheck.assignedElements() : []);
    }
}
function $36f917fbf2efdd6b$export$efccba1c4a2ef57b(el, parent) {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    let isChild = parent.contains(el);
    if (!isChild && window1.HTMLSlotElement && parent instanceof HTMLSlotElement) {
        const children = [
            ...parent.assignedElements()
        ];
        isChild = children.includes(el);
        if (!isChild) isChild = $36f917fbf2efdd6b$var$elementIsChildOfSlot(el, parent);
    }
    return isChild;
}
function $36f917fbf2efdd6b$export$90a7f3efeed30595(text) {
    try {
        console.warn(text);
        return;
    } catch (err) {
    // err
    }
}
function $36f917fbf2efdd6b$export$db3b6bfb95261072(tag, classes = []) {
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes) ? classes : $36f917fbf2efdd6b$export$342063e11d6c3cad(classes));
    return el;
}
function $36f917fbf2efdd6b$export$2d1720544b23b823(el) {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    const document1 = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    const box = el.getBoundingClientRect();
    const body = document1.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    const scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function $36f917fbf2efdd6b$export$625550452a3fa3ec(el, selector) {
    const prevEls = [];
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function $36f917fbf2efdd6b$export$43caf9889c228507(el, selector) {
    const nextEls = [];
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function $36f917fbf2efdd6b$export$9e5f44173e64f162(el, prop) {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function $36f917fbf2efdd6b$export$35e795649ee09318(el) {
    let child = el;
    let i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $36f917fbf2efdd6b$export$4368d992c4eafac0(el, selector) {
    const parents = []; // eslint-disable-line
    let parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $36f917fbf2efdd6b$export$ae1af26003f05816(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener('transitionend', fireCallBack);
    }
    if (callback) el.addEventListener('transitionend', fireCallBack);
}
function $36f917fbf2efdd6b$export$23f2a1d2818174ef(el, size, includeMargins) {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    if (includeMargins) return el[size === 'width' ? 'offsetWidth' : 'offsetHeight'] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-right' : 'margin-top')) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-left' : 'margin-bottom'));
    return el.offsetWidth;
}
function $36f917fbf2efdd6b$export$953cecd6e717a553(el) {
    return (Array.isArray(el) ? el : [
        el
    ]).filter((e)=>!!e);
}
function $36f917fbf2efdd6b$export$407448d2b89b1813(swiper) {
    return (v)=>{
        if (Math.abs(v) > 0 && swiper.browser && swiper.browser.need3dFix && Math.abs(v) % 90 === 0) return v + 0.001;
        return v;
    };
}
function $36f917fbf2efdd6b$export$2408f22a0fab9ae5(el, html = '') {
    if (typeof trustedTypes !== 'undefined') el.innerHTML = trustedTypes.createPolicy('html', {
        createHTML: (s)=>s
    }).createHTML(html);
    else el.innerHTML = html;
}


let $029bc59d811a92d7$var$support;
function $029bc59d811a92d7$var$calcSupport() {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    const document1 = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    return {
        smoothScroll: document1.documentElement && document1.documentElement.style && 'scrollBehavior' in document1.documentElement.style,
        touch: !!('ontouchstart' in window1 || window1.DocumentTouch && document1 instanceof window1.DocumentTouch)
    };
}
function $029bc59d811a92d7$var$getSupport() {
    if (!$029bc59d811a92d7$var$support) $029bc59d811a92d7$var$support = $029bc59d811a92d7$var$calcSupport();
    return $029bc59d811a92d7$var$support;
}
let $029bc59d811a92d7$var$deviceCached;
function $029bc59d811a92d7$var$calcDevice({ userAgent: userAgent } = {}) {
    const support = $029bc59d811a92d7$var$getSupport();
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    const platform = window1.navigator.platform;
    const ua = userAgent || window1.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window1.screen.width;
    const screenHeight = window1.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad)(?!\1).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === 'Win32';
    let macos = platform === 'MacIntel';
    // iPadOs 13 fix
    const iPadScreens = [
        '1024x1366',
        '1366x1024',
        '834x1194',
        '1194x834',
        '834x1112',
        '1112x834',
        '768x1024',
        '1024x768',
        '820x1180',
        '1180x820',
        '810x1080',
        '1080x810'
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            '13_0_0'
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = 'android';
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
    }
    // Export object
    return device;
}
function $029bc59d811a92d7$var$getDevice(overrides = {}) {
    if (!$029bc59d811a92d7$var$deviceCached) $029bc59d811a92d7$var$deviceCached = $029bc59d811a92d7$var$calcDevice(overrides);
    return $029bc59d811a92d7$var$deviceCached;
}
let $029bc59d811a92d7$var$browser;
function $029bc59d811a92d7$var$calcBrowser() {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    const device = $029bc59d811a92d7$var$getDevice();
    let needPerspectiveFix = false;
    function isSafari() {
        const ua = window1.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }
    if (isSafari()) {
        const ua = String(window1.navigator.userAgent);
        if (ua.includes('Version/')) {
            const [major, minor] = ua.split('Version/')[1].split(' ')[0].split('.').map((num)=>Number(num));
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window1.navigator.userAgent);
    const isSafariBrowser = isSafari();
    const need3dFix = isSafariBrowser || isWebView && device.ios;
    return {
        isSafari: needPerspectiveFix || isSafariBrowser,
        needPerspectiveFix: needPerspectiveFix,
        need3dFix: need3dFix,
        isWebView: isWebView
    };
}
function $029bc59d811a92d7$var$getBrowser() {
    if (!$029bc59d811a92d7$var$browser) $029bc59d811a92d7$var$browser = $029bc59d811a92d7$var$calcBrowser();
    return $029bc59d811a92d7$var$browser;
}
function $029bc59d811a92d7$var$Resize({ swiper: swiper, on: on, emit: emit }) {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window1.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach(({ contentBoxSize: contentBoxSize, contentRect: contentRect, target: target })=>{
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window1.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
    };
    on('init', ()=>{
        if (swiper.params.resizeObserver && typeof window1.ResizeObserver !== 'undefined') {
            createObserver();
            return;
        }
        window1.addEventListener('resize', resizeHandler);
        window1.addEventListener('orientationchange', orientationChangeHandler);
    });
    on('destroy', ()=>{
        removeObserver();
        window1.removeEventListener('resize', resizeHandler);
        window1.removeEventListener('orientationchange', orientationChangeHandler);
    });
}
function $029bc59d811a92d7$var$Observer({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const observers = [];
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    const attach = (target, options = {})=>{
        const ObserverFunc = window1.MutationObserver || window1.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit('observerUpdate', mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit('observerUpdate', mutations[0]);
            };
            if (window1.requestAnimationFrame) window1.requestAnimationFrame(observerUpdate);
            else window1.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: swiper.isElement || (typeof options.childList === 'undefined' ? true : options).childList,
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = (0, $36f917fbf2efdd6b$export$4368d992c4eafac0)(swiper.hostEl);
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on('init', init);
    on('destroy', destroy);
}
/* eslint-disable no-underscore-dangle */ var $029bc59d811a92d7$var$eventsEmitter = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        events.split(' ').forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        function onceHandler(...args) {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach((event)=>{
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit (...args) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function $029bc59d811a92d7$var$updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $36f917fbf2efdd6b$export$9e5f44173e64f162)(el, 'padding-left') || 0, 10) - parseInt((0, $36f917fbf2efdd6b$export$9e5f44173e64f162)(el, 'padding-right') || 0, 10);
    height = height - parseInt((0, $36f917fbf2efdd6b$export$9e5f44173e64f162)(el, 'padding-top') || 0, 10) - parseInt((0, $36f917fbf2efdd6b$export$9e5f44173e64f162)(el, 'padding-bottom') || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function $029bc59d811a92d7$var$updateSlides() {
    const swiper = this;
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { wrapperEl: wrapperEl, slidesEl: slidesEl, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    const swiperSize = swiper.size - offsetBefore - offsetAfter;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween - offsetBefore - offsetAfter;
    // reset margins
    slides.forEach((slideEl)=>{
        if (rtl) slideEl.style.marginLeft = '';
        else slideEl.style.marginRight = '';
        slideEl.style.marginBottom = '';
        slideEl.style.marginTop = '';
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $36f917fbf2efdd6b$export$8b22cf2602fb60ce)(wrapperEl, '--swiper-centered-offset-before', '');
        (0, $36f917fbf2efdd6b$export$8b22cf2602fb60ce)(wrapperEl, '--swiper-centered-offset-after', '');
    }
    // set cssMode offsets
    if (params.cssMode) {
        (0, $36f917fbf2efdd6b$export$8b22cf2602fb60ce)(wrapperEl, '--swiper-slides-offset-before', `${offsetBefore}px`);
        (0, $36f917fbf2efdd6b$export$8b22cf2602fb60ce)(wrapperEl, '--swiper-slides-offset-after', `${offsetAfter}px`);
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slides);
    else if (swiper.grid) swiper.grid.unsetSlides();
    // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== 'undefined';
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        const slide = slides[i];
        if (slide) {
            if (gridEnabled) swiper.grid.updateSlide(i, slide, slides);
            if ((0, $36f917fbf2efdd6b$export$9e5f44173e64f162)(slide, 'display') === 'none') continue; // eslint-disable-line
        }
        if (isVirtual && params.slidesPerView === 'auto') {
            if (params.virtual.slidesPerViewAutoSlideSize) slideSize = params.virtual.slidesPerViewAutoSlideSize;
            if (slideSize && slide) {
                if (params.roundLengths) slideSize = Math.floor(slideSize);
                slide.style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
            }
        } else if (params.slidesPerView === 'auto') {
            if (shouldResetSlideSize) slide.style[swiper.getDirectionLabel('width')] = ``;
            const slideStyles = getComputedStyle(slide);
            const currentTransform = slide.style.transform;
            const currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = 'none';
            if (currentWebKitTransform) slide.style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $36f917fbf2efdd6b$export$23f2a1d2818174ef)(slide, 'width', true) : (0, $36f917fbf2efdd6b$export$23f2a1d2818174ef)(slide, 'height', true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, 'width');
                const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                const boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slide) slide.style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
        }
        if (slide) slide.swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    if (params.setWrapperSize) wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        // Check if snapToSlideEdge should be applied
        const isFractionalSlidesPerView = params.slidesPerView !== 'auto' && params.slidesPerView % 1 !== 0;
        const shouldSnapToSlideEdge = params.snapToSlideEdge && !params.loop && (params.slidesPerView === 'auto' || isFractionalSlidesPerView);
        // Calculate the last allowed snap index when snapToSlideEdge is enabled
        // This ensures minimum slides are visible at the end
        let lastAllowedSnapIndex = snapGrid.length;
        if (shouldSnapToSlideEdge) {
            let minVisibleSlides;
            if (params.slidesPerView === 'auto') {
                // For 'auto' mode, calculate how many slides fit based on actual sizes
                minVisibleSlides = 1;
                let accumulatedSize = 0;
                for(let i = slidesSizesGrid.length - 1; i >= 0; i -= 1){
                    accumulatedSize += slidesSizesGrid[i] + (i < slidesSizesGrid.length - 1 ? spaceBetween : 0);
                    if (accumulatedSize <= swiperSize) minVisibleSlides = slidesSizesGrid.length - i;
                    else break;
                }
            } else minVisibleSlides = Math.floor(params.slidesPerView);
            lastAllowedSnapIndex = Math.max(slidesLength - minVisibleSlides, 0);
        }
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (shouldSnapToSlideEdge) // When snapToSlideEdge is enabled, only keep snaps up to lastAllowedSnapIndex
            {
                if (i <= lastAllowedSnapIndex) newSlidesGrid.push(slidesGridItem);
            } else if (snapGrid[i] <= swiper.virtualSize - swiperSize) // When snapToSlideEdge is disabled, keep snaps that fit within scrollable area
            newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) // Only add edge-aligned snap if snapToSlideEdge is not enabled
        {
            if (!shouldSnapToSlideEdge) snapGrid.push(swiper.virtualSize - swiperSize);
        }
    }
    if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            const groupSize = size * params.slidesPerGroup;
            for(let i = 0; i < groups; i += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? 'marginLeft' : swiper.getDirectionLabel('marginRight');
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach((slideEl)=>{
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
        snapGrid = snapGrid.map((snap)=>{
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $36f917fbf2efdd6b$export$8b22cf2602fb60ce)(wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
        (0, $36f917fbf2efdd6b$export$8b22cf2602fb60ce)(wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    swiper.emit('slidesUpdated');
    if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
function $029bc59d811a92d7$var$updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function $029bc59d811a92d7$var$updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    // eslint-disable-next-line
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
const $029bc59d811a92d7$var$toggleSlideClasses$1 = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $029bc59d811a92d7$var$updateSlidesProgress(translate = this && this.translate || 0) {
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
        }
        $029bc59d811a92d7$var$toggleSlideClasses$1(slide, isVisible, params.slideVisibleClass);
        $029bc59d811a92d7$var$toggleSlideClasses$1(slide, isFullyVisible, params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
function $029bc59d811a92d7$var$updateProgress(translate) {
    const swiper = this;
    if (typeof translate === 'undefined') {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd, progressLoop: progressLoop } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}
const $029bc59d811a92d7$var$toggleSlideClasses = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $029bc59d811a92d7$var$updateSlidesClasses() {
    const swiper = this;
    const { slides: slides, params: params, slidesEl: slidesEl, activeIndex: activeIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const getFilteredSlide = (selector)=>{
        return (0, $36f917fbf2efdd6b$export$f1e1789686576879)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    let activeSlide;
    let prevSlide;
    let nextSlide;
    if (isVirtual) {
        if (params.loop) {
            let slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    } else if (gridEnabled) {
        activeSlide = slides.find((slideEl)=>slideEl.column === activeIndex);
        nextSlide = slides.find((slideEl)=>slideEl.column === activeIndex + 1);
        prevSlide = slides.find((slideEl)=>slideEl.column === activeIndex - 1);
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        if (!gridEnabled) {
            // Next Slide
            nextSlide = (0, $36f917fbf2efdd6b$export$43caf9889c228507)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            if (params.loop && !nextSlide) nextSlide = slides[0];
            // Prev Slide
            prevSlide = (0, $36f917fbf2efdd6b$export$625550452a3fa3ec)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            params.loop;
        }
    }
    slides.forEach((slideEl)=>{
        $029bc59d811a92d7$var$toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
        $029bc59d811a92d7$var$toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
        $029bc59d811a92d7$var$toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
}
const $029bc59d811a92d7$var$processLazyPreloader = (swiper, imageEl)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = ()=>swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            else // init later
            requestAnimationFrame(()=>{
                if (slideEl.shadowRoot) {
                    lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
                    if (lazyEl && !lazyEl.lazyPreloaderManaged) lazyEl.remove();
                }
            });
        }
        // Skip removal if managed by React/Vue component
        if (lazyEl && !lazyEl.lazyPreloaderManaged) lazyEl.remove();
    }
};
const $029bc59d811a92d7$var$unlazy = (swiper, index)=>{
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute('loading');
};
const $029bc59d811a92d7$var$preload = (swiper)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [
            activeColumn - amount
        ];
        preloadColumns.push(...Array.from({
            length: amount
        }).map((_, i)=>{
            return activeColumn + slidesPerView + i;
        }));
        swiper.slides.forEach((slideEl, i)=>{
            if (preloadColumns.includes(slideEl.column)) $029bc59d811a92d7$var$unlazy(swiper, i);
        });
        return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $029bc59d811a92d7$var$unlazy(swiper, realIndex);
    }
    else {
        for(let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1)if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) $029bc59d811a92d7$var$unlazy(swiper, i);
    }
};
function $029bc59d811a92d7$var$getActiveIndexByTranslate(swiper) {
    const { slidesGrid: slidesGrid, params: params } = swiper;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for(let i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
    return activeIndex;
}
function $029bc59d811a92d7$var$updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex)=>{
        let realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === 'undefined') activeIndex = $029bc59d811a92d7$var$getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    // Get real index
    let realIndex;
    if (swiper.virtual && params.virtual.enabled) {
        if (params.loop) realIndex = getVirtualRealIndex(activeIndex);
        else realIndex = activeIndex;
    } else if (gridEnabled) {
        const firstSlideInColumn = swiper.slides.find((slideEl)=>slideEl.column === activeIndex);
        let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute('data-swiper-slide-index'), 10);
        if (Number.isNaN(activeSlideIndex)) activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
        const slideIndex = swiper.slides[activeIndex].getAttribute('data-swiper-slide-index');
        if (slideIndex) realIndex = parseInt(slideIndex, 10);
        else realIndex = activeIndex;
    } else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) $029bc59d811a92d7$var$preload(swiper);
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        if (previousRealIndex !== realIndex) swiper.emit('realIndexChange');
        swiper.emit('slideChange');
    }
}
function $029bc59d811a92d7$var$updateClickedSlide(el, path) {
    const swiper = this;
    const params = swiper.params;
    let slide = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) [
        ...path.slice(path.indexOf(el) + 1, path.length)
    ].forEach((pathEl)=>{
        if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) slide = pathEl;
    });
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
var $029bc59d811a92d7$var$update = {
    updateSize: $029bc59d811a92d7$var$updateSize,
    updateSlides: $029bc59d811a92d7$var$updateSlides,
    updateAutoHeight: $029bc59d811a92d7$var$updateAutoHeight,
    updateSlidesOffset: $029bc59d811a92d7$var$updateSlidesOffset,
    updateSlidesProgress: $029bc59d811a92d7$var$updateSlidesProgress,
    updateProgress: $029bc59d811a92d7$var$updateProgress,
    updateSlidesClasses: $029bc59d811a92d7$var$updateSlidesClasses,
    updateActiveIndex: $029bc59d811a92d7$var$updateActiveIndex,
    updateClickedSlide: $029bc59d811a92d7$var$updateClickedSlide
};
function $029bc59d811a92d7$var$getSwiperTranslate(axis = this.isHorizontal() ? 'x' : 'y') {
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, wrapperEl: wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $36f917fbf2efdd6b$export$882b5998b3b9117c)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $029bc59d811a92d7$var$setTranslate(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}
function $029bc59d811a92d7$var$minTranslate() {
    return -this.snapGrid[0];
}
function $029bc59d811a92d7$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $029bc59d811a92d7$var$translateTo(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $36f917fbf2efdd6b$export$3b14a55fb2447963)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: -newTranslate,
                behavior: 'smooth'
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                swiper.animating = false;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.wrapperEl.addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var $029bc59d811a92d7$var$translate = {
    getTranslate: $029bc59d811a92d7$var$getSwiperTranslate,
    setTranslate: $029bc59d811a92d7$var$setTranslate,
    minTranslate: $029bc59d811a92d7$var$minTranslate,
    maxTranslate: $029bc59d811a92d7$var$maxTranslate,
    translateTo: $029bc59d811a92d7$var$translateTo
};
function $029bc59d811a92d7$var$setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : '';
    }
    swiper.emit('setTransition', duration, byController);
}
function $029bc59d811a92d7$var$transitionEmit({ swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step }) {
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && dir === 'reset') swiper.emit(`slideResetTransition${step}`);
    else if (runCallbacks && activeIndex !== previousIndex) {
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === 'next') swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}
function $029bc59d811a92d7$var$transitionStart(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    $029bc59d811a92d7$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'Start'
    });
}
function $029bc59d811a92d7$var$transitionEnd(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    $029bc59d811a92d7$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'End'
    });
}
var $029bc59d811a92d7$var$transition = {
    setTransition: $029bc59d811a92d7$var$setTransition,
    transitionStart: $029bc59d811a92d7$var$transitionStart,
    transitionEnd: $029bc59d811a92d7$var$transitionEnd
};
function $029bc59d811a92d7$var$slideTo(index = 0, speed, runCallbacks = true, internal, initial) {
    if (typeof index === 'string') index = parseInt(index, 10);
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) return false;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
    // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset';
    // initial virtual
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    const isInitialVirtual = isVirtual && initial;
    // Update Index
    if (!isInitialVirtual && (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate)) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = 'none';
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(()=>{
                    wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
                });
            } else wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = '';
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $36f917fbf2efdd6b$export$3b14a55fb2447963)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: t,
                behavior: 'smooth'
            });
        }
        return true;
    }
    const browser = $029bc59d811a92d7$var$getBrowser();
    const isSafari = browser.isSafari;
    if (isVirtual && !initial && isSafari && swiper.isElement) swiper.virtual.update(false, false, slideIndex);
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function $029bc59d811a92d7$var$slideToLoop(index = 0, speed, runCallbacks = true, internal) {
    if (typeof index === 'string') {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    let newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else {
            let targetSlideIndex;
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                targetSlideIndex = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
            } else targetSlideIndex = swiper.getSlideIndexByData(newIndex);
            const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
            const { centeredSlides: centeredSlides, slidesOffsetBefore: slidesOffsetBefore, slidesOffsetAfter: slidesOffsetAfter } = swiper.params;
            const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
            let slidesPerView = swiper.params.slidesPerView;
            if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
            else {
                slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
                if (bothDirections && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
            }
            let needLoopFix = cols - targetSlideIndex < slidesPerView;
            if (bothDirections) needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
            if (internal && bothDirections && swiper.params.slidesPerView !== 'auto' && !gridEnabled) needLoopFix = false;
            if (needLoopFix) {
                const direction = bothDirections ? targetSlideIndex < swiper.activeIndex ? 'prev' : 'next' : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? 'next' : 'prev';
                swiper.loopFix({
                    direction: direction,
                    slideTo: true,
                    activeSlideIndex: direction === 'next' ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
                    slideRealIndex: direction === 'next' ? swiper.realIndex : undefined
                });
            }
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                newIndex = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
            } else newIndex = swiper.getSlideIndexByData(newIndex);
        }
    }
    requestAnimationFrame(()=>{
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
}
/* eslint no-unused-vars: "off" */ function $029bc59d811a92d7$var$slideNext(speed, runCallbacks = true, internal) {
    const swiper = this;
    const { enabled: enabled, params: params, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'next'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(()=>{
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $029bc59d811a92d7$var$slidePrev(speed, runCallbacks = true, internal) {
    const swiper = this;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'prev'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    const isFreeMode = params.freeMode && params.freeMode.enabled;
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && (params.cssMode || isFreeMode)) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== 'undefined') prevSnap = isFreeMode ? snapGrid[prevSnapIndex] : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(()=>{
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $029bc59d811a92d7$var$slideReset(speed, runCallbacks = true, internal) {
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $029bc59d811a92d7$var$slideToClosest(speed, runCallbacks = true, internal, threshold = 0.5) {
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function $029bc59d811a92d7$var$slideToClickedSlide() {
    const swiper = this;
    if (swiper.destroyed) return;
    const { params: params, slidesEl: slidesEl } = swiper;
    const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.getSlideIndexWhenGrid(swiper.clickedIndex);
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    const isGrid = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        if (params.centeredSlides) swiper.slideToLoop(realIndex);
        else if (slideToIndex > (isGrid ? (swiper.slides.length - slidesPerView) / 2 - (swiper.params.grid.rows - 1) : swiper.slides.length - slidesPerView)) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $36f917fbf2efdd6b$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
var $029bc59d811a92d7$var$slide = {
    slideTo: $029bc59d811a92d7$var$slideTo,
    slideToLoop: $029bc59d811a92d7$var$slideToLoop,
    slideNext: $029bc59d811a92d7$var$slideNext,
    slidePrev: $029bc59d811a92d7$var$slidePrev,
    slideReset: $029bc59d811a92d7$var$slideReset,
    slideToClosest: $029bc59d811a92d7$var$slideToClosest,
    slideToClickedSlide: $029bc59d811a92d7$var$slideToClickedSlide
};
function $029bc59d811a92d7$var$loopCreate(slideRealIndex, initial) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    const initSlides = ()=>{
        const slides = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        slides.forEach((el, index)=>{
            el.setAttribute('data-swiper-slide-index', index);
        });
    };
    const clearBlankSlides = ()=>{
        const slides = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(slidesEl, `.${params.slideBlankClass}`);
        slides.forEach((el)=>{
            el.remove();
        });
        if (slides.length > 0) {
            swiper.recalcSlides();
            swiper.updateSlides();
        }
    };
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (params.loopAddBlankSlides && (params.slidesPerGroup > 1 || gridEnabled)) clearBlankSlides();
    const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    const addBlankSlides = (amountOfSlides)=>{
        for(let i = 0; i < amountOfSlides; i += 1){
            const slideEl = swiper.isElement ? (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('swiper-slide', [
                params.slideBlankClass
            ]) : (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', [
                params.slideClass,
                params.slideBlankClass
            ]);
            swiper.slidesEl.append(slideEl);
        }
    };
    if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $36f917fbf2efdd6b$export$90a7f3efeed30595)('Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $36f917fbf2efdd6b$export$90a7f3efeed30595)('Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else initSlides();
    const bothDirections = params.centeredSlides || !!params.slidesOffsetBefore || !!params.slidesOffsetAfter;
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: bothDirections ? undefined : 'next',
        initial: initial
    });
}
function $029bc59d811a92d7$var$loopFix({ slideRealIndex: slideRealIndex, slideTo: slideTo = true, direction: direction, setTranslate: setTranslate, activeSlideIndex: activeSlideIndex, initial: initial, byController: byController, byMousewheel: byMousewheel } = {}) {
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit('beforeLoopFix');
    const { slides: slides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, slidesEl: slidesEl, params: params } = swiper;
    const { centeredSlides: centeredSlides, slidesOffsetBefore: slidesOffsetBefore, slidesOffsetAfter: slidesOffsetAfter, initialSlide: initialSlide } = params;
    const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (slideTo) {
            if (!bothDirections && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (bothDirections && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit('loopFix');
        return;
    }
    let slidesPerView = params.slidesPerView;
    if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
    else {
        slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
        if (bothDirections && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
    }
    const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    let loopedSlides = bothDirections ? Math.max(slidesPerGroup, Math.ceil(slidesPerView / 2)) : slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides || swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) (0, $36f917fbf2efdd6b$export$90a7f3efeed30595)('Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters');
    else if (gridEnabled && params.grid.fill === 'row') (0, $36f917fbf2efdd6b$export$90a7f3efeed30595)('Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`');
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    const isInitialOverflow = initial && cols - initialSlide < slidesPerView && !bothDirections;
    let activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
    if (typeof activeSlideIndex === 'undefined') activeSlideIndex = swiper.getSlideIndex(slides.find((el)=>el.classList.contains(params.slideActiveClass)));
    else activeIndex = activeSlideIndex;
    const isNext = direction === 'next' || !direction;
    const isPrev = direction === 'prev' || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
    const activeColIndexWithShift = activeColIndex + (bothDirections && typeof setTranslate === 'undefined' ? -slidesPerView / 2 + 0.5 : 0);
    // prepend last slides before start
    if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        for(let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                const colIndexToPrepend = cols - index - 1;
                for(let i = slides.length - 1; i >= 0; i -= 1)if (slides[i].column === colIndexToPrepend) prependSlidesIndexes.push(i);
            // slides.forEach((slide, slideIndex) => {
            //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
            // });
            } else prependSlidesIndexes.push(cols - index - 1);
        }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        if (isInitialOverflow) slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
        for(let i = 0; i < slidesAppended; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) slides.forEach((slide, slideIndex)=>{
                if (slide.column === index) appendSlidesIndexes.push(slideIndex);
            });
            else appendSlidesIndexes.push(index);
        }
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
    if (swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) {
        if (appendSlidesIndexes.includes(activeSlideIndex)) appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
        if (prependSlidesIndexes.includes(activeSlideIndex)) prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
    if (isPrev) prependSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === 'auto') swiper.updateSlides();
    else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) swiper.slides.forEach((slide, slideIndex)=>{
        swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else if (setTranslate) {
                const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else {
                const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
            }
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        const loopParams = {
            slideRealIndex: slideRealIndex,
            direction: direction,
            setTranslate: setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach((c)=>{
            if (!c.destroyed && c.params.loop) c.loopFix({
                ...loopParams,
                slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
            });
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix({
            ...loopParams,
            slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
    }
    swiper.emit('loopFix');
}
function $029bc59d811a92d7$var$loopDestroy() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || !slidesEl || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl)=>{
        const index = typeof slideEl.swiperSlideIndex === 'undefined' ? slideEl.getAttribute('data-swiper-slide-index') * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl)=>{
        slideEl.removeAttribute('data-swiper-slide-index');
    });
    newSlidesOrder.forEach((slideEl)=>{
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
var $029bc59d811a92d7$var$loop = {
    loopCreate: $029bc59d811a92d7$var$loopCreate,
    loopFix: $029bc59d811a92d7$var$loopFix,
    loopDestroy: $029bc59d811a92d7$var$loopDestroy
};
function $029bc59d811a92d7$var$setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = 'move';
    el.style.cursor = moving ? 'grabbing' : 'grab';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
function $029bc59d811a92d7$var$unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
var $029bc59d811a92d7$var$grabCursor = {
    setGrabCursor: $029bc59d811a92d7$var$setGrabCursor,
    unsetGrabCursor: $029bc59d811a92d7$var$unsetGrabCursor
};
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $029bc59d811a92d7$var$closestElement(selector, base = this) {
    function __closestFrom(el) {
        if (!el || el === (0, $6b317c2177284918$export$39b482c5e57630a8)() || el === (0, $6b317c2177284918$export$407448d2b89b1813)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $029bc59d811a92d7$var$preventEdgeSwipe(swiper, event, startX) {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    const { params: params } = swiper;
    const edgeSwipeDetection = params.edgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window1.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') {
            event.preventDefault();
            return true;
        }
        return false;
    }
    return true;
}
function $029bc59d811a92d7$var$onTouchStart(event) {
    const swiper = this;
    if (swiper.destroyed) return;
    const document1 = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    const data = swiper.touchEventsData;
    if (e.type === 'pointerdown') {
        if (data.pointerId !== null && data.pointerId !== e.pointerId) return;
        data.pointerId = e.pointerId;
    } else if (e.type === 'touchstart' && e.targetTouches.length === 1) data.touchId = e.targetTouches[0].identifier;
    if (e.type === 'touchstart') {
        // don't proceed touch event
        $029bc59d811a92d7$var$preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
    }
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let targetEl = e.target;
    if (params.touchEventsTarget === 'wrapper') {
        if (!(0, $36f917fbf2efdd6b$export$efccba1c4a2ef57b)(targetEl, swiper.wrapperEl)) return;
    }
    if ('which' in e && e.which === 3) return;
    if ('button' in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
    // eslint-disable-next-line
    const eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $029bc59d811a92d7$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    if (!$029bc59d811a92d7$var$preventEdgeSwipe(swiper, e, startX)) return;
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === 'SELECT') data.isTouched = false;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== targetEl && (e.pointerType === 'mouse' || e.pointerType !== 'mouse' && !targetEl.matches(data.focusableElements))) document1.activeElement.blur();
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit('touchStart', e);
}
function $029bc59d811a92d7$var$onTouchMove(event) {
    const document1 = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    const swiper = this;
    if (swiper.destroyed) return;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === 'mouse') return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (e.type === 'pointermove') {
        if (data.touchId !== null) return; // return from pointer if we use touch
        const id = e.pointerId;
        if (id !== data.pointerId) return;
    }
    let targetTouch;
    if (e.type === 'touchmove') {
        targetTouch = [
            ...e.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    } else targetTouch = e;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (rtl && (pageX > touches.startX && -swiper.translate <= swiper.maxTranslate() || pageX < touches.startX && -swiper.translate >= swiper.minTranslate())) return;
        else if (!rtl && (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())) return;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== e.target && e.pointerType !== 'mouse') document1.activeElement.blur();
    if (document1.activeElement) {
        if (e.target === document1.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || e.type === 'touchmove' && data.preventTouchMoveFromPointerMove) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    swiper.touchesDirection = touchesDiff > 0 ? 'prev' : 'next';
    const isLoop = swiper.params.loop && !params.cssMode;
    const allowLoopFix = swiper.touchesDirection === 'next' && swiper.allowSlideNext || swiper.touchesDirection === 'prev' && swiper.allowSlidePrev;
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            const evt = new window.CustomEvent('transitionend', {
                bubbles: true,
                cancelable: true,
                detail: {
                    bySwiperTouchMove: true
                }
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    let loopFixed;
    new Date().getTime();
    if (params._loopSwapReset !== false && data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
            startTranslate: data.currentTranslate
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) swiper.loopFix({
            direction: 'prev',
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
        }
    } else if (diff < 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) swiper.loopFix({
            direction: 'next',
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}
function $029bc59d811a92d7$var$onTouchEnd(event) {
    const swiper = this;
    if (swiper.destroyed) return;
    const data = swiper.touchEventsData;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let targetTouch;
    const isTouchEvent = e.type === 'touchend' || e.type === 'touchcancel';
    if (!isTouchEvent) {
        if (data.touchId !== null) return; // return from pointer if we use touch
        if (e.pointerId !== data.pointerId) return;
        targetTouch = e;
    } else {
        targetTouch = [
            ...e.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    }
    if ([
        'pointercancel',
        'pointerout',
        'pointerleave',
        'contextmenu'
    ].includes(e.type)) {
        const proceed = [
            'pointercancel',
            'contextmenu'
        ].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    data.pointerId = null;
    data.touchId = null;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    const touchEndTime = (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)();
    const timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)();
    (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
            if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (swipeToLast || currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}
function $029bc59d811a92d7$var$onResize() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) {
        const slides = isVirtual ? swiper.virtual.slides : swiper.slides;
        swiper.slideTo(slides.length - 1, 0, false, true);
    } else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(()=>{
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $029bc59d811a92d7$var$onClick(e) {
    const swiper = this;
    if (swiper.destroyed) return;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $029bc59d811a92d7$var$onScroll() {
    const swiper = this;
    if (swiper.destroyed) return;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}
function $029bc59d811a92d7$var$onLoad(e) {
    const swiper = this;
    if (swiper.destroyed) return;
    $029bc59d811a92d7$var$processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight) return;
    swiper.update();
}
function $029bc59d811a92d7$var$onDocumentTouchStart() {
    const swiper = this;
    if (swiper.destroyed) return;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) swiper.el.style.touchAction = 'auto';
}
const $029bc59d811a92d7$var$events = (swiper, method)=>{
    const document1 = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    const { params: params, el: el, wrapperEl: wrapperEl, device: device } = swiper;
    const capture = !!params.nested;
    const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    const swiperMethod = method;
    if (!el || typeof el === 'string') return;
    // Touch Events
    document1[domMethod]('touchstart', swiper.onDocumentTouchStart, {
        passive: false,
        capture: capture
    });
    el[domMethod]('touchstart', swiper.onTouchStart, {
        passive: false
    });
    el[domMethod]('pointerdown', swiper.onTouchStart, {
        passive: false
    });
    document1[domMethod]('touchmove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]('pointermove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]('touchend', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerup', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointercancel', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('touchcancel', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerout', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerleave', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('contextmenu', swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]('scroll', swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', $029bc59d811a92d7$var$onResize, true);
    else swiper[swiperMethod]('observerUpdate', $029bc59d811a92d7$var$onResize, true);
    // Images loader
    el[domMethod]('load', swiper.onLoad, {
        capture: true
    });
};
function $029bc59d811a92d7$var$attachEvents() {
    const swiper = this;
    const { params: params } = swiper;
    swiper.onTouchStart = $029bc59d811a92d7$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $029bc59d811a92d7$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $029bc59d811a92d7$var$onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = $029bc59d811a92d7$var$onDocumentTouchStart.bind(swiper);
    if (params.cssMode) swiper.onScroll = $029bc59d811a92d7$var$onScroll.bind(swiper);
    swiper.onClick = $029bc59d811a92d7$var$onClick.bind(swiper);
    swiper.onLoad = $029bc59d811a92d7$var$onLoad.bind(swiper);
    $029bc59d811a92d7$var$events(swiper, 'on');
}
function $029bc59d811a92d7$var$detachEvents() {
    const swiper = this;
    $029bc59d811a92d7$var$events(swiper, 'off');
}
var $029bc59d811a92d7$var$events$1 = {
    attachEvents: $029bc59d811a92d7$var$attachEvents,
    detachEvents: $029bc59d811a92d7$var$detachEvents
};
const $029bc59d811a92d7$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $029bc59d811a92d7$var$setBreakpoint() {
    const swiper = this;
    const { realIndex: realIndex, initialized: initialized, params: params, el: el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    const document1 = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    // Get breakpoint for window/container width and update parameters
    const breakpointsBase = params.breakpointsBase === 'window' || !params.breakpointsBase ? params.breakpointsBase : 'container';
    const breakpointContainer = [
        'window',
        'container'
    ].includes(params.breakpointsBase) || !params.breakpointsBase ? swiper.el : document1.querySelector(params.breakpointsBase);
    const breakpoint = swiper.getBreakpoint(breakpoints, breakpointsBase, breakpointContainer);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $029bc59d811a92d7$var$isGridEnabled(swiper, params);
    const isMultiRow = $029bc59d811a92d7$var$isGridEnabled(swiper, breakpointParams);
    const wasGrabCursor = swiper.params.grabCursor;
    const isGrabCursor = breakpointParams.grabCursor;
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) swiper.unsetGrabCursor();
    else if (!wasGrabCursor && isGrabCursor) swiper.setGrabCursor();
    // Toggle navigation, pagination, scrollbar
    [
        'navigation',
        'pagination',
        'scrollbar'
    ].forEach((prop)=>{
        if (typeof breakpointParams[prop] === 'undefined') return;
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    const wasLoop = params.loop;
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    const hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (initialized) {
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (!wasLoop && hasLoop) {
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (wasLoop && !hasLoop) swiper.loopDestroy();
    }
    swiper.emit('breakpoint', breakpointParams);
}
function $029bc59d811a92d7$var$getBreakpoint(breakpoints, base = 'window', containerEl) {
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    let breakpoint = false;
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    const currentHeight = base === 'window' ? window1.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === 'window') {
            if (window1.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}
var $029bc59d811a92d7$var$breakpoints = {
    setBreakpoint: $029bc59d811a92d7$var$setBreakpoint,
    getBreakpoint: $029bc59d811a92d7$var$getBreakpoint
};
function $029bc59d811a92d7$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === 'object') Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $029bc59d811a92d7$var$addClasses() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, el: el, device: device } = swiper;
    // prettier-ignore
    const suffixes = $029bc59d811a92d7$var$prepareClasses([
        'initialized',
        params.direction,
        {
            'free-mode': swiper.params.freeMode && params.freeMode.enabled
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'grid': params.grid && params.grid.rows > 1
        },
        {
            'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        },
        {
            'centered': params.cssMode && params.centeredSlides
        },
        {
            'watch-progress': params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
}
function $029bc59d811a92d7$var$removeClasses() {
    const swiper = this;
    const { el: el, classNames: classNames } = swiper;
    if (!el || typeof el === 'string') return;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
}
var $029bc59d811a92d7$var$classes = {
    addClasses: $029bc59d811a92d7$var$addClasses,
    removeClasses: $029bc59d811a92d7$var$removeClasses
};
function $029bc59d811a92d7$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
}
var $029bc59d811a92d7$var$checkOverflow$1 = {
    checkOverflow: $029bc59d811a92d7$var$checkOverflow
};
var $029bc59d811a92d7$export$4368d992c4eafac0 = {
    init: true,
    direction: 'horizontal',
    oneWayMovement: false,
    swiperElementNodeName: 'SWIPER-CONTAINER',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: 'swiper',
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    snapToSlideEdge: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: 'swiper-',
    // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-blank',
    slideActiveClass: 'swiper-slide-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideFullyVisibleClass: 'swiper-slide-fully-visible',
    slideNextClass: 'swiper-slide-next',
    slidePrevClass: 'swiper-slide-prev',
    wrapperClass: 'swiper-wrapper',
    lazyPreloaderClass: 'swiper-lazy-preloader',
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
function $029bc59d811a92d7$var$moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj = {}) {
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) {
            (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (moduleParamName === 'navigation' && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) params[moduleParamName].auto = true;
        if ([
            'pagination',
            'scrollbar'
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) params[moduleParamName].auto = true;
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)(allModulesParams, obj);
            return;
        }
        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)(allModulesParams, obj);
    };
}
/* eslint no-param-reassign: "off" */ const $029bc59d811a92d7$var$prototypes = {
    eventsEmitter: $029bc59d811a92d7$var$eventsEmitter,
    update: $029bc59d811a92d7$var$update,
    translate: $029bc59d811a92d7$var$translate,
    transition: $029bc59d811a92d7$var$transition,
    slide: $029bc59d811a92d7$var$slide,
    loop: $029bc59d811a92d7$var$loop,
    grabCursor: $029bc59d811a92d7$var$grabCursor,
    events: $029bc59d811a92d7$var$events$1,
    breakpoints: $029bc59d811a92d7$var$breakpoints,
    checkOverflow: $029bc59d811a92d7$var$checkOverflow$1,
    classes: $029bc59d811a92d7$var$classes
};
const $029bc59d811a92d7$var$extendedDefaults = {};
class $029bc59d811a92d7$export$25ce5a424b770e84 {
    constructor(...args){
        let el;
        let params;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)({}, params);
        if (el && !params.el) params.el = el;
        const document1 = (0, $6b317c2177284918$export$39b482c5e57630a8)();
        if (params.el && typeof params.el === 'string' && document1.querySelectorAll(params.el).length > 1) {
            const swipers = [];
            document1.querySelectorAll(params.el).forEach((containerEl)=>{
                const newParams = (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)({}, params, {
                    el: containerEl
                });
                swipers.push(new $029bc59d811a92d7$export$25ce5a424b770e84(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = $029bc59d811a92d7$var$getSupport();
        swiper.device = $029bc59d811a92d7$var$getDevice({
            userAgent: params.userAgent
        });
        swiper.browser = $029bc59d811a92d7$var$getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) params.modules.forEach((mod)=>{
            if (typeof mod === 'function' && swiper.modules.indexOf(mod) < 0) swiper.modules.push(mod);
        });
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                params: params,
                swiper: swiper,
                extendParams: $029bc59d811a92d7$var$moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        const swiperParams = (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)({}, $029bc59d811a92d7$export$4368d992c4eafac0, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)({}, swiperParams, $029bc59d811a92d7$var$extendedDefaults, params);
        swiper.originalParams = (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)({}, swiper.params);
        swiper.passedParams = (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === 'horizontal';
            },
            isVertical () {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment () {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                pointerId: null,
                touchId: null
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit('_swiper');
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    getDirectionLabel(property) {
        if (this.isHorizontal()) return property;
        // prettier-ignore
        return ({
            'width': 'height',
            'margin-top': 'margin-left',
            'margin-bottom ': 'margin-right',
            'margin-left': 'margin-top',
            'margin-right': 'margin-bottom',
            'padding-left': 'padding-top',
            'padding-right': 'padding-bottom',
            'marginRight': 'marginBottom'
        })[property];
    }
    getSlideIndex(slideEl) {
        const { slidesEl: slidesEl, params: params } = this;
        const slides = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = (0, $36f917fbf2efdd6b$export$35e795649ee09318)(slides[0]);
        return (0, $36f917fbf2efdd6b$export$35e795649ee09318)(slideEl) - firstSlideIndex;
    }
    getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === index));
    }
    getSlideIndexWhenGrid(index) {
        if (this.grid && this.params.grid && this.params.grid.rows > 1) {
            if (this.params.grid.fill === 'column') index = Math.floor(index / this.params.grid.rows);
            else if (this.params.grid.fill === 'row') index = index % Math.ceil(this.slides.length / this.params.grid.rows);
        }
        return index;
    }
    recalcSlides() {
        const swiper = this;
        const { slidesEl: slidesEl, params: params } = swiper;
        swiper.slides = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit('enable');
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit('disable');
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(' ').filter((className)=>{
            return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit('_containerClasses', cls.join(' '));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return '';
        return slideEl.className.split(' ').filter((className)=>{
            return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(' ');
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.forEach((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit('_slideClass', slideEl, classNames);
        });
        swiper.emit('_slideClasses', updates);
    }
    slidesPerViewDynamic(view = 'current', exact = false) {
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (typeof params.slidesPerView === 'number') return params.slidesPerView;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += Math.ceil(slides[i].swiperSlideSize);
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === 'current') for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper;
        // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) $029bc59d811a92d7$var$processLazyPreloader(swiper, imageEl);
        });
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
            setTranslate();
            if (params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                translated = swiper.slideTo(slides.length - 1, 0, false, true);
            } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit('update');
    }
    changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.forEach((slideEl)=>{
            if (newDirection === 'vertical') slideEl.style.width = '';
            else slideEl.style.height = '';
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
        swiper.rtl = direction === 'rtl';
        swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
        if (swiper.rtl) {
            swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'rtl';
        } else {
            swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'ltr';
        }
        swiper.update();
    }
    mount(element) {
        const swiper = this;
        if (swiper.mounted) return true;
        // Find el
        let el = element || swiper.params.el;
        if (typeof el === 'string') el = document.querySelector(el);
        if (!el) return false;
        el.swiper = swiper;
        if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) swiper.isElement = true;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
            }
            return (0, $36f917fbf2efdd6b$export$f1e1789686576879)(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
            wrapperEl = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', swiper.params.wrapperClass);
            el.append(wrapperEl);
            (0, $36f917fbf2efdd6b$export$f1e1789686576879)(el, `.${swiper.params.slideClass}`).forEach((slideEl)=>{
                wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            el: el,
            wrapperEl: wrapperEl,
            slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
            hostEl: swiper.isElement ? el.parentNode.host : el,
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === 'rtl' || (0, $36f917fbf2efdd6b$export$9e5f44173e64f162)(el, 'direction') === 'rtl',
            rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || (0, $36f917fbf2efdd6b$export$9e5f44173e64f162)(el, 'direction') === 'rtl'),
            wrongRTL: (0, $36f917fbf2efdd6b$export$9e5f44173e64f162)(wrapperEl, 'display') === '-webkit-box'
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit('beforeInit');
        // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
        // Add Classes
        swiper.addClasses();
        // Update size
        swiper.updateSize();
        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        // Create loop
        if (swiper.params.loop) swiper.loopCreate(undefined, true);
        // Attach events
        swiper.attachEvents();
        const lazyElements = [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ];
        if (swiper.isElement) lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
        lazyElements.forEach((imageEl)=>{
            if (imageEl.complete) $029bc59d811a92d7$var$processLazyPreloader(swiper, imageEl);
            else imageEl.addEventListener('load', (e)=>{
                $029bc59d811a92d7$var$processLazyPreloader(swiper, e.target);
            });
        });
        $029bc59d811a92d7$var$preload(swiper);
        // Init Flag
        swiper.initialized = true;
        $029bc59d811a92d7$var$preload(swiper);
        // Emit
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
    }
    destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const { params: params, el: el, wrapperEl: wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
        swiper.emit('beforeDestroy');
        // Init Flag
        swiper.initialized = false;
        // Detach events
        swiper.detachEvents();
        // Destroy loop
        if (params.loop) swiper.loopDestroy();
        // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            if (el && typeof el !== 'string') el.removeAttribute('style');
            if (wrapperEl) wrapperEl.removeAttribute('style');
            if (slides && slides.length) slides.forEach((slideEl)=>{
                slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                slideEl.removeAttribute('style');
                slideEl.removeAttribute('data-swiper-slide-index');
            });
        }
        swiper.emit('destroy');
        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            if (swiper.el && typeof swiper.el !== 'string') swiper.el.swiper = null;
            (0, $36f917fbf2efdd6b$export$4a5767248b18ef41)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)($029bc59d811a92d7$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $029bc59d811a92d7$var$extendedDefaults;
    }
    static get defaults() {
        return $029bc59d811a92d7$export$4368d992c4eafac0;
    }
    static installModule(mod) {
        if (!$029bc59d811a92d7$export$25ce5a424b770e84.prototype.__modules__) $029bc59d811a92d7$export$25ce5a424b770e84.prototype.__modules__ = [];
        const modules = $029bc59d811a92d7$export$25ce5a424b770e84.prototype.__modules__;
        if (typeof mod === 'function' && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$029bc59d811a92d7$export$25ce5a424b770e84.installModule(m));
            return $029bc59d811a92d7$export$25ce5a424b770e84;
        }
        $029bc59d811a92d7$export$25ce5a424b770e84.installModule(module);
        return $029bc59d811a92d7$export$25ce5a424b770e84;
    }
}
Object.keys($029bc59d811a92d7$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($029bc59d811a92d7$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $029bc59d811a92d7$export$25ce5a424b770e84.prototype[protoMethod] = $029bc59d811a92d7$var$prototypes[prototypeGroup][protoMethod];
    });
});
$029bc59d811a92d7$export$25ce5a424b770e84.use([
    $029bc59d811a92d7$var$Resize,
    $029bc59d811a92d7$var$Observer
]);






function $33834d902fe381ab$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            slidesPerViewAutoSlideSize: 320,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    const tempDOM = document.createElement('div');
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        // eslint-disable-next-line
        let slideEl;
        if (params.renderSlide) {
            slideEl = params.renderSlide.call(swiper, slide, index);
            if (typeof slideEl === 'string') {
                (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(tempDOM, slideEl);
                slideEl = tempDOM.children[0];
            }
        } else if (swiper.isElement) slideEl = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('swiper-slide');
        else slideEl = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', swiper.params.slideClass);
        slideEl.setAttribute('data-swiper-slide-index', index);
        if (!params.renderSlide) (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(slideEl, slide);
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force, beforeInit, forceActiveIndex) {
        const { slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides, slidesPerView: slidesPerView, loop: isLoop, initialSlide: initialSlide } = swiper.params;
        if (beforeInit && !isLoop && initialSlide > 0) return;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter, slidesPerViewAutoSlideSize: slidesPerViewAutoSlideSize } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = typeof forceActiveIndex === 'undefined' ? swiper.activeIndex || 0 : forceActiveIndex;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = 'right';
        else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        let slidesPerViewNumeric;
        if (slidesPerView === 'auto') {
            if (slidesPerViewAutoSlideSize) {
                let swiperSize = swiper.size;
                if (!swiperSize) swiperSize = swiper.isHorizontal() ? swiper.el.getBoundingClientRect().width : swiper.el.getBoundingClientRect().height;
                slidesPerViewNumeric = Math.max(1, Math.ceil(swiperSize / slidesPerViewAutoSlideSize));
            } else slidesPerViewNumeric = 1;
        } else slidesPerViewNumeric = slidesPerView;
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerViewNumeric / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerViewNumeric / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerViewNumeric + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerViewNumeric : slidesPerGroup) + addSlidesBefore;
        }
        let from = activeIndex - slidesBefore;
        let to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore: slidesBefore,
            slidesAfter: slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit('virtualUpdate');
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach((slideEl)=>{
                slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
            });
            swiper.updateProgress();
            emit('virtualUpdate');
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit('virtualUpdate');
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        const getSlideIndex = (index)=>{
            let slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) // eslint-disable-next-line
            slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`)).forEach((slideEl)=>{
            slideEl.remove();
        });
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) {
                const slideIndex = getSlideIndex(i);
                swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`)).forEach((slideEl)=>{
                    slideEl.remove();
                });
            }
        }
        const loopFrom = isLoop ? -slides.length : 0;
        const loopTo = isLoop ? slides.length * 2 : slides.length;
        for(let i = loopFrom; i < loopTo; i += 1)if (i >= from && i <= to) {
            const slideIndex = getSlideIndex(i);
            if (typeof previousTo === 'undefined' || force) appendIndexes.push(slideIndex);
            else {
                if (i > previousTo) appendIndexes.push(slideIndex);
                if (i < previousFrom) prependIndexes.push(slideIndex);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(let i = prependIndexes.length - 1; i >= 0; i -= 1){
            const index = prependIndexes[i];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort((a, b)=>b - a);
            prependIndexes.forEach((index)=>{
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, $36f917fbf2efdd6b$export$f1e1789686576879)(swiper.slidesEl, '.swiper-slide, swiper-slide').forEach((slideEl)=>{
            slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === 'object' && 'length' in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const cachedEl = cache[cachedIndex];
                const cachedElIndex = cachedEl.getAttribute('data-swiper-slide-index');
                if (cachedElIndex) cachedEl.setAttribute('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes[i]];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on('beforeInit', ()=>{
        if (!swiper.params.virtual.enabled) return;
        let domSlidesAssigned;
        if (typeof swiper.passedParams.virtual.slides === 'undefined') {
            const slides = [
                ...swiper.slidesEl.children
            ].filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`));
            if (slides && slides.length) {
                swiper.virtual.slides = [
                    ...slides
                ];
                domSlidesAssigned = true;
                slides.forEach((slideEl, slideIndex)=>{
                    slideEl.setAttribute('data-swiper-slide-index', slideIndex);
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        update(false, true);
    });
    on('setTranslate', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on('init update resize', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $36f917fbf2efdd6b$export$8b22cf2602fb60ce)(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}




/* eslint-disable consistent-return */ function $52e509fb8653e0d9$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    const window = (0, $6b317c2177284918$export$407448d2b89b1813)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true,
            speed: undefined
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && (document.activeElement.isContentEditable || document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea'))) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, $36f917fbf2efdd6b$export$4368d992c4eafac0)(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && (0, $36f917fbf2efdd6b$export$4368d992c4eafac0)(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const el = swiper.el;
            const swiperWidth = el.clientWidth;
            const swiperHeight = el.clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = (0, $36f917fbf2efdd6b$export$2d1720544b23b823)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        const speed = swiper.params.keyboard.speed;
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext(speed);
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev(speed);
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext(speed);
            if (isPageUp || isArrowUp) swiper.slidePrev(speed);
        }
        emit('keyPress', kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener('keydown', handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener('keydown', handle);
        swiper.keyboard.enabled = false;
    }
    on('init', ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}




/* eslint-disable consistent-return */ function $05e7c97b57a34c96$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $6b317c2177284918$export$407448d2b89b1813)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: 'swiper-no-mousewheel'
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ('detail' in e) sY = e.detail;
        if ('wheelDelta' in e) sY = -e.wheelDelta / 120;
        if ('wheelDeltaY' in e) sY = -e.wheelDeltaY / 120;
        if ('wheelDeltaX' in e) sX = -e.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ('deltaY' in e) pY = e.deltaY;
        if ('deltaX' in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)() - lastScrollTime < 60) // Return false as a default
        return true;
        // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit('scroll', newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit('scroll', newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        if (event1.target.closest(`.${swiper.params.mousewheel.noMousewheelClass}`)) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        const targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent.direction < 0 ? 'next' : 'prev',
                    byMousewheel: true
                });
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)(()=>{
                            if (swiper.destroyed || !swiper.params) return;
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)(()=>{
                        if (swiper.destroyed || !swiper.params) return;
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit('scroll', e);
                // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplay.disableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        targetEl[method]('mouseenter', handleMouseEnter);
        targetEl[method]('mouseleave', handleMouseLeave);
        targetEl[method]('wheel', handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener('wheel', handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events('addEventListener');
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events('removeEventListener');
        swiper.mousewheel.enabled = false;
        return true;
    }
    on('init', ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}



function $756cc3b72a05f628$export$db3b6bfb95261072(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(swiper.el, `.${checkProps[key]}`)[0];
            if (!element) {
                element = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}



const $9dcb69c205fd1703$var$arrowSvg = `<svg class="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>`;
function $9dcb69c205fd1703$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            addIcons: true,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock',
            navigationDisabledClass: 'swiper-navigation-disabled'
        }
    });
    swiper.navigation = {
        nextEl: null,
        prevEl: null,
        arrowSvg: $9dcb69c205fd1703$var$arrowSvg
    };
    function getEl(el) {
        let res;
        if (el && typeof el === 'string' && swiper.isElement) {
            res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === 'string') res = [
                ...document.querySelectorAll(el)
            ];
            if (swiper.params.uniqueNavElements && typeof el === 'string' && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
            else if (res && res.length === 1) res = res[0];
        }
        if (el && !res) return el;
        // if (Array.isArray(res) && res.length === 1) res = res[0];
        return res;
    }
    function toggleEl(el, disabled) {
        const params = swiper.params.navigation;
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            if (subEl) {
                subEl.classList[disabled ? 'add' : 'remove'](...params.disabledClass.split(' '));
                if (subEl.tagName === 'BUTTON') subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit('navigationPrev');
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit('navigationNext');
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $756cc3b72a05f628$export$db3b6bfb95261072)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev'
        });
        if (!(params.nextEl || params.prevEl)) return;
        let nextEl = getEl(params.nextEl);
        let prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl: nextEl,
            prevEl: prevEl
        });
        nextEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(prevEl);
        const initButton = (el, dir)=>{
            if (el) {
                if (params.addIcons && el.matches('.swiper-button-next,.swiper-button-prev') && !el.querySelector('svg')) {
                    const tempEl = document.createElement('div');
                    (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(tempEl, $9dcb69c205fd1703$var$arrowSvg);
                    el.appendChild(tempEl.querySelector('svg'));
                    tempEl.remove();
                }
                el.addEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            }
            if (!swiper.enabled && el) el.classList.add(...params.lockClass.split(' '));
        };
        nextEl.forEach((el)=>initButton(el, 'next'));
        prevEl.forEach((el)=>initButton(el, 'prev'));
    }
    function destroy() {
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(prevEl);
        const destroyButton = (el, dir)=>{
            el.removeEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            el.classList.remove(...swiper.params.navigation.disabledClass.split(' '));
        };
        nextEl.forEach((el)=>destroyButton(el, 'next'));
        prevEl.forEach((el)=>destroyButton(el, 'prev'));
    }
    on('init', ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on('toEdge fromEdge lock unlock', ()=>{
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(prevEl);
        if (swiper.enabled) {
            update();
            return;
        }
        [
            ...nextEl,
            ...prevEl
        ].filter((el)=>!!el).forEach((el)=>el.classList.add(swiper.params.navigation.lockClass));
    });
    on('click', (_s, e)=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(prevEl);
        const targetEl = e.target;
        let targetIsButton = prevEl.includes(targetEl) || nextEl.includes(targetEl);
        if (swiper.isElement && !targetIsButton) {
            const path = e.path || e.composedPath && e.composedPath();
            if (path) targetIsButton = path.find((pathEl)=>nextEl.includes(pathEl) || prevEl.includes(pathEl));
        }
        if (swiper.params.navigation.hideOnClick && !targetIsButton) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if (nextEl.length) isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            else if (prevEl.length) isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit('navigationShow');
            else emit('navigationHide');
            [
                ...nextEl,
                ...prevEl
            ].filter((el)=>!!el).forEach((el)=>el.classList.toggle(swiper.params.navigation.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(' '));
        init();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(' '));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}


function $781a64a6db1a7446$export$db3b6bfb95261072(classes = '') {
    // Escape all CSS selector special characters
    return `.${classes.trim().replace(/([\.:!+\/()[\]#>~*^$|=,'"@{}\\])/g, '\\$1') // eslint-disable-line
    .replace(/ /g, '.')}`;
}




function $69d1e0b9767b27dd$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const pfx = 'swiper-pagination';
    extendParams({
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets',
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        if (!bulletEl) return;
        bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
        if (bulletEl) {
            bulletEl.classList.add(`${bulletActiveClass}-${position}`);
            bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
            if (bulletEl) bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
        }
    }
    function getMoveDirection(prevIndex, nextIndex, length) {
        prevIndex = prevIndex % length;
        nextIndex = nextIndex % length;
        if (nextIndex === prevIndex + 1) return 'next';
        else if (nextIndex === prevIndex - 1) return 'previous';
        return;
    }
    function onBulletClick(e) {
        const bulletEl = e.target.closest((0, $781a64a6db1a7446$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        const index = (0, $36f917fbf2efdd6b$export$35e795649ee09318)(bulletEl) * swiper.params.slidesPerGroup;
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            const moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
            if (moveDirection === 'next') swiper.slideNext();
            else if (moveDirection === 'previous') swiper.slidePrev();
            else swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        // Current/Total
        let current;
        let previousIndex;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== 'undefined') {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = (0, $36f917fbf2efdd6b$export$23f2a1d2818174ef)(bullets[0], swiper.isHorizontal() ? 'width' : 'height', true);
                el.forEach((subEl)=>{
                    subEl.style[swiper.isHorizontal() ? 'width' : 'height'] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach((bulletEl)=>{
                const classesToRemove = [
                    ...[
                        '',
                        '-next',
                        '-next-next',
                        '-prev',
                        '-prev-prev',
                        '-main'
                    ].map((suffix)=>`${params.bulletActiveClass}${suffix}`)
                ].map((s)=>typeof s === 'string' && s.includes(' ') ? s.split(' ') : s).flat();
                bulletEl.classList.remove(...classesToRemove);
            });
            if (el.length > 1) bullets.forEach((bullet)=>{
                const bulletIndex = (0, $36f917fbf2efdd6b$export$35e795649ee09318)(bullet);
                if (bulletIndex === current) bullet.classList.add(...params.bulletActiveClass.split(' '));
                else if (swiper.isElement) bullet.setAttribute('part', 'bullet');
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) bullet.classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, 'prev');
                    if (bulletIndex === lastIndex) setSideBullets(bullet, 'next');
                }
            });
            else {
                const bullet = bullets[current];
                if (bullet) bullet.classList.add(...params.bulletActiveClass.split(' '));
                if (swiper.isElement) bullets.forEach((bulletEl, bulletIndex)=>{
                    bulletEl.setAttribute('part', bulletIndex === current ? 'bullet-active' : 'bullet');
                });
                if (params.dynamicBullets) {
                    const firstDisplayedBullet = bullets[firstIndex];
                    const lastDisplayedBullet = bullets[lastIndex];
                    for(let i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                    setSideBullets(firstDisplayedBullet, 'prev');
                    setSideBullets(lastDisplayedBullet, 'next');
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? 'right' : 'left';
                bullets.forEach((bullet)=>{
                    bullet.style[swiper.isHorizontal() ? offsetProp : 'top'] = `${bulletsOffset}px`;
                });
            }
        }
        el.forEach((subEl, subElIndex)=>{
            if (params.type === 'fraction') {
                subEl.querySelectorAll((0, $781a64a6db1a7446$export$db3b6bfb95261072)(params.currentClass)).forEach((fractionEl)=>{
                    fractionEl.textContent = params.formatFractionCurrent(current + 1);
                });
                subEl.querySelectorAll((0, $781a64a6db1a7446$export$db3b6bfb95261072)(params.totalClass)).forEach((totalEl)=>{
                    totalEl.textContent = params.formatFractionTotal(total);
                });
            }
            if (params.type === 'progressbar') {
                let progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
                else progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
                const scale = (current + 1) / total;
                let scaleX = 1;
                let scaleY = 1;
                if (progressbarDirection === 'horizontal') scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, $781a64a6db1a7446$export$db3b6bfb95261072)(params.progressbarFillClass)).forEach((progressEl)=>{
                    progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
                    progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
                });
            }
            if (params.type === 'custom' && params.renderCustom) {
                (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(subEl, params.renderCustom(swiper, current + 1, total));
                if (subElIndex === 0) emit('paginationRender', subEl);
            } else {
                if (subElIndex === 0) emit('paginationRender', subEl);
                emit('paginationUpdate', subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
        });
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
        let el = swiper.pagination.el;
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        let paginationHTML = '';
        if (params.type === 'bullets') {
            let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // prettier-ignore
            paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ''} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
        }
        swiper.pagination.bullets = [];
        el.forEach((subEl)=>{
            if (params.type !== 'custom') (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(subEl, paginationHTML || '');
            if (params.type === 'bullets') swiper.pagination.bullets.push(...subEl.querySelectorAll((0, $781a64a6db1a7446$export$db3b6bfb95261072)(params.bulletClass)));
        });
        if (params.type !== 'custom') emit('paginationRender', el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $756cc3b72a05f628$export$db3b6bfb95261072)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: 'swiper-pagination'
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') el = [
            ...document.querySelectorAll(params.el)
        ];
        if (!el) el = params.el;
        if (!el || el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && Array.isArray(el) && el.length > 1) {
            el = [
                ...swiper.el.querySelectorAll(params.el)
            ];
            // check if it belongs to another nested Swiper
            if (el.length > 1) el = el.find((subEl)=>{
                if ((0, $36f917fbf2efdd6b$export$4368d992c4eafac0)(subEl, '.swiper')[0] !== swiper.el) return false;
                return true;
            });
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el: el
        });
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            if (params.type === 'bullets' && params.clickable) subEl.classList.add(...(params.clickableClass || '').split(' '));
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === 'bullets' && params.dynamicBullets) {
                subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === 'progressbar' && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener('click', onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        if (el) {
            el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>{
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) {
                    subEl.classList.remove(...(params.clickableClass || '').split(' '));
                    subEl.removeEventListener('click', onBulletClick);
                }
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl)=>subEl.classList.remove(...params.bulletActiveClass.split(' ')));
    }
    on('changeDirection', ()=>{
        if (!swiper.pagination || !swiper.pagination.el) return;
        const params = swiper.params.pagination;
        let { el: el } = swiper.pagination;
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on('activeIndexChange', ()=>{
        if (typeof swiper.snapIndex === 'undefined') update();
    });
    on('snapIndexChange', ()=>{
        update();
    });
    on('snapGridLengthChange', ()=>{
        render();
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList[swiper.enabled ? 'remove' : 'add'](swiper.params.pagination.lockClass));
        }
    });
    on('lock unlock', ()=>{
        update();
    });
    on('click', (_s, e)=>{
        const targetEl = e.target;
        const el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(swiper.pagination.el);
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit('paginationShow');
            else emit('paginationHide');
            el.forEach((subEl)=>subEl.classList.toggle(swiper.params.pagination.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
        }
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}






function $c7252c6c2cf4bba7$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag',
            scrollbarDisabledClass: 'swiper-scrollbar-disabled',
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        const params = swiper.params.scrollbar;
        const progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
            dragEl.style.width = `${newSize}px`;
        } else {
            dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
            dragEl.style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            el.style.opacity = 1;
            timeout = setTimeout(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        dragEl.style.width = '';
        dragEl.style.height = '';
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === 'auto') dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) dragEl.style.width = `${dragSize}px`;
        else dragEl.style.height = `${dragSize}px`;
        if (divider >= 1) el.style.display = 'none';
        else el.style.display = '';
        if (swiper.params.scrollbar.hide) el.style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? 'add' : 'remove'](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        return swiper.isHorizontal() ? e.clientX : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { el: el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - (0, $36f917fbf2efdd6b$export$2d1720544b23b823)(el)[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = '100ms';
        dragEl.style.transitionDuration = '100ms';
        setDragPosition(e);
        clearTimeout(dragTimeout);
        el.style.transitionDuration = '0ms';
        if (params.hide) el.style.opacity = 1;
        if (swiper.params.cssMode) swiper.wrapperEl.style['scroll-snap-type'] = 'none';
        emit('scrollbarDragStart', e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault && e.cancelable) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        wrapperEl.style.transitionDuration = '0ms';
        el.style.transitionDuration = '0ms';
        dragEl.style.transitionDuration = '0ms';
        emit('scrollbarDragMove', e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style['scroll-snap-type'] = '';
            wrapperEl.style.transitionDuration = '';
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
        emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, params: params } = swiper;
        const el = scrollbar.el;
        if (!el) return;
        const target = el;
        const activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
        target[eventMethod]('pointerdown', onDragStart, activeListener);
        document[eventMethod]('pointermove', onDragMove, activeListener);
        document[eventMethod]('pointerup', onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('on');
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('off');
    }
    function init() {
        const { scrollbar: scrollbar, el: swiperEl } = swiper;
        swiper.params.scrollbar = (0, $756cc3b72a05f628$export$db3b6bfb95261072)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: 'swiper-scrollbar'
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') {
            el = document.querySelectorAll(params.el);
            if (!el.length) return;
        } else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let dragEl;
        if (el) {
            dragEl = el.querySelector((0, $781a64a6db1a7446$export$db3b6bfb95261072)(swiper.params.scrollbar.dragClass));
            if (!dragEl) {
                dragEl = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', swiper.params.scrollbar.dragClass);
                el.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: el,
            dragEl: dragEl
        });
        if (params.draggable) enableDraggable();
        if (el) el.classList[swiper.enabled ? 'remove' : 'add'](...(0, $36f917fbf2efdd6b$export$342063e11d6c3cad)(swiper.params.scrollbar.lockClass));
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const el = swiper.scrollbar.el;
        if (el) el.classList.remove(...(0, $36f917fbf2efdd6b$export$342063e11d6c3cad)(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass));
        disableDraggable();
    }
    on('changeDirection', ()=>{
        if (!swiper.scrollbar || !swiper.scrollbar.el) return;
        const params = swiper.params.scrollbar;
        let { el: el } = swiper.scrollbar;
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on('update resize observerUpdate lock unlock changeDirection', ()=>{
        updateSize();
    });
    on('setTranslate', ()=>{
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        setTransition(duration);
    });
    on('enable disable', ()=>{
        const { el: el } = swiper.scrollbar;
        if (el) el.classList[swiper.enabled ? 'remove' : 'add'](...(0, $36f917fbf2efdd6b$export$342063e11d6c3cad)(swiper.params.scrollbar.lockClass));
    });
    on('destroy', ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.el.classList.remove(...(0, $36f917fbf2efdd6b$export$342063e11d6c3cad)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.remove(...(0, $36f917fbf2efdd6b$export$342063e11d6c3cad)(swiper.params.scrollbar.scrollbarDisabledClass));
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.el.classList.add(...(0, $36f917fbf2efdd6b$export$342063e11d6c3cad)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.add(...(0, $36f917fbf2efdd6b$export$342063e11d6c3cad)(swiper.params.scrollbar.scrollbarDisabledClass));
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



function $c36b71b742710ea0$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const elementsSelector = '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]';
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const rtlFactor = rtl ? -1 : 1;
        const p = el.getAttribute('data-swiper-parallax') || '0';
        let x = el.getAttribute('data-swiper-parallax-x');
        let y = el.getAttribute('data-swiper-parallax-y');
        const scale = el.getAttribute('data-swiper-parallax-scale');
        const opacity = el.getAttribute('data-swiper-parallax-opacity');
        const rotate = el.getAttribute('data-swiper-parallax-rotate');
        if (x || y) {
            x = x || '0';
            y = y || '0';
        } else if (swiper.isHorizontal()) {
            x = p;
            y = '0';
        } else {
            y = p;
            x = '0';
        }
        if (x.indexOf('%') >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf('%') >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== 'undefined' && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            el.style.opacity = currentOpacity;
        }
        let transform = `translate3d(${x}, ${y}, 0px)`;
        if (typeof scale !== 'undefined' && scale !== null) {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            transform += ` scale(${currentScale})`;
        }
        if (rotate && typeof rotate !== 'undefined' && rotate !== null) {
            const currentRotate = rotate * progress * -1;
            transform += ` rotate(${currentRotate}deg)`;
        }
        el.style.transform = transform;
    };
    const setTranslate = ()=>{
        const { el: el, slides: slides, progress: progress, snapGrid: snapGrid, isElement: isElement } = swiper;
        const elements = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(el, elementsSelector);
        if (swiper.isElement) elements.push(...(0, $36f917fbf2efdd6b$export$f1e1789686576879)(swiper.hostEl, elementsSelector));
        elements.forEach((subEl)=>{
            setTransform(subEl, progress);
        });
        slides.forEach((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`).forEach((subEl)=>{
                setTransform(subEl, slideProgress);
            });
        });
    };
    const setTransition = (duration = swiper.params.speed)=>{
        const { el: el, hostEl: hostEl } = swiper;
        const elements = [
            ...el.querySelectorAll(elementsSelector)
        ];
        if (swiper.isElement) elements.push(...hostEl.querySelectorAll(elementsSelector));
        elements.forEach((parallaxEl)=>{
            let parallaxDuration = parseInt(parallaxEl.getAttribute('data-swiper-parallax-duration'), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
        });
    };
    on('beforeInit', ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on('init', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTranslate', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTransition', (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}




function $401de11e8a126d45$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $6b317c2177284918$export$407448d2b89b1813)();
    extendParams({
        zoom: {
            enabled: false,
            limitToOriginalSize: false,
            maxRatio: 3,
            minRatio: 1,
            panOnMouseMove: false,
            toggle: true,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed'
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let isPanningWithMouse = false;
    let mousePanStart = {
        x: 0,
        y: 0
    };
    const mousePanSensitivity = -3; // Negative to invert pan direction
    let fakeGestureTouched;
    let fakeGestureMoved;
    const evCache = [];
    const gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.imageEl;
                const slideEl = gesture.slideEl;
                emit('zoomChange', value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        const x1 = evCache[0].pageX;
        const y1 = evCache[0].pageY;
        const x2 = evCache[1].pageX;
        const y2 = evCache[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    }
    function getMaxRatio() {
        const params = swiper.params.zoom;
        const maxRatio = gesture.imageWrapEl.getAttribute('data-swiper-zoom') || params.maxRatio;
        if (params.limitToOriginalSize && gesture.imageEl && gesture.imageEl.naturalWidth) {
            const imageMaxRatio = gesture.imageEl.naturalWidth / gesture.imageEl.offsetWidth;
            return Math.min(imageMaxRatio, maxRatio);
        }
        return maxRatio;
    }
    function getScaleOrigin() {
        if (evCache.length < 2) return {
            x: null,
            y: null
        };
        const box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    }
    function eventWithinSlide(e) {
        const slideSelector = getSlideSelector();
        if (e.target.matches(slideSelector)) return true;
        if (swiper.slides.filter((slideEl)=>slideEl.contains(e.target)).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        const selector = `.${swiper.params.zoom.containerClass}`;
        if (e.target.matches(selector)) return true;
        if ([
            ...swiper.hostEl.querySelectorAll(selector)
        ].filter((containerEl)=>containerEl.contains(e.target)).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === 'mouse') evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $36f917fbf2efdd6b$export$4368d992c4eafac0)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = getMaxRatio();
        }
        if (gesture.imageEl) {
            const [originX, originY] = getScaleOrigin();
            gesture.originX = originX;
            gesture.originY = originY;
            gesture.imageEl.style.transitionDuration = '0ms';
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === 'mouse' && e.type === 'pointerout') return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    let allowTouchMoveTimeout;
    function allowTouchMove() {
        swiper.touchEventsData.preventTouchMoveFromPointerMove = false;
    }
    function preventTouchMove() {
        clearTimeout(allowTouchMoveTimeout);
        swiper.touchEventsData.preventTouchMoveFromPointerMove = true;
        allowTouchMoveTimeout = setTimeout(()=>{
            if (swiper.destroyed) return;
            allowTouchMove();
        });
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.imageEl) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        const event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
    }
    function onTouchMove(e) {
        const isMouseEvent = e.pointerType === 'mouse';
        const isMousePan = isMouseEvent && swiper.params.zoom.panOnMouseMove;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) {
            if (isMousePan) onMouseMove(e);
            return;
        }
        if (isMousePan) {
            onMouseMove(e);
            return;
        }
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            image.startX = (0, $36f917fbf2efdd6b$export$882b5998b3b9117c)(gesture.imageWrapEl, 'x') || 0;
            image.startY = (0, $36f917fbf2efdd6b$export$882b5998b3b9117c)(gesture.imageWrapEl, 'y') || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = '0ms';
        }
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
        if (touchesDiff > 5) swiper.allowClick = false;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        preventTouchMove();
        image.isMoved = true;
        const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
        const { originX: originX, originY: originY } = gesture;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        evCache.length = 0;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
            gesture.slideEl.classList.remove(`${swiper.params.zoom.zoomedSlideClass}`);
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function onMouseMove(e) {
        // Only pan if zoomed in and mouse panning is enabled
        if (currentScale <= 1 || !gesture.imageWrapEl) return;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const currentTransform = window.getComputedStyle(gesture.imageWrapEl).transform;
        const matrix = new window.DOMMatrix(currentTransform);
        if (!isPanningWithMouse) {
            isPanningWithMouse = true;
            mousePanStart.x = e.clientX;
            mousePanStart.y = e.clientY;
            image.startX = matrix.e;
            image.startY = matrix.f;
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            return;
        }
        const deltaX = (e.clientX - mousePanStart.x) * mousePanSensitivity;
        const deltaY = (e.clientY - mousePanStart.y) * mousePanSensitivity;
        const scaledWidth = image.width * currentScale;
        const scaledHeight = image.height * currentScale;
        const slideWidth = gesture.slideWidth;
        const slideHeight = gesture.slideHeight;
        const minX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
        const maxX = -minX;
        const minY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
        const maxY = -minY;
        const newX = Math.max(Math.min(image.startX + deltaX, maxX), minX);
        const newY = Math.max(Math.min(image.startY + deltaY, maxY), minY);
        gesture.imageWrapEl.style.transitionDuration = '0ms';
        gesture.imageWrapEl.style.transform = `translate3d(${newX}px, ${newY}px, 0)`;
        mousePanStart.x = e.clientX;
        mousePanStart.y = e.clientY;
        image.startX = newX;
        image.startY = newY;
        image.currentX = newX;
        image.currentY = newY;
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (e && e.target) gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $36f917fbf2efdd6b$export$4368d992c4eafac0)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        gesture.maxRatio = getMaxRatio();
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.touchAction = 'none';
        }
        gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === 'undefined' && e) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        const prevScale = currentScale;
        const forceZoomRatio = typeof e === 'number' ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
            image.touchesStart.x = undefined;
            image.touchesStart.y = undefined;
        }
        const maxRatio = getMaxRatio();
        zoom.scale = forceZoomRatio || maxRatio;
        currentScale = forceZoomRatio || maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, $36f917fbf2efdd6b$export$2d1720544b23b823)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, $36f917fbf2efdd6b$export$2d1720544b23b823)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            imageHeight = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            if (prevScale > 0 && forceZoomRatio && typeof image.currentX === 'number' && typeof image.currentY === 'number') {
                translateX = image.currentX * zoom.scale / prevScale;
                translateY = image.currentY * zoom.scale / prevScale;
            } else {
                translateX = diffX * zoom.scale;
                translateY = diffY * zoom.scale;
            }
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        image.currentX = translateX;
        image.currentY = translateY;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $36f917fbf2efdd6b$export$4368d992c4eafac0)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        gesture.maxRatio = getMaxRatio();
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.style.touchAction = '';
        }
        zoom.scale = 1;
        currentScale = 1;
        image.currentX = undefined;
        image.currentY = undefined;
        image.touchesStart.x = undefined;
        image.touchesStart.y = undefined;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
        gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
        if (swiper.params.zoom.panOnMouseMove) {
            mousePanStart = {
                x: 0,
                y: 0
            };
            if (isPanningWithMouse) {
                isPanningWithMouse = false;
                image.startX = 0;
                image.startY = 0;
            }
        }
    }
    // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.addEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach((eventName)=>{
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.removeEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach((eventName)=>{
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    on('init', ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on('destroy', ()=>{
        disable();
    });
    on('touchStart', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on('touchEnd', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd();
    });
    on('doubleTap', (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on('transitionEnd', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on('slideChange', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}



/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ function $411c83a941bc1076$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: 'slide' // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === 'slide') {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === 'container') {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)(()=>{
                    c.updateAutoHeight();
                });
                (0, $36f917fbf2efdd6b$export$ae1af26003f05816)(c.wrapperEl, ()=>{
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on('beforeInit', ()=>{
        if (typeof window !== 'undefined' && // eslint-disable-line
        (typeof swiper.params.controller.control === 'string' || swiper.params.controller.control instanceof HTMLElement)) {
            const controlElements = typeof swiper.params.controller.control === 'string' ? [
                ...document.querySelectorAll(swiper.params.controller.control)
            ] : [
                swiper.params.controller.control
            ];
            controlElements.forEach((controlElement)=>{
                if (!swiper.controller.control) swiper.controller.control = [];
                if (controlElement && controlElement.swiper) swiper.controller.control.push(controlElement.swiper);
                else if (controlElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onControllerSwiper = (e)=>{
                        swiper.controller.control.push(e.detail[0]);
                        swiper.update();
                        controlElement.removeEventListener(eventName, onControllerSwiper);
                    };
                    controlElement.addEventListener(eventName, onControllerSwiper);
                }
            });
            return;
        }
        swiper.controller.control = swiper.params.controller.control;
    });
    on('update', ()=>{
        removeSpline();
    });
    on('resize', ()=>{
        removeSpline();
    });
    on('observerUpdate', ()=>{
        removeSpline();
    });
    on('setTranslate', (_s, translate, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on('setTransition', (_s, duration, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}





function $9649bf9a787c3914$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: 'swiper-notification',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            slideLabelMessage: '{{index}} / {{slidesLength}}',
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            containerRole: null,
            itemRoleDescriptionMessage: null,
            slideRole: 'group',
            id: null,
            scrollOnFocus: true,
            wrapperLiveRegion: true
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    let preventFocusHandler;
    let focusTargetSlideEl;
    let visibilityChangedTimestamp = new Date().getTime();
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(notification, message);
    }
    function getRandomNumber(size = 16) {
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return 'x'.repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('tabIndex', '0');
        });
    }
    function makeElNotFocusable(el) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('tabIndex', '-1');
        });
    }
    function addElRole(el, role) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('role', role);
        });
    }
    function addElRoleDescription(el, description) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-roledescription', description);
        });
    }
    function addElLabel(el, label) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-label', label);
        });
    }
    function addElId(el, id) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('id', id);
        });
    }
    function addElLive(el, live) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-live', live);
        });
    }
    function disableEl(el) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-disabled', true);
        });
    }
    function enableEl(el) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.removeAttribute('aria-disabled');
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
            if (!e.target.matches((0, $781a64a6db1a7446$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
            const prevEls = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(swiper.navigation.prevEl);
            const nextEls = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(swiper.navigation.nextEl);
            if (nextEls.includes(targetEl)) {
                if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
                if (swiper.isEnd) notify(params.lastSlideMessage);
                else notify(params.nextSlideMessage);
            }
            if (prevEls.includes(targetEl)) {
                if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
                if (swiper.isBeginning) notify(params.firstSlideMessage);
                else notify(params.prevSlideMessage);
            }
        }
        if (swiper.pagination && targetEl.matches((0, $781a64a6db1a7446$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.forEach((bulletEl)=>{
            if (swiper.params.pagination.clickable) {
                makeElFocusable(bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole(bulletEl, 'button');
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0, $36f917fbf2efdd6b$export$35e795649ee09318)(bulletEl) + 1));
                }
            }
            if (bulletEl.matches((0, $781a64a6db1a7446$export$db3b6bfb95261072)(swiper.params.pagination.bulletActiveClass))) bulletEl.setAttribute('aria-current', 'true');
            else bulletEl.removeAttribute('aria-current');
        });
    }
    const initNavEl = (el, wrapperId, message)=>{
        makeElFocusable(el);
        if (el.tagName !== 'BUTTON') {
            addElRole(el, 'button');
            el.addEventListener('keydown', onEnterOrSpaceKey);
        }
        addElLabel(el, message);
    };
    const handlePointerDown = (e)=>{
        if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) preventFocusHandler = true;
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        preventFocusHandler = false;
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const onVisibilityChange = (e)=>{
        visibilityChangedTimestamp = new Date().getTime();
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked || !swiper.params.a11y.scrollOnFocus) return;
        if (new Date().getTime() - visibilityChangedTimestamp < 100) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        focusTargetSlideEl = slideEl;
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        const isActive = (isVirtual ? parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10) : swiper.slides.indexOf(slideEl)) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        requestAnimationFrame(()=>{
            if (preventFocusHandler) return;
            if (swiper.params.loop) swiper.slideToLoop(swiper.getSlideIndexWhenGrid(parseInt(slideEl.getAttribute('data-swiper-slide-index'))), 0);
            else if (isVirtual) swiper.slideTo(swiper.getSlideIndexWhenGrid(parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10)), 0);
            else swiper.slideTo(swiper.getSlideIndexWhenGrid(swiper.slides.indexOf(slideEl)), 0);
            preventFocusHandler = false;
        });
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        const slidesLength = swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.forEach((slideEl, index)=>{
            const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.el.append(liveRegion);
        // Container
        const containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        if (params.containerRole) addElRole(containerEl, params.containerRole);
        // Wrapper
        const wrapperEl = swiper.wrapperEl;
        const wrapperId = params.id || wrapperEl.getAttribute('id') || `swiper-wrapper-${getRandomNumber(16)}`;
        addElId(wrapperEl, wrapperId);
        if (params.wrapperLiveRegion) {
            const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
            addElLive(wrapperEl, live);
        }
        // Slide
        initSlides();
        // Navigation
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach((el)=>initNavEl(el, wrapperId, params.nextSlideMessage));
        if (prevEl) prevEl.forEach((el)=>initNavEl(el, wrapperId, params.prevSlideMessage));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.addEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        // Tab focus
        const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
        document.addEventListener('visibilitychange', onVisibilityChange);
        swiper.el.addEventListener('focus', handleFocus, true);
        swiper.el.addEventListener('pointerdown', handlePointerDown, true);
        swiper.el.addEventListener('pointerup', handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach((el)=>el.removeEventListener('keydown', onEnterOrSpaceKey));
        if (prevEl) prevEl.forEach((el)=>el.removeEventListener('keydown', onEnterOrSpaceKey));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.removeEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
        // Tab focus
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('focus', handleFocus, true);
            swiper.el.removeEventListener('pointerdown', handlePointerDown, true);
            swiper.el.removeEventListener('pointerup', handlePointerUp, true);
        }
    }
    on('beforeInit', ()=>{
        liveRegion = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('span', swiper.params.a11y.notificationClass);
        liveRegion.setAttribute('aria-live', 'assertive');
        liveRegion.setAttribute('aria-atomic', 'true');
    });
    on('afterInit', ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on('fromEdge toEdge afterInit lock unlock', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on('paginationUpdate', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on('destroy', ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



function $38bb61499ef50fab$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        history: {
            enabled: false,
            root: '',
            replaceState: false,
            key: 'slides',
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $6b317c2177284918$export$407448d2b89b1813)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split('/').filter((part)=>part !== '');
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $6b317c2177284918$export$407448d2b89b1813)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${index}"]`) : swiper.slides[index];
        let value = slugify(slide.getAttribute('data-history'));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
            value = `${root}/${key ? `${key}/` : ''}${value}`;
        } else if (!location.pathname.includes(key)) value = `${key ? `${key}/` : ''}${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides[i];
            const slideHistory = slugify(slide.getAttribute('data-history'));
            if (slideHistory === value) {
                const index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $6b317c2177284918$export$407448d2b89b1813)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $6b317c2177284918$export$407448d2b89b1813)();
        if (!swiper.params.history.replaceState) window.removeEventListener('popstate', setHistoryPopState);
    };
    on('init', ()=>{
        if (swiper.params.history.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}




function $87b0baa371d09db8$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, on: on }) {
    let initialized = false;
    const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    const window = (0, $6b317c2177284918$export$407448d2b89b1813)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex (_s, hash) {
                if (swiper.virtual && swiper.params.virtual.enabled) {
                    const slideWithHash = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-hash') === hash);
                    if (!slideWithHash) return 0;
                    const index = parseInt(slideWithHash.getAttribute('data-swiper-slide-index'), 10);
                    return index;
                }
                return swiper.getSlideIndex((0, $36f917fbf2efdd6b$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0]);
            }
        }
    });
    const onHashChange = ()=>{
        emit('hashChange');
        const newHash = document.location.hash.replace('#', '');
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') : '';
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
            if (typeof newIndex === 'undefined' || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') || activeSlideEl.getAttribute('data-history') : '';
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${activeSlideHash}` || '');
            emit('hashSet');
        } else {
            document.location.hash = activeSlideHash || '';
            emit('hashSet');
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace('#', '');
        if (hash) {
            const speed = 0;
            const index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (swiper.params.hashNavigation.watchState) window.addEventListener('hashchange', onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) window.removeEventListener('hashchange', onHashChange);
    };
    on('init', ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHash();
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}



/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ function $c1783ac9556c9fef$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit, params: params }) {
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    let timeout;
    let raf;
    let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayTimeLeft;
    let autoplayStartTime = new Date().getTime();
    let wasPaused;
    let isTouched;
    let pausedByTouch;
    let touchStartTimeout;
    let pausedByInteraction;
    let pausedByPointerEnter;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener('transitionend', onTransitionEnd);
        if (pausedByPointerEnter || e.detail && e.detail.bySwiperTouchMove) return;
        resume();
    }
    const calcTimeLeft = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit('autoplayTimeLeft', timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(()=>{
            calcTimeLeft();
        });
    };
    const getSlideDelay = ()=>{
        let activeSlideEl;
        if (swiper.virtual && swiper.params.virtual.enabled) activeSlideEl = swiper.slides.find((slideEl)=>slideEl.classList.contains('swiper-slide-active'));
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        const currentSlideDelay = parseInt(activeSlideEl.getAttribute('data-swiper-autoplay'), 10);
        return currentSlideDelay;
    };
    const getTotalDelay = ()=>{
        let totalDelay = swiper.params.autoplay.delay;
        const currentSlideDelay = getSlideDelay();
        if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0) totalDelay = currentSlideDelay;
        return totalDelay;
    };
    const run = (delayForce)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        cancelAnimationFrame(raf);
        calcTimeLeft();
        let delay = delayForce;
        if (typeof delay === 'undefined') {
            delay = getTotalDelay();
            autoplayDelayTotal = delay;
            autoplayDelayCurrent = delay;
        }
        autoplayTimeLeft = delay;
        const speed = swiper.params.speed;
        const proceed = ()=>{
            if (!swiper || swiper.destroyed) return;
            if (swiper.params.autoplay.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit('autoplay');
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit('autoplay');
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(()=>{
                    run();
                });
            }
        };
        if (delay > 0) {
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                proceed();
            }, delay);
        } else requestAnimationFrame(()=>{
            proceed();
        });
        // eslint-disable-next-line
        return delay;
    };
    const start = ()=>{
        autoplayStartTime = new Date().getTime();
        swiper.autoplay.running = true;
        run();
        emit('autoplayStart');
    };
    const stop = ()=>{
        swiper.autoplay.running = false;
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        emit('autoplayStop');
    };
    const pause = (internal, reset)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        const proceed = ()=>{
            emit('autoplayPause');
            if (swiper.params.autoplay.waitForTransition) swiper.wrapperEl.addEventListener('transitionend', onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            proceed();
            return;
        }
        const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    const resume = ()=>{
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit('autoplayResume');
    };
    const onVisibilityChange = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
        if (document.visibilityState === 'hidden') {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === 'visible') resume();
    };
    const onPointerEnter = (e)=>{
        if (e.pointerType !== 'mouse') return;
        pausedByInteraction = true;
        pausedByPointerEnter = true;
        if (swiper.animating || swiper.autoplay.paused) return;
        pause(true);
    };
    const onPointerLeave = (e)=>{
        if (e.pointerType !== 'mouse') return;
        pausedByPointerEnter = false;
        if (swiper.autoplay.paused) resume();
    };
    const attachMouseEvents = ()=>{
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.el.addEventListener('pointerenter', onPointerEnter);
            swiper.el.addEventListener('pointerleave', onPointerLeave);
        }
    };
    const detachMouseEvents = ()=>{
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('pointerenter', onPointerEnter);
            swiper.el.removeEventListener('pointerleave', onPointerLeave);
        }
    };
    const attachDocumentEvents = ()=>{
        const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
        document.addEventListener('visibilitychange', onVisibilityChange);
    };
    const detachDocumentEvents = ()=>{
        const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
    };
    on('init', ()=>{
        if (swiper.params.autoplay.enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            start();
        }
    });
    on('destroy', ()=>{
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on('_freeModeStaticRelease', ()=>{
        if (pausedByTouch || pausedByInteraction) resume();
    });
    on('_freeModeNoMomentumRelease', ()=>{
        if (!swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on('beforeTransitionStart', (_s, speed, internal)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on('sliderFirstMove', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.params.autoplay.disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(()=>{
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on('touchEnd', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        clearTimeout(touchStartTimeout);
        clearTimeout(timeout);
        if (swiper.params.autoplay.disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on('slideChange', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) {
            autoplayTimeLeft = getTotalDelay();
            autoplayDelayTotal = getTotalDelay();
        }
    });
    Object.assign(swiper.autoplay, {
        start: start,
        stop: stop,
        pause: pause,
        resume: resume
    });
}




function $21e2f533778c20f0$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-thumbs'
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function isVirtualEnabled() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return false;
        return thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled;
    }
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            if (thumbsParams.swiper.destroyed) {
                initialized = false;
                return false;
            }
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper.update();
        } else if ((0, $36f917fbf2efdd6b$export$ffb5f4729a158638)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on('tap', onThumbClick);
        if (isVirtualEnabled()) swiper.thumbs.swiper.on('virtualUpdate', ()=>{
            update(false, {
                autoScroll: false
            });
        });
        return true;
    }
    function update(initial, p) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach((slideEl)=>slideEl.classList.remove(thumbActiveClass));
        if (thumbsSwiper.params.loop || isVirtualEnabled()) for(let i = 0; i < thumbsToActivate; i += 1)(0, $36f917fbf2efdd6b$export$f1e1789686576879)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach((slideEl)=>{
            slideEl.classList.add(thumbActiveClass);
        });
        else {
            for(let i = 0; i < thumbsToActivate; i += 1)if (thumbsSwiper.slides[swiper.realIndex + i]) thumbsSwiper.slides[swiper.realIndex + i].classList.add(thumbActiveClass);
        }
        if (p?.autoScroll ?? true) autoScroll(initial ? 0 : undefined);
    }
    function autoScroll(slideSpeed) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            const currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                const newThumbsSlide = thumbsSwiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') === `${swiper.realIndex}`);
                newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
                direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
            }
            if (useOffset) newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, slideSpeed);
            }
        }
    }
    on('beforeInit', ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === 'string' || thumbs.swiper instanceof HTMLElement) {
            const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
            const getThumbsElementAndInit = ()=>{
                const thumbsElement = typeof thumbs.swiper === 'string' ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onThumbsSwiper = (e)=>{
                        thumbs.swiper = e.detail[0];
                        thumbsElement.removeEventListener(eventName, onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener(eventName, onThumbsSwiper);
                }
                return thumbsElement;
            };
            const watchForThumbsToAppear = ()=>{
                if (swiper.destroyed) return;
                const thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on('slideChange update resize observerUpdate', ()=>{
        update();
    });
    on('setTransition', (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on('beforeDestroy', ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $49f3fa363ac09256$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, once: once }) {
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        const { touchEventsData: data, touches: touches } = swiper;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)()
        });
    }
    function onTouchEnd({ currentPos: currentPos }) {
        if (swiper.params.cssMode) return;
        const { params: params, wrapperEl: wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper;
        // Time diff
        const touchEndTime = (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once('transitionEnd', ()=>{
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, $36f917fbf2efdd6b$export$ae1af26003f05816)(wrapperEl, ()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        (0, $36f917fbf2efdd6b$export$ae1af26003f05816)(wrapperEl, ()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, $36f917fbf2efdd6b$export$ae1af26003f05816)(wrapperEl, ()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit('_freeModeNoMomentumRelease');
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            emit('_freeModeStaticRelease');
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}


function $3e2c28ea1ae0e231$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        grid: {
            rows: 1,
            fill: 'column'
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    let wasMultiRow;
    const getSpaceBetween = ()=>{
        let spaceBetween = swiper.params.spaceBetween;
        if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
        else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    const initSlides = (slides)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== 'auto' && fill === 'row') slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, Math.floor(slidesPerView) * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    const unsetSlides = ()=>{
        if (swiper.slides) swiper.slides.forEach((slide)=>{
            if (slide.swiperSlideGridSet) {
                slide.style.height = '';
                slide.style[swiper.getDirectionLabel('margin-top')] = '';
            }
        });
    };
    const updateSlide = (i, slide, slides)=>{
        const { slidesPerGroup: slidesPerGroup } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === 'row' && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = newSlideOrderIndex;
        } else if (fill === 'column') {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.row = row;
        slide.column = column;
        slide.style.height = `calc((100% - ${(rows - 1) * spaceBetween}px) / ${rows})`;
        slide.style[swiper.getDirectionLabel('margin-top')] = row !== 0 ? spaceBetween && `${spaceBetween}px` : '';
        slide.swiperSlideGridSet = true;
    };
    const updateWrapperSize = (slideSize, snapGrid)=>{
        const { centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        if (!swiper.params.cssMode) swiper.wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
        if (centeredSlides) {
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            snapGrid.push(...newSlidesGrid);
        }
    };
    const onInit = ()=>{
        wasMultiRow = swiper.params.grid && swiper.params.grid.rows > 1;
    };
    const onUpdate = ()=>{
        const { params: params, el: el } = swiper;
        const isMultiRow = params.grid && params.grid.rows > 1;
        if (wasMultiRow && !isMultiRow) {
            el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
            numFullColumns = 1;
            swiper.emitContainerClasses();
        } else if (!wasMultiRow && isMultiRow) {
            el.classList.add(`${params.containerModifierClass}grid`);
            if (params.grid.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
            swiper.emitContainerClasses();
        }
        wasMultiRow = isMultiRow;
    };
    on('init', onInit);
    on('update', onUpdate);
    swiper.grid = {
        initSlides: initSlides,
        unsetSlides: unsetSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}



function $eb2d45639f1e8538$var$appendSlide(slides) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    const appendElement = (slideEl)=>{
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(tempDOM, slideEl);
            slidesEl.append(tempDOM.children[0]);
            (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(tempDOM, '');
        } else slidesEl.append(slideEl);
    };
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) appendElement(slides[i]);
    } else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}
function $eb2d45639f1e8538$var$prependSlide(slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    const prependElement = (slideEl)=>{
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(tempDOM, slideEl);
            slidesEl.prepend(tempDOM.children[0]);
            (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(tempDOM, '');
        } else slidesEl.prepend(slideEl);
    };
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) prependElement(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
function $eb2d45639f1e8538$var$addSlide(index, slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides[i];
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) slidesEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)slidesEl.append(slidesBuffer[i]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $eb2d45639f1e8538$var$removeSlide(slidesIndexes) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $eb2d45639f1e8538$var$removeAllSlides() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
function $eb2d45639f1e8538$export$2e2bcd8739ae039({ swiper: swiper }) {
    Object.assign(swiper, {
        appendSlide: $eb2d45639f1e8538$var$appendSlide.bind(swiper),
        prependSlide: $eb2d45639f1e8538$var$prependSlide.bind(swiper),
        addSlide: $eb2d45639f1e8538$var$addSlide.bind(swiper),
        removeSlide: $eb2d45639f1e8538$var$removeSlide.bind(swiper),
        removeAllSlides: $eb2d45639f1e8538$var$removeAllSlides.bind(swiper)
    });
}


function $6be88bfc4d238db6$export$f1e1789686576879(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on('beforeInit', ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on('setTranslate _virtualUpdated', ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on('transitionEnd', ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return;
            // remove shadows
            swiper.slides.forEach((slideEl)=>{
                slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>shadowEl.remove());
            });
            // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on('virtualUpdate', ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}



function $b32fc4882a084e0d$export$f1e1789686576879(effectParams, slideEl) {
    const transformEl = (0, $36f917fbf2efdd6b$export$39b482c5e57630a8)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = 'hidden';
        transformEl.style['-webkit-backface-visibility'] = 'hidden';
    }
    return transformEl;
}



function $8cd9c8d5770c3e4b$export$f1e1789686576879({ swiper: swiper, duration: duration, transformElements: transformElements, allSlides: allSlides }) {
    const { activeIndex: activeIndex } = swiper;
    const getSlide = (el)=>{
        if (!el.parentElement) {
            // assume shadow root
            const slide = swiper.slides.find((slideEl)=>slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode);
            return slide;
        }
        return el.parentElement;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter((transformEl)=>{
            const el = transformEl.classList.contains('swiper-slide-transform') ? getSlide(transformEl) : transformEl;
            return swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach((el)=>{
            (0, $36f917fbf2efdd6b$export$ae1af26003f05816)(el, ()=>{
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                const evt = new window.CustomEvent('transitionend', {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}



function $5d17e4afe2f572c9$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        fadeEffect: {
            crossFade: false
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = swiper.slides[i];
            const offset = slideEl.swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
            const targetEl = (0, $b32fc4882a084e0d$export$f1e1789686576879)(params, slideEl);
            targetEl.style.opacity = slideOpacity;
            targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $36f917fbf2efdd6b$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
        });
        (0, $8cd9c8d5770c3e4b$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $6be88bfc4d238db6$export$f1e1789686576879)({
        effect: 'fade',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




function $7a34974922f14d54$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = (slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) {
            shadowBefore = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}`.split(' '));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}`.split(' '));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { el: el, wrapperEl: wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const r = (0, $36f917fbf2efdd6b$export$407448d2b89b1813)(swiper);
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', 'swiper-cube-shadow');
                    swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = `${swiperWidth}px`;
            } else {
                cubeShadowEl = el.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', 'swiper-cube-shadow');
                    el.append(cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${r(isHorizontal ? 0 : -slideAngle)}deg) rotateY(${r(isHorizontal ? slideAngle : 0)}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
        wrapperEl.style['-webkit-transform-origin'] = `50% 50% -${swiperSize / 2}px`;
        if (params.shadow) {
            if (isHorizontal) cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${params.shadowScale})`;
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-89.99deg)`;
            }
        }
        const zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
        wrapperEl.style.transform = `translate3d(0px,0,${zFactor}px) rotateX(${r(swiper.isHorizontal() ? 0 : wrapperRotate)}deg) rotateY(${r(swiper.isHorizontal() ? -wrapperRotate : 0)}deg)`;
        wrapperEl.style.setProperty('--swiper-cube-translate-z', `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { el: el, slides: slides } = swiper;
        slides.forEach((slideEl)=>{
            slideEl.style.transitionDuration = `${duration}ms`;
            slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((subEl)=>{
                subEl.style.transitionDuration = `${duration}ms`;
            });
        });
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
            const shadowEl = el.querySelector('.swiper-cube-shadow');
            if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
        }
    };
    (0, $6be88bfc4d238db6$export$f1e1789686576879)({
        effect: 'cube',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}



function $fab3d8cd791e5fc7$export$db3b6bfb95261072(suffix, slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}${suffix ? ` swiper-slide-shadow-${suffix}` : ''}`;
    const shadowContainer = (0, $36f917fbf2efdd6b$export$39b482c5e57630a8)(slideEl);
    let shadowEl = shadowContainer.querySelector(`.${shadowClass.split(' ').join('.')}`);
    if (!shadowEl) {
        shadowEl = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', shadowClass.split(' '));
        shadowContainer.append(shadowEl);
    }
    return shadowEl;
}






function $68ca3c9f22027c47$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    const createSlideShadows = (slideEl, progress)=>{
        let shadowBefore = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) shadowBefore = (0, $fab3d8cd791e5fc7$export$db3b6bfb95261072)('flip', slideEl, swiper.isHorizontal() ? 'left' : 'top');
        if (!shadowAfter) shadowAfter = (0, $fab3d8cd791e5fc7$export$db3b6bfb95261072)('flip', slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        swiper.params.flipEffect;
        swiper.slides.forEach((slideEl)=>{
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        const rotateFix = (0, $36f917fbf2efdd6b$export$407448d2b89b1813)(swiper);
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            const offset = slideEl.swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows(slideEl, progress);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateFix(rotateX)}deg) rotateY(${rotateFix(rotateY)}deg)`;
            const targetEl = (0, $b32fc4882a084e0d$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $36f917fbf2efdd6b$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $8cd9c8d5770c3e4b$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $6be88bfc4d238db6$export$f1e1789686576879)({
        effect: 'flip',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}






function $983c76c349961a02$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth;
        const r = (0, $36f917fbf2efdd6b$export$407448d2b89b1813)(swiper);
        // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const slideEl = slides[i];
            const slideSize = slidesSizesGrid[i];
            const slideOffset = slideEl.swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch;
            // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${r(rotateX)}deg) rotateY(${r(rotateY)}deg) scale(${scale})`;
            const targetEl = (0, $b32fc4882a084e0d$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let shadowBeforeEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
                let shadowAfterEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
                if (!shadowBeforeEl) shadowBeforeEl = (0, $fab3d8cd791e5fc7$export$db3b6bfb95261072)('coverflow', slideEl, isHorizontal ? 'left' : 'top');
                if (!shadowAfterEl) shadowAfterEl = (0, $fab3d8cd791e5fc7$export$db3b6bfb95261072)('coverflow', slideEl, isHorizontal ? 'right' : 'bottom');
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $36f917fbf2efdd6b$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
    };
    (0, $6be88bfc4d238db6$export$f1e1789686576879)({
        effect: 'coverflow',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}







function $ed2173e49aa32019$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === 'string') return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, wrapperEl: wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        const rotateFix = (0, $36f917fbf2efdd6b$export$407448d2b89b1813)(swiper);
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
            const offset = slideEl.swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            });
            // set rotates
            r.forEach((value, index)=>{
                let val = data.rotate[index] * Math.abs(progress * multiplier);
                r[index] = val;
            });
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(', ');
            const rotateString = `rotateX(${rotateFix(r[0])}deg) rotateY(${rotateFix(r[1])}deg) rotateZ(${rotateFix(r[2])}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;
            // Set shadows
            if (custom && data.shadow || !custom) {
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl && data.shadow) shadowEl = (0, $fab3d8cd791e5fc7$export$db3b6bfb95261072)('creative', slideEl);
                if (shadowEl) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const targetEl = (0, $b32fc4882a084e0d$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = opacityString;
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $36f917fbf2efdd6b$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $8cd9c8d5770c3e4b$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $6be88bfc4d238db6$export$f1e1789686576879)({
        effect: 'creative',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}







function $e7abdc2d61949d3e$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex, rtlTranslate: rtl } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = slideEl.swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${(params.rotate || swiper.isHorizontal() ? -25 : 0) * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            /* eslint-disable */ const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
            /* eslint-enable */ if (params.slideShadows) {
                // Set shadows
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl) shadowEl = (0, $fab3d8cd791e5fc7$export$db3b6bfb95261072)('cards', slideEl);
                if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const targetEl = (0, $b32fc4882a084e0d$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $36f917fbf2efdd6b$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $8cd9c8d5770c3e4b$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $6be88bfc4d238db6$export$f1e1789686576879)({
        effect: 'cards',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                _loopSwapReset: false,
                watchSlidesProgress: true,
                loopAdditionalSlides: swiper.params.cardsEffect.rotate ? 3 : 2,
                centeredSlides: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




document.addEventListener('DOMContentLoaded', ()=>{
    const sliders = document.querySelectorAll('.akc');
    if (!sliders.length) return;
    sliders.forEach((slider)=>{
        new (0, $029bc59d811a92d7$export$25ce5a424b770e84)(slider, {
            modules: [
                (0, $9dcb69c205fd1703$export$2e2bcd8739ae039)
            ],
            wrapperClass: 'akc__list',
            slideClass: 'akc__item',
            navigation: {
                prevEl: slider.querySelector('.akc-slider__btn--prev'),
                nextEl: slider.querySelector('.akc-slider__btn--next')
            },
            breakpoints: {
                0: {
                    slidesPerView: 2,
                    spaceBetween: 10
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 15
                },
                1200: {
                    slidesPerView: 5,
                    spaceBetween: 20
                }
            },
            spaceBetween: 10,
            watchOverflow: true,
            loop: false
        });
    });
});





const $d90cc05fbc862d96$export$a2c6579ad5c38b4c = 'catalog-detail__image-wrapper';
const $d90cc05fbc862d96$export$2f6a37cc3c4f385f = 'catalog-card__image-wrapper';
const $d90cc05fbc862d96$export$32a5abf1f9cfbf46 = (prefix)=>[
        `${prefix}--wide`,
        `${prefix}--tall`,
        `${prefix}--square`
    ];
const $d90cc05fbc862d96$export$9ba501f37a9f6eae = (prefix, width, height)=>{
    if (!width || !height) return '';
    const ratio = width / height;
    if (ratio > 1.05) return `${prefix}--wide`;
    if (ratio < 0.95) return `${prefix}--tall`;
    return `${prefix}--square`;
};
const $d90cc05fbc862d96$export$f99fae79892ab783 = (wrapper, width, height, prefix)=>{
    if (!wrapper || !width || !height) return;
    wrapper.classList.remove(...$d90cc05fbc862d96$export$32a5abf1f9cfbf46(prefix));
    const orientationClass = $d90cc05fbc862d96$export$9ba501f37a9f6eae(prefix, width, height);
    if (orientationClass) wrapper.classList.add(orientationClass);
};
const $d90cc05fbc862d96$export$ae7678e6c7e3e3ff = (wrapper, img, prefix)=>{
    const apply = ()=>{
        $d90cc05fbc862d96$export$f99fae79892ab783(wrapper, img.naturalWidth, img.naturalHeight, prefix);
    };
    if (img.complete && img.naturalWidth) {
        apply();
        return;
    }
    img.addEventListener('load', apply, {
        once: true
    });
};
const $d90cc05fbc862d96$export$515a6fb179e5806 = ()=>{
    document.querySelectorAll('.catalog-card__image-wrapper').forEach((wrapper)=>{
        const img = wrapper.querySelector('.catalog-card__image');
        if (!img) return;
        const width = Number(img.getAttribute('width'));
        const height = Number(img.getAttribute('height'));
        if (width && height) {
            $d90cc05fbc862d96$export$f99fae79892ab783(wrapper, width, height, $d90cc05fbc862d96$export$2f6a37cc3c4f385f);
            return;
        }
        $d90cc05fbc862d96$export$ae7678e6c7e3e3ff(wrapper, img, $d90cc05fbc862d96$export$2f6a37cc3c4f385f);
    });
};


document.addEventListener('DOMContentLoaded', ()=>{
    (0, $d90cc05fbc862d96$export$515a6fb179e5806)();
    const sliders = document.querySelectorAll('.viewed-slider');
    if (!sliders.length) return;
    sliders.forEach((slider)=>{
        new (0, $029bc59d811a92d7$export$25ce5a424b770e84)(slider, {
            modules: [
                (0, $9dcb69c205fd1703$export$2e2bcd8739ae039)
            ],
            wrapperClass: 'viewed__slider',
            slideClass: 'viewed__item',
            navigation: {
                prevEl: slider.querySelector('.viewed__btn--prev'),
                nextEl: slider.querySelector('.viewed__btn--next')
            },
            breakpoints: {
                0: {
                    slidesPerView: 2,
                    spaceBetween: 12
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 16
                },
                1200: {
                    slidesPerView: 5,
                    spaceBetween: 20
                }
            },
            watchOverflow: true,
            loop: false
        });
    });
});




document.addEventListener('DOMContentLoaded', ()=>{
    const sliders = document.querySelectorAll('.brands-slider');
    if (!sliders.length) return;
    sliders.forEach((slider)=>{
        new (0, $029bc59d811a92d7$export$25ce5a424b770e84)(slider, {
            modules: [
                (0, $9dcb69c205fd1703$export$2e2bcd8739ae039)
            ],
            navigation: {
                prevEl: slider.querySelector('.brands-slider__btn--prev'),
                nextEl: slider.querySelector('.brands-slider__btn--next')
            },
            breakpoints: {
                0: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                768: {
                    slidesPerView: 4,
                    spaceBetween: 20
                },
                1200: {
                    slidesPerView: 5,
                    spaceBetween: 20
                }
            },
            slidesPerView: 'auto',
            spaceBetween: 20,
            centeredSlides: false,
            loop: false,
            watchOverflow: true
        });
    });
});




document.addEventListener('DOMContentLoaded', ()=>{
    const sliders = document.querySelectorAll('.js-banner-slider');
    if (!sliders.length) return;
    sliders.forEach((slider)=>{
        const slides = slider.querySelectorAll('.swiper-slide');
        if (slides.length <= 1) return;
        const disableAutoplay = slider.dataset.disableAutoplay === 'true';
        new (0, $029bc59d811a92d7$export$25ce5a424b770e84)(slider, {
            modules: [
                (0, $c1783ac9556c9fef$export$2e2bcd8739ae039),
                (0, $69d1e0b9767b27dd$export$2e2bcd8739ae039)
            ],
            loop: true,
            autoplay: disableAutoplay ? false : {
                delay: 5000,
                disableOnInteraction: false
            },
            pagination: {
                el: slider.querySelector('.banner__dots'),
                clickable: true,
                bulletClass: 'banner__dot',
                bulletActiveClass: 'banner__dot--active'
            },
            allowTouchMove: true
        });
    });
});




const $0a14fa60056f1011$var$initFatSalesBanners = ()=>{
    const sliders = document.querySelectorAll('.js-fat-sales-banners');
    if (!sliders.length) return;
    sliders.forEach((slider)=>{
        const slides = slider.querySelectorAll('.swiper-slide');
        if (slides.length <= 1) return;
        const editMode = slider.dataset.editMode === '1';
        new (0, $029bc59d811a92d7$export$25ce5a424b770e84)(slider, {
            modules: [
                (0, $c1783ac9556c9fef$export$2e2bcd8739ae039),
                (0, $69d1e0b9767b27dd$export$2e2bcd8739ae039)
            ],
            // В режиме правки loop клонирует слайды и ломает Bitrix edit-area id
            loop: !editMode,
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 16,
            watchOverflow: true,
            observer: true,
            observeParents: true,
            autoplay: editMode ? false : {
                delay: 3500,
                disableOnInteraction: false
            },
            pagination: {
                el: slider.querySelector('.fat-sales-banners-carousel__dots'),
                clickable: true,
                bulletClass: 'fat-sales-banners-carousel__dot',
                bulletActiveClass: 'active'
            },
            breakpoints: {
                961: {
                    spaceBetween: 30
                }
            }
        });
    });
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $0a14fa60056f1011$var$initFatSalesBanners);
else $0a14fa60056f1011$var$initFatSalesBanners();


function $5228c155846722a7$export$6c175067e3bccd04(price, count) {
    const totalSum = document.querySelector('.catalog-detail__purchase-total');
    const totalSpan = totalSum?.querySelector('span');
    if (!totalSpan) return;
    const hasExtra = count > 1;
    if (hasExtra) {
        totalSpan.textContent = (price * count).toLocaleString('ru-RU') + " \u20BD";
        totalSum.classList.add('active');
    } else totalSum.classList.remove('active');
}


document.querySelectorAll('.counter').forEach((counter)=>{
    const digit = counter.querySelector('.counter__digit');
    const plusBtn = counter.querySelector('.counter__control.plus');
    let count = parseInt(digit.value) || 1;
    const min = count;
    const max = plusBtn?.dataset.max ? parseInt(plusBtn.dataset.max) : Infinity;
    counter.addEventListener('click', (e)=>{
        const btn = e.target.closest('.counter__control');
        if (!btn) return;
        if (btn.textContent.trim() === '-' && count > min) count--;
        if (btn.textContent.trim() === '+' && count < max) count++;
        digit.value = count;
        (0, $5228c155846722a7$export$6c175067e3bccd04)(Number(counter.dataset.price), count);
    });
});


document.addEventListener('click', (e)=>{
    const select = e.target.closest('.select');
    document.querySelectorAll('.select').forEach((el)=>{
        el.classList.toggle('select--active', el === select && !el.classList.contains('select--active'));
    });
});


(function() {
    const AJAX_URL = '/ajax/productStoreAmountCompact.php';
    const SITE_ID = 's1';
    let currentPopup = null;
    let isListeningOutside = false;
    function closePopup() {
        if (currentPopup && currentPopup.parentNode) currentPopup.remove();
        currentPopup = null;
        if (isListeningOutside) {
            document.removeEventListener('click', outsideClickListener);
            document.removeEventListener('keydown', escKeyListener);
            isListeningOutside = false;
        }
    }
    function outsideClickListener(event) {
        if (currentPopup && !currentPopup.contains(event.target)) closePopup();
    }
    function escKeyListener(event) {
        if (event.key === 'Escape') closePopup();
    }
    function positionPopup(popup, trigger) {
        const rect = trigger.getBoundingClientRect();
        const popupWidth = popup.offsetWidth;
        const popupHeight = popup.offsetHeight;
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        let left = rect.left + scrollLeft - 238;
        let top = rect.top + scrollTop;
        if (left < 10) left = rect.right + scrollLeft + 10;
        if (left + popupWidth > window.innerWidth + scrollLeft - 10) left = rect.left + scrollLeft - popupWidth - 10;
        if (top + popupHeight > window.innerHeight + scrollTop - 10) top = rect.bottom + scrollTop - popupHeight - 10;
        if (top < scrollTop + 10) top = rect.bottom + scrollTop + 5;
        popup.style.position = 'absolute';
        popup.style.left = `${Math.max(5, left)}px`;
        popup.style.top = `${Math.max(5, top)}px`;
        popup.style.zIndex = '10000';
    }
    function createLoadingPopup(trigger) {
        const popup = document.createElement('div');
        popup.className = 'custom-store-popup custom-store-popup--font custom-store-popup--loading';
        popup.innerHTML = `
            <div class="spinner"></div>
            <div class="loading-text">\u{417}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...</div>
        `;
        document.body.appendChild(popup);
        positionPopup(popup, trigger);
        return popup;
    }
    function parseStoresFromHtml(html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const blocks = doc.querySelectorAll('.stores_block');
        const stores = [];
        blocks.forEach((block)=>{
            const addrLink = block.querySelector('.stores_text_wrapp a');
            let address = '';
            if (addrLink) address = addrLink.textContent.trim().replace(/\s+/g, ' ');
            if (!address) {
                const textWrap = block.querySelector('.stores_text_wrapp');
                if (textWrap) address = textWrap.textContent.trim();
            }
            const statusSpan = block.querySelector('.item-stock .value');
            let available = false;
            let quantity = null;
            if (statusSpan) {
                const text = statusSpan.textContent;
                if (text.includes("\u0415\u0441\u0442\u044C \u0432 \u043D\u0430\u043B\u0438\u0447\u0438\u0438")) {
                    available = true;
                    const match = text.match(/\((\d+)\)/);
                    if (match) quantity = parseInt(match[1], 10);
                } else if (text.includes("\u041D\u0435\u0442 \u0432 \u043D\u0430\u043B\u0438\u0447\u0438\u0438")) available = false;
            }
            if (address) stores.push({
                address: address,
                available: available,
                quantity: quantity
            });
        });
        return stores;
    }
    function renderPopupContent(stores, productUrl) {
        const fragment = document.createDocumentFragment();
        const title = document.createElement('div');
        title.className = 'custom-store-popup__title';
        title.textContent = "\u041D\u0430\u043B\u0438\u0447\u0438\u0435";
        fragment.appendChild(title);
        const list = document.createElement('div');
        list.className = 'custom-store-popup__list';
        if (stores.length === 0) {
            const empty = document.createElement('div');
            empty.className = 'custom-store-popup__empty';
            empty.textContent = "\u041D\u0435\u0442 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043E \u043D\u0430\u043B\u0438\u0447\u0438\u0438";
            list.appendChild(empty);
        } else stores.forEach((store)=>{
            const item = document.createElement('div');
            item.className = 'custom-store-popup__item';
            const address = document.createElement('div');
            address.className = 'custom-store-popup__address';
            address.textContent = store.address;
            item.appendChild(address);
            const status = document.createElement('div');
            status.className = 'custom-store-popup__status';
            if (store.available) {
                const available = document.createElement('span');
                available.className = 'custom-store-popup__status-value available';
                available.textContent = "\u0412 \u043D\u0430\u043B\u0438\u0447\u0438\u0438";
                status.appendChild(available);
                if (store.quantity !== null) {
                    const quantity = document.createElement('span');
                    quantity.className = 'custom-store-popup__quantity';
                    quantity.textContent = `(${store.quantity})`;
                    status.appendChild(quantity);
                }
            } else {
                const unavailable = document.createElement('span');
                unavailable.className = 'custom-store-popup__status-value not-available';
                unavailable.textContent = "\u041D\u0435\u0442 \u0432 \u043D\u0430\u043B\u0438\u0447\u0438\u0438";
                status.appendChild(unavailable);
            }
            item.appendChild(status);
            list.appendChild(item);
        });
        fragment.appendChild(list);
        const moreBtn = document.createElement('button');
        moreBtn.className = 'custom-store-popup__more';
        moreBtn.textContent = "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435";
        moreBtn.addEventListener('click', (event)=>{
            event.stopPropagation();
            if (productUrl) window.location.href = productUrl;
            else closePopup();
        });
        fragment.appendChild(moreBtn);
        return fragment;
    }
    async function onStoreTriggerClick(event) {
        const trigger = event.currentTarget;
        event.stopPropagation();
        if (currentPopup) closePopup();
        const elementId = trigger.getAttribute('data-id');
        const storesData = trigger.getAttribute('data-stores');
        if (!elementId) return;
        const storeIds = storesData ? storesData.split(',').map((id)=>id.trim()).filter(Boolean) : [];
        const loadingPopup = createLoadingPopup(trigger);
        currentPopup = loadingPopup;
        const params = new URLSearchParams();
        params.append('ajax', 'Y');
        params.append('ELEMENT_ID', elementId);
        params.append('FIELDS', '');
        params.append('USER_FIELDS', '');
        params.append('SITE_ID', SITE_ID);
        storeIds.forEach((id)=>{
            params.append('STORES[]', id);
        });
        try {
            const response = await fetch(AJAX_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: params.toString()
            });
            if (!response.ok) {
                closePopup();
                return;
            }
            const html = await response.text();
            if (html.includes('Cannot find') || html.includes("\u041E\u0448\u0438\u0431\u043A\u0430")) {
                closePopup();
                return;
            }
            const stores = parseStoresFromHtml(html);
            const productCard = trigger.closest('.catalog-card');
            const productUrl = productCard?.querySelector('.catalog-card__info-title')?.href || '';
            const content = renderPopupContent(stores, productUrl);
            loadingPopup.innerHTML = '';
            loadingPopup.className = 'custom-store-popup custom-store-popup--font';
            loadingPopup.append(content);
            positionPopup(loadingPopup, trigger);
            if (!isListeningOutside) {
                document.addEventListener('click', outsideClickListener);
                document.addEventListener('keydown', escKeyListener);
                isListeningOutside = true;
            }
        } catch  {
            closePopup();
        }
    }
    document.addEventListener('click', (event)=>{
        const trigger = event.target.closest('.js-store-trigger');
        if (trigger) {
            event.preventDefault();
            event.stopPropagation();
            onStoreTriggerClick({
                currentTarget: trigger,
                stopPropagation: ()=>{}
            });
        }
    });
})();


/* global BX, initCountdown, setBasketStatusBtn, InitFlexSlider, InitZoomPict, initCalculatePreview, showTotalSummItem */ (function() {
    class FastViewModal {
        constructor(){
            this.modal = null;
            this.overlay = null;
            this.isLoading = false;
            this.init();
        }
        init() {
        // document.addEventListener('click', (e) => {
        //     const trigger = e.target.closest('[data-param-form_id="fast_view"], .fast_view_block');
        //     if (!trigger) return;
        //     const formId = trigger.getAttribute('data-param-form_id');
        //     if (formId !== 'fast_view') return;
        //     e.preventDefault();
        //     this.open(trigger);
        // });
        //
        // document.addEventListener('keydown', (e) => {
        //     if (e.key === 'Escape') this.close();
        // });
        }
        async open(trigger) {
            if (this.isLoading) return;
            this.isLoading = true;
            let itemHref = trigger.getAttribute('data-param-item_href');
            if (!itemHref) {
                console.error('FastViewModal: Missing item href');
                this.isLoading = false;
                return;
            }
            try {
                itemHref = decodeURIComponent(itemHref);
            } catch (e) {
                console.error('FastViewModal: decodeURIComponent error', e);
            }
            try {
                const modalHtml = await fetch('/ajax/fast_view.php', {
                    method: 'GET',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                }).then((response)=>response.text());
                this.render(modalHtml);
                const separator = itemHref.includes('?') ? '&' : '?';
                const productUrl = itemHref + separator + 'FAST_VIEW=Y';
                const productHtml = await fetch(productUrl, {
                    method: 'GET',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                }).then((response)=>response.text());
                const processed = BX.processHTML(productHtml);
                const container = this.modal.querySelector('#fast_view_item');
                if (container) container.innerHTML = processed.HTML;
                BX.ajax.processScripts(processed.SCRIPT);
                this.initProductFunctions();
                const hiddenTitle = this.modal.querySelector('.title.hidden');
                const modalTitle = this.modal.querySelector('.form_head h2');
                if (hiddenTitle && modalTitle) modalTitle.innerHTML = hiddenTitle.innerHTML;
            } catch (e) {
                console.error('FastViewModal: fetch or render error', e);
            } finally{
                this.isLoading = false;
            }
        }
        render(html) {
            this.close();
            this.overlay = document.createElement('div');
            this.overlay.className = 'jqmOverlay';
            this.overlay.addEventListener('click', ()=>this.close());
            this.modal = document.createElement('div');
            this.modal.className = 'fast_view_frame jqmWindow popup';
            this.modal.innerHTML = html;
            document.body.appendChild(this.overlay);
            document.body.appendChild(this.modal);
            const closeBtn = this.modal.querySelector('.jqmClose');
            if (closeBtn) closeBtn.addEventListener('click', (e)=>{
                e.preventDefault();
                this.close();
            });
        }
        initProductFunctions() {
            if (typeof initCountdown === 'function') initCountdown();
            if (typeof setBasketStatusBtn === 'function') setBasketStatusBtn();
            if (typeof InitFlexSlider === 'function') InitFlexSlider();
            if (typeof InitZoomPict === 'function') {
                const zoomPicture = this.modal.querySelector('.zoom_picture');
                if (zoomPicture) InitZoomPict(zoomPicture);
            }
            if (typeof initCalculatePreview === 'function' && this.modal.querySelector('.item_main_info.noffer')) initCalculatePreview();
            if (typeof showTotalSummItem === 'function') setTimeout(()=>showTotalSummItem('Y'), 100);
            window.dispatchEvent(new Event('scroll'));
        }
        close() {
            if (this.modal) this.modal.remove();
            if (this.overlay) this.overlay.remove();
            this.modal = null;
            this.overlay = null;
        }
    }
    new FastViewModal();
})();


parcelRequire("8Qls7");
/* global BX, CatalogCardState */ (function() {
    const activeFavoriteSvg = '<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="34" height="34" rx="17" fill="#2059B0"/><path d="M12.1796 17.5927L17 22.4401L21.8204 17.5927M17 22.4401L11.8783 17.2898C10.5472 15.9512 10.5472 13.781 11.8783 12.4424C13.2095 11.1039 15.6689 11.3661 17 12.7047C18.3311 11.3661 20.7906 11.1039 22.1217 12.4424C23.4528 13.781 23.4528 15.9512 22.1217 17.2898L17 22.4401Z" stroke="white" stroke-width="1.36" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    const activeCompareSvg = '<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="34" height="34" rx="17" fill="#2059B0"/><path d="M12.92 22.4399L12.92 11.5599M17 22.4399L17 15.6399M21.08 22.4399L21.08 19.7199" stroke="white" stroke-width="1.36" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    function storeOriginalSvg(button) {
        if (!button.originalSvgStored) {
            const svgElement = button.querySelector('svg');
            if (svgElement) {
                button.originalSvg = svgElement.outerHTML;
                button.originalSvgStored = true;
            }
        }
    }
    function setButtonActive(button, isActive) {
        if (isActive) {
            button.classList.add('active');
            if (button.classList.contains('catalog-card__favorite')) button.innerHTML = activeFavoriteSvg;
            else if (button.classList.contains('catalog-card__compare')) button.innerHTML = activeCompareSvg;
        } else {
            button.classList.remove('active');
            if (button.originalSvg) button.innerHTML = button.originalSvg;
        }
    }
    function updateButtonFromState(button) {
        const card = button.closest('#product-info-block');
        if (!card) return;
        const productId = card.getAttribute('data-product-id');
        if (!productId) return;
        storeOriginalSvg(button);
        const isFavorite = button.classList.contains('catalog-card__favorite');
        const list = isFavorite ? CatalogCardState.delay : CatalogCardState.compare;
        const isActive = productId in list;
        setButtonActive(button, isActive);
    }
    async function sendRequest(productId, iblockId, type, button, wasActive) {
        let url;
        if (type === 'favorite') url = `/ajax/item.php?item=${productId}&wish_item=Y&offers=N&iblockID=${iblockId}&quantity=1`;
        else url = `/ajax/item.php?item=${productId}&compare_item=Y&iblock_id=${iblockId}`;
        await fetch(url, {
            method: 'GET',
            credentials: 'same-origin'
        }).then((response)=>{
            if (!response.ok) throw new Error();
        }).catch(()=>{
            setButtonActive(button, wasActive);
        });
    }
    async function onButtonClick(event) {
        const button = event.currentTarget;
        const card = button.closest('#product-info-block');
        if (!card) return;
        const productId = card.getAttribute('data-product-id');
        const iblockId = card.getAttribute('data-iblock-id');
        if (!productId || !iblockId) return;
        const wasActive = button.classList.contains('active');
        const newActive = !wasActive;
        setButtonActive(button, newActive);
        const type = button.classList.contains('catalog-card__favorite') ? 'favorite' : 'compare';
        await sendRequest(productId, iblockId, type, button, wasActive);
        if (window.BX?.onCustomEvent) BX.onCustomEvent('onCompleteAction', [
            {
                action: 'loadBasket'
            }
        ]);
    }
    function syncUI() {
        const favoritesBtn = document.querySelectorAll('#btn-favorite');
        const comparesBtn = document.querySelectorAll('#btn-compare');
        favoritesBtn.forEach((btn)=>updateButtonFromState(btn));
        comparesBtn.forEach((btn)=>updateButtonFromState(btn));
    }
    function initButtons() {
        syncUI();
        document.querySelectorAll('#btn-favorite, #btn-compare').forEach((btn)=>{
            btn.removeEventListener('click', onButtonClick);
            btn.addEventListener('click', onButtonClick);
        });
    }
    CatalogCardState.onReady(()=>{
        initButtons();
        CatalogCardState.addUpdateListener(syncUI);
    });
})();


/* global BX, CatalogCardState */ (function() {
    if (!document.querySelector('#basket-panel')) return;
    function getMaxQuantity(card) {
        const attr = card.getAttribute('data-quantity');
        if (attr === null || attr === '') return Infinity;
        const qty = parseInt(attr, 10);
        return isNaN(qty) ? Infinity : qty;
    }
    function initCounters() {
        const counters = document.querySelectorAll('#product-info-block #basket-counter');
        counters.forEach((counter)=>{
            const card = counter.closest('#product-info-block');
            if (!card) return;
            const digitSpan = counter.querySelector('#basket-digit');
            if (!digitSpan) return;
            let currentValue = parseInt(digitSpan.textContent, 10);
            if (isNaN(currentValue) || currentValue < 1) {
                currentValue = 1;
                digitSpan.textContent = currentValue;
            }
            const maxQuantity = getMaxQuantity(card);
            if (maxQuantity > 0 && currentValue > maxQuantity) {
                currentValue = maxQuantity;
                digitSpan.textContent = currentValue;
            }
            const minusBtn = counter.querySelector('#basket-minus');
            const plusBtn = counter.querySelector('#basket-plus');
            const minusHandler = (e)=>{
                e.stopPropagation();
                let val = parseInt(digitSpan.textContent, 10);
                if (isNaN(val)) val = 1;
                if (val > 1) {
                    val--;
                    digitSpan.textContent = val;
                }
            };
            const plusHandler = (e)=>{
                e.stopPropagation();
                let val = parseInt(digitSpan.textContent, 10);
                if (isNaN(val)) val = 1;
                if (maxQuantity > 0 && val < maxQuantity) {
                    val++;
                    digitSpan.textContent = val;
                }
            };
            if (minusBtn) {
                minusBtn.removeEventListener('click', minusHandler);
                minusBtn.addEventListener('click', minusHandler);
            }
            if (plusBtn) {
                plusBtn.removeEventListener('click', plusHandler);
                plusBtn.addEventListener('click', plusHandler);
            }
        });
    }
    function isDetailPage(card) {
        return card.querySelector('.catalog-detail__purchase-base');
    }
    function getButtonText(card, isDisabled) {
        if (isDisabled) return "\u041D\u0435\u0442 \u0432 \u043D\u0430\u043B\u0438\u0447\u0438\u0438";
        return isDetailPage(card) ? "\u0412 \u043A\u043E\u0440\u0437\u0438\u043D\u0443" : "\u041A\u0443\u043F\u0438\u0442\u044C";
    }
    function getBasketButtonElement(card) {
        return card.querySelector('#basket-panel .btn');
    }
    function transformButtonToCartLink(button, card) {
        const counter = card.querySelector('#basket-counter');
        if (counter) counter.style.display = 'none';
        const newLink = document.createElement('a');
        newLink.href = '/basket';
        newLink.className = button.className;
        newLink.textContent = "\u2713 \u0412 \u043A\u043E\u0440\u0437\u0438\u043D\u0435";
        newLink.style.backgroundColor = 'var(--color-green)';
        newLink.style.display = 'inline-flex';
        newLink.style.alignItems = 'center';
        newLink.style.justifyContent = 'center';
        newLink.style.textDecoration = 'none';
        button.replaceWith(newLink);
    }
    function transformLinkToButton(link, card) {
        const counter = card.querySelector('#basket-counter');
        const maxQuantity = getMaxQuantity(card);
        const isDetail = isDetailPage(card);
        if (counter) counter.style.display = maxQuantity > 0 ? '' : 'none';
        const button = document.createElement('button');
        if (isDetail) button.className = link.className;
        else button.className = 'btn btn--mini btn--mini--font';
        button.disabled = maxQuantity === 0;
        button.textContent = getButtonText(card, maxQuantity === 0);
        button.addEventListener('click', onButtonClick);
        link.replaceWith(button);
    }
    function sendRequest(productId, iblockId, quantity) {
        const params = new URLSearchParams();
        params.append('add_item', 'Y');
        params.append('item', productId);
        params.append('quantity', quantity);
        params.append('iblockID', iblockId);
        params.append('offers', 'N');
        params.append('part_props', 'N');
        params.append('add_props', 'Y');
        params.append('prop[]', '0');
        params.append('props', '""');
        params.append('basket_props', '');
        params.append('rid', '');
        return fetch('/ajax/item.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: params.toString(),
            credentials: 'same-origin'
        });
    }
    async function onButtonClick(event) {
        const button = event.currentTarget;
        if (button.tagName === 'A' || button.disabled) return;
        const card = button.closest('#product-info-block');
        if (!card) return;
        const productId = card.getAttribute('data-product-id');
        const iblockId = card.getAttribute('data-iblock-id');
        if (!productId || !iblockId) return;
        const maxQuantity = getMaxQuantity(card);
        if (maxQuantity === 0) return;
        let digitSpan = null;
        if (isDetailPage(card)) digitSpan = card.querySelector('.counter__digit');
        else digitSpan = card.querySelector('#basket-digit');
        let quantity = 1;
        if (digitSpan) {
            let count = digitSpan.tagName === 'INPUT' ? digitSpan.value : digitSpan.textContent;
            let qty = parseInt(count, 10);
            if (!isNaN(qty) && qty > 0) quantity = qty;
        }
        if (maxQuantity > 0) quantity = Math.min(quantity, maxQuantity);
        await sendRequest(productId, iblockId, quantity).then((response)=>{
            if (!response.ok) throw new Error();
            const currentButton = card.querySelector('#basket-panel .btn');
            if (currentButton && currentButton.tagName !== 'A') transformButtonToCartLink(currentButton, card);
            if (typeof window.addBasketCounter === 'function') window.addBasketCounter(productId);
        }).catch(()=>{
        // ignore
        });
        if (window.BX?.onCustomEvent) BX.onCustomEvent('onCompleteAction', [
            {
                action: 'loadBasket'
            }
        ]);
    }
    function applyQuantityConstraints(card) {
        const maxQuantity = getMaxQuantity(card);
        const button = getBasketButtonElement(card);
        const counter = card.querySelector('#basket-counter');
        const isInBasket = button && button.tagName === 'A';
        if (isInBasket) {
            if (counter) counter.style.display = 'none';
            return;
        }
        if (maxQuantity === 0) {
            if (button) {
                button.disabled = true;
                button.textContent = "\u041D\u0435\u0442 \u0432 \u043D\u0430\u043B\u0438\u0447\u0438\u0438";
            }
            if (counter) counter.style.display = 'none';
        } else {
            if (button) {
                button.disabled = false;
                button.textContent = getButtonText(card, false);
            }
            if (counter) counter.style.display = '';
        }
    }
    function syncUI() {
        const productsInBasket = Object.keys(CatalogCardState.basket);
        const cards = document.querySelectorAll('#product-info-block');
        cards.forEach((card)=>{
            const productId = card.getAttribute('data-product-id');
            if (!productId) return;
            const element = getBasketButtonElement(card);
            const isInBasket = productsInBasket.includes(productId);
            const isLink = element && element.tagName === 'A';
            if (isInBasket === isLink) {
                applyQuantityConstraints(card);
                return;
            }
            if (isInBasket) transformButtonToCartLink(element, card);
            else transformLinkToButton(element, card);
        });
    }
    function initButtons() {
        const cards = document.querySelectorAll('#product-info-block');
        cards.forEach((card)=>{
            applyQuantityConstraints(card);
            const button = getBasketButtonElement(card);
            if (button && button.tagName !== 'A') {
                button.removeEventListener('click', onButtonClick);
                button.addEventListener('click', onButtonClick);
            }
        });
        initCounters();
        syncUI();
    }
    CatalogCardState.onReady(()=>{
        initButtons();
        CatalogCardState.addUpdateListener(syncUI);
    });
})();


(function ChangeMobileTitle() {
    const titlePage = document.querySelector('.change-title__page');
    const titleMain = document.querySelector('.change-title__main');
    if (!titlePage || !titleMain) return;
    const valuePageTitle = titlePage.textContent;
    const valueMainTitle = titleMain.textContent;
    function changeTitle() {
        if (window.innerWidth <= 768) {
            titleMain.textContent = valuePageTitle;
            return;
        }
        titleMain.textContent = valueMainTitle;
    }
    changeTitle();
    window.addEventListener('resize', changeTitle);
})();


/* global BX */ (function() {
    'use strict';
    const CAPTCHA_SCRIPT_SRC = 'https://smartcaptcha.yandexcloud.net/captcha.js';
    let captchaScriptLoading = false;
    const FormUtils = {
        setupPhoneMask (input) {
            if (!input) return;
            input.addEventListener('input', function() {
                let value = this.value.replace(/\D/g, '');
                if (value.startsWith('7') || value.startsWith('8')) value = value.slice(1);
                if (value.length > 10) value = value.slice(0, 10);
                let formatted = '';
                if (value.length > 0) {
                    formatted = '+7';
                    formatted += ' (' + value.slice(0, 3);
                }
                if (value.length >= 4) formatted += ') ' + value.slice(3, 6);
                if (value.length >= 7) formatted += '-' + value.slice(6, 8);
                if (value.length >= 9) formatted += '-' + value.slice(8, 10);
                this.value = formatted;
            });
            input.addEventListener('keydown', function(e) {
                if (e.key === 'Backspace' && this.value.length <= 4) this.value = '';
            });
        },
        validateRequired (value) {
            return typeof value === 'string' && value.trim() !== '';
        },
        validateEmail (value) {
            return /^[^\s@]+@([^\s@.,]+\.)+[^\s@.,]{2,}$/.test(value.trim());
        },
        validatePhoneDigits (digits) {
            return digits.length >= 10;
        },
        initCaptcha (containerId) {
            const container = document.getElementById(containerId);
            if (!container) return;
            if (window.smartCaptcha) {
                try {
                    window.smartCaptcha.reset();
                } catch (e) {
                // ignore
                }
                return;
            }
            if (!captchaScriptLoading && !document.querySelector(`script[src*="smartcaptcha.yandexcloud.net"]`)) {
                window.onloadSmartCaptcha = ()=>{
                    if (window.smartCaptcha) window.smartCaptcha.render(containerId, {
                        sitekey: container.getAttribute('data-sitekey'),
                        style: 'adaptive'
                    });
                };
                const script = document.createElement('script');
                script.src = CAPTCHA_SCRIPT_SRC + '?onload=onloadSmartCaptcha';
                script.async = true;
                script.defer = true;
                document.head.appendChild(script);
                captchaScriptLoading = true;
            }
        },
        resetCaptcha () {
            if (window.smartCaptcha) try {
                window.smartCaptcha.reset();
            } catch (e) {
            // ignore
            }
        },
        showCommonError (block, text) {
            if (!block) return;
            block.innerHTML = text;
            block.style.display = 'flex';
        },
        hideCommonError (block) {
            if (!block) return;
            block.style.display = 'none';
            block.innerHTML = '';
        },
        clearFieldErrors (containerSelector = '') {
            const groups = document.querySelectorAll((containerSelector ? containerSelector + ' ' : '') + '.form-content__group.error, .form-content__file-wrapper.error');
            groups.forEach((group)=>{
                group.classList.remove('error');
                const errSpan = group.querySelector('.form-content__error');
                if (errSpan) errSpan.innerText = '';
            });
        },
        showFieldError (field, message) {
            if (!field) return;
            const group = field.closest('.form-content__group') || field.closest('.form-content__file-wrapper');
            if (group) {
                group.classList.add('error');
                const errSpan = group.querySelector('.form-content__error');
                if (errSpan) errSpan.innerText = message;
            }
        },
        clearFieldError (field) {
            if (!field) return;
            const group = field.closest('.form-content__group') || field.closest('.form-content__file-wrapper');
            if (group) {
                group.classList.remove('error');
                const errSpan = group.querySelector('.form-content__error');
                if (errSpan) errSpan.innerText = '';
            }
        },
        scrollToFirstError (containerSelector, commonErrorsBlock) {
            const firstError = document.querySelector((containerSelector ? containerSelector + ' ' : '') + '.form-content__group.error, .form-content__file-wrapper.error');
            if (firstError) firstError.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
            else if (commonErrorsBlock && commonErrorsBlock.style.display === 'flex') commonErrorsBlock.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        },
        setupFileButton (button, input, textElement) {
            if (!button || !input || !textElement) return;
            button.addEventListener('click', ()=>input.click());
            input.addEventListener('change', function() {
                textElement.textContent = this.files.length > 0 ? this.files[0].name : "\u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u043E";
            });
        },
        async sendFormData ({ url: url, payload: payload = {}, files: files = [], headers: headers = {}, submitBtn: submitBtn, commonErrorsBlock: commonErrorsBlock, containerSelector: containerSelector, onSuccess: onSuccess, onFieldError: onFieldError }) {
            let body;
            let isFormData = files.length > 0;
            if (isFormData) {
                const fd = new FormData();
                for(const key in payload)fd.append(key, payload[key]);
                files.forEach(({ fieldName: fieldName, fileInputElement: fileInputElement })=>{
                    if (fileInputElement && fileInputElement.files.length > 0) fd.append(fieldName, fileInputElement.files[0]);
                });
                body = fd;
            } else {
                body = JSON.stringify(payload);
                headers['Content-Type'] = 'application/json';
            }
            headers['X-Requested-With'] = 'XMLHttpRequest';
            headers['Session-Id'] = BX.bitrix_sessid();
            if (submitBtn) submitBtn.disabled = true;
            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: headers,
                    body: body
                });
                const result = await response.json();
                if (result.success) {
                    if (onSuccess) onSuccess(result);
                } else {
                    FormUtils.hideCommonError(commonErrorsBlock);
                    FormUtils.clearFieldErrors(containerSelector);
                    let handled = false;
                    if (result.errors && Array.isArray(result.errors) && result.errors.length > 0) {
                        result.errors.forEach((err)=>{
                            if (onFieldError) onFieldError(err.field, err.message);
                        });
                        handled = true;
                    }
                    if (!handled && result.message) FormUtils.showCommonError(commonErrorsBlock, result.message);
                    else if (!handled) FormUtils.showCommonError(commonErrorsBlock, "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0437\u0436\u0435.");
                    FormUtils.scrollToFirstError(containerSelector, commonErrorsBlock);
                    const shouldResetCaptcha = result?.errors?.some((e)=>e.field === 'smart_token' || e.field === 'captcha');
                    if (shouldResetCaptcha) FormUtils.resetCaptcha();
                }
            } catch (error) {
                console.error(error);
                FormUtils.showCommonError(commonErrorsBlock, "\u041E\u0448\u0438\u0431\u043A\u0430 \u0441\u0435\u0442\u0438. \u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u0438 \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0441\u043D\u043E\u0432\u0430.");
            } finally{
                if (submitBtn) submitBtn.disabled = false;
            }
        },
        createModal ({ modalId: modalId, closeBtnId: closeBtnId, openBtnClass: openBtnClass, openBtnSelector: openBtnSelector, onOpen: onOpen, onClose: onClose }) {
            const modal = document.getElementById(modalId);
            if (!modal) return;
            const closeBtn = document.getElementById(closeBtnId);
            if (closeBtn) closeBtn.addEventListener('click', onClose);
            if (openBtnClass) document.querySelectorAll(openBtnClass).forEach((btn)=>{
                if (btn) btn.addEventListener('click', (e)=>{
                    e.preventDefault();
                    onOpen();
                });
            });
            else if (openBtnSelector) document.querySelectorAll(openBtnSelector).forEach((btn)=>{
                btn.addEventListener('click', (e)=>{
                    e.preventDefault();
                    onOpen(btn);
                });
            });
            modal.style.display = 'none';
        }
    };
    window.FormUtils = FormUtils;
})();


/* global BX, bitrix_sessid, FormUtils */ (function() {
    if (typeof BX === 'undefined' || typeof FormUtils === 'undefined') return;
    const modalId = 'question-modal-overlay';
    const closeBtnId = 'question-form-header-btn';
    const submitBtn = document.getElementById('submit-feedback-btn');
    const commonErrorsBlock = document.getElementById('question-form-common-errors');
    const captchaContainerId = 'captcha-container-question';
    const containerSelector = '';
    const fullname = document.getElementById('fullname-question');
    const phone = document.getElementById('phone-question');
    const email = document.getElementById('email-question');
    const message = document.getElementById('message-question');
    if (!document.getElementById(modalId) || !submitBtn) return;
    FormUtils.setupPhoneMask(phone);
    const initCaptcha = ()=>FormUtils.initCaptcha(captchaContainerId);
    const resetCaptcha = ()=>FormUtils.resetCaptcha();
    const clearFields = ()=>{
        fullname.value = '';
        phone.value = '';
        email.value = '';
        message.value = '';
    };
    const hideErrors = ()=>{
        FormUtils.clearFieldErrors(containerSelector);
        FormUtils.hideCommonError(commonErrorsBlock);
    };
    const validate = ()=>{
        let isValid = true;
        hideErrors();
        if (!FormUtils.validateRequired(fullname.value)) {
            FormUtils.showFieldError(fullname, "*\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
            isValid = false;
        }
        const phoneDigits = phone.value.replace(/\D/g, '');
        if (!FormUtils.validateRequired(phone.value)) {
            FormUtils.showFieldError(phone, "*\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
            isValid = false;
        } else if (!FormUtils.validatePhoneDigits(phoneDigits)) {
            FormUtils.showFieldError(phone, "*\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 (\u043D\u0435 \u043C\u0435\u043D\u0435\u0435 10 \u0446\u0438\u0444\u0440)");
            isValid = false;
        }
        if (!FormUtils.validateRequired(email.value)) {
            FormUtils.showFieldError(email, "*\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
            isValid = false;
        } else if (!FormUtils.validateEmail(email.value)) {
            FormUtils.showFieldError(email, "*\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 E-mail");
            isValid = false;
        }
        const captchaToken = document.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        if (!captchaToken || !captchaToken.value) {
            FormUtils.showCommonError(commonErrorsBlock, "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435, \u0447\u0442\u043E \u0432\u044B \u043D\u0435 \u0440\u043E\u0431\u043E\u0442");
            isValid = false;
        }
        if (!isValid) FormUtils.scrollToFirstError(containerSelector, commonErrorsBlock);
        return isValid;
    };
    const send = async ()=>{
        if (!validate()) return;
        const captchaToken = document.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        const token = typeof bitrix_sessid === 'function' ? bitrix_sessid() : BX.bitrix_sessid ? BX.bitrix_sessid() : '';
        const payload = {
            fullname: fullname.value,
            phone: phone.value,
            email: email.value,
            message: message.value,
            smart_token: captchaToken ? captchaToken.value : ''
        };
        if (submitBtn) submitBtn.disabled = true;
        try {
            await FormUtils.sendFormData({
                url: '/api/v1/form/ask-question',
                payload: payload,
                headers: {
                    'Session-Id': token,
                    'X-Requested-With': 'XMLHttpRequest'
                },
                submitBtn: submitBtn,
                commonErrorsBlock: commonErrorsBlock,
                containerSelector: containerSelector,
                onSuccess: (result)=>{
                    alert(result.message || "\u0421\u043F\u0430\u0441\u0438\u0431\u043E! \u0412\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E.");
                    close();
                },
                onFieldError: (field, msg)=>{
                    const el = document.getElementById(field);
                    if (el) FormUtils.showFieldError(el, msg);
                }
            });
        } finally{
            if (submitBtn) submitBtn.disabled = false;
        }
    };
    const open = ()=>{
        document.getElementById(modalId).style.display = 'flex';
        document.body.style.overflow = 'hidden';
        hideErrors();
        initCaptcha();
        resetCaptcha();
    };
    const close = ()=>{
        document.getElementById(modalId).style.display = 'none';
        document.body.style.overflow = '';
        clearFields();
        hideErrors();
        resetCaptcha();
    };
    FormUtils.createModal({
        modalId: modalId,
        closeBtnId: closeBtnId,
        openBtnClass: '.open-ask-btn',
        onOpen: open,
        onClose: close
    });
    submitBtn.addEventListener('click', send);
})();


/* global BX, bitrix_sessid, FormUtils */ (function() {
    'use strict';
    if (typeof BX === 'undefined' || typeof FormUtils === 'undefined') return;
    const modalId = 'vacancy-modal-overlay';
    const closeBtnId = 'vacancy-modal-close-btn';
    const submitBtn = document.getElementById('vacancy-submit-btn');
    const commonErrorsBlock = document.getElementById('vacancy-form-common-errors');
    const captchaContainerId = 'vacancy-captcha-container';
    const containerSelector = '#vacancy-modal-content';
    const fullname = document.getElementById('vacancy-fullname');
    const position = document.getElementById('vacancy-desired-position');
    const phone = document.getElementById('vacancy-phone');
    const email = document.getElementById('vacancy-email');
    const message = document.getElementById('vacancy-message');
    const fileInput = document.getElementById('vacancy-file');
    const fileBtn = document.getElementById('vacancy-file-btn');
    const fileText = document.getElementById('vacancy-file-text');
    if (!document.getElementById(modalId) || !submitBtn) return;
    FormUtils.setupPhoneMask(phone);
    FormUtils.setupFileButton(fileBtn, fileInput, fileText);
    const initCaptcha = ()=>FormUtils.initCaptcha(captchaContainerId);
    const resetCaptcha = ()=>FormUtils.resetCaptcha();
    const clearFields = ()=>{
        fullname.value = '';
        position.value = '';
        phone.value = '';
        email.value = '';
        message.value = '';
        if (fileInput) fileInput.value = '';
        if (fileText) fileText.textContent = "\u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u043E";
    };
    const hideErrors = ()=>{
        FormUtils.clearFieldErrors(containerSelector);
        FormUtils.hideCommonError(commonErrorsBlock);
    };
    const validate = ()=>{
        let isValid = true;
        hideErrors();
        if (!FormUtils.validateRequired(fullname.value)) {
            FormUtils.showFieldError(fullname, "*\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
            isValid = false;
        }
        if (!FormUtils.validateRequired(position.value)) {
            FormUtils.showFieldError(position, "*\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
            isValid = false;
        }
        const phoneDigits = phone.value.replace(/\D/g, '');
        if (!FormUtils.validateRequired(phone.value)) {
            FormUtils.showFieldError(phone, "*\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
            isValid = false;
        } else if (!FormUtils.validatePhoneDigits(phoneDigits)) {
            FormUtils.showFieldError(phone, "*\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 (\u043D\u0435 \u043C\u0435\u043D\u0435\u0435 10 \u0446\u0438\u0444\u0440)");
            isValid = false;
        }
        if (!FormUtils.validateRequired(email.value)) {
            FormUtils.showFieldError(email, "*\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
            isValid = false;
        } else if (!FormUtils.validateEmail(email.value)) {
            FormUtils.showFieldError(email, "*\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 E-mail");
            isValid = false;
        }
        if (!FormUtils.validateRequired(message.value)) {
            FormUtils.showFieldError(message, "*\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
            isValid = false;
        }
        if (!fileInput || fileInput.files.length === 0) {
            FormUtils.showFieldError(fileInput, "*\u041F\u0440\u0438\u043A\u0440\u0435\u043F\u0438\u0442\u0435 \u0444\u0430\u0439\u043B \u0440\u0435\u0437\u044E\u043C\u0435");
            isValid = false;
        } else {
            const file = fileInput.files[0];
            const allowedExtensions = [
                'pdf',
                'doc',
                'docx',
                'txt',
                'rtf'
            ];
            const ext = file.name.split('.').pop().toLowerCase();
            if (!allowedExtensions.includes(ext)) {
                FormUtils.showFieldError(fileInput, "*\u0414\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435 \u0444\u043E\u0440\u043C\u0430\u0442\u044B: pdf, doc, docx, txt, rtf");
                isValid = false;
            } else if (file.size > 10485760) {
                FormUtils.showFieldError(fileInput, "*\u0420\u0430\u0437\u043C\u0435\u0440 \u0444\u0430\u0439\u043B\u0430 \u043D\u0435 \u0434\u043E\u043B\u0436\u0435\u043D \u043F\u0440\u0435\u0432\u044B\u0448\u0430\u0442\u044C 10 \u041C\u0411");
                isValid = false;
            }
        }
        const captchaToken = document.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        if (!captchaToken || !captchaToken.value) {
            FormUtils.showCommonError(commonErrorsBlock, "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435, \u0447\u0442\u043E \u0432\u044B \u043D\u0435 \u0440\u043E\u0431\u043E\u0442");
            isValid = false;
        }
        if (!isValid) FormUtils.scrollToFirstError(containerSelector, commonErrorsBlock);
        return isValid;
    };
    const send = async ()=>{
        if (!validate()) return;
        const captchaToken = document.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        const token = typeof bitrix_sessid === 'function' ? bitrix_sessid() : BX.bitrix_sessid ? BX.bitrix_sessid() : '';
        const payload = {
            fullname: fullname.value,
            desired_position: position.value,
            phone: phone.value,
            email: email.value,
            message: message.value,
            smart_token: captchaToken ? captchaToken.value : ''
        };
        if (submitBtn) submitBtn.disabled = true;
        try {
            await FormUtils.sendFormData({
                url: '/api/v1/form/send-resume',
                payload: payload,
                files: [
                    {
                        fieldName: 'resume_file',
                        fileInputElement: fileInput
                    }
                ],
                headers: {
                    'Session-Id': token,
                    'X-Requested-With': 'XMLHttpRequest'
                },
                submitBtn: submitBtn,
                commonErrorsBlock: commonErrorsBlock,
                containerSelector: containerSelector,
                onSuccess: (result)=>{
                    alert(result.message || "\u0420\u0435\u0437\u044E\u043C\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E!");
                    close();
                },
                onFieldError: (field, msg)=>{
                    const el = document.getElementById('vacancy-' + field);
                    if (el) FormUtils.showFieldError(el, msg);
                    else if (field === 'resume_file' || field === 'file') FormUtils.showFieldError(fileInput, msg);
                }
            });
        } finally{
            if (submitBtn) submitBtn.disabled = false;
        }
    };
    const open = (vacancyTitle = '')=>{
        document.getElementById(modalId).style.display = 'flex';
        document.body.style.overflow = 'hidden';
        if (position) position.value = vacancyTitle;
        hideErrors();
        initCaptcha();
        resetCaptcha();
    };
    const close = ()=>{
        document.getElementById(modalId).style.display = 'none';
        document.body.style.overflow = '';
        clearFields();
        hideErrors();
        resetCaptcha();
    };
    FormUtils.createModal({
        modalId: modalId,
        closeBtnId: closeBtnId,
        openBtnSelector: '.vacancy-panel__btn',
        onOpen: (btn)=>{
            const panel = btn.closest('.accordion-panel');
            const titleElement = panel ? panel.querySelector('.accordion-panel__title') : null;
            const title = titleElement ? titleElement.textContent.trim() : '';
            open(title);
        },
        onClose: close
    });
    submitBtn.addEventListener('click', send);
})();


/* global BX, bitrix_sessid, FormUtils */ (function() {
    'use strict';
    if (typeof BX === 'undefined' || typeof FormUtils === 'undefined') return;
    const modalId = 'review-modal-overlay';
    const closeBtnId = 'review-modal-close-btn';
    const submitBtn = document.getElementById('review-submit-btn');
    const commonErrorsBlock = document.getElementById('review-form-common-errors');
    const captchaContainerId = 'review-captcha-container';
    const containerSelector = '#review-modal-content';
    const nameInput = document.getElementById('review-name');
    const emailInput = document.getElementById('review-email');
    const textInput = document.getElementById('review-text');
    const avatarInput = document.getElementById('review-avatar');
    const fileInput = document.getElementById('review-file');
    const avatarBtn = document.getElementById('review-avatar-btn');
    const fileBtn = document.getElementById('review-file-btn');
    const avatarText = document.getElementById('review-avatar-text');
    const fileText = document.getElementById('review-file-text');
    const ratingStars = document.querySelectorAll('#review-rating-stars .review-rating__star');
    const ratingLabel = document.getElementById('review-rating-label');
    const ratingError = document.getElementById('review-rating-error');
    const ratingLabels = [
        "\u043E\u0447\u0435\u043D\u044C \u043F\u043B\u043E\u0445\u043E",
        "\u043F\u043B\u043E\u0445\u043E",
        "\u043D\u043E\u0440\u043C\u0430\u043B\u044C\u043D\u043E",
        "\u0445\u043E\u0440\u043E\u0448\u043E",
        "\u043E\u0442\u043B\u0438\u0447\u043D\u043E"
    ];
    let selectedRating = 0;
    if (!document.getElementById(modalId) || !submitBtn) return;
    FormUtils.setupFileButton(avatarBtn, avatarInput, avatarText);
    FormUtils.setupFileButton(fileBtn, fileInput, fileText);
    const initCaptcha = ()=>FormUtils.initCaptcha(captchaContainerId);
    const resetCaptcha = ()=>FormUtils.resetCaptcha();
    const updateStarsDisplay = (hoverValue = 0)=>{
        ratingStars.forEach((star, index)=>{
            const value = index + 1;
            star.classList.remove('active');
            if (hoverValue) {
                if (value <= hoverValue) star.classList.add('active');
            } else if (selectedRating && value <= selectedRating) star.classList.add('active');
        });
        if (hoverValue) ratingLabel.textContent = ratingLabels[hoverValue - 1] || "\u0431\u0435\u0437 \u043E\u0446\u0435\u043D\u043A\u0438";
        else if (selectedRating) ratingLabel.textContent = ratingLabels[selectedRating - 1];
        else ratingLabel.textContent = "\u0431\u0435\u0437 \u043E\u0446\u0435\u043D\u043A\u0438";
    };
    ratingStars.forEach((star)=>{
        star.addEventListener('mouseenter', function() {
            updateStarsDisplay(parseInt(this.getAttribute('data-value'), 10));
        });
        star.addEventListener('mouseleave', ()=>updateStarsDisplay(0));
        star.addEventListener('click', function() {
            selectedRating = parseInt(this.getAttribute('data-value'), 10);
            updateStarsDisplay(0);
            if (ratingError) {
                ratingError.textContent = '';
                ratingError.parentElement.classList.remove('error');
            }
        });
    });
    const clearFields = ()=>{
        nameInput.value = '';
        emailInput.value = '';
        textInput.value = '';
        selectedRating = 0;
        updateStarsDisplay(0);
        if (avatarInput) {
            avatarInput.value = '';
            if (avatarText) avatarText.textContent = "\u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u043E";
        }
        if (fileInput) {
            fileInput.value = '';
            if (fileText) fileText.textContent = "\u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u043E";
        }
    };
    const hideErrors = ()=>{
        FormUtils.clearFieldErrors(containerSelector);
        FormUtils.hideCommonError(commonErrorsBlock);
        if (ratingError) {
            ratingError.textContent = '';
            ratingError.parentElement.classList.remove('error');
        }
    };
    const validate = ()=>{
        let isValid = true;
        hideErrors();
        if (!FormUtils.validateRequired(nameInput.value)) {
            FormUtils.showFieldError(nameInput, "*\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
            isValid = false;
        }
        if (selectedRating === 0) {
            if (ratingError) {
                ratingError.textContent = "*\u041F\u043E\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u043E\u0446\u0435\u043D\u043A\u0443";
                ratingError.parentElement.classList.add('error');
            }
            isValid = false;
        }
        if (!FormUtils.validateRequired(textInput.value)) {
            FormUtils.showFieldError(textInput, "*\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
            isValid = false;
        }
        if (!FormUtils.validateRequired(emailInput.value)) {
            FormUtils.showFieldError(emailInput, "*\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
            isValid = false;
        } else if (!FormUtils.validateEmail(emailInput.value)) {
            FormUtils.showFieldError(emailInput, "*\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 E-mail");
            isValid = false;
        }
        const fileInputs = [
            {
                input: avatarInput,
                allowed: [
                    'jpg',
                    'jpeg',
                    'png',
                    'gif'
                ],
                maxSize: 5242880,
                name: "\u0430\u0432\u0430\u0442\u0430\u0440"
            },
            {
                input: fileInput,
                allowed: [
                    'pdf',
                    'doc',
                    'docx',
                    'txt',
                    'rtf',
                    'jpg',
                    'jpeg',
                    'png'
                ],
                maxSize: 10485760,
                name: "\u0444\u0430\u0439\u043B"
            }
        ];
        fileInputs.forEach(({ input: input, allowed: allowed, maxSize: maxSize, name: name })=>{
            if (input && input.files.length > 0) {
                const file = input.files[0];
                const ext = file.name.split('.').pop().toLowerCase();
                if (!allowed.includes(ext)) {
                    FormUtils.showFieldError(input, `*\u{41D}\u{435}\u{434}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{43C}\u{44B}\u{439} \u{444}\u{43E}\u{440}\u{43C}\u{430}\u{442} \u{434}\u{43B}\u{44F} ${name}: ${allowed.join(', ')}`);
                    isValid = false;
                } else if (file.size > maxSize) {
                    const sizeMB = Math.round(maxSize / 1048576);
                    FormUtils.showFieldError(input, `*\u{420}\u{430}\u{437}\u{43C}\u{435}\u{440} ${name} \u{43D}\u{435} \u{434}\u{43E}\u{43B}\u{436}\u{435}\u{43D} \u{43F}\u{440}\u{435}\u{432}\u{44B}\u{448}\u{430}\u{442}\u{44C} ${sizeMB} \u{41C}\u{411}`);
                    isValid = false;
                }
            }
        });
        const captchaToken = document.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        if (!captchaToken || !captchaToken.value) {
            FormUtils.showCommonError(commonErrorsBlock, "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435, \u0447\u0442\u043E \u0432\u044B \u043D\u0435 \u0440\u043E\u0431\u043E\u0442");
            isValid = false;
        }
        if (!isValid) {
            const firstError = document.querySelector(containerSelector + ' .form-content__group.error, ' + containerSelector + ' .form-content__file-wrapper.error, ' + containerSelector + ' .review-rating.error');
            if (firstError) firstError.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
            else if (commonErrorsBlock && commonErrorsBlock.style.display === 'flex') commonErrorsBlock.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
        return isValid;
    };
    const send = async ()=>{
        if (!validate()) return;
        const captchaToken = document.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        const token = typeof bitrix_sessid === 'function' ? bitrix_sessid() : BX.bitrix_sessid ? BX.bitrix_sessid() : '';
        const payload = {
            name: nameInput.value,
            email: emailInput.value,
            rating: selectedRating,
            text: textInput.value,
            smart_token: captchaToken ? captchaToken.value : ''
        };
        if (submitBtn) submitBtn.disabled = true;
        try {
            await FormUtils.sendFormData({
                url: '/api/v1/form/review',
                payload: payload,
                files: [
                    {
                        fieldName: 'avatar',
                        fileInputElement: avatarInput
                    },
                    {
                        fieldName: 'attachment',
                        fileInputElement: fileInput
                    }
                ],
                headers: {
                    'Session-Id': token,
                    'X-Requested-With': 'XMLHttpRequest'
                },
                submitBtn: submitBtn,
                commonErrorsBlock: commonErrorsBlock,
                containerSelector: containerSelector,
                onSuccess: (result)=>{
                    alert(result.message || "\u0421\u043F\u0430\u0441\u0438\u0431\u043E! \u0412\u0430\u0448 \u043E\u0442\u0437\u044B\u0432 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D.");
                    close();
                },
                onFieldError: (field, msg)=>{
                    if (field === 'rating') {
                        if (ratingError) {
                            ratingError.textContent = msg;
                            ratingError.parentElement.classList.add('error');
                        }
                    } else {
                        const el = document.getElementById('review-' + field);
                        if (el) FormUtils.showFieldError(el, msg);
                    }
                }
            });
        } finally{
            if (submitBtn) submitBtn.disabled = false;
        }
    };
    const open = ()=>{
        document.getElementById(modalId).style.display = 'flex';
        document.body.style.overflow = 'hidden';
        hideErrors();
        initCaptcha();
        resetCaptcha();
        updateStarsDisplay(0);
    };
    const close = ()=>{
        document.getElementById(modalId).style.display = 'none';
        document.body.style.overflow = '';
        clearFields();
        hideErrors();
        resetCaptcha();
    };
    FormUtils.createModal({
        modalId: modalId,
        closeBtnId: closeBtnId,
        openBtnClass: '.open-review-btn',
        onOpen: open,
        onClose: close
    });
    submitBtn.addEventListener('click', send);
})();


function $10a6cb7b296c0bec$var$setAccordionPanelOpen(btn, panel, isOpen) {
    btn.classList.toggle('is-open', isOpen);
    panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : '0';
}
function $10a6cb7b296c0bec$var$refreshAccordionPanel(panel) {
    const btn = panel.closest('[data-accordion-item]')?.querySelector('[data-accordion-trigger]');
    if (btn?.classList.contains('is-open')) panel.style.maxHeight = panel.scrollHeight + 'px';
}
document.querySelectorAll('.accordion-panel').forEach((panel)=>{
    let btn = panel.querySelector('.accordion-panel__header');
    if (btn) btn.addEventListener('click', ()=>{
        panel.classList.toggle('is-open');
    });
});
document.querySelectorAll('[data-accordion]').forEach((acc)=>{
    const multiple = acc.dataset.accordion === 'multiple';
    acc.querySelectorAll('[data-accordion-item]').forEach((item)=>{
        const btn = item.querySelector('[data-accordion-trigger]');
        const panel = item.querySelector('[data-accordion-panel]');
        if (item.hasAttribute('data-accordion-default-open')) $10a6cb7b296c0bec$var$setAccordionPanelOpen(btn, panel, true);
        btn.addEventListener('click', ()=>{
            const isOpen = btn.classList.contains('is-open');
            if (!multiple) acc.querySelectorAll('[data-accordion-trigger].is-open').forEach((b)=>{
                if (b === btn) return;
                b.classList.remove('is-open');
                b.closest('[data-accordion-item]').querySelector('[data-accordion-panel]').style.maxHeight = '0';
            });
            $10a6cb7b296c0bec$var$setAccordionPanelOpen(btn, panel, !isOpen);
        });
    });
});
window.refreshAccordionPanel = $10a6cb7b296c0bec$var$refreshAccordionPanel;


document.querySelectorAll('.review-card').forEach((card)=>{
    const content = card.querySelector('.review-card__content');
    const footer = card.querySelector('.review-card__footer');
    if (content.scrollHeight > content.clientHeight) footer.hidden = false;
});
document.addEventListener('click', (event)=>{
    const button = event.target.closest('.review-card__more');
    if (!button) return;
    const card = button.closest('.review-card');
    const content = card.querySelector('.review-card__content');
    const footer = card.querySelector('.review-card__footer');
    content.classList.add('is-expanded');
    if (footer) footer.remove();
});


const $d4d06657c043713f$var$t = (t, e = 1e4)=>(t = parseFloat(t + "") || 0, Math.round((t + Number.EPSILON) * e) / e), $d4d06657c043713f$var$e = function(t) {
    if (!(t && t instanceof Element && t.offsetParent)) return !1;
    const e = t.scrollHeight > t.clientHeight, i = window.getComputedStyle(t).overflowY, n = -1 !== i.indexOf("hidden"), s = -1 !== i.indexOf("visible");
    return e && !n && !s;
}, $d4d06657c043713f$var$i = function(t, n) {
    return !(!t || t === document.body || n && t === n) && ($d4d06657c043713f$var$e(t) ? t : $d4d06657c043713f$var$i(t.parentElement, n));
}, $d4d06657c043713f$var$n = function(t) {
    var e = (new DOMParser).parseFromString(t, "text/html").body;
    if (e.childElementCount > 1) {
        for(var i = document.createElement("div"); e.firstChild;)i.appendChild(e.firstChild);
        return i;
    }
    return e.firstChild;
}, $d4d06657c043713f$var$s = (t)=>`${t || ""}`.split(" ").filter((t)=>!!t), $d4d06657c043713f$var$o = (t, e, i)=>{
    t && $d4d06657c043713f$var$s(e).forEach((e)=>{
        t.classList.toggle(e, i || !1);
    });
};
class $d4d06657c043713f$var$a {
    constructor(t){
        Object.defineProperty(this, "pageX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "pageY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "clientX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "clientY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "id", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "time", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "nativePointer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this.nativePointer = t, this.pageX = t.pageX, this.pageY = t.pageY, this.clientX = t.clientX, this.clientY = t.clientY, this.id = self.Touch && t instanceof Touch ? t.identifier : -1, this.time = Date.now();
    }
}
const $d4d06657c043713f$var$r = {
    passive: !1
};
class $d4d06657c043713f$var$l {
    constructor(t, { start: e = ()=>!0, move: i = ()=>{}, end: n = ()=>{} }){
        Object.defineProperty(this, "element", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "startCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "moveCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "endCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "currentPointers", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "startPointers", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), this.element = t, this.startCallback = e, this.moveCallback = i, this.endCallback = n;
        for (const t of [
            "onPointerStart",
            "onTouchStart",
            "onMove",
            "onTouchEnd",
            "onPointerEnd",
            "onWindowBlur"
        ])this[t] = this[t].bind(this);
        this.element.addEventListener("mousedown", this.onPointerStart, $d4d06657c043713f$var$r), this.element.addEventListener("touchstart", this.onTouchStart, $d4d06657c043713f$var$r), this.element.addEventListener("touchmove", this.onMove, $d4d06657c043713f$var$r), this.element.addEventListener("touchend", this.onTouchEnd), this.element.addEventListener("touchcancel", this.onTouchEnd);
    }
    onPointerStart(t) {
        if (!t.buttons || 0 !== t.button) return;
        const e = new $d4d06657c043713f$var$a(t);
        this.currentPointers.some((t)=>t.id === e.id) || this.triggerPointerStart(e, t) && (window.addEventListener("mousemove", this.onMove), window.addEventListener("mouseup", this.onPointerEnd), window.addEventListener("blur", this.onWindowBlur));
    }
    onTouchStart(t) {
        for (const e of Array.from(t.changedTouches || []))this.triggerPointerStart(new $d4d06657c043713f$var$a(e), t);
        window.addEventListener("blur", this.onWindowBlur);
    }
    onMove(t) {
        const e = this.currentPointers.slice(), i = "changedTouches" in t ? Array.from(t.changedTouches || []).map((t)=>new $d4d06657c043713f$var$a(t)) : [
            new $d4d06657c043713f$var$a(t)
        ], n = [];
        for (const t of i){
            const e = this.currentPointers.findIndex((e)=>e.id === t.id);
            e < 0 || (n.push(t), this.currentPointers[e] = t);
        }
        n.length && this.moveCallback(t, this.currentPointers.slice(), e);
    }
    onPointerEnd(t) {
        t.buttons > 0 && 0 !== t.button || (this.triggerPointerEnd(t, new $d4d06657c043713f$var$a(t)), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseup", this.onPointerEnd), window.removeEventListener("blur", this.onWindowBlur));
    }
    onTouchEnd(t) {
        for (const e of Array.from(t.changedTouches || []))this.triggerPointerEnd(t, new $d4d06657c043713f$var$a(e));
    }
    triggerPointerStart(t, e) {
        return !!this.startCallback(e, t, this.currentPointers.slice()) && (this.currentPointers.push(t), this.startPointers.push(t), !0);
    }
    triggerPointerEnd(t, e) {
        const i = this.currentPointers.findIndex((t)=>t.id === e.id);
        i < 0 || (this.currentPointers.splice(i, 1), this.startPointers.splice(i, 1), this.endCallback(t, e, this.currentPointers.slice()));
    }
    onWindowBlur() {
        this.clear();
    }
    clear() {
        for(; this.currentPointers.length;){
            const t = this.currentPointers[this.currentPointers.length - 1];
            this.currentPointers.splice(this.currentPointers.length - 1, 1), this.startPointers.splice(this.currentPointers.length - 1, 1), this.endCallback(new Event("touchend", {
                bubbles: !0,
                cancelable: !0,
                clientX: t.clientX,
                clientY: t.clientY
            }), t, this.currentPointers.slice());
        }
    }
    stop() {
        this.element.removeEventListener("mousedown", this.onPointerStart, $d4d06657c043713f$var$r), this.element.removeEventListener("touchstart", this.onTouchStart, $d4d06657c043713f$var$r), this.element.removeEventListener("touchmove", this.onMove, $d4d06657c043713f$var$r), this.element.removeEventListener("touchend", this.onTouchEnd), this.element.removeEventListener("touchcancel", this.onTouchEnd), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseup", this.onPointerEnd), window.removeEventListener("blur", this.onWindowBlur);
    }
}
function $d4d06657c043713f$var$c(t, e) {
    return e ? Math.sqrt(Math.pow(e.clientX - t.clientX, 2) + Math.pow(e.clientY - t.clientY, 2)) : 0;
}
function $d4d06657c043713f$var$h(t, e) {
    return e ? {
        clientX: (t.clientX + e.clientX) / 2,
        clientY: (t.clientY + e.clientY) / 2
    } : t;
}
const $d4d06657c043713f$var$d = (t)=>"object" == typeof t && null !== t && t.constructor === Object && "[object Object]" === Object.prototype.toString.call(t), $d4d06657c043713f$var$u = (t, ...e)=>{
    const i = e.length;
    for(let n = 0; n < i; n++){
        const i = e[n] || {};
        Object.entries(i).forEach(([e, i])=>{
            const n = Array.isArray(i) ? [] : {};
            t[e] || Object.assign(t, {
                [e]: n
            }), $d4d06657c043713f$var$d(i) ? Object.assign(t[e], $d4d06657c043713f$var$u(n, i)) : Array.isArray(i) ? Object.assign(t, {
                [e]: [
                    ...i
                ]
            }) : Object.assign(t, {
                [e]: i
            });
        });
    }
    return t;
}, $d4d06657c043713f$var$p = function(t, e) {
    return t.split(".").reduce((t, e)=>"object" == typeof t ? t[e] : void 0, e);
};
class $d4d06657c043713f$var$f {
    constructor(t = {}){
        Object.defineProperty(this, "options", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t
        }), Object.defineProperty(this, "events", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: new Map
        }), this.setOptions(t);
        for (const t of Object.getOwnPropertyNames(Object.getPrototypeOf(this)))t.startsWith("on") && "function" == typeof this[t] && (this[t] = this[t].bind(this));
    }
    setOptions(t) {
        this.options = t ? $d4d06657c043713f$var$u({}, this.constructor.defaults, t) : {};
        for (const [t, e] of Object.entries(this.option("on") || {}))this.on(t, e);
    }
    option(t, ...e) {
        let i = $d4d06657c043713f$var$p(t, this.options);
        return i && "function" == typeof i && (i = i.call(this, this, ...e)), i;
    }
    optionFor(t, e, i, ...n) {
        let s = $d4d06657c043713f$var$p(e, t);
        var o;
        "string" != typeof (o = s) || isNaN(o) || isNaN(parseFloat(o)) || (s = parseFloat(s)), "true" === s && (s = !0), "false" === s && (s = !1), s && "function" == typeof s && (s = s.call(this, this, t, ...n));
        let a = $d4d06657c043713f$var$p(e, this.options);
        return a && "function" == typeof a ? s = a.call(this, this, t, ...n, s) : void 0 === s && (s = a), void 0 === s ? i : s;
    }
    cn(t) {
        const e = this.options.classes;
        return e && e[t] || "";
    }
    localize(t, e = []) {
        t = String(t).replace(/\{\{(\w+).?(\w+)?\}\}/g, (t, e, i)=>{
            let n = "";
            return i ? n = this.option(`${e[0] + e.toLowerCase().substring(1)}.l10n.${i}`) : e && (n = this.option(`l10n.${e}`)), n || (n = t), n;
        });
        for(let i = 0; i < e.length; i++)t = t.split(e[i][0]).join(e[i][1]);
        return t = t.replace(/\{\{(.*?)\}\}/g, (t, e)=>e);
    }
    on(t, e) {
        let i = [];
        "string" == typeof t ? i = t.split(" ") : Array.isArray(t) && (i = t), this.events || (this.events = new Map), i.forEach((t)=>{
            let i = this.events.get(t);
            i || (this.events.set(t, []), i = []), i.includes(e) || i.push(e), this.events.set(t, i);
        });
    }
    off(t, e) {
        let i = [];
        "string" == typeof t ? i = t.split(" ") : Array.isArray(t) && (i = t), i.forEach((t)=>{
            const i = this.events.get(t);
            if (Array.isArray(i)) {
                const t = i.indexOf(e);
                t > -1 && i.splice(t, 1);
            }
        });
    }
    emit(t, ...e) {
        [
            ...this.events.get(t) || []
        ].forEach((t)=>t(this, ...e)), "*" !== t && this.emit("*", t, ...e);
    }
}
Object.defineProperty($d4d06657c043713f$var$f, "version", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "5.0.36"
}), Object.defineProperty($d4d06657c043713f$var$f, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {}
});
class $d4d06657c043713f$var$g extends $d4d06657c043713f$var$f {
    constructor(t = {}){
        super(t), Object.defineProperty(this, "plugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        });
    }
    attachPlugins(t = {}) {
        const e = new Map;
        for (const [i, n] of Object.entries(t)){
            const t = this.option(i), s = this.plugins[i];
            s || !1 === t ? s && !1 === t && (s.detach(), delete this.plugins[i]) : e.set(i, new n(this, t || {}));
        }
        for (const [t, i] of e)this.plugins[t] = i, i.attach();
    }
    detachPlugins(t) {
        t = t || Object.keys(this.plugins);
        for (const e of t){
            const t = this.plugins[e];
            t && t.detach(), delete this.plugins[e];
        }
        return this.emit("detachPlugins"), this;
    }
}
var $d4d06657c043713f$var$m;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Error = 1] = "Error", t[t.Ready = 2] = "Ready", t[t.Panning = 3] = "Panning", t[t.Mousemove = 4] = "Mousemove", t[t.Destroy = 5] = "Destroy";
}($d4d06657c043713f$var$m || ($d4d06657c043713f$var$m = {}));
const $d4d06657c043713f$var$v = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f"
], $d4d06657c043713f$var$b = {
    PANUP: "Move up",
    PANDOWN: "Move down",
    PANLEFT: "Move left",
    PANRIGHT: "Move right",
    ZOOMIN: "Zoom in",
    ZOOMOUT: "Zoom out",
    TOGGLEZOOM: "Toggle zoom level",
    TOGGLE1TO1: "Toggle zoom level",
    ITERATEZOOM: "Toggle zoom level",
    ROTATECCW: "Rotate counterclockwise",
    ROTATECW: "Rotate clockwise",
    FLIPX: "Flip horizontally",
    FLIPY: "Flip vertically",
    FITX: "Fit horizontally",
    FITY: "Fit vertically",
    RESET: "Reset",
    TOGGLEFS: "Toggle fullscreen"
}, $d4d06657c043713f$var$y = {
    content: null,
    width: "auto",
    height: "auto",
    panMode: "drag",
    touch: !0,
    dragMinThreshold: 3,
    lockAxis: !1,
    mouseMoveFactor: 1,
    mouseMoveFriction: .12,
    zoom: !0,
    pinchToZoom: !0,
    panOnlyZoomed: "auto",
    minScale: 1,
    maxScale: 2,
    friction: .25,
    dragFriction: .35,
    decelFriction: .05,
    click: "toggleZoom",
    dblClick: !1,
    wheel: "zoom",
    wheelLimit: 7,
    spinner: !0,
    bounds: "auto",
    infinite: !1,
    rubberband: !0,
    bounce: !0,
    maxVelocity: 75,
    transformParent: !1,
    classes: {
        content: "f-panzoom__content",
        isLoading: "is-loading",
        canZoomIn: "can-zoom_in",
        canZoomOut: "can-zoom_out",
        isDraggable: "is-draggable",
        isDragging: "is-dragging",
        inFullscreen: "in-fullscreen",
        htmlHasFullscreen: "with-panzoom-in-fullscreen"
    },
    l10n: $d4d06657c043713f$var$b
}, $d4d06657c043713f$var$w = '<circle cx="25" cy="25" r="20"></circle>', $d4d06657c043713f$var$x = '<div class="f-spinner"><svg viewBox="0 0 50 50">' + $d4d06657c043713f$var$w + $d4d06657c043713f$var$w + "</svg></div>", $d4d06657c043713f$var$E = (t)=>t && null !== t && t instanceof Element && "nodeType" in t, $d4d06657c043713f$var$S = (t, e)=>{
    t && $d4d06657c043713f$var$s(e).forEach((e)=>{
        t.classList.remove(e);
    });
}, $d4d06657c043713f$var$P = (t, e)=>{
    t && $d4d06657c043713f$var$s(e).forEach((e)=>{
        t.classList.add(e);
    });
}, $d4d06657c043713f$var$C = {
    a: 1,
    b: 0,
    c: 0,
    d: 1,
    e: 0,
    f: 0
}, $d4d06657c043713f$var$T = 1e5, $d4d06657c043713f$var$M = 1e4, $d4d06657c043713f$var$O = "mousemove", $d4d06657c043713f$var$A = "drag", $d4d06657c043713f$var$L = "content", $d4d06657c043713f$var$z = "auto";
let $d4d06657c043713f$var$R = null, $d4d06657c043713f$var$k = null;
class $d4d06657c043713f$export$b704d075ddd20210 extends $d4d06657c043713f$var$g {
    get fits() {
        return this.contentRect.width - this.contentRect.fitWidth < 1 && this.contentRect.height - this.contentRect.fitHeight < 1;
    }
    get isTouchDevice() {
        return null === $d4d06657c043713f$var$k && ($d4d06657c043713f$var$k = window.matchMedia("(hover: none)").matches), $d4d06657c043713f$var$k;
    }
    get isMobile() {
        return null === $d4d06657c043713f$var$R && ($d4d06657c043713f$var$R = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)), $d4d06657c043713f$var$R;
    }
    get panMode() {
        return this.options.panMode !== $d4d06657c043713f$var$O || this.isTouchDevice ? $d4d06657c043713f$var$A : $d4d06657c043713f$var$O;
    }
    get panOnlyZoomed() {
        const t = this.options.panOnlyZoomed;
        return t === $d4d06657c043713f$var$z ? this.isTouchDevice : t;
    }
    get isInfinite() {
        return this.option("infinite");
    }
    get angle() {
        return 180 * Math.atan2(this.current.b, this.current.a) / Math.PI || 0;
    }
    get targetAngle() {
        return 180 * Math.atan2(this.target.b, this.target.a) / Math.PI || 0;
    }
    get scale() {
        const { a: t, b: e } = this.current;
        return Math.sqrt(t * t + e * e) || 1;
    }
    get targetScale() {
        const { a: t, b: e } = this.target;
        return Math.sqrt(t * t + e * e) || 1;
    }
    get minScale() {
        return this.option("minScale") || 1;
    }
    get fullScale() {
        const { contentRect: t } = this;
        return t.fullWidth / t.fitWidth || 1;
    }
    get maxScale() {
        return this.fullScale * (this.option("maxScale") || 1) || 1;
    }
    get coverScale() {
        const { containerRect: t, contentRect: e } = this, i = Math.max(t.height / e.fitHeight, t.width / e.fitWidth) || 1;
        return Math.min(this.fullScale, i);
    }
    get isScaling() {
        return Math.abs(this.targetScale - this.scale) > 1e-5 && !this.isResting;
    }
    get isContentLoading() {
        const t = this.content;
        return !!(t && t instanceof HTMLImageElement) && !t.complete;
    }
    get isResting() {
        if (this.isBouncingX || this.isBouncingY) return !1;
        for (const t of $d4d06657c043713f$var$v){
            const e = "e" == t || "f" === t ? 1e-4 : 1e-5;
            if (Math.abs(this.target[t] - this.current[t]) > e) return !1;
        }
        return !(!this.ignoreBounds && !this.checkBounds().inBounds);
    }
    constructor(t, e = {}, i = {}){
        var s;
        if (super(e), Object.defineProperty(this, "pointerTracker", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "resizeObserver", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "updateTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "clickTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "rAF", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "isTicking", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "ignoreBounds", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "isBouncingX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "isBouncingY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "clicks", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "trackingPoints", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "pwt", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "cwd", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "pmme", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "friction", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d4d06657c043713f$var$m.Init
        }), Object.defineProperty(this, "isDragging", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "content", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "spinner", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "containerRect", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                width: 0,
                height: 0,
                innerWidth: 0,
                innerHeight: 0
            }
        }), Object.defineProperty(this, "contentRect", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                fullWidth: 0,
                fullHeight: 0,
                fitWidth: 0,
                fitHeight: 0,
                width: 0,
                height: 0
            }
        }), Object.defineProperty(this, "dragStart", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                x: 0,
                y: 0,
                top: 0,
                left: 0,
                time: 0
            }
        }), Object.defineProperty(this, "dragOffset", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                x: 0,
                y: 0,
                time: 0
            }
        }), Object.defineProperty(this, "current", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: Object.assign({}, $d4d06657c043713f$var$C)
        }), Object.defineProperty(this, "target", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: Object.assign({}, $d4d06657c043713f$var$C)
        }), Object.defineProperty(this, "velocity", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                a: 0,
                b: 0,
                c: 0,
                d: 0,
                e: 0,
                f: 0
            }
        }), Object.defineProperty(this, "lockedAxis", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), !t) throw new Error("Container Element Not Found");
        this.container = t, this.initContent(), this.attachPlugins(Object.assign(Object.assign({}, $d4d06657c043713f$export$b704d075ddd20210.Plugins), i)), this.emit("attachPlugins"), this.emit("init");
        const o = this.content;
        if (o.addEventListener("load", this.onLoad), o.addEventListener("error", this.onError), this.isContentLoading) {
            if (this.option("spinner")) {
                t.classList.add(this.cn("isLoading"));
                const e = $d4d06657c043713f$var$n($d4d06657c043713f$var$x);
                !t.contains(o) || o.parentElement instanceof HTMLPictureElement ? this.spinner = t.appendChild(e) : this.spinner = (null === (s = o.parentElement) || void 0 === s ? void 0 : s.insertBefore(e, o)) || null;
            }
            this.emit("beforeLoad");
        } else queueMicrotask(()=>{
            this.enable();
        });
    }
    initContent() {
        const { container: t } = this, e = this.cn($d4d06657c043713f$var$L);
        let i = this.option($d4d06657c043713f$var$L) || t.querySelector(`.${e}`);
        if (i || (i = t.querySelector("img,picture") || t.firstElementChild, i && $d4d06657c043713f$var$P(i, e)), i instanceof HTMLPictureElement && (i = i.querySelector("img")), !i) throw new Error("No content found");
        this.content = i;
    }
    onLoad() {
        const { spinner: t, container: e, state: i } = this;
        t && (t.remove(), this.spinner = null), this.option("spinner") && e.classList.remove(this.cn("isLoading")), this.emit("afterLoad"), i === $d4d06657c043713f$var$m.Init ? this.enable() : this.updateMetrics();
    }
    onError() {
        this.state !== $d4d06657c043713f$var$m.Destroy && (this.spinner && (this.spinner.remove(), this.spinner = null), this.stop(), this.detachEvents(), this.state = $d4d06657c043713f$var$m.Error, this.emit("error"));
    }
    getNextScale(t) {
        const { fullScale: e, targetScale: i, coverScale: n, maxScale: s, minScale: o } = this;
        let a = o;
        switch(t){
            case "toggleMax":
                a = i - o < .5 * (s - o) ? s : o;
                break;
            case "toggleCover":
                a = i - o < .5 * (n - o) ? n : o;
                break;
            case "toggleZoom":
                a = i - o < .5 * (e - o) ? e : o;
                break;
            case "iterateZoom":
                let t1 = [
                    1,
                    e,
                    s
                ].sort((t, e)=>t - e), r = t1.findIndex((t)=>t > i + 1e-5);
                a = t1[r] || 1;
        }
        return a;
    }
    attachObserver() {
        var t;
        const e = ()=>{
            const { container: t, containerRect: e } = this;
            return Math.abs(e.width - t.getBoundingClientRect().width) > .1 || Math.abs(e.height - t.getBoundingClientRect().height) > .1;
        };
        this.resizeObserver || void 0 === window.ResizeObserver || (this.resizeObserver = new ResizeObserver(()=>{
            this.updateTimer || (e() ? (this.onResize(), this.isMobile && (this.updateTimer = setTimeout(()=>{
                e() && this.onResize(), this.updateTimer = null;
            }, 500))) : this.updateTimer && (clearTimeout(this.updateTimer), this.updateTimer = null));
        })), null === (t = this.resizeObserver) || void 0 === t || t.observe(this.container);
    }
    detachObserver() {
        var t;
        null === (t = this.resizeObserver) || void 0 === t || t.disconnect();
    }
    attachEvents() {
        const { container: t } = this;
        t.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.addEventListener("wheel", this.onWheel, {
            passive: !1
        }), this.pointerTracker = new $d4d06657c043713f$var$l(t, {
            start: this.onPointerDown,
            move: this.onPointerMove,
            end: this.onPointerUp
        }), document.addEventListener($d4d06657c043713f$var$O, this.onMouseMove);
    }
    detachEvents() {
        var t;
        const { container: e } = this;
        e.removeEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), e.removeEventListener("wheel", this.onWheel, {
            passive: !1
        }), null === (t = this.pointerTracker) || void 0 === t || t.stop(), this.pointerTracker = null, document.removeEventListener($d4d06657c043713f$var$O, this.onMouseMove), document.removeEventListener("keydown", this.onKeydown, !0), this.clickTimer && (clearTimeout(this.clickTimer), this.clickTimer = null), this.updateTimer && (clearTimeout(this.updateTimer), this.updateTimer = null);
    }
    animate() {
        this.setTargetForce();
        const t = this.friction, e = this.option("maxVelocity");
        for (const i of $d4d06657c043713f$var$v)t ? (this.velocity[i] *= 1 - t, e && !this.isScaling && (this.velocity[i] = Math.max(Math.min(this.velocity[i], e), -1 * e)), this.current[i] += this.velocity[i]) : this.current[i] = this.target[i];
        this.setTransform(), this.setEdgeForce(), !this.isResting || this.isDragging ? this.rAF = requestAnimationFrame(()=>this.animate()) : this.stop("current");
    }
    setTargetForce() {
        for (const t of $d4d06657c043713f$var$v)"e" === t && this.isBouncingX || "f" === t && this.isBouncingY || (this.velocity[t] = (1 / (1 - this.friction) - 1) * (this.target[t] - this.current[t]));
    }
    checkBounds(t = 0, e = 0) {
        const { current: i } = this, n = i.e + t, s = i.f + e, o = this.getBounds(), { x: a, y: r } = o, l = a.min, c = a.max, h = r.min, d = r.max;
        let u = 0, p = 0;
        return l !== 1 / 0 && n < l ? u = l - n : c !== 1 / 0 && n > c && (u = c - n), h !== 1 / 0 && s < h ? p = h - s : d !== 1 / 0 && s > d && (p = d - s), Math.abs(u) < 1e-4 && (u = 0), Math.abs(p) < 1e-4 && (p = 0), Object.assign(Object.assign({}, o), {
            xDiff: u,
            yDiff: p,
            inBounds: !u && !p
        });
    }
    clampTargetBounds() {
        const { target: t } = this, { x: e, y: i } = this.getBounds();
        e.min !== 1 / 0 && (t.e = Math.max(t.e, e.min)), e.max !== 1 / 0 && (t.e = Math.min(t.e, e.max)), i.min !== 1 / 0 && (t.f = Math.max(t.f, i.min)), i.max !== 1 / 0 && (t.f = Math.min(t.f, i.max));
    }
    calculateContentDim(t = this.current) {
        const { content: e, contentRect: i } = this, { fitWidth: n, fitHeight: s, fullWidth: o, fullHeight: a } = i;
        let r = o, l = a;
        if (this.option("zoom") || 0 !== this.angle) {
            const i = !(e instanceof HTMLImageElement) && ("none" === window.getComputedStyle(e).maxWidth || "none" === window.getComputedStyle(e).maxHeight), c = i ? o : n, h = i ? a : s, d = this.getMatrix(t), u = new DOMPoint(0, 0).matrixTransform(d), p = new DOMPoint(0 + c, 0).matrixTransform(d), f = new DOMPoint(0 + c, 0 + h).matrixTransform(d), g = new DOMPoint(0, 0 + h).matrixTransform(d), m = Math.abs(f.x - u.x), v = Math.abs(f.y - u.y), b = Math.abs(g.x - p.x), y = Math.abs(g.y - p.y);
            r = Math.max(m, b), l = Math.max(v, y);
        }
        return {
            contentWidth: r,
            contentHeight: l
        };
    }
    setEdgeForce() {
        if (this.ignoreBounds || this.isDragging || this.panMode === $d4d06657c043713f$var$O || this.targetScale < this.scale) return this.isBouncingX = !1, void (this.isBouncingY = !1);
        const { target: t } = this, { x: e, y: i, xDiff: n, yDiff: s } = this.checkBounds();
        const o = this.option("maxVelocity");
        let a = this.velocity.e, r = this.velocity.f;
        0 !== n ? (this.isBouncingX = !0, n * a <= 0 ? a += .14 * n : (a = .14 * n, e.min !== 1 / 0 && (this.target.e = Math.max(t.e, e.min)), e.max !== 1 / 0 && (this.target.e = Math.min(t.e, e.max))), o && (a = Math.max(Math.min(a, o), -1 * o))) : this.isBouncingX = !1, 0 !== s ? (this.isBouncingY = !0, s * r <= 0 ? r += .14 * s : (r = .14 * s, i.min !== 1 / 0 && (this.target.f = Math.max(t.f, i.min)), i.max !== 1 / 0 && (this.target.f = Math.min(t.f, i.max))), o && (r = Math.max(Math.min(r, o), -1 * o))) : this.isBouncingY = !1, this.isBouncingX && (this.velocity.e = a), this.isBouncingY && (this.velocity.f = r);
    }
    enable() {
        const { content: t } = this, e = new DOMMatrixReadOnly(window.getComputedStyle(t).transform);
        for (const t of $d4d06657c043713f$var$v)this.current[t] = this.target[t] = e[t];
        this.updateMetrics(), this.attachObserver(), this.attachEvents(), this.state = $d4d06657c043713f$var$m.Ready, this.emit("ready");
    }
    onClick(t) {
        var e;
        "click" === t.type && 0 === t.detail && (this.dragOffset.x = 0, this.dragOffset.y = 0), this.isDragging && (null === (e = this.pointerTracker) || void 0 === e || e.clear(), this.trackingPoints = [], this.startDecelAnim());
        const i = t.target;
        if (!i || t.defaultPrevented) return;
        if (i.hasAttribute("disabled")) return t.preventDefault(), void t.stopPropagation();
        if ((()=>{
            const t = window.getSelection();
            return t && "Range" === t.type;
        })() && !i.closest("button")) return;
        const n = i.closest("[data-panzoom-action]"), s = i.closest("[data-panzoom-change]"), o = n || s, a = o && $d4d06657c043713f$var$E(o) ? o.dataset : null;
        if (a) {
            const e = a.panzoomChange, i = a.panzoomAction;
            if ((e || i) && t.preventDefault(), e) {
                let t = {};
                try {
                    t = JSON.parse(e);
                } catch (t) {
                    console && console.warn("The given data was not valid JSON");
                }
                return void this.applyChange(t);
            }
            if (i) return void (this[i] && this[i]());
        }
        if (Math.abs(this.dragOffset.x) > 3 || Math.abs(this.dragOffset.y) > 3) return t.preventDefault(), void t.stopPropagation();
        if (i.closest("[data-fancybox]")) return;
        const r = this.content.getBoundingClientRect(), l = this.dragStart;
        if (l.time && !this.canZoomOut() && (Math.abs(r.x - l.x) > 2 || Math.abs(r.y - l.y) > 2)) return;
        this.dragStart.time = 0;
        const c = (e)=>{
            this.option("zoom", t) && e && "string" == typeof e && /(iterateZoom)|(toggle(Zoom|Full|Cover|Max)|(zoomTo(Fit|Cover|Max)))/.test(e) && "function" == typeof this[e] && (t.preventDefault(), this[e]({
                event: t
            }));
        }, h = this.option("click", t), d = this.option("dblClick", t);
        d ? (this.clicks++, 1 == this.clicks && (this.clickTimer = setTimeout(()=>{
            1 === this.clicks ? (this.emit("click", t), !t.defaultPrevented && h && c(h)) : (this.emit("dblClick", t), t.defaultPrevented || c(d)), this.clicks = 0, this.clickTimer = null;
        }, 350))) : (this.emit("click", t), !t.defaultPrevented && h && c(h));
    }
    addTrackingPoint(t) {
        const e = this.trackingPoints.filter((t)=>t.time > Date.now() - 100);
        e.push(t), this.trackingPoints = e;
    }
    onPointerDown(t, e, i) {
        var n;
        if (!1 === this.option("touch", t)) return !1;
        this.pwt = 0, this.dragOffset = {
            x: 0,
            y: 0,
            time: 0
        }, this.trackingPoints = [];
        const s = this.content.getBoundingClientRect();
        if (this.dragStart = {
            x: s.x,
            y: s.y,
            top: s.top,
            left: s.left,
            time: Date.now()
        }, this.clickTimer) return !1;
        if (this.panMode === $d4d06657c043713f$var$O && this.targetScale > 1) return t.preventDefault(), t.stopPropagation(), !1;
        const o = t.composedPath()[0];
        if (!i.length) {
            if ([
                "TEXTAREA",
                "OPTION",
                "INPUT",
                "SELECT",
                "VIDEO",
                "IFRAME"
            ].includes(o.nodeName) || o.closest("[contenteditable],[data-selectable],[data-draggable],[data-clickable],[data-panzoom-change],[data-panzoom-action]")) return !1;
            null === (n = window.getSelection()) || void 0 === n || n.removeAllRanges();
        }
        if ("mousedown" === t.type) [
            "A",
            "BUTTON"
        ].includes(o.nodeName) || t.preventDefault();
        else if (Math.abs(this.velocity.a) > .3) return !1;
        return this.target.e = this.current.e, this.target.f = this.current.f, this.stop(), this.isDragging || (this.isDragging = !0, this.addTrackingPoint(e), this.emit("touchStart", t)), !0;
    }
    onPointerMove(e, n, s) {
        if (!1 === this.option("touch", e)) return;
        if (!this.isDragging) return;
        if (n.length < 2 && this.panOnlyZoomed && $d4d06657c043713f$var$t(this.targetScale) <= $d4d06657c043713f$var$t(this.minScale)) return;
        if (this.emit("touchMove", e), e.defaultPrevented) return;
        this.addTrackingPoint(n[0]);
        const { content: o } = this, a = $d4d06657c043713f$var$h(s[0], s[1]), r = $d4d06657c043713f$var$h(n[0], n[1]);
        let l = 0, d = 0;
        if (n.length > 1) {
            const t = o.getBoundingClientRect();
            l = a.clientX - t.left - .5 * t.width, d = a.clientY - t.top - .5 * t.height;
        }
        const u = $d4d06657c043713f$var$c(s[0], s[1]), p = $d4d06657c043713f$var$c(n[0], n[1]);
        let f = u ? p / u : 1, g = r.clientX - a.clientX, m = r.clientY - a.clientY;
        this.dragOffset.x += g, this.dragOffset.y += m, this.dragOffset.time = Date.now() - this.dragStart.time;
        let v = $d4d06657c043713f$var$t(this.targetScale) === $d4d06657c043713f$var$t(this.minScale) && this.option("lockAxis");
        if (v && !this.lockedAxis) {
            if ("xy" === v || "y" === v || "touchmove" === e.type) {
                if (Math.abs(this.dragOffset.x) < 6 && Math.abs(this.dragOffset.y) < 6) return void e.preventDefault();
                const t = Math.abs(180 * Math.atan2(this.dragOffset.y, this.dragOffset.x) / Math.PI);
                this.lockedAxis = t > 45 && t < 135 ? "y" : "x", this.dragOffset.x = 0, this.dragOffset.y = 0, g = 0, m = 0;
            } else this.lockedAxis = v;
        }
        if ($d4d06657c043713f$var$i(e.target, this.content) && (v = "x", this.dragOffset.y = 0), v && "xy" !== v && this.lockedAxis !== v && $d4d06657c043713f$var$t(this.targetScale) === $d4d06657c043713f$var$t(this.minScale)) return;
        e.cancelable && e.preventDefault(), this.container.classList.add(this.cn("isDragging"));
        const b = this.checkBounds(g, m);
        this.option("rubberband") ? ("x" !== this.isInfinite && (b.xDiff > 0 && g < 0 || b.xDiff < 0 && g > 0) && (g *= Math.max(0, .5 - Math.abs(.75 / this.contentRect.fitWidth * b.xDiff))), "y" !== this.isInfinite && (b.yDiff > 0 && m < 0 || b.yDiff < 0 && m > 0) && (m *= Math.max(0, .5 - Math.abs(.75 / this.contentRect.fitHeight * b.yDiff)))) : (b.xDiff && (g = 0), b.yDiff && (m = 0));
        const y = this.targetScale, w = this.minScale, x = this.maxScale;
        y < .5 * w && (f = Math.max(f, w)), y > 1.5 * x && (f = Math.min(f, x)), "y" === this.lockedAxis && $d4d06657c043713f$var$t(y) === $d4d06657c043713f$var$t(w) && (g = 0), "x" === this.lockedAxis && $d4d06657c043713f$var$t(y) === $d4d06657c043713f$var$t(w) && (m = 0), this.applyChange({
            originX: l,
            originY: d,
            panX: g,
            panY: m,
            scale: f,
            friction: this.option("dragFriction"),
            ignoreBounds: !0
        });
    }
    onPointerUp(t, e, n) {
        if (n.length) return this.dragOffset.x = 0, this.dragOffset.y = 0, void (this.trackingPoints = []);
        this.container.classList.remove(this.cn("isDragging")), this.isDragging && (this.addTrackingPoint(e), this.panOnlyZoomed && this.contentRect.width - this.contentRect.fitWidth < 1 && this.contentRect.height - this.contentRect.fitHeight < 1 && (this.trackingPoints = []), $d4d06657c043713f$var$i(t.target, this.content) && "y" === this.lockedAxis && (this.trackingPoints = []), this.emit("touchEnd", t), this.isDragging = !1, this.lockedAxis = !1, this.state !== $d4d06657c043713f$var$m.Destroy && (t.defaultPrevented || this.startDecelAnim()));
    }
    startDecelAnim() {
        var e;
        const i = this.isScaling;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.isBouncingX = !1, this.isBouncingY = !1;
        for (const t of $d4d06657c043713f$var$v)this.velocity[t] = 0;
        this.target.e = this.current.e, this.target.f = this.current.f, $d4d06657c043713f$var$S(this.container, "is-scaling"), $d4d06657c043713f$var$S(this.container, "is-animating"), this.isTicking = !1;
        const { trackingPoints: n } = this, s = n[0], o = n[n.length - 1];
        let a = 0, r = 0, l = 0;
        o && s && (a = o.clientX - s.clientX, r = o.clientY - s.clientY, l = o.time - s.time);
        const c = (null === (e = window.visualViewport) || void 0 === e ? void 0 : e.scale) || 1;
        1 !== c && (a *= c, r *= c);
        let h = 0, d = 0, u = 0, p = 0, f = this.option("decelFriction");
        const g = this.targetScale;
        if (l > 0) {
            u = Math.abs(a) > 3 ? a / (l / 30) : 0, p = Math.abs(r) > 3 ? r / (l / 30) : 0;
            const t = this.option("maxVelocity");
            t && (u = Math.max(Math.min(u, t), -1 * t), p = Math.max(Math.min(p, t), -1 * t));
        }
        u && (h = u / (1 / (1 - f) - 1)), p && (d = p / (1 / (1 - f) - 1)), ("y" === this.option("lockAxis") || "xy" === this.option("lockAxis") && "y" === this.lockedAxis && $d4d06657c043713f$var$t(g) === this.minScale) && (h = u = 0), ("x" === this.option("lockAxis") || "xy" === this.option("lockAxis") && "x" === this.lockedAxis && $d4d06657c043713f$var$t(g) === this.minScale) && (d = p = 0);
        const m = this.dragOffset.x, b = this.dragOffset.y, y = this.option("dragMinThreshold") || 0;
        Math.abs(m) < y && Math.abs(b) < y && (h = d = 0, u = p = 0), (this.option("zoom") && (g < this.minScale - 1e-5 || g > this.maxScale + 1e-5) || i && !h && !d) && (f = .35), this.applyChange({
            panX: h,
            panY: d,
            friction: f
        }), this.emit("decel", u, p, m, b);
    }
    onWheel(t) {
        var e = [
            -t.deltaX || 0,
            -t.deltaY || 0,
            -t.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        });
        const i = Math.max(-1, Math.min(1, e));
        if (this.emit("wheel", t, i), this.panMode === $d4d06657c043713f$var$O) return;
        if (t.defaultPrevented) return;
        const n = this.option("wheel");
        "pan" === n ? (t.preventDefault(), this.panOnlyZoomed && !this.canZoomOut() || this.applyChange({
            panX: 2 * -t.deltaX,
            panY: 2 * -t.deltaY,
            bounce: !1
        })) : "zoom" === n && !1 !== this.option("zoom") && this.zoomWithWheel(t);
    }
    onMouseMove(t) {
        this.panWithMouse(t);
    }
    onKeydown(t) {
        "Escape" === t.key && this.toggleFS();
    }
    onResize() {
        this.updateMetrics(), this.checkBounds().inBounds || this.requestTick();
    }
    setTransform() {
        this.emit("beforeTransform");
        const { current: e, target: i, content: n, contentRect: s } = this, o = Object.assign({}, $d4d06657c043713f$var$C);
        for (const n of $d4d06657c043713f$var$v){
            const s = "e" == n || "f" === n ? $d4d06657c043713f$var$M : $d4d06657c043713f$var$T;
            o[n] = $d4d06657c043713f$var$t(e[n], s), Math.abs(i[n] - e[n]) < ("e" == n || "f" === n ? .51 : .001) && (e[n] = i[n]);
        }
        let { a: a, b: r, c: l, d: c, e: h, f: d } = o, u = `matrix(${a}, ${r}, ${l}, ${c}, ${h}, ${d})`, p = n.parentElement instanceof HTMLPictureElement ? n.parentElement : n;
        if (this.option("transformParent") && (p = p.parentElement || p), p.style.transform === u) return;
        p.style.transform = u;
        const { contentWidth: f, contentHeight: g } = this.calculateContentDim();
        s.width = f, s.height = g, this.emit("afterTransform");
    }
    updateMetrics(e = !1) {
        var i;
        if (!this || this.state === $d4d06657c043713f$var$m.Destroy) return;
        if (this.isContentLoading) return;
        const n = Math.max(1, (null === (i = window.visualViewport) || void 0 === i ? void 0 : i.scale) || 1), { container: s, content: o } = this, a = o instanceof HTMLImageElement, r = s.getBoundingClientRect(), l = getComputedStyle(this.container);
        let c = r.width * n, h = r.height * n;
        const d = parseFloat(l.paddingTop) + parseFloat(l.paddingBottom), u = c - (parseFloat(l.paddingLeft) + parseFloat(l.paddingRight)), p = h - d;
        this.containerRect = {
            width: c,
            height: h,
            innerWidth: u,
            innerHeight: p
        };
        const f = parseFloat(o.dataset.width || "") || ((t)=>{
            let e = 0;
            return e = t instanceof HTMLImageElement ? t.naturalWidth : t instanceof SVGElement ? t.width.baseVal.value : Math.max(t.offsetWidth, t.scrollWidth), e || 0;
        })(o), g = parseFloat(o.dataset.height || "") || ((t)=>{
            let e = 0;
            return e = t instanceof HTMLImageElement ? t.naturalHeight : t instanceof SVGElement ? t.height.baseVal.value : Math.max(t.offsetHeight, t.scrollHeight), e || 0;
        })(o);
        let v = this.option("width", f) || $d4d06657c043713f$var$z, b = this.option("height", g) || $d4d06657c043713f$var$z;
        const y = v === $d4d06657c043713f$var$z, w = b === $d4d06657c043713f$var$z;
        "number" != typeof v && (v = f), "number" != typeof b && (b = g), y && (v = f * (b / g)), w && (b = g / (f / v));
        let x = o.parentElement instanceof HTMLPictureElement ? o.parentElement : o;
        this.option("transformParent") && (x = x.parentElement || x);
        const E = x.getAttribute("style") || "";
        x.style.setProperty("transform", "none", "important"), a && (x.style.width = "", x.style.height = ""), x.offsetHeight;
        const S = o.getBoundingClientRect();
        let P = S.width * n, C = S.height * n, T = P, M = C;
        P = Math.min(P, v), C = Math.min(C, b), a ? { width: P, height: C } = ((t, e, i, n)=>{
            const s = i / t, o = n / e, a = Math.min(s, o);
            return {
                width: t *= a,
                height: e *= a
            };
        })(v, b, P, C) : (P = Math.min(P, v), C = Math.min(C, b));
        let O = .5 * (M - C), A = .5 * (T - P);
        this.contentRect = Object.assign(Object.assign({}, this.contentRect), {
            top: S.top - r.top + O,
            bottom: r.bottom - S.bottom + O,
            left: S.left - r.left + A,
            right: r.right - S.right + A,
            fitWidth: P,
            fitHeight: C,
            width: P,
            height: C,
            fullWidth: v,
            fullHeight: b
        }), x.style.cssText = E, a && (x.style.width = `${P}px`, x.style.height = `${C}px`), this.setTransform(), !0 !== e && this.emit("refresh"), this.ignoreBounds || ($d4d06657c043713f$var$t(this.targetScale) < $d4d06657c043713f$var$t(this.minScale) ? this.zoomTo(this.minScale, {
            friction: 0
        }) : this.targetScale > this.maxScale ? this.zoomTo(this.maxScale, {
            friction: 0
        }) : this.state === $d4d06657c043713f$var$m.Init || this.checkBounds().inBounds || this.requestTick()), this.updateControls();
    }
    calculateBounds() {
        const { contentWidth: e, contentHeight: i } = this.calculateContentDim(this.target), { targetScale: n, lockedAxis: s } = this, { fitWidth: o, fitHeight: a } = this.contentRect;
        let r = 0, l = 0, c = 0, h = 0;
        const d = this.option("infinite");
        if (!0 === d || s && d === s) r = -1 / 0, c = 1 / 0, l = -1 / 0, h = 1 / 0;
        else {
            let { containerRect: s, contentRect: d } = this, u = $d4d06657c043713f$var$t(o * n, $d4d06657c043713f$var$M), p = $d4d06657c043713f$var$t(a * n, $d4d06657c043713f$var$M), { innerWidth: f, innerHeight: g } = s;
            if (s.width === u && (f = s.width), s.width === p && (g = s.height), e > f) {
                c = .5 * (e - f), r = -1 * c;
                let t = .5 * (d.right - d.left);
                r += t, c += t;
            }
            if (o > f && e < f && (r -= .5 * (o - f), c -= .5 * (o - f)), i > g) {
                h = .5 * (i - g), l = -1 * h;
                let t = .5 * (d.bottom - d.top);
                l += t, h += t;
            }
            a > g && i < g && (r -= .5 * (a - g), c -= .5 * (a - g));
        }
        return {
            x: {
                min: r,
                max: c
            },
            y: {
                min: l,
                max: h
            }
        };
    }
    getBounds() {
        const t = this.option("bounds");
        return t !== $d4d06657c043713f$var$z ? t : this.calculateBounds();
    }
    updateControls() {
        const e = this, i = e.container, { panMode: n, contentRect: s, targetScale: a, minScale: r } = e;
        let l = r, c = e.option("click") || !1;
        c && (l = e.getNextScale(c));
        let h = e.canZoomIn(), d = e.canZoomOut(), u = n === $d4d06657c043713f$var$A && !!this.option("touch"), p = d && u;
        if (u && ($d4d06657c043713f$var$t(a) < $d4d06657c043713f$var$t(r) && !this.panOnlyZoomed && (p = !0), ($d4d06657c043713f$var$t(s.width, 1) > $d4d06657c043713f$var$t(s.fitWidth, 1) || $d4d06657c043713f$var$t(s.height, 1) > $d4d06657c043713f$var$t(s.fitHeight, 1)) && (p = !0)), $d4d06657c043713f$var$t(s.width * a, 1) < $d4d06657c043713f$var$t(s.fitWidth, 1) && (p = !1), n === $d4d06657c043713f$var$O && (p = !1), $d4d06657c043713f$var$o(i, this.cn("isDraggable"), p), !this.option("zoom")) return;
        let f = h && $d4d06657c043713f$var$t(l) > $d4d06657c043713f$var$t(a), g = !f && !p && d && $d4d06657c043713f$var$t(l) < $d4d06657c043713f$var$t(a);
        $d4d06657c043713f$var$o(i, this.cn("canZoomIn"), f), $d4d06657c043713f$var$o(i, this.cn("canZoomOut"), g);
        for (const t of i.querySelectorAll("[data-panzoom-action]")){
            let e = !1, i = !1;
            switch(t.dataset.panzoomAction){
                case "zoomIn":
                    h ? e = !0 : i = !0;
                    break;
                case "zoomOut":
                    d ? e = !0 : i = !0;
                    break;
                case "toggleZoom":
                case "iterateZoom":
                    h || d ? e = !0 : i = !0;
                    const n = t.querySelector("g");
                    n && (n.style.display = h ? "" : "none");
            }
            e ? (t.removeAttribute("disabled"), t.removeAttribute("tabindex")) : i && (t.setAttribute("disabled", ""), t.setAttribute("tabindex", "-1"));
        }
    }
    panTo({ x: t = this.target.e, y: e = this.target.f, scale: i = this.targetScale, friction: n = this.option("friction"), angle: s = 0, originX: o = 0, originY: a = 0, flipX: r = !1, flipY: l = !1, ignoreBounds: c = !1 }) {
        this.state !== $d4d06657c043713f$var$m.Destroy && this.applyChange({
            panX: t - this.target.e,
            panY: e - this.target.f,
            scale: i / this.targetScale,
            angle: s,
            originX: o,
            originY: a,
            friction: n,
            flipX: r,
            flipY: l,
            ignoreBounds: c
        });
    }
    applyChange({ panX: e = 0, panY: i = 0, scale: n = 1, angle: s = 0, originX: o = -this.current.e, originY: a = -this.current.f, friction: r = this.option("friction"), flipX: l = !1, flipY: c = !1, ignoreBounds: h = !1, bounce: d = this.option("bounce") }) {
        const u = this.state;
        if (u === $d4d06657c043713f$var$m.Destroy) return;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.friction = r || 0, this.ignoreBounds = h;
        const { current: p } = this, f = p.e, g = p.f, b = this.getMatrix(this.target);
        let y = (new DOMMatrix).translate(f, g).translate(o, a).translate(e, i);
        if (this.option("zoom")) {
            if (!h) {
                const t = this.targetScale, e = this.minScale, i = this.maxScale;
                t * n < e && (n = e / t), t * n > i && (n = i / t);
            }
            y = y.scale(n);
        }
        y = y.translate(-o, -a).translate(-f, -g).multiply(b), s && (y = y.rotate(s)), l && (y = y.scale(-1, 1)), c && (y = y.scale(1, -1));
        for (const e of $d4d06657c043713f$var$v)"e" !== e && "f" !== e && (y[e] > this.minScale + 1e-5 || y[e] < this.minScale - 1e-5) ? this.target[e] = y[e] : this.target[e] = $d4d06657c043713f$var$t(y[e], $d4d06657c043713f$var$M);
        (this.targetScale < this.scale || Math.abs(n - 1) > .1 || this.panMode === $d4d06657c043713f$var$O || !1 === d) && !h && this.clampTargetBounds(), u === $d4d06657c043713f$var$m.Init ? this.animate() : this.isResting || (this.state = $d4d06657c043713f$var$m.Panning, this.requestTick());
    }
    stop(t = !1) {
        if (this.state === $d4d06657c043713f$var$m.Init || this.state === $d4d06657c043713f$var$m.Destroy) return;
        const e = this.isTicking;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.isBouncingX = !1, this.isBouncingY = !1;
        for (const e of $d4d06657c043713f$var$v)this.velocity[e] = 0, "current" === t ? this.current[e] = this.target[e] : "target" === t && (this.target[e] = this.current[e]);
        this.setTransform(), $d4d06657c043713f$var$S(this.container, "is-scaling"), $d4d06657c043713f$var$S(this.container, "is-animating"), this.isTicking = !1, this.state = $d4d06657c043713f$var$m.Ready, e && (this.emit("endAnimation"), this.updateControls());
    }
    requestTick() {
        this.isTicking || (this.emit("startAnimation"), this.updateControls(), $d4d06657c043713f$var$P(this.container, "is-animating"), this.isScaling && $d4d06657c043713f$var$P(this.container, "is-scaling")), this.isTicking = !0, this.rAF || (this.rAF = requestAnimationFrame(()=>this.animate()));
    }
    panWithMouse(e, i = this.option("mouseMoveFriction")) {
        if (this.pmme = e, this.panMode !== $d4d06657c043713f$var$O || !e) return;
        if ($d4d06657c043713f$var$t(this.targetScale) <= $d4d06657c043713f$var$t(this.minScale)) return;
        this.emit("mouseMove", e);
        const { container: n, containerRect: s, contentRect: o } = this, a = s.width, r = s.height, l = n.getBoundingClientRect(), c = (e.clientX || 0) - l.left, h = (e.clientY || 0) - l.top;
        let { contentWidth: d, contentHeight: u } = this.calculateContentDim(this.target);
        const p = this.option("mouseMoveFactor");
        p > 1 && (d !== a && (d *= p), u !== r && (u *= p));
        let f = .5 * (d - a) - c / a * 100 / 100 * (d - a);
        f += .5 * (o.right - o.left);
        let g = .5 * (u - r) - h / r * 100 / 100 * (u - r);
        g += .5 * (o.bottom - o.top), this.applyChange({
            panX: f - this.target.e,
            panY: g - this.target.f,
            friction: i
        });
    }
    zoomWithWheel(e) {
        if (this.state === $d4d06657c043713f$var$m.Destroy || this.state === $d4d06657c043713f$var$m.Init) return;
        const i = Date.now();
        if (i - this.pwt < 45) return void e.preventDefault();
        this.pwt = i;
        var n = [
            -e.deltaX || 0,
            -e.deltaY || 0,
            -e.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        });
        const s = Math.max(-1, Math.min(1, n)), { targetScale: o, maxScale: a, minScale: r } = this;
        let l = o * (100 + 45 * s) / 100;
        $d4d06657c043713f$var$t(l) < $d4d06657c043713f$var$t(r) && $d4d06657c043713f$var$t(o) <= $d4d06657c043713f$var$t(r) ? (this.cwd += Math.abs(s), l = r) : $d4d06657c043713f$var$t(l) > $d4d06657c043713f$var$t(a) && $d4d06657c043713f$var$t(o) >= $d4d06657c043713f$var$t(a) ? (this.cwd += Math.abs(s), l = a) : (this.cwd = 0, l = Math.max(Math.min(l, a), r)), this.cwd > this.option("wheelLimit") || (e.preventDefault(), $d4d06657c043713f$var$t(l) !== $d4d06657c043713f$var$t(o) && this.zoomTo(l, {
            event: e
        }));
    }
    canZoomIn() {
        return this.option("zoom") && ($d4d06657c043713f$var$t(this.contentRect.width, 1) < $d4d06657c043713f$var$t(this.contentRect.fitWidth, 1) || $d4d06657c043713f$var$t(this.targetScale) < $d4d06657c043713f$var$t(this.maxScale));
    }
    canZoomOut() {
        return this.option("zoom") && $d4d06657c043713f$var$t(this.targetScale) > $d4d06657c043713f$var$t(this.minScale);
    }
    zoomIn(t = 1.25, e) {
        this.zoomTo(this.targetScale * t, e);
    }
    zoomOut(t = .8, e) {
        this.zoomTo(this.targetScale * t, e);
    }
    zoomToFit(t) {
        this.zoomTo("fit", t);
    }
    zoomToCover(t) {
        this.zoomTo("cover", t);
    }
    zoomToFull(t) {
        this.zoomTo("full", t);
    }
    zoomToMax(t) {
        this.zoomTo("max", t);
    }
    toggleZoom(t) {
        this.zoomTo(this.getNextScale("toggleZoom"), t);
    }
    toggleMax(t) {
        this.zoomTo(this.getNextScale("toggleMax"), t);
    }
    toggleCover(t) {
        this.zoomTo(this.getNextScale("toggleCover"), t);
    }
    iterateZoom(t) {
        this.zoomTo("next", t);
    }
    zoomTo(t = 1, { friction: e = $d4d06657c043713f$var$z, originX: i = $d4d06657c043713f$var$z, originY: n = $d4d06657c043713f$var$z, event: s } = {}) {
        if (this.isContentLoading || this.state === $d4d06657c043713f$var$m.Destroy) return;
        const { targetScale: o, fullScale: a, maxScale: r, coverScale: l } = this;
        if (this.stop(), this.panMode === $d4d06657c043713f$var$O && (s = this.pmme || s), s || i === $d4d06657c043713f$var$z || n === $d4d06657c043713f$var$z) {
            const t = this.content.getBoundingClientRect(), e = this.container.getBoundingClientRect(), o = s ? s.clientX : e.left + .5 * e.width, a = s ? s.clientY : e.top + .5 * e.height;
            i = o - t.left - .5 * t.width, n = a - t.top - .5 * t.height;
        }
        let c = 1;
        "number" == typeof t ? c = t : "full" === t ? c = a : "cover" === t ? c = l : "max" === t ? c = r : "fit" === t ? c = 1 : "next" === t && (c = this.getNextScale("iterateZoom")), c = c / o || 1, e = e === $d4d06657c043713f$var$z ? c > 1 ? .15 : .25 : e, this.applyChange({
            scale: c,
            originX: i,
            originY: n,
            friction: e
        }), s && this.panMode === $d4d06657c043713f$var$O && this.panWithMouse(s, e);
    }
    rotateCCW() {
        this.applyChange({
            angle: -90
        });
    }
    rotateCW() {
        this.applyChange({
            angle: 90
        });
    }
    flipX() {
        this.applyChange({
            flipX: !0
        });
    }
    flipY() {
        this.applyChange({
            flipY: !0
        });
    }
    fitX() {
        this.stop("target");
        const { containerRect: t, contentRect: e, target: i } = this;
        this.applyChange({
            panX: .5 * t.width - (e.left + .5 * e.fitWidth) - i.e,
            panY: .5 * t.height - (e.top + .5 * e.fitHeight) - i.f,
            scale: t.width / e.fitWidth / this.targetScale,
            originX: 0,
            originY: 0,
            ignoreBounds: !0
        });
    }
    fitY() {
        this.stop("target");
        const { containerRect: t, contentRect: e, target: i } = this;
        this.applyChange({
            panX: .5 * t.width - (e.left + .5 * e.fitWidth) - i.e,
            panY: .5 * t.innerHeight - (e.top + .5 * e.fitHeight) - i.f,
            scale: t.height / e.fitHeight / this.targetScale,
            originX: 0,
            originY: 0,
            ignoreBounds: !0
        });
    }
    toggleFS() {
        const { container: t } = this, e = this.cn("inFullscreen"), i = this.cn("htmlHasFullscreen");
        t.classList.toggle(e);
        const n = t.classList.contains(e);
        n ? (document.documentElement.classList.add(i), document.addEventListener("keydown", this.onKeydown, !0)) : (document.documentElement.classList.remove(i), document.removeEventListener("keydown", this.onKeydown, !0)), this.updateMetrics(), this.emit(n ? "enterFS" : "exitFS");
    }
    getMatrix(t = this.current) {
        const { a: e, b: i, c: n, d: s, e: o, f: a } = t;
        return new DOMMatrix([
            e,
            i,
            n,
            s,
            o,
            a
        ]);
    }
    reset(t) {
        if (this.state !== $d4d06657c043713f$var$m.Init && this.state !== $d4d06657c043713f$var$m.Destroy) {
            this.stop("current");
            for (const t of $d4d06657c043713f$var$v)this.target[t] = $d4d06657c043713f$var$C[t];
            this.target.a = this.minScale, this.target.d = this.minScale, this.clampTargetBounds(), this.isResting || (this.friction = void 0 === t ? this.option("friction") : t, this.state = $d4d06657c043713f$var$m.Panning, this.requestTick());
        }
    }
    destroy() {
        this.stop(), this.state = $d4d06657c043713f$var$m.Destroy, this.detachEvents(), this.detachObserver();
        const { container: t, content: e } = this, i = this.option("classes") || {};
        for (const e of Object.values(i))t.classList.remove(e + "");
        e && (e.removeEventListener("load", this.onLoad), e.removeEventListener("error", this.onError)), this.detachPlugins();
    }
}
Object.defineProperty($d4d06657c043713f$export$b704d075ddd20210, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$y
}), Object.defineProperty($d4d06657c043713f$export$b704d075ddd20210, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {}
});
const $d4d06657c043713f$var$D = function(t, e) {
    let i = !0;
    return (...n)=>{
        i && (i = !1, t(...n), setTimeout(()=>{
            i = !0;
        }, e));
    };
}, $d4d06657c043713f$var$F = (t, e)=>{
    let i = [];
    return t.childNodes.forEach((t)=>{
        t.nodeType !== Node.ELEMENT_NODE || e && !t.matches(e) || i.push(t);
    }), i;
}, $d4d06657c043713f$var$j = {
    viewport: null,
    track: null,
    enabled: !0,
    slides: [],
    axis: "x",
    transition: "fade",
    preload: 1,
    slidesPerPage: "auto",
    initialPage: 0,
    friction: .12,
    Panzoom: {
        decelFriction: .12
    },
    center: !0,
    infinite: !0,
    fill: !0,
    dragFree: !1,
    adaptiveHeight: !1,
    direction: "ltr",
    classes: {
        container: "f-carousel",
        viewport: "f-carousel__viewport",
        track: "f-carousel__track",
        slide: "f-carousel__slide",
        isLTR: "is-ltr",
        isRTL: "is-rtl",
        isHorizontal: "is-horizontal",
        isVertical: "is-vertical",
        inTransition: "in-transition",
        isSelected: "is-selected"
    },
    l10n: {
        NEXT: "Next slide",
        PREV: "Previous slide",
        GOTO: "Go to slide #%d"
    }
};
var $d4d06657c043713f$var$B;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Destroy = 2] = "Destroy";
}($d4d06657c043713f$var$B || ($d4d06657c043713f$var$B = {}));
const $d4d06657c043713f$var$H = (t)=>{
    if ("string" == typeof t || t instanceof HTMLElement) t = {
        html: t
    };
    else {
        const e = t.thumb;
        void 0 !== e && ("string" == typeof e && (t.thumbSrc = e), e instanceof HTMLImageElement && (t.thumbEl = e, t.thumbElSrc = e.src, t.thumbSrc = e.src), delete t.thumb);
    }
    return Object.assign({
        html: "",
        el: null,
        isDom: !1,
        class: "",
        customClass: "",
        index: -1,
        dim: 0,
        gap: 0,
        pos: 0,
        transition: !1
    }, t);
}, $d4d06657c043713f$var$N = (t = {})=>Object.assign({
        index: -1,
        slides: [],
        dim: 0,
        pos: -1
    }, t);
class $d4d06657c043713f$var$_ extends $d4d06657c043713f$var$f {
    constructor(t, e){
        super(e), Object.defineProperty(this, "instance", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t
        });
    }
    attach() {}
    detach() {}
}
const $d4d06657c043713f$var$$ = {
    classes: {
        list: "f-carousel__dots",
        isDynamic: "is-dynamic",
        hasDots: "has-dots",
        dot: "f-carousel__dot",
        isBeforePrev: "is-before-prev",
        isPrev: "is-prev",
        isCurrent: "is-current",
        isNext: "is-next",
        isAfterNext: "is-after-next"
    },
    dotTpl: '<button type="button" data-carousel-page="%i" aria-label="{{GOTO}}"><span class="f-carousel__dot" aria-hidden="true"></span></button>',
    dynamicFrom: 11,
    maxCount: 1 / 0,
    minCount: 2
};
class $d4d06657c043713f$var$W extends $d4d06657c043713f$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "isDynamic", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "list", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onRefresh() {
        this.refresh();
    }
    build() {
        let t = this.list;
        if (!t) {
            t = document.createElement("ul"), $d4d06657c043713f$var$P(t, this.cn("list")), t.setAttribute("role", "tablist");
            const e = this.instance.container;
            e.appendChild(t), $d4d06657c043713f$var$P(e, this.cn("hasDots")), this.list = t;
        }
        return t;
    }
    refresh() {
        var t;
        const e = this.instance.pages.length, i = Math.min(2, this.option("minCount")), n = Math.max(2e3, this.option("maxCount")), s = this.option("dynamicFrom");
        if (e < i || e > n) return void this.cleanup();
        const a = "number" == typeof s && e > 5 && e >= s, r = !this.list || this.isDynamic !== a || this.list.children.length !== e;
        r && this.cleanup();
        const l = this.build();
        if ($d4d06657c043713f$var$o(l, this.cn("isDynamic"), !!a), r) for(let t = 0; t < e; t++)l.append(this.createItem(t));
        let c, h = 0;
        for (const e of [
            ...l.children
        ]){
            const i = h === this.instance.page;
            i && (c = e), $d4d06657c043713f$var$o(e, this.cn("isCurrent"), i), null === (t = e.children[0]) || void 0 === t || t.setAttribute("aria-selected", i ? "true" : "false");
            for (const t of [
                "isBeforePrev",
                "isPrev",
                "isNext",
                "isAfterNext"
            ])$d4d06657c043713f$var$S(e, this.cn(t));
            h++;
        }
        if (c = c || l.firstChild, a && c) {
            const t = c.previousElementSibling, e = t && t.previousElementSibling;
            $d4d06657c043713f$var$P(t, this.cn("isPrev")), $d4d06657c043713f$var$P(e, this.cn("isBeforePrev"));
            const i = c.nextElementSibling, n = i && i.nextElementSibling;
            $d4d06657c043713f$var$P(i, this.cn("isNext")), $d4d06657c043713f$var$P(n, this.cn("isAfterNext"));
        }
        this.isDynamic = a;
    }
    createItem(t = 0) {
        var e;
        const i = document.createElement("li");
        i.setAttribute("role", "presentation");
        const s = $d4d06657c043713f$var$n(this.instance.localize(this.option("dotTpl"), [
            [
                "%d",
                t + 1
            ]
        ]).replace(/\%i/g, t + ""));
        return i.appendChild(s), null === (e = i.children[0]) || void 0 === e || e.setAttribute("role", "tab"), i;
    }
    cleanup() {
        this.list && (this.list.remove(), this.list = null), this.isDynamic = !1, $d4d06657c043713f$var$S(this.instance.container, this.cn("hasDots"));
    }
    attach() {
        this.instance.on([
            "refresh",
            "change"
        ], this.onRefresh);
    }
    detach() {
        this.instance.off([
            "refresh",
            "change"
        ], this.onRefresh), this.cleanup();
    }
}
Object.defineProperty($d4d06657c043713f$var$W, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$$
});
const $d4d06657c043713f$var$X = "disabled", $d4d06657c043713f$var$q = "next", $d4d06657c043713f$var$Y = "prev";
class $d4d06657c043713f$var$V extends $d4d06657c043713f$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "prev", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "next", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "isDom", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        });
    }
    onRefresh() {
        const t = this.instance, e = t.pages.length, i = t.page;
        if (e < 2) return void this.cleanup();
        this.build();
        let n = this.prev, s = this.next;
        n && s && (n.removeAttribute($d4d06657c043713f$var$X), s.removeAttribute($d4d06657c043713f$var$X), t.isInfinite || (i <= 0 && n.setAttribute($d4d06657c043713f$var$X, ""), i >= e - 1 && s.setAttribute($d4d06657c043713f$var$X, "")));
    }
    addBtn(t) {
        var e;
        const i = this.instance, n = document.createElement("button");
        n.setAttribute("tabindex", "0"), n.setAttribute("title", i.localize(`{{${t.toUpperCase()}}}`)), $d4d06657c043713f$var$P(n, this.cn("button") + " " + this.cn(t === $d4d06657c043713f$var$q ? "isNext" : "isPrev"));
        const s = i.isRTL ? t === $d4d06657c043713f$var$q ? $d4d06657c043713f$var$Y : $d4d06657c043713f$var$q : t;
        var o;
        return n.innerHTML = i.localize(this.option(`${s}Tpl`)), n.dataset[`carousel${o = t, o ? o.match("^[a-z]") ? o.charAt(0).toUpperCase() + o.substring(1) : o : ""}`] = "true", null === (e = this.container) || void 0 === e || e.appendChild(n), n;
    }
    build() {
        const t = this.instance.container, e = this.cn("container");
        let { container: i, prev: n, next: s } = this;
        i || (i = t.querySelector("." + e), this.isDom = !!i), i || (i = document.createElement("div"), $d4d06657c043713f$var$P(i, e), t.appendChild(i)), this.container = i, s || (s = i.querySelector("[data-carousel-next]")), s || (s = this.addBtn($d4d06657c043713f$var$q)), this.next = s, n || (n = i.querySelector("[data-carousel-prev]")), n || (n = this.addBtn($d4d06657c043713f$var$Y)), this.prev = n;
    }
    cleanup() {
        this.isDom || (this.prev && this.prev.remove(), this.next && this.next.remove(), this.container && this.container.remove()), this.prev = null, this.next = null, this.container = null, this.isDom = !1;
    }
    attach() {
        this.instance.on([
            "refresh",
            "change"
        ], this.onRefresh);
    }
    detach() {
        this.instance.off([
            "refresh",
            "change"
        ], this.onRefresh), this.cleanup();
    }
}
Object.defineProperty($d4d06657c043713f$var$V, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        classes: {
            container: "f-carousel__nav",
            button: "f-button",
            isNext: "is-next",
            isPrev: "is-prev"
        },
        nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"/></svg>',
        prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"/></svg>'
    }
});
class $d4d06657c043713f$var$Z extends $d4d06657c043713f$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "selectedIndex", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "target", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "nav", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    addAsTargetFor(t) {
        this.target = this.instance, this.nav = t, this.attachEvents();
    }
    addAsNavFor(t) {
        this.nav = this.instance, this.target = t, this.attachEvents();
    }
    attachEvents() {
        const { nav: t, target: e } = this;
        t && e && (t.options.initialSlide = e.options.initialPage, t.state === $d4d06657c043713f$var$B.Ready ? this.onNavReady(t) : t.on("ready", this.onNavReady), e.state === $d4d06657c043713f$var$B.Ready ? this.onTargetReady(e) : e.on("ready", this.onTargetReady));
    }
    onNavReady(t) {
        t.on("createSlide", this.onNavCreateSlide), t.on("Panzoom.click", this.onNavClick), t.on("Panzoom.touchEnd", this.onNavTouch), this.onTargetChange();
    }
    onTargetReady(t) {
        t.on("change", this.onTargetChange), t.on("Panzoom.refresh", this.onTargetChange), this.onTargetChange();
    }
    onNavClick(t, e, i) {
        this.onNavTouch(t, t.panzoom, i);
    }
    onNavTouch(t, e, i) {
        var n, s;
        if (Math.abs(e.dragOffset.x) > 3 || Math.abs(e.dragOffset.y) > 3) return;
        const o = i.target, { nav: a, target: r } = this;
        if (!a || !r || !o) return;
        const l = o.closest("[data-index]");
        if (i.stopPropagation(), i.preventDefault(), !l) return;
        const c = parseInt(l.dataset.index || "", 10) || 0, h = r.getPageForSlide(c), d = a.getPageForSlide(c);
        a.slideTo(d), r.slideTo(h, {
            friction: (null === (s = null === (n = this.nav) || void 0 === n ? void 0 : n.plugins) || void 0 === s ? void 0 : s.Sync.option("friction")) || 0
        }), this.markSelectedSlide(c);
    }
    onNavCreateSlide(t, e) {
        e.index === this.selectedIndex && this.markSelectedSlide(e.index);
    }
    onTargetChange() {
        var t, e;
        const { target: i, nav: n } = this;
        if (!i || !n) return;
        if (n.state !== $d4d06657c043713f$var$B.Ready || i.state !== $d4d06657c043713f$var$B.Ready) return;
        const s = null === (e = null === (t = i.pages[i.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0 === e ? void 0 : e.index, o = n.getPageForSlide(s);
        this.markSelectedSlide(s), n.slideTo(o, null === n.prevPage && null === i.prevPage ? {
            friction: 0
        } : void 0);
    }
    markSelectedSlide(t) {
        const e = this.nav;
        e && e.state === $d4d06657c043713f$var$B.Ready && (this.selectedIndex = t, [
            ...e.slides
        ].map((e)=>{
            e.el && e.el.classList[e.index === t ? "add" : "remove"]("is-nav-selected");
        }));
    }
    attach() {
        const t = this;
        let e = t.options.target, i = t.options.nav;
        e ? t.addAsNavFor(e) : i && t.addAsTargetFor(i);
    }
    detach() {
        const t = this, e = t.nav, i = t.target;
        e && (e.off("ready", t.onNavReady), e.off("createSlide", t.onNavCreateSlide), e.off("Panzoom.click", t.onNavClick), e.off("Panzoom.touchEnd", t.onNavTouch)), t.nav = null, i && (i.off("ready", t.onTargetReady), i.off("refresh", t.onTargetChange), i.off("change", t.onTargetChange)), t.target = null;
    }
}
Object.defineProperty($d4d06657c043713f$var$Z, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        friction: .35
    }
});
const $d4d06657c043713f$var$U = {
    Navigation: $d4d06657c043713f$var$V,
    Dots: $d4d06657c043713f$var$W,
    Sync: $d4d06657c043713f$var$Z
}, $d4d06657c043713f$var$G = "animationend", $d4d06657c043713f$var$K = "isSelected", $d4d06657c043713f$var$J = "slide";
class $d4d06657c043713f$export$144901db2ea8e967 extends $d4d06657c043713f$var$g {
    get axis() {
        return this.isHorizontal ? "e" : "f";
    }
    get isEnabled() {
        return this.state === $d4d06657c043713f$var$B.Ready;
    }
    get isInfinite() {
        let t = !1;
        const { contentDim: e, viewportDim: i, pages: n, slides: s } = this, o = s[0];
        return n.length >= 2 && o && e + o.dim >= i && (t = this.option("infinite")), t;
    }
    get isRTL() {
        return "rtl" === this.option("direction");
    }
    get isHorizontal() {
        return "x" === this.option("axis");
    }
    constructor(t, e = {}, i = {}){
        if (super(), Object.defineProperty(this, "bp", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ""
        }), Object.defineProperty(this, "lp", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "userOptions", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "userPlugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d4d06657c043713f$var$B.Init
        }), Object.defineProperty(this, "page", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "prevPage", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "viewport", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "track", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "slides", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "pages", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "panzoom", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "inTransition", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: new Set
        }), Object.defineProperty(this, "contentDim", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "viewportDim", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), "string" == typeof t && (t = document.querySelector(t)), !t || !$d4d06657c043713f$var$E(t)) throw new Error("No Element found");
        this.container = t, this.slideNext = $d4d06657c043713f$var$D(this.slideNext.bind(this), 150), this.slidePrev = $d4d06657c043713f$var$D(this.slidePrev.bind(this), 150), this.userOptions = e, this.userPlugins = i, queueMicrotask(()=>{
            this.processOptions();
        });
    }
    processOptions() {
        var t, e;
        const i = $d4d06657c043713f$var$u({}, $d4d06657c043713f$export$144901db2ea8e967.defaults, this.userOptions);
        let n = "";
        const s = i.breakpoints;
        if (s && $d4d06657c043713f$var$d(s)) for (const [t, e] of Object.entries(s))window.matchMedia(t).matches && $d4d06657c043713f$var$d(e) && (n += t, $d4d06657c043713f$var$u(i, e));
        n === this.bp && this.state !== $d4d06657c043713f$var$B.Init || (this.bp = n, this.state === $d4d06657c043713f$var$B.Ready && (i.initialSlide = (null === (e = null === (t = this.pages[this.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0 === e ? void 0 : e.index) || 0), this.state !== $d4d06657c043713f$var$B.Init && this.destroy(), super.setOptions(i), !1 === this.option("enabled") ? this.attachEvents() : setTimeout(()=>{
            this.init();
        }, 0));
    }
    init() {
        this.state = $d4d06657c043713f$var$B.Init, this.emit("init"), this.attachPlugins(Object.assign(Object.assign({}, $d4d06657c043713f$export$144901db2ea8e967.Plugins), this.userPlugins)), this.emit("attachPlugins"), this.initLayout(), this.initSlides(), this.updateMetrics(), this.setInitialPosition(), this.initPanzoom(), this.attachEvents(), this.state = $d4d06657c043713f$var$B.Ready, this.emit("ready");
    }
    initLayout() {
        const { container: t } = this, e = this.option("classes");
        $d4d06657c043713f$var$P(t, this.cn("container")), $d4d06657c043713f$var$o(t, e.isLTR, !this.isRTL), $d4d06657c043713f$var$o(t, e.isRTL, this.isRTL), $d4d06657c043713f$var$o(t, e.isVertical, !this.isHorizontal), $d4d06657c043713f$var$o(t, e.isHorizontal, this.isHorizontal);
        let i = this.option("viewport") || t.querySelector(`.${e.viewport}`);
        i || (i = document.createElement("div"), $d4d06657c043713f$var$P(i, e.viewport), i.append(...$d4d06657c043713f$var$F(t, `.${e.slide}`)), t.prepend(i)), i.addEventListener("scroll", this.onScroll);
        let n = this.option("track") || t.querySelector(`.${e.track}`);
        n || (n = document.createElement("div"), $d4d06657c043713f$var$P(n, e.track), n.append(...Array.from(i.childNodes))), n.setAttribute("aria-live", "polite"), i.contains(n) || i.prepend(n), this.viewport = i, this.track = n, this.emit("initLayout");
    }
    initSlides() {
        const { track: t } = this;
        if (!t) return;
        const e = [
            ...this.slides
        ], i = [];
        [
            ...$d4d06657c043713f$var$F(t, `.${this.cn($d4d06657c043713f$var$J)}`)
        ].forEach((t)=>{
            if ($d4d06657c043713f$var$E(t)) {
                const e = $d4d06657c043713f$var$H({
                    el: t,
                    isDom: !0,
                    index: this.slides.length
                });
                i.push(e);
            }
        });
        for (let t of [
            ...this.option("slides", []) || [],
            ...e
        ])i.push($d4d06657c043713f$var$H(t));
        this.slides = i;
        for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
        for (const t of i)this.emit("beforeInitSlide", t, t.index), this.emit("initSlide", t, t.index);
        this.emit("initSlides");
    }
    setInitialPage() {
        const t = this.option("initialSlide");
        this.page = "number" == typeof t ? this.getPageForSlide(t) : parseInt(this.option("initialPage", 0) + "", 10) || 0;
    }
    setInitialPosition() {
        const { track: t, pages: e, isHorizontal: i } = this;
        if (!t || !e.length) return;
        let n = this.page;
        e[n] || (this.page = n = 0);
        const s = (e[n].pos || 0) * (this.isRTL && i ? 1 : -1), o = i ? `${s}px` : "0", a = i ? "0" : `${s}px`;
        t.style.transform = `translate3d(${o}, ${a}, 0) scale(1)`, this.option("adaptiveHeight") && this.setViewportHeight();
    }
    initPanzoom() {
        this.panzoom && (this.panzoom.destroy(), this.panzoom = null);
        const t = this.option("Panzoom") || {};
        this.panzoom = new $d4d06657c043713f$export$b704d075ddd20210(this.viewport, $d4d06657c043713f$var$u({}, {
            content: this.track,
            zoom: !1,
            panOnlyZoomed: !1,
            lockAxis: this.isHorizontal ? "x" : "y",
            infinite: this.isInfinite,
            click: !1,
            dblClick: !1,
            touch: (t)=>!(this.pages.length < 2 && !t.options.infinite),
            bounds: ()=>this.getBounds(),
            maxVelocity: (t)=>Math.abs(t.target[this.axis] - t.current[this.axis]) < 2 * this.viewportDim ? 100 : 0
        }, t)), this.panzoom.on("*", (t, e, ...i)=>{
            this.emit(`Panzoom.${e}`, t, ...i);
        }), this.panzoom.on("decel", this.onDecel), this.panzoom.on("refresh", this.onRefresh), this.panzoom.on("beforeTransform", this.onBeforeTransform), this.panzoom.on("endAnimation", this.onEndAnimation);
    }
    attachEvents() {
        const t = this.container;
        t && (t.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.addEventListener("slideTo", this.onSlideTo)), window.addEventListener("resize", this.onResize);
    }
    createPages() {
        let t = [];
        const { contentDim: e, viewportDim: i } = this;
        let n = this.option("slidesPerPage");
        n = ("auto" === n || e <= i) && !1 !== this.option("fill") ? 1 / 0 : parseFloat(n + "");
        let s = 0, o = 0, a = 0;
        for (const e of this.slides)(!t.length || o + e.dim - i > .05 || a >= n) && (t.push($d4d06657c043713f$var$N()), s = t.length - 1, o = 0, a = 0), t[s].slides.push(e), o += e.dim + e.gap, a++;
        return t;
    }
    processPages() {
        const e = this.pages, { contentDim: i, viewportDim: n, isInfinite: s } = this, o = this.option("center"), a = this.option("fill"), r = a && o && i > n && !s;
        if (e.forEach((t, e)=>{
            var s;
            t.index = e, t.pos = (null === (s = t.slides[0]) || void 0 === s ? void 0 : s.pos) || 0, t.dim = 0;
            for (const [e, i] of t.slides.entries())t.dim += i.dim, e < t.slides.length - 1 && (t.dim += i.gap);
            r && t.pos + .5 * t.dim < .5 * n ? t.pos = 0 : r && t.pos + .5 * t.dim >= i - .5 * n ? t.pos = i - n : o && (t.pos += -0.5 * (n - t.dim));
        }), e.forEach((e)=>{
            a && !s && i > n && (e.pos = Math.max(e.pos, 0), e.pos = Math.min(e.pos, i - n)), e.pos = $d4d06657c043713f$var$t(e.pos, 1e3), e.dim = $d4d06657c043713f$var$t(e.dim, 1e3), Math.abs(e.pos) <= .1 && (e.pos = 0);
        }), s) return e;
        const l = [];
        let c;
        return e.forEach((t)=>{
            const e = Object.assign({}, t);
            c && e.pos === c.pos ? (c.dim += e.dim, c.slides = [
                ...c.slides,
                ...e.slides
            ]) : (e.index = l.length, c = e, l.push(e));
        }), l;
    }
    getPageFromIndex(t = 0) {
        const e = this.pages.length;
        let i;
        return t = parseInt((t || 0).toString()) || 0, i = this.isInfinite ? (t % e + e) % e : Math.max(Math.min(t, e - 1), 0), i;
    }
    getSlideMetrics(e) {
        var i, n;
        const s = this.isHorizontal ? "width" : "height";
        let o = 0, a = 0, r = e.el;
        const l = !(!r || r.parentNode);
        if (r ? o = parseFloat(r.dataset[s] || "") || 0 : (r = document.createElement("div"), r.style.visibility = "hidden", (this.track || document.body).prepend(r)), $d4d06657c043713f$var$P(r, this.cn($d4d06657c043713f$var$J) + " " + e.class + " " + e.customClass), o) r.style[s] = `${o}px`, r.style["width" === s ? "height" : "width"] = "";
        else {
            l && (this.track || document.body).prepend(r), o = r.getBoundingClientRect()[s] * Math.max(1, (null === (i = window.visualViewport) || void 0 === i ? void 0 : i.scale) || 1);
            let t = r[this.isHorizontal ? "offsetWidth" : "offsetHeight"];
            t - 1 > o && (o = t);
        }
        const c = getComputedStyle(r);
        return "content-box" === c.boxSizing && (this.isHorizontal ? (o += parseFloat(c.paddingLeft) || 0, o += parseFloat(c.paddingRight) || 0) : (o += parseFloat(c.paddingTop) || 0, o += parseFloat(c.paddingBottom) || 0)), a = parseFloat(c[this.isHorizontal ? "marginRight" : "marginBottom"]) || 0, l ? null === (n = r.parentElement) || void 0 === n || n.removeChild(r) : e.el || r.remove(), {
            dim: $d4d06657c043713f$var$t(o, 1e3),
            gap: $d4d06657c043713f$var$t(a, 1e3)
        };
    }
    getBounds() {
        const { isInfinite: t, isRTL: e, isHorizontal: i, pages: n } = this;
        let s = {
            min: 0,
            max: 0
        };
        if (t) s = {
            min: -1 / 0,
            max: 1 / 0
        };
        else if (n.length) {
            const t = n[0].pos, o = n[n.length - 1].pos;
            s = e && i ? {
                min: t,
                max: o
            } : {
                min: -1 * o,
                max: -1 * t
            };
        }
        return {
            x: i ? s : {
                min: 0,
                max: 0
            },
            y: i ? {
                min: 0,
                max: 0
            } : s
        };
    }
    repositionSlides() {
        let e, { isHorizontal: i, isRTL: n, isInfinite: s, viewport: o, viewportDim: a, contentDim: r, page: l, pages: c, slides: h, panzoom: d } = this, u = 0, p = 0, f = 0, g = 0;
        d ? g = -1 * d.current[this.axis] : c[l] && (g = c[l].pos || 0), e = i ? n ? "right" : "left" : "top", n && i && (g *= -1);
        for (const i of h){
            const n = i.el;
            n ? ("top" === e ? (n.style.right = "", n.style.left = "") : n.style.top = "", i.index !== u ? n.style[e] = 0 === p ? "" : `${$d4d06657c043713f$var$t(p, 1e3)}px` : n.style[e] = "", f += i.dim + i.gap, u++) : p += i.dim + i.gap;
        }
        if (s && f && o) {
            let n = getComputedStyle(o), s = "padding", l = i ? "Right" : "Bottom", c = parseFloat(n[s + (i ? "Left" : "Top")]);
            g -= c, a += c, a += parseFloat(n[s + l]);
            for (const i of h)i.el && ($d4d06657c043713f$var$t(i.pos) < $d4d06657c043713f$var$t(a) && $d4d06657c043713f$var$t(i.pos + i.dim + i.gap) < $d4d06657c043713f$var$t(g) && $d4d06657c043713f$var$t(g) > $d4d06657c043713f$var$t(r - a) && (i.el.style[e] = `${$d4d06657c043713f$var$t(p + f, 1e3)}px`), $d4d06657c043713f$var$t(i.pos + i.gap) >= $d4d06657c043713f$var$t(r - a) && $d4d06657c043713f$var$t(i.pos) > $d4d06657c043713f$var$t(g + a) && $d4d06657c043713f$var$t(g) < $d4d06657c043713f$var$t(a) && (i.el.style[e] = `-${$d4d06657c043713f$var$t(f, 1e3)}px`));
        }
        let m, v, b = [
            ...this.inTransition
        ];
        if (b.length > 1 && (m = c[b[0]], v = c[b[1]]), m && v) {
            let i = 0;
            for (const n of h)n.el ? this.inTransition.has(n.index) && m.slides.indexOf(n) < 0 && (n.el.style[e] = `${$d4d06657c043713f$var$t(i + (m.pos - v.pos), 1e3)}px`) : i += n.dim + n.gap;
        }
    }
    createSlideEl(t) {
        const { track: e, slides: i } = this;
        if (!e || !t) return;
        if (t.el && t.el.parentNode) return;
        const n = t.el || document.createElement("div");
        $d4d06657c043713f$var$P(n, this.cn($d4d06657c043713f$var$J)), $d4d06657c043713f$var$P(n, t.class), $d4d06657c043713f$var$P(n, t.customClass);
        const s = t.html;
        s && (s instanceof HTMLElement ? n.appendChild(s) : n.innerHTML = t.html + "");
        const o = [];
        i.forEach((t, e)=>{
            t.el && o.push(e);
        });
        const a = t.index;
        let r = null;
        if (o.length) r = i[o.reduce((t, e)=>Math.abs(e - a) < Math.abs(t - a) ? e : t)];
        const l = r && r.el && r.el.parentNode ? r.index < t.index ? r.el.nextSibling : r.el : null;
        e.insertBefore(n, e.contains(l) ? l : null), t.el = n, this.emit("createSlide", t);
    }
    removeSlideEl(t, e = !1) {
        const i = null == t ? void 0 : t.el;
        if (!i || !i.parentNode) return;
        const n = this.cn($d4d06657c043713f$var$K);
        if (i.classList.contains(n) && ($d4d06657c043713f$var$S(i, n), this.emit("unselectSlide", t)), t.isDom && !e) return i.removeAttribute("aria-hidden"), i.removeAttribute("data-index"), void (i.style.left = "");
        this.emit("removeSlide", t);
        const s = new CustomEvent($d4d06657c043713f$var$G);
        i.dispatchEvent(s), t.el && (t.el.remove(), t.el = null);
    }
    transitionTo(t = 0, e = this.option("transition")) {
        var i, n, s, o;
        if (!e) return !1;
        const a = this.page, { pages: r, panzoom: l } = this;
        t = parseInt((t || 0).toString()) || 0;
        const c = this.getPageFromIndex(t);
        if (!l || !r[c] || r.length < 2 || Math.abs(((null === (n = null === (i = r[a]) || void 0 === i ? void 0 : i.slides[0]) || void 0 === n ? void 0 : n.dim) || 0) - this.viewportDim) > 1) return !1;
        let h = t > a ? 1 : -1;
        this.isInfinite && (0 === a && t === r.length - 1 && (h = -1), a === r.length - 1 && 0 === t && (h = 1));
        const d = r[c].pos * (this.isRTL ? 1 : -1);
        if (a === c && Math.abs(d - l.target[this.axis]) < 1) return !1;
        this.clearTransitions();
        const u = l.isResting;
        $d4d06657c043713f$var$P(this.container, this.cn("inTransition"));
        const p = (null === (s = r[a]) || void 0 === s ? void 0 : s.slides[0]) || null, f = (null === (o = r[c]) || void 0 === o ? void 0 : o.slides[0]) || null;
        this.inTransition.add(f.index), this.createSlideEl(f);
        let g = p.el, m = f.el;
        u || e === $d4d06657c043713f$var$J || (e = "fadeFast", g = null);
        const v = this.isRTL ? "next" : "prev", b = this.isRTL ? "prev" : "next";
        return g && (this.inTransition.add(p.index), p.transition = e, g.addEventListener($d4d06657c043713f$var$G, this.onAnimationEnd), g.classList.add(`f-${e}Out`, `to-${h > 0 ? b : v}`)), m && (f.transition = e, m.addEventListener($d4d06657c043713f$var$G, this.onAnimationEnd), m.classList.add(`f-${e}In`, `from-${h > 0 ? v : b}`)), l.current[this.axis] = d, l.target[this.axis] = d, l.requestTick(), this.onChange(c), !0;
    }
    manageSlideVisiblity() {
        const t = new Set, e = new Set, i = this.getVisibleSlides(parseFloat(this.option("preload", 0) + "") || 0);
        for (const n of this.slides)i.has(n) ? t.add(n) : e.add(n);
        for (const e of this.inTransition)t.add(this.slides[e]);
        for (const e of t)this.createSlideEl(e), this.lazyLoadSlide(e);
        for (const i of e)t.has(i) || this.removeSlideEl(i);
        this.markSelectedSlides(), this.repositionSlides();
    }
    markSelectedSlides() {
        if (!this.pages[this.page] || !this.pages[this.page].slides) return;
        const t = "aria-hidden";
        let e = this.cn($d4d06657c043713f$var$K);
        if (e) for (const i of this.slides){
            const n = i.el;
            n && (n.dataset.index = `${i.index}`, n.classList.contains("f-thumbs__slide") ? this.getVisibleSlides(0).has(i) ? n.removeAttribute(t) : n.setAttribute(t, "true") : this.pages[this.page].slides.includes(i) ? (n.classList.contains(e) || ($d4d06657c043713f$var$P(n, e), this.emit("selectSlide", i)), n.removeAttribute(t)) : (n.classList.contains(e) && ($d4d06657c043713f$var$S(n, e), this.emit("unselectSlide", i)), n.setAttribute(t, "true")));
        }
    }
    flipInfiniteTrack() {
        const { axis: t, isHorizontal: e, isInfinite: i, isRTL: n, viewportDim: s, contentDim: o } = this, a = this.panzoom;
        if (!a || !i) return;
        let r = a.current[t], l = a.target[t] - r, c = 0, h = .5 * s;
        n && e ? (r < -h && (c = -1, r += o), r > o - h && (c = 1, r -= o)) : (r > h && (c = 1, r -= o), r < -o + h && (c = -1, r += o)), c && (a.current[t] = r, a.target[t] = r + l);
    }
    lazyLoadImg(t, e) {
        const i = this, s = "f-fadeIn", o = "is-preloading";
        let a = !1, r = null;
        const l = ()=>{
            a || (a = !0, r && (r.remove(), r = null), $d4d06657c043713f$var$S(e, o), e.complete && ($d4d06657c043713f$var$P(e, s), setTimeout(()=>{
                $d4d06657c043713f$var$S(e, s);
            }, 350)), this.option("adaptiveHeight") && t.el && this.pages[this.page].slides.indexOf(t) > -1 && (i.updateMetrics(), i.setViewportHeight()), this.emit("load", t));
        };
        $d4d06657c043713f$var$P(e, o), e.src = e.dataset.lazySrcset || e.dataset.lazySrc || "", delete e.dataset.lazySrc, delete e.dataset.lazySrcset, e.addEventListener("error", ()=>{
            l();
        }), e.addEventListener("load", ()=>{
            l();
        }), setTimeout(()=>{
            const i = e.parentNode;
            i && t.el && (e.complete ? l() : a || (r = $d4d06657c043713f$var$n($d4d06657c043713f$var$x), i.insertBefore(r, e)));
        }, 300);
    }
    lazyLoadSlide(t) {
        const e = t && t.el;
        if (!e) return;
        const i = new Set;
        let n = Array.from(e.querySelectorAll("[data-lazy-src],[data-lazy-srcset]"));
        e.dataset.lazySrc && n.push(e), n.map((t)=>{
            t instanceof HTMLImageElement ? i.add(t) : t instanceof HTMLElement && t.dataset.lazySrc && (t.style.backgroundImage = `url('${t.dataset.lazySrc}')`, delete t.dataset.lazySrc);
        });
        for (const e of i)this.lazyLoadImg(t, e);
    }
    onAnimationEnd(t) {
        var e;
        const i = t.target, n = i ? parseInt(i.dataset.index || "", 10) || 0 : -1, s = this.slides[n], o = t.animationName;
        if (!i || !s || !o) return;
        const a = !!this.inTransition.has(n) && s.transition;
        a && o.substring(0, a.length + 2) === `f-${a}` && this.inTransition.delete(n), this.inTransition.size || this.clearTransitions(), n === this.page && (null === (e = this.panzoom) || void 0 === e ? void 0 : e.isResting) && this.emit("settle");
    }
    onDecel(t, e = 0, i = 0, n = 0, s = 0) {
        if (this.option("dragFree")) return void this.setPageFromPosition();
        const { isRTL: o, isHorizontal: a, axis: r, pages: l } = this, c = l.length, h = Math.abs(Math.atan2(i, e) / (Math.PI / 180));
        let d = 0;
        if (d = h > 45 && h < 135 ? a ? 0 : i : a ? e : 0, !c) return;
        let u = this.page, p = o && a ? 1 : -1;
        const f = t.current[r] * p;
        let { pageIndex: g } = this.getPageFromPosition(f);
        Math.abs(d) > 5 ? (l[u].dim < document.documentElement["client" + (this.isHorizontal ? "Width" : "Height")] - 1 && (u = g), u = o && a ? d < 0 ? u - 1 : u + 1 : d < 0 ? u + 1 : u - 1) : u = 0 === n && 0 === s ? u : g, this.slideTo(u, {
            transition: !1,
            friction: t.option("decelFriction")
        });
    }
    onClick(t) {
        const e = t.target, i = e && $d4d06657c043713f$var$E(e) ? e.dataset : null;
        let n, s;
        i && (void 0 !== i.carouselPage ? (s = "slideTo", n = i.carouselPage) : void 0 !== i.carouselNext ? s = "slideNext" : void 0 !== i.carouselPrev && (s = "slidePrev")), s ? (t.preventDefault(), t.stopPropagation(), e && !e.hasAttribute("disabled") && this[s](n)) : this.emit("click", t);
    }
    onSlideTo(t) {
        const e = t.detail || 0;
        this.slideTo(this.getPageForSlide(e), {
            friction: 0
        });
    }
    onChange(t, e = 0) {
        const i = this.page;
        this.prevPage = i, this.page = t, this.option("adaptiveHeight") && this.setViewportHeight(), t !== i && (this.markSelectedSlides(), this.emit("change", t, i, e));
    }
    onRefresh() {
        let t = this.contentDim, e = this.viewportDim;
        this.updateMetrics(), this.contentDim === t && this.viewportDim === e || this.slideTo(this.page, {
            friction: 0,
            transition: !1
        });
    }
    onScroll() {
        var t;
        null === (t = this.viewport) || void 0 === t || t.scroll(0, 0);
    }
    onResize() {
        this.option("breakpoints") && this.processOptions();
    }
    onBeforeTransform(t) {
        this.lp !== t.current[this.axis] && (this.flipInfiniteTrack(), this.manageSlideVisiblity()), this.lp = t.current.e;
    }
    onEndAnimation() {
        this.inTransition.size || this.emit("settle");
    }
    reInit(t = null, e = null) {
        this.destroy(), this.state = $d4d06657c043713f$var$B.Init, this.prevPage = null, this.userOptions = t || this.userOptions, this.userPlugins = e || this.userPlugins, this.processOptions();
    }
    slideTo(t = 0, { friction: e = this.option("friction"), transition: i = this.option("transition") } = {}) {
        if (this.state === $d4d06657c043713f$var$B.Destroy) return;
        t = parseInt((t || 0).toString()) || 0;
        const n = this.getPageFromIndex(t), { axis: s, isHorizontal: o, isRTL: a, pages: r, panzoom: l } = this, c = r.length, h = a && o ? 1 : -1;
        if (!l || !c) return;
        if (this.page !== n) {
            const e = new Event("beforeChange", {
                bubbles: !0,
                cancelable: !0
            });
            if (this.emit("beforeChange", e, t), e.defaultPrevented) return;
        }
        if (this.transitionTo(t, i)) return;
        let d = r[n].pos;
        if (this.isInfinite) {
            const e = this.contentDim, i = l.target[s] * h;
            if (2 === c) d += e * Math.floor(parseFloat(t + "") / 2);
            else d = [
                d,
                d - e,
                d + e
            ].reduce(function(t, e) {
                return Math.abs(e - i) < Math.abs(t - i) ? e : t;
            });
        }
        d *= h, Math.abs(l.target[s] - d) < 1 || (l.panTo({
            x: o ? d : 0,
            y: o ? 0 : d,
            friction: e
        }), this.onChange(n));
    }
    slideToClosest(t) {
        if (this.panzoom) {
            const { pageIndex: e } = this.getPageFromPosition();
            this.slideTo(e, t);
        }
    }
    slideNext() {
        this.slideTo(this.page + 1);
    }
    slidePrev() {
        this.slideTo(this.page - 1);
    }
    clearTransitions() {
        this.inTransition.clear(), $d4d06657c043713f$var$S(this.container, this.cn("inTransition"));
        const t = [
            "to-prev",
            "to-next",
            "from-prev",
            "from-next"
        ];
        for (const e of this.slides){
            const i = e.el;
            if (i) {
                i.removeEventListener($d4d06657c043713f$var$G, this.onAnimationEnd), i.classList.remove(...t);
                const n = e.transition;
                n && i.classList.remove(`f-${n}Out`, `f-${n}In`);
            }
        }
        this.manageSlideVisiblity();
    }
    addSlide(t, e) {
        var i, n, s, o;
        const a = this.panzoom, r = (null === (i = this.pages[this.page]) || void 0 === i ? void 0 : i.pos) || 0, l = (null === (n = this.pages[this.page]) || void 0 === n ? void 0 : n.dim) || 0, c = this.contentDim < this.viewportDim;
        let h = Array.isArray(e) ? e : [
            e
        ];
        const d = [];
        for (const t of h)d.push($d4d06657c043713f$var$H(t));
        this.slides.splice(t, 0, ...d);
        for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
        for (const t of d)this.emit("beforeInitSlide", t, t.index);
        if (this.page >= t && (this.page += d.length), this.updateMetrics(), a) {
            const e = (null === (s = this.pages[this.page]) || void 0 === s ? void 0 : s.pos) || 0, i = (null === (o = this.pages[this.page]) || void 0 === o ? void 0 : o.dim) || 0, n = this.pages.length || 1, h = this.isRTL ? l - i : i - l, d = this.isRTL ? r - e : e - r;
            c && 1 === n ? (t <= this.page && (a.current[this.axis] -= h, a.target[this.axis] -= h), a.panTo({
                [this.isHorizontal ? "x" : "y"]: -1 * e
            })) : d && t <= this.page && (a.target[this.axis] -= d, a.current[this.axis] -= d, a.requestTick());
        }
        for (const t of d)this.emit("initSlide", t, t.index);
    }
    prependSlide(t) {
        this.addSlide(0, t);
    }
    appendSlide(t) {
        this.addSlide(this.slides.length, t);
    }
    removeSlide(t) {
        const e = this.slides.length;
        t = (t % e + e) % e;
        const i = this.slides[t];
        if (i) {
            this.removeSlideEl(i, !0), this.slides.splice(t, 1);
            for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
            this.updateMetrics(), this.slideTo(this.page, {
                friction: 0,
                transition: !1
            }), this.emit("destroySlide", i);
        }
    }
    updateMetrics() {
        const { panzoom: e, viewport: i, track: n, slides: s, isHorizontal: o, isInfinite: a } = this;
        if (!n) return;
        const r = o ? "width" : "height", l = o ? "offsetWidth" : "offsetHeight";
        if (i) {
            let e = Math.max(i[l], $d4d06657c043713f$var$t(i.getBoundingClientRect()[r], 1e3)), n = getComputedStyle(i), s = "padding", a = o ? "Right" : "Bottom";
            e -= parseFloat(n[s + (o ? "Left" : "Top")]) + parseFloat(n[s + a]), this.viewportDim = e;
        }
        let c, h = 0;
        for (const [e, i] of s.entries()){
            let n = 0, o = 0;
            !i.el && c ? (n = c.dim, o = c.gap) : ({ dim: n, gap: o } = this.getSlideMetrics(i), c = i), n = $d4d06657c043713f$var$t(n, 1e3), o = $d4d06657c043713f$var$t(o, 1e3), i.dim = n, i.gap = o, i.pos = h, h += n, (a || e < s.length - 1) && (h += o);
        }
        h = $d4d06657c043713f$var$t(h, 1e3), this.contentDim = h, e && (e.contentRect[r] = h, e.contentRect[o ? "fullWidth" : "fullHeight"] = h), this.pages = this.createPages(), this.pages = this.processPages(), this.state === $d4d06657c043713f$var$B.Init && this.setInitialPage(), this.page = Math.max(0, Math.min(this.page, this.pages.length - 1)), this.manageSlideVisiblity(), this.emit("refresh");
    }
    getProgress(e, i = !1, n = !1) {
        void 0 === e && (e = this.page);
        const s = this, o = s.panzoom, a = s.contentDim, r = s.pages[e] || 0;
        if (!r || !o) return e > this.page ? -1 : 1;
        let l = -1 * o.current.e, c = $d4d06657c043713f$var$t((l - r.pos) / (1 * r.dim), 1e3), h = c, d = c;
        this.isInfinite && !0 !== n && (h = $d4d06657c043713f$var$t((l - r.pos + a) / (1 * r.dim), 1e3), d = $d4d06657c043713f$var$t((l - r.pos - a) / (1 * r.dim), 1e3));
        let u = [
            c,
            h,
            d
        ].reduce(function(t, e) {
            return Math.abs(e) < Math.abs(t) ? e : t;
        });
        return i ? u : u > 1 ? 1 : u < -1 ? -1 : u;
    }
    setViewportHeight() {
        const { page: t, pages: e, viewport: i, isHorizontal: n } = this;
        if (!i || !e[t]) return;
        let s = 0;
        n && this.track && (this.track.style.height = "auto", e[t].slides.forEach((t)=>{
            t.el && (s = Math.max(s, t.el.offsetHeight));
        })), i.style.height = s ? `${s}px` : "";
    }
    getPageForSlide(t) {
        for (const e of this.pages)for (const i of e.slides)if (i.index === t) return e.index;
        return -1;
    }
    getVisibleSlides(t = 0) {
        var e;
        const i = new Set;
        let { panzoom: n, contentDim: s, viewportDim: o, pages: a, page: r } = this;
        if (o) {
            s = s + (null === (e = this.slides[this.slides.length - 1]) || void 0 === e ? void 0 : e.gap) || 0;
            let l = 0;
            l = n && n.state !== $d4d06657c043713f$var$m.Init && n.state !== $d4d06657c043713f$var$m.Destroy ? -1 * n.current[this.axis] : a[r] && a[r].pos || 0, this.isInfinite && (l -= Math.floor(l / s) * s), this.isRTL && this.isHorizontal && (l *= -1);
            const c = l - o * t, h = l + o * (t + 1), d = this.isInfinite ? [
                -1,
                0,
                1
            ] : [
                0
            ];
            for (const t of this.slides)for (const e of d){
                const n = t.pos + e * s, o = n + t.dim + t.gap;
                n < h && o > c && i.add(t);
            }
        }
        return i;
    }
    getPageFromPosition(t) {
        const { viewportDim: e, contentDim: i, slides: n, pages: s, panzoom: o } = this, a = s.length, r = n.length, l = n[0], c = n[r - 1], h = this.option("center");
        let d = 0, u = 0, p = 0, f = void 0 === t ? -1 * ((null == o ? void 0 : o.target[this.axis]) || 0) : t;
        h && (f += .5 * e), this.isInfinite ? (f < l.pos - .5 * c.gap && (f -= i, p = -1), f > c.pos + c.dim + .5 * c.gap && (f -= i, p = 1)) : f = Math.max(l.pos || 0, Math.min(f, c.pos));
        let g = c, m = n.find((t)=>{
            const e = t.pos - .5 * g.gap, i = t.pos + t.dim + .5 * t.gap;
            return g = t, f >= e && f < i;
        });
        return m || (m = c), u = this.getPageForSlide(m.index), d = u + p * a, {
            page: d,
            pageIndex: u
        };
    }
    setPageFromPosition() {
        const { pageIndex: t } = this.getPageFromPosition();
        this.onChange(t);
    }
    destroy() {
        if ([
            $d4d06657c043713f$var$B.Destroy
        ].includes(this.state)) return;
        this.state = $d4d06657c043713f$var$B.Destroy;
        const { container: t, viewport: e, track: i, slides: n, panzoom: s } = this, o = this.option("classes");
        t.removeEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.removeEventListener("slideTo", this.onSlideTo), window.removeEventListener("resize", this.onResize), s && (s.destroy(), this.panzoom = null), n && n.forEach((t)=>{
            this.removeSlideEl(t);
        }), this.detachPlugins(), e && (e.removeEventListener("scroll", this.onScroll), e.offsetParent && i && i.offsetParent && e.replaceWith(...i.childNodes));
        for (const [e, i] of Object.entries(o))"container" !== e && i && t.classList.remove(i);
        this.track = null, this.viewport = null, this.page = 0, this.slides = [];
        const a = this.events.get("ready");
        this.events = new Map, a && this.events.set("ready", a);
    }
}
Object.defineProperty($d4d06657c043713f$export$144901db2ea8e967, "Panzoom", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$export$b704d075ddd20210
}), Object.defineProperty($d4d06657c043713f$export$144901db2ea8e967, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$j
}), Object.defineProperty($d4d06657c043713f$export$144901db2ea8e967, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$U
});
const $d4d06657c043713f$var$tt = function(t) {
    if (!$d4d06657c043713f$var$E(t)) return 0;
    const e = window.scrollY, i = window.innerHeight, n = e + i, s = t.getBoundingClientRect(), o = s.y + e, a = s.height, r = o + a;
    if (e > r || n < o) return 0;
    if (e < o && n > r) return 100;
    if (o < e && r > n) return 100;
    let l = a;
    o < e && (l -= e - o), r > n && (l -= r - n);
    const c = l / i * 100;
    return Math.round(c);
}, $d4d06657c043713f$var$et = !("undefined" == typeof window || !window.document || !window.document.createElement);
let $d4d06657c043713f$var$it;
const $d4d06657c043713f$var$nt = [
    "a[href]",
    "area[href]",
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    "select:not([disabled]):not([aria-hidden])",
    "textarea:not([disabled]):not([aria-hidden])",
    "button:not([disabled]):not([aria-hidden]):not(.fancybox-focus-guard)",
    "iframe",
    "object",
    "embed",
    "video",
    "audio",
    "[contenteditable]",
    '[tabindex]:not([tabindex^="-"]):not([disabled]):not([aria-hidden])'
].join(","), $d4d06657c043713f$var$st = (t)=>{
    if (t && $d4d06657c043713f$var$et) {
        void 0 === $d4d06657c043713f$var$it && document.createElement("div").focus({
            get preventScroll () {
                return $d4d06657c043713f$var$it = !0, !1;
            }
        });
        try {
            if ($d4d06657c043713f$var$it) t.focus({
                preventScroll: !0
            });
            else {
                const e = window.scrollY || document.body.scrollTop, i = window.scrollX || document.body.scrollLeft;
                t.focus(), document.body.scrollTo({
                    top: e,
                    left: i,
                    behavior: "auto"
                });
            }
        } catch (t) {}
    }
}, $d4d06657c043713f$var$ot = ()=>{
    const t = document;
    let e, i = "", n = "", s = "";
    return t.fullscreenEnabled ? (i = "requestFullscreen", n = "exitFullscreen", s = "fullscreenElement") : t.webkitFullscreenEnabled && (i = "webkitRequestFullscreen", n = "webkitExitFullscreen", s = "webkitFullscreenElement"), i && (e = {
        request: function(e = t.documentElement) {
            return "webkitRequestFullscreen" === i ? e[i](Element.ALLOW_KEYBOARD_INPUT) : e[i]();
        },
        exit: function() {
            return t[s] && t[n]();
        },
        isFullscreen: function() {
            return t[s];
        }
    }), e;
}, $d4d06657c043713f$var$at = {
    animated: !0,
    autoFocus: !0,
    backdropClick: "close",
    Carousel: {
        classes: {
            container: "fancybox__carousel",
            viewport: "fancybox__viewport",
            track: "fancybox__track",
            slide: "fancybox__slide"
        }
    },
    closeButton: "auto",
    closeExisting: !1,
    commonCaption: !1,
    compact: ()=>window.matchMedia("(max-width: 578px), (max-height: 578px)").matches,
    contentClick: "toggleZoom",
    contentDblClick: !1,
    defaultType: "image",
    defaultDisplay: "flex",
    dragToClose: !0,
    Fullscreen: {
        autoStart: !1
    },
    groupAll: !1,
    groupAttr: "data-fancybox",
    hideClass: "f-fadeOut",
    hideScrollbar: !0,
    idle: 3500,
    keyboard: {
        Escape: "close",
        Delete: "close",
        Backspace: "close",
        PageUp: "next",
        PageDown: "prev",
        ArrowUp: "prev",
        ArrowDown: "next",
        ArrowRight: "next",
        ArrowLeft: "prev"
    },
    l10n: Object.assign(Object.assign({}, $d4d06657c043713f$var$b), {
        CLOSE: "Close",
        NEXT: "Next",
        PREV: "Previous",
        MODAL: "You can close this modal content with the ESC key",
        ERROR: "Something Went Wrong, Please Try Again Later",
        IMAGE_ERROR: "Image Not Found",
        ELEMENT_NOT_FOUND: "HTML Element Not Found",
        AJAX_NOT_FOUND: "Error Loading AJAX : Not Found",
        AJAX_FORBIDDEN: "Error Loading AJAX : Forbidden",
        IFRAME_ERROR: "Error Loading Page",
        TOGGLE_ZOOM: "Toggle zoom level",
        TOGGLE_THUMBS: "Toggle thumbnails",
        TOGGLE_SLIDESHOW: "Toggle slideshow",
        TOGGLE_FULLSCREEN: "Toggle full-screen mode",
        DOWNLOAD: "Download"
    }),
    parentEl: null,
    placeFocusBack: !0,
    showClass: "f-zoomInUp",
    startIndex: 0,
    tpl: {
        closeButton: '<button data-fancybox-close class="f-button is-close-btn" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"/></svg></button>',
        main: '<div class="fancybox__container" role="dialog" aria-modal="true" aria-label="{{MODAL}}" tabindex="-1">\n    <div class="fancybox__backdrop"></div>\n    <div class="fancybox__carousel"></div>\n    <div class="fancybox__footer"></div>\n  </div>'
    },
    trapFocus: !0,
    wheel: "zoom"
};
var $d4d06657c043713f$var$rt, $d4d06657c043713f$var$lt;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Closing = 2] = "Closing", t[t.CustomClosing = 3] = "CustomClosing", t[t.Destroy = 4] = "Destroy";
}($d4d06657c043713f$var$rt || ($d4d06657c043713f$var$rt = {})), function(t) {
    t[t.Loading = 0] = "Loading", t[t.Opening = 1] = "Opening", t[t.Ready = 2] = "Ready", t[t.Closing = 3] = "Closing";
}($d4d06657c043713f$var$lt || ($d4d06657c043713f$var$lt = {}));
let $d4d06657c043713f$var$ct = "", $d4d06657c043713f$var$ht = !1, $d4d06657c043713f$var$dt = !1, $d4d06657c043713f$var$ut = null;
const $d4d06657c043713f$var$pt = ()=>{
    let t = "", e = "";
    const i = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance();
    if (i) {
        const n = i.carousel, s = i.getSlide();
        if (n && s) {
            let o = s.slug || void 0, a = s.triggerEl || void 0;
            e = o || i.option("slug") || "", !e && a && a.dataset && (e = a.dataset.fancybox || ""), e && "true" !== e && (t = "#" + e + (!o && n.slides.length > 1 ? "-" + (s.index + 1) : ""));
        }
    }
    return {
        hash: t,
        slug: e,
        index: 1
    };
}, $d4d06657c043713f$var$ft = ()=>{
    const t = new URL(document.URL).hash, e = t.slice(1).split("-"), i = e[e.length - 1], n = i && /^\+?\d+$/.test(i) && parseInt(e.pop() || "1", 10) || 1;
    return {
        hash: t,
        slug: e.join("-"),
        index: n
    };
}, $d4d06657c043713f$var$gt = ()=>{
    const { slug: t, index: e } = $d4d06657c043713f$var$ft();
    if (!t) return;
    let i = document.querySelector(`[data-slug="${t}"]`);
    if (i && i.dispatchEvent(new CustomEvent("click", {
        bubbles: !0,
        cancelable: !0
    })), $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance()) return;
    const n = document.querySelectorAll(`[data-fancybox="${t}"]`);
    n.length && (i = n[e - 1], i && i.dispatchEvent(new CustomEvent("click", {
        bubbles: !0,
        cancelable: !0
    })));
}, $d4d06657c043713f$var$mt = ()=>{
    if (!1 === $d4d06657c043713f$export$cb45b08d97cdc4fd.defaults.Hash) return;
    const t = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance();
    if (!1 === (null == t ? void 0 : t.options.Hash)) return;
    const { slug: e, index: i } = $d4d06657c043713f$var$ft(), { slug: n } = $d4d06657c043713f$var$pt();
    t && (e === n ? t.jumpTo(i - 1) : ($d4d06657c043713f$var$ht = !0, t.close())), $d4d06657c043713f$var$gt();
}, $d4d06657c043713f$var$vt = ()=>{
    $d4d06657c043713f$var$ut && clearTimeout($d4d06657c043713f$var$ut), queueMicrotask(()=>{
        $d4d06657c043713f$var$mt();
    });
}, $d4d06657c043713f$var$bt = ()=>{
    window.addEventListener("hashchange", $d4d06657c043713f$var$vt, !1), setTimeout(()=>{
        $d4d06657c043713f$var$mt();
    }, 500);
};
$d4d06657c043713f$var$et && (/complete|interactive|loaded/.test(document.readyState) ? $d4d06657c043713f$var$bt() : document.addEventListener("DOMContentLoaded", $d4d06657c043713f$var$bt));
const $d4d06657c043713f$var$yt = "is-zooming-in";
class $d4d06657c043713f$var$wt extends $d4d06657c043713f$var$_ {
    onCreateSlide(t, e, i) {
        const n = this.instance.optionFor(i, "src") || "";
        i.el && "image" === i.type && "string" == typeof n && this.setImage(i, n);
    }
    onRemoveSlide(t, e, i) {
        i.panzoom && i.panzoom.destroy(), i.panzoom = void 0, i.imageEl = void 0;
    }
    onChange(t, e, i, n) {
        $d4d06657c043713f$var$S(this.instance.container, $d4d06657c043713f$var$yt);
        for (const t of e.slides){
            const e = t.panzoom;
            e && t.index !== i && e.reset(.35);
        }
    }
    onClose() {
        var t;
        const e = this.instance, i = e.container, n = e.getSlide();
        if (!i || !i.parentElement || !n) return;
        const { el: s, contentEl: o, panzoom: a, thumbElSrc: r } = n;
        if (!s || !r || !o || !a || a.isContentLoading || a.state === $d4d06657c043713f$var$m.Init || a.state === $d4d06657c043713f$var$m.Destroy) return;
        a.updateMetrics();
        let l = this.getZoomInfo(n);
        if (!l) return;
        this.instance.state = $d4d06657c043713f$var$rt.CustomClosing, i.classList.remove($d4d06657c043713f$var$yt), i.classList.add("is-zooming-out"), o.style.backgroundImage = `url('${r}')`;
        const c = i.getBoundingClientRect();
        1 === ((null === (t = window.visualViewport) || void 0 === t ? void 0 : t.scale) || 1) && Object.assign(i.style, {
            position: "absolute",
            top: `${i.offsetTop + window.scrollY}px`,
            left: `${i.offsetLeft + window.scrollX}px`,
            bottom: "auto",
            right: "auto",
            width: `${c.width}px`,
            height: `${c.height}px`,
            overflow: "hidden"
        });
        const { x: h, y: d, scale: u, opacity: p } = l;
        if (p) {
            const t = ((t, e, i, n)=>{
                const s = e - t, o = n - i;
                return (e)=>i + ((e - t) / s * o || 0);
            })(a.scale, u, 1, 0);
            a.on("afterTransform", ()=>{
                o.style.opacity = t(a.scale) + "";
            });
        }
        a.on("endAnimation", ()=>{
            e.destroy();
        }), a.target.a = u, a.target.b = 0, a.target.c = 0, a.target.d = u, a.panTo({
            x: h,
            y: d,
            scale: u,
            friction: p ? .2 : .33,
            ignoreBounds: !0
        }), a.isResting && e.destroy();
    }
    setImage(t, e) {
        const i = this.instance;
        t.src = e, this.process(t, e).then((e)=>{
            const { contentEl: n, imageEl: s, thumbElSrc: o, el: a } = t;
            if (i.isClosing() || !n || !s) return;
            n.offsetHeight;
            const r = !!i.isOpeningSlide(t) && this.getZoomInfo(t);
            if (this.option("protected") && a) {
                a.addEventListener("contextmenu", (t)=>{
                    t.preventDefault();
                });
                const t = document.createElement("div");
                $d4d06657c043713f$var$P(t, "fancybox-protected"), n.appendChild(t);
            }
            if (o && r) {
                const s = e.contentRect, a = Math.max(s.fullWidth, s.fullHeight);
                let c = null;
                !r.opacity && a > 1200 && (c = document.createElement("img"), $d4d06657c043713f$var$P(c, "fancybox-ghost"), c.src = o, n.appendChild(c));
                const h = ()=>{
                    c && ($d4d06657c043713f$var$P(c, "f-fadeFastOut"), setTimeout(()=>{
                        c && (c.remove(), c = null);
                    }, 200));
                };
                (l = o, new Promise((t, e)=>{
                    const i = new Image;
                    i.onload = t, i.onerror = e, i.src = l;
                })).then(()=>{
                    i.hideLoading(t), t.state = $d4d06657c043713f$var$lt.Opening, this.instance.emit("reveal", t), this.zoomIn(t).then(()=>{
                        h(), this.instance.done(t);
                    }, ()=>{}), c && setTimeout(()=>{
                        h();
                    }, a > 2500 ? 800 : 200);
                }, ()=>{
                    i.hideLoading(t), i.revealContent(t);
                });
            } else {
                const n = this.optionFor(t, "initialSize"), s = this.optionFor(t, "zoom"), o = {
                    event: i.prevMouseMoveEvent || i.options.event,
                    friction: s ? .12 : 0
                };
                let a = i.optionFor(t, "showClass") || void 0, r = !0;
                i.isOpeningSlide(t) && ("full" === n ? e.zoomToFull(o) : "cover" === n ? e.zoomToCover(o) : "max" === n ? e.zoomToMax(o) : r = !1, e.stop("current")), r && a && (a = e.isDragging ? "f-fadeIn" : ""), i.hideLoading(t), i.revealContent(t, a);
            }
            var l;
        }, ()=>{
            i.setError(t, "{{IMAGE_ERROR}}");
        });
    }
    process(t, e) {
        return new Promise((i, s)=>{
            var o;
            const a = this.instance, r = t.el;
            a.clearContent(t), a.showLoading(t);
            let l = this.optionFor(t, "content");
            if ("string" == typeof l && (l = $d4d06657c043713f$var$n(l)), !l || !$d4d06657c043713f$var$E(l)) {
                if (l = document.createElement("img"), l instanceof HTMLImageElement) {
                    let i = "", n = t.caption;
                    i = "string" == typeof n && n ? n.replace(/<[^>]+>/gi, "").substring(0, 1e3) : `Image ${t.index + 1} of ${(null === (o = a.carousel) || void 0 === o ? void 0 : o.pages.length) || 1}`, l.src = e || "", l.alt = i, l.draggable = !1, t.srcset && l.setAttribute("srcset", t.srcset), this.instance.isOpeningSlide(t) && (l.fetchPriority = "high");
                }
                t.sizes && l.setAttribute("sizes", t.sizes);
            }
            $d4d06657c043713f$var$P(l, "fancybox-image"), t.imageEl = l, a.setContent(t, l, !1);
            t.panzoom = new $d4d06657c043713f$export$b704d075ddd20210(r, $d4d06657c043713f$var$u({
                transformParent: !0
            }, this.option("Panzoom") || {}, {
                content: l,
                width: (e, i)=>a.optionFor(t, "width", "auto", i) || "auto",
                height: (e, i)=>a.optionFor(t, "height", "auto", i) || "auto",
                wheel: ()=>{
                    const t = a.option("wheel");
                    return ("zoom" === t || "pan" == t) && t;
                },
                click: (e, i)=>{
                    var n, s;
                    if (a.isCompact || a.isClosing()) return !1;
                    if (t.index !== (null === (n = a.getSlide()) || void 0 === n ? void 0 : n.index)) return !1;
                    if (i) {
                        const t = i.composedPath()[0];
                        if ([
                            "A",
                            "BUTTON",
                            "TEXTAREA",
                            "OPTION",
                            "INPUT",
                            "SELECT",
                            "VIDEO"
                        ].includes(t.nodeName)) return !1;
                    }
                    let o = !i || i.target && (null === (s = t.contentEl) || void 0 === s ? void 0 : s.contains(i.target));
                    return a.option(o ? "contentClick" : "backdropClick") || !1;
                },
                dblClick: ()=>a.isCompact ? "toggleZoom" : a.option("contentDblClick") || !1,
                spinner: !1,
                panOnlyZoomed: !0,
                wheelLimit: 1 / 0,
                on: {
                    ready: (t)=>{
                        i(t);
                    },
                    error: ()=>{
                        s();
                    },
                    destroy: ()=>{
                        s();
                    }
                }
            }));
        });
    }
    zoomIn(t) {
        return new Promise((e, i)=>{
            const n = this.instance, s = n.container, { panzoom: o, contentEl: a, el: r } = t;
            o && o.updateMetrics();
            const l = this.getZoomInfo(t);
            if (!(l && r && a && o && s)) return void i();
            const { x: c, y: h, scale: d, opacity: u } = l, p = ()=>{
                t.state !== $d4d06657c043713f$var$lt.Closing && (u && (a.style.opacity = Math.max(Math.min(1, 1 - (1 - o.scale) / (1 - d)), 0) + ""), o.scale >= 1 && o.scale > o.targetScale - .1 && e(o));
            }, f = (t)=>{
                (t.scale < .99 || t.scale > 1.01) && !t.isDragging || ($d4d06657c043713f$var$S(s, $d4d06657c043713f$var$yt), a.style.opacity = "", t.off("endAnimation", f), t.off("touchStart", f), t.off("afterTransform", p), e(t));
            };
            o.on("endAnimation", f), o.on("touchStart", f), o.on("afterTransform", p), o.on([
                "error",
                "destroy"
            ], ()=>{
                i();
            }), o.panTo({
                x: c,
                y: h,
                scale: d,
                friction: 0,
                ignoreBounds: !0
            }), o.stop("current");
            const g = {
                event: "mousemove" === o.panMode ? n.prevMouseMoveEvent || n.options.event : void 0
            }, m = this.optionFor(t, "initialSize");
            $d4d06657c043713f$var$P(s, $d4d06657c043713f$var$yt), n.hideLoading(t), "full" === m ? o.zoomToFull(g) : "cover" === m ? o.zoomToCover(g) : "max" === m ? o.zoomToMax(g) : o.reset(.172);
        });
    }
    getZoomInfo(t) {
        const { el: e, imageEl: i, thumbEl: n, panzoom: s } = t, o = this.instance, a = o.container;
        if (!e || !i || !n || !s || $d4d06657c043713f$var$tt(n) < 3 || !this.optionFor(t, "zoom") || !a || o.state === $d4d06657c043713f$var$rt.Destroy) return !1;
        if ("0" === getComputedStyle(a).getPropertyValue("--f-images-zoom")) return !1;
        const r = window.visualViewport || null;
        if (1 !== (r ? r.scale : 1)) return !1;
        let { top: l, left: c, width: h, height: d } = n.getBoundingClientRect(), { top: u, left: p, fitWidth: f, fitHeight: g } = s.contentRect;
        if (!(h && d && f && g)) return !1;
        const m = s.container.getBoundingClientRect();
        p += m.left, u += m.top;
        const v = -1 * (p + .5 * f - (c + .5 * h)), b = -1 * (u + .5 * g - (l + .5 * d)), y = h / f;
        let w = this.option("zoomOpacity") || !1;
        return "auto" === w && (w = Math.abs(h / d - f / g) > .1), {
            x: v,
            y: b,
            scale: y,
            opacity: w
        };
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.change", t.onChange), e.on("Carousel.createSlide", t.onCreateSlide), e.on("Carousel.removeSlide", t.onRemoveSlide), e.on("close", t.onClose);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.change", t.onChange), e.off("Carousel.createSlide", t.onCreateSlide), e.off("Carousel.removeSlide", t.onRemoveSlide), e.off("close", t.onClose);
    }
}
Object.defineProperty($d4d06657c043713f$var$wt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        initialSize: "fit",
        Panzoom: {
            maxScale: 1
        },
        protected: !1,
        zoom: !0,
        zoomOpacity: "auto"
    }
}), "function" == typeof SuppressedError && SuppressedError;
const $d4d06657c043713f$var$xt = "html", $d4d06657c043713f$var$Et = "image", $d4d06657c043713f$var$St = "map", $d4d06657c043713f$var$Pt = "youtube", $d4d06657c043713f$var$Ct = "vimeo", $d4d06657c043713f$var$Tt = "html5video", $d4d06657c043713f$var$Mt = (t, e = {})=>{
    const i = new URL(t), n = new URLSearchParams(i.search), s = new URLSearchParams;
    for (const [t, i] of [
        ...n,
        ...Object.entries(e)
    ]){
        let e = i + "";
        if ("t" === t) {
            let t = e.match(/((\d*)m)?(\d*)s?/);
            t && s.set("start", 60 * parseInt(t[2] || "0") + parseInt(t[3] || "0") + "");
        } else s.set(t, e);
    }
    let o = s + "", a = t.match(/#t=((.*)?\d+s)/);
    return a && (o += `#t=${a[1]}`), o;
}, $d4d06657c043713f$var$Ot = {
    ajax: null,
    autoSize: !0,
    iframeAttr: {
        allow: "autoplay; fullscreen",
        scrolling: "auto"
    },
    preload: !0,
    videoAutoplay: !0,
    videoRatio: 16 / 9,
    videoTpl: '<video class="fancybox__html5video" playsinline controls controlsList="nodownload" poster="{{poster}}">\n  <source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos.</video>',
    videoFormat: "",
    vimeo: {
        byline: 1,
        color: "00adef",
        controls: 1,
        dnt: 1,
        muted: 0
    },
    youtube: {
        controls: 1,
        enablejsapi: 1,
        nocookie: 1,
        rel: 0,
        fs: 1
    }
}, $d4d06657c043713f$var$At = [
    "image",
    "html",
    "ajax",
    "inline",
    "clone",
    "iframe",
    "map",
    "pdf",
    "html5video",
    "youtube",
    "vimeo"
];
class $d4d06657c043713f$var$Lt extends $d4d06657c043713f$var$_ {
    onBeforeInitSlide(t, e, i) {
        this.processType(i);
    }
    onCreateSlide(t, e, i) {
        this.setContent(i);
    }
    onClearContent(t, e) {
        e.xhr && (e.xhr.abort(), e.xhr = null);
        const i = e.iframeEl;
        i && (i.onload = i.onerror = null, i.src = "//about:blank", e.iframeEl = null);
        const n = e.contentEl, s = e.placeholderEl;
        if ("inline" === e.type && n && s) n.classList.remove("fancybox__content"), "none" !== getComputedStyle(n).getPropertyValue("display") && (n.style.display = "none"), setTimeout(()=>{
            s && (n && s.parentNode && s.parentNode.insertBefore(n, s), s.remove());
        }, 0), e.contentEl = void 0, e.placeholderEl = void 0;
        else for(; e.el && e.el.firstChild;)e.el.removeChild(e.el.firstChild);
    }
    onSelectSlide(t, e, i) {
        i.state === $d4d06657c043713f$var$lt.Ready && this.playVideo();
    }
    onUnselectSlide(t, e, i) {
        var n, s;
        if (i.type === $d4d06657c043713f$var$Tt) {
            try {
                null === (s = null === (n = i.el) || void 0 === n ? void 0 : n.querySelector("video")) || void 0 === s || s.pause();
            } catch (t) {}
            return;
        }
        let o;
        i.type === $d4d06657c043713f$var$Ct ? o = {
            method: "pause",
            value: "true"
        } : i.type === $d4d06657c043713f$var$Pt && (o = {
            event: "command",
            func: "pauseVideo"
        }), o && i.iframeEl && i.iframeEl.contentWindow && i.iframeEl.contentWindow.postMessage(JSON.stringify(o), "*"), i.poller && clearTimeout(i.poller);
    }
    onDone(t, e) {
        t.isCurrentSlide(e) && !t.isClosing() && this.playVideo();
    }
    onRefresh(t, e) {
        e.slides.forEach((t)=>{
            t.el && (this.resizeIframe(t), this.setAspectRatio(t));
        });
    }
    onMessage(t) {
        try {
            let e = JSON.parse(t.data);
            if ("https://player.vimeo.com" === t.origin) {
                if ("ready" === e.event) for (let e of Array.from(document.getElementsByClassName("fancybox__iframe")))e instanceof HTMLIFrameElement && e.contentWindow === t.source && (e.dataset.ready = "true");
            } else if (t.origin.match(/^https:\/\/(www.)?youtube(-nocookie)?.com$/) && "onReady" === e.event) {
                const t = document.getElementById(e.id);
                t && (t.dataset.ready = "true");
            }
        } catch (t) {}
    }
    loadAjaxContent(t) {
        const e = this.instance.optionFor(t, "src") || "";
        this.instance.showLoading(t);
        const i = this.instance, n = new XMLHttpRequest;
        i.showLoading(t), n.onreadystatechange = function() {
            n.readyState === XMLHttpRequest.DONE && i.state === $d4d06657c043713f$var$rt.Ready && (i.hideLoading(t), 200 === n.status ? i.setContent(t, n.responseText) : i.setError(t, 404 === n.status ? "{{AJAX_NOT_FOUND}}" : "{{AJAX_FORBIDDEN}}"));
        };
        const s = t.ajax || null;
        n.open(s ? "POST" : "GET", e + ""), n.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), n.setRequestHeader("X-Requested-With", "XMLHttpRequest"), n.send(s), t.xhr = n;
    }
    setInlineContent(t) {
        let e = null;
        if ($d4d06657c043713f$var$E(t.src)) e = t.src;
        else if ("string" == typeof t.src) {
            const i = t.src.split("#", 2).pop();
            e = i ? document.getElementById(i) : null;
        }
        if (e) {
            if ("clone" === t.type || e.closest(".fancybox__slide")) {
                e = e.cloneNode(!0);
                const i = e.dataset.animationName;
                i && (e.classList.remove(i), delete e.dataset.animationName);
                let n = e.getAttribute("id");
                n = n ? `${n}--clone` : `clone-${this.instance.id}-${t.index}`, e.setAttribute("id", n);
            } else if (e.parentNode) {
                const i = document.createElement("div");
                i.classList.add("fancybox-placeholder"), e.parentNode.insertBefore(i, e), t.placeholderEl = i;
            }
            this.instance.setContent(t, e);
        } else this.instance.setError(t, "{{ELEMENT_NOT_FOUND}}");
    }
    setIframeContent(t) {
        const { src: e, el: i } = t;
        if (!e || "string" != typeof e || !i) return;
        i.classList.add("is-loading");
        const n = this.instance, s = document.createElement("iframe");
        s.className = "fancybox__iframe", s.setAttribute("id", `fancybox__iframe_${n.id}_${t.index}`);
        for (const [e, i] of Object.entries(this.optionFor(t, "iframeAttr") || {}))s.setAttribute(e, i);
        s.onerror = ()=>{
            n.setError(t, "{{IFRAME_ERROR}}");
        }, t.iframeEl = s;
        const o = this.optionFor(t, "preload");
        if ("iframe" !== t.type || !1 === o) return s.setAttribute("src", t.src + ""), n.setContent(t, s, !1), this.resizeIframe(t), void n.revealContent(t);
        n.showLoading(t), s.onload = ()=>{
            if (!s.src.length) return;
            const e = "true" !== s.dataset.ready;
            s.dataset.ready = "true", this.resizeIframe(t), e ? n.revealContent(t) : n.hideLoading(t);
        }, s.setAttribute("src", e), n.setContent(t, s, !1);
    }
    resizeIframe(t) {
        const { type: e, iframeEl: i } = t;
        if (e === $d4d06657c043713f$var$Pt || e === $d4d06657c043713f$var$Ct) return;
        const n = null == i ? void 0 : i.parentElement;
        if (!i || !n) return;
        let s = t.autoSize;
        void 0 === s && (s = this.optionFor(t, "autoSize"));
        let o = t.width || 0, a = t.height || 0;
        o && a && (s = !1);
        const r = n && n.style;
        if (!1 !== t.preload && !1 !== s && r) try {
            const t = window.getComputedStyle(n), e = parseFloat(t.paddingLeft) + parseFloat(t.paddingRight), s = parseFloat(t.paddingTop) + parseFloat(t.paddingBottom), l = i.contentWindow;
            if (l) {
                const t = l.document, i = t.getElementsByTagName($d4d06657c043713f$var$xt)[0], n = t.body;
                r.width = "", n.style.overflow = "hidden", o = o || i.scrollWidth + e, r.width = `${o}px`, n.style.overflow = "", r.flex = "0 0 auto", r.height = `${n.scrollHeight}px`, a = i.scrollHeight + s;
            }
        } catch (t) {}
        if (o || a) {
            const t = {
                flex: "0 1 auto",
                width: "",
                height: ""
            };
            o && "auto" !== o && (t.width = `${o}px`), a && "auto" !== a && (t.height = `${a}px`), Object.assign(r, t);
        }
    }
    playVideo() {
        const t = this.instance.getSlide();
        if (!t) return;
        const { el: e } = t;
        if (!e || !e.offsetParent) return;
        if (!this.optionFor(t, "videoAutoplay")) return;
        if (t.type === $d4d06657c043713f$var$Tt) try {
            const t = e.querySelector("video");
            if (t) {
                const e = t.play();
                void 0 !== e && e.then(()=>{}).catch((e)=>{
                    t.muted = !0, t.play();
                });
            }
        } catch (t) {}
        if (t.type !== $d4d06657c043713f$var$Pt && t.type !== $d4d06657c043713f$var$Ct) return;
        const i = ()=>{
            if (t.iframeEl && t.iframeEl.contentWindow) {
                let e;
                if ("true" === t.iframeEl.dataset.ready) return e = t.type === $d4d06657c043713f$var$Pt ? {
                    event: "command",
                    func: "playVideo"
                } : {
                    method: "play",
                    value: "true"
                }, e && t.iframeEl.contentWindow.postMessage(JSON.stringify(e), "*"), void (t.poller = void 0);
                t.type === $d4d06657c043713f$var$Pt && (e = {
                    event: "listening",
                    id: t.iframeEl.getAttribute("id")
                }, t.iframeEl.contentWindow.postMessage(JSON.stringify(e), "*"));
            }
            t.poller = setTimeout(i, 250);
        };
        i();
    }
    processType(t) {
        if (t.html) return t.type = $d4d06657c043713f$var$xt, t.src = t.html, void (t.html = "");
        const e = this.instance.optionFor(t, "src", "");
        if (!e || "string" != typeof e) return;
        let i = t.type, n = null;
        if (n = e.match(/(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(?:watch\?(?:.*&)?v=|v\/|u\/|shorts\/|embed\/?)?(videoseries\?list=(?:.*)|[\w-]{11}|\?listType=(?:.*)&list=(?:.*))(?:.*)/i)) {
            const s = this.optionFor(t, $d4d06657c043713f$var$Pt), { nocookie: o } = s, a = function(t, e) {
                var i = {};
                for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (i[n] = t[n]);
                if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
                    var s = 0;
                    for(n = Object.getOwnPropertySymbols(t); s < n.length; s++)e.indexOf(n[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[s]) && (i[n[s]] = t[n[s]]);
                }
                return i;
            }(s, [
                "nocookie"
            ]), r = `www.youtube${o ? "-nocookie" : ""}.com`, l = $d4d06657c043713f$var$Mt(e, a), c = encodeURIComponent(n[2]);
            t.videoId = c, t.src = `https://${r}/embed/${c}?${l}`, t.thumbSrc = t.thumbSrc || `https://i.ytimg.com/vi/${c}/mqdefault.jpg`, i = $d4d06657c043713f$var$Pt;
        } else if (n = e.match(/^.+vimeo.com\/(?:\/)?([\d]+)((\/|\?h=)([a-z0-9]+))?(.*)?/)) {
            const s = $d4d06657c043713f$var$Mt(e, this.optionFor(t, $d4d06657c043713f$var$Ct)), o = encodeURIComponent(n[1]), a = n[4] || "";
            t.videoId = o, t.src = `https://player.vimeo.com/video/${o}?${a ? `h=${a}${s ? "&" : ""}` : ""}${s}`, i = $d4d06657c043713f$var$Ct;
        }
        if (!i && t.triggerEl) {
            const e = t.triggerEl.dataset.type;
            $d4d06657c043713f$var$At.includes(e) && (i = e);
        }
        i || "string" == typeof e && ("#" === e.charAt(0) ? i = "inline" : (n = e.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i)) ? (i = $d4d06657c043713f$var$Tt, t.videoFormat = t.videoFormat || "video/" + ("ogv" === n[1] ? "ogg" : n[1])) : e.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i) ? i = $d4d06657c043713f$var$Et : e.match(/\.(pdf)((\?|#).*)?$/i) && (i = "pdf")), (n = e.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:(?:(?:maps\/(?:place\/(?:.*)\/)?\@(.*),(\d+.?\d+?)z))|(?:\?ll=))(.*)?/i)) ? (t.src = `https://maps.google.${n[1]}/?ll=${(n[2] ? n[2] + "&z=" + Math.floor(parseFloat(n[3])) + (n[4] ? n[4].replace(/^\//, "&") : "") : n[4] + "").replace(/\?/, "&")}&output=${n[4] && n[4].indexOf("layer=c") > 0 ? "svembed" : "embed"}`, i = $d4d06657c043713f$var$St) : (n = e.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:maps\/search\/)(.*)/i)) && (t.src = `https://maps.google.${n[1]}/maps?q=${n[2].replace("query=", "q=").replace("api=1", "")}&output=embed`, i = $d4d06657c043713f$var$St), i = i || this.instance.option("defaultType"), t.type = i, i === $d4d06657c043713f$var$Et && (t.thumbSrc = t.thumbSrc || t.src);
    }
    setContent(t) {
        const e = this.instance.optionFor(t, "src") || "";
        if (t && t.type && e) {
            switch(t.type){
                case $d4d06657c043713f$var$xt:
                    this.instance.setContent(t, e);
                    break;
                case $d4d06657c043713f$var$Tt:
                    const i = this.option("videoTpl");
                    i && this.instance.setContent(t, i.replace(/\{\{src\}\}/gi, e + "").replace(/\{\{format\}\}/gi, this.optionFor(t, "videoFormat") || "").replace(/\{\{poster\}\}/gi, t.poster || t.thumbSrc || ""));
                    break;
                case "inline":
                case "clone":
                    this.setInlineContent(t);
                    break;
                case "ajax":
                    this.loadAjaxContent(t);
                    break;
                case "pdf":
                case $d4d06657c043713f$var$St:
                case $d4d06657c043713f$var$Pt:
                case $d4d06657c043713f$var$Ct:
                    t.preload = !1;
                case "iframe":
                    this.setIframeContent(t);
            }
            this.setAspectRatio(t);
        }
    }
    setAspectRatio(t) {
        const e = t.contentEl;
        if (!(t.el && e && t.type && [
            $d4d06657c043713f$var$Pt,
            $d4d06657c043713f$var$Ct,
            $d4d06657c043713f$var$Tt
        ].includes(t.type))) return;
        let i, n = t.width || "auto", s = t.height || "auto";
        if ("auto" === n || "auto" === s) {
            i = this.optionFor(t, "videoRatio");
            const e = (i + "").match(/(\d+)\s*\/\s?(\d+)/);
            i = e && e.length > 2 ? parseFloat(e[1]) / parseFloat(e[2]) : parseFloat(i + "");
        } else n && s && (i = n / s);
        if (!i) return;
        e.style.aspectRatio = "", e.style.width = "", e.style.height = "", e.offsetHeight;
        const o = e.getBoundingClientRect(), a = o.width || 1, r = o.height || 1;
        e.style.aspectRatio = i + "", i < a / r ? (s = "auto" === s ? r : Math.min(r, s), e.style.width = "auto", e.style.height = `${s}px`) : (n = "auto" === n ? a : Math.min(a, n), e.style.width = `${n}px`, e.style.height = "auto");
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.beforeInitSlide", t.onBeforeInitSlide), e.on("Carousel.createSlide", t.onCreateSlide), e.on("Carousel.selectSlide", t.onSelectSlide), e.on("Carousel.unselectSlide", t.onUnselectSlide), e.on("Carousel.Panzoom.refresh", t.onRefresh), e.on("done", t.onDone), e.on("clearContent", t.onClearContent), window.addEventListener("message", t.onMessage);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.beforeInitSlide", t.onBeforeInitSlide), e.off("Carousel.createSlide", t.onCreateSlide), e.off("Carousel.selectSlide", t.onSelectSlide), e.off("Carousel.unselectSlide", t.onUnselectSlide), e.off("Carousel.Panzoom.refresh", t.onRefresh), e.off("done", t.onDone), e.off("clearContent", t.onClearContent), window.removeEventListener("message", t.onMessage);
    }
}
Object.defineProperty($d4d06657c043713f$var$Lt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$Ot
});
const $d4d06657c043713f$var$zt = "play", $d4d06657c043713f$var$Rt = "pause", $d4d06657c043713f$var$kt = "ready";
class $d4d06657c043713f$var$It extends $d4d06657c043713f$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d4d06657c043713f$var$kt
        }), Object.defineProperty(this, "inHover", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "timer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "progressBar", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    get isActive() {
        return this.state !== $d4d06657c043713f$var$kt;
    }
    onReady(t) {
        this.option("autoStart") && (t.isInfinite || t.page < t.pages.length - 1) && this.start();
    }
    onChange() {
        this.removeProgressBar(), this.pause();
    }
    onSettle() {
        this.resume();
    }
    onVisibilityChange() {
        "visible" === document.visibilityState ? this.resume() : this.pause();
    }
    onMouseEnter() {
        this.inHover = !0, this.pause();
    }
    onMouseLeave() {
        var t;
        this.inHover = !1, (null === (t = this.instance.panzoom) || void 0 === t ? void 0 : t.isResting) && this.resume();
    }
    onTimerEnd() {
        const t = this.instance;
        "play" === this.state && (t.isInfinite || t.page !== t.pages.length - 1 ? t.slideNext() : t.slideTo(0));
    }
    removeProgressBar() {
        this.progressBar && (this.progressBar.remove(), this.progressBar = null);
    }
    createProgressBar() {
        var t;
        if (!this.option("showProgress")) return null;
        this.removeProgressBar();
        const e = this.instance, i = (null === (t = e.pages[e.page]) || void 0 === t ? void 0 : t.slides) || [];
        let n = this.option("progressParentEl");
        if (n || (n = (1 === i.length ? i[0].el : null) || e.viewport), !n) return null;
        const s = document.createElement("div");
        return $d4d06657c043713f$var$P(s, "f-progress"), n.prepend(s), this.progressBar = s, s.offsetHeight, s;
    }
    set() {
        const t = this, e = t.instance;
        if (e.pages.length < 2) return;
        if (t.timer) return;
        const i = t.option("timeout");
        t.state = $d4d06657c043713f$var$zt, $d4d06657c043713f$var$P(e.container, "has-autoplay");
        let n = t.createProgressBar();
        n && (n.style.transitionDuration = `${i}ms`, n.style.transform = "scaleX(1)"), t.timer = setTimeout(()=>{
            t.timer = null, t.inHover || t.onTimerEnd();
        }, i), t.emit("set");
    }
    clear() {
        const t = this;
        t.timer && (clearTimeout(t.timer), t.timer = null), t.removeProgressBar();
    }
    start() {
        const t = this;
        if (t.set(), t.state !== $d4d06657c043713f$var$kt) {
            if (t.option("pauseOnHover")) {
                const e = t.instance.container;
                e.addEventListener("mouseenter", t.onMouseEnter, !1), e.addEventListener("mouseleave", t.onMouseLeave, !1);
            }
            document.addEventListener("visibilitychange", t.onVisibilityChange, !1), t.emit("start");
        }
    }
    stop() {
        const t = this, e = t.state, i = t.instance.container;
        t.clear(), t.state = $d4d06657c043713f$var$kt, i.removeEventListener("mouseenter", t.onMouseEnter, !1), i.removeEventListener("mouseleave", t.onMouseLeave, !1), document.removeEventListener("visibilitychange", t.onVisibilityChange, !1), $d4d06657c043713f$var$S(i, "has-autoplay"), e !== $d4d06657c043713f$var$kt && t.emit("stop");
    }
    pause() {
        const t = this;
        t.state === $d4d06657c043713f$var$zt && (t.state = $d4d06657c043713f$var$Rt, t.clear(), t.emit($d4d06657c043713f$var$Rt));
    }
    resume() {
        const t = this, e = t.instance;
        if (e.isInfinite || e.page !== e.pages.length - 1) {
            if (t.state !== $d4d06657c043713f$var$zt) {
                if (t.state === $d4d06657c043713f$var$Rt && !t.inHover) {
                    const e = new Event("resume", {
                        bubbles: !0,
                        cancelable: !0
                    });
                    t.emit("resume", e), e.defaultPrevented || t.set();
                }
            } else t.set();
        } else t.stop();
    }
    toggle() {
        this.state === $d4d06657c043713f$var$zt || this.state === $d4d06657c043713f$var$Rt ? this.stop() : this.start();
    }
    attach() {
        const t = this, e = t.instance;
        e.on("ready", t.onReady), e.on("Panzoom.startAnimation", t.onChange), e.on("Panzoom.endAnimation", t.onSettle), e.on("Panzoom.touchMove", t.onChange);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("ready", t.onReady), e.off("Panzoom.startAnimation", t.onChange), e.off("Panzoom.endAnimation", t.onSettle), e.off("Panzoom.touchMove", t.onChange), t.stop();
    }
}
Object.defineProperty($d4d06657c043713f$var$It, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        autoStart: !0,
        pauseOnHover: !0,
        progressParentEl: null,
        showProgress: !0,
        timeout: 3e3
    }
});
class $d4d06657c043713f$var$Dt extends $d4d06657c043713f$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "ref", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onPrepare(t) {
        const e = t.carousel;
        if (!e) return;
        const i = t.container;
        i && (e.options.Autoplay = $d4d06657c043713f$var$u({
            autoStart: !1
        }, this.option("Autoplay") || {}, {
            pauseOnHover: !1,
            timeout: this.option("timeout"),
            progressParentEl: ()=>this.option("progressParentEl") || null,
            on: {
                start: ()=>{
                    t.emit("startSlideshow");
                },
                set: (e)=>{
                    var n;
                    i.classList.add("has-slideshow"), (null === (n = t.getSlide()) || void 0 === n ? void 0 : n.state) !== $d4d06657c043713f$var$lt.Ready && e.pause();
                },
                stop: ()=>{
                    i.classList.remove("has-slideshow"), t.isCompact || t.endIdle(), t.emit("endSlideshow");
                },
                resume: (e, i)=>{
                    var n, s, o;
                    !i || !i.cancelable || (null === (n = t.getSlide()) || void 0 === n ? void 0 : n.state) === $d4d06657c043713f$var$lt.Ready && (null === (o = null === (s = t.carousel) || void 0 === s ? void 0 : s.panzoom) || void 0 === o ? void 0 : o.isResting) || i.preventDefault();
                }
            }
        }), e.attachPlugins({
            Autoplay: $d4d06657c043713f$var$It
        }), this.ref = e.plugins.Autoplay);
    }
    onReady(t) {
        const e = t.carousel, i = this.ref;
        i && e && this.option("playOnStart") && (e.isInfinite || e.page < e.pages.length - 1) && i.start();
    }
    onDone(t, e) {
        const i = this.ref, n = t.carousel;
        if (!i || !n) return;
        const s = e.panzoom;
        s && s.on("startAnimation", ()=>{
            t.isCurrentSlide(e) && i.stop();
        }), t.isCurrentSlide(e) && i.resume();
    }
    onKeydown(t, e) {
        var i;
        const n = this.ref;
        n && e === this.option("key") && "BUTTON" !== (null === (i = document.activeElement) || void 0 === i ? void 0 : i.nodeName) && n.toggle();
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.init", t.onPrepare), e.on("Carousel.ready", t.onReady), e.on("done", t.onDone), e.on("keydown", t.onKeydown);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.init", t.onPrepare), e.off("Carousel.ready", t.onReady), e.off("done", t.onDone), e.off("keydown", t.onKeydown);
    }
}
Object.defineProperty($d4d06657c043713f$var$Dt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        key: " ",
        playOnStart: !1,
        progressParentEl: (t)=>{
            var e;
            return (null === (e = t.instance.container) || void 0 === e ? void 0 : e.querySelector(".fancybox__toolbar [data-fancybox-toggle-slideshow]")) || t.instance.container;
        },
        timeout: 3e3
    }
});
const $d4d06657c043713f$var$Ft = {
    classes: {
        container: "f-thumbs f-carousel__thumbs",
        viewport: "f-thumbs__viewport",
        track: "f-thumbs__track",
        slide: "f-thumbs__slide",
        isResting: "is-resting",
        isSelected: "is-selected",
        isLoading: "is-loading",
        hasThumbs: "has-thumbs"
    },
    minCount: 2,
    parentEl: null,
    thumbTpl: '<button class="f-thumbs__slide__button" tabindex="0" type="button" aria-label="{{GOTO}}" data-carousel-index="%i"><img class="f-thumbs__slide__img" data-lazy-src="{{%s}}" alt="" /></button>',
    type: "modern"
};
var $d4d06657c043713f$var$jt;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Hidden = 2] = "Hidden";
}($d4d06657c043713f$var$jt || ($d4d06657c043713f$var$jt = {}));
const $d4d06657c043713f$var$Bt = "isResting", $d4d06657c043713f$var$Ht = "thumbWidth", $d4d06657c043713f$var$Nt = "thumbHeight", $d4d06657c043713f$var$_t = "thumbClipWidth";
let $d4d06657c043713f$var$$t = class extends $d4d06657c043713f$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "type", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "modern"
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "track", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "carousel", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "thumbWidth", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbClipWidth", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbHeight", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbGap", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbExtraGap", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d4d06657c043713f$var$jt.Init
        });
    }
    get isModern() {
        return "modern" === this.type;
    }
    onInitSlide(t, e) {
        const i = e.el ? e.el.dataset : void 0;
        i && (e.thumbSrc = i.thumbSrc || e.thumbSrc || "", e[$d4d06657c043713f$var$_t] = parseFloat(i[$d4d06657c043713f$var$_t] || "") || e[$d4d06657c043713f$var$_t] || 0, e[$d4d06657c043713f$var$Nt] = parseFloat(i.thumbHeight || "") || e[$d4d06657c043713f$var$Nt] || 0), this.addSlide(e);
    }
    onInitSlides() {
        this.build();
    }
    onChange() {
        var t;
        if (!this.isModern) return;
        const e = this.container, i = this.instance, n = i.panzoom, s = this.carousel, a = s ? s.panzoom : null, r = i.page;
        if (n && s && a) {
            if (n.isDragging) {
                $d4d06657c043713f$var$S(e, this.cn($d4d06657c043713f$var$Bt));
                let n = (null === (t = s.pages[r]) || void 0 === t ? void 0 : t.pos) || 0;
                n += i.getProgress(r) * (this[$d4d06657c043713f$var$_t] + this.thumbGap);
                let o = a.getBounds();
                -1 * n > o.x.min && -1 * n < o.x.max && a.panTo({
                    x: -1 * n,
                    friction: .12
                });
            } else $d4d06657c043713f$var$o(e, this.cn($d4d06657c043713f$var$Bt), n.isResting);
            this.shiftModern();
        }
    }
    onRefresh() {
        this.updateProps();
        for (const t of this.instance.slides || [])this.resizeModernSlide(t);
        this.shiftModern();
    }
    isDisabled() {
        const t = this.option("minCount") || 0;
        if (t) {
            const e = this.instance;
            let i = 0;
            for (const t of e.slides || [])t.thumbSrc && i++;
            if (i < t) return !0;
        }
        const e = this.option("type");
        return [
            "modern",
            "classic"
        ].indexOf(e) < 0;
    }
    getThumb(t) {
        const e = this.option("thumbTpl") || "";
        return {
            html: this.instance.localize(e, [
                [
                    "%i",
                    t.index
                ],
                [
                    "%d",
                    t.index + 1
                ],
                [
                    "%s",
                    t.thumbSrc || "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                ]
            ])
        };
    }
    addSlide(t) {
        const e = this.carousel;
        e && e.addSlide(t.index, this.getThumb(t));
    }
    getSlides() {
        const t = [];
        for (const e of this.instance.slides || [])t.push(this.getThumb(e));
        return t;
    }
    resizeModernSlide(t) {
        this.isModern && (t[$d4d06657c043713f$var$Ht] = t[$d4d06657c043713f$var$_t] && t[$d4d06657c043713f$var$Nt] ? Math.round(this[$d4d06657c043713f$var$Nt] * (t[$d4d06657c043713f$var$_t] / t[$d4d06657c043713f$var$Nt])) : this[$d4d06657c043713f$var$Ht]);
    }
    updateProps() {
        const t = this.container;
        if (!t) return;
        const e = (e)=>parseFloat(getComputedStyle(t).getPropertyValue("--f-thumb-" + e)) || 0;
        this.thumbGap = e("gap"), this.thumbExtraGap = e("extra-gap"), this[$d4d06657c043713f$var$Ht] = e("width") || 40, this[$d4d06657c043713f$var$_t] = e("clip-width") || 40, this[$d4d06657c043713f$var$Nt] = e("height") || 40;
    }
    build() {
        const t = this;
        if (t.state !== $d4d06657c043713f$var$jt.Init) return;
        if (t.isDisabled()) return void t.emit("disabled");
        const e = t.instance, i = e.container, n = t.getSlides(), s = t.option("type");
        t.type = s;
        const o = t.option("parentEl"), a = t.cn("container"), r = t.cn("track");
        let l = null == o ? void 0 : o.querySelector("." + a);
        l || (l = document.createElement("div"), $d4d06657c043713f$var$P(l, a), o ? o.appendChild(l) : i.after(l)), $d4d06657c043713f$var$P(l, `is-${s}`), $d4d06657c043713f$var$P(i, t.cn("hasThumbs")), t.container = l, t.updateProps();
        let c = l.querySelector("." + r);
        c || (c = document.createElement("div"), $d4d06657c043713f$var$P(c, t.cn("track")), l.appendChild(c)), t.track = c;
        const h = $d4d06657c043713f$var$u({}, {
            track: c,
            infinite: !1,
            center: !0,
            fill: "classic" === s,
            dragFree: !0,
            slidesPerPage: 1,
            transition: !1,
            preload: .25,
            friction: .12,
            Panzoom: {
                maxVelocity: 0
            },
            Dots: !1,
            Navigation: !1,
            classes: {
                container: "f-thumbs",
                viewport: "f-thumbs__viewport",
                track: "f-thumbs__track",
                slide: "f-thumbs__slide"
            }
        }, t.option("Carousel") || {}, {
            Sync: {
                target: e
            },
            slides: n
        }), d = new e.constructor(l, h);
        d.on("createSlide", (e, i)=>{
            t.setProps(i.index), t.emit("createSlide", i, i.el);
        }), d.on("ready", ()=>{
            t.shiftModern(), t.emit("ready");
        }), d.on("refresh", ()=>{
            t.shiftModern();
        }), d.on("Panzoom.click", (e, i, n)=>{
            t.onClick(n);
        }), t.carousel = d, t.state = $d4d06657c043713f$var$jt.Ready;
    }
    onClick(t) {
        t.preventDefault(), t.stopPropagation();
        const e = this.instance, { pages: i, page: n } = e, s = (t)=>{
            if (t) {
                const e = t.closest("[data-carousel-index]");
                if (e) return [
                    parseInt(e.dataset.carouselIndex || "", 10) || 0,
                    e
                ];
            }
            return [
                -1,
                void 0
            ];
        }, o = (t, e)=>{
            const i = document.elementFromPoint(t, e);
            return i ? s(i) : [
                -1,
                void 0
            ];
        };
        let [a, r] = s(t.target);
        if (a > -1) return;
        const l = this[$d4d06657c043713f$var$_t], c = t.clientX, h = t.clientY;
        let [d, u] = o(c - l, h), [p, f] = o(c + l, h);
        u && f ? (a = Math.abs(c - u.getBoundingClientRect().right) < Math.abs(c - f.getBoundingClientRect().left) ? d : p, a === n && (a = a === d ? p : d)) : u ? a = d : f && (a = p), a > -1 && i[a] && e.slideTo(a);
    }
    getShift(t) {
        var e;
        const i = this, { instance: n } = i, s = i.carousel;
        if (!n || !s) return 0;
        const o = i[$d4d06657c043713f$var$Ht], a = i[$d4d06657c043713f$var$_t], r = i.thumbGap, l = i.thumbExtraGap;
        if (!(null === (e = s.slides[t]) || void 0 === e ? void 0 : e.el)) return 0;
        const c = .5 * (o - a), h = n.pages.length - 1;
        let d = n.getProgress(0), u = n.getProgress(h), p = n.getProgress(t, !1, !0), f = 0, g = c + l + r;
        const m = d < 0 && d > -1, v = u > 0 && u < 1;
        return 0 === t ? (f = g * Math.abs(d), v && 1 === d && (f -= g * Math.abs(u))) : t === h ? (f = g * Math.abs(u) * -1, m && -1 === u && (f += g * Math.abs(d))) : m || v ? (f = -1 * g, f += g * Math.abs(d), f += g * (1 - Math.abs(u))) : f = g * p, f;
    }
    setProps(e) {
        var i;
        const n = this;
        if (!n.isModern) return;
        const { instance: s } = n, o = n.carousel;
        if (s && o) {
            const a = null === (i = o.slides[e]) || void 0 === i ? void 0 : i.el;
            if (a && a.childNodes.length) {
                let i = $d4d06657c043713f$var$t(1 - Math.abs(s.getProgress(e))), o = $d4d06657c043713f$var$t(n.getShift(e));
                a.style.setProperty("--progress", i ? i + "" : ""), a.style.setProperty("--shift", o + "");
            }
        }
    }
    shiftModern() {
        const t = this;
        if (!t.isModern) return;
        const { instance: e, track: i } = t, n = e.panzoom, s = t.carousel;
        if (!(e && i && n && s)) return;
        if (n.state === $d4d06657c043713f$var$m.Init || n.state === $d4d06657c043713f$var$m.Destroy) return;
        for (const i of e.slides)t.setProps(i.index);
        let o = (t[$d4d06657c043713f$var$_t] + t.thumbGap) * (s.slides.length || 0);
        i.style.setProperty("--width", o + "");
    }
    cleanup() {
        const t = this;
        t.carousel && t.carousel.destroy(), t.carousel = null, t.container && t.container.remove(), t.container = null, t.track && t.track.remove(), t.track = null, t.state = $d4d06657c043713f$var$jt.Init, $d4d06657c043713f$var$S(t.instance.container, t.cn("hasThumbs"));
    }
    attach() {
        const t = this, e = t.instance;
        e.on("initSlide", t.onInitSlide), e.state === $d4d06657c043713f$var$B.Init ? e.on("initSlides", t.onInitSlides) : t.onInitSlides(), e.on([
            "change",
            "Panzoom.afterTransform"
        ], t.onChange), e.on("Panzoom.refresh", t.onRefresh);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("initSlide", t.onInitSlide), e.off("initSlides", t.onInitSlides), e.off([
            "change",
            "Panzoom.afterTransform"
        ], t.onChange), e.off("Panzoom.refresh", t.onRefresh), t.cleanup();
    }
};
Object.defineProperty($d4d06657c043713f$var$$t, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$Ft
});
const $d4d06657c043713f$var$Wt = Object.assign(Object.assign({}, $d4d06657c043713f$var$Ft), {
    key: "t",
    showOnStart: !0,
    parentEl: null
}), $d4d06657c043713f$var$Xt = "is-masked", $d4d06657c043713f$var$qt = "aria-hidden";
class $d4d06657c043713f$var$Yt extends $d4d06657c043713f$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "ref", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "hidden", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        });
    }
    get isEnabled() {
        const t = this.ref;
        return t && !t.isDisabled();
    }
    get isHidden() {
        return this.hidden;
    }
    onClick(t, e) {
        e.stopPropagation();
    }
    onCreateSlide(t, e) {
        var i, n, s;
        const o = (null === (s = null === (n = null === (i = this.instance) || void 0 === i ? void 0 : i.carousel) || void 0 === n ? void 0 : n.slides[e.index]) || void 0 === s ? void 0 : s.type) || "", a = e.el;
        if (a && o) {
            let t = `for-${o}`;
            [
                "video",
                "youtube",
                "vimeo",
                "html5video"
            ].includes(o) && (t += " for-video"), $d4d06657c043713f$var$P(a, t);
        }
    }
    onInit() {
        var t;
        const e = this, i = e.instance, n = i.carousel;
        if (e.ref || !n) return;
        const s = e.option("parentEl") || i.footer || i.container;
        if (!s) return;
        const o = $d4d06657c043713f$var$u({}, e.options, {
            parentEl: s,
            classes: {
                container: "f-thumbs fancybox__thumbs"
            },
            Carousel: {
                Sync: {
                    friction: i.option("Carousel.friction") || 0
                }
            },
            on: {
                ready: (t)=>{
                    const i = t.container;
                    i && this.hidden && (e.refresh(), i.style.transition = "none", e.hide(), i.offsetHeight, queueMicrotask(()=>{
                        i.style.transition = "", e.show();
                    }));
                }
            }
        });
        o.Carousel = o.Carousel || {}, o.Carousel.on = $d4d06657c043713f$var$u((null === (t = e.options.Carousel) || void 0 === t ? void 0 : t.on) || {}, {
            click: this.onClick,
            createSlide: this.onCreateSlide
        }), n.options.Thumbs = o, n.attachPlugins({
            Thumbs: $d4d06657c043713f$var$$t
        }), e.ref = n.plugins.Thumbs, e.option("showOnStart") || (e.ref.state = $d4d06657c043713f$var$jt.Hidden, e.hidden = !0);
    }
    onResize() {
        var t;
        const e = null === (t = this.ref) || void 0 === t ? void 0 : t.container;
        e && (e.style.maxHeight = "");
    }
    onKeydown(t, e) {
        const i = this.option("key");
        i && i === e && this.toggle();
    }
    toggle() {
        const t = this.ref;
        if (t && !t.isDisabled()) return t.state === $d4d06657c043713f$var$jt.Hidden ? (t.state = $d4d06657c043713f$var$jt.Init, void t.build()) : void (this.hidden ? this.show() : this.hide());
    }
    show() {
        const t = this.ref;
        if (!t || t.isDisabled()) return;
        const e = t.container;
        e && (this.refresh(), e.offsetHeight, e.removeAttribute($d4d06657c043713f$var$qt), e.classList.remove($d4d06657c043713f$var$Xt), this.hidden = !1);
    }
    hide() {
        const t = this.ref, e = t && t.container;
        e && (this.refresh(), e.offsetHeight, e.classList.add($d4d06657c043713f$var$Xt), e.setAttribute($d4d06657c043713f$var$qt, "true")), this.hidden = !0;
    }
    refresh() {
        const t = this.ref;
        if (!t || !t.state) return;
        const e = t.container, i = (null == e ? void 0 : e.firstChild) || null;
        e && i && i.childNodes.length && (e.style.maxHeight = `${i.getBoundingClientRect().height}px`);
    }
    attach() {
        const t = this, e = t.instance;
        e.state === $d4d06657c043713f$var$rt.Init ? e.on("Carousel.init", t.onInit) : t.onInit(), e.on("resize", t.onResize), e.on("keydown", t.onKeydown);
    }
    detach() {
        var t;
        const e = this, i = e.instance;
        i.off("Carousel.init", e.onInit), i.off("resize", e.onResize), i.off("keydown", e.onKeydown), null === (t = i.carousel) || void 0 === t || t.detachPlugins([
            "Thumbs"
        ]), e.ref = null;
    }
}
Object.defineProperty($d4d06657c043713f$var$Yt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$Wt
});
const $d4d06657c043713f$var$Vt = {
    panLeft: {
        icon: '<svg><path d="M5 12h14M5 12l6 6M5 12l6-6"/></svg>',
        change: {
            panX: -100
        }
    },
    panRight: {
        icon: '<svg><path d="M5 12h14M13 18l6-6M13 6l6 6"/></svg>',
        change: {
            panX: 100
        }
    },
    panUp: {
        icon: '<svg><path d="M12 5v14M18 11l-6-6M6 11l6-6"/></svg>',
        change: {
            panY: -100
        }
    },
    panDown: {
        icon: '<svg><path d="M12 5v14M18 13l-6 6M6 13l6 6"/></svg>',
        change: {
            panY: 100
        }
    },
    zoomIn: {
        icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M11 8v6M8 11h6"/></svg>',
        action: "zoomIn"
    },
    zoomOut: {
        icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "zoomOut"
    },
    toggle1to1: {
        icon: '<svg><path d="M3.51 3.07c5.74.02 11.48-.02 17.22.02 1.37.1 2.34 1.64 2.18 3.13 0 4.08.02 8.16 0 12.23-.1 1.54-1.47 2.64-2.79 2.46-5.61-.01-11.24.02-16.86-.01-1.36-.12-2.33-1.65-2.17-3.14 0-4.07-.02-8.16 0-12.23.1-1.36 1.22-2.48 2.42-2.46Z"/><path d="M5.65 8.54h1.49v6.92m8.94-6.92h1.49v6.92M11.5 9.4v.02m0 5.18v0"/></svg>',
        action: "toggleZoom"
    },
    toggleZoom: {
        icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "toggleZoom"
    },
    iterateZoom: {
        icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "iterateZoom"
    },
    rotateCCW: {
        icon: '<svg><path d="M15 4.55a8 8 0 0 0-6 14.9M9 15v5H4M18.37 7.16v.01M13 19.94v.01M16.84 18.37v.01M19.37 15.1v.01M19.94 11v.01"/></svg>',
        action: "rotateCCW"
    },
    rotateCW: {
        icon: '<svg><path d="M9 4.55a8 8 0 0 1 6 14.9M15 15v5h5M5.63 7.16v.01M4.06 11v.01M4.63 15.1v.01M7.16 18.37v.01M11 19.94v.01"/></svg>',
        action: "rotateCW"
    },
    flipX: {
        icon: '<svg style="stroke-width: 1.3"><path d="M12 3v18M16 7v10h5L16 7M8 7v10H3L8 7"/></svg>',
        action: "flipX"
    },
    flipY: {
        icon: '<svg style="stroke-width: 1.3"><path d="M3 12h18M7 16h10L7 21v-5M7 8h10L7 3v5"/></svg>',
        action: "flipY"
    },
    fitX: {
        icon: '<svg><path d="M4 12V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6M10 18H3M21 18h-7M6 15l-3 3 3 3M18 15l3 3-3 3"/></svg>',
        action: "fitX"
    },
    fitY: {
        icon: '<svg><path d="M12 20H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h6M18 14v7M18 3v7M15 18l3 3 3-3M15 6l3-3 3 3"/></svg>',
        action: "fitY"
    },
    reset: {
        icon: '<svg><path d="M20 11A8.1 8.1 0 0 0 4.5 9M4 5v4h4M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/></svg>',
        action: "reset"
    },
    toggleFS: {
        icon: '<svg><g><path d="M14.5 9.5 21 3m0 0h-6m6 0v6M3 21l6.5-6.5M3 21v-6m0 6h6"/></g><g><path d="m14 10 7-7m-7 7h6m-6 0V4M3 21l7-7m0 0v6m0-6H4"/></g></svg>',
        action: "toggleFS"
    }
};
var $d4d06657c043713f$var$Zt;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Disabled = 2] = "Disabled";
}($d4d06657c043713f$var$Zt || ($d4d06657c043713f$var$Zt = {}));
const $d4d06657c043713f$var$Ut = {
    absolute: "auto",
    display: {
        left: [
            "infobar"
        ],
        middle: [],
        right: [
            "iterateZoom",
            "slideshow",
            "fullscreen",
            "thumbs",
            "close"
        ]
    },
    enabled: "auto",
    items: {
        infobar: {
            tpl: '<div class="fancybox__infobar" tabindex="-1"><span data-fancybox-current-index></span>/<span data-fancybox-count></span></div>'
        },
        download: {
            tpl: '<a class="f-button" title="{{DOWNLOAD}}" data-fancybox-download href="javasript:;"><svg><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5 5-5M12 4v12"/></svg></a>'
        },
        prev: {
            tpl: '<button class="f-button" title="{{PREV}}" data-fancybox-prev><svg><path d="m15 6-6 6 6 6"/></svg></button>'
        },
        next: {
            tpl: '<button class="f-button" title="{{NEXT}}" data-fancybox-next><svg><path d="m9 6 6 6-6 6"/></svg></button>'
        },
        slideshow: {
            tpl: '<button class="f-button" title="{{TOGGLE_SLIDESHOW}}" data-fancybox-toggle-slideshow><svg><g><path d="M8 4v16l13 -8z"></path></g><g><path d="M8 4v15M17 4v15"/></g></svg></button>'
        },
        fullscreen: {
            tpl: '<button class="f-button" title="{{TOGGLE_FULLSCREEN}}" data-fancybox-toggle-fullscreen><svg><g><path d="M4 8V6a2 2 0 0 1 2-2h2M4 16v2a2 2 0 0 0 2 2h2M16 4h2a2 2 0 0 1 2 2v2M16 20h2a2 2 0 0 0 2-2v-2"/></g><g><path d="M15 19v-2a2 2 0 0 1 2-2h2M15 5v2a2 2 0 0 0 2 2h2M5 15h2a2 2 0 0 1 2 2v2M5 9h2a2 2 0 0 0 2-2V5"/></g></svg></button>'
        },
        thumbs: {
            tpl: '<button class="f-button" title="{{TOGGLE_THUMBS}}" data-fancybox-toggle-thumbs><svg><circle cx="5.5" cy="5.5" r="1"/><circle cx="12" cy="5.5" r="1"/><circle cx="18.5" cy="5.5" r="1"/><circle cx="5.5" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="18.5" cy="12" r="1"/><circle cx="5.5" cy="18.5" r="1"/><circle cx="12" cy="18.5" r="1"/><circle cx="18.5" cy="18.5" r="1"/></svg></button>'
        },
        close: {
            tpl: '<button class="f-button" title="{{CLOSE}}" data-fancybox-close><svg><path d="m19.5 4.5-15 15M4.5 4.5l15 15"/></svg></button>'
        }
    },
    parentEl: null
}, $d4d06657c043713f$var$Gt = {
    tabindex: "-1",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
}, $d4d06657c043713f$var$Kt = "has-toolbar", $d4d06657c043713f$var$Jt = "fancybox__toolbar";
class $d4d06657c043713f$var$Qt extends $d4d06657c043713f$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d4d06657c043713f$var$Zt.Init
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onReady(t) {
        var e;
        if (!t.carousel) return;
        let i = this.option("display"), n = this.option("absolute"), s = this.option("enabled");
        if ("auto" === s) {
            const t = this.instance.carousel;
            let e = 0;
            if (t) for (const i of t.slides)(i.panzoom || "image" === i.type) && e++;
            e || (s = !1);
        }
        s || (i = void 0);
        let o = 0;
        const a = {
            left: [],
            middle: [],
            right: []
        };
        if (i) for (const t of [
            "left",
            "middle",
            "right"
        ])for (const n of i[t]){
            const i = this.createEl(n);
            i && (null === (e = a[t]) || void 0 === e || e.push(i), o++);
        }
        let r = null;
        if (o && (r = this.createContainer()), r) {
            for (const [t, e] of Object.entries(a)){
                const i = document.createElement("div");
                $d4d06657c043713f$var$P(i, $d4d06657c043713f$var$Jt + "__column is-" + t);
                for (const t of e)i.appendChild(t);
                "auto" !== n || "middle" !== t || e.length || (n = !0), r.appendChild(i);
            }
            !0 === n && $d4d06657c043713f$var$P(r, "is-absolute"), this.state = $d4d06657c043713f$var$Zt.Ready, this.onRefresh();
        } else this.state = $d4d06657c043713f$var$Zt.Disabled;
    }
    onClick(t) {
        var e, i;
        const n = this.instance, s = n.getSlide(), o = null == s ? void 0 : s.panzoom, a = t.target, r = a && $d4d06657c043713f$var$E(a) ? a.dataset : null;
        if (!r) return;
        if (void 0 !== r.fancyboxToggleThumbs) return t.preventDefault(), t.stopPropagation(), void (null === (e = n.plugins.Thumbs) || void 0 === e || e.toggle());
        if (void 0 !== r.fancyboxToggleFullscreen) return t.preventDefault(), t.stopPropagation(), void this.instance.toggleFullscreen();
        if (void 0 !== r.fancyboxToggleSlideshow) {
            t.preventDefault(), t.stopPropagation();
            const e = null === (i = n.carousel) || void 0 === i ? void 0 : i.plugins.Autoplay;
            let s = e.isActive;
            return o && "mousemove" === o.panMode && !s && o.reset(), void (s ? e.stop() : e.start());
        }
        const l = r.panzoomAction, c = r.panzoomChange;
        if ((c || l) && (t.preventDefault(), t.stopPropagation()), c) {
            let t = {};
            try {
                t = JSON.parse(c);
            } catch (t) {}
            o && o.applyChange(t);
        } else l && o && o[l] && o[l]();
    }
    onChange() {
        this.onRefresh();
    }
    onRefresh() {
        if (this.instance.isClosing()) return;
        const t = this.container;
        if (!t) return;
        const e = this.instance.getSlide();
        if (!e || e.state !== $d4d06657c043713f$var$lt.Ready) return;
        const i = e && !e.error && e.panzoom;
        for (const e of t.querySelectorAll("[data-panzoom-action]"))i ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        let n = i && i.canZoomIn(), s = i && i.canZoomOut();
        for (const e of t.querySelectorAll('[data-panzoom-action="zoomIn"]'))n ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        for (const e of t.querySelectorAll('[data-panzoom-action="zoomOut"]'))s ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        for (const e of t.querySelectorAll('[data-panzoom-action="toggleZoom"],[data-panzoom-action="iterateZoom"]')){
            s || n ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
            const t = e.querySelector("g");
            t && (t.style.display = n ? "" : "none");
        }
    }
    onDone(t, e) {
        var i;
        null === (i = e.panzoom) || void 0 === i || i.on("afterTransform", ()=>{
            this.instance.isCurrentSlide(e) && this.onRefresh();
        }), this.instance.isCurrentSlide(e) && this.onRefresh();
    }
    createContainer() {
        const t = this.instance.container;
        if (!t) return null;
        const e = this.option("parentEl") || t;
        let i = e.querySelector("." + $d4d06657c043713f$var$Jt);
        return i || (i = document.createElement("div"), $d4d06657c043713f$var$P(i, $d4d06657c043713f$var$Jt), e.prepend(i)), i.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !0
        }), t && $d4d06657c043713f$var$P(t, $d4d06657c043713f$var$Kt), this.container = i, i;
    }
    createEl(t) {
        const e = this.instance, i = e.carousel;
        if (!i) return null;
        if ("toggleFS" === t) return null;
        if ("fullscreen" === t && !$d4d06657c043713f$var$ot()) return null;
        let s = null;
        const o = i.slides.length || 0;
        let a = 0, r = 0;
        for (const t of i.slides)(t.panzoom || "image" === t.type) && a++, ("image" === t.type || t.downloadSrc) && r++;
        if (o < 2 && [
            "infobar",
            "prev",
            "next"
        ].includes(t)) return s;
        if (void 0 !== $d4d06657c043713f$var$Vt[t] && !a) return null;
        if ("download" === t && !r) return null;
        if ("thumbs" === t) {
            const t = e.plugins.Thumbs;
            if (!t || !t.isEnabled) return null;
        }
        if ("slideshow" === t) {
            if (!i.plugins.Autoplay || o < 2) return null;
        }
        if (void 0 !== $d4d06657c043713f$var$Vt[t]) {
            const e = $d4d06657c043713f$var$Vt[t];
            s = document.createElement("button"), s.setAttribute("title", this.instance.localize(`{{${t.toUpperCase()}}}`)), $d4d06657c043713f$var$P(s, "f-button"), e.action && (s.dataset.panzoomAction = e.action), e.change && (s.dataset.panzoomChange = JSON.stringify(e.change)), s.appendChild($d4d06657c043713f$var$n(this.instance.localize(e.icon)));
        } else {
            const e = (this.option("items") || [])[t];
            e && (s = $d4d06657c043713f$var$n(this.instance.localize(e.tpl)), "function" == typeof e.click && s.addEventListener("click", (t)=>{
                t.preventDefault(), t.stopPropagation(), "function" == typeof e.click && e.click.call(this, this, t);
            }));
        }
        const l = null == s ? void 0 : s.querySelector("svg");
        if (l) for (const [t, e] of Object.entries($d4d06657c043713f$var$Gt))l.getAttribute(t) || l.setAttribute(t, String(e));
        return s;
    }
    removeContainer() {
        const t = this.container;
        t && t.remove(), this.container = null, this.state = $d4d06657c043713f$var$Zt.Disabled;
        const e = this.instance.container;
        e && $d4d06657c043713f$var$S(e, $d4d06657c043713f$var$Kt);
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.initSlides", t.onReady), e.on("done", t.onDone), e.on([
            "reveal",
            "Carousel.change"
        ], t.onChange), t.onReady(t.instance);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.initSlides", t.onReady), e.off("done", t.onDone), e.off([
            "reveal",
            "Carousel.change"
        ], t.onChange), t.removeContainer();
    }
}
Object.defineProperty($d4d06657c043713f$var$Qt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$Ut
});
const $d4d06657c043713f$var$te = {
    Hash: class extends $d4d06657c043713f$var$_ {
        onReady() {
            $d4d06657c043713f$var$ht = !1;
        }
        onChange(t) {
            $d4d06657c043713f$var$ut && clearTimeout($d4d06657c043713f$var$ut);
            const { hash: e } = $d4d06657c043713f$var$pt(), { hash: i } = $d4d06657c043713f$var$ft(), n = t.isOpeningSlide(t.getSlide());
            n && ($d4d06657c043713f$var$ct = i === e ? "" : i), e && e !== i && ($d4d06657c043713f$var$ut = setTimeout(()=>{
                try {
                    if (t.state === $d4d06657c043713f$var$rt.Ready) {
                        let t = "replaceState";
                        n && !$d4d06657c043713f$var$dt && (t = "pushState", $d4d06657c043713f$var$dt = !0), window.history[t]({}, document.title, window.location.pathname + window.location.search + e);
                    }
                } catch (t) {}
            }, 300));
        }
        onClose(t) {
            if ($d4d06657c043713f$var$ut && clearTimeout($d4d06657c043713f$var$ut), !$d4d06657c043713f$var$ht && $d4d06657c043713f$var$dt) return $d4d06657c043713f$var$dt = !1, $d4d06657c043713f$var$ht = !1, void window.history.back();
            if (!$d4d06657c043713f$var$ht) try {
                window.history.replaceState({}, document.title, window.location.pathname + window.location.search + ($d4d06657c043713f$var$ct || ""));
            } catch (t) {}
        }
        attach() {
            const t = this.instance;
            t.on("ready", this.onReady), t.on([
                "Carousel.ready",
                "Carousel.change"
            ], this.onChange), t.on("close", this.onClose);
        }
        detach() {
            const t = this.instance;
            t.off("ready", this.onReady), t.off([
                "Carousel.ready",
                "Carousel.change"
            ], this.onChange), t.off("close", this.onClose);
        }
        static parseURL() {
            return $d4d06657c043713f$var$ft();
        }
        static startFromUrl() {
            $d4d06657c043713f$var$gt();
        }
        static destroy() {
            window.removeEventListener("hashchange", $d4d06657c043713f$var$vt, !1);
        }
    },
    Html: $d4d06657c043713f$var$Lt,
    Images: $d4d06657c043713f$var$wt,
    Slideshow: $d4d06657c043713f$var$Dt,
    Thumbs: $d4d06657c043713f$var$Yt,
    Toolbar: $d4d06657c043713f$var$Qt
}, $d4d06657c043713f$var$ee = "with-fancybox", $d4d06657c043713f$var$ie = "hide-scrollbar", $d4d06657c043713f$var$ne = "--fancybox-scrollbar-compensate", $d4d06657c043713f$var$se = "--fancybox-body-margin", $d4d06657c043713f$var$oe = "aria-hidden", $d4d06657c043713f$var$ae = "is-using-tab", $d4d06657c043713f$var$re = "is-animated", $d4d06657c043713f$var$le = "is-compact", $d4d06657c043713f$var$ce = "is-loading", $d4d06657c043713f$var$he = "is-opening", $d4d06657c043713f$var$de = "has-caption", $d4d06657c043713f$var$ue = "disabled", $d4d06657c043713f$var$pe = "tabindex", $d4d06657c043713f$var$fe = "download", $d4d06657c043713f$var$ge = "href", $d4d06657c043713f$var$me = "src", $d4d06657c043713f$var$ve = (t)=>"string" == typeof t, $d4d06657c043713f$var$be = function() {
    var t = window.getSelection();
    return !!t && "Range" === t.type;
};
let $d4d06657c043713f$var$ye, $d4d06657c043713f$var$we = null, $d4d06657c043713f$var$xe = null, $d4d06657c043713f$var$Ee = 0, $d4d06657c043713f$var$Se = 0, $d4d06657c043713f$var$Pe = 0, $d4d06657c043713f$var$Ce = 0;
const $d4d06657c043713f$var$Te = new Map;
let $d4d06657c043713f$var$Me = 0;
class $d4d06657c043713f$export$cb45b08d97cdc4fd extends $d4d06657c043713f$var$g {
    get isIdle() {
        return this.idle;
    }
    get isCompact() {
        return this.option("compact");
    }
    constructor(t = [], e = {}, i = {}){
        super(e), Object.defineProperty(this, "userSlides", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "userPlugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "idle", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "idleTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "clickTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "pwt", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "ignoreFocusChange", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "startedFs", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d4d06657c043713f$var$rt.Init
        }), Object.defineProperty(this, "id", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "caption", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "footer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "carousel", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "lastFocus", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "prevMouseMoveEvent", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), $d4d06657c043713f$var$ye || ($d4d06657c043713f$var$ye = $d4d06657c043713f$var$ot()), this.id = e.id || ++$d4d06657c043713f$var$Me, $d4d06657c043713f$var$Te.set(this.id, this), this.userSlides = t, this.userPlugins = i, queueMicrotask(()=>{
            this.init();
        });
    }
    init() {
        if (this.state === $d4d06657c043713f$var$rt.Destroy) return;
        this.state = $d4d06657c043713f$var$rt.Init, this.attachPlugins(Object.assign(Object.assign({}, $d4d06657c043713f$export$cb45b08d97cdc4fd.Plugins), this.userPlugins)), this.emit("init"), this.emit("attachPlugins"), !0 === this.option("hideScrollbar") && (()=>{
            if (!$d4d06657c043713f$var$et) return;
            const t = document, e = t.body, i = t.documentElement;
            if (e.classList.contains($d4d06657c043713f$var$ie)) return;
            let n = window.innerWidth - i.getBoundingClientRect().width;
            const s = parseFloat(window.getComputedStyle(e).marginRight);
            n < 0 && (n = 0), i.style.setProperty($d4d06657c043713f$var$ne, `${n}px`), s && e.style.setProperty($d4d06657c043713f$var$se, `${s}px`), e.classList.add($d4d06657c043713f$var$ie);
        })(), this.initLayout(), this.scale();
        const t = ()=>{
            this.initCarousel(this.userSlides), this.state = $d4d06657c043713f$var$rt.Ready, this.attachEvents(), this.emit("ready"), setTimeout(()=>{
                this.container && this.container.setAttribute($d4d06657c043713f$var$oe, "false");
            }, 16);
        };
        this.option("Fullscreen.autoStart") && $d4d06657c043713f$var$ye && !$d4d06657c043713f$var$ye.isFullscreen() ? $d4d06657c043713f$var$ye.request().then(()=>{
            this.startedFs = !0, t();
        }).catch(()=>t()) : t();
    }
    initLayout() {
        var t, e;
        const i = this.option("parentEl") || document.body, s = $d4d06657c043713f$var$n(this.localize(this.option("tpl.main") || ""));
        if (s) {
            if (s.setAttribute("id", `fancybox-${this.id}`), s.setAttribute("aria-label", this.localize("{{MODAL}}")), s.classList.toggle($d4d06657c043713f$var$le, this.isCompact), $d4d06657c043713f$var$P(s, this.option("mainClass") || ""), $d4d06657c043713f$var$P(s, $d4d06657c043713f$var$he), this.container = s, this.footer = s.querySelector(".fancybox__footer"), i.appendChild(s), $d4d06657c043713f$var$P(document.documentElement, $d4d06657c043713f$var$ee), $d4d06657c043713f$var$we && $d4d06657c043713f$var$xe || ($d4d06657c043713f$var$we = document.createElement("span"), $d4d06657c043713f$var$P($d4d06657c043713f$var$we, "fancybox-focus-guard"), $d4d06657c043713f$var$we.setAttribute($d4d06657c043713f$var$pe, "0"), $d4d06657c043713f$var$we.setAttribute($d4d06657c043713f$var$oe, "true"), $d4d06657c043713f$var$we.setAttribute("aria-label", "Focus guard"), $d4d06657c043713f$var$xe = $d4d06657c043713f$var$we.cloneNode(), null === (t = s.parentElement) || void 0 === t || t.insertBefore($d4d06657c043713f$var$we, s), null === (e = s.parentElement) || void 0 === e || e.append($d4d06657c043713f$var$xe)), s.addEventListener("mousedown", (t)=>{
                $d4d06657c043713f$var$Ee = t.pageX, $d4d06657c043713f$var$Se = t.pageY, $d4d06657c043713f$var$S(s, $d4d06657c043713f$var$ae);
            }), this.option("closeExisting")) for (const t of $d4d06657c043713f$var$Te.values())t.id !== this.id && t.close();
            else this.option("animated") && ($d4d06657c043713f$var$P(s, $d4d06657c043713f$var$re), setTimeout(()=>{
                this.isClosing() || $d4d06657c043713f$var$S(s, $d4d06657c043713f$var$re);
            }, 350));
            this.emit("initLayout");
        }
    }
    initCarousel(t) {
        const i = this.container;
        if (!i) return;
        const n = i.querySelector(".fancybox__carousel");
        if (!n) return;
        const s = this.carousel = new $d4d06657c043713f$export$144901db2ea8e967(n, $d4d06657c043713f$var$u({}, {
            slides: t,
            transition: "fade",
            Panzoom: {
                lockAxis: this.option("dragToClose") ? "xy" : "x",
                infinite: !!this.option("dragToClose") && "y"
            },
            Dots: !1,
            Navigation: {
                classes: {
                    container: "fancybox__nav",
                    button: "f-button",
                    isNext: "is-next",
                    isPrev: "is-prev"
                }
            },
            initialPage: this.option("startIndex"),
            l10n: this.option("l10n")
        }, this.option("Carousel") || {}));
        s.on("*", (t, e, ...i)=>{
            this.emit(`Carousel.${e}`, t, ...i);
        }), s.on([
            "ready",
            "change"
        ], ()=>{
            this.manageCaption();
        }), this.on("Carousel.removeSlide", (t, e, i)=>{
            this.clearContent(i), i.state = void 0;
        }), s.on("Panzoom.touchStart", ()=>{
            var t, e;
            this.isCompact || this.endIdle(), (null === (t = document.activeElement) || void 0 === t ? void 0 : t.closest(".f-thumbs")) && (null === (e = this.container) || void 0 === e || e.focus());
        }), s.on("settle", ()=>{
            this.idleTimer || this.isCompact || !this.option("idle") || this.setIdle(), this.option("autoFocus") && !this.isClosing && this.checkFocus();
        }), this.option("dragToClose") && (s.on("Panzoom.afterTransform", (t, i)=>{
            const n = this.getSlide();
            if (n && $d4d06657c043713f$var$e(n.el)) return;
            const s = this.container;
            if (s) {
                const t = Math.abs(i.current.f), e = t < 1 ? "" : Math.max(.5, Math.min(1, 1 - t / i.contentRect.fitHeight * 1.5));
                s.style.setProperty("--fancybox-ts", e ? "0s" : ""), s.style.setProperty("--fancybox-opacity", e + "");
            }
        }), s.on("Panzoom.touchEnd", (t, i, n)=>{
            var s;
            const o = this.getSlide();
            if (o && $d4d06657c043713f$var$e(o.el)) return;
            if (i.isMobile && document.activeElement && -1 !== [
                "TEXTAREA",
                "INPUT"
            ].indexOf(null === (s = document.activeElement) || void 0 === s ? void 0 : s.nodeName)) return;
            const a = Math.abs(i.dragOffset.y);
            "y" === i.lockedAxis && (a >= 200 || a >= 50 && i.dragOffset.time < 300) && (n && n.cancelable && n.preventDefault(), this.close(n, "f-throwOut" + (i.current.f < 0 ? "Up" : "Down")));
        })), s.on("change", (t)=>{
            var e;
            let i = null === (e = this.getSlide()) || void 0 === e ? void 0 : e.triggerEl;
            if (i) {
                const e = new CustomEvent("slideTo", {
                    bubbles: !0,
                    cancelable: !0,
                    detail: t.page
                });
                i.dispatchEvent(e);
            }
        }), s.on([
            "refresh",
            "change"
        ], (t)=>{
            const e = this.container;
            if (!e) return;
            for (const i of e.querySelectorAll("[data-fancybox-current-index]"))i.innerHTML = t.page + 1;
            for (const i of e.querySelectorAll("[data-fancybox-count]"))i.innerHTML = t.pages.length;
            if (!t.isInfinite) {
                for (const i of e.querySelectorAll("[data-fancybox-next]"))t.page < t.pages.length - 1 ? (i.removeAttribute($d4d06657c043713f$var$ue), i.removeAttribute($d4d06657c043713f$var$pe)) : (i.setAttribute($d4d06657c043713f$var$ue, ""), i.setAttribute($d4d06657c043713f$var$pe, "-1"));
                for (const i of e.querySelectorAll("[data-fancybox-prev]"))t.page > 0 ? (i.removeAttribute($d4d06657c043713f$var$ue), i.removeAttribute($d4d06657c043713f$var$pe)) : (i.setAttribute($d4d06657c043713f$var$ue, ""), i.setAttribute($d4d06657c043713f$var$pe, "-1"));
            }
            const i = this.getSlide();
            if (!i) return;
            let n = i.downloadSrc || "";
            n || "image" !== i.type || i.error || !$d4d06657c043713f$var$ve(i[$d4d06657c043713f$var$me]) || (n = i[$d4d06657c043713f$var$me]);
            for (const t of e.querySelectorAll("[data-fancybox-download]")){
                const e = i.downloadFilename;
                n ? (t.removeAttribute($d4d06657c043713f$var$ue), t.removeAttribute($d4d06657c043713f$var$pe), t.setAttribute($d4d06657c043713f$var$ge, n), t.setAttribute($d4d06657c043713f$var$fe, e || n), t.setAttribute("target", "_blank")) : (t.setAttribute($d4d06657c043713f$var$ue, ""), t.setAttribute($d4d06657c043713f$var$pe, "-1"), t.removeAttribute($d4d06657c043713f$var$ge), t.removeAttribute($d4d06657c043713f$var$fe));
            }
        }), this.emit("initCarousel");
    }
    attachEvents() {
        const t = this, e = t.container;
        if (!e) return;
        e.addEventListener("click", t.onClick, {
            passive: !1,
            capture: !1
        }), e.addEventListener("wheel", t.onWheel, {
            passive: !1,
            capture: !1
        }), document.addEventListener("keydown", t.onKeydown, {
            passive: !1,
            capture: !0
        }), document.addEventListener("visibilitychange", t.onVisibilityChange, !1), document.addEventListener("mousemove", t.onMousemove), t.option("trapFocus") && document.addEventListener("focus", t.onFocus, !0), window.addEventListener("resize", t.onResize);
        const i = window.visualViewport;
        i && (i.addEventListener("scroll", t.onResize), i.addEventListener("resize", t.onResize));
    }
    detachEvents() {
        const t = this, e = t.container;
        if (!e) return;
        document.removeEventListener("keydown", t.onKeydown, {
            passive: !1,
            capture: !0
        }), e.removeEventListener("wheel", t.onWheel, {
            passive: !1,
            capture: !1
        }), e.removeEventListener("click", t.onClick, {
            passive: !1,
            capture: !1
        }), document.removeEventListener("mousemove", t.onMousemove), window.removeEventListener("resize", t.onResize);
        const i = window.visualViewport;
        i && (i.removeEventListener("resize", t.onResize), i.removeEventListener("scroll", t.onResize)), document.removeEventListener("visibilitychange", t.onVisibilityChange, !1), document.removeEventListener("focus", t.onFocus, !0);
    }
    scale() {
        const t = this.container;
        if (!t) return;
        const e = window.visualViewport, i = Math.max(1, (null == e ? void 0 : e.scale) || 1);
        let n = "", s = "", o = "";
        if (e && i > 1) {
            let t = `${e.offsetLeft}px`, a = `${e.offsetTop}px`;
            n = e.width * i + "px", s = e.height * i + "px", o = `translate3d(${t}, ${a}, 0) scale(${1 / i})`;
        }
        t.style.transform = o, t.style.width = n, t.style.height = s;
    }
    onClick(t) {
        var e;
        const { container: i, isCompact: n } = this;
        if (!i || this.isClosing()) return;
        !n && this.option("idle") && this.resetIdle();
        const s = t.composedPath()[0];
        if (s.closest(".fancybox-spinner") || s.closest("[data-fancybox-close]")) return t.preventDefault(), void this.close(t);
        if (s.closest("[data-fancybox-prev]")) return t.preventDefault(), void this.prev();
        if (s.closest("[data-fancybox-next]")) return t.preventDefault(), void this.next();
        if ("click" === t.type && 0 === t.detail) return;
        if (Math.abs(t.pageX - $d4d06657c043713f$var$Ee) > 30 || Math.abs(t.pageY - $d4d06657c043713f$var$Se) > 30) return;
        const o = document.activeElement;
        if ($d4d06657c043713f$var$be() && o && i.contains(o)) return;
        if (n && "image" === (null === (e = this.getSlide()) || void 0 === e ? void 0 : e.type)) return void (this.clickTimer ? (clearTimeout(this.clickTimer), this.clickTimer = null) : this.clickTimer = setTimeout(()=>{
            this.toggleIdle(), this.clickTimer = null;
        }, 350));
        if (this.emit("click", t), t.defaultPrevented) return;
        let a = !1;
        if (s.closest(".fancybox__content")) {
            if (o) {
                if (o.closest("[contenteditable]")) return;
                s.matches($d4d06657c043713f$var$nt) || o.blur();
            }
            if ($d4d06657c043713f$var$be()) return;
            a = this.option("contentClick");
        } else s.closest(".fancybox__carousel") && !s.matches($d4d06657c043713f$var$nt) && (a = this.option("backdropClick"));
        "close" === a ? (t.preventDefault(), this.close(t)) : "next" === a ? (t.preventDefault(), this.next()) : "prev" === a && (t.preventDefault(), this.prev());
    }
    onWheel(t) {
        const e = t.target;
        let n = this.option("wheel", t);
        e.closest(".fancybox__thumbs") && (n = "slide");
        const s = "slide" === n, o = [
            -t.deltaX || 0,
            -t.deltaY || 0,
            -t.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        }), a = Math.max(-1, Math.min(1, o)), r = Date.now();
        this.pwt && r - this.pwt < 300 ? s && t.preventDefault() : (this.pwt = r, this.emit("wheel", t, a), t.defaultPrevented || ("close" === n ? (t.preventDefault(), this.close(t)) : "slide" === n && ($d4d06657c043713f$var$i(e) || (t.preventDefault(), this[a > 0 ? "prev" : "next"]()))));
    }
    onScroll() {
        window.scrollTo($d4d06657c043713f$var$Pe, $d4d06657c043713f$var$Ce);
    }
    onKeydown(t) {
        if (!this.isTopmost()) return;
        this.isCompact || !this.option("idle") || this.isClosing() || this.resetIdle();
        const e = t.key, i = this.option("keyboard");
        if (!i) return;
        const n = t.composedPath()[0], s = document.activeElement && document.activeElement.classList, o = s && s.contains("f-button") || n.dataset.carouselPage || n.dataset.carouselIndex;
        if ("Escape" !== e && !o && $d4d06657c043713f$var$E(n)) {
            if (n.isContentEditable || -1 !== [
                "TEXTAREA",
                "OPTION",
                "INPUT",
                "SELECT",
                "VIDEO"
            ].indexOf(n.nodeName)) return;
        }
        if ("Tab" === t.key ? $d4d06657c043713f$var$P(this.container, $d4d06657c043713f$var$ae) : $d4d06657c043713f$var$S(this.container, $d4d06657c043713f$var$ae), t.ctrlKey || t.altKey || t.shiftKey) return;
        this.emit("keydown", e, t);
        const a = i[e];
        a && "function" == typeof this[a] && (t.preventDefault(), this[a]());
    }
    onResize() {
        const t = this.container;
        if (!t) return;
        const e = this.isCompact;
        t.classList.toggle($d4d06657c043713f$var$le, e), this.manageCaption(this.getSlide()), this.isCompact ? this.clearIdle() : this.endIdle(), this.scale(), this.emit("resize");
    }
    onFocus(t) {
        this.isTopmost() && this.checkFocus(t);
    }
    onMousemove(t) {
        this.prevMouseMoveEvent = t, !this.isCompact && this.option("idle") && this.resetIdle();
    }
    onVisibilityChange() {
        "visible" === document.visibilityState ? this.checkFocus() : this.endIdle();
    }
    manageCloseBtn(t) {
        const e = this.optionFor(t, "closeButton") || !1;
        if ("auto" === e) {
            const t = this.plugins.Toolbar;
            if (t && t.state === $d4d06657c043713f$var$Zt.Ready) return;
        }
        if (!e) return;
        if (!t.contentEl || t.closeBtnEl) return;
        const i = this.option("tpl.closeButton");
        if (i) {
            const e = $d4d06657c043713f$var$n(this.localize(i));
            t.closeBtnEl = t.contentEl.appendChild(e), t.el && $d4d06657c043713f$var$P(t.el, "has-close-btn");
        }
    }
    manageCaption(t) {
        var e, i;
        const n = "fancybox__caption", s = this.container;
        if (!s) return;
        $d4d06657c043713f$var$S(s, $d4d06657c043713f$var$de);
        const o = this.isCompact || this.option("commonCaption"), a = !o;
        if (this.caption && this.stop(this.caption), a && this.caption && (this.caption.remove(), this.caption = null), o && !this.caption) for (const t of (null === (e = this.carousel) || void 0 === e ? void 0 : e.slides) || [])t.captionEl && (t.captionEl.remove(), t.captionEl = void 0, $d4d06657c043713f$var$S(t.el, $d4d06657c043713f$var$de), null === (i = t.el) || void 0 === i || i.removeAttribute("aria-labelledby"));
        if (t || (t = this.getSlide()), !t || o && !this.isCurrentSlide(t)) return;
        const r = t.el;
        let l = this.optionFor(t, "caption", "");
        if (!l) return void (o && this.caption && this.animate(this.caption, "f-fadeOut", ()=>{
            this.caption && (this.caption.innerHTML = "");
        }));
        let c = null;
        if (a) {
            if (c = t.captionEl || null, r && !c) {
                const e = n + `_${this.id}_${t.index}`;
                c = document.createElement("div"), $d4d06657c043713f$var$P(c, n), c.setAttribute("id", e), t.captionEl = r.appendChild(c), $d4d06657c043713f$var$P(r, $d4d06657c043713f$var$de), r.setAttribute("aria-labelledby", e);
            }
        } else {
            if (c = this.caption, c || (c = s.querySelector("." + n)), !c) {
                c = document.createElement("div"), c.dataset.fancyboxCaption = "", $d4d06657c043713f$var$P(c, n);
                (this.footer || s).prepend(c);
            }
            $d4d06657c043713f$var$P(s, $d4d06657c043713f$var$de), this.caption = c;
        }
        c && (c.innerHTML = "", $d4d06657c043713f$var$ve(l) || "number" == typeof l ? c.innerHTML = l + "" : l instanceof HTMLElement && c.appendChild(l));
    }
    checkFocus(t) {
        this.focus(t);
    }
    focus(t) {
        var e;
        if (this.ignoreFocusChange) return;
        const i = document.activeElement || null, n = (null == t ? void 0 : t.target) || null, s = this.container, o = null === (e = this.carousel) || void 0 === e ? void 0 : e.viewport;
        if (!s || !o) return;
        if (!t && i && s.contains(i)) return;
        const a = this.getSlide(), r = a && a.state === $d4d06657c043713f$var$lt.Ready ? a.el : null;
        if (!r || r.contains(i) || s === i) return;
        t && t.cancelable && t.preventDefault(), this.ignoreFocusChange = !0;
        const l = Array.from(s.querySelectorAll($d4d06657c043713f$var$nt));
        let c = [], h = null;
        for (let t of l){
            const e = !t.offsetParent || !!t.closest('[aria-hidden="true"]'), i = r && r.contains(t), n = !o.contains(t);
            if (t === s || (i || n) && !e) {
                c.push(t);
                const e = t.dataset.origTabindex;
                void 0 !== e && e && (t.tabIndex = parseFloat(e)), t.removeAttribute("data-orig-tabindex"), !t.hasAttribute("autoFocus") && h || (h = t);
            } else {
                const e = void 0 === t.dataset.origTabindex ? t.getAttribute("tabindex") || "" : t.dataset.origTabindex;
                e && (t.dataset.origTabindex = e), t.tabIndex = -1;
            }
        }
        let d = null;
        t ? (!n || c.indexOf(n) < 0) && (d = h || s, c.length && (i === $d4d06657c043713f$var$xe ? d = c[0] : this.lastFocus !== s && i !== $d4d06657c043713f$var$we || (d = c[c.length - 1]))) : d = a && "image" === a.type ? s : h || s, d && $d4d06657c043713f$var$st(d), this.lastFocus = document.activeElement, this.ignoreFocusChange = !1;
    }
    next() {
        const t = this.carousel;
        t && t.pages.length > 1 && t.slideNext();
    }
    prev() {
        const t = this.carousel;
        t && t.pages.length > 1 && t.slidePrev();
    }
    jumpTo(...t) {
        this.carousel && this.carousel.slideTo(...t);
    }
    isTopmost() {
        var t;
        return (null === (t = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance()) || void 0 === t ? void 0 : t.id) == this.id;
    }
    animate(t = null, e = "", i) {
        if (!t || !e) return void (i && i());
        this.stop(t);
        const n = (s)=>{
            s.target === t && t.dataset.animationName && (t.removeEventListener("animationend", n), delete t.dataset.animationName, i && i(), $d4d06657c043713f$var$S(t, e));
        };
        t.dataset.animationName = e, t.addEventListener("animationend", n), $d4d06657c043713f$var$P(t, e);
    }
    stop(t) {
        t && t.dispatchEvent(new CustomEvent("animationend", {
            bubbles: !1,
            cancelable: !0,
            currentTarget: t
        }));
    }
    setContent(t, e = "", i = !0) {
        if (this.isClosing()) return;
        const s = t.el;
        if (!s) return;
        let o = null;
        if ($d4d06657c043713f$var$E(e) ? o = e : (o = $d4d06657c043713f$var$n(e + ""), $d4d06657c043713f$var$E(o) || (o = document.createElement("div"), o.innerHTML = e + "")), [
            "img",
            "picture",
            "iframe",
            "video",
            "audio"
        ].includes(o.nodeName.toLowerCase())) {
            const t = document.createElement("div");
            t.appendChild(o), o = t;
        }
        $d4d06657c043713f$var$E(o) && t.filter && !t.error && (o = o.querySelector(t.filter)), o && $d4d06657c043713f$var$E(o) ? ($d4d06657c043713f$var$P(o, "fancybox__content"), t.id && o.setAttribute("id", t.id), s.classList.add(`has-${t.error ? "error" : t.type || "unknown"}`), s.prepend(o), "none" === o.style.display && (o.style.display = ""), "none" === getComputedStyle(o).getPropertyValue("display") && (o.style.display = t.display || this.option("defaultDisplay") || "flex"), t.contentEl = o, i && this.revealContent(t), this.manageCloseBtn(t), this.manageCaption(t)) : this.setError(t, "{{ELEMENT_NOT_FOUND}}");
    }
    revealContent(t, e) {
        const i = t.el, n = t.contentEl;
        i && n && (this.emit("reveal", t), this.hideLoading(t), t.state = $d4d06657c043713f$var$lt.Opening, (e = this.isOpeningSlide(t) ? void 0 === e ? this.optionFor(t, "showClass") : e : "f-fadeIn") ? this.animate(n, e, ()=>{
            this.done(t);
        }) : this.done(t));
    }
    done(t) {
        this.isClosing() || (t.state = $d4d06657c043713f$var$lt.Ready, this.emit("done", t), $d4d06657c043713f$var$P(t.el, "is-done"), this.isCurrentSlide(t) && this.option("autoFocus") && queueMicrotask(()=>{
            var e;
            null === (e = t.panzoom) || void 0 === e || e.updateControls(), this.option("autoFocus") && this.focus();
        }), this.isOpeningSlide(t) && ($d4d06657c043713f$var$S(this.container, $d4d06657c043713f$var$he), !this.isCompact && this.option("idle") && this.setIdle()));
    }
    isCurrentSlide(t) {
        const e = this.getSlide();
        return !(!t || !e) && e.index === t.index;
    }
    isOpeningSlide(t) {
        var e, i;
        return null === (null === (e = this.carousel) || void 0 === e ? void 0 : e.prevPage) && t && t.index === (null === (i = this.getSlide()) || void 0 === i ? void 0 : i.index);
    }
    showLoading(t) {
        t.state = $d4d06657c043713f$var$lt.Loading;
        const e = t.el;
        if (!e) return;
        $d4d06657c043713f$var$P(e, $d4d06657c043713f$var$ce), this.emit("loading", t), t.spinnerEl || setTimeout(()=>{
            if (!this.isClosing() && !t.spinnerEl && t.state === $d4d06657c043713f$var$lt.Loading) {
                let i = $d4d06657c043713f$var$n($d4d06657c043713f$var$x);
                $d4d06657c043713f$var$P(i, "fancybox-spinner"), t.spinnerEl = i, e.prepend(i), this.animate(i, "f-fadeIn");
            }
        }, 250);
    }
    hideLoading(t) {
        const e = t.el;
        if (!e) return;
        const i = t.spinnerEl;
        this.isClosing() ? null == i || i.remove() : ($d4d06657c043713f$var$S(e, $d4d06657c043713f$var$ce), i && this.animate(i, "f-fadeOut", ()=>{
            i.remove();
        }), t.state === $d4d06657c043713f$var$lt.Loading && (this.emit("loaded", t), t.state = $d4d06657c043713f$var$lt.Ready));
    }
    setError(t, e) {
        if (this.isClosing()) return;
        const i = new Event("error", {
            bubbles: !0,
            cancelable: !0
        });
        if (this.emit("error", i, t), i.defaultPrevented) return;
        t.error = e, this.hideLoading(t), this.clearContent(t);
        const n = document.createElement("div");
        n.classList.add("fancybox-error"), n.innerHTML = this.localize(e || "<p>{{ERROR}}</p>"), this.setContent(t, n);
    }
    clearContent(t) {
        if (void 0 === t.state) return;
        this.emit("clearContent", t), t.contentEl && (t.contentEl.remove(), t.contentEl = void 0);
        const e = t.el;
        e && ($d4d06657c043713f$var$S(e, "has-error"), $d4d06657c043713f$var$S(e, "has-unknown"), $d4d06657c043713f$var$S(e, `has-${t.type || "unknown"}`)), t.closeBtnEl && t.closeBtnEl.remove(), t.closeBtnEl = void 0, t.captionEl && t.captionEl.remove(), t.captionEl = void 0, t.spinnerEl && t.spinnerEl.remove(), t.spinnerEl = void 0;
    }
    getSlide() {
        var t;
        const e = this.carousel;
        return (null === (t = null == e ? void 0 : e.pages[null == e ? void 0 : e.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0;
    }
    close(t, e) {
        if (this.isClosing()) return;
        const i = new Event("shouldClose", {
            bubbles: !0,
            cancelable: !0
        });
        if (this.emit("shouldClose", i, t), i.defaultPrevented) return;
        t && t.cancelable && (t.preventDefault(), t.stopPropagation());
        const n = ()=>{
            this.proceedClose(t, e);
        };
        this.startedFs && $d4d06657c043713f$var$ye && $d4d06657c043713f$var$ye.isFullscreen() ? Promise.resolve($d4d06657c043713f$var$ye.exit()).then(()=>n()) : n();
    }
    clearIdle() {
        this.idleTimer && clearTimeout(this.idleTimer), this.idleTimer = null;
    }
    setIdle(t = !1) {
        const e = ()=>{
            this.clearIdle(), this.idle = !0, $d4d06657c043713f$var$P(this.container, "is-idle"), this.emit("setIdle");
        };
        if (this.clearIdle(), !this.isClosing()) {
            if (t) e();
            else {
                const t = this.option("idle");
                t && (this.idleTimer = setTimeout(e, t));
            }
        }
    }
    endIdle() {
        this.clearIdle(), this.idle && !this.isClosing() && (this.idle = !1, $d4d06657c043713f$var$S(this.container, "is-idle"), this.emit("endIdle"));
    }
    resetIdle() {
        this.endIdle(), this.setIdle();
    }
    toggleIdle() {
        this.idle ? this.endIdle() : this.setIdle(!0);
    }
    toggleFullscreen() {
        $d4d06657c043713f$var$ye && ($d4d06657c043713f$var$ye.isFullscreen() ? $d4d06657c043713f$var$ye.exit() : $d4d06657c043713f$var$ye.request().then(()=>{
            this.startedFs = !0;
        }));
    }
    isClosing() {
        return [
            $d4d06657c043713f$var$rt.Closing,
            $d4d06657c043713f$var$rt.CustomClosing,
            $d4d06657c043713f$var$rt.Destroy
        ].includes(this.state);
    }
    proceedClose(t, e) {
        var i, n;
        this.state = $d4d06657c043713f$var$rt.Closing, this.clearIdle(), this.detachEvents();
        const s = this.container, o = this.carousel, a = this.getSlide(), r = a && this.option("placeFocusBack") ? a.triggerEl || this.option("triggerEl") : null;
        if (r && ($d4d06657c043713f$var$tt(r) ? $d4d06657c043713f$var$st(r) : r.focus()), s && ($d4d06657c043713f$var$S(s, $d4d06657c043713f$var$he), $d4d06657c043713f$var$P(s, "is-closing"), s.setAttribute($d4d06657c043713f$var$oe, "true"), this.option("animated") && $d4d06657c043713f$var$P(s, $d4d06657c043713f$var$re), s.style.pointerEvents = "none"), o) {
            o.clearTransitions(), null === (i = o.panzoom) || void 0 === i || i.destroy(), null === (n = o.plugins.Navigation) || void 0 === n || n.detach();
            for (const t of o.slides){
                t.state = $d4d06657c043713f$var$lt.Closing, this.hideLoading(t);
                const e = t.contentEl;
                e && this.stop(e);
                const i = null == t ? void 0 : t.panzoom;
                i && (i.stop(), i.detachEvents(), i.detachObserver()), this.isCurrentSlide(t) || o.emit("removeSlide", t);
            }
        }
        $d4d06657c043713f$var$Pe = window.scrollX, $d4d06657c043713f$var$Ce = window.scrollY, window.addEventListener("scroll", this.onScroll), this.emit("close", t), this.state !== $d4d06657c043713f$var$rt.CustomClosing ? (void 0 === e && a && (e = this.optionFor(a, "hideClass")), e && a ? (this.animate(a.contentEl, e, ()=>{
            o && o.emit("removeSlide", a);
        }), setTimeout(()=>{
            this.destroy();
        }, 500)) : this.destroy()) : setTimeout(()=>{
            this.destroy();
        }, 500);
    }
    destroy() {
        var t;
        if (this.state === $d4d06657c043713f$var$rt.Destroy) return;
        window.removeEventListener("scroll", this.onScroll), this.state = $d4d06657c043713f$var$rt.Destroy, null === (t = this.carousel) || void 0 === t || t.destroy();
        const e = this.container;
        e && e.remove(), $d4d06657c043713f$var$Te.delete(this.id);
        const i = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance();
        i ? i.focus() : ($d4d06657c043713f$var$we && ($d4d06657c043713f$var$we.remove(), $d4d06657c043713f$var$we = null), $d4d06657c043713f$var$xe && ($d4d06657c043713f$var$xe.remove(), $d4d06657c043713f$var$xe = null), $d4d06657c043713f$var$S(document.documentElement, $d4d06657c043713f$var$ee), (()=>{
            if (!$d4d06657c043713f$var$et) return;
            const t = document, e = t.body;
            e.classList.remove($d4d06657c043713f$var$ie), e.style.setProperty($d4d06657c043713f$var$se, ""), t.documentElement.style.setProperty($d4d06657c043713f$var$ne, "");
        })(), this.emit("destroy"));
    }
    static bind(t, e, i) {
        if (!$d4d06657c043713f$var$et) return;
        let n, s = "", o = {};
        if (void 0 === t ? n = document.body : $d4d06657c043713f$var$ve(t) ? (n = document.body, s = t, "object" == typeof e && (o = e || {})) : (n = t, $d4d06657c043713f$var$ve(e) && (s = e), "object" == typeof i && (o = i || {})), !n || !$d4d06657c043713f$var$E(n)) return;
        s = s || "[data-fancybox]";
        const a = $d4d06657c043713f$export$cb45b08d97cdc4fd.openers.get(n) || new Map;
        a.set(s, o), $d4d06657c043713f$export$cb45b08d97cdc4fd.openers.set(n, a), 1 === a.size && n.addEventListener("click", $d4d06657c043713f$export$cb45b08d97cdc4fd.fromEvent);
    }
    static unbind(t, e) {
        let i, n = "";
        if ($d4d06657c043713f$var$ve(t) ? (i = document.body, n = t) : (i = t, $d4d06657c043713f$var$ve(e) && (n = e)), !i) return;
        const s = $d4d06657c043713f$export$cb45b08d97cdc4fd.openers.get(i);
        s && n && s.delete(n), n && s || ($d4d06657c043713f$export$cb45b08d97cdc4fd.openers.delete(i), i.removeEventListener("click", $d4d06657c043713f$export$cb45b08d97cdc4fd.fromEvent));
    }
    static destroy() {
        let t;
        for(; t = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance();)t.destroy();
        for (const t of $d4d06657c043713f$export$cb45b08d97cdc4fd.openers.keys())t.removeEventListener("click", $d4d06657c043713f$export$cb45b08d97cdc4fd.fromEvent);
        $d4d06657c043713f$export$cb45b08d97cdc4fd.openers = new Map;
    }
    static fromEvent(t) {
        if (t.defaultPrevented) return;
        if (t.button && 0 !== t.button) return;
        if (t.ctrlKey || t.metaKey || t.shiftKey) return;
        let e = t.composedPath()[0];
        const i = e.closest("[data-fancybox-trigger]");
        if (i) {
            const t = i.dataset.fancyboxTrigger || "", n = document.querySelectorAll(`[data-fancybox="${t}"]`), s = parseInt(i.dataset.fancyboxIndex || "", 10) || 0;
            e = n[s] || e;
        }
        if (!(e && e instanceof Element)) return;
        let n, s, o, a;
        if ([
            ...$d4d06657c043713f$export$cb45b08d97cdc4fd.openers
        ].reverse().find(([t, i])=>!(!t.contains(e) || ![
                ...i
            ].reverse().find(([i, r])=>{
                let l = e.closest(i);
                return !!l && (n = t, s = i, o = l, a = r, !0);
            }))), !n || !s || !o) return;
        a = a || {}, t.preventDefault(), e = o;
        let r = [], l = $d4d06657c043713f$var$u({}, $d4d06657c043713f$var$at, a);
        l.event = t, l.triggerEl = e, l.delegate = i;
        const c = l.groupAll, h = l.groupAttr, d = h && e ? e.getAttribute(`${h}`) : "";
        if ((!e || d || c) && (r = [].slice.call(n.querySelectorAll(s))), e && !c && (r = d ? r.filter((t)=>t.getAttribute(`${h}`) === d) : [
            e
        ]), !r.length) return;
        const p = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance();
        return p && p.options.triggerEl && r.indexOf(p.options.triggerEl) > -1 ? void 0 : (e && (l.startIndex = r.indexOf(e)), $d4d06657c043713f$export$cb45b08d97cdc4fd.fromNodes(r, l));
    }
    static fromSelector(t, e, i) {
        let n = null, s = "", o = {};
        if ($d4d06657c043713f$var$ve(t) ? (n = document.body, s = t, "object" == typeof e && (o = e || {})) : t instanceof HTMLElement && $d4d06657c043713f$var$ve(e) && (n = t, s = e, "object" == typeof i && (o = i || {})), !n || !s) return !1;
        const a = $d4d06657c043713f$export$cb45b08d97cdc4fd.openers.get(n);
        return !!a && (o = $d4d06657c043713f$var$u({}, a.get(s) || {}, o), !!o && $d4d06657c043713f$export$cb45b08d97cdc4fd.fromNodes(Array.from(n.querySelectorAll(s)), o));
    }
    static fromNodes(t, e) {
        e = $d4d06657c043713f$var$u({}, $d4d06657c043713f$var$at, e || {});
        const i = [];
        for (const n of t){
            const t = n.dataset || {}, s = t[$d4d06657c043713f$var$me] || n.getAttribute($d4d06657c043713f$var$ge) || n.getAttribute("currentSrc") || n.getAttribute($d4d06657c043713f$var$me) || void 0;
            let o;
            const a = e.delegate;
            let r;
            a && i.length === e.startIndex && (o = a instanceof HTMLImageElement ? a : a.querySelector("img:not([aria-hidden])")), o || (o = n instanceof HTMLImageElement ? n : n.querySelector("img:not([aria-hidden])")), o && (r = o.currentSrc || o[$d4d06657c043713f$var$me] || void 0, !r && o.dataset && (r = o.dataset.lazySrc || o.dataset[$d4d06657c043713f$var$me] || void 0));
            const l = {
                src: s,
                triggerEl: n,
                thumbEl: o,
                thumbElSrc: r,
                thumbSrc: r
            };
            for(const e in t){
                let i = t[e] + "";
                i = "false" !== i && ("true" === i || i), l[e] = i;
            }
            i.push(l);
        }
        return new $d4d06657c043713f$export$cb45b08d97cdc4fd(i, e);
    }
    static getInstance(t) {
        if (t) return $d4d06657c043713f$var$Te.get(t);
        return Array.from($d4d06657c043713f$var$Te.values()).reverse().find((t)=>!t.isClosing() && t) || null;
    }
    static getSlide() {
        var t;
        return (null === (t = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance()) || void 0 === t ? void 0 : t.getSlide()) || null;
    }
    static show(t = [], e = {}) {
        return new $d4d06657c043713f$export$cb45b08d97cdc4fd(t, e);
    }
    static next() {
        const t = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance();
        t && t.next();
    }
    static prev() {
        const t = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance();
        t && t.prev();
    }
    static close(t = !0, ...e) {
        if (t) for (const t of $d4d06657c043713f$var$Te.values())t.close(...e);
        else {
            const t = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance();
            t && t.close(...e);
        }
    }
}
Object.defineProperty($d4d06657c043713f$export$cb45b08d97cdc4fd, "version", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "5.0.36"
}), Object.defineProperty($d4d06657c043713f$export$cb45b08d97cdc4fd, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$at
}), Object.defineProperty($d4d06657c043713f$export$cb45b08d97cdc4fd, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$te
}), Object.defineProperty($d4d06657c043713f$export$cb45b08d97cdc4fd, "openers", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: new Map
});



(0, $d4d06657c043713f$export$cb45b08d97cdc4fd).bind('[data-fancybox]', {});


document.addEventListener('DOMContentLoaded', function() {
    if (document.querySelector('.bnpl-card')) $e06e35327013422b$var$initWidget();
});
function $e06e35327013422b$var$preventModalScroll(event) {
    const bnplModal = document.querySelector('.bnpl-modal');
    if (event.target === bnplModal) event.preventDefault();
}
const $e06e35327013422b$var$closeBnplModal = ()=>{
    const body = document.querySelector('body');
    body.style.overflow = '';
    const bnplModal = document.querySelector('.bnpl-modal');
    const modalPayments = bnplModal.querySelector('.bnpl-schedule-calc__payments');
    bnplModal.classList.remove('bnpl-modal--open');
    bnplModal.removeEventListener('wheel', $e06e35327013422b$var$preventModalScroll, {
        passive: false
    });
    bnplModal.removeEventListener('touchmove', $e06e35327013422b$var$preventModalScroll, {
        passive: false
    });
    modalPayments.querySelectorAll('.bnpl-schedule-calc__part').forEach((el)=>el.remove());
    const others = modalPayments.querySelector('.bnpl-schedule-calc__others');
    if (others) others.remove();
};
function $e06e35327013422b$var$getDictIndex(amount) {
    const last = String(amount).slice(-1);
    const penult = String(amount).slice(-2, -1);
    if (penult === '1') return 2;
    if (last === '1') return 0;
    if ([
        '2',
        '3',
        '4'
    ].includes(last)) return 1;
    return 2;
}
function $e06e35327013422b$var$getLinesTemplate(numRecs) {
    const isMany = numRecs > 3 && numRecs <= 5;
    return `<div class="bnpl-schedule-calc__lines ${isMany ? 'bnpl-schedule-calc__lines--many' : ''}">
        ${numRecs <= 5 ? Array(numRecs).fill('<div></div>').join('') : '<div></div>'}
    </div>`;
}
function $e06e35327013422b$var$getDatesArr(numRecs, interval, isFormatted = false) {
    return Array.from({
        length: numRecs
    }, (_, i)=>{
        const now = new Date();
        const date = now.setDate(now.getDate() + interval * (i + 1));
        return isFormatted ? $e06e35327013422b$var$getDateWithMonth(date) : date;
    });
}
function $e06e35327013422b$var$toNumber(string) {
    return Number(string.replace(/,/, '.'));
}
function $e06e35327013422b$var$getElementFromTemplate(template) {
    const el = document.createElement('div');
    el.innerHTML = template;
    return el.children[0];
}
function $e06e35327013422b$var$checkWeeks(daysAmount) {
    return daysAmount >= 7 && !(daysAmount % 7);
}
function $e06e35327013422b$var$getDaysFromNow(date) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const days = Math.floor((new Date(date) - today) / 86400000);
    return `${days} ${$e06e35327013422b$var$getDaysFormatted(days)}`;
}
function $e06e35327013422b$var$getDateWithMonth(date) {
    const d = new Date(date);
    const months = [
        "\u044F\u043D\u0432\u0430\u0440\u044F",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044F",
        "\u043C\u0430\u0440\u0442\u0430",
        "\u0430\u043F\u0440\u0435\u043B\u044F",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D\u044F",
        "\u0438\u044E\u043B\u044F",
        "\u0430\u0432\u0433\u0443\u0441\u0442\u0430",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044F",
        "\u043D\u043E\u044F\u0431\u0440\u044F",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044F"
    ];
    return `${d.getDate()} ${months[d.getMonth()]}`;
}
function $e06e35327013422b$var$getPaymentsFormatted(amount) {
    return [
        "\u043F\u043B\u0430\u0442\u0435\u0436",
        "\u043F\u043B\u0430\u0442\u0435\u0436\u0430",
        "\u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439"
    ][$e06e35327013422b$var$getDictIndex(amount)];
}
function $e06e35327013422b$var$getEveryFormatted(amount) {
    return [
        "\u043A\u0430\u0436\u0434\u0443\u044E",
        "\u043A\u0430\u0436\u0434\u044B\u0435",
        "\u043A\u0430\u0436\u0434\u044B\u0435"
    ][$e06e35327013422b$var$getDictIndex(amount)];
}
function $e06e35327013422b$var$getDaysFormatted(amount, isGen = false) {
    return isGen ? [
        "\u0434\u043D\u044F",
        "\u0434\u043D\u0435\u0439",
        "\u0434\u043D\u0435\u0439"
    ][$e06e35327013422b$var$getDictIndex(amount)] : [
        "\u0434\u0435\u043D\u044C",
        "\u0434\u043D\u044F",
        "\u0434\u043D\u0435\u0439"
    ][$e06e35327013422b$var$getDictIndex(amount)];
}
function $e06e35327013422b$var$getWeeksFormatted(amount, isGen = false) {
    return isGen ? [
        "\u043D\u0435\u0434\u0435\u043B\u0438",
        "\u043D\u0435\u0434\u0435\u043B\u044C",
        "\u043D\u0435\u0434\u0435\u043B\u044C"
    ][$e06e35327013422b$var$getDictIndex(amount)] : [
        "\u043D\u0435\u0434\u0435\u043B\u044E",
        "\u043D\u0435\u0434\u0435\u043B\u0438",
        "\u043D\u0435\u0434\u0435\u043B\u044C"
    ][$e06e35327013422b$var$getDictIndex(amount)];
}
function $e06e35327013422b$var$openBnplModal(params) {
    const body = document.querySelector('body');
    body.style.overflow = 'hidden';
    const bnplModal = document.querySelector('.bnpl-modal');
    const modalCloseButton = bnplModal.querySelector('.bnpl-modal__close');
    if (bnplModal.parentElement !== body) document.body.appendChild(bnplModal);
    modalCloseButton && modalCloseButton.addEventListener('click', $e06e35327013422b$var$closeBnplModal);
    bnplModal && bnplModal.addEventListener('click', (e)=>{
        if (e.target === bnplModal) $e06e35327013422b$var$closeBnplModal();
    });
    const bnplSpoilerHeader = bnplModal.querySelector('.bnpl-modal-spoiler__header');
    bnplSpoilerHeader && bnplSpoilerHeader.addEventListener('click', (e)=>{
        const spoiler = e.target.closest('.bnpl-modal-spoiler');
        const spoilerBody = spoiler.querySelector('.bnpl-modal-spoiler__body');
        spoiler.classList.toggle('bnpl-modal-spoiler--open');
        spoilerBody.style.maxHeight = spoiler.classList.contains('bnpl-modal-spoiler--open') ? spoilerBody.scrollHeight + 'px' : null;
    });
    const modalFirstPercent = bnplModal.querySelectorAll('.bnpl-first-percent');
    const modalFirstAmount = bnplModal.querySelectorAll('.bnpl-first-amount');
    const modalRecsPercent = bnplModal.querySelectorAll('.bnpl-recs-percent');
    const modalRecPercent = bnplModal.querySelectorAll('.bnpl-rec-percent');
    const modalRecInterval = bnplModal.querySelectorAll('.bnpl-rec-interval');
    const modalRecIntervalEvery = bnplModal.querySelectorAll('.bnpl-rec-interval-every');
    const modalPayments = bnplModal.querySelector('.bnpl-schedule-calc__payments');
    bnplModal.classList.add('bnpl-modal--open');
    bnplModal.addEventListener('wheel', $e06e35327013422b$var$preventModalScroll, {
        passive: false
    });
    bnplModal.addEventListener('touchmove', $e06e35327013422b$var$preventModalScroll, {
        passive: false
    });
    modalFirstAmount.forEach((el)=>el.innerHTML = params.firstPayment.toLocaleString('ru-RU'));
    modalFirstPercent.forEach((el)=>el.innerHTML = params.firstPaymentPercents.toLocaleString('ru-RU'));
    modalRecsPercent.forEach((el)=>el.innerHTML = params.recsPercents.toLocaleString('ru-RU'));
    modalRecPercent.forEach((el)=>el.innerHTML = Number(params.recPercents).toLocaleString('ru-RU'));
    const intervalStr = params.isWeeks ? Math.floor(params.paymentsInterval / 7) > 1 ? `\u{440}\u{430}\u{437} \u{432} ${Math.floor(params.paymentsInterval / 7)} ${$e06e35327013422b$var$getWeeksFormatted(Math.floor(params.paymentsInterval / 7))}` : "\u0440\u0430\u0437 \u0432 \u043D\u0435\u0434\u0435\u043B\u044E" : `\u{440}\u{430}\u{437} \u{432} ${params.paymentsInterval} ${$e06e35327013422b$var$getDaysFormatted(params.paymentsInterval)}`;
    modalRecInterval.forEach((el)=>el.innerHTML = intervalStr);
    const intervalEveryStr = params.isWeeks ? Math.floor(params.paymentsInterval / 7) > 1 ? `\u{43A}\u{430}\u{436}\u{434}\u{44B}\u{435} ${Math.floor(params.paymentsInterval / 7)} ${$e06e35327013422b$var$getWeeksFormatted(Math.floor(params.paymentsInterval / 7))}` : "\u043A\u0430\u0436\u0434\u0443\u044E \u043D\u0435\u0434\u0435\u043B\u044E" : `\u{43A}\u{430}\u{436}\u{434}\u{44B}\u{435} ${params.paymentsInterval} ${$e06e35327013422b$var$getDaysFormatted(params.paymentsInterval)}`;
    modalRecIntervalEvery.forEach((el)=>el.innerHTML = intervalEveryStr);
    // Подстановка расписания
    if (params.numRecPayments >= 4) {
        const tpl = `<div class="bnpl-schedule-calc__part bnpl-schedule-calc__part--combined">
            ${$e06e35327013422b$var$getLinesTemplate(params.numRecPayments)}
            <div class="bnpl-schedule-calc__descr">\u{415}\u{449}\u{435} ${params.numRecPayments} ${$e06e35327013422b$var$getPaymentsFormatted(params.numRecPayments)} ${intervalStr}</div>
            <div class="bnpl-schedule-calc__sum">\u{43F}\u{43E} ${Number(params.recAmount).toLocaleString('ru-RU')} \u{20BD}</div>
        </div>`;
        modalPayments.append($e06e35327013422b$var$getElementFromTemplate(tpl));
    } else {
        const tpl = (date)=>`<div class="bnpl-schedule-calc__part">
            <div class="bnpl-schedule-calc__descr">\u{447}\u{435}\u{440}\u{435}\u{437} ${$e06e35327013422b$var$getDaysFromNow(date)}</div>
            <div class="bnpl-schedule-calc__sum">${Number(params.recAmount).toLocaleString('ru-RU')} \u{20BD}</div>
        </div>`;
        const frag = new DocumentFragment();
        $e06e35327013422b$var$getDatesArr(params.numRecPayments, params.paymentsInterval).forEach((d)=>frag.append($e06e35327013422b$var$getElementFromTemplate(tpl(d))));
        modalPayments.append(frag);
    }
    // Для мобильных
    const tplMobile = `<div class="bnpl-schedule-calc__others">
        ${$e06e35327013422b$var$getLinesTemplate(params.numRecPayments)}
        <div class="bnpl-schedule-calc__descr">\u{415}\u{449}\u{435} ${params.numRecPayments} ${$e06e35327013422b$var$getPaymentsFormatted(params.numRecPayments)} \u{440}\u{430}\u{437} \u{432} ${params.paymentsInterval} ${$e06e35327013422b$var$getWeeksFormatted(params.paymentsInterval)}</div>
        <div class="bnpl-schedule-calc__sum">\u{43F}\u{43E} ${Number(params.recAmount).toLocaleString('ru-RU')} \u{20BD}</div>
    </div>`;
    const todayEl = modalPayments.querySelector('.bnpl-schedule-calc__today');
    todayEl && todayEl.after($e06e35327013422b$var$getElementFromTemplate(tplMobile));
}
function $e06e35327013422b$var$getPaymentAmount(amount) {
    const [rub, kop] = String(amount).split('.');
    return `${rub.toLocaleString('ru-RU')}<span class="bnpl-kopecks">,${kop} \u{20BD}</span>`;
}
function $e06e35327013422b$var$updateCard(card, payments) {
    card.querySelector('.bnpl-schedule-calc__today .bnpl-schedule-calc__sum').innerHTML = `${payments.firstPayment.toLocaleString('ru-RU')}  <span>\u{20BD}</span>`;
    card.querySelectorAll('.bnpl-schedule-calc__part').forEach((el)=>el.remove());
    if (payments.numPayments > 4 || card.classList.contains('bnpl-card--type-7-js')) {
        const interval = payments.isWeeks ? Math.floor(payments.paymentsInterval / 7) : payments.paymentsInterval;
        const tpl = `<div class="bnpl-schedule-calc__part">
            ${card.classList.contains('bnpl-card--type-7-js') ? $e06e35327013422b$var$getLinesTemplate(payments.numRecPayments) : ''}
            <div class="bnpl-schedule-calc__descr">\u{415}\u{449}\u{435} ${payments.numRecPayments} ${$e06e35327013422b$var$getPaymentsFormatted(payments.numRecPayments)}
                ${interval > 1 ? $e06e35327013422b$var$getEveryFormatted(interval) : "\u0440\u0430\u0437 \u0432"} ${interval > 1 ? interval : ''} ${payments.isWeeks ? $e06e35327013422b$var$getWeeksFormatted(interval) : $e06e35327013422b$var$getDaysFormatted(interval)}
            </div>
            <div class="bnpl-schedule-calc__sum">\u{43F}\u{43E} ${$e06e35327013422b$var$getPaymentAmount(payments.recAmount.toFixed(2))}</div>
        </div>`;
        card.querySelector('.bnpl-schedule-calc').append($e06e35327013422b$var$getElementFromTemplate(tpl));
    } else {
        const frag = new DocumentFragment();
        $e06e35327013422b$var$getDatesArr(payments.numRecPayments, payments.paymentsInterval, true).forEach((d)=>{
            frag.append($e06e35327013422b$var$getElementFromTemplate(`<div class="bnpl-schedule-calc__part">
                <div class="bnpl-schedule-calc__descr">${d}</div>
                <div class="bnpl-schedule-calc__sum">${payments.recAmount.toLocaleString('ru-RU')}  <span> \u{20BD}</span></div>
            </div>`));
        });
        card.querySelector('.bnpl-schedule-calc').append(frag);
    }
    const modalButton = card.querySelector('.bnpl-help-button');
    modalButton && (modalButton.onclick = ()=>$e06e35327013422b$var$openBnplModal(payments));
}
function $e06e35327013422b$var$calcPayments(price, numPayments, firstPaymentPercents, paymentsInterval) {
    const isWeeks = $e06e35327013422b$var$checkWeeks(paymentsInterval);
    const numRecPayments = numPayments - 1;
    const recAmountUnrounded = price * (1 - 0.01 * firstPaymentPercents) / numRecPayments;
    const recAmount = Math.floor(recAmountUnrounded * 100) / 100;
    const remainder = recAmountUnrounded - recAmount;
    const firstPayment = (price * firstPaymentPercents / 100 + numRecPayments * remainder).toFixed(2);
    const recsPercents = 100 - firstPaymentPercents;
    const recPercents = Number((recsPercents / numRecPayments).toFixed(2));
    const numDays = paymentsInterval * numRecPayments;
    return {
        firstPayment: Number(firstPayment),
        firstPaymentStr: firstPayment,
        recAmount: recAmount,
        numRecPayments: numRecPayments,
        numPayments: numPayments,
        firstPaymentPercents: firstPaymentPercents,
        recsPercents: recsPercents,
        recPercents: recPercents,
        paymentsInterval: paymentsInterval,
        isWeeks: isWeeks,
        numDays: numDays
    };
}
function $e06e35327013422b$var$initWidget() {
    const card = document.querySelector('.bnpl-card');
    if (!card) return;
    const price = $e06e35327013422b$var$toNumber(card.dataset.price);
    const firstPaymentPercents = $e06e35327013422b$var$toNumber(card.dataset.firstPaymentPercents);
    const paymentsInterval = $e06e35327013422b$var$toNumber(card.dataset.paymentsInterval);
    const defaultPayments = $e06e35327013422b$var$calcPayments(price, $e06e35327013422b$var$toNumber(card.dataset.paymentsNumber), firstPaymentPercents, paymentsInterval);
    $e06e35327013422b$var$updateCard(card, defaultPayments);
    card.querySelectorAll('.bnpl-card__radio-item').forEach((item)=>{
        item.onclick = ()=>{
            card.querySelectorAll('.bnpl-card__radio-item').forEach((i)=>i.dataset.checked = 'false');
            item.dataset.checked = 'true';
            const numPayments = Number(item.dataset.value);
            const payments = $e06e35327013422b$var$calcPayments(price, numPayments, firstPaymentPercents, paymentsInterval);
            $e06e35327013422b$var$updateCard(card, payments);
        };
    });
}


/* eslint-disable */ (function() {
    'use strict';
    try {
        if (typeof document < 'u') {
            var t = document.createElement('style');
            t.appendChild(document.createTextNode('@import"https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;600;700&display=swap";._root_1s9hm_1{display:flex;justify-content:space-between;align-items:center;border:1px solid #222222;padding:8px 16px;border-radius:8px;gap:8px;cursor:pointer;max-width:429px}._root_1s9hm_1._dark_1s9hm_12{color:#fff;border:1px solid white;background:#000}._text_1s9hm_18{font-size:16px;font-style:normal;font-weight:700;line-height:20px}._link_1s9hm_25{display:flex;align-items:center;gap:8px;font-size:14px;font-style:normal;font-weight:400;line-height:24px}._root_16fmr_1{display:flex;justify-content:space-between;align-items:center;padding:8px 16px;border-radius:8px;cursor:pointer;max-width:429px}._root_16fmr_1._dark_16fmr_10{color:#fff;background:#000}._text_16fmr_15{font-size:16px;font-style:normal;font-weight:700;line-height:20px}._link_16fmr_22{display:flex;align-items:center;gap:8px;font-size:14px;font-style:normal;font-weight:400;line-height:24px}._root_1u9kw_1{display:flex;justify-content:space-between;align-items:center;padding:8px 16px;border-radius:8px;cursor:pointer;max-width:429px;border:1px solid #222222}._root_1u9kw_1._dark_1u9kw_11{color:#fff;background:#000;border:1px solid white}._text_1u9kw_17{font-size:16px;font-style:normal;font-weight:700;line-height:20px}._link_1u9kw_24{display:flex;align-items:center;gap:8px;font-size:14px;font-style:normal;font-weight:400;line-height:24px}._root_1cs5x_1{display:flex;justify-content:space-between;max-width:249px;width:auto;padding:16px;border:1px solid #222222;border-radius:16px;gap:16px;color:#222;cursor:pointer}._root_1cs5x_1._dark_1cs5x_13{color:#fff;border:1px solid white;background:#000}._container_1cs5x_19{display:flex;flex-direction:column;gap:4px}._text_1cs5x_25{font-size:18px;font-style:normal;font-weight:700;line-height:20px}._sumPay_1cs5x_32{font-size:14px;font-style:normal;font-weight:400;line-height:20px}._link_1cs5x_39{font-size:14px;font-style:italic;font-weight:400;line-height:20px;text-decoration-line:underline}._root_1a58k_1{color:#525252;flex:1}._root_1a58k_1._dark_1a58k_5{color:#fff}._line_1a58k_9{border-radius:8px;height:6px;background:#ddd}._sum_1a58k_15{font-size:16px;font-style:normal;font-weight:800;line-height:24px}._active_1a58k_22{color:#222}._active_1a58k_22 ._line_1a58k_9{background:#7bcd00}._root_w28u7_1{max-width:388px;padding:16px;border:1px solid #222222;border-radius:24px;color:#222;cursor:pointer}._root_w28u7_1._dark_w28u7_9{color:#fff;border:1px solid white;background:#000}._root_w28u7_1._dark_w28u7_9 ._icon_w28u7_14{color:#fff}._title_container_w28u7_18{display:flex;justify-content:space-between;margin-bottom:12px;font-size:18px;font-style:normal;font-weight:700;line-height:20px}._title_w28u7_18,._schedule_w28u7_33{display:flex;gap:8px}._wide_15mzm_1{max-width:100%}._root_1hact_1{position:fixed;inset:0;z-index:100;overflow:auto;-webkit-overflow-scrolling:touch;background-color:#3a4259b3;display:flex;align-items:center;justify-content:center;font-family:Source Sans Pro,Arial,Helvetica,sans-serif}._root_1hact_1._dark_1hact_16 ._inner_1hact_16,._root_1hact_1._dark_1hact_16 ._description_1hact_17,._root_1hact_1._dark_1hact_16 ._title_1hact_18,._root_1hact_1._dark_1hact_16 ._header_1hact_19,._root_1hact_1._dark_1hact_16 ._content_1hact_20,._root_1hact_1._dark_1hact_16 ._buttons-inner_1hact_21{background:#444;color:#fff}._header_1hact_19{display:flex;justify-content:center;flex-direction:column;flex-wrap:wrap;text-align:left;font-size:20px;font-style:normal;font-weight:700;line-height:28px;color:#222;margin-bottom:32px}._title_1hact_18{font-size:28px;font-style:normal;font-weight:700;line-height:36px}._description_1hact_17{font-size:20px;font-style:normal;font-weight:400;line-height:28px;margin-top:16px;color:#222}._inner_1hact_16{position:relative;padding:40px 64px;background:#fff;box-shadow:0 16px 48px #495c8829;flex:0 1 auto;border-radius:32px;max-width:600px;box-sizing:border-box}._container_1hact_67{position:relative;display:flex;justify-content:center}._content_1hact_20{font-weight:400;font-size:14px;line-height:20px;color:#525252;margin-top:32px}._buttons-inner_1hact_21{margin-left:-16px;margin-right:-16px;width:100%;color:#222}._footer_1hact_88{display:flex;align-items:center;justify-content:center}._close_1hact_94{position:absolute;top:24px;right:24px;cursor:pointer}@media (max-width: 768px){._root_1hact_1{display:flex;flex-direction:column;justify-content:flex-end}._inner_1hact_16{padding:24px 16px;border-radius:16px 16px 0 0}._header_1hact_19{margin-bottom:24px}}._link_bih1d_1{display:flex;align-items:center;justify-content:center;gap:8px;font-size:16px;font-style:normal;font-weight:400;line-height:24px;margin-top:32px;text-decoration:none;cursor:pointer;color:#222}._link_bih1d_1._white_bih1d_15{color:#fff}._widget_bih1d_19{padding:0;border:0!important;max-width:100%;background:transparent!important;margin-bottom:32px}.bnpl-widget{font-family:Source Sans Pro,Arial,Helvetica,sans-serif;box-sizing:border-box}')), document.head.appendChild(t);
        }
    } catch (e) {
        console.error('vite-plugin-css-injected-by-js', e);
    }
})();
var $24b824b09891b629$var$oi = {};
/**
 * @vue/shared v3.4.15
 * (c) 2018-present Yuxi (Evan) You and Vue contributors
 * @license MIT
 **/ function $24b824b09891b629$var$Ke(e, t) {
    const n = new Set(e.split(','));
    return t ? (r)=>n.has(r.toLowerCase()) : (r)=>n.has(r);
}
const $24b824b09891b629$var$Z = $24b824b09891b629$var$oi.NODE_ENV !== 'production' ? Object.freeze({}) : {}, $24b824b09891b629$var$Rt = $24b824b09891b629$var$oi.NODE_ENV !== 'production' ? Object.freeze([]) : [], $24b824b09891b629$var$ae = ()=>{}, $24b824b09891b629$var$ii = ()=>!1, $24b824b09891b629$var$fn = (e)=>e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // uppercase letter
    (e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), $24b824b09891b629$var$Pn = (e)=>e.startsWith('onUpdate:'), $24b824b09891b629$var$se = Object.assign, $24b824b09891b629$var$Wr = (e, t)=>{
    const n = e.indexOf(t);
    n > -1 && e.splice(n, 1);
}, $24b824b09891b629$var$Ts = Object.prototype.hasOwnProperty, $24b824b09891b629$var$H = (e, t)=>$24b824b09891b629$var$Ts.call(e, t), $24b824b09891b629$var$M = Array.isArray, $24b824b09891b629$var$yt = (e)=>$24b824b09891b629$var$Hn(e) === '[object Map]', $24b824b09891b629$var$si = (e)=>$24b824b09891b629$var$Hn(e) === '[object Set]', $24b824b09891b629$var$S = (e)=>typeof e == 'function', $24b824b09891b629$var$re = (e)=>typeof e == 'string', $24b824b09891b629$var$Bt = (e)=>typeof e == 'symbol', $24b824b09891b629$var$ee = (e)=>e !== null && typeof e == 'object', $24b824b09891b629$var$Lr = (e)=>($24b824b09891b629$var$ee(e) || $24b824b09891b629$var$S(e)) && $24b824b09891b629$var$S(e.then) && $24b824b09891b629$var$S(e.catch), $24b824b09891b629$var$ai = Object.prototype.toString, $24b824b09891b629$var$Hn = (e)=>$24b824b09891b629$var$ai.call(e), $24b824b09891b629$var$Ur = (e)=>$24b824b09891b629$var$Hn(e).slice(8, -1), $24b824b09891b629$var$li = (e)=>$24b824b09891b629$var$Hn(e) === '[object Object]', $24b824b09891b629$var$jr = (e)=>$24b824b09891b629$var$re(e) && e !== 'NaN' && e[0] !== '-' && '' + parseInt(e, 10) === e, $24b824b09891b629$var$Dn = /* @__PURE__ */ $24b824b09891b629$var$Ke(// the leading comma is intentional so empty string "" is also included
',key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted'), $24b824b09891b629$var$xs = /* @__PURE__ */ $24b824b09891b629$var$Ke('bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo'), $24b824b09891b629$var$Gn = (e)=>{
    const t = /* @__PURE__ */ Object.create(null);
    return (n)=>t[n] || (t[n] = e(n));
}, $24b824b09891b629$var$Vs = /-(\w)/g, $24b824b09891b629$var$Ue = $24b824b09891b629$var$Gn((e)=>e.replace($24b824b09891b629$var$Vs, (t, n)=>n ? n.toUpperCase() : '')), $24b824b09891b629$var$Ms = /\B([A-Z])/g, $24b824b09891b629$var$st = $24b824b09891b629$var$Gn((e)=>e.replace($24b824b09891b629$var$Ms, '-$1').toLowerCase()), $24b824b09891b629$var$$t = $24b824b09891b629$var$Gn((e)=>e.charAt(0).toUpperCase() + e.slice(1)), $24b824b09891b629$var$mt = $24b824b09891b629$var$Gn((e)=>e ? `on${$24b824b09891b629$var$$t(e)}` : ''), $24b824b09891b629$var$at = (e, t)=>!Object.is(e, t), $24b824b09891b629$var$Xt = (e, t)=>{
    for(let n = 0; n < e.length; n++)e[n](t);
}, $24b824b09891b629$var$Sn = (e, t, n)=>{
    Object.defineProperty(e, t, {
        configurable: !0,
        enumerable: !1,
        value: n
    });
}, $24b824b09891b629$var$Ps = (e)=>{
    const t = parseFloat(e);
    return isNaN(t) ? e : t;
};
let $24b824b09891b629$var$po;
const $24b824b09891b629$var$Hr = ()=>$24b824b09891b629$var$po || ($24b824b09891b629$var$po = typeof globalThis < 'u' ? globalThis : typeof self < 'u' ? self : typeof window < 'u' ? window : typeof $parcel$global < 'u' ? $parcel$global : {});
function $24b824b09891b629$var$Gr(e) {
    if ($24b824b09891b629$var$M(e)) {
        const t = {};
        for(let n = 0; n < e.length; n++){
            const r = e[n], o = $24b824b09891b629$var$re(r) ? $24b824b09891b629$var$As(r) : $24b824b09891b629$var$Gr(r);
            if (o) for(const i in o)t[i] = o[i];
        }
        return t;
    } else if ($24b824b09891b629$var$re(e) || $24b824b09891b629$var$ee(e)) return e;
}
const $24b824b09891b629$var$Ss = /;(?![^(]*\))/g, $24b824b09891b629$var$ks = /:([^]+)/, $24b824b09891b629$var$Is = /\/\*[^]*?\*\//g;
function $24b824b09891b629$var$As(e) {
    const t = {};
    return e.replace($24b824b09891b629$var$Is, '').split($24b824b09891b629$var$Ss).forEach((n)=>{
        if (n) {
            const r = n.split($24b824b09891b629$var$ks);
            r.length > 1 && (t[r[0].trim()] = r[1].trim());
        }
    }), t;
}
function $24b824b09891b629$var$U(e) {
    let t = '';
    if ($24b824b09891b629$var$re(e)) t = e;
    else if ($24b824b09891b629$var$M(e)) for(let n = 0; n < e.length; n++){
        const r = $24b824b09891b629$var$U(e[n]);
        r && (t += r + ' ');
    }
    else if ($24b824b09891b629$var$ee(e)) for(const n in e)e[n] && (t += n + ' ');
    return t.trim();
}
const $24b824b09891b629$var$Fs = 'html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot', $24b824b09891b629$var$Rs = 'svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view', $24b824b09891b629$var$Ws = 'annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics', $24b824b09891b629$var$Ls = /* @__PURE__ */ $24b824b09891b629$var$Ke($24b824b09891b629$var$Fs), $24b824b09891b629$var$Us = /* @__PURE__ */ $24b824b09891b629$var$Ke($24b824b09891b629$var$Rs), $24b824b09891b629$var$js = /* @__PURE__ */ $24b824b09891b629$var$Ke($24b824b09891b629$var$Ws), $24b824b09891b629$var$Hs = 'itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly', $24b824b09891b629$var$Gs = /* @__PURE__ */ $24b824b09891b629$var$Ke($24b824b09891b629$var$Hs);
function $24b824b09891b629$var$ui(e) {
    return !!e || e === '';
}
const $24b824b09891b629$var$jt = (e)=>$24b824b09891b629$var$re(e) ? e : e == null ? '' : $24b824b09891b629$var$M(e) || $24b824b09891b629$var$ee(e) && (e.toString === $24b824b09891b629$var$ai || !$24b824b09891b629$var$S(e.toString)) ? JSON.stringify(e, $24b824b09891b629$var$ci, 2) : String(e), $24b824b09891b629$var$ci = (e, t)=>t && t.__v_isRef ? $24b824b09891b629$var$ci(e, t.value) : $24b824b09891b629$var$yt(t) ? {
        [`Map(${t.size})`]: [
            ...t.entries()
        ].reduce((n, [r, o], i)=>(n[$24b824b09891b629$var$ur(r, i) + ' =>'] = o, n), {})
    } : $24b824b09891b629$var$si(t) ? {
        [`Set(${t.size})`]: [
            ...t.values()
        ].map((n)=>$24b824b09891b629$var$ur(n))
    } : $24b824b09891b629$var$Bt(t) ? $24b824b09891b629$var$ur(t) : $24b824b09891b629$var$ee(t) && !$24b824b09891b629$var$M(t) && !$24b824b09891b629$var$li(t) ? String(t) : t, $24b824b09891b629$var$ur = (e, t = '')=>{
    var n;
    return $24b824b09891b629$var$Bt(e) ? `Symbol(${(n = e.description) != null ? n : t})` : e;
};
var $24b824b09891b629$var$he = {};
function $24b824b09891b629$var$_r(e, ...t) {
    console.warn(`[Vue warn] ${e}`, ...t);
}
let $24b824b09891b629$var$xe;
class $24b824b09891b629$var$Bs {
    constructor(t = !1){
        this.detached = t, this._active = !0, this.effects = [], this.cleanups = [], this.parent = $24b824b09891b629$var$xe, !t && $24b824b09891b629$var$xe && (this.index = ($24b824b09891b629$var$xe.scopes || ($24b824b09891b629$var$xe.scopes = [])).push(this) - 1);
    }
    get active() {
        return this._active;
    }
    run(t) {
        if (this._active) {
            const n = $24b824b09891b629$var$xe;
            try {
                return $24b824b09891b629$var$xe = this, t();
            } finally{
                $24b824b09891b629$var$xe = n;
            }
        } else $24b824b09891b629$var$he.NODE_ENV !== 'production' && $24b824b09891b629$var$_r('cannot run an inactive effect scope.');
    }
    /**
     * This should only be called on non-detached scopes
     * @internal
     */ on() {
        $24b824b09891b629$var$xe = this;
    }
    /**
     * This should only be called on non-detached scopes
     * @internal
     */ off() {
        $24b824b09891b629$var$xe = this.parent;
    }
    stop(t) {
        if (this._active) {
            let n, r;
            for(n = 0, r = this.effects.length; n < r; n++)this.effects[n].stop();
            for(n = 0, r = this.cleanups.length; n < r; n++)this.cleanups[n]();
            if (this.scopes) for(n = 0, r = this.scopes.length; n < r; n++)this.scopes[n].stop(!0);
            if (!this.detached && this.parent && !t) {
                const o = this.parent.scopes.pop();
                o && o !== this && (this.parent.scopes[this.index] = o, o.index = this.index);
            }
            this.parent = void 0, this._active = !1;
        }
    }
}
function $24b824b09891b629$var$Ys(e, t = $24b824b09891b629$var$xe) {
    t && t.active && t.effects.push(e);
}
function $24b824b09891b629$var$qs() {
    return $24b824b09891b629$var$xe;
}
let $24b824b09891b629$var$bt;
class $24b824b09891b629$var$Br {
    constructor(t, n, r, o){
        this.fn = t, this.trigger = n, this.scheduler = r, this.active = !0, this.deps = [], this._dirtyLevel = 2, this._trackId = 0, this._runnings = 0, this._shouldSchedule = !1, this._depsLength = 0, $24b824b09891b629$var$Ys(this, o);
    }
    get dirty() {
        if (this._dirtyLevel === 1) {
            $24b824b09891b629$var$ft();
            for(let t = 0; t < this._depsLength; t++){
                const n = this.deps[t];
                if (n.computed && ($24b824b09891b629$var$Ks(n.computed), this._dirtyLevel >= 2)) break;
            }
            this._dirtyLevel < 2 && (this._dirtyLevel = 0), $24b824b09891b629$var$dt();
        }
        return this._dirtyLevel >= 2;
    }
    set dirty(t) {
        this._dirtyLevel = t ? 2 : 0;
    }
    run() {
        if (this._dirtyLevel = 0, !this.active) return this.fn();
        let t = $24b824b09891b629$var$ot, n = $24b824b09891b629$var$bt;
        try {
            return $24b824b09891b629$var$ot = !0, $24b824b09891b629$var$bt = this, this._runnings++, $24b824b09891b629$var$ho(this), this.fn();
        } finally{
            $24b824b09891b629$var$mo(this), this._runnings--, $24b824b09891b629$var$bt = n, $24b824b09891b629$var$ot = t;
        }
    }
    stop() {
        var t;
        this.active && ($24b824b09891b629$var$ho(this), $24b824b09891b629$var$mo(this), (t = this.onStop) == null || t.call(this), this.active = !1);
    }
}
function $24b824b09891b629$var$Ks(e) {
    return e.value;
}
function $24b824b09891b629$var$ho(e) {
    e._trackId++, e._depsLength = 0;
}
function $24b824b09891b629$var$mo(e) {
    if (e.deps && e.deps.length > e._depsLength) {
        for(let t = e._depsLength; t < e.deps.length; t++)$24b824b09891b629$var$fi(e.deps[t], e);
        e.deps.length = e._depsLength;
    }
}
function $24b824b09891b629$var$fi(e, t) {
    const n = e.get(t);
    n !== void 0 && t._trackId !== n && (e.delete(t), e.size === 0 && e.cleanup());
}
let $24b824b09891b629$var$ot = !0, $24b824b09891b629$var$yr = 0;
const $24b824b09891b629$var$di = [];
function $24b824b09891b629$var$ft() {
    $24b824b09891b629$var$di.push($24b824b09891b629$var$ot), $24b824b09891b629$var$ot = !1;
}
function $24b824b09891b629$var$dt() {
    const e = $24b824b09891b629$var$di.pop();
    $24b824b09891b629$var$ot = e === void 0 ? !0 : e;
}
function $24b824b09891b629$var$Yr() {
    $24b824b09891b629$var$yr++;
}
function $24b824b09891b629$var$qr() {
    for($24b824b09891b629$var$yr--; !$24b824b09891b629$var$yr && $24b824b09891b629$var$br.length;)$24b824b09891b629$var$br.shift()();
}
function $24b824b09891b629$var$pi(e, t, n) {
    var r;
    if (t.get(e) !== e._trackId) {
        t.set(e, e._trackId);
        const o = e.deps[e._depsLength];
        o !== t ? (o && $24b824b09891b629$var$fi(o, e), e.deps[e._depsLength++] = t) : e._depsLength++, $24b824b09891b629$var$he.NODE_ENV !== 'production' && ((r = e.onTrack) == null || r.call(e, $24b824b09891b629$var$se({
            effect: e
        }, n)));
    }
}
const $24b824b09891b629$var$br = [];
function $24b824b09891b629$var$hi(e, t, n) {
    var r;
    $24b824b09891b629$var$Yr();
    for (const o of e.keys())if (o._dirtyLevel < t && e.get(o) === o._trackId) {
        const i = o._dirtyLevel;
        o._dirtyLevel = t, i === 0 && (o._shouldSchedule = !0, $24b824b09891b629$var$he.NODE_ENV !== 'production' && ((r = o.onTrigger) == null || r.call(o, $24b824b09891b629$var$se({
            effect: o
        }, n))), o.trigger());
    }
    $24b824b09891b629$var$mi(e), $24b824b09891b629$var$qr();
}
function $24b824b09891b629$var$mi(e) {
    for (const t of e.keys())t.scheduler && t._shouldSchedule && (!t._runnings || t.allowRecurse) && e.get(t) === t._trackId && (t._shouldSchedule = !1, $24b824b09891b629$var$br.push(t.scheduler));
}
const $24b824b09891b629$var$gi = (e, t)=>{
    const n = /* @__PURE__ */ new Map();
    return n.cleanup = e, n.computed = t, n;
}, $24b824b09891b629$var$wr = /* @__PURE__ */ new WeakMap(), $24b824b09891b629$var$wt = Symbol($24b824b09891b629$var$he.NODE_ENV !== 'production' ? 'iterate' : ''), $24b824b09891b629$var$Er = Symbol($24b824b09891b629$var$he.NODE_ENV !== 'production' ? 'Map key iterate' : '');
function $24b824b09891b629$var$me(e, t, n) {
    if ($24b824b09891b629$var$ot && $24b824b09891b629$var$bt) {
        let r = $24b824b09891b629$var$wr.get(e);
        r || $24b824b09891b629$var$wr.set(e, r = /* @__PURE__ */ new Map());
        let o = r.get(n);
        o || r.set(n, o = $24b824b09891b629$var$gi(()=>r.delete(n))), $24b824b09891b629$var$pi($24b824b09891b629$var$bt, o, $24b824b09891b629$var$he.NODE_ENV !== 'production' ? {
            target: e,
            type: t,
            key: n
        } : void 0);
    }
}
function $24b824b09891b629$var$Le(e, t, n, r, o, i) {
    const s = $24b824b09891b629$var$wr.get(e);
    if (!s) return;
    let a = [];
    if (t === 'clear') a = [
        ...s.values()
    ];
    else if (n === 'length' && $24b824b09891b629$var$M(e)) {
        const u = Number(r);
        s.forEach((d1, h)=>{
            (h === 'length' || !$24b824b09891b629$var$Bt(h) && h >= u) && a.push(d1);
        });
    } else switch(n !== void 0 && a.push(s.get(n)), t){
        case 'add':
            $24b824b09891b629$var$M(e) ? $24b824b09891b629$var$jr(n) && a.push(s.get('length')) : (a.push(s.get($24b824b09891b629$var$wt)), $24b824b09891b629$var$yt(e) && a.push(s.get($24b824b09891b629$var$Er)));
            break;
        case 'delete':
            $24b824b09891b629$var$M(e) || (a.push(s.get($24b824b09891b629$var$wt)), $24b824b09891b629$var$yt(e) && a.push(s.get($24b824b09891b629$var$Er)));
            break;
        case 'set':
            $24b824b09891b629$var$yt(e) && a.push(s.get($24b824b09891b629$var$wt));
            break;
    }
    $24b824b09891b629$var$Yr();
    for (const u of a)u && $24b824b09891b629$var$hi(u, 2, $24b824b09891b629$var$he.NODE_ENV !== 'production' ? {
        target: e,
        type: t,
        key: n,
        newValue: r,
        oldValue: o,
        oldTarget: i
    } : void 0);
    $24b824b09891b629$var$qr();
}
const $24b824b09891b629$var$Xs = /* @__PURE__ */ $24b824b09891b629$var$Ke('__proto__,__v_isRef,__isVue'), $24b824b09891b629$var$vi = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e)=>e !== 'arguments' && e !== 'caller').map((e)=>Symbol[e]).filter($24b824b09891b629$var$Bt)), $24b824b09891b629$var$go = /* @__PURE__ */ $24b824b09891b629$var$zs();
function $24b824b09891b629$var$zs() {
    const e = {};
    return [
        'includes',
        'indexOf',
        'lastIndexOf'
    ].forEach((t)=>{
        e[t] = function(...n) {
            const r = $24b824b09891b629$var$R(this);
            for(let i = 0, s = this.length; i < s; i++)$24b824b09891b629$var$me(r, 'get', i + '');
            const o = r[t](...n);
            return o === -1 || o === !1 ? r[t](...n.map($24b824b09891b629$var$R)) : o;
        };
    }), [
        'push',
        'pop',
        'shift',
        'unshift',
        'splice'
    ].forEach((t)=>{
        e[t] = function(...n) {
            $24b824b09891b629$var$ft(), $24b824b09891b629$var$Yr();
            const r = $24b824b09891b629$var$R(this)[t].apply(this, n);
            return $24b824b09891b629$var$qr(), $24b824b09891b629$var$dt(), r;
        };
    }), e;
}
function $24b824b09891b629$var$Js(e) {
    const t = $24b824b09891b629$var$R(this);
    return $24b824b09891b629$var$me(t, 'has', e), t.hasOwnProperty(e);
}
class $24b824b09891b629$var$_i {
    constructor(t = !1, n = !1){
        this._isReadonly = t, this._shallow = n;
    }
    get(t, n, r) {
        const o = this._isReadonly, i = this._shallow;
        if (n === '__v_isReactive') return !o;
        if (n === '__v_isReadonly') return o;
        if (n === '__v_isShallow') return i;
        if (n === '__v_raw') return r === (o ? i ? $24b824b09891b629$var$Di : $24b824b09891b629$var$Oi : i ? $24b824b09891b629$var$Ni : $24b824b09891b629$var$Ei).get(t) || // receiver is not the reactive proxy, but has the same prototype
        // this means the reciever is a user proxy of the reactive proxy
        Object.getPrototypeOf(t) === Object.getPrototypeOf(r) ? t : void 0;
        const s = $24b824b09891b629$var$M(t);
        if (!o) {
            if (s && $24b824b09891b629$var$H($24b824b09891b629$var$go, n)) return Reflect.get($24b824b09891b629$var$go, n, r);
            if (n === 'hasOwnProperty') return $24b824b09891b629$var$Js;
        }
        const a = Reflect.get(t, n, r);
        return ($24b824b09891b629$var$Bt(n) ? $24b824b09891b629$var$vi.has(n) : $24b824b09891b629$var$Xs(n)) || (o || $24b824b09891b629$var$me(t, 'get', n), i) ? a : $24b824b09891b629$var$ge(a) ? s && $24b824b09891b629$var$jr(n) ? a : a.value : $24b824b09891b629$var$ee(a) ? o ? $24b824b09891b629$var$$i(a) : $24b824b09891b629$var$Yt(a) : a;
    }
}
class $24b824b09891b629$var$yi extends $24b824b09891b629$var$_i {
    constructor(t = !1){
        super(!1, t);
    }
    set(t, n, r, o) {
        let i = t[n];
        if (!this._shallow) {
            const u = $24b824b09891b629$var$lt(i);
            if (!$24b824b09891b629$var$kn(r) && !$24b824b09891b629$var$lt(r) && (i = $24b824b09891b629$var$R(i), r = $24b824b09891b629$var$R(r)), !$24b824b09891b629$var$M(t) && $24b824b09891b629$var$ge(i) && !$24b824b09891b629$var$ge(r)) return u ? !1 : (i.value = r, !0);
        }
        const s = $24b824b09891b629$var$M(t) && $24b824b09891b629$var$jr(n) ? Number(n) < t.length : $24b824b09891b629$var$H(t, n), a = Reflect.set(t, n, r, o);
        return t === $24b824b09891b629$var$R(o) && (s ? $24b824b09891b629$var$at(r, i) && $24b824b09891b629$var$Le(t, 'set', n, r, i) : $24b824b09891b629$var$Le(t, 'add', n, r)), a;
    }
    deleteProperty(t, n) {
        const r = $24b824b09891b629$var$H(t, n), o = t[n], i = Reflect.deleteProperty(t, n);
        return i && r && $24b824b09891b629$var$Le(t, 'delete', n, void 0, o), i;
    }
    has(t, n) {
        const r = Reflect.has(t, n);
        return (!$24b824b09891b629$var$Bt(n) || !$24b824b09891b629$var$vi.has(n)) && $24b824b09891b629$var$me(t, 'has', n), r;
    }
    ownKeys(t) {
        return $24b824b09891b629$var$me(t, 'iterate', $24b824b09891b629$var$M(t) ? 'length' : $24b824b09891b629$var$wt), Reflect.ownKeys(t);
    }
}
class $24b824b09891b629$var$bi extends $24b824b09891b629$var$_i {
    constructor(t = !1){
        super(!0, t);
    }
    set(t, n) {
        return $24b824b09891b629$var$he.NODE_ENV !== 'production' && $24b824b09891b629$var$_r(`Set operation on key "${String(n)}" failed: target is readonly.`, t), !0;
    }
    deleteProperty(t, n) {
        return $24b824b09891b629$var$he.NODE_ENV !== 'production' && $24b824b09891b629$var$_r(`Delete operation on key "${String(n)}" failed: target is readonly.`, t), !0;
    }
}
const $24b824b09891b629$var$Qs = /* @__PURE__ */ new $24b824b09891b629$var$yi(), $24b824b09891b629$var$Zs = /* @__PURE__ */ new $24b824b09891b629$var$bi(), $24b824b09891b629$var$ea = /* @__PURE__ */ new $24b824b09891b629$var$yi(!0), $24b824b09891b629$var$ta = /* @__PURE__ */ new $24b824b09891b629$var$bi(!0), $24b824b09891b629$var$Kr = (e)=>e, $24b824b09891b629$var$Bn = (e)=>Reflect.getPrototypeOf(e);
function $24b824b09891b629$var$_n(e, t, n = !1, r = !1) {
    e = e.__v_raw;
    const o = $24b824b09891b629$var$R(e), i = $24b824b09891b629$var$R(t);
    n || ($24b824b09891b629$var$at(t, i) && $24b824b09891b629$var$me(o, 'get', t), $24b824b09891b629$var$me(o, 'get', i));
    const { has: s } = $24b824b09891b629$var$Bn(o), a = r ? $24b824b09891b629$var$Kr : n ? $24b824b09891b629$var$Xr : $24b824b09891b629$var$an;
    if (s.call(o, t)) return a(e.get(t));
    if (s.call(o, i)) return a(e.get(i));
    e !== o && e.get(t);
}
function $24b824b09891b629$var$yn(e, t = !1) {
    const n = this.__v_raw, r = $24b824b09891b629$var$R(n), o = $24b824b09891b629$var$R(e);
    return t || ($24b824b09891b629$var$at(e, o) && $24b824b09891b629$var$me(r, 'has', e), $24b824b09891b629$var$me(r, 'has', o)), e === o ? n.has(e) : n.has(e) || n.has(o);
}
function $24b824b09891b629$var$bn(e, t = !1) {
    return e = e.__v_raw, !t && $24b824b09891b629$var$me($24b824b09891b629$var$R(e), 'iterate', $24b824b09891b629$var$wt), Reflect.get(e, 'size', e);
}
function $24b824b09891b629$var$vo(e) {
    e = $24b824b09891b629$var$R(e);
    const t = $24b824b09891b629$var$R(this);
    return $24b824b09891b629$var$Bn(t).has.call(t, e) || (t.add(e), $24b824b09891b629$var$Le(t, 'add', e, e)), this;
}
function $24b824b09891b629$var$_o(e, t) {
    t = $24b824b09891b629$var$R(t);
    const n = $24b824b09891b629$var$R(this), { has: r, get: o } = $24b824b09891b629$var$Bn(n);
    let i = r.call(n, e);
    i ? $24b824b09891b629$var$he.NODE_ENV !== 'production' && $24b824b09891b629$var$wi(n, r, e) : (e = $24b824b09891b629$var$R(e), i = r.call(n, e));
    const s = o.call(n, e);
    return n.set(e, t), i ? $24b824b09891b629$var$at(t, s) && $24b824b09891b629$var$Le(n, 'set', e, t, s) : $24b824b09891b629$var$Le(n, 'add', e, t), this;
}
function $24b824b09891b629$var$yo(e) {
    const t = $24b824b09891b629$var$R(this), { has: n, get: r } = $24b824b09891b629$var$Bn(t);
    let o = n.call(t, e);
    o ? $24b824b09891b629$var$he.NODE_ENV !== 'production' && $24b824b09891b629$var$wi(t, n, e) : (e = $24b824b09891b629$var$R(e), o = n.call(t, e));
    const i = r ? r.call(t, e) : void 0, s = t.delete(e);
    return o && $24b824b09891b629$var$Le(t, 'delete', e, void 0, i), s;
}
function $24b824b09891b629$var$bo() {
    const e = $24b824b09891b629$var$R(this), t = e.size !== 0, n = $24b824b09891b629$var$he.NODE_ENV !== 'production' ? $24b824b09891b629$var$yt(e) ? new Map(e) : new Set(e) : void 0, r = e.clear();
    return t && $24b824b09891b629$var$Le(e, 'clear', void 0, void 0, n), r;
}
function $24b824b09891b629$var$wn(e, t) {
    return function(r, o) {
        const i = this, s = i.__v_raw, a = $24b824b09891b629$var$R(s), u = t ? $24b824b09891b629$var$Kr : e ? $24b824b09891b629$var$Xr : $24b824b09891b629$var$an;
        return !e && $24b824b09891b629$var$me(a, 'iterate', $24b824b09891b629$var$wt), s.forEach((d1, h)=>r.call(o, u(d1), u(h), i));
    };
}
function $24b824b09891b629$var$En(e, t, n) {
    return function(...r) {
        const o = this.__v_raw, i = $24b824b09891b629$var$R(o), s = $24b824b09891b629$var$yt(i), a = e === 'entries' || e === Symbol.iterator && s, u = e === 'keys' && s, d1 = o[e](...r), h = n ? $24b824b09891b629$var$Kr : t ? $24b824b09891b629$var$Xr : $24b824b09891b629$var$an;
        return !t && $24b824b09891b629$var$me(i, 'iterate', u ? $24b824b09891b629$var$Er : $24b824b09891b629$var$wt), {
            // iterator protocol
            next () {
                const { value: c, done: m } = d1.next();
                return m ? {
                    value: c,
                    done: m
                } : {
                    value: a ? [
                        h(c[0]),
                        h(c[1])
                    ] : h(c),
                    done: m
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $24b824b09891b629$var$Je(e) {
    return function(...t) {
        if ($24b824b09891b629$var$he.NODE_ENV !== 'production') {
            const n = t[0] ? `on key "${t[0]}" ` : '';
            console.warn(`${$24b824b09891b629$var$$t(e)} operation ${n}failed: target is readonly.`, $24b824b09891b629$var$R(this));
        }
        return e === 'delete' ? !1 : e === 'clear' ? void 0 : this;
    };
}
function $24b824b09891b629$var$na() {
    const e = {
        get (i) {
            return $24b824b09891b629$var$_n(this, i);
        },
        get size () {
            return $24b824b09891b629$var$bn(this);
        },
        has: $24b824b09891b629$var$yn,
        add: $24b824b09891b629$var$vo,
        set: $24b824b09891b629$var$_o,
        delete: $24b824b09891b629$var$yo,
        clear: $24b824b09891b629$var$bo,
        forEach: $24b824b09891b629$var$wn(!1, !1)
    }, t = {
        get (i) {
            return $24b824b09891b629$var$_n(this, i, !1, !0);
        },
        get size () {
            return $24b824b09891b629$var$bn(this);
        },
        has: $24b824b09891b629$var$yn,
        add: $24b824b09891b629$var$vo,
        set: $24b824b09891b629$var$_o,
        delete: $24b824b09891b629$var$yo,
        clear: $24b824b09891b629$var$bo,
        forEach: $24b824b09891b629$var$wn(!1, !0)
    }, n = {
        get (i) {
            return $24b824b09891b629$var$_n(this, i, !0);
        },
        get size () {
            return $24b824b09891b629$var$bn(this, !0);
        },
        has (i) {
            return $24b824b09891b629$var$yn.call(this, i, !0);
        },
        add: $24b824b09891b629$var$Je('add'),
        set: $24b824b09891b629$var$Je('set'),
        delete: $24b824b09891b629$var$Je('delete'),
        clear: $24b824b09891b629$var$Je('clear'),
        forEach: $24b824b09891b629$var$wn(!0, !1)
    }, r = {
        get (i) {
            return $24b824b09891b629$var$_n(this, i, !0, !0);
        },
        get size () {
            return $24b824b09891b629$var$bn(this, !0);
        },
        has (i) {
            return $24b824b09891b629$var$yn.call(this, i, !0);
        },
        add: $24b824b09891b629$var$Je('add'),
        set: $24b824b09891b629$var$Je('set'),
        delete: $24b824b09891b629$var$Je('delete'),
        clear: $24b824b09891b629$var$Je('clear'),
        forEach: $24b824b09891b629$var$wn(!0, !0)
    };
    return [
        'keys',
        'values',
        'entries',
        Symbol.iterator
    ].forEach((i)=>{
        e[i] = $24b824b09891b629$var$En(i, !1, !1), n[i] = $24b824b09891b629$var$En(i, !0, !1), t[i] = $24b824b09891b629$var$En(i, !1, !0), r[i] = $24b824b09891b629$var$En(i, !0, !0);
    }), [
        e,
        n,
        t,
        r
    ];
}
const [$24b824b09891b629$var$ra, $24b824b09891b629$var$oa, $24b824b09891b629$var$ia, $24b824b09891b629$var$sa] = /* @__PURE__ */ $24b824b09891b629$var$na();
function $24b824b09891b629$var$Yn(e, t) {
    const n = t ? e ? $24b824b09891b629$var$sa : $24b824b09891b629$var$ia : e ? $24b824b09891b629$var$oa : $24b824b09891b629$var$ra;
    return (r, o, i)=>o === '__v_isReactive' ? !e : o === '__v_isReadonly' ? e : o === '__v_raw' ? r : Reflect.get($24b824b09891b629$var$H(n, o) && o in r ? n : r, o, i);
}
const $24b824b09891b629$var$aa = {
    get: /* @__PURE__ */ $24b824b09891b629$var$Yn(!1, !1)
}, $24b824b09891b629$var$la = {
    get: /* @__PURE__ */ $24b824b09891b629$var$Yn(!1, !0)
}, $24b824b09891b629$var$ua = {
    get: /* @__PURE__ */ $24b824b09891b629$var$Yn(!0, !1)
}, $24b824b09891b629$var$ca = {
    get: /* @__PURE__ */ $24b824b09891b629$var$Yn(!0, !0)
};
function $24b824b09891b629$var$wi(e, t, n) {
    const r = $24b824b09891b629$var$R(n);
    if (r !== n && t.call(e, r)) {
        const o = $24b824b09891b629$var$Ur(e);
        console.warn(`Reactive ${o} contains both the raw and reactive versions of the same object${o === 'Map' ? ' as keys' : ''}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $24b824b09891b629$var$Ei = /* @__PURE__ */ new WeakMap(), $24b824b09891b629$var$Ni = /* @__PURE__ */ new WeakMap(), $24b824b09891b629$var$Oi = /* @__PURE__ */ new WeakMap(), $24b824b09891b629$var$Di = /* @__PURE__ */ new WeakMap();
function $24b824b09891b629$var$fa(e) {
    switch(e){
        case 'Object':
        case 'Array':
            return 1;
        case 'Map':
        case 'Set':
        case 'WeakMap':
        case 'WeakSet':
            return 2;
        default:
            return 0;
    }
}
function $24b824b09891b629$var$da(e) {
    return e.__v_skip || !Object.isExtensible(e) ? 0 : $24b824b09891b629$var$fa($24b824b09891b629$var$Ur(e));
}
function $24b824b09891b629$var$Yt(e) {
    return $24b824b09891b629$var$lt(e) ? e : $24b824b09891b629$var$qn(e, !1, $24b824b09891b629$var$Qs, $24b824b09891b629$var$aa, $24b824b09891b629$var$Ei);
}
function $24b824b09891b629$var$pa(e) {
    return $24b824b09891b629$var$qn(e, !1, $24b824b09891b629$var$ea, $24b824b09891b629$var$la, $24b824b09891b629$var$Ni);
}
function $24b824b09891b629$var$$i(e) {
    return $24b824b09891b629$var$qn(e, !0, $24b824b09891b629$var$Zs, $24b824b09891b629$var$ua, $24b824b09891b629$var$Oi);
}
function $24b824b09891b629$var$Ft(e) {
    return $24b824b09891b629$var$qn(e, !0, $24b824b09891b629$var$ta, $24b824b09891b629$var$ca, $24b824b09891b629$var$Di);
}
function $24b824b09891b629$var$qn(e, t, n, r, o) {
    if (!$24b824b09891b629$var$ee(e)) return $24b824b09891b629$var$he.NODE_ENV !== 'production' && console.warn(`value cannot be made reactive: ${String(e)}`), e;
    if (e.__v_raw && !(t && e.__v_isReactive)) return e;
    const i = o.get(e);
    if (i) return i;
    const s = $24b824b09891b629$var$da(e);
    if (s === 0) return e;
    const a = new Proxy(e, s === 2 ? r : n);
    return o.set(e, a), a;
}
function $24b824b09891b629$var$Et(e) {
    return $24b824b09891b629$var$lt(e) ? $24b824b09891b629$var$Et(e.__v_raw) : !!(e && e.__v_isReactive);
}
function $24b824b09891b629$var$lt(e) {
    return !!(e && e.__v_isReadonly);
}
function $24b824b09891b629$var$kn(e) {
    return !!(e && e.__v_isShallow);
}
function $24b824b09891b629$var$Nr(e) {
    return $24b824b09891b629$var$Et(e) || $24b824b09891b629$var$lt(e);
}
function $24b824b09891b629$var$R(e) {
    const t = e && e.__v_raw;
    return t ? $24b824b09891b629$var$R(t) : e;
}
function $24b824b09891b629$var$Ci(e) {
    return $24b824b09891b629$var$Sn(e, '__v_skip', !0), e;
}
const $24b824b09891b629$var$an = (e)=>$24b824b09891b629$var$ee(e) ? $24b824b09891b629$var$Yt(e) : e, $24b824b09891b629$var$Xr = (e)=>$24b824b09891b629$var$ee(e) ? $24b824b09891b629$var$$i(e) : e;
class $24b824b09891b629$var$Ti {
    constructor(t, n, r, o){
        this._setter = n, this.dep = void 0, this.__v_isRef = !0, this.__v_isReadonly = !1, this.effect = new $24b824b09891b629$var$Br(()=>t(this._value), ()=>$24b824b09891b629$var$$n(this, 1), ()=>this.dep && $24b824b09891b629$var$mi(this.dep)), this.effect.computed = this, this.effect.active = this._cacheable = !o, this.__v_isReadonly = r;
    }
    get value() {
        const t = $24b824b09891b629$var$R(this);
        return (!t._cacheable || t.effect.dirty) && $24b824b09891b629$var$at(t._value, t._value = t.effect.run()) && $24b824b09891b629$var$$n(t, 2), $24b824b09891b629$var$xi(t), t.effect._dirtyLevel >= 1 && $24b824b09891b629$var$$n(t, 1), t._value;
    }
    set value(t) {
        this._setter(t);
    }
    // #region polyfill _dirty for backward compatibility third party code for Vue <= 3.3.x
    get _dirty() {
        return this.effect.dirty;
    }
    set _dirty(t) {
        this.effect.dirty = t;
    }
}
function $24b824b09891b629$var$ha(e, t, n = !1) {
    let r, o;
    const i = $24b824b09891b629$var$S(e);
    i ? (r = e, o = $24b824b09891b629$var$he.NODE_ENV !== 'production' ? ()=>{
        console.warn('Write operation failed: computed value is readonly');
    } : $24b824b09891b629$var$ae) : (r = e.get, o = e.set);
    const s = new $24b824b09891b629$var$Ti(r, o, i || !o, n);
    return $24b824b09891b629$var$he.NODE_ENV !== 'production' && t && !n && (s.effect.onTrack = t.onTrack, s.effect.onTrigger = t.onTrigger), s;
}
function $24b824b09891b629$var$xi(e) {
    $24b824b09891b629$var$ot && $24b824b09891b629$var$bt && (e = $24b824b09891b629$var$R(e), $24b824b09891b629$var$pi($24b824b09891b629$var$bt, e.dep || (e.dep = $24b824b09891b629$var$gi(()=>e.dep = void 0, e instanceof $24b824b09891b629$var$Ti ? e : void 0)), $24b824b09891b629$var$he.NODE_ENV !== 'production' ? {
        target: e,
        type: 'get',
        key: 'value'
    } : void 0));
}
function $24b824b09891b629$var$$n(e, t = 2, n) {
    e = $24b824b09891b629$var$R(e);
    const r = e.dep;
    r && $24b824b09891b629$var$hi(r, t, $24b824b09891b629$var$he.NODE_ENV !== 'production' ? {
        target: e,
        type: 'set',
        key: 'value',
        newValue: n
    } : void 0);
}
function $24b824b09891b629$var$ge(e) {
    return !!(e && e.__v_isRef === !0);
}
function $24b824b09891b629$var$Vi(e) {
    return $24b824b09891b629$var$ma(e, !1);
}
function $24b824b09891b629$var$ma(e, t) {
    return $24b824b09891b629$var$ge(e) ? e : new $24b824b09891b629$var$ga(e, t);
}
class $24b824b09891b629$var$ga {
    constructor(t, n){
        this.__v_isShallow = n, this.dep = void 0, this.__v_isRef = !0, this._rawValue = n ? t : $24b824b09891b629$var$R(t), this._value = n ? t : $24b824b09891b629$var$an(t);
    }
    get value() {
        return $24b824b09891b629$var$xi(this), this._value;
    }
    set value(t) {
        const n = this.__v_isShallow || $24b824b09891b629$var$kn(t) || $24b824b09891b629$var$lt(t);
        t = n ? t : $24b824b09891b629$var$R(t), $24b824b09891b629$var$at(t, this._rawValue) && (this._rawValue = t, this._value = n ? t : $24b824b09891b629$var$an(t), $24b824b09891b629$var$$n(this, 2, t));
    }
}
function $24b824b09891b629$var$Mi(e) {
    return $24b824b09891b629$var$ge(e) ? e.value : e;
}
const $24b824b09891b629$var$va = {
    get: (e, t, n)=>$24b824b09891b629$var$Mi(Reflect.get(e, t, n)),
    set: (e, t, n, r)=>{
        const o = e[t];
        return $24b824b09891b629$var$ge(o) && !$24b824b09891b629$var$ge(n) ? (o.value = n, !0) : Reflect.set(e, t, n, r);
    }
};
function $24b824b09891b629$var$Pi(e) {
    return $24b824b09891b629$var$Et(e) ? e : new Proxy(e, $24b824b09891b629$var$va);
}
var $24b824b09891b629$var$p = {};
const $24b824b09891b629$var$Nt = [];
function $24b824b09891b629$var$Cn(e) {
    $24b824b09891b629$var$Nt.push(e);
}
function $24b824b09891b629$var$Tn() {
    $24b824b09891b629$var$Nt.pop();
}
function $24b824b09891b629$var$w(e, ...t) {
    $24b824b09891b629$var$ft();
    const n = $24b824b09891b629$var$Nt.length ? $24b824b09891b629$var$Nt[$24b824b09891b629$var$Nt.length - 1].component : null, r = n && n.appContext.config.warnHandler, o = $24b824b09891b629$var$_a();
    if (r) $24b824b09891b629$var$qe(r, n, 11, [
        e + t.join(''),
        n && n.proxy,
        o.map(({ vnode: i })=>`at <${$24b824b09891b629$var$tr(n, i.type)}>`).join(`
`),
        o
    ]);
    else {
        const i = [
            `[Vue warn]: ${e}`,
            ...t
        ];
        o.length && i.push(`
`, ...$24b824b09891b629$var$ya(o)), console.warn(...i);
    }
    $24b824b09891b629$var$dt();
}
function $24b824b09891b629$var$_a() {
    let e = $24b824b09891b629$var$Nt[$24b824b09891b629$var$Nt.length - 1];
    if (!e) return [];
    const t = [];
    for(; e;){
        const n = t[0];
        n && n.vnode === e ? n.recurseCount++ : t.push({
            vnode: e,
            recurseCount: 0
        });
        const r = e.component && e.component.parent;
        e = r && r.vnode;
    }
    return t;
}
function $24b824b09891b629$var$ya(e) {
    const t = [];
    return e.forEach((n, r)=>{
        t.push(...r === 0 ? [] : [
            `
`
        ], ...$24b824b09891b629$var$ba(n));
    }), t;
}
function $24b824b09891b629$var$ba({ vnode: e, recurseCount: t }) {
    const n = t > 0 ? `... (${t} recursive calls)` : '', r = e.component ? e.component.parent == null : !1, o = ` at <${$24b824b09891b629$var$tr(e.component, e.type, r)}`, i = '>' + n;
    return e.props ? [
        o,
        ...$24b824b09891b629$var$wa(e.props),
        i
    ] : [
        o + i
    ];
}
function $24b824b09891b629$var$wa(e) {
    const t = [], n = Object.keys(e);
    return n.slice(0, 3).forEach((r)=>{
        t.push(...$24b824b09891b629$var$Si(r, e[r]));
    }), n.length > 3 && t.push(' ...'), t;
}
function $24b824b09891b629$var$Si(e, t, n) {
    return $24b824b09891b629$var$re(t) ? (t = JSON.stringify(t), n ? t : [
        `${e}=${t}`
    ]) : typeof t == 'number' || typeof t == 'boolean' || t == null ? n ? t : [
        `${e}=${t}`
    ] : $24b824b09891b629$var$ge(t) ? (t = $24b824b09891b629$var$Si(e, $24b824b09891b629$var$R(t.value), !0), n ? t : [
        `${e}=Ref<`,
        t,
        '>'
    ]) : $24b824b09891b629$var$S(t) ? [
        `${e}=fn${t.name ? `<${t.name}>` : ''}`
    ] : (t = $24b824b09891b629$var$R(t), n ? t : [
        `${e}=`,
        t
    ]);
}
const $24b824b09891b629$var$zr = {
    sp: 'serverPrefetch hook',
    bc: 'beforeCreate hook',
    c: 'created hook',
    bm: 'beforeMount hook',
    m: 'mounted hook',
    bu: 'beforeUpdate hook',
    u: 'updated',
    bum: 'beforeUnmount hook',
    um: 'unmounted hook',
    a: 'activated hook',
    da: 'deactivated hook',
    ec: 'errorCaptured hook',
    rtc: 'renderTracked hook',
    rtg: 'renderTriggered hook',
    0: 'setup function',
    1: 'render function',
    2: 'watcher getter',
    3: 'watcher callback',
    4: 'watcher cleanup function',
    5: 'native event handler',
    6: 'component event handler',
    7: 'vnode hook',
    8: 'directive hook',
    9: 'transition hook',
    10: 'app errorHandler',
    11: 'app warnHandler',
    12: 'ref function',
    13: 'async component loader',
    14: 'scheduler flush. This is likely a Vue internals bug. Please open an issue at https://github.com/vuejs/core .'
};
function $24b824b09891b629$var$qe(e, t, n, r) {
    let o;
    try {
        o = r ? e(...r) : e();
    } catch (i) {
        $24b824b09891b629$var$dn(i, t, n);
    }
    return o;
}
function $24b824b09891b629$var$Pe(e, t, n, r) {
    if ($24b824b09891b629$var$S(e)) {
        const i = $24b824b09891b629$var$qe(e, t, n, r);
        return i && $24b824b09891b629$var$Lr(i) && i.catch((s)=>{
            $24b824b09891b629$var$dn(s, t, n);
        }), i;
    }
    const o = [];
    for(let i = 0; i < e.length; i++)o.push($24b824b09891b629$var$Pe(e[i], t, n, r));
    return o;
}
function $24b824b09891b629$var$dn(e, t, n, r = !0) {
    const o = t ? t.vnode : null;
    if (t) {
        let i = t.parent;
        const s = t.proxy, a = $24b824b09891b629$var$p.NODE_ENV !== 'production' ? $24b824b09891b629$var$zr[n] : `https://vuejs.org/error-reference/#runtime-${n}`;
        for(; i;){
            const d1 = i.ec;
            if (d1) {
                for(let h = 0; h < d1.length; h++)if (d1[h](e, s, a) === !1) return;
            }
            i = i.parent;
        }
        const u = t.appContext.config.errorHandler;
        if (u) {
            $24b824b09891b629$var$qe(u, null, 10, [
                e,
                s,
                a
            ]);
            return;
        }
    }
    $24b824b09891b629$var$Ea(e, n, o, r);
}
function $24b824b09891b629$var$Ea(e, t, n, r = !0) {
    if ($24b824b09891b629$var$p.NODE_ENV !== 'production') {
        const o = $24b824b09891b629$var$zr[t];
        if (n && $24b824b09891b629$var$Cn(n), $24b824b09891b629$var$w(`Unhandled error${o ? ` during execution of ${o}` : ''}`), n && $24b824b09891b629$var$Tn(), r) throw e;
        console.error(e);
    } else console.error(e);
}
let $24b824b09891b629$var$ln = !1, $24b824b09891b629$var$Or = !1;
const $24b824b09891b629$var$ve = [];
let $24b824b09891b629$var$Ae = 0;
const $24b824b09891b629$var$Wt = [];
let $24b824b09891b629$var$Ye = null, $24b824b09891b629$var$et = 0;
const $24b824b09891b629$var$ki = /* @__PURE__ */ Promise.resolve();
let $24b824b09891b629$var$Jr = null;
const $24b824b09891b629$var$Na = 100;
function $24b824b09891b629$var$Oa(e) {
    const t = $24b824b09891b629$var$Jr || $24b824b09891b629$var$ki;
    return e ? t.then(this ? e.bind(this) : e) : t;
}
function $24b824b09891b629$var$Da(e) {
    let t = $24b824b09891b629$var$Ae + 1, n = $24b824b09891b629$var$ve.length;
    for(; t < n;){
        const r = t + n >>> 1, o = $24b824b09891b629$var$ve[r], i = $24b824b09891b629$var$un(o);
        i < e || i === e && o.pre ? t = r + 1 : n = r;
    }
    return t;
}
function $24b824b09891b629$var$Kn(e) {
    (!$24b824b09891b629$var$ve.length || !$24b824b09891b629$var$ve.includes(e, $24b824b09891b629$var$ln && e.allowRecurse ? $24b824b09891b629$var$Ae + 1 : $24b824b09891b629$var$Ae)) && (e.id == null ? $24b824b09891b629$var$ve.push(e) : $24b824b09891b629$var$ve.splice($24b824b09891b629$var$Da(e.id), 0, e), $24b824b09891b629$var$Ii());
}
function $24b824b09891b629$var$Ii() {
    !$24b824b09891b629$var$ln && !$24b824b09891b629$var$Or && ($24b824b09891b629$var$Or = !0, $24b824b09891b629$var$Jr = $24b824b09891b629$var$ki.then($24b824b09891b629$var$Ri));
}
function $24b824b09891b629$var$$a(e) {
    const t = $24b824b09891b629$var$ve.indexOf(e);
    t > $24b824b09891b629$var$Ae && $24b824b09891b629$var$ve.splice(t, 1);
}
function $24b824b09891b629$var$Ai(e) {
    $24b824b09891b629$var$M(e) ? $24b824b09891b629$var$Wt.push(...e) : (!$24b824b09891b629$var$Ye || !$24b824b09891b629$var$Ye.includes(e, e.allowRecurse ? $24b824b09891b629$var$et + 1 : $24b824b09891b629$var$et)) && $24b824b09891b629$var$Wt.push(e), $24b824b09891b629$var$Ii();
}
function $24b824b09891b629$var$wo(e, t, n = $24b824b09891b629$var$ln ? $24b824b09891b629$var$Ae + 1 : 0) {
    for($24b824b09891b629$var$p.NODE_ENV !== 'production' && (t = t || /* @__PURE__ */ new Map()); n < $24b824b09891b629$var$ve.length; n++){
        const r = $24b824b09891b629$var$ve[n];
        if (r && r.pre) {
            if (e && r.id !== e.uid || $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Qr(t, r)) continue;
            $24b824b09891b629$var$ve.splice(n, 1), n--, r();
        }
    }
}
function $24b824b09891b629$var$Fi(e) {
    if ($24b824b09891b629$var$Wt.length) {
        const t = [
            ...new Set($24b824b09891b629$var$Wt)
        ].sort((n, r)=>$24b824b09891b629$var$un(n) - $24b824b09891b629$var$un(r));
        if ($24b824b09891b629$var$Wt.length = 0, $24b824b09891b629$var$Ye) {
            $24b824b09891b629$var$Ye.push(...t);
            return;
        }
        for($24b824b09891b629$var$Ye = t, $24b824b09891b629$var$p.NODE_ENV !== 'production' && (e = e || /* @__PURE__ */ new Map()), $24b824b09891b629$var$et = 0; $24b824b09891b629$var$et < $24b824b09891b629$var$Ye.length; $24b824b09891b629$var$et++)$24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Qr(e, $24b824b09891b629$var$Ye[$24b824b09891b629$var$et]) || $24b824b09891b629$var$Ye[$24b824b09891b629$var$et]();
        $24b824b09891b629$var$Ye = null, $24b824b09891b629$var$et = 0;
    }
}
const $24b824b09891b629$var$un = (e)=>e.id == null ? 1 / 0 : e.id, $24b824b09891b629$var$Ca = (e, t)=>{
    const n = $24b824b09891b629$var$un(e) - $24b824b09891b629$var$un(t);
    if (n === 0) {
        if (e.pre && !t.pre) return -1;
        if (t.pre && !e.pre) return 1;
    }
    return n;
};
function $24b824b09891b629$var$Ri(e) {
    $24b824b09891b629$var$Or = !1, $24b824b09891b629$var$ln = !0, $24b824b09891b629$var$p.NODE_ENV !== 'production' && (e = e || /* @__PURE__ */ new Map()), $24b824b09891b629$var$ve.sort($24b824b09891b629$var$Ca);
    const t = $24b824b09891b629$var$p.NODE_ENV !== 'production' ? (n)=>$24b824b09891b629$var$Qr(e, n) : $24b824b09891b629$var$ae;
    try {
        for($24b824b09891b629$var$Ae = 0; $24b824b09891b629$var$Ae < $24b824b09891b629$var$ve.length; $24b824b09891b629$var$Ae++){
            const n = $24b824b09891b629$var$ve[$24b824b09891b629$var$Ae];
            if (n && n.active !== !1) {
                if ($24b824b09891b629$var$p.NODE_ENV !== 'production' && t(n)) continue;
                $24b824b09891b629$var$qe(n, null, 14);
            }
        }
    } finally{
        $24b824b09891b629$var$Ae = 0, $24b824b09891b629$var$ve.length = 0, $24b824b09891b629$var$Fi(e), $24b824b09891b629$var$ln = !1, $24b824b09891b629$var$Jr = null, ($24b824b09891b629$var$ve.length || $24b824b09891b629$var$Wt.length) && $24b824b09891b629$var$Ri(e);
    }
}
function $24b824b09891b629$var$Qr(e, t) {
    if (!e.has(t)) e.set(t, 1);
    else {
        const n = e.get(t);
        if (n > $24b824b09891b629$var$Na) {
            const r = t.ownerInstance, o = r && $24b824b09891b629$var$so(r.type);
            return $24b824b09891b629$var$dn(`Maximum recursive updates exceeded${o ? ` in component <${o}>` : ''}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10), !0;
        } else e.set(t, n + 1);
    }
}
let $24b824b09891b629$var$it = !1;
const $24b824b09891b629$var$It = /* @__PURE__ */ new Set();
$24b824b09891b629$var$p.NODE_ENV !== 'production' && ($24b824b09891b629$var$Hr().__VUE_HMR_RUNTIME__ = {
    createRecord: $24b824b09891b629$var$cr($24b824b09891b629$var$Wi),
    rerender: $24b824b09891b629$var$cr($24b824b09891b629$var$Va),
    reload: $24b824b09891b629$var$cr($24b824b09891b629$var$Ma)
});
const $24b824b09891b629$var$Ct = /* @__PURE__ */ new Map();
function $24b824b09891b629$var$Ta(e) {
    const t = e.type.__hmrId;
    let n = $24b824b09891b629$var$Ct.get(t);
    n || ($24b824b09891b629$var$Wi(t, e.type), n = $24b824b09891b629$var$Ct.get(t)), n.instances.add(e);
}
function $24b824b09891b629$var$xa(e) {
    $24b824b09891b629$var$Ct.get(e.type.__hmrId).instances.delete(e);
}
function $24b824b09891b629$var$Wi(e, t) {
    return $24b824b09891b629$var$Ct.has(e) ? !1 : ($24b824b09891b629$var$Ct.set(e, {
        initialDef: $24b824b09891b629$var$nn(t),
        instances: /* @__PURE__ */ new Set()
    }), !0);
}
function $24b824b09891b629$var$nn(e) {
    return $24b824b09891b629$var$vs(e) ? e.__vccOpts : e;
}
function $24b824b09891b629$var$Va(e, t) {
    const n = $24b824b09891b629$var$Ct.get(e);
    n && (n.initialDef.render = t, [
        ...n.instances
    ].forEach((r)=>{
        t && (r.render = t, $24b824b09891b629$var$nn(r.type).render = t), r.renderCache = [], $24b824b09891b629$var$it = !0, r.effect.dirty = !0, r.update(), $24b824b09891b629$var$it = !1;
    }));
}
function $24b824b09891b629$var$Ma(e, t) {
    const n = $24b824b09891b629$var$Ct.get(e);
    if (!n) return;
    t = $24b824b09891b629$var$nn(t), $24b824b09891b629$var$Eo(n.initialDef, t);
    const r = [
        ...n.instances
    ];
    for (const o of r){
        const i = $24b824b09891b629$var$nn(o.type);
        $24b824b09891b629$var$It.has(i) || (i !== n.initialDef && $24b824b09891b629$var$Eo(i, t), $24b824b09891b629$var$It.add(i)), o.appContext.propsCache.delete(o.type), o.appContext.emitsCache.delete(o.type), o.appContext.optionsCache.delete(o.type), o.ceReload ? ($24b824b09891b629$var$It.add(i), o.ceReload(t.styles), $24b824b09891b629$var$It.delete(i)) : o.parent ? (o.parent.effect.dirty = !0, $24b824b09891b629$var$Kn(o.parent.update)) : o.appContext.reload ? o.appContext.reload() : typeof window < 'u' ? window.location.reload() : console.warn('[HMR] Root or manually mounted instance modified. Full reload required.');
    }
    $24b824b09891b629$var$Ai(()=>{
        for (const o of r)$24b824b09891b629$var$It.delete($24b824b09891b629$var$nn(o.type));
    });
}
function $24b824b09891b629$var$Eo(e, t) {
    $24b824b09891b629$var$se(e, t);
    for(const n in e)n !== '__file' && !(n in t) && delete e[n];
}
function $24b824b09891b629$var$cr(e) {
    return (t, n)=>{
        try {
            return e(t, n);
        } catch (r) {
            console.error(r), console.warn('[HMR] Something went wrong during Vue component hot-reload. Full reload required.');
        }
    };
}
let $24b824b09891b629$var$Fe, $24b824b09891b629$var$en = [], $24b824b09891b629$var$Dr = !1;
function $24b824b09891b629$var$pn(e, ...t) {
    $24b824b09891b629$var$Fe ? $24b824b09891b629$var$Fe.emit(e, ...t) : $24b824b09891b629$var$Dr || $24b824b09891b629$var$en.push({
        event: e,
        args: t
    });
}
function $24b824b09891b629$var$Li(e, t) {
    var n, r;
    $24b824b09891b629$var$Fe = e, $24b824b09891b629$var$Fe ? ($24b824b09891b629$var$Fe.enabled = !0, $24b824b09891b629$var$en.forEach(({ event: o, args: i })=>$24b824b09891b629$var$Fe.emit(o, ...i)), $24b824b09891b629$var$en = []) : /* handle late devtools injection - only do this if we are in an actual */ /* browser environment to avoid the timer handle stalling test runner exit */ /* (#4815) */ typeof window < 'u' && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    !((r = (n = window.navigator) == null ? void 0 : n.userAgent) != null && r.includes('jsdom')) ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((i)=>{
        $24b824b09891b629$var$Li(i, t);
    }), setTimeout(()=>{
        $24b824b09891b629$var$Fe || (t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, $24b824b09891b629$var$Dr = !0, $24b824b09891b629$var$en = []);
    }, 3e3)) : ($24b824b09891b629$var$Dr = !0, $24b824b09891b629$var$en = []);
}
function $24b824b09891b629$var$Pa(e, t) {
    $24b824b09891b629$var$pn('app:init', e, t, {
        Fragment: $24b824b09891b629$var$Oe,
        Text: $24b824b09891b629$var$hn,
        Comment: $24b824b09891b629$var$De,
        Static: $24b824b09891b629$var$Vn
    });
}
function $24b824b09891b629$var$Sa(e) {
    $24b824b09891b629$var$pn('app:unmount', e);
}
const $24b824b09891b629$var$ka = /* @__PURE__ */ $24b824b09891b629$var$Zr('component:added'), $24b824b09891b629$var$Ui = /* @__PURE__ */ $24b824b09891b629$var$Zr('component:updated'), $24b824b09891b629$var$Ia = /* @__PURE__ */ $24b824b09891b629$var$Zr('component:removed'), $24b824b09891b629$var$Aa = (e)=>{
    $24b824b09891b629$var$Fe && typeof $24b824b09891b629$var$Fe.cleanupBuffer == 'function' && // remove the component if it wasn't buffered
    !$24b824b09891b629$var$Fe.cleanupBuffer(e) && $24b824b09891b629$var$Ia(e);
};
function $24b824b09891b629$var$Zr(e) {
    return (t)=>{
        $24b824b09891b629$var$pn(e, t.appContext.app, t.uid, t.parent ? t.parent.uid : void 0, t);
    };
}
const $24b824b09891b629$var$Fa = /* @__PURE__ */ $24b824b09891b629$var$ji('perf:start'), $24b824b09891b629$var$Ra = /* @__PURE__ */ $24b824b09891b629$var$ji('perf:end');
function $24b824b09891b629$var$ji(e) {
    return (t, n, r)=>{
        $24b824b09891b629$var$pn(e, t.appContext.app, t.uid, t, n, r);
    };
}
function $24b824b09891b629$var$Wa(e, t, n) {
    $24b824b09891b629$var$pn('component:emit', e.appContext.app, e, t, n);
}
function $24b824b09891b629$var$La(e, t, ...n) {
    if (e.isUnmounted) return;
    const r = e.vnode.props || $24b824b09891b629$var$Z;
    if ($24b824b09891b629$var$p.NODE_ENV !== 'production') {
        const { emitsOptions: h, propsOptions: [c] } = e;
        if (h) {
            if (!(t in h)) (!c || !($24b824b09891b629$var$mt(t) in c)) && $24b824b09891b629$var$w(`Component emitted event "${t}" but it is neither declared in the emits option nor as an "${$24b824b09891b629$var$mt(t)}" prop.`);
            else {
                const m = h[t];
                $24b824b09891b629$var$S(m) && (m(...n) || $24b824b09891b629$var$w(`Invalid event arguments: event validation failed for event "${t}".`));
            }
        }
    }
    let o = n;
    const i = t.startsWith('update:'), s = i && t.slice(7);
    if (s && s in r) {
        const h = `${s === 'modelValue' ? 'model' : s}Modifiers`, { number: c, trim: m } = r[h] || $24b824b09891b629$var$Z;
        m && (o = n.map((N)=>$24b824b09891b629$var$re(N) ? N.trim() : N)), c && (o = n.map($24b824b09891b629$var$Ps));
    }
    if ($24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Wa(e, t, o), $24b824b09891b629$var$p.NODE_ENV !== 'production') {
        const h = t.toLowerCase();
        h !== t && r[$24b824b09891b629$var$mt(h)] && $24b824b09891b629$var$w(`Event "${h}" is emitted in component ${$24b824b09891b629$var$tr(e, e.type)} but the handler is registered for "${t}". Note that HTML attributes are case-insensitive and you cannot use v-on to listen to camelCase events when using in-DOM templates. You should probably use "${$24b824b09891b629$var$st(t)}" instead of "${t}".`);
    }
    let a, u = r[a = $24b824b09891b629$var$mt(t)] || // also try camelCase event handler (#2249)
    r[a = $24b824b09891b629$var$mt($24b824b09891b629$var$Ue(t))];
    !u && i && (u = r[a = $24b824b09891b629$var$mt($24b824b09891b629$var$st(t))]), u && $24b824b09891b629$var$Pe(u, e, 6, o);
    const d1 = r[a + 'Once'];
    if (d1) {
        if (!e.emitted) e.emitted = {};
        else if (e.emitted[a]) return;
        e.emitted[a] = !0, $24b824b09891b629$var$Pe(d1, e, 6, o);
    }
}
function $24b824b09891b629$var$Hi(e, t, n = !1) {
    const r = t.emitsCache, o = r.get(e);
    if (o !== void 0) return o;
    const i = e.emits;
    let s = {}, a = !1;
    if (!$24b824b09891b629$var$S(e)) {
        const u = (d1)=>{
            const h = $24b824b09891b629$var$Hi(d1, t, !0);
            h && (a = !0, $24b824b09891b629$var$se(s, h));
        };
        !n && t.mixins.length && t.mixins.forEach(u), e.extends && u(e.extends), e.mixins && e.mixins.forEach(u);
    }
    return !i && !a ? ($24b824b09891b629$var$ee(e) && r.set(e, null), null) : ($24b824b09891b629$var$M(i) ? i.forEach((u)=>s[u] = null) : $24b824b09891b629$var$se(s, i), $24b824b09891b629$var$ee(e) && r.set(e, s), s);
}
function $24b824b09891b629$var$Xn(e, t) {
    return !e || !$24b824b09891b629$var$fn(t) ? !1 : (t = t.slice(2).replace(/Once$/, ''), $24b824b09891b629$var$H(e, t[0].toLowerCase() + t.slice(1)) || $24b824b09891b629$var$H(e, $24b824b09891b629$var$st(t)) || $24b824b09891b629$var$H(e, t));
}
let $24b824b09891b629$var$le = null, $24b824b09891b629$var$Gi = null;
function $24b824b09891b629$var$In(e) {
    const t = $24b824b09891b629$var$le;
    return $24b824b09891b629$var$le = e, $24b824b09891b629$var$Gi = e && e.type.__scopeId || null, t;
}
function $24b824b09891b629$var$At(e, t = $24b824b09891b629$var$le, n) {
    if (!t || e._n) return e;
    const r = (...o)=>{
        r._d && $24b824b09891b629$var$Fo(-1);
        const i = $24b824b09891b629$var$In(t);
        let s;
        try {
            s = e(...o);
        } finally{
            $24b824b09891b629$var$In(i), r._d && $24b824b09891b629$var$Fo(1);
        }
        return $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Ui(t), s;
    };
    return r._n = !0, r._c = !0, r._d = !0, r;
}
let $24b824b09891b629$var$$r = !1;
function $24b824b09891b629$var$An() {
    $24b824b09891b629$var$$r = !0;
}
function $24b824b09891b629$var$fr(e) {
    const { type: t, vnode: n, proxy: r, withProxy: o, props: i, propsOptions: [s], slots: a, attrs: u, emit: d1, render: h, renderCache: c, data: m, setupState: N, ctx: T, inheritAttrs: P } = e;
    let L, X;
    const j = $24b824b09891b629$var$In(e);
    $24b824b09891b629$var$p.NODE_ENV !== 'production' && ($24b824b09891b629$var$$r = !1);
    try {
        if (n.shapeFlag & 4) {
            const B = o || r, Y = $24b824b09891b629$var$p.NODE_ENV !== 'production' && N.__isScriptSetup ? new Proxy(B, {
                get (C, K, Q) {
                    return $24b824b09891b629$var$w(`Property '${String(K)}' was accessed via 'this'. Avoid using 'this' in templates.`), Reflect.get(C, K, Q);
                }
            }) : B;
            L = $24b824b09891b629$var$Ve(h.call(Y, B, c, i, N, m, T)), X = u;
        } else {
            const B = t;
            $24b824b09891b629$var$p.NODE_ENV !== 'production' && u === i && $24b824b09891b629$var$An(), L = $24b824b09891b629$var$Ve(B.length > 1 ? B(i, $24b824b09891b629$var$p.NODE_ENV !== 'production' ? {
                get attrs () {
                    return $24b824b09891b629$var$An(), u;
                },
                slots: a,
                emit: d1
            } : {
                attrs: u,
                slots: a,
                emit: d1
            }) : B(i, null)), X = t.props ? u : $24b824b09891b629$var$Ua(u);
        }
    } catch (B) {
        $24b824b09891b629$var$sn.length = 0, $24b824b09891b629$var$dn(B, e, 1), L = $24b824b09891b629$var$pe($24b824b09891b629$var$De);
    }
    let A = L, F;
    if ($24b824b09891b629$var$p.NODE_ENV !== 'production' && L.patchFlag > 0 && L.patchFlag & 2048 && ([A, F] = $24b824b09891b629$var$Bi(L)), X && P !== !1) {
        const B = Object.keys(X), { shapeFlag: Y } = A;
        if (B.length) {
            if (Y & 7) s && B.some($24b824b09891b629$var$Pn) && (X = $24b824b09891b629$var$ja(X, s)), A = $24b824b09891b629$var$ct(A, X);
            else if ($24b824b09891b629$var$p.NODE_ENV !== 'production' && !$24b824b09891b629$var$$r && A.type !== $24b824b09891b629$var$De) {
                const C = Object.keys(u), K = [], Q = [];
                for(let ue = 0, ye = C.length; ue < ye; ue++){
                    const Ce = C[ue];
                    $24b824b09891b629$var$fn(Ce) ? $24b824b09891b629$var$Pn(Ce) || K.push(Ce[2].toLowerCase() + Ce.slice(3)) : Q.push(Ce);
                }
                Q.length && $24b824b09891b629$var$w(`Extraneous non-props attributes (${Q.join(', ')}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes.`), K.length && $24b824b09891b629$var$w(`Extraneous non-emits event listeners (${K.join(', ')}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.`);
            }
        }
    }
    return n.dirs && ($24b824b09891b629$var$p.NODE_ENV !== 'production' && !$24b824b09891b629$var$No(A) && $24b824b09891b629$var$w('Runtime directive used on component with non-element root node. The directives will not function as intended.'), A = $24b824b09891b629$var$ct(A), A.dirs = A.dirs ? A.dirs.concat(n.dirs) : n.dirs), n.transition && ($24b824b09891b629$var$p.NODE_ENV !== 'production' && !$24b824b09891b629$var$No(A) && $24b824b09891b629$var$w('Component inside <Transition> renders non-element root node that cannot be animated.'), A.transition = n.transition), $24b824b09891b629$var$p.NODE_ENV !== 'production' && F ? F(A) : L = A, $24b824b09891b629$var$In(j), L;
}
const $24b824b09891b629$var$Bi = (e)=>{
    const t = e.children, n = e.dynamicChildren, r = $24b824b09891b629$var$eo(t, !1);
    if (r) {
        if ($24b824b09891b629$var$p.NODE_ENV !== 'production' && r.patchFlag > 0 && r.patchFlag & 2048) return $24b824b09891b629$var$Bi(r);
    } else return [
        e,
        void 0
    ];
    const o = t.indexOf(r), i = n ? n.indexOf(r) : -1, s = (a)=>{
        t[o] = a, n && (i > -1 ? n[i] = a : a.patchFlag > 0 && (e.dynamicChildren = [
            ...n,
            a
        ]));
    };
    return [
        $24b824b09891b629$var$Ve(r),
        s
    ];
};
function $24b824b09891b629$var$eo(e, t = !0) {
    let n;
    for(let r = 0; r < e.length; r++){
        const o = e[r];
        if ($24b824b09891b629$var$Jn(o)) {
            if (o.type !== $24b824b09891b629$var$De || o.children === 'v-if') {
                if (n) return;
                if (n = o, $24b824b09891b629$var$p.NODE_ENV !== 'production' && t && n.patchFlag > 0 && n.patchFlag & 2048) return $24b824b09891b629$var$eo(n.children);
            }
        } else return;
    }
    return n;
}
const $24b824b09891b629$var$Ua = (e)=>{
    let t;
    for(const n in e)(n === 'class' || n === 'style' || $24b824b09891b629$var$fn(n)) && ((t || (t = {}))[n] = e[n]);
    return t;
}, $24b824b09891b629$var$ja = (e, t)=>{
    const n = {};
    for(const r in e)(!$24b824b09891b629$var$Pn(r) || !(r.slice(9) in t)) && (n[r] = e[r]);
    return n;
}, $24b824b09891b629$var$No = (e)=>e.shapeFlag & 7 || e.type === $24b824b09891b629$var$De;
function $24b824b09891b629$var$Ha(e, t, n) {
    const { props: r, children: o, component: i } = e, { props: s, children: a, patchFlag: u } = t, d1 = i.emitsOptions;
    if ($24b824b09891b629$var$p.NODE_ENV !== 'production' && (o || a) && $24b824b09891b629$var$it || t.dirs || t.transition) return !0;
    if (n && u >= 0) {
        if (u & 1024) return !0;
        if (u & 16) return r ? $24b824b09891b629$var$Oo(r, s, d1) : !!s;
        if (u & 8) {
            const h = t.dynamicProps;
            for(let c = 0; c < h.length; c++){
                const m = h[c];
                if (s[m] !== r[m] && !$24b824b09891b629$var$Xn(d1, m)) return !0;
            }
        }
    } else return (o || a) && (!a || !a.$stable) ? !0 : r === s ? !1 : r ? s ? $24b824b09891b629$var$Oo(r, s, d1) : !0 : !!s;
    return !1;
}
function $24b824b09891b629$var$Oo(e, t, n) {
    const r = Object.keys(t);
    if (r.length !== Object.keys(e).length) return !0;
    for(let o = 0; o < r.length; o++){
        const i = r[o];
        if (t[i] !== e[i] && !$24b824b09891b629$var$Xn(n, i)) return !0;
    }
    return !1;
}
function $24b824b09891b629$var$Ga({ vnode: e, parent: t }, n) {
    for(; t;){
        const r = t.subTree;
        if (r.suspense && r.suspense.activeBranch === e && (r.el = e.el), r === e) (e = t.vnode).el = n, t = t.parent;
        else break;
    }
}
const $24b824b09891b629$var$Cr = 'components', $24b824b09891b629$var$Ba = 'directives', $24b824b09891b629$var$Yi = Symbol.for('v-ndc');
function $24b824b09891b629$var$Ya(e) {
    return $24b824b09891b629$var$re(e) ? $24b824b09891b629$var$qi($24b824b09891b629$var$Cr, e, !1) || e : e || $24b824b09891b629$var$Yi;
}
function $24b824b09891b629$var$qa(e) {
    return $24b824b09891b629$var$qi($24b824b09891b629$var$Ba, e);
}
function $24b824b09891b629$var$qi(e, t, n = !0, r = !1) {
    const o = $24b824b09891b629$var$le || $24b824b09891b629$var$de;
    if (o) {
        const i = o.type;
        if (e === $24b824b09891b629$var$Cr) {
            const a = $24b824b09891b629$var$so(i, !1);
            if (a && (a === t || a === $24b824b09891b629$var$Ue(t) || a === $24b824b09891b629$var$$t($24b824b09891b629$var$Ue(t)))) return i;
        }
        const s = // local registration
        // check instance[type] first which is resolved for options API
        $24b824b09891b629$var$Do(o[e] || i[e], t) || // global registration
        $24b824b09891b629$var$Do(o.appContext[e], t);
        if (!s && r) return i;
        if ($24b824b09891b629$var$p.NODE_ENV !== 'production' && n && !s) {
            const a = e === $24b824b09891b629$var$Cr ? `
If this is a native custom element, make sure to exclude it from component resolution via compilerOptions.isCustomElement.` : '';
            $24b824b09891b629$var$w(`Failed to resolve ${e.slice(0, -1)}: ${t}${a}`);
        }
        return s;
    } else $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w(`resolve${$24b824b09891b629$var$$t(e.slice(0, -1))} can only be used in render() or setup().`);
}
function $24b824b09891b629$var$Do(e, t) {
    return e && (e[t] || e[$24b824b09891b629$var$Ue(t)] || e[$24b824b09891b629$var$$t($24b824b09891b629$var$Ue(t))]);
}
const $24b824b09891b629$var$Ka = (e)=>e.__isSuspense;
function $24b824b09891b629$var$Xa(e, t) {
    t && t.pendingBranch ? $24b824b09891b629$var$M(e) ? t.effects.push(...e) : t.effects.push(e) : $24b824b09891b629$var$Ai(e);
}
const $24b824b09891b629$var$za = Symbol.for('v-scx'), $24b824b09891b629$var$Ja = ()=>{
    {
        const e = $24b824b09891b629$var$xn($24b824b09891b629$var$za);
        return e || $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w('Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build.'), e;
    }
}, $24b824b09891b629$var$Nn = {};
function $24b824b09891b629$var$dr(e, t, n) {
    return $24b824b09891b629$var$p.NODE_ENV !== 'production' && !$24b824b09891b629$var$S(t) && $24b824b09891b629$var$w('`watch(fn, options?)` signature has been moved to a separate API. Use `watchEffect(fn, options?)` instead. `watch` now only supports `watch(source, cb, options?) signature.'), $24b824b09891b629$var$Ki(e, t, n);
}
function $24b824b09891b629$var$Ki(e, t, { immediate: n, deep: r, flush: o, once: i, onTrack: s, onTrigger: a } = $24b824b09891b629$var$Z) {
    if (t && i) {
        const C = t;
        t = (...K)=>{
            C(...K), Y();
        };
    }
    $24b824b09891b629$var$p.NODE_ENV !== 'production' && r !== void 0 && typeof r == 'number' && $24b824b09891b629$var$w('watch() "deep" option with number value will be used as watch depth in future versions. Please use a boolean instead to avoid potential breakage.'), $24b824b09891b629$var$p.NODE_ENV !== 'production' && !t && (n !== void 0 && $24b824b09891b629$var$w('watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.'), r !== void 0 && $24b824b09891b629$var$w('watch() "deep" option is only respected when using the watch(source, callback, options?) signature.'), i !== void 0 && $24b824b09891b629$var$w('watch() "once" option is only respected when using the watch(source, callback, options?) signature.'));
    const u = (C)=>{
        $24b824b09891b629$var$w('Invalid watch source: ', C, 'A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.');
    }, d1 = $24b824b09891b629$var$de, h = (C)=>r === !0 ? C : $24b824b09891b629$var$vt(C, r === !1 ? 1 : void 0);
    let c, m = !1, N = !1;
    if ($24b824b09891b629$var$ge(e) ? (c = ()=>e.value, m = $24b824b09891b629$var$kn(e)) : $24b824b09891b629$var$Et(e) ? (c = ()=>h(e), m = !0) : $24b824b09891b629$var$M(e) ? (N = !0, m = e.some((C)=>$24b824b09891b629$var$Et(C) || $24b824b09891b629$var$kn(C)), c = ()=>e.map((C)=>{
            if ($24b824b09891b629$var$ge(C)) return C.value;
            if ($24b824b09891b629$var$Et(C)) return h(C);
            if ($24b824b09891b629$var$S(C)) return $24b824b09891b629$var$qe(C, d1, 2);
            $24b824b09891b629$var$p.NODE_ENV !== 'production' && u(C);
        })) : $24b824b09891b629$var$S(e) ? t ? c = ()=>$24b824b09891b629$var$qe(e, d1, 2) : c = ()=>(T && T(), $24b824b09891b629$var$Pe(e, d1, 3, [
            P
        ])) : (c = $24b824b09891b629$var$ae, $24b824b09891b629$var$p.NODE_ENV !== 'production' && u(e)), t && r) {
        const C = c;
        c = ()=>$24b824b09891b629$var$vt(C());
    }
    let T, P = (C)=>{
        T = F.onStop = ()=>{
            $24b824b09891b629$var$qe(C, d1, 4), T = F.onStop = void 0;
        };
    }, L;
    if ($24b824b09891b629$var$Zn) {
        if (P = $24b824b09891b629$var$ae, t ? n && $24b824b09891b629$var$Pe(t, d1, 3, [
            c(),
            N ? [] : void 0,
            P
        ]) : c(), o === 'sync') {
            const C = $24b824b09891b629$var$Ja();
            L = C.__watcherHandles || (C.__watcherHandles = []);
        } else return $24b824b09891b629$var$ae;
    }
    let X = N ? new Array(e.length).fill($24b824b09891b629$var$Nn) : $24b824b09891b629$var$Nn;
    const j = ()=>{
        if (!(!F.active || !F.dirty)) {
            if (t) {
                const C = F.run();
                (r || m || (N ? C.some((K, Q)=>$24b824b09891b629$var$at(K, X[Q])) : $24b824b09891b629$var$at(C, X))) && (T && T(), $24b824b09891b629$var$Pe(t, d1, 3, [
                    C,
                    // pass undefined as the old value when it's changed for the first time
                    X === $24b824b09891b629$var$Nn ? void 0 : N && X[0] === $24b824b09891b629$var$Nn ? [] : X,
                    P
                ]), X = C);
            } else F.run();
        }
    };
    j.allowRecurse = !!t;
    let A;
    o === 'sync' ? A = j : o === 'post' ? A = ()=>$24b824b09891b629$var$Ne(j, d1 && d1.suspense) : (j.pre = !0, d1 && (j.id = d1.uid), A = ()=>$24b824b09891b629$var$Kn(j));
    const F = new $24b824b09891b629$var$Br(c, $24b824b09891b629$var$ae, A), B = $24b824b09891b629$var$qs(), Y = ()=>{
        F.stop(), B && $24b824b09891b629$var$Wr(B.effects, F);
    };
    return $24b824b09891b629$var$p.NODE_ENV !== 'production' && (F.onTrack = s, F.onTrigger = a), t ? n ? j() : X = F.run() : o === 'post' ? $24b824b09891b629$var$Ne(F.run.bind(F), d1 && d1.suspense) : F.run(), L && L.push(Y), Y;
}
function $24b824b09891b629$var$Qa(e, t, n) {
    const r = this.proxy, o = $24b824b09891b629$var$re(e) ? e.includes('.') ? $24b824b09891b629$var$Xi(r, e) : ()=>r[e] : e.bind(r, r);
    let i;
    $24b824b09891b629$var$S(t) ? i = t : (i = t.handler, n = t);
    const s = $24b824b09891b629$var$mn(this), a = $24b824b09891b629$var$Ki(o, i.bind(r), n);
    return s(), a;
}
function $24b824b09891b629$var$Xi(e, t) {
    const n = t.split('.');
    return ()=>{
        let r = e;
        for(let o = 0; o < n.length && r; o++)r = r[n[o]];
        return r;
    };
}
function $24b824b09891b629$var$vt(e, t, n = 0, r) {
    if (!$24b824b09891b629$var$ee(e) || e.__v_skip) return e;
    if (t && t > 0) {
        if (n >= t) return e;
        n++;
    }
    if (r = r || /* @__PURE__ */ new Set(), r.has(e)) return e;
    if (r.add(e), $24b824b09891b629$var$ge(e)) $24b824b09891b629$var$vt(e.value, t, n, r);
    else if ($24b824b09891b629$var$M(e)) for(let o = 0; o < e.length; o++)$24b824b09891b629$var$vt(e[o], t, n, r);
    else if ($24b824b09891b629$var$si(e) || $24b824b09891b629$var$yt(e)) e.forEach((o)=>{
        $24b824b09891b629$var$vt(o, t, n, r);
    });
    else if ($24b824b09891b629$var$li(e)) for(const o in e)$24b824b09891b629$var$vt(e[o], t, n, r);
    return e;
}
function $24b824b09891b629$var$zi(e) {
    $24b824b09891b629$var$xs(e) && $24b824b09891b629$var$w('Do not use built-in directive ids as custom directive id: ' + e);
}
function $24b824b09891b629$var$Za(e, t) {
    if ($24b824b09891b629$var$le === null) return $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w('withDirectives can only be used inside render functions.'), e;
    const n = $24b824b09891b629$var$er($24b824b09891b629$var$le) || $24b824b09891b629$var$le.proxy, r = e.dirs || (e.dirs = []);
    for(let o = 0; o < t.length; o++){
        let [i, s, a, u = $24b824b09891b629$var$Z] = t[o];
        i && ($24b824b09891b629$var$S(i) && (i = {
            mounted: i,
            updated: i
        }), i.deep && $24b824b09891b629$var$vt(s), r.push({
            dir: i,
            instance: n,
            value: s,
            oldValue: void 0,
            arg: a,
            modifiers: u
        }));
    }
    return e;
}
function $24b824b09891b629$var$pt(e, t, n, r) {
    const o = e.dirs, i = t && t.dirs;
    for(let s = 0; s < o.length; s++){
        const a = o[s];
        i && (a.oldValue = i[s].value);
        let u = a.dir[r];
        u && ($24b824b09891b629$var$ft(), $24b824b09891b629$var$Pe(u, n, 8, [
            e.el,
            a,
            e,
            t
        ]), $24b824b09891b629$var$dt());
    }
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $24b824b09891b629$var$el(e, t) {
    return $24b824b09891b629$var$S(e) ? // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    $24b824b09891b629$var$se({
        name: e.name
    }, t, {
        setup: e
    }) : e;
}
const $24b824b09891b629$var$rn = (e)=>!!e.type.__asyncLoader, $24b824b09891b629$var$to = (e)=>e.type.__isKeepAlive;
function $24b824b09891b629$var$tl(e, t) {
    $24b824b09891b629$var$Ji(e, 'a', t);
}
function $24b824b09891b629$var$nl(e, t) {
    $24b824b09891b629$var$Ji(e, 'da', t);
}
function $24b824b09891b629$var$Ji(e, t, n = $24b824b09891b629$var$de) {
    const r = e.__wdc || (e.__wdc = ()=>{
        let o = n;
        for(; o;){
            if (o.isDeactivated) return;
            o = o.parent;
        }
        return e();
    });
    if ($24b824b09891b629$var$zn(t, r, n), n) {
        let o = n.parent;
        for(; o && o.parent;)$24b824b09891b629$var$to(o.parent.vnode) && $24b824b09891b629$var$rl(r, t, n, o), o = o.parent;
    }
}
function $24b824b09891b629$var$rl(e, t, n, r) {
    const o = $24b824b09891b629$var$zn(t, e, r, !0);
    $24b824b09891b629$var$Qi(()=>{
        $24b824b09891b629$var$Wr(r[t], o);
    }, n);
}
function $24b824b09891b629$var$zn(e, t, n = $24b824b09891b629$var$de, r = !1) {
    if (n) {
        const o = n[e] || (n[e] = []), i = t.__weh || (t.__weh = (...s)=>{
            if (n.isUnmounted) return;
            $24b824b09891b629$var$ft();
            const a = $24b824b09891b629$var$mn(n), u = $24b824b09891b629$var$Pe(t, n, e, s);
            return a(), $24b824b09891b629$var$dt(), u;
        });
        return r ? o.unshift(i) : o.push(i), i;
    } else if ($24b824b09891b629$var$p.NODE_ENV !== 'production') {
        const o = $24b824b09891b629$var$mt($24b824b09891b629$var$zr[e].replace(/ hook$/, ''));
        $24b824b09891b629$var$w(`${o} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup(). If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`);
    }
}
const $24b824b09891b629$var$Xe = (e)=>(t, n = $24b824b09891b629$var$de)=>// post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
        (!$24b824b09891b629$var$Zn || e === 'sp') && $24b824b09891b629$var$zn(e, (...r)=>t(...r), n), $24b824b09891b629$var$ol = $24b824b09891b629$var$Xe('bm'), $24b824b09891b629$var$il = $24b824b09891b629$var$Xe('m'), $24b824b09891b629$var$sl = $24b824b09891b629$var$Xe('bu'), $24b824b09891b629$var$al = $24b824b09891b629$var$Xe('u'), $24b824b09891b629$var$ll = $24b824b09891b629$var$Xe('bum'), $24b824b09891b629$var$Qi = $24b824b09891b629$var$Xe('um'), $24b824b09891b629$var$ul = $24b824b09891b629$var$Xe('sp'), $24b824b09891b629$var$cl = $24b824b09891b629$var$Xe('rtg'), $24b824b09891b629$var$fl = $24b824b09891b629$var$Xe('rtc');
function $24b824b09891b629$var$dl(e, t = $24b824b09891b629$var$de) {
    $24b824b09891b629$var$zn('ec', e, t);
}
function $24b824b09891b629$var$pl(e, t, n, r) {
    let o;
    const i = n && n[r];
    if ($24b824b09891b629$var$M(e) || $24b824b09891b629$var$re(e)) {
        o = new Array(e.length);
        for(let s = 0, a = e.length; s < a; s++)o[s] = t(e[s], s, void 0, i && i[s]);
    } else if (typeof e == 'number') {
        $24b824b09891b629$var$p.NODE_ENV !== 'production' && !Number.isInteger(e) && $24b824b09891b629$var$w(`The v-for range expect an integer value but got ${e}.`), o = new Array(e);
        for(let s = 0; s < e; s++)o[s] = t(s + 1, s, void 0, i && i[s]);
    } else if ($24b824b09891b629$var$ee(e)) {
        if (e[Symbol.iterator]) o = Array.from(e, (s, a)=>t(s, a, void 0, i && i[a]));
        else {
            const s = Object.keys(e);
            o = new Array(s.length);
            for(let a = 0, u = s.length; a < u; a++){
                const d1 = s[a];
                o[a] = t(e[d1], d1, a, i && i[a]);
            }
        }
    } else o = [];
    return n && (n[r] = o), o;
}
function $24b824b09891b629$var$hl(e, t) {
    for(let n = 0; n < t.length; n++){
        const r = t[n];
        if ($24b824b09891b629$var$M(r)) for(let o = 0; o < r.length; o++)e[r[o].name] = r[o].fn;
        else r && (e[r.name] = r.key ? (...o)=>{
            const i = r.fn(...o);
            return i && (i.key = r.key), i;
        } : r.fn);
    }
    return e;
}
function $24b824b09891b629$var$zt(e, t, n = {}, r, o) {
    if ($24b824b09891b629$var$le.isCE || $24b824b09891b629$var$le.parent && $24b824b09891b629$var$rn($24b824b09891b629$var$le.parent) && $24b824b09891b629$var$le.parent.isCE) return t !== 'default' && (n.name = t), $24b824b09891b629$var$pe('slot', n, r && r());
    let i = e[t];
    $24b824b09891b629$var$p.NODE_ENV !== 'production' && i && i.length > 1 && ($24b824b09891b629$var$w('SSR-optimized slot function detected in a non-SSR-optimized render function. You need to mark this component with $dynamic-slots in the parent template.'), i = ()=>[]), i && i._c && (i._d = !1), $24b824b09891b629$var$te();
    const s = i && $24b824b09891b629$var$Zi(i(n)), a = $24b824b09891b629$var$ut($24b824b09891b629$var$Oe, {
        key: n.key || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        s && s.key || `_${t}`
    }, s || (r ? r() : []), s && e._ === 1 ? 64 : -2);
    return !o && a.scopeId && (a.slotScopeIds = [
        a.scopeId + '-s'
    ]), i && i._c && (i._d = !0), a;
}
function $24b824b09891b629$var$Zi(e) {
    return e.some((t)=>$24b824b09891b629$var$Jn(t) ? !(t.type === $24b824b09891b629$var$De || t.type === $24b824b09891b629$var$Oe && !$24b824b09891b629$var$Zi(t.children)) : !0) ? e : null;
}
const $24b824b09891b629$var$Tr = (e)=>e ? $24b824b09891b629$var$ms(e) ? $24b824b09891b629$var$er(e) || e.proxy : $24b824b09891b629$var$Tr(e.parent) : null, $24b824b09891b629$var$Ot = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ $24b824b09891b629$var$se(/* @__PURE__ */ Object.create(null), {
    $: (e)=>e,
    $el: (e)=>e.vnode.el,
    $data: (e)=>e.data,
    $props: (e)=>$24b824b09891b629$var$p.NODE_ENV !== 'production' ? $24b824b09891b629$var$Ft(e.props) : e.props,
    $attrs: (e)=>$24b824b09891b629$var$p.NODE_ENV !== 'production' ? $24b824b09891b629$var$Ft(e.attrs) : e.attrs,
    $slots: (e)=>$24b824b09891b629$var$p.NODE_ENV !== 'production' ? $24b824b09891b629$var$Ft(e.slots) : e.slots,
    $refs: (e)=>$24b824b09891b629$var$p.NODE_ENV !== 'production' ? $24b824b09891b629$var$Ft(e.refs) : e.refs,
    $parent: (e)=>$24b824b09891b629$var$Tr(e.parent),
    $root: (e)=>$24b824b09891b629$var$Tr(e.root),
    $emit: (e)=>e.emit,
    $options: (e)=>$24b824b09891b629$var$ro(e),
    $forceUpdate: (e)=>e.f || (e.f = ()=>{
            e.effect.dirty = !0, $24b824b09891b629$var$Kn(e.update);
        }),
    $nextTick: (e)=>e.n || (e.n = $24b824b09891b629$var$Oa.bind(e.proxy)),
    $watch: (e)=>$24b824b09891b629$var$Qa.bind(e)
}), $24b824b09891b629$var$no = (e)=>e === '_' || e === '$', $24b824b09891b629$var$pr = (e, t)=>e !== $24b824b09891b629$var$Z && !e.__isScriptSetup && $24b824b09891b629$var$H(e, t), $24b824b09891b629$var$es = {
    get ({ _: e }, t) {
        const { ctx: n, setupState: r, data: o, props: i, accessCache: s, type: a, appContext: u } = e;
        if ($24b824b09891b629$var$p.NODE_ENV !== 'production' && t === '__isVue') return !0;
        let d1;
        if (t[0] !== '$') {
            const N = s[t];
            if (N !== void 0) switch(N){
                case 1:
                    return r[t];
                case 2:
                    return o[t];
                case 4:
                    return n[t];
                case 3:
                    return i[t];
            }
            else {
                if ($24b824b09891b629$var$pr(r, t)) return s[t] = 1, r[t];
                if (o !== $24b824b09891b629$var$Z && $24b824b09891b629$var$H(o, t)) return s[t] = 2, o[t];
                if (// only cache other properties when instance has declared (thus stable)
                // props
                (d1 = e.propsOptions[0]) && $24b824b09891b629$var$H(d1, t)) return s[t] = 3, i[t];
                if (n !== $24b824b09891b629$var$Z && $24b824b09891b629$var$H(n, t)) return s[t] = 4, n[t];
                $24b824b09891b629$var$xr && (s[t] = 0);
            }
        }
        const h = $24b824b09891b629$var$Ot[t];
        let c, m;
        if (h) return t === '$attrs' ? ($24b824b09891b629$var$me(e, 'get', t), $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$An()) : $24b824b09891b629$var$p.NODE_ENV !== 'production' && t === '$slots' && $24b824b09891b629$var$me(e, 'get', t), h(e);
        if (// css module (injected by vue-loader)
        (c = a.__cssModules) && (c = c[t])) return c;
        if (n !== $24b824b09891b629$var$Z && $24b824b09891b629$var$H(n, t)) return s[t] = 4, n[t];
        if (// global properties
        m = u.config.globalProperties, $24b824b09891b629$var$H(m, t)) return m[t];
        $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$le && (!$24b824b09891b629$var$re(t) || // #1091 avoid internal isRef/isVNode checks on component instance leading
        // to infinite warning loop
        t.indexOf('__v') !== 0) && (o !== $24b824b09891b629$var$Z && $24b824b09891b629$var$no(t[0]) && $24b824b09891b629$var$H(o, t) ? $24b824b09891b629$var$w(`Property ${JSON.stringify(t)} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`) : e === $24b824b09891b629$var$le && $24b824b09891b629$var$w(`Property ${JSON.stringify(t)} was accessed during render but is not defined on instance.`));
    },
    set ({ _: e }, t, n) {
        const { data: r, setupState: o, ctx: i } = e;
        return $24b824b09891b629$var$pr(o, t) ? (o[t] = n, !0) : $24b824b09891b629$var$p.NODE_ENV !== 'production' && o.__isScriptSetup && $24b824b09891b629$var$H(o, t) ? ($24b824b09891b629$var$w(`Cannot mutate <script setup> binding "${t}" from Options API.`), !1) : r !== $24b824b09891b629$var$Z && $24b824b09891b629$var$H(r, t) ? (r[t] = n, !0) : $24b824b09891b629$var$H(e.props, t) ? ($24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w(`Attempting to mutate prop "${t}". Props are readonly.`), !1) : t[0] === '$' && t.slice(1) in e ? ($24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w(`Attempting to mutate public property "${t}". Properties starting with $ are reserved and readonly.`), !1) : ($24b824b09891b629$var$p.NODE_ENV !== 'production' && t in e.appContext.config.globalProperties ? Object.defineProperty(i, t, {
            enumerable: !0,
            configurable: !0,
            value: n
        }) : i[t] = n, !0);
    },
    has ({ _: { data: e, setupState: t, accessCache: n, ctx: r, appContext: o, propsOptions: i } }, s) {
        let a;
        return !!n[s] || e !== $24b824b09891b629$var$Z && $24b824b09891b629$var$H(e, s) || $24b824b09891b629$var$pr(t, s) || (a = i[0]) && $24b824b09891b629$var$H(a, s) || $24b824b09891b629$var$H(r, s) || $24b824b09891b629$var$H($24b824b09891b629$var$Ot, s) || $24b824b09891b629$var$H(o.config.globalProperties, s);
    },
    defineProperty (e, t, n) {
        return n.get != null ? e._.accessCache[t] = 0 : $24b824b09891b629$var$H(n, 'value') && this.set(e, t, n.value, null), Reflect.defineProperty(e, t, n);
    }
};
$24b824b09891b629$var$p.NODE_ENV !== 'production' && ($24b824b09891b629$var$es.ownKeys = (e)=>($24b824b09891b629$var$w('Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead.'), Reflect.ownKeys(e)));
function $24b824b09891b629$var$ml(e) {
    const t = {};
    return Object.defineProperty(t, '_', {
        configurable: !0,
        enumerable: !1,
        get: ()=>e
    }), Object.keys($24b824b09891b629$var$Ot).forEach((n)=>{
        Object.defineProperty(t, n, {
            configurable: !0,
            enumerable: !1,
            get: ()=>$24b824b09891b629$var$Ot[n](e),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: $24b824b09891b629$var$ae
        });
    }), t;
}
function $24b824b09891b629$var$gl(e) {
    const { ctx: t, propsOptions: [n] } = e;
    n && Object.keys(n).forEach((r)=>{
        Object.defineProperty(t, r, {
            enumerable: !0,
            configurable: !0,
            get: ()=>e.props[r],
            set: $24b824b09891b629$var$ae
        });
    });
}
function $24b824b09891b629$var$vl(e) {
    const { ctx: t, setupState: n } = e;
    Object.keys($24b824b09891b629$var$R(n)).forEach((r)=>{
        if (!n.__isScriptSetup) {
            if ($24b824b09891b629$var$no(r[0])) {
                $24b824b09891b629$var$w(`setup() return property ${JSON.stringify(r)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(t, r, {
                enumerable: !0,
                configurable: !0,
                get: ()=>n[r],
                set: $24b824b09891b629$var$ae
            });
        }
    });
}
function $24b824b09891b629$var$$o(e) {
    return $24b824b09891b629$var$M(e) ? e.reduce((t, n)=>(t[n] = null, t), {}) : e;
}
function $24b824b09891b629$var$_l() {
    const e = /* @__PURE__ */ Object.create(null);
    return (t, n)=>{
        e[n] ? $24b824b09891b629$var$w(`${t} property "${n}" is already defined in ${e[n]}.`) : e[n] = t;
    };
}
let $24b824b09891b629$var$xr = !0;
function $24b824b09891b629$var$yl(e) {
    const t = $24b824b09891b629$var$ro(e), n = e.proxy, r = e.ctx;
    $24b824b09891b629$var$xr = !1, t.beforeCreate && $24b824b09891b629$var$Co(t.beforeCreate, e, 'bc');
    const { // state
    data: o, computed: i, methods: s, watch: a, provide: u, inject: d1, // lifecycle
    created: h, beforeMount: c, mounted: m, beforeUpdate: N, updated: T, activated: P, deactivated: L, beforeDestroy: X, beforeUnmount: j, destroyed: A, unmounted: F, render: B, renderTracked: Y, renderTriggered: C, errorCaptured: K, serverPrefetch: Q, // public API
    expose: ue, inheritAttrs: ye, // assets
    components: Ce, directives: Vt, filters: gn } = t, ie = $24b824b09891b629$var$p.NODE_ENV !== 'production' ? $24b824b09891b629$var$_l() : null;
    if ($24b824b09891b629$var$p.NODE_ENV !== 'production') {
        const [W] = e.propsOptions;
        if (W) for(const q in W)ie('Props', q);
    }
    if (d1 && $24b824b09891b629$var$bl(d1, r, ie), s) for(const W in s){
        const q = s[W];
        $24b824b09891b629$var$S(q) ? ($24b824b09891b629$var$p.NODE_ENV !== 'production' ? Object.defineProperty(r, W, {
            value: q.bind(n),
            configurable: !0,
            enumerable: !0,
            writable: !0
        }) : r[W] = q.bind(n), $24b824b09891b629$var$p.NODE_ENV !== 'production' && ie('Methods', W)) : $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w(`Method "${W}" has type "${typeof q}" in the component definition. Did you reference the function correctly?`);
    }
    if (o) {
        $24b824b09891b629$var$p.NODE_ENV !== 'production' && !$24b824b09891b629$var$S(o) && $24b824b09891b629$var$w('The data option must be a function. Plain object usage is no longer supported.');
        const W = o.call(n, n);
        if ($24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Lr(W) && $24b824b09891b629$var$w('data() returned a Promise - note data() cannot be async; If you intend to perform data fetching before component renders, use async setup() + <Suspense>.'), !$24b824b09891b629$var$ee(W)) $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w('data() should return an object.');
        else if (e.data = $24b824b09891b629$var$Yt(W), $24b824b09891b629$var$p.NODE_ENV !== 'production') for(const q in W)ie('Data', q), $24b824b09891b629$var$no(q[0]) || Object.defineProperty(r, q, {
            configurable: !0,
            enumerable: !0,
            get: ()=>W[q],
            set: $24b824b09891b629$var$ae
        });
    }
    if ($24b824b09891b629$var$xr = !0, i) for(const W in i){
        const q = i[W], Se = $24b824b09891b629$var$S(q) ? q.bind(n, n) : $24b824b09891b629$var$S(q.get) ? q.get.bind(n, n) : $24b824b09891b629$var$ae;
        $24b824b09891b629$var$p.NODE_ENV !== 'production' && Se === $24b824b09891b629$var$ae && $24b824b09891b629$var$w(`Computed property "${W}" has no getter.`);
        const or = !$24b824b09891b629$var$S(q) && $24b824b09891b629$var$S(q.set) ? q.set.bind(n) : $24b824b09891b629$var$p.NODE_ENV !== 'production' ? ()=>{
            $24b824b09891b629$var$w(`Write operation failed: computed property "${W}" is readonly.`);
        } : $24b824b09891b629$var$ae, qt = $24b824b09891b629$var$Tt({
            get: Se,
            set: or
        });
        Object.defineProperty(r, W, {
            enumerable: !0,
            configurable: !0,
            get: ()=>qt.value,
            set: (Mt)=>qt.value = Mt
        }), $24b824b09891b629$var$p.NODE_ENV !== 'production' && ie('Computed', W);
    }
    if (a) for(const W in a)$24b824b09891b629$var$ts(a[W], r, n, W);
    if (u) {
        const W = $24b824b09891b629$var$S(u) ? u.call(n) : u;
        Reflect.ownKeys(W).forEach((q)=>{
            $24b824b09891b629$var$$l(q, W[q]);
        });
    }
    h && $24b824b09891b629$var$Co(h, e, 'c');
    function oe(W, q) {
        $24b824b09891b629$var$M(q) ? q.forEach((Se)=>W(Se.bind(n))) : q && W(q.bind(n));
    }
    if (oe($24b824b09891b629$var$ol, c), oe($24b824b09891b629$var$il, m), oe($24b824b09891b629$var$sl, N), oe($24b824b09891b629$var$al, T), oe($24b824b09891b629$var$tl, P), oe($24b824b09891b629$var$nl, L), oe($24b824b09891b629$var$dl, K), oe($24b824b09891b629$var$fl, Y), oe($24b824b09891b629$var$cl, C), oe($24b824b09891b629$var$ll, j), oe($24b824b09891b629$var$Qi, F), oe($24b824b09891b629$var$ul, Q), $24b824b09891b629$var$M(ue)) {
        if (ue.length) {
            const W = e.exposed || (e.exposed = {});
            ue.forEach((q)=>{
                Object.defineProperty(W, q, {
                    get: ()=>n[q],
                    set: (Se)=>n[q] = Se
                });
            });
        } else e.exposed || (e.exposed = {});
    }
    B && e.render === $24b824b09891b629$var$ae && (e.render = B), ye != null && (e.inheritAttrs = ye), Ce && (e.components = Ce), Vt && (e.directives = Vt);
}
function $24b824b09891b629$var$bl(e, t, n = $24b824b09891b629$var$ae) {
    $24b824b09891b629$var$M(e) && (e = $24b824b09891b629$var$Vr(e));
    for(const r in e){
        const o = e[r];
        let i;
        $24b824b09891b629$var$ee(o) ? 'default' in o ? i = $24b824b09891b629$var$xn(o.from || r, o.default, !0) : i = $24b824b09891b629$var$xn(o.from || r) : i = $24b824b09891b629$var$xn(o), $24b824b09891b629$var$ge(i) ? Object.defineProperty(t, r, {
            enumerable: !0,
            configurable: !0,
            get: ()=>i.value,
            set: (s)=>i.value = s
        }) : t[r] = i, $24b824b09891b629$var$p.NODE_ENV !== 'production' && n('Inject', r);
    }
}
function $24b824b09891b629$var$Co(e, t, n) {
    $24b824b09891b629$var$Pe($24b824b09891b629$var$M(e) ? e.map((r)=>r.bind(t.proxy)) : e.bind(t.proxy), t, n);
}
function $24b824b09891b629$var$ts(e, t, n, r) {
    const o = r.includes('.') ? $24b824b09891b629$var$Xi(n, r) : ()=>n[r];
    if ($24b824b09891b629$var$re(e)) {
        const i = t[e];
        $24b824b09891b629$var$S(i) ? $24b824b09891b629$var$dr(o, i) : $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w(`Invalid watch handler specified by key "${e}"`, i);
    } else if ($24b824b09891b629$var$S(e)) $24b824b09891b629$var$dr(o, e.bind(n));
    else if ($24b824b09891b629$var$ee(e)) {
        if ($24b824b09891b629$var$M(e)) e.forEach((i)=>$24b824b09891b629$var$ts(i, t, n, r));
        else {
            const i = $24b824b09891b629$var$S(e.handler) ? e.handler.bind(n) : t[e.handler];
            $24b824b09891b629$var$S(i) ? $24b824b09891b629$var$dr(o, i, e) : $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w(`Invalid watch handler specified by key "${e.handler}"`, i);
        }
    } else $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w(`Invalid watch option: "${r}"`, e);
}
function $24b824b09891b629$var$ro(e) {
    const t = e.type, { mixins: n, extends: r } = t, { mixins: o, optionsCache: i, config: { optionMergeStrategies: s } } = e.appContext, a = i.get(t);
    let u;
    return a ? u = a : !o.length && !n && !r ? u = t : (u = {}, o.length && o.forEach((d1)=>$24b824b09891b629$var$Fn(u, d1, s, !0)), $24b824b09891b629$var$Fn(u, t, s)), $24b824b09891b629$var$ee(t) && i.set(t, u), u;
}
function $24b824b09891b629$var$Fn(e, t, n, r = !1) {
    const { mixins: o, extends: i } = t;
    i && $24b824b09891b629$var$Fn(e, i, n, !0), o && o.forEach((s)=>$24b824b09891b629$var$Fn(e, s, n, !0));
    for(const s in t)if (r && s === 'expose') $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w('"expose" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.');
    else {
        const a = $24b824b09891b629$var$wl[s] || n && n[s];
        e[s] = a ? a(e[s], t[s]) : t[s];
    }
    return e;
}
const $24b824b09891b629$var$wl = {
    data: $24b824b09891b629$var$To,
    props: $24b824b09891b629$var$xo,
    emits: $24b824b09891b629$var$xo,
    // objects
    methods: $24b824b09891b629$var$tn,
    computed: $24b824b09891b629$var$tn,
    // lifecycle
    beforeCreate: $24b824b09891b629$var$Ee,
    created: $24b824b09891b629$var$Ee,
    beforeMount: $24b824b09891b629$var$Ee,
    mounted: $24b824b09891b629$var$Ee,
    beforeUpdate: $24b824b09891b629$var$Ee,
    updated: $24b824b09891b629$var$Ee,
    beforeDestroy: $24b824b09891b629$var$Ee,
    beforeUnmount: $24b824b09891b629$var$Ee,
    destroyed: $24b824b09891b629$var$Ee,
    unmounted: $24b824b09891b629$var$Ee,
    activated: $24b824b09891b629$var$Ee,
    deactivated: $24b824b09891b629$var$Ee,
    errorCaptured: $24b824b09891b629$var$Ee,
    serverPrefetch: $24b824b09891b629$var$Ee,
    // assets
    components: $24b824b09891b629$var$tn,
    directives: $24b824b09891b629$var$tn,
    // watch
    watch: $24b824b09891b629$var$Nl,
    // provide / inject
    provide: $24b824b09891b629$var$To,
    inject: $24b824b09891b629$var$El
};
function $24b824b09891b629$var$To(e, t) {
    return t ? e ? function() {
        return $24b824b09891b629$var$se($24b824b09891b629$var$S(e) ? e.call(this, this) : e, $24b824b09891b629$var$S(t) ? t.call(this, this) : t);
    } : t : e;
}
function $24b824b09891b629$var$El(e, t) {
    return $24b824b09891b629$var$tn($24b824b09891b629$var$Vr(e), $24b824b09891b629$var$Vr(t));
}
function $24b824b09891b629$var$Vr(e) {
    if ($24b824b09891b629$var$M(e)) {
        const t = {};
        for(let n = 0; n < e.length; n++)t[e[n]] = e[n];
        return t;
    }
    return e;
}
function $24b824b09891b629$var$Ee(e, t) {
    return e ? [
        ...new Set([].concat(e, t))
    ] : t;
}
function $24b824b09891b629$var$tn(e, t) {
    return e ? $24b824b09891b629$var$se(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function $24b824b09891b629$var$xo(e, t) {
    return e ? $24b824b09891b629$var$M(e) && $24b824b09891b629$var$M(t) ? [
        .../* @__PURE__ */ new Set([
            ...e,
            ...t
        ])
    ] : $24b824b09891b629$var$se(/* @__PURE__ */ Object.create(null), $24b824b09891b629$var$$o(e), $24b824b09891b629$var$$o(t ?? {})) : t;
}
function $24b824b09891b629$var$Nl(e, t) {
    if (!e) return t;
    if (!t) return e;
    const n = $24b824b09891b629$var$se(/* @__PURE__ */ Object.create(null), e);
    for(const r in t)n[r] = $24b824b09891b629$var$Ee(e[r], t[r]);
    return n;
}
function $24b824b09891b629$var$ns() {
    return {
        app: null,
        config: {
            isNativeTag: $24b824b09891b629$var$ii,
            performance: !1,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $24b824b09891b629$var$Ol = 0;
function $24b824b09891b629$var$Dl(e, t) {
    return function(r, o = null) {
        $24b824b09891b629$var$S(r) || (r = $24b824b09891b629$var$se({}, r)), o != null && !$24b824b09891b629$var$ee(o) && ($24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w('root props passed to app.mount() must be an object.'), o = null);
        const i = $24b824b09891b629$var$ns(), s = /* @__PURE__ */ new WeakSet();
        let a = !1;
        const u = i.app = {
            _uid: $24b824b09891b629$var$Ol++,
            _component: r,
            _props: o,
            _container: null,
            _context: i,
            _instance: null,
            version: $24b824b09891b629$var$Uo,
            get config () {
                return i.config;
            },
            set config (d){
                $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w('app.config cannot be replaced. Modify individual options instead.');
            },
            use (d1, ...h) {
                return s.has(d1) ? $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w('Plugin has already been applied to target app.') : d1 && $24b824b09891b629$var$S(d1.install) ? (s.add(d1), d1.install(u, ...h)) : $24b824b09891b629$var$S(d1) ? (s.add(d1), d1(u, ...h)) : $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w('A plugin must either be a function or an object with an "install" function.'), u;
            },
            mixin (d1) {
                return i.mixins.includes(d1) ? $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w('Mixin has already been applied to target app' + (d1.name ? `: ${d1.name}` : '')) : i.mixins.push(d1), u;
            },
            component (d1, h) {
                return $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Ar(d1, i.config), h ? ($24b824b09891b629$var$p.NODE_ENV !== 'production' && i.components[d1] && $24b824b09891b629$var$w(`Component "${d1}" has already been registered in target app.`), i.components[d1] = h, u) : i.components[d1];
            },
            directive (d1, h) {
                return $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$zi(d1), h ? ($24b824b09891b629$var$p.NODE_ENV !== 'production' && i.directives[d1] && $24b824b09891b629$var$w(`Directive "${d1}" has already been registered in target app.`), i.directives[d1] = h, u) : i.directives[d1];
            },
            mount (d1, h, c) {
                if (a) $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w('App has already been mounted.\nIf you want to remount the same app, move your app creation logic into a factory function and create fresh app instances for each mount - e.g. `const createMyApp = () => createApp(App)`');
                else {
                    $24b824b09891b629$var$p.NODE_ENV !== 'production' && d1.__vue_app__ && $24b824b09891b629$var$w('There is already an app instance mounted on the host container.\n If you want to mount another app on the same host container, you need to unmount the previous app by calling `app.unmount()` first.');
                    const m = $24b824b09891b629$var$pe(r, o);
                    return m.appContext = i, c === !0 ? c = 'svg' : c === !1 && (c = void 0), $24b824b09891b629$var$p.NODE_ENV !== 'production' && (i.reload = ()=>{
                        e($24b824b09891b629$var$ct(m), d1, c);
                    }), h && t ? t(m, d1) : e(m, d1, c), a = !0, u._container = d1, d1.__vue_app__ = u, $24b824b09891b629$var$p.NODE_ENV !== 'production' && (u._instance = m.component, $24b824b09891b629$var$Pa(u, $24b824b09891b629$var$Uo)), $24b824b09891b629$var$er(m.component) || m.component.proxy;
                }
            },
            unmount () {
                a ? (e(null, u._container), $24b824b09891b629$var$p.NODE_ENV !== 'production' && (u._instance = null, $24b824b09891b629$var$Sa(u)), delete u._container.__vue_app__) : $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w('Cannot unmount an app that is not mounted.');
            },
            provide (d1, h) {
                return $24b824b09891b629$var$p.NODE_ENV !== 'production' && d1 in i.provides && $24b824b09891b629$var$w(`App already provides property with key "${String(d1)}". It will be overwritten with the new value.`), i.provides[d1] = h, u;
            },
            runWithContext (d1) {
                $24b824b09891b629$var$Rn = u;
                try {
                    return d1();
                } finally{
                    $24b824b09891b629$var$Rn = null;
                }
            }
        };
        return u;
    };
}
let $24b824b09891b629$var$Rn = null;
function $24b824b09891b629$var$$l(e, t) {
    if (!$24b824b09891b629$var$de) $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w('provide() can only be used inside setup().');
    else {
        let n = $24b824b09891b629$var$de.provides;
        const r = $24b824b09891b629$var$de.parent && $24b824b09891b629$var$de.parent.provides;
        r === n && (n = $24b824b09891b629$var$de.provides = Object.create(r)), n[e] = t;
    }
}
function $24b824b09891b629$var$xn(e, t, n = !1) {
    const r = $24b824b09891b629$var$de || $24b824b09891b629$var$le;
    if (r || $24b824b09891b629$var$Rn) {
        const o = r ? r.parent == null ? r.vnode.appContext && r.vnode.appContext.provides : r.parent.provides : $24b824b09891b629$var$Rn._context.provides;
        if (o && e in o) return o[e];
        if (arguments.length > 1) return n && $24b824b09891b629$var$S(t) ? t.call(r && r.proxy) : t;
        $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w(`injection "${String(e)}" not found.`);
    } else $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w('inject() can only be used inside setup() or functional components.');
}
function $24b824b09891b629$var$Cl(e, t, n, r = !1) {
    const o = {}, i = {};
    $24b824b09891b629$var$Sn(i, $24b824b09891b629$var$Qn, 1), e.propsDefaults = /* @__PURE__ */ Object.create(null), $24b824b09891b629$var$rs(e, t, o, i);
    for(const s in e.propsOptions[0])s in o || (o[s] = void 0);
    $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$is(t || {}, o, e), n ? e.props = r ? o : $24b824b09891b629$var$pa(o) : e.type.props ? e.props = o : e.props = i, e.attrs = i;
}
function $24b824b09891b629$var$Tl(e) {
    for(; e;){
        if (e.type.__hmrId) return !0;
        e = e.parent;
    }
}
function $24b824b09891b629$var$xl(e, t, n, r) {
    const { props: o, attrs: i, vnode: { patchFlag: s } } = e, a = $24b824b09891b629$var$R(o), [u] = e.propsOptions;
    let d1 = !1;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    !($24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Tl(e)) && (r || s > 0) && !(s & 16)) {
        if (s & 8) {
            const h = e.vnode.dynamicProps;
            for(let c = 0; c < h.length; c++){
                let m = h[c];
                if ($24b824b09891b629$var$Xn(e.emitsOptions, m)) continue;
                const N = t[m];
                if (u) {
                    if ($24b824b09891b629$var$H(i, m)) N !== i[m] && (i[m] = N, d1 = !0);
                    else {
                        const T = $24b824b09891b629$var$Ue(m);
                        o[T] = $24b824b09891b629$var$Mr(u, a, T, N, e, !1);
                    }
                } else N !== i[m] && (i[m] = N, d1 = !0);
            }
        }
    } else {
        $24b824b09891b629$var$rs(e, t, o, i) && (d1 = !0);
        let h;
        for(const c in a)(!t || // for camelCase
        !$24b824b09891b629$var$H(t, c) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((h = $24b824b09891b629$var$st(c)) === c || !$24b824b09891b629$var$H(t, h))) && (u ? n && // for camelCase
        (n[c] !== void 0 || // for kebab-case
        n[h] !== void 0) && (o[c] = $24b824b09891b629$var$Mr(u, a, c, void 0, e, !0)) : delete o[c]);
        if (i !== a) for(const c in i)(!t || !$24b824b09891b629$var$H(t, c)) && (delete i[c], d1 = !0);
    }
    d1 && $24b824b09891b629$var$Le(e, 'set', '$attrs'), $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$is(t || {}, o, e);
}
function $24b824b09891b629$var$rs(e, t, n, r) {
    const [o, i] = e.propsOptions;
    let s = !1, a;
    if (t) for(let u in t){
        if ($24b824b09891b629$var$Dn(u)) continue;
        const d1 = t[u];
        let h;
        o && $24b824b09891b629$var$H(o, h = $24b824b09891b629$var$Ue(u)) ? !i || !i.includes(h) ? n[h] = d1 : (a || (a = {}))[h] = d1 : $24b824b09891b629$var$Xn(e.emitsOptions, u) || (!(u in r) || d1 !== r[u]) && (r[u] = d1, s = !0);
    }
    if (i) {
        const u = $24b824b09891b629$var$R(n), d1 = a || $24b824b09891b629$var$Z;
        for(let h = 0; h < i.length; h++){
            const c = i[h];
            n[c] = $24b824b09891b629$var$Mr(o, u, c, d1[c], e, !$24b824b09891b629$var$H(d1, c));
        }
    }
    return s;
}
function $24b824b09891b629$var$Mr(e, t, n, r, o, i) {
    const s = e[n];
    if (s != null) {
        const a = $24b824b09891b629$var$H(s, 'default');
        if (a && r === void 0) {
            const u = s.default;
            if (s.type !== Function && !s.skipFactory && $24b824b09891b629$var$S(u)) {
                const { propsDefaults: d1 } = o;
                if (n in d1) r = d1[n];
                else {
                    const h = $24b824b09891b629$var$mn(o);
                    r = d1[n] = u.call(null, t), h();
                }
            } else r = u;
        }
        s[0] && /* shouldCast */ (i && !a ? r = !1 : s[1] && /* shouldCastTrue */ (r === '' || r === $24b824b09891b629$var$st(n)) && (r = !0));
    }
    return r;
}
function $24b824b09891b629$var$os(e, t, n = !1) {
    const r = t.propsCache, o = r.get(e);
    if (o) return o;
    const i = e.props, s = {}, a = [];
    let u = !1;
    if (!$24b824b09891b629$var$S(e)) {
        const h = (c)=>{
            u = !0;
            const [m, N] = $24b824b09891b629$var$os(c, t, !0);
            $24b824b09891b629$var$se(s, m), N && a.push(...N);
        };
        !n && t.mixins.length && t.mixins.forEach(h), e.extends && h(e.extends), e.mixins && e.mixins.forEach(h);
    }
    if (!i && !u) return $24b824b09891b629$var$ee(e) && r.set(e, $24b824b09891b629$var$Rt), $24b824b09891b629$var$Rt;
    if ($24b824b09891b629$var$M(i)) for(let h = 0; h < i.length; h++){
        $24b824b09891b629$var$p.NODE_ENV !== 'production' && !$24b824b09891b629$var$re(i[h]) && $24b824b09891b629$var$w('props must be strings when using array syntax.', i[h]);
        const c = $24b824b09891b629$var$Ue(i[h]);
        $24b824b09891b629$var$Vo(c) && (s[c] = $24b824b09891b629$var$Z);
    }
    else if (i) {
        $24b824b09891b629$var$p.NODE_ENV !== 'production' && !$24b824b09891b629$var$ee(i) && $24b824b09891b629$var$w('invalid props options', i);
        for(const h in i){
            const c = $24b824b09891b629$var$Ue(h);
            if ($24b824b09891b629$var$Vo(c)) {
                const m = i[h], N = s[c] = $24b824b09891b629$var$M(m) || $24b824b09891b629$var$S(m) ? {
                    type: m
                } : $24b824b09891b629$var$se({}, m);
                if (N) {
                    const T = $24b824b09891b629$var$Po(Boolean, N.type), P = $24b824b09891b629$var$Po(String, N.type);
                    N[0] = T > -1, /* shouldCast */ N[1] = P < 0 || T < P, /* shouldCastTrue */ (T > -1 || $24b824b09891b629$var$H(N, 'default')) && a.push(c);
                }
            }
        }
    }
    const d1 = [
        s,
        a
    ];
    return $24b824b09891b629$var$ee(e) && r.set(e, d1), d1;
}
function $24b824b09891b629$var$Vo(e) {
    return e[0] !== '$' ? !0 : ($24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w(`Invalid prop name: "${e}" is a reserved property.`), !1);
}
function $24b824b09891b629$var$Pr(e) {
    const t = e && e.toString().match(/^\s*(function|class) (\w+)/);
    return t ? t[2] : e === null ? 'null' : '';
}
function $24b824b09891b629$var$Mo(e, t) {
    return $24b824b09891b629$var$Pr(e) === $24b824b09891b629$var$Pr(t);
}
function $24b824b09891b629$var$Po(e, t) {
    return $24b824b09891b629$var$M(t) ? t.findIndex((n)=>$24b824b09891b629$var$Mo(n, e)) : $24b824b09891b629$var$S(t) && $24b824b09891b629$var$Mo(t, e) ? 0 : -1;
}
function $24b824b09891b629$var$is(e, t, n) {
    const r = $24b824b09891b629$var$R(t), o = n.propsOptions[0];
    for(const i in o){
        let s = o[i];
        s != null && $24b824b09891b629$var$Vl(i, r[i], s, $24b824b09891b629$var$p.NODE_ENV !== 'production' ? $24b824b09891b629$var$Ft(r) : r, !$24b824b09891b629$var$H(e, i) && !$24b824b09891b629$var$H(e, $24b824b09891b629$var$st(i)));
    }
}
function $24b824b09891b629$var$Vl(e, t, n, r, o) {
    const { type: i, required: s, validator: a, skipCheck: u } = n;
    if (s && o) {
        $24b824b09891b629$var$w('Missing required prop: "' + e + '"');
        return;
    }
    if (!(t == null && !s)) {
        if (i != null && i !== !0 && !u) {
            let d1 = !1;
            const h = $24b824b09891b629$var$M(i) ? i : [
                i
            ], c = [];
            for(let m = 0; m < h.length && !d1; m++){
                const { valid: N, expectedType: T } = $24b824b09891b629$var$Pl(t, h[m]);
                c.push(T || ''), d1 = N;
            }
            if (!d1) {
                $24b824b09891b629$var$w($24b824b09891b629$var$Sl(e, t, c));
                return;
            }
        }
        a && !a(t, r) && $24b824b09891b629$var$w('Invalid prop: custom validator check failed for prop "' + e + '".');
    }
}
const $24b824b09891b629$var$Ml = /* @__PURE__ */ $24b824b09891b629$var$Ke('String,Number,Boolean,Function,Symbol,BigInt');
function $24b824b09891b629$var$Pl(e, t) {
    let n;
    const r = $24b824b09891b629$var$Pr(t);
    if ($24b824b09891b629$var$Ml(r)) {
        const o = typeof e;
        n = o === r.toLowerCase(), !n && o === 'object' && (n = e instanceof t);
    } else r === 'Object' ? n = $24b824b09891b629$var$ee(e) : r === 'Array' ? n = $24b824b09891b629$var$M(e) : r === 'null' ? n = e === null : n = e instanceof t;
    return {
        valid: n,
        expectedType: r
    };
}
function $24b824b09891b629$var$Sl(e, t, n) {
    if (n.length === 0) return `Prop type [] for prop "${e}" won't match anything. Did you mean to use type Array instead?`;
    let r = `Invalid prop: type check failed for prop "${e}". Expected ${n.map($24b824b09891b629$var$$t).join(' | ')}`;
    const o = n[0], i = $24b824b09891b629$var$Ur(t), s = $24b824b09891b629$var$So(t, o), a = $24b824b09891b629$var$So(t, i);
    return n.length === 1 && $24b824b09891b629$var$ko(o) && !$24b824b09891b629$var$kl(o, i) && (r += ` with value ${s}`), r += `, got ${i} `, $24b824b09891b629$var$ko(i) && (r += `with value ${a}.`), r;
}
function $24b824b09891b629$var$So(e, t) {
    return t === 'String' ? `"${e}"` : t === 'Number' ? `${Number(e)}` : `${e}`;
}
function $24b824b09891b629$var$ko(e) {
    return [
        'string',
        'number',
        'boolean'
    ].some((n)=>e.toLowerCase() === n);
}
function $24b824b09891b629$var$kl(...e) {
    return e.some((t)=>t.toLowerCase() === 'boolean');
}
const $24b824b09891b629$var$ss = (e)=>e[0] === '_' || e === '$stable', $24b824b09891b629$var$oo = (e)=>$24b824b09891b629$var$M(e) ? e.map($24b824b09891b629$var$Ve) : [
        $24b824b09891b629$var$Ve(e)
    ], $24b824b09891b629$var$Il = (e, t, n)=>{
    if (t._n) return t;
    const r = $24b824b09891b629$var$At((...o)=>($24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$de && (!n || n.root === $24b824b09891b629$var$de.root) && $24b824b09891b629$var$w(`Slot "${e}" invoked outside of the render function: this will not track dependencies used in the slot. Invoke the slot function inside the render function instead.`), $24b824b09891b629$var$oo(t(...o))), n);
    return r._c = !1, r;
}, $24b824b09891b629$var$as = (e, t, n)=>{
    const r = e._ctx;
    for(const o in e){
        if ($24b824b09891b629$var$ss(o)) continue;
        const i = e[o];
        if ($24b824b09891b629$var$S(i)) t[o] = $24b824b09891b629$var$Il(o, i, r);
        else if (i != null) {
            $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w(`Non-function value encountered for slot "${o}". Prefer function slots for better performance.`);
            const s = $24b824b09891b629$var$oo(i);
            t[o] = ()=>s;
        }
    }
}, $24b824b09891b629$var$ls = (e, t)=>{
    $24b824b09891b629$var$p.NODE_ENV !== 'production' && !$24b824b09891b629$var$to(e.vnode) && $24b824b09891b629$var$w('Non-function value encountered for default slot. Prefer function slots for better performance.');
    const n = $24b824b09891b629$var$oo(t);
    e.slots.default = ()=>n;
}, $24b824b09891b629$var$Al = (e, t)=>{
    if (e.vnode.shapeFlag & 32) {
        const n = t._;
        n ? (e.slots = $24b824b09891b629$var$R(t), $24b824b09891b629$var$Sn(t, '_', n)) : $24b824b09891b629$var$as(t, e.slots = {});
    } else e.slots = {}, t && $24b824b09891b629$var$ls(e, t);
    $24b824b09891b629$var$Sn(e.slots, $24b824b09891b629$var$Qn, 1);
}, $24b824b09891b629$var$Fl = (e, t, n)=>{
    const { vnode: r, slots: o } = e;
    let i = !0, s = $24b824b09891b629$var$Z;
    if (r.shapeFlag & 32) {
        const a = t._;
        a ? $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$it ? ($24b824b09891b629$var$se(o, t), $24b824b09891b629$var$Le(e, 'set', '$slots')) : n && a === 1 ? i = !1 : ($24b824b09891b629$var$se(o, t), !n && a === 1 && delete o._) : (i = !t.$stable, $24b824b09891b629$var$as(t, o)), s = t;
    } else t && ($24b824b09891b629$var$ls(e, t), s = {
        default: 1
    });
    if (i) for(const a in o)!$24b824b09891b629$var$ss(a) && s[a] == null && delete o[a];
};
function $24b824b09891b629$var$Sr(e, t, n, r, o = !1) {
    if ($24b824b09891b629$var$M(e)) {
        e.forEach((m, N)=>$24b824b09891b629$var$Sr(m, t && ($24b824b09891b629$var$M(t) ? t[N] : t), n, r, o));
        return;
    }
    if ($24b824b09891b629$var$rn(r) && !o) return;
    const i = r.shapeFlag & 4 ? $24b824b09891b629$var$er(r.component) || r.component.proxy : r.el, s = o ? null : i, { i: a, r: u } = e;
    if ($24b824b09891b629$var$p.NODE_ENV !== 'production' && !a) {
        $24b824b09891b629$var$w('Missing ref owner context. ref cannot be used on hoisted vnodes. A vnode with ref must be created inside the render function.');
        return;
    }
    const d1 = t && t.r, h = a.refs === $24b824b09891b629$var$Z ? a.refs = {} : a.refs, c = a.setupState;
    if (d1 != null && d1 !== u && ($24b824b09891b629$var$re(d1) ? (h[d1] = null, $24b824b09891b629$var$H(c, d1) && (c[d1] = null)) : $24b824b09891b629$var$ge(d1) && (d1.value = null)), $24b824b09891b629$var$S(u)) $24b824b09891b629$var$qe(u, a, 12, [
        s,
        h
    ]);
    else {
        const m = $24b824b09891b629$var$re(u), N = $24b824b09891b629$var$ge(u), T = e.f;
        if (m || N) {
            const P = ()=>{
                if (T) {
                    const L = m ? $24b824b09891b629$var$H(c, u) ? c[u] : h[u] : u.value;
                    o ? $24b824b09891b629$var$M(L) && $24b824b09891b629$var$Wr(L, i) : $24b824b09891b629$var$M(L) ? L.includes(i) || L.push(i) : m ? (h[u] = [
                        i
                    ], $24b824b09891b629$var$H(c, u) && (c[u] = h[u])) : (u.value = [
                        i
                    ], e.k && (h[e.k] = u.value));
                } else m ? (h[u] = s, $24b824b09891b629$var$H(c, u) && (c[u] = s)) : N ? (u.value = s, e.k && (h[e.k] = s)) : $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w('Invalid template ref type:', u, `(${typeof u})`);
            };
            o || T ? P() : (P.id = -1, $24b824b09891b629$var$Ne(P, n));
        } else $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w('Invalid template ref type:', u, `(${typeof u})`);
    }
}
let $24b824b09891b629$var$Jt, $24b824b09891b629$var$rt;
function $24b824b09891b629$var$Ge(e, t) {
    e.appContext.config.performance && $24b824b09891b629$var$Wn() && $24b824b09891b629$var$rt.mark(`vue-${t}-${e.uid}`), $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Fa(e, t, $24b824b09891b629$var$Wn() ? $24b824b09891b629$var$rt.now() : Date.now());
}
function $24b824b09891b629$var$Be(e, t) {
    if (e.appContext.config.performance && $24b824b09891b629$var$Wn()) {
        const n = `vue-${t}-${e.uid}`, r = n + ':end';
        $24b824b09891b629$var$rt.mark(r), $24b824b09891b629$var$rt.measure(`<${$24b824b09891b629$var$tr(e, e.type)}> ${t}`, n, r), $24b824b09891b629$var$rt.clearMarks(n), $24b824b09891b629$var$rt.clearMarks(r);
    }
    $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Ra(e, t, $24b824b09891b629$var$Wn() ? $24b824b09891b629$var$rt.now() : Date.now());
}
function $24b824b09891b629$var$Wn() {
    return $24b824b09891b629$var$Jt !== void 0 || (typeof window < 'u' && window.performance ? ($24b824b09891b629$var$Jt = !0, $24b824b09891b629$var$rt = window.performance) : $24b824b09891b629$var$Jt = !1), $24b824b09891b629$var$Jt;
}
function $24b824b09891b629$var$Rl() {
    const e = [];
    if ($24b824b09891b629$var$p.NODE_ENV !== 'production' && e.length) {
        const t = e.length > 1;
        console.warn(`Feature flag${t ? 's' : ''} ${e.join(', ')} ${t ? 'are' : 'is'} not explicitly defined. You are running the esm-bundler build of Vue, which expects these compile-time feature flags to be globally injected via the bundler config in order to get better tree-shaking in the production bundle.

For more details, see https://link.vuejs.org/feature-flags.`);
    }
}
const $24b824b09891b629$var$Ne = $24b824b09891b629$var$Xa;
function $24b824b09891b629$var$Wl(e) {
    return $24b824b09891b629$var$Ll(e);
}
function $24b824b09891b629$var$Ll(e, t) {
    $24b824b09891b629$var$Rl();
    const n = $24b824b09891b629$var$Hr();
    n.__VUE__ = !0, $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Li(n.__VUE_DEVTOOLS_GLOBAL_HOOK__, n);
    const { insert: r, remove: o, patchProp: i, createElement: s, createText: a, createComment: u, setText: d1, setElementText: h, parentNode: c, nextSibling: m, setScopeId: N = $24b824b09891b629$var$ae, insertStaticContent: T } = e, P = (l, f, g, v = null, _ = null, E = null, D, b = null, O = $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$it ? !1 : !!f.dynamicChildren)=>{
        if (l === f) return;
        l && !$24b824b09891b629$var$Qt(l, f) && (v = vn(l), ze(l, _, E, !0), l = null), f.patchFlag === -2 && (O = !1, f.dynamicChildren = null);
        const { type: y, ref: $, shapeFlag: V } = f;
        switch(y){
            case $24b824b09891b629$var$hn:
                L(l, f, g, v);
                break;
            case $24b824b09891b629$var$De:
                X(l, f, g, v);
                break;
            case $24b824b09891b629$var$Vn:
                l == null ? j(f, g, v, D) : $24b824b09891b629$var$p.NODE_ENV !== 'production' && A(l, f, g, D);
                break;
            case $24b824b09891b629$var$Oe:
                Vt(l, f, g, v, _, E, D, b, O);
                break;
            default:
                V & 1 ? Y(l, f, g, v, _, E, D, b, O) : V & 6 ? gn(l, f, g, v, _, E, D, b, O) : V & 64 || V & 128 ? y.process(l, f, g, v, _, E, D, b, O, Pt) : $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w('Invalid VNode type:', y, `(${typeof y})`);
        }
        $ != null && _ && $24b824b09891b629$var$Sr($, l && l.ref, E, f || l, !f);
    }, L = (l, f, g, v)=>{
        if (l == null) r(f.el = a(f.children), g, v);
        else {
            const _ = f.el = l.el;
            f.children !== l.children && d1(_, f.children);
        }
    }, X = (l, f, g, v)=>{
        l == null ? r(f.el = u(f.children || ''), g, v) : f.el = l.el;
    }, j = (l, f, g, v)=>{
        [l.el, l.anchor] = T(l.children, f, g, v, l.el, l.anchor);
    }, A = (l, f, g, v)=>{
        if (f.children !== l.children) {
            const _ = m(l.anchor);
            B(l), [f.el, f.anchor] = T(f.children, g, _, v);
        } else f.el = l.el, f.anchor = l.anchor;
    }, F = ({ el: l, anchor: f }, g, v)=>{
        let _;
        for(; l && l !== f;)_ = m(l), r(l, g, v), l = _;
        r(f, g, v);
    }, B = ({ el: l, anchor: f })=>{
        let g;
        for(; l && l !== f;)g = m(l), o(l), l = g;
        o(f);
    }, Y = (l, f, g, v, _, E, D, b, O)=>{
        f.type === 'svg' ? D = 'svg' : f.type === 'math' && (D = 'mathml'), l == null ? C(f, g, v, _, E, D, b, O) : ue(l, f, _, E, D, b, O);
    }, C = (l, f, g, v, _, E, D, b)=>{
        let O, y;
        const { props: $, shapeFlag: V, transition: x, dirs: k } = l;
        if (O = l.el = s(l.type, E, $ && $.is, $), V & 8 ? h(O, l.children) : V & 16 && Q(l.children, O, null, v, _, $24b824b09891b629$var$hr(l, E), D, b), k && $24b824b09891b629$var$pt(l, null, v, 'created'), K(O, l, l.scopeId, D, v), $) {
            for(const z in $)z !== 'value' && !$24b824b09891b629$var$Dn(z) && i(O, z, null, $[z], E, l.children, v, _, He);
            'value' in $ && i(O, 'value', null, $.value, E), (y = $.onVnodeBeforeMount) && $24b824b09891b629$var$Ie(y, v, l);
        }
        $24b824b09891b629$var$p.NODE_ENV !== 'production' && (Object.defineProperty(O, '__vnode', {
            value: l,
            enumerable: !1
        }), Object.defineProperty(O, '__vueParentComponent', {
            value: v,
            enumerable: !1
        })), k && $24b824b09891b629$var$pt(l, null, v, 'beforeMount');
        const G = $24b824b09891b629$var$Ul(_, x);
        G && x.beforeEnter(O), r(O, f, g), ((y = $ && $.onVnodeMounted) || G || k) && $24b824b09891b629$var$Ne(()=>{
            y && $24b824b09891b629$var$Ie(y, v, l), G && x.enter(O), k && $24b824b09891b629$var$pt(l, null, v, 'mounted');
        }, _);
    }, K = (l, f, g, v, _)=>{
        if (g && N(l, g), v) for(let E = 0; E < v.length; E++)N(l, v[E]);
        if (_) {
            let E = _.subTree;
            if ($24b824b09891b629$var$p.NODE_ENV !== 'production' && E.patchFlag > 0 && E.patchFlag & 2048 && (E = $24b824b09891b629$var$eo(E.children) || E), f === E) {
                const D = _.vnode;
                K(l, D, D.scopeId, D.slotScopeIds, _.parent);
            }
        }
    }, Q = (l, f, g, v, _, E, D, b, O = 0)=>{
        for(let y = O; y < l.length; y++){
            const $ = l[y] = b ? $24b824b09891b629$var$tt(l[y]) : $24b824b09891b629$var$Ve(l[y]);
            P(null, $, f, g, v, _, E, D, b);
        }
    }, ue = (l, f, g, v, _, E, D)=>{
        const b = f.el = l.el;
        let { patchFlag: O, dynamicChildren: y, dirs: $ } = f;
        O |= l.patchFlag & 16;
        const V = l.props || $24b824b09891b629$var$Z, x = f.props || $24b824b09891b629$var$Z;
        let k;
        if (g && $24b824b09891b629$var$ht(g, !1), (k = x.onVnodeBeforeUpdate) && $24b824b09891b629$var$Ie(k, g, f, l), $ && $24b824b09891b629$var$pt(f, l, g, 'beforeUpdate'), g && $24b824b09891b629$var$ht(g, !0), $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$it && (O = 0, D = !1, y = null), y ? (ye(l.dynamicChildren, y, b, g, v, $24b824b09891b629$var$hr(f, _), E), $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$on(l, f)) : D || Se(l, f, b, null, g, v, $24b824b09891b629$var$hr(f, _), E, !1), O > 0) {
            if (O & 16) Ce(b, f, V, x, g, v, _);
            else if (O & 2 && V.class !== x.class && i(b, 'class', null, x.class, _), O & 4 && i(b, 'style', V.style, x.style, _), O & 8) {
                const G = f.dynamicProps;
                for(let z = 0; z < G.length; z++){
                    const ne = G[z], ce = V[ne], Te = x[ne];
                    (Te !== ce || ne === 'value') && i(b, ne, ce, Te, _, l.children, g, v, He);
                }
            }
            O & 1 && l.children !== f.children && h(b, f.children);
        } else !D && y == null && Ce(b, f, V, x, g, v, _);
        ((k = x.onVnodeUpdated) || $) && $24b824b09891b629$var$Ne(()=>{
            k && $24b824b09891b629$var$Ie(k, g, f, l), $ && $24b824b09891b629$var$pt(f, l, g, 'updated');
        }, v);
    }, ye = (l, f, g, v, _, E, D)=>{
        for(let b = 0; b < f.length; b++){
            const O = l[b], y = f[b], $ = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            O.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (O.type === $24b824b09891b629$var$Oe || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$24b824b09891b629$var$Qt(O, y) || // - In the case of a component, it could contain anything.
            O.shapeFlag & 70) ? c(O.el) : // just pass the block element here to avoid a DOM parentNode call.
            g;
            P(O, y, $, null, v, _, E, D, !0);
        }
    }, Ce = (l, f, g, v, _, E, D)=>{
        if (g !== v) {
            if (g !== $24b824b09891b629$var$Z) for(const b in g)!$24b824b09891b629$var$Dn(b) && !(b in v) && i(l, b, g[b], null, D, f.children, _, E, He);
            for(const b in v){
                if ($24b824b09891b629$var$Dn(b)) continue;
                const O = v[b], y = g[b];
                O !== y && b !== 'value' && i(l, b, y, O, D, f.children, _, E, He);
            }
            'value' in v && i(l, 'value', g.value, v.value, D);
        }
    }, Vt = (l, f, g, v, _, E, D, b, O)=>{
        const y = f.el = l ? l.el : a(''), $ = f.anchor = l ? l.anchor : a('');
        let { patchFlag: V, dynamicChildren: x, slotScopeIds: k } = f;
        $24b824b09891b629$var$p.NODE_ENV !== 'production' && // #5523 dev root fragment may inherit directives
        ($24b824b09891b629$var$it || V & 2048) && (V = 0, O = !1, x = null), k && (b = b ? b.concat(k) : k), l == null ? (r(y, g, v), r($, g, v), Q(// #10007
        // such fragment like `<></>` will be compiled into
        // a fragment which doesn't have a children.
        // In this case fallback to an empty array
        f.children || [], g, $, _, E, D, b, O)) : V > 0 && V & 64 && x && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        l.dynamicChildren ? (ye(l.dynamicChildren, x, g, _, E, D, b), $24b824b09891b629$var$p.NODE_ENV !== 'production' ? $24b824b09891b629$var$on(l, f) : //  get moved around. Make sure all root level vnodes inherit el.
        // #2134 or if it's a component root, it may also get moved around
        // as the component is being moved.
        (f.key != null || _ && f === _.subTree) && $24b824b09891b629$var$on(l, f, !0)) : Se(l, f, g, $, _, E, D, b, O);
    }, gn = (l, f, g, v, _, E, D, b, O)=>{
        f.slotScopeIds = b, l == null ? f.shapeFlag & 512 ? _.ctx.activate(f, g, v, D, O) : ie(f, g, v, _, E, D, O) : oe(l, f, O);
    }, ie = (l, f, g, v, _, E, D)=>{
        const b = l.component = $24b824b09891b629$var$Zl(l, v, _);
        if ($24b824b09891b629$var$p.NODE_ENV !== 'production' && b.type.__hmrId && $24b824b09891b629$var$Ta(b), $24b824b09891b629$var$p.NODE_ENV !== 'production' && ($24b824b09891b629$var$Cn(l), $24b824b09891b629$var$Ge(b, 'mount')), $24b824b09891b629$var$to(l) && (b.ctx.renderer = Pt), $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Ge(b, 'init'), $24b824b09891b629$var$tu(b), $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Be(b, 'init'), b.asyncDep) {
            if (_ && _.registerDep(b, W), !l.el) {
                const O = b.subTree = $24b824b09891b629$var$pe($24b824b09891b629$var$De);
                X(null, O, f, g);
            }
        } else W(b, l, f, g, _, E, D);
        $24b824b09891b629$var$p.NODE_ENV !== 'production' && ($24b824b09891b629$var$Tn(), $24b824b09891b629$var$Be(b, 'mount'));
    }, oe = (l, f, g)=>{
        const v = f.component = l.component;
        if ($24b824b09891b629$var$Ha(l, f, g)) {
            if (v.asyncDep && !v.asyncResolved) {
                $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Cn(f), q(v, f, g), $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Tn();
                return;
            } else v.next = f, $24b824b09891b629$var$$a(v.update), v.effect.dirty = !0, v.update();
        } else f.el = l.el, v.vnode = f;
    }, W = (l, f, g, v, _, E, D)=>{
        const b = ()=>{
            if (l.isMounted) {
                let { next: $, bu: V, u: x, parent: k, vnode: G } = l;
                {
                    const St = $24b824b09891b629$var$us(l);
                    if (St) {
                        $ && ($.el = G.el, q(l, $, D)), St.asyncDep.then(()=>{
                            l.isUnmounted || b();
                        });
                        return;
                    }
                }
                let z = $, ne;
                $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Cn($ || l.vnode), $24b824b09891b629$var$ht(l, !1), $ ? ($.el = G.el, q(l, $, D)) : $ = G, V && $24b824b09891b629$var$Xt(V), (ne = $.props && $.props.onVnodeBeforeUpdate) && $24b824b09891b629$var$Ie(ne, k, $, G), $24b824b09891b629$var$ht(l, !0), $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Ge(l, 'render');
                const ce = $24b824b09891b629$var$fr(l);
                $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Be(l, 'render');
                const Te = l.subTree;
                l.subTree = ce, $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Ge(l, 'patch'), P(Te, ce, // parent may have changed if it's in a teleport
                c(Te.el), // anchor may have changed if it's in a fragment
                vn(Te), l, _, E), $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Be(l, 'patch'), $.el = ce.el, z === null && $24b824b09891b629$var$Ga(l, ce.el), x && $24b824b09891b629$var$Ne(x, _), (ne = $.props && $.props.onVnodeUpdated) && $24b824b09891b629$var$Ne(()=>$24b824b09891b629$var$Ie(ne, k, $, G), _), $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Ui(l), $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Tn();
            } else {
                let $;
                const { el: V, props: x } = f, { bm: k, m: G, parent: z } = l, ne = $24b824b09891b629$var$rn(f);
                if ($24b824b09891b629$var$ht(l, !1), k && $24b824b09891b629$var$Xt(k), !ne && ($ = x && x.onVnodeBeforeMount) && $24b824b09891b629$var$Ie($, z, f), $24b824b09891b629$var$ht(l, !0), V && lr) {
                    const ce = ()=>{
                        $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Ge(l, 'render'), l.subTree = $24b824b09891b629$var$fr(l), $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Be(l, 'render'), $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Ge(l, 'hydrate'), lr(V, l.subTree, l, _, null), $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Be(l, 'hydrate');
                    };
                    ne ? f.type.__asyncLoader().then(// note: we are moving the render call into an async callback,
                    // which means it won't track dependencies - but it's ok because
                    // a server-rendered async wrapper is already in resolved state
                    // and it will never need to change.
                    ()=>!l.isUnmounted && ce()) : ce();
                } else {
                    $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Ge(l, 'render');
                    const ce = l.subTree = $24b824b09891b629$var$fr(l);
                    $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Be(l, 'render'), $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Ge(l, 'patch'), P(null, ce, g, v, l, _, E), $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Be(l, 'patch'), f.el = ce.el;
                }
                if (G && $24b824b09891b629$var$Ne(G, _), !ne && ($ = x && x.onVnodeMounted)) {
                    const ce = f;
                    $24b824b09891b629$var$Ne(()=>$24b824b09891b629$var$Ie($, z, ce), _);
                }
                (f.shapeFlag & 256 || z && $24b824b09891b629$var$rn(z.vnode) && z.vnode.shapeFlag & 256) && l.a && $24b824b09891b629$var$Ne(l.a, _), l.isMounted = !0, $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$ka(l), f = g = v = null;
            }
        }, O = l.effect = new $24b824b09891b629$var$Br(b, $24b824b09891b629$var$ae, ()=>$24b824b09891b629$var$Kn(y), l.scope), y = l.update = ()=>{
            O.dirty && O.run();
        };
        y.id = l.uid, $24b824b09891b629$var$ht(l, !0), $24b824b09891b629$var$p.NODE_ENV !== 'production' && (O.onTrack = l.rtc ? ($)=>$24b824b09891b629$var$Xt(l.rtc, $) : void 0, O.onTrigger = l.rtg ? ($)=>$24b824b09891b629$var$Xt(l.rtg, $) : void 0, y.ownerInstance = l), y();
    }, q = (l, f, g)=>{
        f.component = l;
        const v = l.vnode.props;
        l.vnode = f, l.next = null, $24b824b09891b629$var$xl(l, f.props, v, g), $24b824b09891b629$var$Fl(l, f.children, g), $24b824b09891b629$var$ft(), $24b824b09891b629$var$wo(l), $24b824b09891b629$var$dt();
    }, Se = (l, f, g, v, _, E, D, b, O = !1)=>{
        const y = l && l.children, $ = l ? l.shapeFlag : 0, V = f.children, { patchFlag: x, shapeFlag: k } = f;
        if (x > 0) {
            if (x & 128) {
                qt(y, V, g, v, _, E, D, b, O);
                return;
            } else if (x & 256) {
                or(y, V, g, v, _, E, D, b, O);
                return;
            }
        }
        k & 8 ? ($ & 16 && He(y, _, E), V !== y && h(g, V)) : $ & 16 ? k & 16 ? qt(y, V, g, v, _, E, D, b, O) : He(y, _, E, !0) : ($ & 8 && h(g, ''), k & 16 && Q(V, g, v, _, E, D, b, O));
    }, or = (l, f, g, v, _, E, D, b, O)=>{
        l = l || $24b824b09891b629$var$Rt, f = f || $24b824b09891b629$var$Rt;
        const y = l.length, $ = f.length, V = Math.min(y, $);
        let x;
        for(x = 0; x < V; x++){
            const k = f[x] = O ? $24b824b09891b629$var$tt(f[x]) : $24b824b09891b629$var$Ve(f[x]);
            P(l[x], k, g, null, _, E, D, b, O);
        }
        y > $ ? He(l, _, E, !0, !1, V) : Q(f, g, v, _, E, D, b, O, V);
    }, qt = (l, f, g, v, _, E, D, b, O)=>{
        let y = 0;
        const $ = f.length;
        let V = l.length - 1, x = $ - 1;
        for(; y <= V && y <= x;){
            const k = l[y], G = f[y] = O ? $24b824b09891b629$var$tt(f[y]) : $24b824b09891b629$var$Ve(f[y]);
            if ($24b824b09891b629$var$Qt(k, G)) P(k, G, g, null, _, E, D, b, O);
            else break;
            y++;
        }
        for(; y <= V && y <= x;){
            const k = l[V], G = f[x] = O ? $24b824b09891b629$var$tt(f[x]) : $24b824b09891b629$var$Ve(f[x]);
            if ($24b824b09891b629$var$Qt(k, G)) P(k, G, g, null, _, E, D, b, O);
            else break;
            V--, x--;
        }
        if (y > V) {
            if (y <= x) {
                const k = x + 1, G = k < $ ? f[k].el : v;
                for(; y <= x;)P(null, f[y] = O ? $24b824b09891b629$var$tt(f[y]) : $24b824b09891b629$var$Ve(f[y]), g, G, _, E, D, b, O), y++;
            }
        } else if (y > x) for(; y <= V;)ze(l[y], _, E, !0), y++;
        else {
            const k = y, G = y, z = /* @__PURE__ */ new Map();
            for(y = G; y <= x; y++){
                const be = f[y] = O ? $24b824b09891b629$var$tt(f[y]) : $24b824b09891b629$var$Ve(f[y]);
                be.key != null && ($24b824b09891b629$var$p.NODE_ENV !== 'production' && z.has(be.key) && $24b824b09891b629$var$w('Duplicate keys found during update:', JSON.stringify(be.key), 'Make sure keys are unique.'), z.set(be.key, y));
            }
            let ne, ce = 0;
            const Te = x - G + 1;
            let St = !1, uo = 0;
            const Kt = new Array(Te);
            for(y = 0; y < Te; y++)Kt[y] = 0;
            for(y = k; y <= V; y++){
                const be = l[y];
                if (ce >= Te) {
                    ze(be, _, E, !0);
                    continue;
                }
                let ke;
                if (be.key != null) ke = z.get(be.key);
                else for(ne = G; ne <= x; ne++)if (Kt[ne - G] === 0 && $24b824b09891b629$var$Qt(be, f[ne])) {
                    ke = ne;
                    break;
                }
                ke === void 0 ? ze(be, _, E, !0) : (Kt[ke - G] = y + 1, ke >= uo ? uo = ke : St = !0, P(be, f[ke], g, null, _, E, D, b, O), ce++);
            }
            const co = St ? $24b824b09891b629$var$jl(Kt) : $24b824b09891b629$var$Rt;
            for(ne = co.length - 1, y = Te - 1; y >= 0; y--){
                const be = G + y, ke = f[be], fo = be + 1 < $ ? f[be + 1].el : v;
                Kt[y] === 0 ? P(null, ke, g, fo, _, E, D, b, O) : St && (ne < 0 || y !== co[ne] ? Mt(ke, g, fo, 2) : ne--);
            }
        }
    }, Mt = (l, f, g, v, _ = null)=>{
        const { el: E, type: D, transition: b, children: O, shapeFlag: y } = l;
        if (y & 6) {
            Mt(l.component.subTree, f, g, v);
            return;
        }
        if (y & 128) {
            l.suspense.move(f, g, v);
            return;
        }
        if (y & 64) {
            D.move(l, f, g, Pt);
            return;
        }
        if (D === $24b824b09891b629$var$Oe) {
            r(E, f, g);
            for(let V = 0; V < O.length; V++)Mt(O[V], f, g, v);
            r(l.anchor, f, g);
            return;
        }
        if (D === $24b824b09891b629$var$Vn) {
            F(l, f, g);
            return;
        }
        if (v !== 2 && y & 1 && b) {
            if (v === 0) b.beforeEnter(E), r(E, f, g), $24b824b09891b629$var$Ne(()=>b.enter(E), _);
            else {
                const { leave: V, delayLeave: x, afterLeave: k } = b, G = ()=>r(E, f, g), z = ()=>{
                    V(E, ()=>{
                        G(), k && k();
                    });
                };
                x ? x(E, G, z) : z();
            }
        } else r(E, f, g);
    }, ze = (l, f, g, v = !1, _ = !1)=>{
        const { type: E, props: D, ref: b, children: O, dynamicChildren: y, shapeFlag: $, patchFlag: V, dirs: x } = l;
        if (b != null && $24b824b09891b629$var$Sr(b, null, g, l, !0), $ & 256) {
            f.ctx.deactivate(l);
            return;
        }
        const k = $ & 1 && x, G = !$24b824b09891b629$var$rn(l);
        let z;
        if (G && (z = D && D.onVnodeBeforeUnmount) && $24b824b09891b629$var$Ie(z, f, l), $ & 6) Cs(l.component, g, v);
        else {
            if ($ & 128) {
                l.suspense.unmount(g, v);
                return;
            }
            k && $24b824b09891b629$var$pt(l, null, f, 'beforeUnmount'), $ & 64 ? l.type.remove(l, f, g, _, Pt, v) : y && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (E !== $24b824b09891b629$var$Oe || V > 0 && V & 64) ? He(y, f, g, !1, !0) : (E === $24b824b09891b629$var$Oe && V & 384 || !_ && $ & 16) && He(O, f, g), v && ir(l);
        }
        (G && (z = D && D.onVnodeUnmounted) || k) && $24b824b09891b629$var$Ne(()=>{
            z && $24b824b09891b629$var$Ie(z, f, l), k && $24b824b09891b629$var$pt(l, null, f, 'unmounted');
        }, g);
    }, ir = (l)=>{
        const { type: f, el: g, anchor: v, transition: _ } = l;
        if (f === $24b824b09891b629$var$Oe) {
            $24b824b09891b629$var$p.NODE_ENV !== 'production' && l.patchFlag > 0 && l.patchFlag & 2048 && _ && !_.persisted ? l.children.forEach((D)=>{
                D.type === $24b824b09891b629$var$De ? o(D.el) : ir(D);
            }) : $s(g, v);
            return;
        }
        if (f === $24b824b09891b629$var$Vn) {
            B(l);
            return;
        }
        const E = ()=>{
            o(g), _ && !_.persisted && _.afterLeave && _.afterLeave();
        };
        if (l.shapeFlag & 1 && _ && !_.persisted) {
            const { leave: D, delayLeave: b } = _, O = ()=>D(g, E);
            b ? b(l.el, E, O) : O();
        } else E();
    }, $s = (l, f)=>{
        let g;
        for(; l !== f;)g = m(l), o(l), l = g;
        o(f);
    }, Cs = (l, f, g)=>{
        $24b824b09891b629$var$p.NODE_ENV !== 'production' && l.type.__hmrId && $24b824b09891b629$var$xa(l);
        const { bum: v, scope: _, update: E, subTree: D, um: b } = l;
        v && $24b824b09891b629$var$Xt(v), _.stop(), E && (E.active = !1, ze(D, l, f, g)), b && $24b824b09891b629$var$Ne(b, f), $24b824b09891b629$var$Ne(()=>{
            l.isUnmounted = !0;
        }, f), f && f.pendingBranch && !f.isUnmounted && l.asyncDep && !l.asyncResolved && l.suspenseId === f.pendingId && (f.deps--, f.deps === 0 && f.resolve()), $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Aa(l);
    }, He = (l, f, g, v = !1, _ = !1, E = 0)=>{
        for(let D = E; D < l.length; D++)ze(l[D], f, g, v, _);
    }, vn = (l)=>l.shapeFlag & 6 ? vn(l.component.subTree) : l.shapeFlag & 128 ? l.suspense.next() : m(l.anchor || l.el);
    let sr = !1;
    const lo = (l, f, g)=>{
        l == null ? f._vnode && ze(f._vnode, null, null, !0) : P(f._vnode || null, l, f, null, null, null, g), sr || (sr = !0, $24b824b09891b629$var$wo(), $24b824b09891b629$var$Fi(), sr = !1), f._vnode = l;
    }, Pt = {
        p: P,
        um: ze,
        m: Mt,
        r: ir,
        mt: ie,
        mc: Q,
        pc: Se,
        pbc: ye,
        n: vn,
        o: e
    };
    let ar, lr;
    return t && ([ar, lr] = t(Pt)), {
        render: lo,
        hydrate: ar,
        createApp: $24b824b09891b629$var$Dl(lo, ar)
    };
}
function $24b824b09891b629$var$hr({ type: e, props: t }, n) {
    return n === 'svg' && e === 'foreignObject' || n === 'mathml' && e === 'annotation-xml' && t && t.encoding && t.encoding.includes('html') ? void 0 : n;
}
function $24b824b09891b629$var$ht({ effect: e, update: t }, n) {
    e.allowRecurse = t.allowRecurse = n;
}
function $24b824b09891b629$var$Ul(e, t) {
    return (!e || e && !e.pendingBranch) && t && !t.persisted;
}
function $24b824b09891b629$var$on(e, t, n = !1) {
    const r = e.children, o = t.children;
    if ($24b824b09891b629$var$M(r) && $24b824b09891b629$var$M(o)) for(let i = 0; i < r.length; i++){
        const s = r[i];
        let a = o[i];
        a.shapeFlag & 1 && !a.dynamicChildren && ((a.patchFlag <= 0 || a.patchFlag === 32) && (a = o[i] = $24b824b09891b629$var$tt(o[i]), a.el = s.el), n || $24b824b09891b629$var$on(s, a)), a.type === $24b824b09891b629$var$hn && (a.el = s.el), $24b824b09891b629$var$p.NODE_ENV !== 'production' && a.type === $24b824b09891b629$var$De && !a.el && (a.el = s.el);
    }
}
function $24b824b09891b629$var$jl(e) {
    const t = e.slice(), n = [
        0
    ];
    let r, o, i, s, a;
    const u = e.length;
    for(r = 0; r < u; r++){
        const d1 = e[r];
        if (d1 !== 0) {
            if (o = n[n.length - 1], e[o] < d1) {
                t[r] = o, n.push(r);
                continue;
            }
            for(i = 0, s = n.length - 1; i < s;)a = i + s >> 1, e[n[a]] < d1 ? i = a + 1 : s = a;
            d1 < e[n[i]] && (i > 0 && (t[r] = n[i - 1]), n[i] = r);
        }
    }
    for(i = n.length, s = n[i - 1]; i-- > 0;)n[i] = s, s = t[s];
    return n;
}
function $24b824b09891b629$var$us(e) {
    const t = e.subTree.component;
    if (t) return t.asyncDep && !t.asyncResolved ? t : $24b824b09891b629$var$us(t);
}
const $24b824b09891b629$var$Hl = (e)=>e.__isTeleport, $24b824b09891b629$var$Lt = (e)=>e && (e.disabled || e.disabled === ''), $24b824b09891b629$var$Io = (e)=>typeof SVGElement < 'u' && e instanceof SVGElement, $24b824b09891b629$var$Ao = (e)=>typeof MathMLElement == 'function' && e instanceof MathMLElement, $24b824b09891b629$var$kr = (e, t)=>{
    const n = e && e.to;
    if ($24b824b09891b629$var$re(n)) {
        if (t) {
            const r = t(n);
            return r || $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w(`Failed to locate Teleport target with selector "${n}". Note the target element must exist before the component is mounted - i.e. the target cannot be rendered by the component itself, and ideally should be outside of the entire Vue component tree.`), r;
        } else return $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w('Current renderer does not support string target for Teleports. (missing querySelector renderer option)'), null;
    } else return $24b824b09891b629$var$p.NODE_ENV !== 'production' && !n && !$24b824b09891b629$var$Lt(e) && $24b824b09891b629$var$w(`Invalid Teleport target: ${n}`), n;
}, $24b824b09891b629$var$Gl = {
    name: 'Teleport',
    __isTeleport: !0,
    process (e, t, n, r, o, i, s, a, u, d1) {
        const { mc: h, pc: c, pbc: m, o: { insert: N, querySelector: T, createText: P, createComment: L } } = d1, X = $24b824b09891b629$var$Lt(t.props);
        let { shapeFlag: j, children: A, dynamicChildren: F } = t;
        if ($24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$it && (u = !1, F = null), e == null) {
            const B = t.el = $24b824b09891b629$var$p.NODE_ENV !== 'production' ? L('teleport start') : P(''), Y = t.anchor = $24b824b09891b629$var$p.NODE_ENV !== 'production' ? L('teleport end') : P('');
            N(B, n, r), N(Y, n, r);
            const C = t.target = $24b824b09891b629$var$kr(t.props, T), K = t.targetAnchor = P('');
            C ? (N(K, C), s === 'svg' || $24b824b09891b629$var$Io(C) ? s = 'svg' : (s === 'mathml' || $24b824b09891b629$var$Ao(C)) && (s = 'mathml')) : $24b824b09891b629$var$p.NODE_ENV !== 'production' && !X && $24b824b09891b629$var$w('Invalid Teleport target on mount:', C, `(${typeof C})`);
            const Q = (ue, ye)=>{
                j & 16 && h(A, ue, ye, o, i, s, a, u);
            };
            X ? Q(n, Y) : C && Q(C, K);
        } else {
            t.el = e.el;
            const B = t.anchor = e.anchor, Y = t.target = e.target, C = t.targetAnchor = e.targetAnchor, K = $24b824b09891b629$var$Lt(e.props), Q = K ? n : Y, ue = K ? B : C;
            if (s === 'svg' || $24b824b09891b629$var$Io(Y) ? s = 'svg' : (s === 'mathml' || $24b824b09891b629$var$Ao(Y)) && (s = 'mathml'), F ? (m(e.dynamicChildren, F, Q, o, i, s, a), $24b824b09891b629$var$on(e, t, !0)) : u || c(e, t, Q, ue, o, i, s, a, !1), X) K ? t.props && e.props && t.props.to !== e.props.to && (t.props.to = e.props.to) : $24b824b09891b629$var$On(t, n, B, d1, 1);
            else if ((t.props && t.props.to) !== (e.props && e.props.to)) {
                const ye = t.target = $24b824b09891b629$var$kr(t.props, T);
                ye ? $24b824b09891b629$var$On(t, ye, null, d1, 0) : $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$w('Invalid Teleport target on update:', Y, `(${typeof Y})`);
            } else K && $24b824b09891b629$var$On(t, Y, C, d1, 1);
        }
        $24b824b09891b629$var$cs(t);
    },
    remove (e, t, n, r, { um: o, o: { remove: i } }, s) {
        const { shapeFlag: a, children: u, anchor: d1, targetAnchor: h, target: c, props: m } = e;
        if (c && i(h), s && i(d1), a & 16) {
            const N = s || !$24b824b09891b629$var$Lt(m);
            for(let T = 0; T < u.length; T++){
                const P = u[T];
                o(P, t, n, N, !!P.dynamicChildren);
            }
        }
    },
    move: $24b824b09891b629$var$On,
    hydrate: $24b824b09891b629$var$Bl
};
function $24b824b09891b629$var$On(e, t, n, { o: { insert: r }, m: o }, i = 2) {
    i === 0 && r(e.targetAnchor, t, n);
    const { el: s, anchor: a, shapeFlag: u, children: d1, props: h } = e, c = i === 2;
    if (c && r(s, t, n), (!c || $24b824b09891b629$var$Lt(h)) && u & 16) for(let m = 0; m < d1.length; m++)o(d1[m], t, n, 2);
    c && r(a, t, n);
}
function $24b824b09891b629$var$Bl(e, t, n, r, o, i, { o: { nextSibling: s, parentNode: a, querySelector: u } }, d1) {
    const h = t.target = $24b824b09891b629$var$kr(t.props, u);
    if (h) {
        const c = h._lpa || h.firstChild;
        if (t.shapeFlag & 16) {
            if ($24b824b09891b629$var$Lt(t.props)) t.anchor = d1(s(e), t, a(e), n, r, o, i), t.targetAnchor = c;
            else {
                t.anchor = s(e);
                let m = c;
                for(; m;)if (m = s(m), m && m.nodeType === 8 && m.data === 'teleport anchor') {
                    t.targetAnchor = m, h._lpa = t.targetAnchor && s(t.targetAnchor);
                    break;
                }
                d1(c, t, h, n, r, o, i);
            }
        }
        $24b824b09891b629$var$cs(t);
    }
    return t.anchor && s(t.anchor);
}
const $24b824b09891b629$var$Yl = $24b824b09891b629$var$Gl;
function $24b824b09891b629$var$cs(e) {
    const t = e.ctx;
    if (t && t.ut) {
        let n = e.children[0].el;
        for(; n && n !== e.targetAnchor;)n.nodeType === 1 && n.setAttribute('data-v-owner', t.uid), n = n.nextSibling;
        t.ut();
    }
}
const $24b824b09891b629$var$Oe = Symbol.for('v-fgt'), $24b824b09891b629$var$hn = Symbol.for('v-txt'), $24b824b09891b629$var$De = Symbol.for('v-cmt'), $24b824b09891b629$var$Vn = Symbol.for('v-stc'), $24b824b09891b629$var$sn = [];
let $24b824b09891b629$var$Me = null;
function $24b824b09891b629$var$te(e = !1) {
    $24b824b09891b629$var$sn.push($24b824b09891b629$var$Me = e ? null : []);
}
function $24b824b09891b629$var$ql() {
    $24b824b09891b629$var$sn.pop(), $24b824b09891b629$var$Me = $24b824b09891b629$var$sn[$24b824b09891b629$var$sn.length - 1] || null;
}
let $24b824b09891b629$var$cn = 1;
function $24b824b09891b629$var$Fo(e) {
    $24b824b09891b629$var$cn += e;
}
function $24b824b09891b629$var$fs(e) {
    return e.dynamicChildren = $24b824b09891b629$var$cn > 0 ? $24b824b09891b629$var$Me || $24b824b09891b629$var$Rt : null, $24b824b09891b629$var$ql(), $24b824b09891b629$var$cn > 0 && $24b824b09891b629$var$Me && $24b824b09891b629$var$Me.push(e), e;
}
function $24b824b09891b629$var$fe(e, t, n, r, o, i) {
    return $24b824b09891b629$var$fs($24b824b09891b629$var$I(e, t, n, r, o, i, !0));
}
function $24b824b09891b629$var$ut(e, t, n, r, o) {
    return $24b824b09891b629$var$fs($24b824b09891b629$var$pe(e, t, n, r, o, !0));
}
function $24b824b09891b629$var$Jn(e) {
    return e ? e.__v_isVNode === !0 : !1;
}
function $24b824b09891b629$var$Qt(e, t) {
    return $24b824b09891b629$var$p.NODE_ENV !== 'production' && t.shapeFlag & 6 && $24b824b09891b629$var$It.has(t.type) ? (e.shapeFlag &= -257, t.shapeFlag &= -513, !1) : e.type === t.type && e.key === t.key;
}
const $24b824b09891b629$var$Kl = (...e)=>$24b824b09891b629$var$ps(...e), $24b824b09891b629$var$Qn = '__vInternal', $24b824b09891b629$var$ds = ({ key: e })=>e ?? null, $24b824b09891b629$var$Mn = ({ ref: e, ref_key: t, ref_for: n })=>(typeof e == 'number' && (e = '' + e), e != null ? $24b824b09891b629$var$re(e) || $24b824b09891b629$var$ge(e) || $24b824b09891b629$var$S(e) ? {
        i: $24b824b09891b629$var$le,
        r: e,
        k: t,
        f: !!n
    } : e : null);
function $24b824b09891b629$var$I(e, t = null, n = null, r = 0, o = null, i = e === $24b824b09891b629$var$Oe ? 0 : 1, s = !1, a = !1) {
    const u = {
        __v_isVNode: !0,
        __v_skip: !0,
        type: e,
        props: t,
        key: t && $24b824b09891b629$var$ds(t),
        ref: t && $24b824b09891b629$var$Mn(t),
        scopeId: $24b824b09891b629$var$Gi,
        slotScopeIds: null,
        children: n,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: i,
        patchFlag: r,
        dynamicProps: o,
        dynamicChildren: null,
        appContext: null,
        ctx: $24b824b09891b629$var$le
    };
    return a ? ($24b824b09891b629$var$io(u, n), i & 128 && e.normalize(u)) : n && (u.shapeFlag |= $24b824b09891b629$var$re(n) ? 8 : 16), $24b824b09891b629$var$p.NODE_ENV !== 'production' && u.key !== u.key && $24b824b09891b629$var$w('VNode created with invalid key (NaN). VNode type:', u.type), $24b824b09891b629$var$cn > 0 && // avoid a block node from tracking itself
    !s && // has current parent block
    $24b824b09891b629$var$Me && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (u.patchFlag > 0 || i & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    u.patchFlag !== 32 && $24b824b09891b629$var$Me.push(u), u;
}
const $24b824b09891b629$var$pe = $24b824b09891b629$var$p.NODE_ENV !== 'production' ? $24b824b09891b629$var$Kl : $24b824b09891b629$var$ps;
function $24b824b09891b629$var$ps(e, t = null, n = null, r = 0, o = null, i = !1) {
    if ((!e || e === $24b824b09891b629$var$Yi) && ($24b824b09891b629$var$p.NODE_ENV !== 'production' && !e && $24b824b09891b629$var$w(`Invalid vnode type when creating vnode: ${e}.`), e = $24b824b09891b629$var$De), $24b824b09891b629$var$Jn(e)) {
        const a = $24b824b09891b629$var$ct(e, t, !0);
        return n && $24b824b09891b629$var$io(a, n), $24b824b09891b629$var$cn > 0 && !i && $24b824b09891b629$var$Me && (a.shapeFlag & 6 ? $24b824b09891b629$var$Me[$24b824b09891b629$var$Me.indexOf(e)] = a : $24b824b09891b629$var$Me.push(a)), a.patchFlag |= -2, a;
    }
    if ($24b824b09891b629$var$vs(e) && (e = e.__vccOpts), t) {
        t = $24b824b09891b629$var$Xl(t);
        let { class: a, style: u } = t;
        a && !$24b824b09891b629$var$re(a) && (t.class = $24b824b09891b629$var$U(a)), $24b824b09891b629$var$ee(u) && ($24b824b09891b629$var$Nr(u) && !$24b824b09891b629$var$M(u) && (u = $24b824b09891b629$var$se({}, u)), t.style = $24b824b09891b629$var$Gr(u));
    }
    const s = $24b824b09891b629$var$re(e) ? 1 : $24b824b09891b629$var$Ka(e) ? 128 : $24b824b09891b629$var$Hl(e) ? 64 : $24b824b09891b629$var$ee(e) ? 4 : $24b824b09891b629$var$S(e) ? 2 : 0;
    return $24b824b09891b629$var$p.NODE_ENV !== 'production' && s & 4 && $24b824b09891b629$var$Nr(e) && (e = $24b824b09891b629$var$R(e), $24b824b09891b629$var$w('Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.', `
Component that was made reactive: `, e)), $24b824b09891b629$var$I(e, t, n, r, o, s, i, !0);
}
function $24b824b09891b629$var$Xl(e) {
    return e ? $24b824b09891b629$var$Nr(e) || $24b824b09891b629$var$Qn in e ? $24b824b09891b629$var$se({}, e) : e : null;
}
function $24b824b09891b629$var$ct(e, t, n = !1) {
    const { props: r, ref: o, patchFlag: i, children: s } = e, a = t ? $24b824b09891b629$var$zl(r || {}, t) : r;
    return {
        __v_isVNode: !0,
        __v_skip: !0,
        type: e.type,
        props: a,
        key: a && $24b824b09891b629$var$ds(a),
        ref: t && t.ref ? // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        n && o ? $24b824b09891b629$var$M(o) ? o.concat($24b824b09891b629$var$Mn(t)) : [
            o,
            $24b824b09891b629$var$Mn(t)
        ] : $24b824b09891b629$var$Mn(t) : o,
        scopeId: e.scopeId,
        slotScopeIds: e.slotScopeIds,
        children: $24b824b09891b629$var$p.NODE_ENV !== 'production' && i === -1 && $24b824b09891b629$var$M(s) ? s.map($24b824b09891b629$var$hs) : s,
        target: e.target,
        targetAnchor: e.targetAnchor,
        staticCount: e.staticCount,
        shapeFlag: e.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: t && e.type !== $24b824b09891b629$var$Oe ? i === -1 ? 16 : i | 16 : i,
        dynamicProps: e.dynamicProps,
        dynamicChildren: e.dynamicChildren,
        appContext: e.appContext,
        dirs: e.dirs,
        transition: e.transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: e.component,
        suspense: e.suspense,
        ssContent: e.ssContent && $24b824b09891b629$var$ct(e.ssContent),
        ssFallback: e.ssFallback && $24b824b09891b629$var$ct(e.ssFallback),
        el: e.el,
        anchor: e.anchor,
        ctx: e.ctx,
        ce: e.ce
    };
}
function $24b824b09891b629$var$hs(e) {
    const t = $24b824b09891b629$var$ct(e);
    return $24b824b09891b629$var$M(e.children) && (t.children = e.children.map($24b824b09891b629$var$hs)), t;
}
function $24b824b09891b629$var$Ze(e = ' ', t = 0) {
    return $24b824b09891b629$var$pe($24b824b09891b629$var$hn, null, e, t);
}
function $24b824b09891b629$var$_t(e = '', t = !1) {
    return t ? ($24b824b09891b629$var$te(), $24b824b09891b629$var$ut($24b824b09891b629$var$De, null, e)) : $24b824b09891b629$var$pe($24b824b09891b629$var$De, null, e);
}
function $24b824b09891b629$var$Ve(e) {
    return e == null || typeof e == 'boolean' ? $24b824b09891b629$var$pe($24b824b09891b629$var$De) : $24b824b09891b629$var$M(e) ? $24b824b09891b629$var$pe($24b824b09891b629$var$Oe, null, // #3666, avoid reference pollution when reusing vnode
    e.slice()) : typeof e == 'object' ? $24b824b09891b629$var$tt(e) : $24b824b09891b629$var$pe($24b824b09891b629$var$hn, null, String(e));
}
function $24b824b09891b629$var$tt(e) {
    return e.el === null && e.patchFlag !== -1 || e.memo ? e : $24b824b09891b629$var$ct(e);
}
function $24b824b09891b629$var$io(e, t) {
    let n = 0;
    const { shapeFlag: r } = e;
    if (t == null) t = null;
    else if ($24b824b09891b629$var$M(t)) n = 16;
    else if (typeof t == 'object') {
        if (r & 65) {
            const o = t.default;
            o && (o._c && (o._d = !1), $24b824b09891b629$var$io(e, o()), o._c && (o._d = !0));
            return;
        } else {
            n = 32;
            const o = t._;
            !o && !($24b824b09891b629$var$Qn in t) ? t._ctx = $24b824b09891b629$var$le : o === 3 && $24b824b09891b629$var$le && ($24b824b09891b629$var$le.slots._ === 1 ? t._ = 1 : (t._ = 2, e.patchFlag |= 1024));
        }
    } else $24b824b09891b629$var$S(t) ? (t = {
        default: t,
        _ctx: $24b824b09891b629$var$le
    }, n = 32) : (t = String(t), r & 64 ? (n = 16, t = [
        $24b824b09891b629$var$Ze(t)
    ]) : n = 8);
    e.children = t, e.shapeFlag |= n;
}
function $24b824b09891b629$var$zl(...e) {
    const t = {};
    for(let n = 0; n < e.length; n++){
        const r = e[n];
        for(const o in r)if (o === 'class') t.class !== r.class && (t.class = $24b824b09891b629$var$U([
            t.class,
            r.class
        ]));
        else if (o === 'style') t.style = $24b824b09891b629$var$Gr([
            t.style,
            r.style
        ]);
        else if ($24b824b09891b629$var$fn(o)) {
            const i = t[o], s = r[o];
            s && i !== s && !($24b824b09891b629$var$M(i) && i.includes(s)) && (t[o] = i ? [].concat(i, s) : s);
        } else o !== '' && (t[o] = r[o]);
    }
    return t;
}
function $24b824b09891b629$var$Ie(e, t, n, r = null) {
    $24b824b09891b629$var$Pe(e, t, 7, [
        n,
        r
    ]);
}
const $24b824b09891b629$var$Jl = $24b824b09891b629$var$ns();
let $24b824b09891b629$var$Ql = 0;
function $24b824b09891b629$var$Zl(e, t, n) {
    const r = e.type, o = (t ? t.appContext : e.appContext) || $24b824b09891b629$var$Jl, i = {
        uid: $24b824b09891b629$var$Ql++,
        vnode: e,
        type: r,
        parent: t,
        appContext: o,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        scope: new $24b824b09891b629$var$Bs(!0),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: t ? t.provides : Object.create(o.provides),
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $24b824b09891b629$var$os(r, o),
        emitsOptions: $24b824b09891b629$var$Hi(r, o),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: $24b824b09891b629$var$Z,
        // inheritAttrs
        inheritAttrs: r.inheritAttrs,
        // state
        ctx: $24b824b09891b629$var$Z,
        data: $24b824b09891b629$var$Z,
        props: $24b824b09891b629$var$Z,
        attrs: $24b824b09891b629$var$Z,
        slots: $24b824b09891b629$var$Z,
        refs: $24b824b09891b629$var$Z,
        setupState: $24b824b09891b629$var$Z,
        setupContext: null,
        attrsProxy: null,
        slotsProxy: null,
        // suspense related
        suspense: n,
        suspenseId: n ? n.pendingId : 0,
        asyncDep: null,
        asyncResolved: !1,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: !1,
        isUnmounted: !1,
        isDeactivated: !1,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    return $24b824b09891b629$var$p.NODE_ENV !== 'production' ? i.ctx = $24b824b09891b629$var$ml(i) : i.ctx = {
        _: i
    }, i.root = t ? t.root : i, i.emit = $24b824b09891b629$var$La.bind(null, i), e.ce && e.ce(i), i;
}
let $24b824b09891b629$var$de = null, $24b824b09891b629$var$Ln, $24b824b09891b629$var$Ir;
{
    const e = $24b824b09891b629$var$Hr(), t = (n, r)=>{
        let o;
        return (o = e[n]) || (o = e[n] = []), o.push(r), (i)=>{
            o.length > 1 ? o.forEach((s)=>s(i)) : o[0](i);
        };
    };
    $24b824b09891b629$var$Ln = t('__VUE_INSTANCE_SETTERS__', (n)=>$24b824b09891b629$var$de = n), $24b824b09891b629$var$Ir = t('__VUE_SSR_SETTERS__', (n)=>$24b824b09891b629$var$Zn = n);
}const $24b824b09891b629$var$mn = (e)=>{
    const t = $24b824b09891b629$var$de;
    return $24b824b09891b629$var$Ln(e), e.scope.on(), ()=>{
        e.scope.off(), $24b824b09891b629$var$Ln(t);
    };
}, $24b824b09891b629$var$Ro = ()=>{
    $24b824b09891b629$var$de && $24b824b09891b629$var$de.scope.off(), $24b824b09891b629$var$Ln(null);
}, $24b824b09891b629$var$eu = /* @__PURE__ */ $24b824b09891b629$var$Ke('slot,component');
function $24b824b09891b629$var$Ar(e, t) {
    const n = t.isNativeTag || $24b824b09891b629$var$ii;
    ($24b824b09891b629$var$eu(e) || n(e)) && $24b824b09891b629$var$w('Do not use built-in or reserved HTML elements as component id: ' + e);
}
function $24b824b09891b629$var$ms(e) {
    return e.vnode.shapeFlag & 4;
}
let $24b824b09891b629$var$Zn = !1;
function $24b824b09891b629$var$tu(e, t = !1) {
    t && $24b824b09891b629$var$Ir(t);
    const { props: n, children: r } = e.vnode, o = $24b824b09891b629$var$ms(e);
    $24b824b09891b629$var$Cl(e, n, o, t), $24b824b09891b629$var$Al(e, r);
    const i = o ? $24b824b09891b629$var$nu(e, t) : void 0;
    return t && $24b824b09891b629$var$Ir(!1), i;
}
function $24b824b09891b629$var$nu(e, t) {
    var n;
    const r = e.type;
    if ($24b824b09891b629$var$p.NODE_ENV !== 'production') {
        if (r.name && $24b824b09891b629$var$Ar(r.name, e.appContext.config), r.components) {
            const i = Object.keys(r.components);
            for(let s = 0; s < i.length; s++)$24b824b09891b629$var$Ar(i[s], e.appContext.config);
        }
        if (r.directives) {
            const i = Object.keys(r.directives);
            for(let s = 0; s < i.length; s++)$24b824b09891b629$var$zi(i[s]);
        }
        r.compilerOptions && $24b824b09891b629$var$ru() && $24b824b09891b629$var$w('"compilerOptions" is only supported when using a build of Vue that includes the runtime compiler. Since you are using a runtime-only build, the options should be passed via your build tool config instead.');
    }
    e.accessCache = /* @__PURE__ */ Object.create(null), e.proxy = $24b824b09891b629$var$Ci(new Proxy(e.ctx, $24b824b09891b629$var$es)), $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$gl(e);
    const { setup: o } = r;
    if (o) {
        const i = e.setupContext = o.length > 1 ? $24b824b09891b629$var$iu(e) : null, s = $24b824b09891b629$var$mn(e);
        $24b824b09891b629$var$ft();
        const a = $24b824b09891b629$var$qe(o, e, 0, [
            $24b824b09891b629$var$p.NODE_ENV !== 'production' ? $24b824b09891b629$var$Ft(e.props) : e.props,
            i
        ]);
        if ($24b824b09891b629$var$dt(), s(), $24b824b09891b629$var$Lr(a)) {
            if (a.then($24b824b09891b629$var$Ro, $24b824b09891b629$var$Ro), t) return a.then((u)=>{
                $24b824b09891b629$var$Wo(e, u, t);
            }).catch((u)=>{
                $24b824b09891b629$var$dn(u, e, 0);
            });
            if (e.asyncDep = a, $24b824b09891b629$var$p.NODE_ENV !== 'production' && !e.suspense) {
                const u = (n = r.name) != null ? n : 'Anonymous';
                $24b824b09891b629$var$w(`Component <${u}>: setup function returned a promise, but no <Suspense> boundary was found in the parent component tree. A component with async setup() must be nested in a <Suspense> in order to be rendered.`);
            }
        } else $24b824b09891b629$var$Wo(e, a, t);
    } else $24b824b09891b629$var$gs(e, t);
}
function $24b824b09891b629$var$Wo(e, t, n) {
    $24b824b09891b629$var$S(t) ? e.type.__ssrInlineRender ? e.ssrRender = t : e.render = t : $24b824b09891b629$var$ee(t) ? ($24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Jn(t) && $24b824b09891b629$var$w('setup() should not return VNodes directly - return a render function instead.'), $24b824b09891b629$var$p.NODE_ENV !== 'production' && (e.devtoolsRawSetupState = t), e.setupState = $24b824b09891b629$var$Pi(t), $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$vl(e)) : $24b824b09891b629$var$p.NODE_ENV !== 'production' && t !== void 0 && $24b824b09891b629$var$w(`setup() should return an object. Received: ${t === null ? 'null' : typeof t}`), $24b824b09891b629$var$gs(e, n);
}
let $24b824b09891b629$var$Fr;
const $24b824b09891b629$var$ru = ()=>!$24b824b09891b629$var$Fr;
function $24b824b09891b629$var$gs(e, t, n) {
    const r = e.type;
    if (!e.render) {
        if (!t && $24b824b09891b629$var$Fr && !r.render) {
            const o = r.template || $24b824b09891b629$var$ro(e).template;
            if (o) {
                $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Ge(e, 'compile');
                const { isCustomElement: i, compilerOptions: s } = e.appContext.config, { delimiters: a, compilerOptions: u } = r, d1 = $24b824b09891b629$var$se($24b824b09891b629$var$se({
                    isCustomElement: i,
                    delimiters: a
                }, s), u);
                r.render = $24b824b09891b629$var$Fr(o, d1), $24b824b09891b629$var$p.NODE_ENV !== 'production' && $24b824b09891b629$var$Be(e, 'compile');
            }
        }
        e.render = r.render || $24b824b09891b629$var$ae;
    }
    {
        const o = $24b824b09891b629$var$mn(e);
        $24b824b09891b629$var$ft();
        try {
            $24b824b09891b629$var$yl(e);
        } finally{
            $24b824b09891b629$var$dt(), o();
        }
    }
    $24b824b09891b629$var$p.NODE_ENV !== 'production' && !r.render && e.render === $24b824b09891b629$var$ae && !t && (r.template ? $24b824b09891b629$var$w('Component provided template option but runtime compilation is not supported in this build of Vue. Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".') : $24b824b09891b629$var$w('Component is missing template or render function.'));
}
function $24b824b09891b629$var$Lo(e) {
    return e.attrsProxy || (e.attrsProxy = new Proxy(e.attrs, $24b824b09891b629$var$p.NODE_ENV !== 'production' ? {
        get (t, n) {
            return $24b824b09891b629$var$An(), $24b824b09891b629$var$me(e, 'get', '$attrs'), t[n];
        },
        set () {
            return $24b824b09891b629$var$w('setupContext.attrs is readonly.'), !1;
        },
        deleteProperty () {
            return $24b824b09891b629$var$w('setupContext.attrs is readonly.'), !1;
        }
    } : {
        get (t, n) {
            return $24b824b09891b629$var$me(e, 'get', '$attrs'), t[n];
        }
    }));
}
function $24b824b09891b629$var$ou(e) {
    return e.slotsProxy || (e.slotsProxy = new Proxy(e.slots, {
        get (t, n) {
            return $24b824b09891b629$var$me(e, 'get', '$slots'), t[n];
        }
    }));
}
function $24b824b09891b629$var$iu(e) {
    const t = (n)=>{
        if ($24b824b09891b629$var$p.NODE_ENV !== 'production' && (e.exposed && $24b824b09891b629$var$w('expose() should be called only once per setup().'), n != null)) {
            let r = typeof n;
            r === 'object' && ($24b824b09891b629$var$M(n) ? r = 'array' : $24b824b09891b629$var$ge(n) && (r = 'ref')), r !== 'object' && $24b824b09891b629$var$w(`expose() should be passed a plain object, received ${r}.`);
        }
        e.exposed = n || {};
    };
    return $24b824b09891b629$var$p.NODE_ENV !== 'production' ? Object.freeze({
        get attrs () {
            return $24b824b09891b629$var$Lo(e);
        },
        get slots () {
            return $24b824b09891b629$var$ou(e);
        },
        get emit () {
            return (n, ...r)=>e.emit(n, ...r);
        },
        expose: t
    }) : {
        get attrs () {
            return $24b824b09891b629$var$Lo(e);
        },
        slots: e.slots,
        emit: e.emit,
        expose: t
    };
}
function $24b824b09891b629$var$er(e) {
    if (e.exposed) return e.exposeProxy || (e.exposeProxy = new Proxy($24b824b09891b629$var$Pi($24b824b09891b629$var$Ci(e.exposed)), {
        get (t, n) {
            if (n in t) return t[n];
            if (n in $24b824b09891b629$var$Ot) return $24b824b09891b629$var$Ot[n](e);
        },
        has (t, n) {
            return n in t || n in $24b824b09891b629$var$Ot;
        }
    }));
}
const $24b824b09891b629$var$su = /(?:^|[-_])(\w)/g, $24b824b09891b629$var$au = (e)=>e.replace($24b824b09891b629$var$su, (t)=>t.toUpperCase()).replace(/[-_]/g, '');
function $24b824b09891b629$var$so(e, t = !0) {
    return $24b824b09891b629$var$S(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function $24b824b09891b629$var$tr(e, t, n = !1) {
    let r = $24b824b09891b629$var$so(t);
    if (!r && t.__file) {
        const o = t.__file.match(/([^/\\]+)\.\w+$/);
        o && (r = o[1]);
    }
    if (!r && e && e.parent) {
        const o = (i)=>{
            for(const s in i)if (i[s] === t) return s;
        };
        r = o(e.components || e.parent.type.components) || o(e.appContext.components);
    }
    return r ? $24b824b09891b629$var$au(r) : n ? 'App' : 'Anonymous';
}
function $24b824b09891b629$var$vs(e) {
    return $24b824b09891b629$var$S(e) && '__vccOpts' in e;
}
const $24b824b09891b629$var$Tt = (e, t)=>$24b824b09891b629$var$ha(e, t, $24b824b09891b629$var$Zn);
function $24b824b09891b629$var$mr(e) {
    return !!(e && e.__v_isShallow);
}
function $24b824b09891b629$var$lu() {
    if ($24b824b09891b629$var$p.NODE_ENV === 'production' || typeof window > 'u') return;
    const e = {
        style: 'color:#3ba776'
    }, t = {
        style: 'color:#1677ff'
    }, n = {
        style: 'color:#f5222d'
    }, r = {
        style: 'color:#eb2f96'
    }, o = {
        header (c) {
            return $24b824b09891b629$var$ee(c) ? c.__isVue ? [
                'div',
                e,
                'VueInstance'
            ] : $24b824b09891b629$var$ge(c) ? [
                'div',
                {},
                [
                    'span',
                    e,
                    h(c)
                ],
                '<',
                a(c.value),
                '>'
            ] : $24b824b09891b629$var$Et(c) ? [
                'div',
                {},
                [
                    'span',
                    e,
                    $24b824b09891b629$var$mr(c) ? 'ShallowReactive' : 'Reactive'
                ],
                '<',
                a(c),
                `>${$24b824b09891b629$var$lt(c) ? ' (readonly)' : ''}`
            ] : $24b824b09891b629$var$lt(c) ? [
                'div',
                {},
                [
                    'span',
                    e,
                    $24b824b09891b629$var$mr(c) ? 'ShallowReadonly' : 'Readonly'
                ],
                '<',
                a(c),
                '>'
            ] : null : null;
        },
        hasBody (c) {
            return c && c.__isVue;
        },
        body (c) {
            if (c && c.__isVue) return [
                'div',
                {},
                ...i(c.$)
            ];
        }
    };
    function i(c) {
        const m = [];
        c.type.props && c.props && m.push(s('props', $24b824b09891b629$var$R(c.props))), c.setupState !== $24b824b09891b629$var$Z && m.push(s('setup', c.setupState)), c.data !== $24b824b09891b629$var$Z && m.push(s('data', $24b824b09891b629$var$R(c.data)));
        const N = u(c, 'computed');
        N && m.push(s('computed', N));
        const T = u(c, 'inject');
        return T && m.push(s('injected', T)), m.push([
            'div',
            {},
            [
                'span',
                {
                    style: r.style + ';opacity:0.66'
                },
                '$ (internal): '
            ],
            [
                'object',
                {
                    object: c
                }
            ]
        ]), m;
    }
    function s(c, m) {
        return m = $24b824b09891b629$var$se({}, m), Object.keys(m).length ? [
            'div',
            {
                style: 'line-height:1.25em;margin-bottom:0.6em'
            },
            [
                'div',
                {
                    style: 'color:#476582'
                },
                c
            ],
            [
                'div',
                {
                    style: 'padding-left:1.25em'
                },
                ...Object.keys(m).map((N)=>[
                        'div',
                        {},
                        [
                            'span',
                            r,
                            N + ': '
                        ],
                        a(m[N], !1)
                    ])
            ]
        ] : [
            'span',
            {}
        ];
    }
    function a(c, m = !0) {
        return typeof c == 'number' ? [
            'span',
            t,
            c
        ] : typeof c == 'string' ? [
            'span',
            n,
            JSON.stringify(c)
        ] : typeof c == 'boolean' ? [
            'span',
            r,
            c
        ] : $24b824b09891b629$var$ee(c) ? [
            'object',
            {
                object: m ? $24b824b09891b629$var$R(c) : c
            }
        ] : [
            'span',
            n,
            String(c)
        ];
    }
    function u(c, m) {
        const N = c.type;
        if ($24b824b09891b629$var$S(N)) return;
        const T = {};
        for(const P in c.ctx)d1(N, P, m) && (T[P] = c.ctx[P]);
        return T;
    }
    function d1(c, m, N) {
        const T = c[N];
        if ($24b824b09891b629$var$M(T) && T.includes(m) || $24b824b09891b629$var$ee(T) && m in T || c.extends && d1(c.extends, m, N) || c.mixins && c.mixins.some((P)=>d1(P, m, N))) return !0;
    }
    function h(c) {
        return $24b824b09891b629$var$mr(c) ? 'ShallowRef' : c.effect ? 'ComputedRef' : 'Ref';
    }
    window.devtoolsFormatters ? window.devtoolsFormatters.push(o) : window.devtoolsFormatters = [
        o
    ];
}
const $24b824b09891b629$var$Uo = '3.4.15', $24b824b09891b629$var$Dt = $24b824b09891b629$var$p.NODE_ENV !== 'production' ? $24b824b09891b629$var$w : $24b824b09891b629$var$ae;
var $24b824b09891b629$var$Ht = {};
const $24b824b09891b629$var$uu = 'http://www.w3.org/2000/svg', $24b824b09891b629$var$cu = 'http://www.w3.org/1998/Math/MathML', $24b824b09891b629$var$nt = typeof document < 'u' ? document : null, $24b824b09891b629$var$jo = $24b824b09891b629$var$nt && /* @__PURE__ */ $24b824b09891b629$var$nt.createElement('template'), $24b824b09891b629$var$fu = {
    insert: (e, t, n)=>{
        t.insertBefore(e, n || null);
    },
    remove: (e)=>{
        const t = e.parentNode;
        t && t.removeChild(e);
    },
    createElement: (e, t, n, r)=>{
        const o = t === 'svg' ? $24b824b09891b629$var$nt.createElementNS($24b824b09891b629$var$uu, e) : t === 'mathml' ? $24b824b09891b629$var$nt.createElementNS($24b824b09891b629$var$cu, e) : $24b824b09891b629$var$nt.createElement(e, n ? {
            is: n
        } : void 0);
        return e === 'select' && r && r.multiple != null && o.setAttribute('multiple', r.multiple), o;
    },
    createText: (e)=>$24b824b09891b629$var$nt.createTextNode(e),
    createComment: (e)=>$24b824b09891b629$var$nt.createComment(e),
    setText: (e, t)=>{
        e.nodeValue = t;
    },
    setElementText: (e, t)=>{
        e.textContent = t;
    },
    parentNode: (e)=>e.parentNode,
    nextSibling: (e)=>e.nextSibling,
    querySelector: (e)=>$24b824b09891b629$var$nt.querySelector(e),
    setScopeId (e, t) {
        e.setAttribute(t, '');
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (e, t, n, r, o, i) {
        const s = n ? n.previousSibling : t.lastChild;
        if (o && (o === i || o.nextSibling)) for(; t.insertBefore(o.cloneNode(!0), n), !(o === i || !(o = o.nextSibling)););
        else {
            $24b824b09891b629$var$jo.innerHTML = r === 'svg' ? `<svg>${e}</svg>` : r === 'mathml' ? `<math>${e}</math>` : e;
            const a = $24b824b09891b629$var$jo.content;
            if (r === 'svg' || r === 'mathml') {
                const u = a.firstChild;
                for(; u.firstChild;)a.appendChild(u.firstChild);
                a.removeChild(u);
            }
            t.insertBefore(a, n);
        }
        return [
            // first
            s ? s.nextSibling : t.firstChild,
            // last
            n ? n.previousSibling : t.lastChild
        ];
    }
}, $24b824b09891b629$var$du = Symbol('_vtc');
function $24b824b09891b629$var$pu(e, t, n) {
    const r = e[$24b824b09891b629$var$du];
    r && (t = (t ? [
        t,
        ...r
    ] : [
        ...r
    ]).join(' ')), t == null ? e.removeAttribute('class') : n ? e.setAttribute('class', t) : e.className = t;
}
const $24b824b09891b629$var$hu = Symbol('_vod'), $24b824b09891b629$var$mu = Symbol($24b824b09891b629$var$Ht.NODE_ENV !== 'production' ? 'CSS_VAR_TEXT' : '');
function $24b824b09891b629$var$gu(e, t, n) {
    const r = e.style, o = r.display, i = $24b824b09891b629$var$re(n);
    if (n && !i) {
        if (t && !$24b824b09891b629$var$re(t)) for(const s in t)n[s] == null && $24b824b09891b629$var$Rr(r, s, '');
        for(const s in n)$24b824b09891b629$var$Rr(r, s, n[s]);
    } else if (i) {
        if (t !== n) {
            const s = r[$24b824b09891b629$var$mu];
            s && (n += ';' + s), r.cssText = n;
        }
    } else t && e.removeAttribute('style');
    $24b824b09891b629$var$hu in e && (r.display = o);
}
const $24b824b09891b629$var$vu = /[^\\];\s*$/, $24b824b09891b629$var$Ho = /\s*!important$/;
function $24b824b09891b629$var$Rr(e, t, n) {
    if ($24b824b09891b629$var$M(n)) n.forEach((r)=>$24b824b09891b629$var$Rr(e, t, r));
    else if (n == null && (n = ''), $24b824b09891b629$var$Ht.NODE_ENV !== 'production' && $24b824b09891b629$var$vu.test(n) && $24b824b09891b629$var$Dt(`Unexpected semicolon at the end of '${t}' style value: '${n}'`), t.startsWith('--')) e.setProperty(t, n);
    else {
        const r = $24b824b09891b629$var$_u(e, t);
        $24b824b09891b629$var$Ho.test(n) ? e.setProperty($24b824b09891b629$var$st(r), n.replace($24b824b09891b629$var$Ho, ''), 'important') : e[r] = n;
    }
}
const $24b824b09891b629$var$Go = [
    'Webkit',
    'Moz',
    'ms'
], $24b824b09891b629$var$gr = {};
function $24b824b09891b629$var$_u(e, t) {
    const n = $24b824b09891b629$var$gr[t];
    if (n) return n;
    let r = $24b824b09891b629$var$Ue(t);
    if (r !== 'filter' && r in e) return $24b824b09891b629$var$gr[t] = r;
    r = $24b824b09891b629$var$$t(r);
    for(let o = 0; o < $24b824b09891b629$var$Go.length; o++){
        const i = $24b824b09891b629$var$Go[o] + r;
        if (i in e) return $24b824b09891b629$var$gr[t] = i;
    }
    return t;
}
const $24b824b09891b629$var$Bo = 'http://www.w3.org/1999/xlink';
function $24b824b09891b629$var$yu(e, t, n, r, o) {
    if (r && t.startsWith('xlink:')) n == null ? e.removeAttributeNS($24b824b09891b629$var$Bo, t.slice(6, t.length)) : e.setAttributeNS($24b824b09891b629$var$Bo, t, n);
    else {
        const i = $24b824b09891b629$var$Gs(t);
        n == null || i && !$24b824b09891b629$var$ui(n) ? e.removeAttribute(t) : e.setAttribute(t, i ? '' : n);
    }
}
function $24b824b09891b629$var$bu(e, t, n, r, o, i, s) {
    if (t === 'innerHTML' || t === 'textContent') {
        r && s(r, o, i), e[t] = n ?? '';
        return;
    }
    const a = e.tagName;
    if (t === 'value' && a !== 'PROGRESS' && // custom elements may use _value internally
    !a.includes('-')) {
        e._value = n;
        const d1 = a === 'OPTION' ? e.getAttribute('value') : e.value, h = n ?? '';
        d1 !== h && (e.value = h), n == null && e.removeAttribute(t);
        return;
    }
    let u = !1;
    if (n === '' || n == null) {
        const d1 = typeof e[t];
        d1 === 'boolean' ? n = $24b824b09891b629$var$ui(n) : n == null && d1 === 'string' ? (n = '', u = !0) : d1 === 'number' && (n = 0, u = !0);
    }
    try {
        e[t] = n;
    } catch (d1) {
        $24b824b09891b629$var$Ht.NODE_ENV !== 'production' && !u && $24b824b09891b629$var$Dt(`Failed setting prop "${t}" on <${a.toLowerCase()}>: value ${n} is invalid.`, d1);
    }
    u && e.removeAttribute(t);
}
function $24b824b09891b629$var$wu(e, t, n, r) {
    e.addEventListener(t, n, r);
}
function $24b824b09891b629$var$Eu(e, t, n, r) {
    e.removeEventListener(t, n, r);
}
const $24b824b09891b629$var$Yo = Symbol('_vei');
function $24b824b09891b629$var$Nu(e, t, n, r, o = null) {
    const i = e[$24b824b09891b629$var$Yo] || (e[$24b824b09891b629$var$Yo] = {}), s = i[t];
    if (r && s) s.value = r;
    else {
        const [a, u] = $24b824b09891b629$var$Ou(t);
        if (r) {
            const d1 = i[t] = $24b824b09891b629$var$Cu(r, o);
            $24b824b09891b629$var$wu(e, a, d1, u);
        } else s && ($24b824b09891b629$var$Eu(e, a, s, u), i[t] = void 0);
    }
}
const $24b824b09891b629$var$qo = /(?:Once|Passive|Capture)$/;
function $24b824b09891b629$var$Ou(e) {
    let t;
    if ($24b824b09891b629$var$qo.test(e)) {
        t = {};
        let r;
        for(; r = e.match($24b824b09891b629$var$qo);)e = e.slice(0, e.length - r[0].length), t[r[0].toLowerCase()] = !0;
    }
    return [
        e[2] === ':' ? e.slice(3) : $24b824b09891b629$var$st(e.slice(2)),
        t
    ];
}
let $24b824b09891b629$var$vr = 0;
const $24b824b09891b629$var$Du = /* @__PURE__ */ Promise.resolve(), $24b824b09891b629$var$$u = ()=>$24b824b09891b629$var$vr || ($24b824b09891b629$var$Du.then(()=>$24b824b09891b629$var$vr = 0), $24b824b09891b629$var$vr = Date.now());
function $24b824b09891b629$var$Cu(e, t) {
    const n = (r)=>{
        if (!r._vts) r._vts = Date.now();
        else if (r._vts <= n.attached) return;
        $24b824b09891b629$var$Pe($24b824b09891b629$var$Tu(r, n.value), t, 5, [
            r
        ]);
    };
    return n.value = e, n.attached = $24b824b09891b629$var$$u(), n;
}
function $24b824b09891b629$var$Tu(e, t) {
    if ($24b824b09891b629$var$M(t)) {
        const n = e.stopImmediatePropagation;
        return e.stopImmediatePropagation = ()=>{
            n.call(e), e._stopped = !0;
        }, t.map((r)=>(o)=>!o._stopped && r && r(o));
    } else return t;
}
const $24b824b09891b629$var$Ko = (e)=>e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // lowercase letter
    e.charCodeAt(2) > 96 && e.charCodeAt(2) < 123, $24b824b09891b629$var$xu = (e, t, n, r, o, i, s, a, u)=>{
    const d1 = o === 'svg';
    t === 'class' ? $24b824b09891b629$var$pu(e, r, d1) : t === 'style' ? $24b824b09891b629$var$gu(e, n, r) : $24b824b09891b629$var$fn(t) ? $24b824b09891b629$var$Pn(t) || $24b824b09891b629$var$Nu(e, t, n, r, s) : (t[0] === '.' ? (t = t.slice(1), !0) : t[0] === '^' ? (t = t.slice(1), !1) : $24b824b09891b629$var$Vu(e, t, r, d1)) ? $24b824b09891b629$var$bu(e, t, r, i, s, a, u) : (t === 'true-value' ? e._trueValue = r : t === 'false-value' && (e._falseValue = r), $24b824b09891b629$var$yu(e, t, r, d1));
};
function $24b824b09891b629$var$Vu(e, t, n, r) {
    if (r) return !!(t === 'innerHTML' || t === 'textContent' || t in e && $24b824b09891b629$var$Ko(t) && $24b824b09891b629$var$S(n));
    if (t === 'spellcheck' || t === 'draggable' || t === 'translate' || t === 'form' || t === 'list' && e.tagName === 'INPUT' || t === 'type' && e.tagName === 'TEXTAREA') return !1;
    if (t === 'width' || t === 'height') {
        const o = e.tagName;
        if (o === 'IMG' || o === 'VIDEO' || o === 'CANVAS' || o === 'SOURCE') return !1;
    }
    return $24b824b09891b629$var$Ko(t) && $24b824b09891b629$var$re(n) ? !1 : t in e;
}
const $24b824b09891b629$var$Mu = /* @__PURE__ */ $24b824b09891b629$var$se({
    patchProp: $24b824b09891b629$var$xu
}, $24b824b09891b629$var$fu);
let $24b824b09891b629$var$Xo;
function $24b824b09891b629$var$Pu() {
    return $24b824b09891b629$var$Xo || ($24b824b09891b629$var$Xo = $24b824b09891b629$var$Wl($24b824b09891b629$var$Mu));
}
const $24b824b09891b629$var$Su = (...e)=>{
    const t = $24b824b09891b629$var$Pu().createApp(...e);
    $24b824b09891b629$var$Ht.NODE_ENV !== 'production' && ($24b824b09891b629$var$Iu(t), $24b824b09891b629$var$Au(t));
    const { mount: n } = t;
    return t.mount = (r)=>{
        const o = $24b824b09891b629$var$Fu(r);
        if (!o) return;
        const i = t._component;
        !$24b824b09891b629$var$S(i) && !i.render && !i.template && (i.template = o.innerHTML), o.innerHTML = '';
        const s = n(o, !1, $24b824b09891b629$var$ku(o));
        return o instanceof Element && (o.removeAttribute('v-cloak'), o.setAttribute('data-v-app', '')), s;
    }, t;
};
function $24b824b09891b629$var$ku(e) {
    if (e instanceof SVGElement) return 'svg';
    if (typeof MathMLElement == 'function' && e instanceof MathMLElement) return 'mathml';
}
function $24b824b09891b629$var$Iu(e) {
    Object.defineProperty(e.config, 'isNativeTag', {
        value: (t)=>$24b824b09891b629$var$Ls(t) || $24b824b09891b629$var$Us(t) || $24b824b09891b629$var$js(t),
        writable: !1
    });
}
function $24b824b09891b629$var$Au(e) {
    {
        const t = e.config.isCustomElement;
        Object.defineProperty(e.config, 'isCustomElement', {
            get () {
                return t;
            },
            set () {
                $24b824b09891b629$var$Dt('The `isCustomElement` config option is deprecated. Use `compilerOptions.isCustomElement` instead.');
            }
        });
        const n = e.config.compilerOptions, r = 'The `compilerOptions` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, `compilerOptions` must be passed to `@vue/compiler-dom` in the build setup instead.\n- For vue-loader: pass it via vue-loader\'s `compilerOptions` loader option.\n- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc';
        Object.defineProperty(e.config, 'compilerOptions', {
            get () {
                return $24b824b09891b629$var$Dt(r), n;
            },
            set () {
                $24b824b09891b629$var$Dt(r);
            }
        });
    }
}
function $24b824b09891b629$var$Fu(e) {
    if ($24b824b09891b629$var$re(e)) {
        const t = document.querySelector(e);
        return $24b824b09891b629$var$Ht.NODE_ENV !== 'production' && !t && $24b824b09891b629$var$Dt(`Failed to mount app: mount target selector "${e}" returned null.`), t;
    }
    return $24b824b09891b629$var$Ht.NODE_ENV !== 'production' && window.ShadowRoot && e instanceof window.ShadowRoot && e.mode === 'closed' && $24b824b09891b629$var$Dt('mounting on a ShadowRoot with `{mode: "closed"}` may lead to unpredictable bugs'), e;
}
var $24b824b09891b629$var$Ru = {};
function $24b824b09891b629$var$Wu() {
    $24b824b09891b629$var$lu();
}
$24b824b09891b629$var$Ru.NODE_ENV !== 'production' && $24b824b09891b629$var$Wu();
const $24b824b09891b629$var$$e = (e, t)=>{
    const n = e.__vccOpts || e;
    for (const [r, o] of t)n[r] = o;
    return n;
}, $24b824b09891b629$var$Lu = {
    name: 'IPaginateNext'
}, $24b824b09891b629$var$Uu = {
    width: '24',
    height: '25',
    viewBox: '0 0 24 25',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
}, $24b824b09891b629$var$ju = /* @__PURE__ */ $24b824b09891b629$var$I('path', {
    d: 'M10 7.22168L15 12.2217L10 17.2217',
    stroke: 'currentColor',
    'stroke-linecap': 'round'
}, null, -1), $24b824b09891b629$var$Hu = [
    $24b824b09891b629$var$ju
];
function $24b824b09891b629$var$Gu(e, t, n, r, o, i) {
    return $24b824b09891b629$var$te(), $24b824b09891b629$var$fe('svg', $24b824b09891b629$var$Uu, $24b824b09891b629$var$Hu);
}
const $24b824b09891b629$var$_s = /* @__PURE__ */ $24b824b09891b629$var$$e($24b824b09891b629$var$Lu, [
    [
        'render',
        $24b824b09891b629$var$Gu
    ]
]), $24b824b09891b629$var$Bu = '_root_1s9hm_1', $24b824b09891b629$var$Yu = '_dark_1s9hm_12', $24b824b09891b629$var$qu = '_text_1s9hm_18', $24b824b09891b629$var$Ku = '_link_1s9hm_25', $24b824b09891b629$var$Xu = {
    root: $24b824b09891b629$var$Bu,
    dark: $24b824b09891b629$var$Yu,
    text: $24b824b09891b629$var$qu,
    link: $24b824b09891b629$var$Ku
}, $24b824b09891b629$var$zu = /* @__PURE__ */ $24b824b09891b629$var$I('span', null, "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435", -1), $24b824b09891b629$var$Ju = {
    __name: 'BnplWidgetOne',
    props: {
        params: Object
    },
    setup (e) {
        const t = e;
        return (n, r)=>($24b824b09891b629$var$te(), $24b824b09891b629$var$fe('div', {
                class: $24b824b09891b629$var$U([
                    n.$style.root,
                    t.params.isDarkTheme && n.$style.dark
                ])
            }, [
                $24b824b09891b629$var$I('span', {
                    class: $24b824b09891b629$var$U(n.$style.text)
                }, "\u0434\u0430\u0432\u0430\u0439 \u0434\u0435\u043B\u0438\u0442\u044C", 2),
                $24b824b09891b629$var$I('div', {
                    class: $24b824b09891b629$var$U(n.$style.link)
                }, [
                    $24b824b09891b629$var$zu,
                    $24b824b09891b629$var$pe($24b824b09891b629$var$_s)
                ], 2)
            ], 2));
    }
}, $24b824b09891b629$var$Qu = {
    $style: $24b824b09891b629$var$Xu
}, $24b824b09891b629$var$Zu = /* @__PURE__ */ $24b824b09891b629$var$$e($24b824b09891b629$var$Ju, [
    [
        '__cssModules',
        $24b824b09891b629$var$Qu
    ]
]);
function $24b824b09891b629$var$Un(e) {
    '@babel/helpers - typeof';
    return $24b824b09891b629$var$Un = typeof Symbol == 'function' && typeof Symbol.iterator == 'symbol' ? function(t) {
        return typeof t;
    } : function(t) {
        return t && typeof Symbol == 'function' && t.constructor === Symbol && t !== Symbol.prototype ? 'symbol' : typeof t;
    }, $24b824b09891b629$var$Un(e);
}
function $24b824b09891b629$var$xt(e) {
    if (e === null || e === !0 || e === !1) return NaN;
    var t = Number(e);
    return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function $24b824b09891b629$var$_e(e, t) {
    if (t.length < e) throw new TypeError(e + ' argument' + (e > 1 ? 's' : '') + ' required, but only ' + t.length + ' present');
}
function $24b824b09891b629$var$je(e) {
    $24b824b09891b629$var$_e(1, arguments);
    var t = Object.prototype.toString.call(e);
    return e instanceof Date || $24b824b09891b629$var$Un(e) === 'object' && t === '[object Date]' ? new Date(e.getTime()) : typeof e == 'number' || t === '[object Number]' ? new Date(e) : ((typeof e == 'string' || t === '[object String]') && typeof console < 'u' && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function $24b824b09891b629$var$ec(e, t) {
    $24b824b09891b629$var$_e(2, arguments);
    var n = $24b824b09891b629$var$je(e).getTime(), r = $24b824b09891b629$var$xt(t);
    return new Date(n + r);
}
var $24b824b09891b629$var$tc = {};
function $24b824b09891b629$var$nr() {
    return $24b824b09891b629$var$tc;
}
function $24b824b09891b629$var$nc(e) {
    var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
    return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function $24b824b09891b629$var$rc(e) {
    return $24b824b09891b629$var$_e(1, arguments), e instanceof Date || $24b824b09891b629$var$Un(e) === 'object' && Object.prototype.toString.call(e) === '[object Date]';
}
function $24b824b09891b629$var$oc(e) {
    if ($24b824b09891b629$var$_e(1, arguments), !$24b824b09891b629$var$rc(e) && typeof e != 'number') return !1;
    var t = $24b824b09891b629$var$je(e);
    return !isNaN(Number(t));
}
function $24b824b09891b629$var$ic(e, t) {
    $24b824b09891b629$var$_e(2, arguments);
    var n = $24b824b09891b629$var$xt(t);
    return $24b824b09891b629$var$ec(e, -n);
}
var $24b824b09891b629$var$sc = 864e5;
function $24b824b09891b629$var$ac(e) {
    $24b824b09891b629$var$_e(1, arguments);
    var t = $24b824b09891b629$var$je(e), n = t.getTime();
    t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
    var r = t.getTime(), o = n - r;
    return Math.floor(o / $24b824b09891b629$var$sc) + 1;
}
function $24b824b09891b629$var$jn(e) {
    $24b824b09891b629$var$_e(1, arguments);
    var t = 1, n = $24b824b09891b629$var$je(e), r = n.getUTCDay(), o = (r < t ? 7 : 0) + r - t;
    return n.setUTCDate(n.getUTCDate() - o), n.setUTCHours(0, 0, 0, 0), n;
}
function $24b824b09891b629$var$ys(e) {
    $24b824b09891b629$var$_e(1, arguments);
    var t = $24b824b09891b629$var$je(e), n = t.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
    r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
    var o = $24b824b09891b629$var$jn(r), i = /* @__PURE__ */ new Date(0);
    i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0);
    var s = $24b824b09891b629$var$jn(i);
    return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= s.getTime() ? n : n - 1;
}
function $24b824b09891b629$var$lc(e) {
    $24b824b09891b629$var$_e(1, arguments);
    var t = $24b824b09891b629$var$ys(e), n = /* @__PURE__ */ new Date(0);
    n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0);
    var r = $24b824b09891b629$var$jn(n);
    return r;
}
var $24b824b09891b629$var$uc = 6048e5;
function $24b824b09891b629$var$cc(e) {
    $24b824b09891b629$var$_e(1, arguments);
    var t = $24b824b09891b629$var$je(e), n = $24b824b09891b629$var$jn(t).getTime() - $24b824b09891b629$var$lc(t).getTime();
    return Math.round(n / $24b824b09891b629$var$uc) + 1;
}
function $24b824b09891b629$var$Gt(e, t) {
    var n, r, o, i, s, a, u, d1;
    $24b824b09891b629$var$_e(1, arguments);
    var h = $24b824b09891b629$var$nr(), c = $24b824b09891b629$var$xt((n = (r = (o = (i = t?.weekStartsOn) !== null && i !== void 0 ? i : t == null || (s = t.locale) === null || s === void 0 || (a = s.options) === null || a === void 0 ? void 0 : a.weekStartsOn) !== null && o !== void 0 ? o : h.weekStartsOn) !== null && r !== void 0 ? r : (u = h.locale) === null || u === void 0 || (d1 = u.options) === null || d1 === void 0 ? void 0 : d1.weekStartsOn) !== null && n !== void 0 ? n : 0);
    if (!(c >= 0 && c <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var m = $24b824b09891b629$var$je(e), N = m.getUTCDay(), T = (N < c ? 7 : 0) + N - c;
    return m.setUTCDate(m.getUTCDate() - T), m.setUTCHours(0, 0, 0, 0), m;
}
function $24b824b09891b629$var$bs(e, t) {
    var n, r, o, i, s, a, u, d1;
    $24b824b09891b629$var$_e(1, arguments);
    var h = $24b824b09891b629$var$je(e), c = h.getUTCFullYear(), m = $24b824b09891b629$var$nr(), N = $24b824b09891b629$var$xt((n = (r = (o = (i = t?.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (s = t.locale) === null || s === void 0 || (a = s.options) === null || a === void 0 ? void 0 : a.firstWeekContainsDate) !== null && o !== void 0 ? o : m.firstWeekContainsDate) !== null && r !== void 0 ? r : (u = m.locale) === null || u === void 0 || (d1 = u.options) === null || d1 === void 0 ? void 0 : d1.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
    if (!(N >= 1 && N <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var T = /* @__PURE__ */ new Date(0);
    T.setUTCFullYear(c + 1, 0, N), T.setUTCHours(0, 0, 0, 0);
    var P = $24b824b09891b629$var$Gt(T, t), L = /* @__PURE__ */ new Date(0);
    L.setUTCFullYear(c, 0, N), L.setUTCHours(0, 0, 0, 0);
    var X = $24b824b09891b629$var$Gt(L, t);
    return h.getTime() >= P.getTime() ? c + 1 : h.getTime() >= X.getTime() ? c : c - 1;
}
function $24b824b09891b629$var$fc(e, t) {
    var n, r, o, i, s, a, u, d1;
    $24b824b09891b629$var$_e(1, arguments);
    var h = $24b824b09891b629$var$nr(), c = $24b824b09891b629$var$xt((n = (r = (o = (i = t?.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (s = t.locale) === null || s === void 0 || (a = s.options) === null || a === void 0 ? void 0 : a.firstWeekContainsDate) !== null && o !== void 0 ? o : h.firstWeekContainsDate) !== null && r !== void 0 ? r : (u = h.locale) === null || u === void 0 || (d1 = u.options) === null || d1 === void 0 ? void 0 : d1.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), m = $24b824b09891b629$var$bs(e, t), N = /* @__PURE__ */ new Date(0);
    N.setUTCFullYear(m, 0, c), N.setUTCHours(0, 0, 0, 0);
    var T = $24b824b09891b629$var$Gt(N, t);
    return T;
}
var $24b824b09891b629$var$dc = 6048e5;
function $24b824b09891b629$var$pc(e, t) {
    $24b824b09891b629$var$_e(1, arguments);
    var n = $24b824b09891b629$var$je(e), r = $24b824b09891b629$var$Gt(n, t).getTime() - $24b824b09891b629$var$fc(n, t).getTime();
    return Math.round(r / $24b824b09891b629$var$dc) + 1;
}
function $24b824b09891b629$var$J(e, t) {
    for(var n = e < 0 ? '-' : '', r = Math.abs(e).toString(); r.length < t;)r = '0' + r;
    return n + r;
}
var $24b824b09891b629$var$hc = {
    // Year
    y: function(t, n) {
        var r = t.getUTCFullYear(), o = r > 0 ? r : 1 - r;
        return $24b824b09891b629$var$J(n === 'yy' ? o % 100 : o, n.length);
    },
    // Month
    M: function(t, n) {
        var r = t.getUTCMonth();
        return n === 'M' ? String(r + 1) : $24b824b09891b629$var$J(r + 1, 2);
    },
    // Day of the month
    d: function(t, n) {
        return $24b824b09891b629$var$J(t.getUTCDate(), n.length);
    },
    // AM or PM
    a: function(t, n) {
        var r = t.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(n){
            case 'a':
            case 'aa':
                return r.toUpperCase();
            case 'aaa':
                return r;
            case 'aaaaa':
                return r[0];
            case 'aaaa':
            default:
                return r === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function(t, n) {
        return $24b824b09891b629$var$J(t.getUTCHours() % 12 || 12, n.length);
    },
    // Hour [0-23]
    H: function(t, n) {
        return $24b824b09891b629$var$J(t.getUTCHours(), n.length);
    },
    // Minute
    m: function(t, n) {
        return $24b824b09891b629$var$J(t.getUTCMinutes(), n.length);
    },
    // Second
    s: function(t, n) {
        return $24b824b09891b629$var$J(t.getUTCSeconds(), n.length);
    },
    // Fraction of second
    S: function(t, n) {
        var r = n.length, o = t.getUTCMilliseconds(), i = Math.floor(o * Math.pow(10, r - 3));
        return $24b824b09891b629$var$J(i, n.length);
    }
};
const $24b824b09891b629$var$Qe = $24b824b09891b629$var$hc;
var $24b824b09891b629$var$kt = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
}, $24b824b09891b629$var$mc = {
    // Era
    G: function(t, n, r) {
        var o = t.getUTCFullYear() > 0 ? 1 : 0;
        switch(n){
            case 'G':
            case 'GG':
            case 'GGG':
                return r.era(o, {
                    width: 'abbreviated'
                });
            case 'GGGGG':
                return r.era(o, {
                    width: 'narrow'
                });
            case 'GGGG':
            default:
                return r.era(o, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function(t, n, r) {
        if (n === 'yo') {
            var o = t.getUTCFullYear(), i = o > 0 ? o : 1 - o;
            return r.ordinalNumber(i, {
                unit: 'year'
            });
        }
        return $24b824b09891b629$var$Qe.y(t, n);
    },
    // Local week-numbering year
    Y: function(t, n, r, o) {
        var i = $24b824b09891b629$var$bs(t, o), s = i > 0 ? i : 1 - i;
        if (n === 'YY') {
            var a = s % 100;
            return $24b824b09891b629$var$J(a, 2);
        }
        return n === 'Yo' ? r.ordinalNumber(s, {
            unit: 'year'
        }) : $24b824b09891b629$var$J(s, n.length);
    },
    // ISO week-numbering year
    R: function(t, n) {
        var r = $24b824b09891b629$var$ys(t);
        return $24b824b09891b629$var$J(r, n.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(t, n) {
        var r = t.getUTCFullYear();
        return $24b824b09891b629$var$J(r, n.length);
    },
    // Quarter
    Q: function(t, n, r) {
        var o = Math.ceil((t.getUTCMonth() + 1) / 3);
        switch(n){
            case 'Q':
                return String(o);
            case 'QQ':
                return $24b824b09891b629$var$J(o, 2);
            case 'Qo':
                return r.ordinalNumber(o, {
                    unit: 'quarter'
                });
            case 'QQQ':
                return r.quarter(o, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'QQQQQ':
                return r.quarter(o, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'QQQQ':
            default:
                return r.quarter(o, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function(t, n, r) {
        var o = Math.ceil((t.getUTCMonth() + 1) / 3);
        switch(n){
            case 'q':
                return String(o);
            case 'qq':
                return $24b824b09891b629$var$J(o, 2);
            case 'qo':
                return r.ordinalNumber(o, {
                    unit: 'quarter'
                });
            case 'qqq':
                return r.quarter(o, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            case 'qqqqq':
                return r.quarter(o, {
                    width: 'narrow',
                    context: 'standalone'
                });
            case 'qqqq':
            default:
                return r.quarter(o, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function(t, n, r) {
        var o = t.getUTCMonth();
        switch(n){
            case 'M':
            case 'MM':
                return $24b824b09891b629$var$Qe.M(t, n);
            case 'Mo':
                return r.ordinalNumber(o + 1, {
                    unit: 'month'
                });
            case 'MMM':
                return r.month(o, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'MMMMM':
                return r.month(o, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'MMMM':
            default:
                return r.month(o, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function(t, n, r) {
        var o = t.getUTCMonth();
        switch(n){
            case 'L':
                return String(o + 1);
            case 'LL':
                return $24b824b09891b629$var$J(o + 1, 2);
            case 'Lo':
                return r.ordinalNumber(o + 1, {
                    unit: 'month'
                });
            case 'LLL':
                return r.month(o, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            case 'LLLLL':
                return r.month(o, {
                    width: 'narrow',
                    context: 'standalone'
                });
            case 'LLLL':
            default:
                return r.month(o, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function(t, n, r, o) {
        var i = $24b824b09891b629$var$pc(t, o);
        return n === 'wo' ? r.ordinalNumber(i, {
            unit: 'week'
        }) : $24b824b09891b629$var$J(i, n.length);
    },
    // ISO week of year
    I: function(t, n, r) {
        var o = $24b824b09891b629$var$cc(t);
        return n === 'Io' ? r.ordinalNumber(o, {
            unit: 'week'
        }) : $24b824b09891b629$var$J(o, n.length);
    },
    // Day of the month
    d: function(t, n, r) {
        return n === 'do' ? r.ordinalNumber(t.getUTCDate(), {
            unit: 'date'
        }) : $24b824b09891b629$var$Qe.d(t, n);
    },
    // Day of year
    D: function(t, n, r) {
        var o = $24b824b09891b629$var$ac(t);
        return n === 'Do' ? r.ordinalNumber(o, {
            unit: 'dayOfYear'
        }) : $24b824b09891b629$var$J(o, n.length);
    },
    // Day of week
    E: function(t, n, r) {
        var o = t.getUTCDay();
        switch(n){
            case 'E':
            case 'EE':
            case 'EEE':
                return r.day(o, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'EEEEE':
                return r.day(o, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'EEEEEE':
                return r.day(o, {
                    width: 'short',
                    context: 'formatting'
                });
            case 'EEEE':
            default:
                return r.day(o, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function(t, n, r, o) {
        var i = t.getUTCDay(), s = (i - o.weekStartsOn + 8) % 7 || 7;
        switch(n){
            case 'e':
                return String(s);
            case 'ee':
                return $24b824b09891b629$var$J(s, 2);
            case 'eo':
                return r.ordinalNumber(s, {
                    unit: 'day'
                });
            case 'eee':
                return r.day(i, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'eeeee':
                return r.day(i, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'eeeeee':
                return r.day(i, {
                    width: 'short',
                    context: 'formatting'
                });
            case 'eeee':
            default:
                return r.day(i, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function(t, n, r, o) {
        var i = t.getUTCDay(), s = (i - o.weekStartsOn + 8) % 7 || 7;
        switch(n){
            case 'c':
                return String(s);
            case 'cc':
                return $24b824b09891b629$var$J(s, n.length);
            case 'co':
                return r.ordinalNumber(s, {
                    unit: 'day'
                });
            case 'ccc':
                return r.day(i, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            case 'ccccc':
                return r.day(i, {
                    width: 'narrow',
                    context: 'standalone'
                });
            case 'cccccc':
                return r.day(i, {
                    width: 'short',
                    context: 'standalone'
                });
            case 'cccc':
            default:
                return r.day(i, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function(t, n, r) {
        var o = t.getUTCDay(), i = o === 0 ? 7 : o;
        switch(n){
            case 'i':
                return String(i);
            case 'ii':
                return $24b824b09891b629$var$J(i, n.length);
            case 'io':
                return r.ordinalNumber(i, {
                    unit: 'day'
                });
            case 'iii':
                return r.day(o, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'iiiii':
                return r.day(o, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'iiiiii':
                return r.day(o, {
                    width: 'short',
                    context: 'formatting'
                });
            case 'iiii':
            default:
                return r.day(o, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function(t, n, r) {
        var o = t.getUTCHours(), i = o / 12 >= 1 ? 'pm' : 'am';
        switch(n){
            case 'a':
            case 'aa':
                return r.dayPeriod(i, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return r.dayPeriod(i, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return r.dayPeriod(i, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return r.dayPeriod(i, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(t, n, r) {
        var o = t.getUTCHours(), i;
        switch(o === 12 ? i = $24b824b09891b629$var$kt.noon : o === 0 ? i = $24b824b09891b629$var$kt.midnight : i = o / 12 >= 1 ? 'pm' : 'am', n){
            case 'b':
            case 'bb':
                return r.dayPeriod(i, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return r.dayPeriod(i, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return r.dayPeriod(i, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return r.dayPeriod(i, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(t, n, r) {
        var o = t.getUTCHours(), i;
        switch(o >= 17 ? i = $24b824b09891b629$var$kt.evening : o >= 12 ? i = $24b824b09891b629$var$kt.afternoon : o >= 4 ? i = $24b824b09891b629$var$kt.morning : i = $24b824b09891b629$var$kt.night, n){
            case 'B':
            case 'BB':
            case 'BBB':
                return r.dayPeriod(i, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return r.dayPeriod(i, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return r.dayPeriod(i, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function(t, n, r) {
        if (n === 'ho') {
            var o = t.getUTCHours() % 12;
            return o === 0 && (o = 12), r.ordinalNumber(o, {
                unit: 'hour'
            });
        }
        return $24b824b09891b629$var$Qe.h(t, n);
    },
    // Hour [0-23]
    H: function(t, n, r) {
        return n === 'Ho' ? r.ordinalNumber(t.getUTCHours(), {
            unit: 'hour'
        }) : $24b824b09891b629$var$Qe.H(t, n);
    },
    // Hour [0-11]
    K: function(t, n, r) {
        var o = t.getUTCHours() % 12;
        return n === 'Ko' ? r.ordinalNumber(o, {
            unit: 'hour'
        }) : $24b824b09891b629$var$J(o, n.length);
    },
    // Hour [1-24]
    k: function(t, n, r) {
        var o = t.getUTCHours();
        return o === 0 && (o = 24), n === 'ko' ? r.ordinalNumber(o, {
            unit: 'hour'
        }) : $24b824b09891b629$var$J(o, n.length);
    },
    // Minute
    m: function(t, n, r) {
        return n === 'mo' ? r.ordinalNumber(t.getUTCMinutes(), {
            unit: 'minute'
        }) : $24b824b09891b629$var$Qe.m(t, n);
    },
    // Second
    s: function(t, n, r) {
        return n === 'so' ? r.ordinalNumber(t.getUTCSeconds(), {
            unit: 'second'
        }) : $24b824b09891b629$var$Qe.s(t, n);
    },
    // Fraction of second
    S: function(t, n) {
        return $24b824b09891b629$var$Qe.S(t, n);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(t, n, r, o) {
        var i = o._originalDate || t, s = i.getTimezoneOffset();
        if (s === 0) return 'Z';
        switch(n){
            case 'X':
                return $24b824b09891b629$var$Jo(s);
            case 'XXXX':
            case 'XX':
                return $24b824b09891b629$var$gt(s);
            case 'XXXXX':
            case 'XXX':
            default:
                return $24b824b09891b629$var$gt(s, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(t, n, r, o) {
        var i = o._originalDate || t, s = i.getTimezoneOffset();
        switch(n){
            case 'x':
                return $24b824b09891b629$var$Jo(s);
            case 'xxxx':
            case 'xx':
                return $24b824b09891b629$var$gt(s);
            case 'xxxxx':
            case 'xxx':
            default:
                return $24b824b09891b629$var$gt(s, ':');
        }
    },
    // Timezone (GMT)
    O: function(t, n, r, o) {
        var i = o._originalDate || t, s = i.getTimezoneOffset();
        switch(n){
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $24b824b09891b629$var$zo(s, ':');
            case 'OOOO':
            default:
                return 'GMT' + $24b824b09891b629$var$gt(s, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(t, n, r, o) {
        var i = o._originalDate || t, s = i.getTimezoneOffset();
        switch(n){
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $24b824b09891b629$var$zo(s, ':');
            case 'zzzz':
            default:
                return 'GMT' + $24b824b09891b629$var$gt(s, ':');
        }
    },
    // Seconds timestamp
    t: function(t, n, r, o) {
        var i = o._originalDate || t, s = Math.floor(i.getTime() / 1e3);
        return $24b824b09891b629$var$J(s, n.length);
    },
    // Milliseconds timestamp
    T: function(t, n, r, o) {
        var i = o._originalDate || t, s = i.getTime();
        return $24b824b09891b629$var$J(s, n.length);
    }
};
function $24b824b09891b629$var$zo(e, t) {
    var n = e > 0 ? '-' : '+', r = Math.abs(e), o = Math.floor(r / 60), i = r % 60;
    if (i === 0) return n + String(o);
    var s = t || '';
    return n + String(o) + s + $24b824b09891b629$var$J(i, 2);
}
function $24b824b09891b629$var$Jo(e, t) {
    if (e % 60 === 0) {
        var n = e > 0 ? '-' : '+';
        return n + $24b824b09891b629$var$J(Math.abs(e) / 60, 2);
    }
    return $24b824b09891b629$var$gt(e, t);
}
function $24b824b09891b629$var$gt(e, t) {
    var n = t || '', r = e > 0 ? '-' : '+', o = Math.abs(e), i = $24b824b09891b629$var$J(Math.floor(o / 60), 2), s = $24b824b09891b629$var$J(o % 60, 2);
    return r + i + n + s;
}
var $24b824b09891b629$var$Qo = function(t, n) {
    switch(t){
        case 'P':
            return n.date({
                width: 'short'
            });
        case 'PP':
            return n.date({
                width: 'medium'
            });
        case 'PPP':
            return n.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return n.date({
                width: 'full'
            });
    }
}, $24b824b09891b629$var$ws = function(t, n) {
    switch(t){
        case 'p':
            return n.time({
                width: 'short'
            });
        case 'pp':
            return n.time({
                width: 'medium'
            });
        case 'ppp':
            return n.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return n.time({
                width: 'full'
            });
    }
}, $24b824b09891b629$var$gc = function(t, n) {
    var r = t.match(/(P+)(p+)?/) || [], o = r[1], i = r[2];
    if (!i) return $24b824b09891b629$var$Qo(t, n);
    var s;
    switch(o){
        case 'P':
            s = n.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            s = n.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            s = n.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            s = n.dateTime({
                width: 'full'
            });
            break;
    }
    return s.replace('{{date}}', $24b824b09891b629$var$Qo(o, n)).replace('{{time}}', $24b824b09891b629$var$ws(i, n));
}, $24b824b09891b629$var$vc = {
    p: $24b824b09891b629$var$ws,
    P: $24b824b09891b629$var$gc
}, $24b824b09891b629$var$_c = [
    'D',
    'DD'
], $24b824b09891b629$var$yc = [
    'YY',
    'YYYY'
];
function $24b824b09891b629$var$bc(e) {
    return $24b824b09891b629$var$_c.indexOf(e) !== -1;
}
function $24b824b09891b629$var$wc(e) {
    return $24b824b09891b629$var$yc.indexOf(e) !== -1;
}
function $24b824b09891b629$var$Zo(e, t, n) {
    if (e === 'YYYY') throw new RangeError('Use `yyyy` instead of `YYYY` (in `'.concat(t, '`) for formatting years to the input `').concat(n, '`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md'));
    if (e === 'YY') throw new RangeError('Use `yy` instead of `YY` (in `'.concat(t, '`) for formatting years to the input `').concat(n, '`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md'));
    if (e === 'D') throw new RangeError('Use `d` instead of `D` (in `'.concat(t, '`) for formatting days of the month to the input `').concat(n, '`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md'));
    if (e === 'DD') throw new RangeError('Use `dd` instead of `DD` (in `'.concat(t, '`) for formatting days of the month to the input `').concat(n, '`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md'));
}
var $24b824b09891b629$var$Ec = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
}, $24b824b09891b629$var$Nc = function(t, n, r) {
    var o, i = $24b824b09891b629$var$Ec[t];
    return typeof i == 'string' ? o = i : n === 1 ? o = i.one : o = i.other.replace('{{count}}', n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? 'in ' + o : o + ' ago' : o;
};
const $24b824b09891b629$var$Oc = $24b824b09891b629$var$Nc;
function $24b824b09891b629$var$Ut(e) {
    return function() {
        var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.width ? String(t.width) : e.defaultWidth, r = e.formats[n] || e.formats[e.defaultWidth];
        return r;
    };
}
var $24b824b09891b629$var$Dc = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
}, $24b824b09891b629$var$$c = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
}, $24b824b09891b629$var$Cc = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
}, $24b824b09891b629$var$Tc = {
    date: $24b824b09891b629$var$Ut({
        formats: $24b824b09891b629$var$Dc,
        defaultWidth: 'full'
    }),
    time: $24b824b09891b629$var$Ut({
        formats: $24b824b09891b629$var$$c,
        defaultWidth: 'full'
    }),
    dateTime: $24b824b09891b629$var$Ut({
        formats: $24b824b09891b629$var$Cc,
        defaultWidth: 'full'
    })
};
const $24b824b09891b629$var$xc = $24b824b09891b629$var$Tc;
var $24b824b09891b629$var$Vc = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
}, $24b824b09891b629$var$Mc = function(t, n, r, o) {
    return $24b824b09891b629$var$Vc[t];
};
const $24b824b09891b629$var$Pc = $24b824b09891b629$var$Mc;
function $24b824b09891b629$var$Re(e) {
    return function(t, n) {
        var r = n != null && n.context ? String(n.context) : 'standalone', o;
        if (r === 'formatting' && e.formattingValues) {
            var i = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : i;
            o = e.formattingValues[s] || e.formattingValues[i];
        } else {
            var a = e.defaultWidth, u = n != null && n.width ? String(n.width) : e.defaultWidth;
            o = e.values[u] || e.values[a];
        }
        var d1 = e.argumentCallback ? e.argumentCallback(t) : t;
        return o[d1];
    };
}
var $24b824b09891b629$var$Sc = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
}, $24b824b09891b629$var$kc = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
}, $24b824b09891b629$var$Ic = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
}, $24b824b09891b629$var$Ac = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
}, $24b824b09891b629$var$Fc = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
}, $24b824b09891b629$var$Rc = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
}, $24b824b09891b629$var$Wc = function(t, n) {
    var r = Number(t), o = r % 100;
    if (o > 20 || o < 10) switch(o % 10){
        case 1:
            return r + 'st';
        case 2:
            return r + 'nd';
        case 3:
            return r + 'rd';
    }
    return r + 'th';
}, $24b824b09891b629$var$Lc = {
    ordinalNumber: $24b824b09891b629$var$Wc,
    era: $24b824b09891b629$var$Re({
        values: $24b824b09891b629$var$Sc,
        defaultWidth: 'wide'
    }),
    quarter: $24b824b09891b629$var$Re({
        values: $24b824b09891b629$var$kc,
        defaultWidth: 'wide',
        argumentCallback: function(t) {
            return t - 1;
        }
    }),
    month: $24b824b09891b629$var$Re({
        values: $24b824b09891b629$var$Ic,
        defaultWidth: 'wide'
    }),
    day: $24b824b09891b629$var$Re({
        values: $24b824b09891b629$var$Ac,
        defaultWidth: 'wide'
    }),
    dayPeriod: $24b824b09891b629$var$Re({
        values: $24b824b09891b629$var$Fc,
        defaultWidth: 'wide',
        formattingValues: $24b824b09891b629$var$Rc,
        defaultFormattingWidth: 'wide'
    })
};
const $24b824b09891b629$var$Uc = $24b824b09891b629$var$Lc;
function $24b824b09891b629$var$We(e) {
    return function(t) {
        var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(o);
        if (!i) return null;
        var s = i[0], a = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], u = Array.isArray(a) ? $24b824b09891b629$var$Hc(a, function(c) {
            return c.test(s);
        }) : $24b824b09891b629$var$jc(a, function(c) {
            return c.test(s);
        }), d1;
        d1 = e.valueCallback ? e.valueCallback(u) : u, d1 = n.valueCallback ? n.valueCallback(d1) : d1;
        var h = t.slice(s.length);
        return {
            value: d1,
            rest: h
        };
    };
}
function $24b824b09891b629$var$jc(e, t) {
    for(var n in e)if (e.hasOwnProperty(n) && t(e[n])) return n;
}
function $24b824b09891b629$var$Hc(e, t) {
    for(var n = 0; n < e.length; n++)if (t(e[n])) return n;
}
function $24b824b09891b629$var$Es(e) {
    return function(t) {
        var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.match(e.matchPattern);
        if (!r) return null;
        var o = r[0], i = t.match(e.parsePattern);
        if (!i) return null;
        var s = e.valueCallback ? e.valueCallback(i[0]) : i[0];
        s = n.valueCallback ? n.valueCallback(s) : s;
        var a = t.slice(o.length);
        return {
            value: s,
            rest: a
        };
    };
}
var $24b824b09891b629$var$Gc = /^(\d+)(th|st|nd|rd)?/i, $24b824b09891b629$var$Bc = /\d+/i, $24b824b09891b629$var$Yc = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
}, $24b824b09891b629$var$qc = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
}, $24b824b09891b629$var$Kc = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
}, $24b824b09891b629$var$Xc = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
}, $24b824b09891b629$var$zc = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, $24b824b09891b629$var$Jc = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
}, $24b824b09891b629$var$Qc = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, $24b824b09891b629$var$Zc = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
}, $24b824b09891b629$var$ef = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, $24b824b09891b629$var$tf = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
}, $24b824b09891b629$var$nf = {
    ordinalNumber: $24b824b09891b629$var$Es({
        matchPattern: $24b824b09891b629$var$Gc,
        parsePattern: $24b824b09891b629$var$Bc,
        valueCallback: function(t) {
            return parseInt(t, 10);
        }
    }),
    era: $24b824b09891b629$var$We({
        matchPatterns: $24b824b09891b629$var$Yc,
        defaultMatchWidth: 'wide',
        parsePatterns: $24b824b09891b629$var$qc,
        defaultParseWidth: 'any'
    }),
    quarter: $24b824b09891b629$var$We({
        matchPatterns: $24b824b09891b629$var$Kc,
        defaultMatchWidth: 'wide',
        parsePatterns: $24b824b09891b629$var$Xc,
        defaultParseWidth: 'any',
        valueCallback: function(t) {
            return t + 1;
        }
    }),
    month: $24b824b09891b629$var$We({
        matchPatterns: $24b824b09891b629$var$zc,
        defaultMatchWidth: 'wide',
        parsePatterns: $24b824b09891b629$var$Jc,
        defaultParseWidth: 'any'
    }),
    day: $24b824b09891b629$var$We({
        matchPatterns: $24b824b09891b629$var$Qc,
        defaultMatchWidth: 'wide',
        parsePatterns: $24b824b09891b629$var$Zc,
        defaultParseWidth: 'any'
    }),
    dayPeriod: $24b824b09891b629$var$We({
        matchPatterns: $24b824b09891b629$var$ef,
        defaultMatchWidth: 'any',
        parsePatterns: $24b824b09891b629$var$tf,
        defaultParseWidth: 'any'
    })
};
const $24b824b09891b629$var$rf = $24b824b09891b629$var$nf;
var $24b824b09891b629$var$of = {
    code: 'en-US',
    formatDistance: $24b824b09891b629$var$Oc,
    formatLong: $24b824b09891b629$var$xc,
    formatRelative: $24b824b09891b629$var$Pc,
    localize: $24b824b09891b629$var$Uc,
    match: $24b824b09891b629$var$rf,
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
const $24b824b09891b629$var$sf = $24b824b09891b629$var$of;
var $24b824b09891b629$var$af = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, $24b824b09891b629$var$lf = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, $24b824b09891b629$var$uf = /^'([^]*?)'?$/, $24b824b09891b629$var$cf = /''/g, $24b824b09891b629$var$ff = /[a-zA-Z]/;
function $24b824b09891b629$var$df(e, t, n) {
    var r, o, i, s, a, u, d1, h, c, m, N, T, P, L, X, j, A, F;
    $24b824b09891b629$var$_e(2, arguments);
    var B = String(t), Y = $24b824b09891b629$var$nr(), C = (r = (o = n?.locale) !== null && o !== void 0 ? o : Y.locale) !== null && r !== void 0 ? r : $24b824b09891b629$var$sf, K = $24b824b09891b629$var$xt((i = (s = (a = (u = n?.firstWeekContainsDate) !== null && u !== void 0 ? u : n == null || (d1 = n.locale) === null || d1 === void 0 || (h = d1.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && a !== void 0 ? a : Y.firstWeekContainsDate) !== null && s !== void 0 ? s : (c = Y.locale) === null || c === void 0 || (m = c.options) === null || m === void 0 ? void 0 : m.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
    if (!(K >= 1 && K <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var Q = $24b824b09891b629$var$xt((N = (T = (P = (L = n?.weekStartsOn) !== null && L !== void 0 ? L : n == null || (X = n.locale) === null || X === void 0 || (j = X.options) === null || j === void 0 ? void 0 : j.weekStartsOn) !== null && P !== void 0 ? P : Y.weekStartsOn) !== null && T !== void 0 ? T : (A = Y.locale) === null || A === void 0 || (F = A.options) === null || F === void 0 ? void 0 : F.weekStartsOn) !== null && N !== void 0 ? N : 0);
    if (!(Q >= 0 && Q <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!C.localize) throw new RangeError('locale must contain localize property');
    if (!C.formatLong) throw new RangeError('locale must contain formatLong property');
    var ue = $24b824b09891b629$var$je(e);
    if (!$24b824b09891b629$var$oc(ue)) throw new RangeError('Invalid time value');
    var ye = $24b824b09891b629$var$nc(ue), Ce = $24b824b09891b629$var$ic(ue, ye), Vt = {
        firstWeekContainsDate: K,
        weekStartsOn: Q,
        locale: C,
        _originalDate: ue
    }, gn = B.match($24b824b09891b629$var$lf).map(function(ie) {
        var oe = ie[0];
        if (oe === 'p' || oe === 'P') {
            var W = $24b824b09891b629$var$vc[oe];
            return W(ie, C.formatLong);
        }
        return ie;
    }).join('').match($24b824b09891b629$var$af).map(function(ie) {
        if (ie === "''") return "'";
        var oe = ie[0];
        if (oe === "'") return $24b824b09891b629$var$pf(ie);
        var W = $24b824b09891b629$var$mc[oe];
        if (W) return !(n != null && n.useAdditionalWeekYearTokens) && $24b824b09891b629$var$wc(ie) && $24b824b09891b629$var$Zo(ie, t, String(e)), !(n != null && n.useAdditionalDayOfYearTokens) && $24b824b09891b629$var$bc(ie) && $24b824b09891b629$var$Zo(ie, t, String(e)), W(Ce, ie, C.localize, Vt);
        if (oe.match($24b824b09891b629$var$ff)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + oe + '`');
        return ie;
    }).join('');
    return gn;
}
function $24b824b09891b629$var$pf(e) {
    var t = e.match($24b824b09891b629$var$uf);
    return t ? t[1].replace($24b824b09891b629$var$cf, "'") : e;
}
function $24b824b09891b629$var$ei(e, t, n) {
    $24b824b09891b629$var$_e(2, arguments);
    var r = $24b824b09891b629$var$Gt(e, n), o = $24b824b09891b629$var$Gt(t, n);
    return r.getTime() === o.getTime();
}
function $24b824b09891b629$var$Zt(e, t) {
    if (e.one !== void 0 && t === 1) return e.one;
    var n = t % 10, r = t % 100;
    return n === 1 && r !== 11 ? e.singularNominative.replace('{{count}}', String(t)) : n >= 2 && n <= 4 && (r < 10 || r > 20) ? e.singularGenitive.replace('{{count}}', String(t)) : e.pluralGenitive.replace('{{count}}', String(t));
}
function $24b824b09891b629$var$we(e) {
    return function(t, n) {
        return n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? e.future ? $24b824b09891b629$var$Zt(e.future, t) : "\u0447\u0435\u0440\u0435\u0437 " + $24b824b09891b629$var$Zt(e.regular, t) : e.past ? $24b824b09891b629$var$Zt(e.past, t) : $24b824b09891b629$var$Zt(e.regular, t) + " \u043D\u0430\u0437\u0430\u0434" : $24b824b09891b629$var$Zt(e.regular, t);
    };
}
var $24b824b09891b629$var$hf = {
    lessThanXSeconds: $24b824b09891b629$var$we({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $24b824b09891b629$var$we({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: function(t, n) {
        return n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "\u0447\u0435\u0440\u0435\u0437 \u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B" : "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434" : "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
    },
    lessThanXMinutes: $24b824b09891b629$var$we({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u043C\u0438\u043D\u0443\u0442\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u043C\u0438\u043D\u0443\u0442\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    xMinutes: $24b824b09891b629$var$we({
        regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    aboutXHours: $24b824b09891b629$var$we({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xHours: $24b824b09891b629$var$we({
        regular: {
            singularNominative: "{{count}} \u0447\u0430\u0441",
            singularGenitive: "{{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "{{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xDays: $24b824b09891b629$var$we({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u044F",
            pluralGenitive: "{{count}} \u0434\u043D\u0435\u0439"
        }
    }),
    aboutXWeeks: $24b824b09891b629$var$we({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044E",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    xWeeks: $24b824b09891b629$var$we({
        regular: {
            singularNominative: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044F",
            singularGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    aboutXMonths: $24b824b09891b629$var$we({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    xMonths: $24b824b09891b629$var$we({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    aboutXYears: $24b824b09891b629$var$we({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    xYears: $24b824b09891b629$var$we({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "{{count}} \u043B\u0435\u0442"
        }
    }),
    overXYears: $24b824b09891b629$var$we({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    almostXYears: $24b824b09891b629$var$we({
        regular: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    })
}, $24b824b09891b629$var$mf = function(t, n, r) {
    return $24b824b09891b629$var$hf[t](n, r);
};
const $24b824b09891b629$var$gf = $24b824b09891b629$var$mf;
var $24b824b09891b629$var$vf = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: 'dd.MM.y'
}, $24b824b09891b629$var$_f = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
}, $24b824b09891b629$var$yf = {
    any: '{{date}}, {{time}}'
}, $24b824b09891b629$var$bf = {
    date: $24b824b09891b629$var$Ut({
        formats: $24b824b09891b629$var$vf,
        defaultWidth: 'full'
    }),
    time: $24b824b09891b629$var$Ut({
        formats: $24b824b09891b629$var$_f,
        defaultWidth: 'full'
    }),
    dateTime: $24b824b09891b629$var$Ut({
        formats: $24b824b09891b629$var$yf,
        defaultWidth: 'any'
    })
};
const $24b824b09891b629$var$wf = $24b824b09891b629$var$bf;
var $24b824b09891b629$var$ao = [
    "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
    "\u043F\u044F\u0442\u043D\u0438\u0446\u0443",
    "\u0441\u0443\u0431\u0431\u043E\u0442\u0443"
];
function $24b824b09891b629$var$Ef(e) {
    var t = $24b824b09891b629$var$ao[e];
    switch(e){
        case 0:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u0435 " + t + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u044B\u0439 " + t + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u0443\u044E " + t + " \u0432' p";
    }
}
function $24b824b09891b629$var$ti(e) {
    var t = $24b824b09891b629$var$ao[e];
    return e === 2 ? "'\u0432\u043E " + t + " \u0432' p" : "'\u0432 " + t + " \u0432' p";
}
function $24b824b09891b629$var$Nf(e) {
    var t = $24b824b09891b629$var$ao[e];
    switch(e){
        case 0:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435 " + t + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 " + t + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E " + t + " \u0432' p";
    }
}
var $24b824b09891b629$var$Of = {
    lastWeek: function(t, n, r) {
        var o = t.getUTCDay();
        return $24b824b09891b629$var$ei(t, n, r) ? $24b824b09891b629$var$ti(o) : $24b824b09891b629$var$Ef(o);
    },
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
    today: "'\u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0432' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u0432' p",
    nextWeek: function(t, n, r) {
        var o = t.getUTCDay();
        return $24b824b09891b629$var$ei(t, n, r) ? $24b824b09891b629$var$ti(o) : $24b824b09891b629$var$Nf(o);
    },
    other: 'P'
}, $24b824b09891b629$var$Df = function(t, n, r, o) {
    var i = $24b824b09891b629$var$Of[t];
    return typeof i == 'function' ? i(n, r, o) : i;
};
const $24b824b09891b629$var$$f = $24b824b09891b629$var$Df;
var $24b824b09891b629$var$Cf = {
    narrow: [
        "\u0434\u043E \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B"
    ]
}, $24b824b09891b629$var$Tf = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
}, $24b824b09891b629$var$xf = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044C",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044C",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0435\u043B\u044C",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044C",
        "\u043D\u043E\u044F\u0431\u0440\u044C",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044C"
    ]
}, $24b824b09891b629$var$Vf = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440.",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D.",
        "\u0438\u044E\u043B.",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044F",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044F",
        "\u043C\u0430\u0440\u0442\u0430",
        "\u0430\u043F\u0440\u0435\u043B\u044F",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D\u044F",
        "\u0438\u044E\u043B\u044F",
        "\u0430\u0432\u0433\u0443\u0441\u0442\u0430",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044F",
        "\u043D\u043E\u044F\u0431\u0440\u044F",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044F"
    ]
}, $24b824b09891b629$var$Mf = {
    narrow: [
        "\u0412",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u0432\u0441",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u0432\u0441\u043A",
        "\u043F\u043D\u0434",
        "\u0432\u0442\u0440",
        "\u0441\u0440\u0434",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
        "\u043F\u044F\u0442\u043D\u0438\u0446\u0430",
        "\u0441\u0443\u0431\u0431\u043E\u0442\u0430"
    ]
}, $24b824b09891b629$var$Pf = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u0447\u044C"
    }
}, $24b824b09891b629$var$Sf = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0430",
        night: "\u043D\u043E\u0447\u0438"
    }
}, $24b824b09891b629$var$kf = function(t, n) {
    var r = Number(t), o = n?.unit, i;
    return o === 'date' ? i = "-\u0435" : o === 'week' || o === 'minute' || o === 'second' ? i = "-\u044F" : i = "-\u0439", r + i;
}, $24b824b09891b629$var$If = {
    ordinalNumber: $24b824b09891b629$var$kf,
    era: $24b824b09891b629$var$Re({
        values: $24b824b09891b629$var$Cf,
        defaultWidth: 'wide'
    }),
    quarter: $24b824b09891b629$var$Re({
        values: $24b824b09891b629$var$Tf,
        defaultWidth: 'wide',
        argumentCallback: function(t) {
            return t - 1;
        }
    }),
    month: $24b824b09891b629$var$Re({
        values: $24b824b09891b629$var$xf,
        defaultWidth: 'wide',
        formattingValues: $24b824b09891b629$var$Vf,
        defaultFormattingWidth: 'wide'
    }),
    day: $24b824b09891b629$var$Re({
        values: $24b824b09891b629$var$Mf,
        defaultWidth: 'wide'
    }),
    dayPeriod: $24b824b09891b629$var$Re({
        values: $24b824b09891b629$var$Pf,
        defaultWidth: 'any',
        formattingValues: $24b824b09891b629$var$Sf,
        defaultFormattingWidth: 'wide'
    })
};
const $24b824b09891b629$var$Af = $24b824b09891b629$var$If;
var $24b824b09891b629$var$Ff = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i, $24b824b09891b629$var$Rf = /\d+/i, $24b824b09891b629$var$Wf = {
    narrow: /^((до )?н\.?\s?э\.?)/i,
    abbreviated: /^((до )?н\.?\s?э\.?)/i,
    wide: /^(до нашей эры|нашей эры|наша эра)/i
}, $24b824b09891b629$var$Lf = {
    any: [
        /^д/i,
        /^н/i
    ]
}, $24b824b09891b629$var$Uf = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
    wide: /^[1234](-?[ыои]?й?)? квартал/i
}, $24b824b09891b629$var$jf = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
}, $24b824b09891b629$var$Hf = {
    narrow: /^[яфмаисонд]/i,
    abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
    wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
}, $24b824b09891b629$var$Gf = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^я/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
}, $24b824b09891b629$var$Bf = {
    narrow: /^[впсч]/i,
    short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
    abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
    wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
}, $24b824b09891b629$var$Yf = {
    narrow: [
        /^в/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^в[ос]/i,
        /^п[он]/i,
        /^в/i,
        /^ср/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
}, $24b824b09891b629$var$qf = {
    narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
}, $24b824b09891b629$var$Kf = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^полн/i,
        noon: /^полд/i,
        morning: /^у/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
}, $24b824b09891b629$var$Xf = {
    ordinalNumber: $24b824b09891b629$var$Es({
        matchPattern: $24b824b09891b629$var$Ff,
        parsePattern: $24b824b09891b629$var$Rf,
        valueCallback: function(t) {
            return parseInt(t, 10);
        }
    }),
    era: $24b824b09891b629$var$We({
        matchPatterns: $24b824b09891b629$var$Wf,
        defaultMatchWidth: 'wide',
        parsePatterns: $24b824b09891b629$var$Lf,
        defaultParseWidth: 'any'
    }),
    quarter: $24b824b09891b629$var$We({
        matchPatterns: $24b824b09891b629$var$Uf,
        defaultMatchWidth: 'wide',
        parsePatterns: $24b824b09891b629$var$jf,
        defaultParseWidth: 'any',
        valueCallback: function(t) {
            return t + 1;
        }
    }),
    month: $24b824b09891b629$var$We({
        matchPatterns: $24b824b09891b629$var$Hf,
        defaultMatchWidth: 'wide',
        parsePatterns: $24b824b09891b629$var$Gf,
        defaultParseWidth: 'any'
    }),
    day: $24b824b09891b629$var$We({
        matchPatterns: $24b824b09891b629$var$Bf,
        defaultMatchWidth: 'wide',
        parsePatterns: $24b824b09891b629$var$Yf,
        defaultParseWidth: 'any'
    }),
    dayPeriod: $24b824b09891b629$var$We({
        matchPatterns: $24b824b09891b629$var$qf,
        defaultMatchWidth: 'wide',
        parsePatterns: $24b824b09891b629$var$Kf,
        defaultParseWidth: 'any'
    })
};
const $24b824b09891b629$var$zf = $24b824b09891b629$var$Xf;
var $24b824b09891b629$var$Jf = {
    code: 'ru',
    formatDistance: $24b824b09891b629$var$gf,
    formatLong: $24b824b09891b629$var$wf,
    formatRelative: $24b824b09891b629$var$$f,
    localize: $24b824b09891b629$var$Af,
    match: $24b824b09891b629$var$zf,
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};
const $24b824b09891b629$var$Qf = $24b824b09891b629$var$Jf, $24b824b09891b629$var$Zf = (e)=>new Intl.NumberFormat('ru-RU', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(e), $24b824b09891b629$var$ed = (e)=>new Intl.NumberFormat('ru-RU', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(e), $24b824b09891b629$var$rr = (e)=>Number.isInteger(e) ? $24b824b09891b629$var$ed(e) : $24b824b09891b629$var$Zf(e), $24b824b09891b629$var$td = (e)=>$24b824b09891b629$var$df(new Date(e), 'd MMMM', {
        locale: $24b824b09891b629$var$Qf
    }), $24b824b09891b629$var$nd = {
    name: 'IInfo'
}, $24b824b09891b629$var$rd = {
    width: '17',
    height: '18',
    viewBox: '0 0 17 18',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
}, $24b824b09891b629$var$od = /* @__PURE__ */ $24b824b09891b629$var$I('path', {
    d: 'M7.999 6.334a.833.833 0 100-1.667.833.833 0 000 1.667z',
    fill: 'currentColor'
}, null, -1), $24b824b09891b629$var$id = /* @__PURE__ */ $24b824b09891b629$var$I('path', {
    d: 'M8 8v5',
    stroke: 'currentColor',
    'stroke-width': '1.5',
    'stroke-linecap': 'round'
}, null, -1), $24b824b09891b629$var$sd = /* @__PURE__ */ $24b824b09891b629$var$I('path', {
    d: 'M2.813 14.186a7.333 7.333 0 1110.371-10.37 7.333 7.333 0 01-10.37 10.37',
    stroke: 'currentColor',
    'stroke-width': '1.5'
}, null, -1), $24b824b09891b629$var$ad = [
    $24b824b09891b629$var$od,
    $24b824b09891b629$var$id,
    $24b824b09891b629$var$sd
];
function $24b824b09891b629$var$ld(e, t, n, r, o, i) {
    return $24b824b09891b629$var$te(), $24b824b09891b629$var$fe('svg', $24b824b09891b629$var$rd, $24b824b09891b629$var$ad);
}
const $24b824b09891b629$var$Ns = /* @__PURE__ */ $24b824b09891b629$var$$e($24b824b09891b629$var$nd, [
    [
        'render',
        $24b824b09891b629$var$ld
    ]
]), $24b824b09891b629$var$ud = '_root_16fmr_1', $24b824b09891b629$var$cd = '_dark_16fmr_10', $24b824b09891b629$var$fd = '_text_16fmr_15', $24b824b09891b629$var$dd = '_link_16fmr_22', $24b824b09891b629$var$pd = {
    root: $24b824b09891b629$var$ud,
    dark: $24b824b09891b629$var$cd,
    text: $24b824b09891b629$var$fd,
    link: $24b824b09891b629$var$dd
}, $24b824b09891b629$var$hd = {
    __name: 'BnplWidgetTwo',
    props: {
        params: Object
    },
    setup (e) {
        const t = e, n = $24b824b09891b629$var$Tt(()=>`4 \u{43F}\u{43B}\u{430}\u{442}\u{435}\u{436}\u{430} \u{43F}\u{43E} ${$24b824b09891b629$var$rr(Math.round(t.params.price / 4))} \u{20BD}`);
        return (r, o)=>($24b824b09891b629$var$te(), $24b824b09891b629$var$fe('div', {
                class: $24b824b09891b629$var$U([
                    r.$style.root,
                    t.params.isDarkTheme && r.$style.dark
                ])
            }, [
                $24b824b09891b629$var$I('span', {
                    class: $24b824b09891b629$var$U(r.$style.text)
                }, "\u0434\u0430\u0432\u0430\u0439 \u0434\u0435\u043B\u0438\u0442\u044C", 2),
                $24b824b09891b629$var$I('div', {
                    class: $24b824b09891b629$var$U(r.$style.link)
                }, [
                    $24b824b09891b629$var$I('span', null, $24b824b09891b629$var$jt(n.value), 1),
                    $24b824b09891b629$var$pe($24b824b09891b629$var$Ns)
                ], 2)
            ], 2));
    }
}, $24b824b09891b629$var$md = {
    $style: $24b824b09891b629$var$pd
}, $24b824b09891b629$var$gd = /* @__PURE__ */ $24b824b09891b629$var$$e($24b824b09891b629$var$hd, [
    [
        '__cssModules',
        $24b824b09891b629$var$md
    ]
]), $24b824b09891b629$var$vd = '_root_1u9kw_1', $24b824b09891b629$var$_d = '_dark_1u9kw_11', $24b824b09891b629$var$yd = '_text_1u9kw_17', $24b824b09891b629$var$bd = '_link_1u9kw_24', $24b824b09891b629$var$wd = {
    root: $24b824b09891b629$var$vd,
    dark: $24b824b09891b629$var$_d,
    text: $24b824b09891b629$var$yd,
    link: $24b824b09891b629$var$bd
}, $24b824b09891b629$var$Ed = {
    __name: 'BnplWidgetThree',
    props: {
        params: Object
    },
    setup (e) {
        const t = e, n = $24b824b09891b629$var$Tt(()=>`4 \u{43F}\u{43B}\u{430}\u{442}\u{435}\u{436}\u{430} \u{43F}\u{43E} ${$24b824b09891b629$var$rr(Math.round(t.params.price / 4))} \u{20BD}`);
        return (r, o)=>($24b824b09891b629$var$te(), $24b824b09891b629$var$fe('div', {
                class: $24b824b09891b629$var$U([
                    r.$style.root,
                    t.params.isDarkTheme && r.$style.dark
                ])
            }, [
                $24b824b09891b629$var$I('span', {
                    class: $24b824b09891b629$var$U(r.$style.text)
                }, "\u0434\u0430\u0432\u0430\u0439 \u0434\u0435\u043B\u0438\u0442\u044C", 2),
                $24b824b09891b629$var$I('div', {
                    class: $24b824b09891b629$var$U(r.$style.link)
                }, [
                    $24b824b09891b629$var$I('span', null, $24b824b09891b629$var$jt(n.value), 1),
                    $24b824b09891b629$var$pe($24b824b09891b629$var$Ns)
                ], 2)
            ], 2));
    }
}, $24b824b09891b629$var$Nd = {
    $style: $24b824b09891b629$var$wd
}, $24b824b09891b629$var$Od = /* @__PURE__ */ $24b824b09891b629$var$$e($24b824b09891b629$var$Ed, [
    [
        '__cssModules',
        $24b824b09891b629$var$Nd
    ]
]), $24b824b09891b629$var$Dd = {
    name: 'IChart'
}, $24b824b09891b629$var$$d = {
    fill: 'none',
    height: '68',
    viewBox: '0 0 68 68',
    width: '68',
    xmlns: 'http://www.w3.org/2000/svg'
}, $24b824b09891b629$var$Cd = /* @__PURE__ */ $24b824b09891b629$var$I('circle', {
    cx: '34',
    cy: '34',
    fill: '#9E6FC3',
    r: '34'
}, null, -1), $24b824b09891b629$var$Td = /* @__PURE__ */ $24b824b09891b629$var$I('path', {
    d: 'M45.1306 35.969C44.1464 41.1627 39.5861 45.1024 34.1102 45.1024C27.9248 45.1024 22.8896 40.0633 22.8896 33.8732C22.8896 28.3817 26.8377 23.8064 32.0446 22.8329V19.9011C25.2355 20.9089 20 26.7898 20 33.8789C20 41.6666 26.3284 47.9999 34.1102 47.9999C41.1767 47.9999 47.0474 42.7775 48.0659 35.9747H45.1306V35.969Z',
    fill: 'white'
}, null, -1), $24b824b09891b629$var$xd = /* @__PURE__ */ $24b824b09891b629$var$I('path', {
    d: 'M50 32.121C50 32.6077 49.9771 33.0887 49.9256 33.564H35.8898L34.4479 32.121V18.0744C34.9228 18.0229 35.4034 18 35.8898 18C36.3762 18 36.8625 18.0229 37.3317 18.0744C43.9634 18.7501 49.2504 24.0469 49.9256 30.6779C49.9771 31.1532 50 31.6285 50 32.121Z',
    fill: 'white'
}, null, -1), $24b824b09891b629$var$Vd = [
    $24b824b09891b629$var$Cd,
    $24b824b09891b629$var$Td,
    $24b824b09891b629$var$xd
];
function $24b824b09891b629$var$Md(e, t, n, r, o, i) {
    return $24b824b09891b629$var$te(), $24b824b09891b629$var$fe('svg', $24b824b09891b629$var$$d, $24b824b09891b629$var$Vd);
}
const $24b824b09891b629$var$Pd = /* @__PURE__ */ $24b824b09891b629$var$$e($24b824b09891b629$var$Dd, [
    [
        'render',
        $24b824b09891b629$var$Md
    ]
]), $24b824b09891b629$var$Sd = '_root_1cs5x_1', $24b824b09891b629$var$kd = '_dark_1cs5x_13', $24b824b09891b629$var$Id = '_container_1cs5x_19', $24b824b09891b629$var$Ad = '_text_1cs5x_25', $24b824b09891b629$var$Fd = '_sumPay_1cs5x_32', $24b824b09891b629$var$Rd = '_link_1cs5x_39', $24b824b09891b629$var$Wd = {
    root: $24b824b09891b629$var$Sd,
    dark: $24b824b09891b629$var$kd,
    container: $24b824b09891b629$var$Id,
    text: $24b824b09891b629$var$Ad,
    sumPay: $24b824b09891b629$var$Fd,
    link: $24b824b09891b629$var$Rd
}, $24b824b09891b629$var$Ld = {
    __name: 'BnplWidgetFour',
    props: {
        params: Object
    },
    setup (e) {
        const t = e, n = $24b824b09891b629$var$Tt(()=>`4 \u{43F}\u{43B}\u{430}\u{442}\u{435}\u{436}\u{430} \u{43F}\u{43E} ${$24b824b09891b629$var$rr(Math.round(t.params.price / 4))} \u{20BD}`);
        return (r, o)=>($24b824b09891b629$var$te(), $24b824b09891b629$var$fe('div', {
                class: $24b824b09891b629$var$U([
                    r.$style.root,
                    t.params.isDarkTheme && r.$style.dark
                ])
            }, [
                $24b824b09891b629$var$pe($24b824b09891b629$var$Pd),
                $24b824b09891b629$var$I('div', {
                    class: $24b824b09891b629$var$U(r.$style.container)
                }, [
                    $24b824b09891b629$var$I('span', {
                        class: $24b824b09891b629$var$U(r.$style.text)
                    }, "\u0434\u0430\u0432\u0430\u0439 \u0434\u0435\u043B\u0438\u0442\u044C", 2),
                    $24b824b09891b629$var$I('span', {
                        class: $24b824b09891b629$var$U(r.$style.sumPay)
                    }, $24b824b09891b629$var$jt(n.value), 3),
                    $24b824b09891b629$var$I('span', {
                        class: $24b824b09891b629$var$U(r.$style.link)
                    }, "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435", 2)
                ], 2)
            ], 2));
    }
}, $24b824b09891b629$var$Ud = {
    $style: $24b824b09891b629$var$Wd
}, $24b824b09891b629$var$jd = /* @__PURE__ */ $24b824b09891b629$var$$e($24b824b09891b629$var$Ld, [
    [
        '__cssModules',
        $24b824b09891b629$var$Ud
    ]
]), $24b824b09891b629$var$Hd = {
    name: 'IChartSmall'
}, $24b824b09891b629$var$Gd = {
    fill: 'none',
    height: '20',
    viewBox: '0 0 16 20',
    width: '16',
    xmlns: 'http://www.w3.org/2000/svg'
}, $24b824b09891b629$var$Bd = /* @__PURE__ */ $24b824b09891b629$var$I('path', {
    d: 'M13.403 12.0835C12.8781 14.8535 10.4459 16.9546 7.52546 16.9546C4.22659 16.9546 1.54111 14.2671 1.54111 10.9657C1.54111 8.03692 3.64677 5.59676 6.42381 5.07757V3.51392C2.7923 4.05142 0 7.1879 0 10.9688C0 15.1222 3.37517 18.5 7.52546 18.5C11.2943 18.5 14.4253 15.7147 14.9685 12.0865H13.403V12.0835Z',
    fill: 'currentColor'
}, null, -1), $24b824b09891b629$var$Yd = /* @__PURE__ */ $24b824b09891b629$var$I('path', {
    d: 'M16 10.0312C16 10.2908 15.9878 10.5473 15.9603 10.8008H8.47454L7.70551 10.0312V2.5397C7.9588 2.51222 8.21514 2.5 8.47454 2.5C8.73393 2.5 8.99332 2.51222 9.24356 2.5397C12.7805 2.90008 15.6002 5.72504 15.9603 9.26159C15.9878 9.51508 16 9.76857 16 10.0312Z',
    fill: 'currentColor'
}, null, -1), $24b824b09891b629$var$qd = [
    $24b824b09891b629$var$Bd,
    $24b824b09891b629$var$Yd
];
function $24b824b09891b629$var$Kd(e, t, n, r, o, i) {
    return $24b824b09891b629$var$te(), $24b824b09891b629$var$fe('svg', $24b824b09891b629$var$Gd, $24b824b09891b629$var$qd);
}
const $24b824b09891b629$var$Xd = /* @__PURE__ */ $24b824b09891b629$var$$e($24b824b09891b629$var$Hd, [
    [
        'render',
        $24b824b09891b629$var$Kd
    ]
]), $24b824b09891b629$var$zd = '_root_1a58k_1', $24b824b09891b629$var$Jd = '_dark_1a58k_5', $24b824b09891b629$var$Qd = '_line_1a58k_9', $24b824b09891b629$var$Zd = '_sum_1a58k_15', $24b824b09891b629$var$ep = '_active_1a58k_22', $24b824b09891b629$var$tp = {
    root: $24b824b09891b629$var$zd,
    dark: $24b824b09891b629$var$Jd,
    line: $24b824b09891b629$var$Qd,
    sum: $24b824b09891b629$var$Zd,
    active: $24b824b09891b629$var$ep
}, $24b824b09891b629$var$np = {
    __name: 'ScheduleItem',
    props: {
        item: Object,
        isDarkTheme: Boolean
    },
    setup (e) {
        return (t, n)=>($24b824b09891b629$var$te(), $24b824b09891b629$var$fe('div', {
                class: $24b824b09891b629$var$U([
                    t.$style.root,
                    e.item.isActive && t.$style.active,
                    e.isDarkTheme && t.$style.dark
                ])
            }, [
                $24b824b09891b629$var$I('div', {
                    class: $24b824b09891b629$var$U(t.$style.line)
                }, null, 2),
                $24b824b09891b629$var$I('div', null, $24b824b09891b629$var$jt(e.item.date), 1),
                $24b824b09891b629$var$I('div', {
                    class: $24b824b09891b629$var$U(t.$style.sum)
                }, $24b824b09891b629$var$jt(e.item.sum), 3)
            ], 2));
    }
}, $24b824b09891b629$var$rp = {
    $style: $24b824b09891b629$var$tp
}, $24b824b09891b629$var$op = /* @__PURE__ */ $24b824b09891b629$var$$e($24b824b09891b629$var$np, [
    [
        '__cssModules',
        $24b824b09891b629$var$rp
    ]
]), $24b824b09891b629$var$ip = '_root_w28u7_1', $24b824b09891b629$var$sp = '_dark_w28u7_9', $24b824b09891b629$var$ap = '_icon_w28u7_14', $24b824b09891b629$var$lp = '_title_container_w28u7_18', $24b824b09891b629$var$up = '_title_w28u7_18', $24b824b09891b629$var$cp = '_schedule_w28u7_33', $24b824b09891b629$var$fp = {
    root: $24b824b09891b629$var$ip,
    dark: $24b824b09891b629$var$sp,
    icon: $24b824b09891b629$var$ap,
    title_container: $24b824b09891b629$var$lp,
    title: $24b824b09891b629$var$up,
    schedule: $24b824b09891b629$var$cp
}, $24b824b09891b629$var$dp = /* @__PURE__ */ $24b824b09891b629$var$I('span', null, "\u0434\u0430\u0432\u0430\u0439 \u0434\u0435\u043B\u0438\u0442\u044C", -1), $24b824b09891b629$var$ni = 4, $24b824b09891b629$var$pp = {
    __name: 'BnplWidgetFive',
    props: {
        params: Object
    },
    setup (e) {
        const t = e, n = $24b824b09891b629$var$Tt(()=>o(/* @__PURE__ */ new Date(), 4, !0)), r = $24b824b09891b629$var$Tt(()=>`${$24b824b09891b629$var$rr(t.params.price)} \u{20BD}`);
        function o(i, s, a = !1) {
            if (s <= 0) return [];
            const u = a ? "\u0421\u0435\u0433\u043E\u0434\u043D\u044F" : $24b824b09891b629$var$td(i).slice(0, 6), d1 = new Date(i.getTime() + 1209600000), h = Math.round(t.params.price / $24b824b09891b629$var$ni), c = t.params.price - h * ($24b824b09891b629$var$ni - 1), m = c % 1 !== 0 ? c.toFixed(2) : c, N = s > 1 ? `${h} \u{20BD}` : `${m} \u{20BD}`;
            return [
                {
                    date: u,
                    sum: N,
                    isActive: a
                },
                ...o(d1, s - 1)
            ];
        }
        return (i, s)=>($24b824b09891b629$var$te(), $24b824b09891b629$var$fe('div', {
                class: $24b824b09891b629$var$U([
                    i.$style.root,
                    t.params.isDarkTheme && i.$style.dark
                ])
            }, [
                $24b824b09891b629$var$I('div', {
                    class: $24b824b09891b629$var$U(i.$style.title_container)
                }, [
                    $24b824b09891b629$var$I('div', {
                        class: $24b824b09891b629$var$U(i.$style.title)
                    }, [
                        $24b824b09891b629$var$pe($24b824b09891b629$var$Xd, {
                            class: $24b824b09891b629$var$U(i.$style.icon)
                        }, null, 8, [
                            'class'
                        ]),
                        $24b824b09891b629$var$dp
                    ], 2),
                    $24b824b09891b629$var$I('div', null, $24b824b09891b629$var$jt(r.value), 1)
                ], 2),
                $24b824b09891b629$var$I('div', {
                    class: $24b824b09891b629$var$U(i.$style.schedule)
                }, [
                    ($24b824b09891b629$var$te(!0), $24b824b09891b629$var$fe($24b824b09891b629$var$Oe, null, $24b824b09891b629$var$pl(n.value, (a, u)=>($24b824b09891b629$var$te(), $24b824b09891b629$var$ut($24b824b09891b629$var$op, {
                            key: u,
                            'is-dark-theme': t.params.isDarkTheme,
                            item: a
                        }, null, 8, [
                            'is-dark-theme',
                            'item'
                        ]))), 128))
                ], 2)
            ], 2));
    }
}, $24b824b09891b629$var$hp = {
    $style: $24b824b09891b629$var$fp
}, $24b824b09891b629$var$Os = /* @__PURE__ */ $24b824b09891b629$var$$e($24b824b09891b629$var$pp, [
    [
        '__cssModules',
        $24b824b09891b629$var$hp
    ]
]), $24b824b09891b629$var$mp = '_wide_15mzm_1', $24b824b09891b629$var$gp = {
    wide: $24b824b09891b629$var$mp
}, $24b824b09891b629$var$vp = /* @__PURE__ */ $24b824b09891b629$var$el({
    components: {
        BnplWidgetOne: $24b824b09891b629$var$Zu,
        BnplWidgetTwo: $24b824b09891b629$var$gd,
        BnplWidgetThree: $24b824b09891b629$var$Od,
        BnplWidgetFour: $24b824b09891b629$var$jd,
        BnplWidgetFive: $24b824b09891b629$var$Os
    },
    props: {
        dataParams: {
            type: Object
        }
    },
    setup (e) {
        const t = $24b824b09891b629$var$Yt(window.widgetParams || e.dataParams || {});
        return window.updateWidgetParams = (n)=>{
            Object.assign(t, n);
        }, {
            params: t
        };
    }
});
function $24b824b09891b629$var$_p(e, t, n, r, o, i) {
    return e.params ? ($24b824b09891b629$var$te(), $24b824b09891b629$var$ut($24b824b09891b629$var$Ya(e.params.view), {
        key: 0,
        class: $24b824b09891b629$var$U([
            e.params?.wide && e.$style.wide
        ]),
        params: e.params
    }, null, 8, [
        'class',
        'params'
    ])) : $24b824b09891b629$var$_t('', !0);
}
const $24b824b09891b629$var$yp = {
    $style: $24b824b09891b629$var$gp
}, $24b824b09891b629$var$bp = /* @__PURE__ */ $24b824b09891b629$var$$e($24b824b09891b629$var$vp, [
    [
        'render',
        $24b824b09891b629$var$_p
    ],
    [
        '__cssModules',
        $24b824b09891b629$var$yp
    ]
]), $24b824b09891b629$var$wp = {}, $24b824b09891b629$var$Ep = {
    width: '24',
    height: '24',
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
}, $24b824b09891b629$var$Np = /* @__PURE__ */ $24b824b09891b629$var$I('path', {
    d: 'M4 20L20 4',
    stroke: 'currentColor',
    'stroke-width': '2',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round'
}, null, -1), $24b824b09891b629$var$Op = /* @__PURE__ */ $24b824b09891b629$var$I('path', {
    d: 'M20 20L4 4',
    stroke: 'currentColor',
    'stroke-width': '2',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round'
}, null, -1), $24b824b09891b629$var$Dp = [
    $24b824b09891b629$var$Np,
    $24b824b09891b629$var$Op
];
function $24b824b09891b629$var$$p(e, t) {
    return $24b824b09891b629$var$te(), $24b824b09891b629$var$fe('svg', $24b824b09891b629$var$Ep, $24b824b09891b629$var$Dp);
}
const $24b824b09891b629$var$Cp = /* @__PURE__ */ $24b824b09891b629$var$$e($24b824b09891b629$var$wp, [
    [
        'render',
        $24b824b09891b629$var$$p
    ]
]), $24b824b09891b629$var$Tp = '_root_1hact_1', $24b824b09891b629$var$xp = '_dark_1hact_16', $24b824b09891b629$var$Vp = '_inner_1hact_16', $24b824b09891b629$var$Mp = '_description_1hact_17', $24b824b09891b629$var$Pp = '_title_1hact_18', $24b824b09891b629$var$Sp = '_header_1hact_19', $24b824b09891b629$var$kp = '_content_1hact_20', $24b824b09891b629$var$Ip = '_container_1hact_67', $24b824b09891b629$var$Ap = '_footer_1hact_88', $24b824b09891b629$var$Fp = '_close_1hact_94', $24b824b09891b629$var$Rp = {
    root: $24b824b09891b629$var$Tp,
    dark: $24b824b09891b629$var$xp,
    inner: $24b824b09891b629$var$Vp,
    description: $24b824b09891b629$var$Mp,
    title: $24b824b09891b629$var$Pp,
    header: $24b824b09891b629$var$Sp,
    content: $24b824b09891b629$var$kp,
    'buttons-inner': '_buttons-inner_1hact_21',
    container: $24b824b09891b629$var$Ip,
    footer: $24b824b09891b629$var$Ap,
    close: $24b824b09891b629$var$Fp
}, $24b824b09891b629$var$Wp = {
    __name: 'ModalWindow',
    props: {
        isDarkTheme: Boolean
    },
    emits: [
        'close'
    ],
    setup (e, { emit: t }) {
        const n = t, r = e;
        function o() {
            n('close');
        }
        return (i, s)=>{
            const a = $24b824b09891b629$var$qa('click-outside');
            return $24b824b09891b629$var$te(), $24b824b09891b629$var$ut($24b824b09891b629$var$Yl, {
                to: 'body'
            }, [
                $24b824b09891b629$var$I('div', {
                    class: $24b824b09891b629$var$U([
                        i.$style.root,
                        r.isDarkTheme && i.$style.dark
                    ])
                }, [
                    $24b824b09891b629$var$I('div', {
                        class: $24b824b09891b629$var$U(i.$style.container)
                    }, [
                        $24b824b09891b629$var$Za(($24b824b09891b629$var$te(), $24b824b09891b629$var$fe('div', {
                            class: $24b824b09891b629$var$U(i.$style.inner)
                        }, [
                            $24b824b09891b629$var$I('div', {
                                class: $24b824b09891b629$var$U(i.$style.close),
                                onClick: o
                            }, [
                                $24b824b09891b629$var$pe($24b824b09891b629$var$Cp)
                            ], 2),
                            i.$slots.header ? ($24b824b09891b629$var$te(), $24b824b09891b629$var$fe('div', {
                                key: 0,
                                class: $24b824b09891b629$var$U(i.$style.header)
                            }, [
                                $24b824b09891b629$var$zt(i.$slots, 'header')
                            ], 2)) : $24b824b09891b629$var$_t('', !0),
                            i.$slots.title ? ($24b824b09891b629$var$te(), $24b824b09891b629$var$fe('div', {
                                key: 1,
                                class: $24b824b09891b629$var$U(i.$style.title)
                            }, [
                                $24b824b09891b629$var$zt(i.$slots, 'title')
                            ], 2)) : $24b824b09891b629$var$_t('', !0),
                            i.$slots.description ? ($24b824b09891b629$var$te(), $24b824b09891b629$var$fe('div', {
                                key: 2,
                                class: $24b824b09891b629$var$U(i.$style.description)
                            }, [
                                $24b824b09891b629$var$zt(i.$slots, 'description')
                            ], 2)) : $24b824b09891b629$var$_t('', !0),
                            $24b824b09891b629$var$I('div', null, [
                                $24b824b09891b629$var$I('div', {
                                    class: $24b824b09891b629$var$U(i.$style.content)
                                }, [
                                    $24b824b09891b629$var$zt(i.$slots, 'default')
                                ], 2)
                            ]),
                            $24b824b09891b629$var$I('div', {
                                class: $24b824b09891b629$var$U(i.$style.footer)
                            }, [
                                i.$slots.buttons ? ($24b824b09891b629$var$te(), $24b824b09891b629$var$fe('div', {
                                    key: 0,
                                    class: $24b824b09891b629$var$U(i.$style['buttons-inner'])
                                }, [
                                    $24b824b09891b629$var$zt(i.$slots, 'buttons')
                                ], 2)) : $24b824b09891b629$var$_t('', !0)
                            ], 2)
                        ], 2)), [
                            [
                                a,
                                o
                            ]
                        ])
                    ], 2)
                ], 2)
            ]);
        };
    }
}, $24b824b09891b629$var$Lp = {
    $style: $24b824b09891b629$var$Rp
}, $24b824b09891b629$var$Up = /* @__PURE__ */ $24b824b09891b629$var$$e($24b824b09891b629$var$Wp, [
    [
        '__cssModules',
        $24b824b09891b629$var$Lp
    ]
]);
var $24b824b09891b629$var$jp = {
    VITE_PUBLIC_PATH: '/',
    VITE_BASE_URL: 'https://davay-delit.ru',
    BASE_URL: '/',
    MODE: 'production',
    DEV: !1,
    PROD: !0,
    SSR: !1
};
const { VITE_BASE_URL: $24b824b09891b629$var$ri } = $24b824b09891b629$var$jp, $24b824b09891b629$var$Hp = {
    VITE_BASE_URL: $24b824b09891b629$var$ri,
    VITE_LANDING_BASE_URL: `${$24b824b09891b629$var$ri}/landing`
}, $24b824b09891b629$var$Gp = '_link_bih1d_1', $24b824b09891b629$var$Bp = '_white_bih1d_15', $24b824b09891b629$var$Yp = '_widget_bih1d_19', $24b824b09891b629$var$qp = {
    link: $24b824b09891b629$var$Gp,
    white: $24b824b09891b629$var$Bp,
    widget: $24b824b09891b629$var$Yp
}, $24b824b09891b629$var$Kp = /* @__PURE__ */ $24b824b09891b629$var$I('br', null, null, -1), $24b824b09891b629$var$Xp = /* @__PURE__ */ $24b824b09891b629$var$I('br', null, null, -1), $24b824b09891b629$var$zp = /* @__PURE__ */ $24b824b09891b629$var$I('br', null, null, -1), $24b824b09891b629$var$Jp = [
    'href'
], $24b824b09891b629$var$Qp = {
    __name: 'BnplWidgetModal',
    props: {
        dataParams: Object
    },
    setup (e) {
        const t = e, n = $24b824b09891b629$var$Vi(window.widgetParams), r = $24b824b09891b629$var$Tt(()=>n.value ?? $24b824b09891b629$var$Yt({
                ...t.dataParams || {}
            }));
        return (o, i)=>($24b824b09891b629$var$te(), $24b824b09891b629$var$ut($24b824b09891b629$var$Up, {
                'is-dark-theme': r.value.isDarkTheme,
                onClose: i[0] || (i[0] = (s)=>o.$emit('close'))
            }, $24b824b09891b629$var$hl({
                title: $24b824b09891b629$var$At(()=>[
                        $24b824b09891b629$var$Ze("\u0421\u0443\u043C\u043C\u0430 \u043F\u043E\u043A\u0443\u043F\u043A\u0438 \u043B\u0435\u0433\u043A\u043E "),
                        $24b824b09891b629$var$Kp,
                        $24b824b09891b629$var$Ze(" \u0434\u0435\u043B\u0438\u0442\u0441\u044F \u043D\u0430 4 \u0440\u0430\u0432\u043D\u044B\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u0430 ")
                    ]),
                description: $24b824b09891b629$var$At(()=>[
                        $24b824b09891b629$var$Ze(" \u041E\u043F\u043B\u0430\u0442\u0438 \u0441\u0440\u0430\u0437\u0443 \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u0435\u0440\u0432\u0443\u044E \u0447\u0430\u0441\u0442\u044C, \u0430 \u043E\u0441\u0442\u0430\u043B\u044C\u043D\u044B\u0435 \u0441\u043F\u0438\u0448\u0443\u0442\u0441\u044F \u043F\u043E \u0433\u0440\u0430\u0444\u0438\u043A\u0443 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438! ")
                    ]),
                default: $24b824b09891b629$var$At(()=>[
                        r.value.price ? ($24b824b09891b629$var$te(), $24b824b09891b629$var$ut($24b824b09891b629$var$Os, {
                            key: 0,
                            class: $24b824b09891b629$var$U(o.$style.widget),
                            params: r.value
                        }, null, 8, [
                            'class',
                            'params'
                        ])) : $24b824b09891b629$var$_t('', !0),
                        $24b824b09891b629$var$Ze(" \u041D\u0430\u043C \u043D\u0435 \u043D\u0443\u0436\u043D\u044B \u0434\u0435\u0442\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u043F\u0430\u0441\u043F\u043E\u0440\u0442\u0430. \u0422\u043E\u043B\u044C\u043A\u043E \u0424\u0418\u041E \u0438 \u0434\u0430\u0442\u0430 \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F. "),
                        $24b824b09891b629$var$Xp,
                        $24b824b09891b629$var$zp,
                        $24b824b09891b629$var$Ze(" \u041F\u043B\u0430\u0442\u0435\u0436\u0438 \u0431\u0443\u0434\u0443\u0442 \u0441\u043F\u0438\u0441\u044B\u0432\u0430\u0442\u044C\u0441\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u0441 \u043F\u0440\u0438\u043A\u0440\u0435\u043F\u043B\u0435\u043D\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u044B, \u043D\u043E \u0442\u044B \u0432\u0441\u0435\u0433\u0434\u0430 \u043C\u043E\u0436\u0435\u0448\u044C \u0437\u0430\u0439\u0442\u0438 \u0432 \u043B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442 \u0438 \u043E\u043F\u043B\u0430\u0442\u0438\u0442\u044C \u0434\u043E\u0441\u0440\u043E\u0447\u043D\u043E. ")
                    ]),
                buttons: $24b824b09891b629$var$At(()=>[
                        $24b824b09891b629$var$I('a', {
                            class: $24b824b09891b629$var$U([
                                o.$style.link,
                                r.value.isDarkTheme && o.$style.white
                            ]),
                            href: $24b824b09891b629$var$Mi($24b824b09891b629$var$Hp).VITE_BASE_URL,
                            target: '_blank'
                        }, [
                            $24b824b09891b629$var$Ze(" \u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0441\u0435\u0440\u0432\u0438\u0441\u0430 "),
                            $24b824b09891b629$var$pe($24b824b09891b629$var$_s)
                        ], 10, $24b824b09891b629$var$Jp)
                    ]),
                _: 2
            }, [
                r.value.price ? void 0 : {
                    name: 'header',
                    fn: $24b824b09891b629$var$At(()=>[
                            $24b824b09891b629$var$Ze("\u0434\u0430\u0432\u0430\u0439 \u0434\u0435\u043B\u0438\u0442\u044C")
                        ]),
                    key: '0'
                }
            ]), 1032, [
                'is-dark-theme'
            ]));
    }
}, $24b824b09891b629$var$Zp = {
    $style: $24b824b09891b629$var$qp
}, $24b824b09891b629$var$eh = /* @__PURE__ */ $24b824b09891b629$var$$e($24b824b09891b629$var$Qp, [
    [
        '__cssModules',
        $24b824b09891b629$var$Zp
    ]
]), $24b824b09891b629$var$th = {
    __name: 'App',
    props: {
        price: Number,
        view: String,
        isDarkTheme: Boolean,
        wide: Boolean
    },
    setup (e) {
        const t = $24b824b09891b629$var$Vi(!1), r = $24b824b09891b629$var$Yt({
            ...e
        });
        return (o, i)=>($24b824b09891b629$var$te(), $24b824b09891b629$var$fe($24b824b09891b629$var$Oe, null, [
                $24b824b09891b629$var$pe($24b824b09891b629$var$bp, {
                    'data-params': r,
                    class: 'bnpl-widget',
                    onClick: i[0] || (i[0] = (s)=>t.value = !0)
                }, null, 8, [
                    'data-params'
                ]),
                t.value ? ($24b824b09891b629$var$te(), $24b824b09891b629$var$ut($24b824b09891b629$var$eh, {
                    key: 0,
                    'data-params': r,
                    onClose: i[1] || (i[1] = (s)=>t.value = !1)
                }, null, 8, [
                    'data-params'
                ])) : $24b824b09891b629$var$_t('', !0)
            ], 64));
    }
};
var $24b824b09891b629$var$nh = typeof globalThis < 'u' ? globalThis : typeof window < 'u' ? window : typeof $parcel$global < 'u' ? $parcel$global : typeof self < 'u' ? self : {};
function $24b824b09891b629$var$rh(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, 'default') ? e.default : e;
}
var $24b824b09891b629$var$Ds = {
    exports: {}
};
(function(e, t) {
    (function(n, r) {
        e.exports = r();
    })($24b824b09891b629$var$nh, function() {
        var n = '__v-click-outside', r = typeof window < 'u', o = typeof navigator < 'u', i = r && ('ontouchstart' in window || o && navigator.msMaxTouchPoints > 0) ? [
            'touchstart'
        ] : [
            'click'
        ], s = function(h) {
            var c = h.event, m = h.handler;
            (0, h.middleware)(c) && m(c);
        }, a = function(h, c) {
            var m = function(j) {
                var A = typeof j == 'function';
                if (!A && typeof j != 'object') throw new Error('v-click-outside: Binding value must be a function or an object');
                return {
                    handler: A ? j : j.handler,
                    middleware: j.middleware || function(F) {
                        return F;
                    },
                    events: j.events || i,
                    isActive: j.isActive !== !1,
                    detectIframe: j.detectIframe !== !1,
                    capture: !!j.capture
                };
            }(c.value), N = m.handler, T = m.middleware, P = m.detectIframe, L = m.capture;
            if (m.isActive) {
                if (h[n] = m.events.map(function(j) {
                    return {
                        event: j,
                        srcTarget: document.documentElement,
                        handler: function(A) {
                            return function(F) {
                                var B = F.el, Y = F.event, C = F.handler, K = F.middleware, Q = Y.path || Y.composedPath && Y.composedPath();
                                (Q ? Q.indexOf(B) < 0 : !B.contains(Y.target)) && s({
                                    event: Y,
                                    handler: C,
                                    middleware: K
                                });
                            }({
                                el: h,
                                event: A,
                                handler: N,
                                middleware: T
                            });
                        },
                        capture: L
                    };
                }), P) {
                    var X = {
                        event: 'blur',
                        srcTarget: window,
                        handler: function(j) {
                            return function(A) {
                                var F = A.el, B = A.event, Y = A.handler, C = A.middleware;
                                setTimeout(function() {
                                    var K = document.activeElement;
                                    K && K.tagName === 'IFRAME' && !F.contains(K) && s({
                                        event: B,
                                        handler: Y,
                                        middleware: C
                                    });
                                }, 0);
                            }({
                                el: h,
                                event: j,
                                handler: N,
                                middleware: T
                            });
                        },
                        capture: L
                    };
                    h[n] = [].concat(h[n], [
                        X
                    ]);
                }
                h[n].forEach(function(j) {
                    var A = j.event, F = j.srcTarget, B = j.handler;
                    return setTimeout(function() {
                        h[n] && F.addEventListener(A, B, L);
                    }, 0);
                });
            }
        }, u = function(h) {
            (h[n] || []).forEach(function(c) {
                return c.srcTarget.removeEventListener(c.event, c.handler, c.capture);
            }), delete h[n];
        }, d1 = r ? {
            beforeMount: a,
            updated: function(h, c) {
                var m = c.value, N = c.oldValue;
                JSON.stringify(m) !== JSON.stringify(N) && (u(h), a(h, {
                    value: m
                }));
            },
            unmounted: u
        } : {};
        return {
            install: function(h) {
                h.directive('click-outside', d1);
            },
            directive: d1
        };
    });
})($24b824b09891b629$var$Ds);
var $24b824b09891b629$var$oh = $24b824b09891b629$var$Ds.exports;
const $24b824b09891b629$var$ih = /* @__PURE__ */ $24b824b09891b629$var$rh($24b824b09891b629$var$oh);
document.querySelectorAll('#otp-widget-bnpl').forEach((e)=>{
    let t = null;
    const n = (i)=>{
        t && t.unmount(), t = $24b824b09891b629$var$Su($24b824b09891b629$var$th, i), t.use($24b824b09891b629$var$ih), t.mount(e);
    };
    let r = JSON.parse(e.dataset.params || '{}');
    n(r), new MutationObserver((i)=>{
        i.forEach((s)=>{
            if (s.type === 'attributes' && s.attributeName === 'data-params') {
                const a = JSON.parse(e.dataset.params || '{}');
                n(a);
            }
        });
    }).observe(e, {
        attributes: !0,
        attributeFilter: [
            'data-params'
        ]
    });
});


(function() {
    'use strict';
    const DEFAULT_PARAMS = {
        isDarkTheme: false,
        view: 'bnpl-widget-five',
        price: 0
    };
    let lockedOverlay = null;
    let bodyOverflow = '';
    function getOtpHost() {
        return document.querySelector('.otp-bnpl-modal-host') || document.querySelector('#otp-widget-bnpl');
    }
    function isOtpOverlay(node) {
        return node instanceof HTMLElement && node !== getOtpHost() && getComputedStyle(node).position === 'fixed' && (node.textContent || '').includes("\u0440\u0430\u0432\u043D\u044B\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u0430");
    }
    function lockPageScroll(overlay) {
        if (lockedOverlay) return;
        lockedOverlay = overlay;
        bodyOverflow = document.body.style.overflow;
        document.documentElement.classList.add('scroll-lock');
        document.body.classList.add('scroll-lock');
        document.body.style.overflow = 'hidden';
    }
    function unlockPageScroll() {
        if (!lockedOverlay) return;
        lockedOverlay = null;
        document.documentElement.classList.remove('scroll-lock');
        document.body.classList.remove('scroll-lock');
        document.body.style.overflow = bodyOverflow;
    }
    function syncPageScroll() {
        const overlay = [
            ...document.body.children
        ].find(isOtpOverlay) || null;
        if (overlay) {
            lockPageScroll(overlay);
            return;
        }
        unlockPageScroll();
    }
    new MutationObserver(syncPageScroll).observe(document.body, {
        childList: true
    });
    function openDavayDelitModal(price) {
        const host = getOtpHost();
        if (!host) return;
        host.dataset.params = JSON.stringify({
            ...DEFAULT_PARAMS,
            price: Number(price) || 0
        });
        setTimeout(()=>{
            host.querySelector('.bnpl-widget')?.click();
        }, 0);
    }
    document.addEventListener('click', (event)=>{
        const button = event.target.closest('.js-davay-delit-info');
        if (!button) return;
        event.preventDefault();
        event.stopPropagation();
        openDavayDelitModal(button.dataset.price);
    });
})();





const $5a15c093331a66af$var$mainPhoto = document.querySelector('.catalog-detail__image');
const $5a15c093331a66af$var$mainLink = document.querySelector('.catalog-detail__image-wrapper');
const $5a15c093331a66af$var$thumbSwiper = document.querySelector('.catalog-detail__swiper-thumbs');
if ($5a15c093331a66af$var$mainPhoto && $5a15c093331a66af$var$mainLink) (0, $d90cc05fbc862d96$export$ae7678e6c7e3e3ff)($5a15c093331a66af$var$mainLink, $5a15c093331a66af$var$mainPhoto, (0, $d90cc05fbc862d96$export$a2c6579ad5c38b4c));
if ($5a15c093331a66af$var$thumbSwiper && $5a15c093331a66af$var$mainPhoto && $5a15c093331a66af$var$mainLink) new (0, $029bc59d811a92d7$export$25ce5a424b770e84)($5a15c093331a66af$var$thumbSwiper, {
    modules: [
        (0, $49f3fa363ac09256$export$2e2bcd8739ae039),
        (0, $9dcb69c205fd1703$export$2e2bcd8739ae039)
    ],
    spaceBetween: 10,
    slidesPerView: 3,
    freeMode: true,
    navigation: {
        prevEl: '.catalog-detail__thumb-prev',
        nextEl: '.catalog-detail__thumb-next'
    },
    on: {
        click (swiper) {
            const slide = swiper.clickedSlide;
            if (!slide) return;
            const big = slide.dataset.big;
            const width = Number(slide.dataset.width);
            const height = Number(slide.dataset.height);
            $5a15c093331a66af$var$mainPhoto.src = big;
            $5a15c093331a66af$var$mainLink.href = big;
            swiper.slides.forEach((s)=>s.classList.remove('swiper-slide-active'));
            slide.classList.add('swiper-slide-active');
            $5a15c093331a66af$var$mainLink.classList.remove(...(0, $d90cc05fbc862d96$export$32a5abf1f9cfbf46)((0, $d90cc05fbc862d96$export$a2c6579ad5c38b4c)));
            if (width && height) (0, $d90cc05fbc862d96$export$f99fae79892ab783)($5a15c093331a66af$var$mainLink, width, height, (0, $d90cc05fbc862d96$export$a2c6579ad5c38b4c));
            else (0, $d90cc05fbc862d96$export$ae7678e6c7e3e3ff)($5a15c093331a66af$var$mainLink, $5a15c093331a66af$var$mainPhoto, (0, $d90cc05fbc862d96$export$a2c6579ad5c38b4c));
        }
    }
});




new (0, $029bc59d811a92d7$export$25ce5a424b770e84)('.catalog-detail__reviews', {
    modules: [
        (0, $49f3fa363ac09256$export$2e2bcd8739ae039)
    ],
    direction: 'vertical',
    slidesOffsetAfter: 60,
    spaceBetween: 10,
    slidesPerView: 2,
    freeMode: true,
    breakpoints: {
        600: {
            direction: 'horizontal'
        }
    }
});


document.querySelectorAll('.catalog-detail__info-tab').forEach((btn, i)=>{
    btn.addEventListener('click', ()=>$13fc86d2673f485c$var$switchTab(i));
});
function $13fc86d2673f485c$var$switchTab(i) {
    document.querySelectorAll('.catalog-detail__info-tab').forEach((b, j)=>{
        b.classList.toggle('active', i === j);
    });
    document.querySelectorAll('.catalog-detail__info-tab-panel').forEach((p, j)=>{
        p.classList.toggle('active', i === j);
    });
}


/* global BX */ document.addEventListener('DOMContentLoaded', ()=>{
    const productIdInput = document.getElementById('productId');
    const storesWrapper = document.getElementById('catalog-detail__stores');
    if (!productIdInput?.value || !storesWrapper || typeof BX === 'undefined') return;
    const productId = productIdInput.value;
    fetch(`/api/v1/catalog/${productId}/stores`, {
        method: 'GET',
        headers: {
            'Session-Id': BX.bitrix_sessid()
        }
    }).then((response)=>response.json()).then((result)=>{
        if (result.success) {
            $d7b5a02ae93a6f1e$var$setTotalAmount(result.stores);
            $d7b5a02ae93a6f1e$var$buildStores(result.stores);
        } else console.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0441\u043A\u043B\u0430\u0434\u043E\u0432");
    }).catch((err)=>console.error(err));
});
function $d7b5a02ae93a6f1e$var$setTotalAmount(stores) {
    const totalAmountWrapper = document.getElementById('catalog-detail__total-amount');
    if (!totalAmountWrapper) return;
    let totalCount = 0;
    stores.forEach((store)=>{
        totalCount += store.amount;
    });
    totalAmountWrapper.textContent = totalCount;
}
function $d7b5a02ae93a6f1e$var$buildStores(stores) {
    const storesWrapper = document.getElementById('catalog-detail__stores');
    if (!storesWrapper) return;
    stores.forEach((store)=>{
        const item = document.createElement('div');
        item.textContent = store.storeName;
        const amount = document.createElement('span');
        amount.textContent = store.amount === 0 ? '-' : store.amount;
        item.classList.add('catalog-detail__store');
        amount.classList.add('catalog-detail__store-amount');
        if (store.amount !== 0) amount.classList.add('catalog-detail__store-amount--available');
        item.appendChild(amount);
        storesWrapper.appendChild(item);
    });
    window.refreshAccordionPanel?.(storesWrapper);
}


/* global BX, FormUtils */ (function() {
    if (typeof BX === 'undefined' || typeof FormUtils === 'undefined') return;
    const form = document.getElementById('catalog-detail__question');
    const submitBtn = document.getElementById('submit-feedback-btn');
    const commonErrorsBlock = document.getElementById('question-form-common-errors');
    const captchaContainerId = 'captcha-container-question';
    const containerSelector = '';
    const fullname = document.getElementById('fullname-question');
    const phone = document.getElementById('phone-question');
    const email = document.getElementById('email-question');
    const message = document.getElementById('message-question');
    const productName = document.getElementById('productName');
    if (!form || !submitBtn) return;
    FormUtils.setupPhoneMask(phone);
    FormUtils.initCaptcha(captchaContainerId);
    const hideErrors = ()=>{
        FormUtils.clearFieldErrors(containerSelector);
        FormUtils.hideCommonError(commonErrorsBlock);
    };
    const validate = ()=>{
        let isValid = true;
        hideErrors();
        if (!FormUtils.validateRequired(fullname.value)) {
            FormUtils.showFieldError(fullname, "*\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
            isValid = false;
        }
        const phoneDigits = phone.value.replace(/\D/g, '');
        if (!FormUtils.validateRequired(phone.value)) {
            FormUtils.showFieldError(phone, "*\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
            isValid = false;
        } else if (!FormUtils.validatePhoneDigits(phoneDigits)) {
            FormUtils.showFieldError(phone, "*\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 (\u043D\u0435 \u043C\u0435\u043D\u0435\u0435 10 \u0446\u0438\u0444\u0440)");
            isValid = false;
        }
        if (FormUtils.validateRequired(email.value)) {
            if (!FormUtils.validateEmail(email.value)) {
                FormUtils.showFieldError(email, "*\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 E-mail");
                isValid = false;
            }
        }
        const captchaToken = document.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        if (!captchaToken || !captchaToken.value) {
            FormUtils.showCommonError(commonErrorsBlock, "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435, \u0447\u0442\u043E \u0432\u044B \u043D\u0435 \u0440\u043E\u0431\u043E\u0442");
            isValid = false;
        }
        if (!isValid) FormUtils.scrollToFirstError(containerSelector, commonErrorsBlock);
        return isValid;
    };
    const send = async ()=>{
        if (!validate()) return;
        const captchaToken = document.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        const payload = {
            fullname: fullname.value,
            phone: phone.value,
            email: email.value,
            message: message.value,
            smart_token: captchaToken ? captchaToken.value : '',
            productUrl: window.location.href,
            productName: productName.value
        };
        await FormUtils.sendFormData({
            url: '/api/v1/form/ask-question',
            payload: payload,
            submitBtn: submitBtn,
            commonErrorsBlock: commonErrorsBlock,
            containerSelector: containerSelector,
            onSuccess: (result)=>{
                alert(result.message || "\u0421\u043F\u0430\u0441\u0438\u0431\u043E! \u0412\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E.");
                close();
            },
            onFieldError: (field, msg)=>{
                const el = document.getElementById(field);
                if (el) FormUtils.showFieldError(el, msg);
            }
        });
    };
    submitBtn.addEventListener('click', send);
})();




/* global arNextOptions */ function $1447ccd9a012ced8$export$696425601a52f2e4(basket, type) {
    basket.querySelectorAll('.basket-fly__tabs li').forEach((tab)=>{
        tab.classList.toggle('basket-fly__tab_active', tab.dataset.type === type);
    });
    basket.querySelectorAll('.tabs_content.basket > li').forEach((content)=>{
        content.classList.toggle('basket-fly__content_active', content.getAttribute('item-section') === type);
    });
    basket.querySelectorAll('.edge-menu__item').forEach((item)=>{
        item.classList.toggle('edge-menu__item--active', item.dataset.type === type);
    });
    basket.querySelectorAll('.remove_all_basket').forEach((button)=>{
        const buttonType = button.classList.contains('AnDelCanBuy') ? 'AnDelCanBuy' : button.classList.contains('DelDelCanBuy') ? 'DelDelCanBuy' : button.classList.contains('nAnCanBuy') ? 'nAnCanBuy' : null;
        button.classList.toggle('remove_all_basket--active', buttonType === type);
    });
}


async function $d6bc0afe1a05eefb$export$37001b2ee4aaacfe() {
    const basket = document.querySelector('#basket_line .basket_fly');
    if (!basket) return;
    const params = document.querySelector('#fly_basket_params');
    if (!params) return;
    $d6bc0afe1a05eefb$var$beforeRefreshBasketFly(basket);
    const response = await fetch(`${arNextOptions.SITE_DIR}ajax/basket_fly.php`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: new URLSearchParams({
            PARAMS: params.value
        })
    });
    if (!response.ok) throw new Error(`Basket refresh failed: ${response.status}`);
    const html = await response.text();
    basket.innerHTML = html;
    basket.classList.add('loaded');
    $d6bc0afe1a05eefb$var$afterRefreshBasketFly();
}
function $d6bc0afe1a05eefb$var$beforeRefreshBasketFly(basket) {
    const activeTab = document?.querySelector('.basket-fly__tabs li.basket-fly__tab_active');
    if (!activeTab) return;
    sessionStorage.setItem('basket_active_tab', activeTab.getAttribute('item-section'));
    const bodyItems = basket.querySelectorAll('.basket-fly__items-body');
    if (bodyItems) bodyItems.forEach((body)=>{
        let typeBody = body.closest('.tabs_content.basket > li');
        if (typeBody.getAttribute('item-section') === activeTab.getAttribute('item-section')) sessionStorage.setItem('basket_scroll_top', body.scrollTop.toString());
    });
}
function $d6bc0afe1a05eefb$var$afterRefreshBasketFly() {
    const basket = document.querySelector('#basket_line .basket_fly');
    if (!basket) return;
    const activeTab = sessionStorage.getItem('basket_active_tab');
    (0, $1447ccd9a012ced8$export$696425601a52f2e4)(basket, activeTab);
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            const scrollTop = sessionStorage.getItem('basket_scroll_top');
            const body = basket.querySelector(`.tabs_content.basket > li[item-section="${activeTab}"] .basket-fly__items-body`);
            if (body && scrollTop !== null) body.scrollTop = parseInt(scrollTop, 10);
            sessionStorage.removeItem('basket_scroll_top');
        });
    });
    sessionStorage.removeItem('basket_active_tab');
}


(function() {
    if (window.BX && typeof window.BX.addCustomEvent === 'function') window.BX.addCustomEvent('onCompleteAction', async (eventData)=>{
        if (!eventData || !eventData.action) return;
        if (String(eventData.action).indexOf('loadBasket') === 0) await (0, $d6bc0afe1a05eefb$export$37001b2ee4aaacfe)();
    });
})();



const $c99111243668abeb$var$selectors = {
    basket: '#basket_line .basket_fly, .basket_fly.basket-fly',
    opener: '.basket-fly__opener .edge-menu__item.clicked',
    close: '.basket_fly .close, .basket_fly .back_button',
    tabs: '.basket-fly__tabs > li',
    contents: '.tabs_content.basket > li',
    removeButtons: '.basket_sort .remove_all_basket'
};
const $c99111243668abeb$var$classes = {
    opened: 'basket-fly--opened',
    closed: 'basket-fly--closed',
    activeTab: 'basket-fly__tab_active',
    activeContent: 'basket-fly__content_active',
    activeOpener: 'edge-menu__item--active'
};
function $c99111243668abeb$var$getBasket() {
    return document.querySelector($c99111243668abeb$var$selectors.basket);
}
function $c99111243668abeb$var$isOpened(basket) {
    return basket.classList.contains($c99111243668abeb$var$classes.opened);
}
function $c99111243668abeb$var$clearActive(basket) {
    basket.querySelectorAll($c99111243668abeb$var$selectors.opener).forEach((opener)=>{
        opener.classList.remove($c99111243668abeb$var$classes.activeOpener);
    });
    basket.querySelectorAll($c99111243668abeb$var$selectors.tabs).forEach((tab)=>{
        tab.classList.remove('basket-fly__tab_active');
    });
    basket.querySelectorAll($c99111243668abeb$var$selectors.contents).forEach((content)=>{
        content.classList.remove('basket-fly__content_active');
    });
}
function $c99111243668abeb$var$openBasket(basket, type) {
    basket.classList.add($c99111243668abeb$var$classes.opened);
    basket.classList.remove($c99111243668abeb$var$classes.closed);
    basket.setAttribute('aria-hidden', 'false');
    if (type) (0, $1447ccd9a012ced8$export$696425601a52f2e4)(basket, type);
}
function $c99111243668abeb$export$8038573f31246ebe(basket) {
    basket.classList.remove($c99111243668abeb$var$classes.opened);
    basket.classList.add($c99111243668abeb$var$classes.closed);
    basket.setAttribute('aria-hidden', 'true');
    $c99111243668abeb$var$clearActive(basket);
}
async function $c99111243668abeb$var$toggleBasket(basket, type) {
    const current = basket.querySelector(`${$c99111243668abeb$var$selectors.contents}.${$c99111243668abeb$var$classes.activeContent}`);
    const currentType = current ? current.getAttribute('item-section') : '';
    if (!$c99111243668abeb$var$isOpened(basket)) {
        $c99111243668abeb$var$openBasket(basket, type);
        return;
    }
    if (type && currentType !== type) {
        (0, $1447ccd9a012ced8$export$696425601a52f2e4)(basket, type);
        return;
    }
    $c99111243668abeb$export$8038573f31246ebe(basket);
}
function $c99111243668abeb$var$handleOpenerClick(event) {
    const opener = event.target.closest($c99111243668abeb$var$selectors.opener);
    if (!opener) return;
    const basket = opener.closest('.basket_fly');
    if (!basket) return;
    event.preventDefault();
    $c99111243668abeb$var$toggleBasket(basket, opener.dataset.type);
}
function $c99111243668abeb$var$handleTabClick(event) {
    const tab = event.target.closest($c99111243668abeb$var$selectors.tabs);
    if (!tab) return;
    const basket = tab.closest('.basket_fly');
    if (!basket) return;
    event.preventDefault();
    (0, $1447ccd9a012ced8$export$696425601a52f2e4)(basket, tab.dataset.type);
}
function $c99111243668abeb$var$handleCloseClick(event) {
    const close = event.target.closest($c99111243668abeb$var$selectors.close);
    if (!close) return;
    const basket = close.closest('.basket_fly') || $c99111243668abeb$var$getBasket();
    if (!basket) return;
    event.preventDefault();
    $c99111243668abeb$export$8038573f31246ebe(basket);
}
function $c99111243668abeb$var$handleOutsideClick(event) {
    const basket = $c99111243668abeb$var$getBasket();
    if (!basket || !$c99111243668abeb$var$isOpened(basket)) return;
    if (event.target.closest('.basket_fly')) return;
    $c99111243668abeb$export$8038573f31246ebe(basket);
}
function $c99111243668abeb$var$initBasketFly() {
    const basket = $c99111243668abeb$var$getBasket();
    if (!basket) return;
    $c99111243668abeb$export$8038573f31246ebe(basket);
    basket.addEventListener('click', $c99111243668abeb$var$handleOpenerClick);
    basket.addEventListener('click', $c99111243668abeb$var$handleTabClick);
    basket.addEventListener('click', $c99111243668abeb$var$handleCloseClick);
    document.addEventListener('click', $c99111243668abeb$var$handleOutsideClick);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $c99111243668abeb$var$initBasketFly);
else $c99111243668abeb$var$initBasketFly();


/* global BX, arNextOptions */ 

(function() {
    const selectors = {
        basket: '.basket_fly',
        removeAllButton: '.remove_all_basket'
    };
    const classes = {
        disabled: 'disabled'
    };
    let basketParamsCache = null;
    function getBasketParams() {
        if (basketParamsCache) return basketParamsCache;
        const input = document.querySelector('#fly_basket_params');
        if (!input) throw new Error('fly_basket_params not found');
        basketParamsCache = input.value;
        return basketParamsCache;
    }
    async function clearSection(type) {
        const form = document.querySelector('#basket_form');
        if (!form) throw new Error('Basket form not found');
        const params = getBasketParams();
        let index = 1;
        switch(type){
            case 'delay':
                index = 2;
                break;
            case 'na':
                index = 4;
                break;
        }
        const body = new URLSearchParams({
            PARAMS: params,
            TYPE: index,
            CLEAR_ALL: 'Y'
        });
        const response = await fetch(`${arNextOptions.SITE_DIR}ajax/show_basket_fly.php`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            body: body
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.text();
    }
    function resetCatalogButtons() {
        document.querySelectorAll('.to-cart').forEach((button)=>{
            button.classList.remove('clicked');
            button.style.display = '';
        });
        document.querySelectorAll('.in-cart').forEach((button)=>{
            button.style.display = 'none';
        });
        document.querySelectorAll('.wish_item').forEach((button)=>{
            button.classList.remove('added');
        });
        document.querySelectorAll('.counter_block').forEach((counter)=>{
            counter.style.display = '';
        });
        document.querySelectorAll('.button_block').forEach((block)=>{
            block.classList.remove('wide');
        });
    }
    async function handleRemoveAll(event) {
        const button = event.target.closest(selectors.removeAllButton);
        if (!button) return;
        event.preventDefault();
        if (button.classList.contains(classes.disabled)) return;
        const type = button.dataset.type;
        if (!type) return;
        button.classList.add(classes.disabled);
        try {
            await clearSection(type);
            resetCatalogButtons();
            await (0, $d6bc0afe1a05eefb$export$37001b2ee4aaacfe)();
            (0, $c99111243668abeb$export$8038573f31246ebe)(document.querySelector(selectors.basket));
            if (window.BX?.onCustomEvent) BX.onCustomEvent('onCompleteAction', [
                {
                    action: 'loadBasket'
                }
            ]);
        } catch (error) {
            console.error('Basket clear error:', error);
        } finally{
            button.classList.remove(classes.disabled);
        }
    }
    function initBasketFlyClear() {
        document.addEventListener('click', handleRemoveAll);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBasketFlyClear);
    else initBasketFlyClear();
})();


/* global arNextOptions, jsPriceFormat */ 
(function() {
    let timerBasketUpdate = null;
    function getInput(id) {
        return document.querySelector(`#QUANTITY_INPUT_${id}`);
    }
    function getSelect(id) {
        return document.querySelector(`#QUANTITY_SELECT_${id}`);
    }
    function getHidden(id) {
        return document.querySelector(`#QUANTITY_${id}`);
    }
    function isFloat(input) {
        return input?.dataset?.float_ratio === 'true';
    }
    function setQuantityFly(basketId, ratio, direction) {
        const input = getInput(basketId);
        if (!input) return;
        const currentValue = input.value;
        const isDblQuantity = isFloat(input);
        let step = isDblQuantity ? parseFloat(ratio) : parseInt(ratio, 10);
        if (isDblQuantity && window.arNextOptions?.JS_ITEM_CLICK?.precisionFactor) step = Math.round(step * arNextOptions.JS_ITEM_CLICK.precisionFactor) / arNextOptions.JS_ITEM_CLICK.precisionFactor;
        let curValue = isDblQuantity ? parseFloat(currentValue) : parseInt(currentValue, 10);
        const max = parseFloat(input.getAttribute('max')) || Infinity;
        if (direction === 'up' && curValue >= max) return;
        curValue = direction === 'up' ? curValue + step : curValue - step;
        if (curValue > max) curValue = max;
        if (curValue < 1) return;
        if (isDblQuantity && window.arNextOptions?.JS_ITEM_CLICK?.precisionFactor) curValue = Math.round(curValue * arNextOptions.JS_ITEM_CLICK.precisionFactor) / arNextOptions.JS_ITEM_CLICK.precisionFactor;
        input.value = curValue;
        input.defaultValue = currentValue;
        recalcLocalTotals(basketId);
        if (timerBasketUpdate) clearTimeout(timerBasketUpdate);
        timerBasketUpdate = setTimeout(()=>{
            updateQuantityFly(basketId, step);
            timerBasketUpdate = null;
        }, 700);
    }
    function recalcLocalTotals() {
        let totalSum = 0;
        const rows = document.querySelectorAll(`#basket_line .basket_fly tr[data-id]`);
        rows.forEach((row)=>{
            const id = row.getAttribute('data-id');
            const input = getInput(id);
            const priceInput = document.querySelector(`#basket_form input[name="item_price_${id}"]`);
            if (!input || !priceInput) return;
            const count = parseFloat(input.value) || 0;
            const price = parseFloat(priceInput.value) || 0;
            const sum = count * price;
            totalSum += sum;
            const priceCell = row.querySelector('.summ-cell .price');
            if (priceCell && window.jsPriceFormat) priceCell.innerHTML = jsPriceFormat(sum);
        });
        const totalEl = document.querySelector('#basket_form .itog span.price');
        if (totalEl && window.jsPriceFormat) totalEl.innerHTML = jsPriceFormat(totalSum);
        const discountEl = document.querySelector('#basket_form .itog div.discount');
        if (discountEl) discountEl.style.opacity = '0.2';
    }
    async function updateQuantityFly(basketId, ratio) {
        const input = getInput(basketId);
        if (!input) return;
        let newVal = parseFloat(input.value) || 0;
        if (newVal < 0) newVal = 0;
        const isIntRatio = ratio % 1 === 0;
        if (isIntRatio) newVal = parseInt(newVal, 10);
        else newVal = parseFloat(newVal).toFixed(1);
        const select = getSelect(basketId);
        if (select) Array.from(select.options).forEach((option)=>{
            if (parseFloat(option.value).toFixed(2) === parseFloat(newVal).toFixed(2)) option.selected = true;
        });
        const hidden = getHidden(basketId);
        if (hidden) hidden.value = newVal;
        input.value = newVal;
        const form = document.querySelector('form[name^="basket_form"]');
        if (!form) return;
        const body = new URLSearchParams(new FormData(form));
        body.append('BasketRefresh', 'Y');
        try {
            const response = await fetch(`${window.arNextOptions.SITE_DIR}ajax/basket_fly.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: body
            });
            if (!response.ok) return;
            await (0, $d6bc0afe1a05eefb$export$37001b2ee4aaacfe)();
        } catch (e) {
            console.error('Quantity update failed', e);
        }
    }
    window.setQuantityFly = setQuantityFly;
    window.updateQuantityFly = updateQuantityFly;
})();


/* global BX, arNextOptions */ 
(function() {
    async function deleteProduct(event) {
        const button = event.target.closest('.remove');
        if (!button) return;
        const delayParent = button.closest('[item-section="DelDelCanBuy"]');
        const isDelayBtn = Boolean(delayParent);
        event.preventDefault();
        const itemBlock = button.closest('.basket-fly__item');
        if (!itemBlock) return;
        const productId = itemBlock.getAttribute('product-id') || itemBlock.dataset.productId;
        if (!productId) return;
        const basket = button.closest('.basket_fly, .basket-fly');
        let isLastItem = false;
        const itemDelay = basket?.querySelector('#basket_form [item-section="DelDelCanBuy"]');
        if (itemDelay) isLastItem = itemDelay.querySelectorAll('.basket-fly__item').length === 1;
        try {
            button.classList.add('is-loading');
            if (typeof window.delFromBasketCounter === 'function') {
                const needDelay = typeof window.checkCounters === 'function' ? window.checkCounters() : false;
                if (needDelay) {
                    window.delFromBasketCounter(productId);
                    await new Promise((r)=>setTimeout(r, 120));
                } else window.delFromBasketCounter(productId);
            }
            await fetch(`${arNextOptions.SITE_DIR}ajax/item.php?delete_item=Y&item=${productId}`, {
                method: 'GET',
                credentials: 'same-origin'
            });
            if (isLastItem && isDelayBtn) {
                const actualBasket = document.querySelector('.basket_fly, .basket-fly');
                if (actualBasket) (0, $c99111243668abeb$export$8038573f31246ebe)(actualBasket);
            }
            if (window.BX?.onCustomEvent) BX.onCustomEvent('onCompleteAction', [
                {
                    action: 'loadBasket'
                }
            ]);
        } catch (e) {
            console.error('deleteProduct error:', e);
        } finally{
            if (button && document.contains(button)) button.classList.remove('is-loading');
        }
    }
    function init() {
        document.addEventListener('click', deleteProduct);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();


/* global BX, arNextOptions */ 
(function() {
    async function delayProduct(event) {
        const button = event.target.closest('.wish_item');
        if (!button) return;
        event.preventDefault();
        const itemBlock = button.closest('.basket-fly__item');
        if (!itemBlock) return;
        const productId = itemBlock.getAttribute('product-id');
        if (!productId) return;
        try {
            button.classList.add('is-loading');
            const quantityInput = itemBlock.querySelector('#QUANTITY_' + itemBlock.getAttribute('data-id'));
            const quantity = quantityInput ? quantityInput.value : 1;
            await fetch(`${arNextOptions.SITE_DIR}ajax/item.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: new URLSearchParams({
                    wish_item: 'Y',
                    item: productId,
                    quantity: quantity
                })
            });
            await (0, $d6bc0afe1a05eefb$export$37001b2ee4aaacfe)();
            if (typeof window.delFromBasketCounter === 'function') window.delFromBasketCounter(productId);
            if (typeof BX !== 'undefined') BX.onCustomEvent('onCompleteAction', [
                {
                    action: 'loadBasket'
                }
            ]);
        } catch (e) {
            console.error('delayProduct error:', e);
        } finally{
            button.classList.remove('is-loading');
        }
    }
    function init() {
        document.addEventListener('click', delayProduct);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();


const $f2d90c9f8532b140$var$oneClickBuyBasket = function() {
    const name = 'one_click_buy_basket';
    if (window.matchMedia('(min-width:992px)').matches) {
        const fastOrderBtn = document.querySelector('.fast_order');
        if (fastOrderBtn && !fastOrderBtn.classList.contains('clicked')) {
            document.querySelectorAll('.fast_order').forEach((el)=>el.classList.add('clicked'));
            document.querySelectorAll('.' + name + '_frame, .jqmOverlay').forEach((el)=>el.remove());
            const overlay = document.createElement('div');
            overlay.className = 'jqmOverlay';
            overlay.style.cssText = 'position:fixed; top:0; left:0; width:100%; height:100%; background-color:#000; opacity:0.5; z-index:2999;';
            document.body.appendChild(overlay);
            const frame = document.createElement('div');
            frame.className = name + '_frame popup';
            frame.style.cssText = 'position:fixed; z-index:3000; display:none;';
            document.body.appendChild(frame);
            const wElement = typeof window.jQuery !== 'undefined' ? window.jQuery(frame) : frame;
            const oElement = typeof window.jQuery !== 'undefined' ? window.jQuery(overlay) : overlay;
            const hash = {
                w: wElement,
                o: oElement
            };
            const closeModal = ()=>{
                if (typeof window.onHidejqm === 'function') window.onHidejqm(name, hash);
                frame.remove();
                overlay.remove();
                document.querySelectorAll('.fast_order').forEach((el)=>el.classList.remove('clicked'));
            };
            overlay.addEventListener('click', closeModal);
            const siteDir = window.arNextOptions ? window.arNextOptions['SITE_DIR'] : '/';
            const url = siteDir + 'ajax/one_click_buy_basket.php';
            fetch(url).then((response)=>{
                if (!response.ok) throw new Error("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u0444\u043E\u0440\u043C\u044B");
                return response.text();
            }).then((html)=>{
                frame.innerHTML = html;
                frame.style.display = 'block';
                const closeBtn = frame.querySelector('.jqmClose');
                if (closeBtn) closeBtn.addEventListener('click', (e)=>{
                    e.preventDefault();
                    closeModal();
                });
                if (typeof window.onLoadjqm === 'function') window.onLoadjqm(name, hash);
            }).catch((error)=>{
                console.error("\u041E\u0448\u0438\u0431\u043A\u0430:", error);
                closeModal();
            });
        }
    } else {
        const siteDir = window.arNextOptions ? window.arNextOptions['SITE_DIR'] : '/';
        let script = siteDir + 'form/?name=' + name + '&form_id=ocb&path=' + window.location.pathname + '&buy_basket=y';
        window.location.href = script;
    }
};
document.addEventListener('click', function(event) {
    const btn = event.target.closest('.fast_order');
    if (btn) {
        event.preventDefault();
        $f2d90c9f8532b140$var$oneClickBuyBasket();
    }
});




(function waitMap() {
    const map = window.GLOBAL_arMapObjects?.MAP_v33;
    if (!map) {
        setTimeout(waitMap, 100);
        return;
    }
    document.querySelector('.map-zoom-in')?.addEventListener('click', ()=>{
        map.setZoom(map.getZoom() + 1);
    });
    document.querySelector('.map-zoom-out')?.addEventListener('click', ()=>{
        map.setZoom(map.getZoom() - 1);
    });
    document.querySelector('.map-type')?.addEventListener('change', (event)=>{
        map.setType(event.target.value);
    });
})();


document.addEventListener('DOMContentLoaded', function() {
    const tabs = document.querySelectorAll('.faq-tabs__nav-btn');
    const panels = document.querySelectorAll('.faq-tabs__panel');
    tabs.forEach((btn)=>{
        btn.addEventListener('click', function() {
            const tabId = this.dataset.tab;
            document.querySelectorAll('.faq-tabs__nav-item').forEach((item)=>item.classList.remove('is-active'));
            panels.forEach((panel)=>panel.classList.remove('is-active'));
            this.parentElement.classList.add('is-active');
            document.querySelector(`.faq-tabs__panel[data-tab="${tabId}"]`).classList.add('is-active');
        });
    });
});


/* global BX, bitrix_sessid, FormUtils */ 
(function() {
    if (typeof BX === 'undefined' || typeof FormUtils === 'undefined') return;
    const modalId = 'buy-one-click-modal-overlay';
    const closeBtnId = 'buy-one-click-form-header-btn';
    const submitBtn = document.getElementById('buy-one-click-submit-btn');
    const commonErrorsBlock = document.getElementById('buy-one-click-form-common-errors');
    const containerSelector = '';
    const MIN_ORDER_AMOUNT = 500;
    const captchaContainerId = 'captcha-container-question';
    let defaultDeliveryHref = null;
    let activeTriggerBtn = null;
    const fullname = document.getElementById('fullname-buy-one-click');
    const phone = document.getElementById('phone-buy-one-click');
    const email = document.getElementById('email-buy-one-click');
    const message = document.getElementById('message-buy-one-click');
    if (!document.getElementById(modalId) || !submitBtn) return;
    FormUtils.setupPhoneMask(phone);
    const initCaptcha = ()=>FormUtils.initCaptcha(captchaContainerId);
    const resetCaptcha = ()=>FormUtils.resetCaptcha();
    const clearFields = ()=>{
        fullname.value = '';
        phone.value = '';
        email.value = '';
        message.value = '';
    };
    const hideErrors = ()=>{
        FormUtils.clearFieldErrors(containerSelector);
        FormUtils.hideCommonError(commonErrorsBlock);
    };
    const validate = ()=>{
        let isValid = true;
        hideErrors();
        if (!FormUtils.validateRequired(fullname.value)) {
            FormUtils.showFieldError(fullname, "*\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
            isValid = false;
        }
        const phoneDigits = phone.value.replace(/\D/g, '');
        if (!FormUtils.validateRequired(phone.value)) {
            FormUtils.showFieldError(phone, "*\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
            isValid = false;
        } else if (!FormUtils.validatePhoneDigits(phoneDigits)) {
            FormUtils.showFieldError(phone, "*\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 (\u043D\u0435 \u043C\u0435\u043D\u0435\u0435 10 \u0446\u0438\u0444\u0440)");
            isValid = false;
        }
        if (!FormUtils.validateRequired(email.value)) {
            FormUtils.showFieldError(email, "*\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
            isValid = false;
        } else if (!FormUtils.validateEmail(email.value)) {
            FormUtils.showFieldError(email, "*\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 E-mail");
            isValid = false;
        }
        const captchaToken = document.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        if (!captchaToken || !captchaToken.value) {
            FormUtils.showCommonError(commonErrorsBlock, "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435, \u0447\u0442\u043E \u0432\u044B \u043D\u0435 \u0440\u043E\u0431\u043E\u0442");
            isValid = false;
        }
        if (!isValid) FormUtils.scrollToFirstError(containerSelector, commonErrorsBlock);
        return isValid;
    };
    const getBasketItemsData = ()=>{
        const basket = window.BX?.Sale?.BasketComponent;
        if (basket && basket.result && basket.result.BASKET_ITEM_RENDER_DATA) return basket.result.BASKET_ITEM_RENDER_DATA.map((item)=>({
                id: item.PRODUCT_ID,
                quantity: parseFloat(item.QUANTITY) || 1,
                price: parseFloat(item.PRICE) || 0
            }));
        return [];
    };
    const getOrderInfo = ()=>{
        const isMassOrder = activeTriggerBtn?.classList.contains('open-buy-one-click--mas');
        if (isMassOrder) {
            const items = getBasketItemsData();
            const total = items.reduce((sum, item)=>sum + item.price * item.quantity, 0);
            return {
                isMassOrder: true,
                items: items.map((item)=>({
                        id: item.id,
                        quantity: item.quantity
                    })),
                total: total
            };
        }
        const openBtn = document.querySelector('.catalog-detail__one-click .open-buy-one-click') || document.querySelector('.open-buy-one-click');
        const counter = document.getElementById('basket-counter');
        const quantityInputId = openBtn?.getAttribute('data-quantity-input-id');
        const quantityInput = quantityInputId ? document.getElementById(quantityInputId) : counter?.querySelector('.counter__digit');
        const productId = openBtn?.getAttribute('data-product-id') || document.getElementById('product-info-block')?.dataset.productId || document.getElementById('productId')?.value || '';
        const baseQuantity = parseFloat(String(quantityInput?.value ?? '1').replace(',', '.')) || 1;
        const flyInput = document.getElementById('emergency-fly-counter') || document.querySelector('.basket-fly__item-counter');
        const flyQuantity = flyInput ? parseFloat(String(flyInput.value).replace(',', '.')) || 1 : 0;
        const quantity = Math.max(baseQuantity, flyQuantity);
        let price = 0;
        if (counter?.dataset.price) price = parseFloat(String(counter.dataset.price).replace(',', '.')) || 0;
        else {
            const metaPrice = document.querySelector('[itemprop="price"]');
            price = parseFloat(metaPrice?.content || '0') || 0;
        }
        return {
            isMassOrder: false,
            productId: productId,
            quantity: quantity,
            price: price,
            total: price * quantity
        };
    };
    const validateMinOrderAmount = ()=>{
        const { total: total } = getOrderInfo();
        if (total < MIN_ORDER_AMOUNT) {
            FormUtils.showCommonError(commonErrorsBlock, "\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u0437\u0430\u043A\u0430\u0437\u0430 500 \u0440\u0443\u0431\u043B\u0435\u0439");
            FormUtils.scrollToFirstError(containerSelector, commonErrorsBlock);
            return false;
        }
        return true;
    };
    const clearBasketAfterOrder = ()=>{
        const removeAllBtn = document.querySelector('.remove_all_basket[data-type="basket"]') || document.querySelector('.remove_all_basket');
        const removeBasket = document.getElementById('basket__button-clear');
        if (removeAllBtn) removeAllBtn.click();
        else if (removeBasket) removeBasket.click();
        else if (window.BX?.onCustomEvent) BX.onCustomEvent('onCompleteAction', [
            {
                action: 'loadBasket'
            }
        ]);
    };
    const send = async ()=>{
        if (!validate()) return;
        if (!validateMinOrderAmount()) return;
        const orderInfo = getOrderInfo();
        const token = typeof bitrix_sessid === 'function' ? bitrix_sessid() : BX.bitrix_sessid ? BX.bitrix_sessid() : '';
        const captchaToken = document.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        const payload = {
            fullname: fullname.value,
            phone: phone.value,
            email: email.value,
            message: message.value,
            smart_token: captchaToken ? captchaToken.value : ''
        };
        payload.items = orderInfo.isMassOrder ? orderInfo.items : [
            {
                id: orderInfo.productId,
                quantity: orderInfo.quantity
            }
        ];
        if (submitBtn) submitBtn.disabled = true;
        try {
            const response = await fetch('/api/v1/order/buy-one-click', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Session-Id': token,
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify(payload)
            });
            const rawText = await response.text();
            const jsonMatch = rawText.match(/\{[\s\S]*\}/);
            if (jsonMatch) {
                const result = JSON.parse(jsonMatch[0]);
                if (result.success || result.orderId) {
                    alert(result.message || `\u{421}\u{43F}\u{430}\u{441}\u{438}\u{431}\u{43E}! \u{412}\u{430}\u{448} \u{437}\u{430}\u{43A}\u{430}\u{437} \u{2116}${result.orderId} \u{443}\u{441}\u{43F}\u{435}\u{448}\u{43D}\u{43E} \u{43F}\u{440}\u{438}\u{43D}\u{44F}\u{442}.`);
                    clearBasketAfterOrder();
                    close();
                    return;
                }
            }
            FormUtils.showCommonError(commonErrorsBlock, "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u0437\u0430\u043A\u0430\u0437\u0430 \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0435.");
            FormUtils.scrollToFirstError(containerSelector, commonErrorsBlock);
        } catch (e) {
            console.error(e);
            FormUtils.showCommonError(commonErrorsBlock, "\u041E\u0448\u0438\u0431\u043A\u0430 \u0441\u0435\u0442\u0438. \u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u0438 \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0441\u043D\u043E\u0432\u0430.");
            FormUtils.scrollToFirstError(containerSelector, commonErrorsBlock);
        } finally{
            if (submitBtn) submitBtn.disabled = false;
        }
    };
    const initDeliveryHref = ()=>{
        const href = document.getElementById('deliveryLink');
        if (href) {
            defaultDeliveryHref = document.getElementById('deliveryLink').outerHTML;
            href.addEventListener('click', (e)=>{
                e.preventDefault();
                href.outerHTML = '<span id="deliveryLink" style="display: inline-block; max-width: 265px;" class="simple-text--font">\u0412 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0437\u0430\u043A\u0430\u0437\u0430 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u0430 <a href="/help/delivery" target="_blank" rel="noopener noreferrer">\u0446\u0435\u043D\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438</a></span>';
            });
        }
    };
    const getDefaultDeliveryHref = ()=>{
        const href = document.getElementById('deliveryLink');
        if (href) href.outerHTML = defaultDeliveryHref;
    };
    const open = ()=>{
        const basketContainer = document.querySelector('.basket_fly, .basket-fly');
        if (basketContainer) (0, $c99111243668abeb$export$8038573f31246ebe)(basketContainer);
        document.getElementById(modalId).style.display = 'flex';
        document.body.style.overflow = 'hidden';
        hideErrors();
        initDeliveryHref();
        initCaptcha();
        resetCaptcha();
        setTimeout(()=>{
            const fone = document.querySelector('.jqmOverlay');
            if (fone) fone.remove();
        }, 50);
    };
    const close = ()=>{
        document.getElementById(modalId).style.display = 'none';
        document.body.style.overflow = '';
        clearFields();
        hideErrors();
        getDefaultDeliveryHref();
        resetCaptcha();
        activeTriggerBtn = null;
    };
    FormUtils.createModal({
        modalId: modalId,
        closeBtnId: closeBtnId,
        onOpen: open,
        onClose: close
    });
    document.addEventListener('click', (e)=>{
        const targetBtn = e.target.closest('.open-buy-one-click');
        if (targetBtn) {
            e.preventDefault();
            activeTriggerBtn = targetBtn;
            open();
        }
    });
    submitBtn.addEventListener('click', send);
})();


/* global BX, bitrix_sessid, FormUtils */ (function() {
    if (typeof BX === 'undefined' || typeof FormUtils === 'undefined') return;
    const modalId = 'report-error-modal-overlay';
    const closeBtnId = 'report-error-form-header-btn';
    const submitBtn = document.getElementById('report-error-submit-btn');
    const commonErrorsBlock = document.getElementById('report-form-common-errors');
    const captchaContainerId = 'captcha-container-report';
    const containerSelector = '';
    const email = document.getElementById('email-report');
    const message = document.getElementById('message-report');
    const productName = document.getElementById('productName');
    if (!document.getElementById(modalId) || !submitBtn) return;
    const initCaptcha = ()=>FormUtils.initCaptcha(captchaContainerId);
    const resetCaptcha = ()=>FormUtils.resetCaptcha();
    const clearFields = ()=>{
        email.value = '';
        message.value = '';
    };
    const hideErrors = ()=>{
        FormUtils.clearFieldErrors(containerSelector);
        FormUtils.hideCommonError(commonErrorsBlock);
    };
    const validate = ()=>{
        let isValid = true;
        hideErrors();
        if (!FormUtils.validateRequired(email.value)) {
            FormUtils.showFieldError(email, "*\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
            isValid = false;
        } else if (!FormUtils.validateEmail(email.value)) {
            FormUtils.showFieldError(email, "*\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 E-mail");
            isValid = false;
        }
        if (!FormUtils.validateRequired(message.value)) {
            FormUtils.showFieldError(message, "*\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
            isValid = false;
        }
        const captchaToken = document.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        if (!captchaToken || !captchaToken.value) {
            FormUtils.showCommonError(commonErrorsBlock, "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435, \u0447\u0442\u043E \u0432\u044B \u043D\u0435 \u0440\u043E\u0431\u043E\u0442");
            isValid = false;
        }
        if (!isValid) FormUtils.scrollToFirstError(containerSelector, commonErrorsBlock);
        return isValid;
    };
    const send = async ()=>{
        if (!validate()) return;
        const captchaToken = document.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        const token = typeof bitrix_sessid === 'function' ? bitrix_sessid() : BX.bitrix_sessid ? BX.bitrix_sessid() : '';
        const payload = {
            email: email.value,
            message: message.value,
            smart_token: captchaToken ? captchaToken.value : '',
            productUrl: window.location.href,
            productName: productName.value
        };
        if (submitBtn) submitBtn.disabled = true;
        try {
            await FormUtils.sendFormData({
                url: '/api/v1/form/catalog-report',
                payload: payload,
                headers: {
                    'Session-Id': token,
                    'X-Requested-With': 'XMLHttpRequest'
                },
                submitBtn: submitBtn,
                commonErrorsBlock: commonErrorsBlock,
                containerSelector: containerSelector,
                onSuccess: (result)=>{
                    alert(result.message || "\u0421\u043F\u0430\u0441\u0438\u0431\u043E! \u0412\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E.");
                    close();
                },
                onFieldError: (field, msg)=>{
                    const el = document.getElementById(field);
                    if (el) FormUtils.showFieldError(el, msg);
                }
            });
        } finally{
            if (submitBtn) submitBtn.disabled = false;
        }
    };
    const open = ()=>{
        document.getElementById(modalId).style.display = 'flex';
        document.body.style.overflow = 'hidden';
        hideErrors();
        initCaptcha();
        resetCaptcha();
    };
    const close = ()=>{
        document.getElementById(modalId).style.display = 'none';
        document.body.style.overflow = '';
        clearFields();
        hideErrors();
        resetCaptcha();
    };
    FormUtils.createModal({
        modalId: modalId,
        closeBtnId: closeBtnId,
        openBtnClass: '.open-report-error',
        onOpen: open,
        onClose: close
    });
    submitBtn.addEventListener('click', send);
})();


(function() {
    function getBasketTotalPrice() {
        if (window.BX && window.BX.Sale && window.BX.Sale.BasketComponent && window.BX.Sale.BasketComponent.result && typeof window.BX.Sale.BasketComponent.result.allSum !== 'undefined') return Number(window.BX.Sale.BasketComponent.result.allSum) || 0;
        return null;
    }
    function renderBasketMinPriceWarning() {
        const minPrice = 500;
        const basketTotal = getBasketTotalPrice();
        const anchors = document.querySelectorAll('[data-anchor="min-price-total"]');
        if (!anchors.length || basketTotal === null) return;
        anchors.forEach((anchor)=>{
            anchor.innerHTML = '';
            if (basketTotal >= minPrice) return;
            const warning = document.createElement('div');
            warning.className = 'warning';
            warning.innerHTML = `
                <svg width="2" height="15" viewBox="0 0 2 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.0498 1V9M1.09961 13V13.1L1 13.1002V13H1.09961Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            `;
            const info = document.createElement('div');
            info.className = 'basket__min-price-info';
            const firstText = document.createElement('p');
            firstText.className = 'basket__min-price-text';
            firstText.textContent = "\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u0437\u0430\u043A\u0430\u0437\u0430 500 \u0440\u0443\u0431\u043B\u0435\u0439";
            const secondText = document.createElement('p');
            secondText.className = 'basket__min-price-text';
            secondText.textContent = "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0434\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0435\u0449\u0451 \u0442\u043E\u0432\u0430\u0440\u043E\u0432 \u0432 \u043A\u043E\u0440\u0437\u0438\u043D\u0443";
            info.appendChild(firstText);
            info.appendChild(secondText);
            anchor.appendChild(warning);
            anchor.appendChild(info);
        });
    }
    if (window.BX && typeof window.BX.addCustomEvent === 'function') window.BX.addCustomEvent('onCompleteAction', (eventData)=>{
        if (!eventData || !eventData.action) return;
        if (String(eventData.action).indexOf('loadBasket') === 0) renderBasketMinPriceWarning();
    });
    renderBasketMinPriceWarning();
})();


/* global BX */ /* eslint-disable no-prototype-builtins */ (function() {
    'use strict';
    BX.namespace('BX.Sale.BasketActionPool');
    BX.Sale.BasketActionPool = function(component) {
        this.component = component;
        this.requestProcessing = false;
        this.updateTimer = null;
        this.isBasketRefreshed = this.component.params.DEFERRED_REFRESH !== 'Y';
        this.needFullRecalculation = this.component.params.DEFERRED_REFRESH === 'Y';
        this.pool = {};
        this.lastActualPool = {};
        this.approvedAction = [
            'QUANTITY',
            'DELETE',
            'RESTORE',
            'DELAY',
            'OFFER',
            'MERGE_OFFER'
        ];
        this.switchTimer();
    };
    BX.Sale.BasketActionPool.prototype.setRefreshStatus = function(status) {
        this.isBasketRefreshed = !!status;
    };
    BX.Sale.BasketActionPool.prototype.getRefreshStatus = function() {
        return this.isBasketRefreshed;
    };
    BX.Sale.BasketActionPool.prototype.isItemInPool = function(itemId) {
        return !!this.pool[itemId];
    };
    BX.Sale.BasketActionPool.prototype.clearLastActualQuantityPool = function(itemId) {
        this.lastActualPool[itemId] && delete this.lastActualPool[itemId].QUANTITY;
    };
    BX.Sale.BasketActionPool.prototype.checkItemPoolBefore = function(itemId) {
        if (!itemId) return;
        this.pool[itemId] = this.pool[itemId] || {};
    };
    BX.Sale.BasketActionPool.prototype.checkItemPoolAfter = function(itemId) {
        if (!itemId || !this.pool[itemId]) return;
        if (Object.keys(this.pool[itemId]).length === 0) delete this.pool[itemId];
    };
    BX.Sale.BasketActionPool.prototype.addCoupon = function(coupon) {
        this.pool.COUPON = coupon;
        this.switchTimer();
    };
    BX.Sale.BasketActionPool.prototype.removeCoupon = function(coupon) {
        this.checkItemPoolBefore('REMOVE_COUPON');
        this.pool.REMOVE_COUPON[coupon] = coupon;
        this.switchTimer();
    };
    BX.Sale.BasketActionPool.prototype.changeQuantity = function(itemId, quantity, oldQuantity) {
        this.checkItemPoolBefore(itemId);
        if (this.lastActualPool[itemId] && this.lastActualPool[itemId].QUANTITY !== quantity || !this.lastActualPool[itemId] && quantity !== oldQuantity) this.pool[itemId].QUANTITY = quantity;
        else this.pool[itemId] && delete this.pool[itemId].QUANTITY;
        this.checkItemPoolAfter(itemId);
        this.switchTimer();
    };
    BX.Sale.BasketActionPool.prototype.deleteItem = function(itemId) {
        this.checkItemPoolBefore(itemId);
        if (this.pool[itemId].RESTORE) delete this.pool[itemId].RESTORE;
        else this.pool[itemId].DELETE = 'Y';
        this.checkItemPoolAfter(itemId);
        this.switchTimer();
    };
    BX.Sale.BasketActionPool.prototype.restoreItem = function(itemId, itemData) {
        this.checkItemPoolBefore(itemId);
        if (this.pool[itemId].DELETE === 'Y') delete this.pool[itemId].DELETE;
        else this.pool[itemId].RESTORE = itemData;
        this.checkItemPoolAfter(itemId);
        this.switchTimer();
    };
    BX.Sale.BasketActionPool.prototype.addDelayed = function(itemId) {
        this.checkItemPoolBefore(itemId);
        this.pool[itemId].DELAY = 'Y';
        this.checkItemPoolAfter(itemId);
        this.switchTimer();
    };
    BX.Sale.BasketActionPool.prototype.removeDelayed = function(itemId) {
        this.checkItemPoolBefore(itemId);
        this.pool[itemId].DELAY = 'N';
        this.checkItemPoolAfter(itemId);
        this.switchTimer();
    };
    BX.Sale.BasketActionPool.prototype.changeSku = function(itemId, props, oldProps) {
        if (JSON.stringify(props) !== JSON.stringify(oldProps)) {
            this.checkItemPoolBefore(itemId);
            this.pool[itemId].OFFER = props;
        } else {
            this.pool[itemId] && delete this.pool[itemId].OFFER;
            this.checkItemPoolAfter(itemId);
        }
        this.switchTimer();
    };
    BX.Sale.BasketActionPool.prototype.mergeSku = function(itemId) {
        this.checkItemPoolBefore(itemId);
        this.pool[itemId].MERGE_OFFER = 'Y';
        this.switchTimer();
    };
    BX.Sale.BasketActionPool.prototype.switchTimer = function() {
        clearTimeout(this.updateTimer);
        if (this.isProcessing()) return;
        if (this.isPoolEmpty()) {
            this.component.editPostponedBasketItems();
            this.component.fireCustomEvents();
        }
        if (!this.isPoolEmpty()) this.updateTimer = setTimeout(BX.proxy(this.trySendPool, this), 300);
        else if (!this.getRefreshStatus()) this.trySendPool();
    };
    BX.Sale.BasketActionPool.prototype.trySendPool = function() {
        if (this.isPoolEmpty() && this.getRefreshStatus()) return;
        this.doProcessing(true);
        if (!this.isPoolEmpty()) {
            this.component.sendRequest('recalculateAjax', {
                basket: this.getPoolData()
            });
            this.lastActualPool = this.pool;
            this.pool = {};
        } else if (!this.getRefreshStatus()) {
            this.component.sendRequest('refreshAjax', {
                fullRecalculation: this.needFullRecalculation ? 'Y' : 'N'
            });
            this.needFullRecalculation = false;
        }
    };
    BX.Sale.BasketActionPool.prototype.getPoolData = function() {
        var poolData = {}, currentPool = this.pool;
        if (currentPool.COUPON) {
            poolData.coupon = currentPool.COUPON;
            delete currentPool.COUPON;
        }
        if (currentPool.REMOVE_COUPON) {
            poolData.delete_coupon = currentPool.REMOVE_COUPON;
            delete currentPool.REMOVE_COUPON;
        }
        for(var id in currentPool)if (currentPool.hasOwnProperty(id)) {
            for(var action in currentPool[id])if (currentPool[id].hasOwnProperty(action) && BX.util.in_array(action, this.approvedAction)) poolData[action + '_' + id] = currentPool[id][action];
        }
        return poolData;
    };
    BX.Sale.BasketActionPool.prototype.isPoolEmpty = function() {
        return Object.keys(this.pool).length === 0;
    };
    BX.Sale.BasketActionPool.prototype.doProcessing = function(state) {
        this.requestProcessing = state === true;
        if (this.requestProcessing) this.component.startLoader();
        else this.component.endLoader();
    };
    BX.Sale.BasketActionPool.prototype.isProcessing = function() {
        return this.requestProcessing === true;
    };
})();


/* global BX */ /* eslint-disable no-prototype-builtins */ (function() {
    'use strict';
    BX.namespace('BX.Sale.BasketFilter');
    BX.Sale.BasketFilter = function(component) {
        this.component = component;
        this.activeFilterMode = false;
        this.filterTimer = null;
        this.mouseOverClearFilter = false;
        this.realShownItems = [];
        this.realSortedItems = [];
        this.realScrollTop = 0;
        this.lastShownItemsHash = '';
        this.currentFilter = {
            query: '',
            similarHash: '',
            warning: false,
            notAvailable: false,
            delayed: false
        };
        if (this.component.useItemsFilter) this.bindEvents();
    };
    BX.Sale.BasketFilter.prototype.bindEvents = function() {
        var entity;
        var filterNode = this.component.getEntity(this.component.getCacheNode(this.component.ids.itemListWrapper), 'basket-filter');
        entity = this.component.getEntity(filterNode, 'basket-filter-input');
        if (BX.type.isDomNode(entity)) {
            BX.bind(entity, 'focus', function() {
                filterNode.style.flex = 3;
            });
            BX.bind(entity, 'blur', BX.delegate(function() {
                if (!this.mouseOverClearFilter) filterNode.style.flex = '';
            }, this));
            BX.bind(entity, 'keyup', BX.proxy(this.onFilterInput, this));
            BX.bind(entity, 'cut', BX.proxy(this.onFilterInput, this));
            BX.bind(entity, 'paste', BX.proxy(this.onFilterInput, this));
        }
        entity = this.component.getEntity(filterNode, 'basket-filter-clear-btn');
        if (BX.type.isDomNode(entity)) {
            BX.bind(entity, 'mouseenter', BX.delegate(function() {
                this.mouseOverClearFilter = true;
            }, this));
            BX.bind(entity, 'mouseout', BX.delegate(function() {
                this.mouseOverClearFilter = false;
            }, this));
            BX.bind(entity, 'click', BX.delegate(function() {
                if (!this.filterInputEmpty()) {
                    this.clearFilterInput();
                    this.onFilterChange();
                }
                filterNode.style.flex = '';
            }, this));
        }
    };
    BX.Sale.BasketFilter.prototype.isActive = function() {
        return this.activeFilterMode;
    };
    BX.Sale.BasketFilter.prototype.showFilterByName = function(name) {
        if (!name) return;
        switch(name){
            case 'not-available':
                this.showNotAvailableItemsFilter();
                break;
            case 'delayed':
                this.showDelayItemsFilter();
                break;
            case 'warning':
                this.showWarningItemsFilter();
                break;
            case 'similar':
                this.showSimilarItemsFilter();
                break;
            case 'all':
            default:
                this.clearAllFiltersExcept([]);
                this.onFilterChange();
        }
    };
    BX.Sale.BasketFilter.prototype.onFilterInput = function() {
        var value = BX.type.isDomNode(BX.proxy_context) ? BX.util.trim(BX.proxy_context.value).toLowerCase() : '';
        if (this.currentFilter.query !== value) {
            this.currentFilter.query = value;
            this.onFilterChange();
        }
    };
    BX.Sale.BasketFilter.prototype.clearAllFiltersExcept = function(names) {
        if (!names || !BX.type.isArray(names)) return;
        !BX.util.in_array('input', names) && this.clearFilterInput();
        !BX.util.in_array('warning', names) && this.clearWarningItemsFilter();
        !BX.util.in_array('delayed', names) && this.clearDelayItemsFilter();
        !BX.util.in_array('not-available', names) && this.clearNotAvailableItemsFilter();
        if (!BX.util.in_array('similar', names)) {
            this.clearSimilarItemsFilter();
            this.component.showSimilarCount(false);
        }
    };
    BX.Sale.BasketFilter.prototype.filterInputEmpty = function() {
        return this.currentFilter.query.length === 0;
    };
    BX.Sale.BasketFilter.prototype.clearFilterInput = function() {
        this.currentFilter.query = '';
        var input = this.component.getEntity(this.component.getCacheNode(this.component.ids.itemListWrapper), 'basket-filter-input');
        if (BX.type.isDomNode(input)) input.value = '';
    };
    BX.Sale.BasketFilter.prototype.addWarningItemsFilter = function() {
        this.currentFilter.warning = true;
    };
    BX.Sale.BasketFilter.prototype.clearWarningItemsFilter = function() {
        this.currentFilter.warning = false;
    };
    BX.Sale.BasketFilter.prototype.showWarningItemsFilter = function() {
        if (!this.currentFilter.warning) {
            this.clearAllFiltersExcept([
                'warning'
            ]);
            this.addWarningItemsFilter();
            this.onFilterChange();
        }
    };
    BX.Sale.BasketFilter.prototype.addDelayItemsFilter = function() {
        this.currentFilter.delayed = true;
    };
    BX.Sale.BasketFilter.prototype.clearDelayItemsFilter = function() {
        this.currentFilter.delayed = false;
    };
    BX.Sale.BasketFilter.prototype.showDelayItemsFilter = function() {
        if (!this.currentFilter.delayed) {
            this.clearAllFiltersExcept([
                'delayed'
            ]);
            this.addDelayItemsFilter();
            this.onFilterChange();
        }
    };
    BX.Sale.BasketFilter.prototype.addNotAvailableItemsFilter = function() {
        this.currentFilter.notAvailable = true;
    };
    BX.Sale.BasketFilter.prototype.clearNotAvailableItemsFilter = function() {
        this.currentFilter.notAvailable = false;
    };
    BX.Sale.BasketFilter.prototype.showNotAvailableItemsFilter = function() {
        if (!this.currentFilter.notAvailable) {
            this.clearAllFiltersExcept([
                'not-available'
            ]);
            this.addNotAvailableItemsFilter();
            this.onFilterChange();
        }
    };
    BX.Sale.BasketFilter.prototype.addSimilarItemsFilter = function(item) {
        this.currentFilter.similarHash = item.HASH;
    };
    BX.Sale.BasketFilter.prototype.clearSimilarItemsFilter = function() {
        this.currentFilter.similarHash = '';
    };
    BX.Sale.BasketFilter.prototype.showSimilarItemsFilter = function() {
        var item = this.component.getItemDataByTarget(BX.proxy_context);
        if (this.currentFilter.similarHash !== item.HASH) {
            this.clearAllFiltersExcept([
                'similar'
            ]);
            this.addSimilarItemsFilter(item);
            this.onFilterChange();
        }
    };
    BX.Sale.BasketFilter.prototype.getTimeoutDuration = function() {
        return this.component.duration.filterTimer;
    };
    BX.Sale.BasketFilter.prototype.onFilterChange = function() {
        this.component.showItemsOverlay();
        if (this.currentFilter.query.length || this.currentFilter.similarHash.length || this.currentFilter.warning || this.currentFilter.notAvailable || this.currentFilter.delayed) {
            clearTimeout(this.filterTimer);
            this.filterTimer = setTimeout(BX.proxy(this.enableFilterMode, this), this.getTimeoutDuration());
        } else this.disableFilterMode();
    };
    BX.Sale.BasketFilter.prototype.enableFilterMode = function() {
        var foundItemsHash;
        if (!this.activeFilterMode) {
            this.activeFilterMode = true;
            this.realShownItems = BX.util.array_values(this.component.shownItems);
            this.realSortedItems = BX.util.array_values(this.component.sortedItems);
            this.realScrollTop = this.component.getDocumentScrollTop();
        }
        this.component.scrollToFirstItem();
        this.component.sortedItems = this.searchItems();
        foundItemsHash = JSON.stringify(this.component.sortedItems);
        if (this.lastShownItemsHash !== foundItemsHash) {
            this.lastShownItemsHash = foundItemsHash;
            this.component.deleteBasketItems(BX.util.array_values(this.component.shownItems), false);
            if (this.component.sortedItems.length) {
                this.component.initializeBasketItems();
                this.hideEmptyFilterResult();
            } else this.showEmptyFilterResult();
            if (this.currentFilter.similarHash.length) this.component.showSimilarCount(true);
        } else this.highlightFoundItems();
        this.component.hideItemsOverlay();
    };
    BX.Sale.BasketFilter.prototype.disableFilterMode = function() {
        clearTimeout(this.filterTimer);
        this.lastShownItemsHash = '';
        if (this.activeFilterMode) {
            this.activeFilterMode = false;
            this.component.sortedItems = BX.util.array_values(this.realSortedItems);
            this.component.deleteBasketItems(BX.util.array_values(this.component.shownItems), false);
            this.hideEmptyFilterResult();
            this.component.editBasketItems(BX.util.array_values(this.realShownItems));
            window.scrollTo(0, this.realScrollTop);
        }
        this.component.hideItemsOverlay();
    };
    BX.Sale.BasketFilter.prototype.searchItems = function() {
        var items = [];
        for(var i = 0; i < this.realSortedItems.length; i++){
            var item = this.component.items[this.realSortedItems[i]];
            if (item && this.searchItemMatch(item)) items.push(item.ID);
        }
        return items;
    };
    BX.Sale.BasketFilter.prototype.highlightFoundItems = function() {
        if (!this.activeFilterMode) return;
        for(var i in this.component.shownItems)if (this.component.shownItems.hasOwnProperty(i)) this.highlightSearchMatch(this.component.items[this.component.shownItems[i]]);
    };
    BX.Sale.BasketFilter.prototype.searchItemMatch = function(item) {
        var match = false, found = false;
        if (this.currentFilter.notAvailable) {
            found = !!item.NOT_AVAILABLE;
            if (!found) return match;
        } else if (this.currentFilter.delayed) {
            found = !!item.DELAYED;
            if (!found) return match;
        } else if (this.currentFilter.warning) {
            found = BX.util.in_array(item.ID, this.component.warningItems);
            if (!found) return match;
        } else if (BX.type.isNotEmptyString(this.currentFilter.similarHash)) {
            found = this.currentFilter.similarHash === item.HASH;
            if (!found) return match;
        }
        if (BX.type.isNotEmptyString(this.currentFilter.query)) {
            if (item.NAME.toLowerCase().indexOf(this.currentFilter.query) !== -1) match = 'NAME';
            if (!match) {
                var floatValue = parseFloat(this.currentFilter.query);
                if (!isNaN(floatValue)) {
                    if (parseFloat(item.PRICE) === floatValue) match = 'PRICE';
                    else if (parseFloat(item.SUM_PRICE) === floatValue) match = 'SUM_PRICE';
                }
            }
            if (!match && this.currentFilter.query.length >= 3) {
                if (item.PRICE_FORMATED.toLowerCase().indexOf(this.currentFilter.query) !== -1) match = 'PRICE';
                else if (item.SUM_PRICE_FORMATED.toLowerCase().indexOf(this.currentFilter.query) !== -1) match = 'SUM_PRICE';
            }
            var k, lcValue;
            if (!match && item.PROPS.length) {
                for(k in item.PROPS)if (item.PROPS.hasOwnProperty(k) && BX.type.isNotEmptyString(item.PROPS[k].VALUE)) {
                    lcValue = item.PROPS[k].VALUE.toLowerCase();
                    if (lcValue === this.currentFilter.query || this.currentFilter.query.length >= 3 && lcValue.indexOf(this.currentFilter.query) !== -1) {
                        match = 'PROPS';
                        break;
                    }
                }
            }
            if (!match && item.COLUMN_LIST.length) {
                for(k in item.COLUMN_LIST)if (item.COLUMN_LIST.hasOwnProperty(k) && BX.type.isNotEmptyString(item.COLUMN_LIST[k].VALUE)) {
                    lcValue = item.COLUMN_LIST[k].VALUE.toLowerCase();
                    if (lcValue === this.currentFilter.query || this.currentFilter.query.length >= 3 && lcValue.indexOf(this.currentFilter.query) !== -1) {
                        match = 'COLUMNS';
                        break;
                    }
                }
            }
        } else if (found) match = true;
        return match;
    };
    BX.Sale.BasketFilter.prototype.highlightSearchMatch = function(itemData) {
        var searchMatch = this.searchItemMatch(itemData);
        if (searchMatch) {
            var entity, i, k, code;
            switch(searchMatch){
                case 'NAME':
                    entity = this.component.getEntity(BX(this.component.ids.item + itemData.ID), 'basket-item-name');
                    if (BX.type.isDomNode(entity)) entity.innerHTML = itemData.NAME.replace(new RegExp('(.*)(' + this.currentFilter.query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')(.*)', 'gi'), function(full, match1, match2, match3) {
                        return BX.util.htmlspecialchars(match1) + '<span class="basket-item-highlighted">' + BX.util.htmlspecialchars(match2) + '</span>' + BX.util.htmlspecialchars(match3);
                    });
                    break;
                case 'PRICE':
                    entity = BX(this.component.ids.price + itemData.ID);
                    BX.addClass(entity, 'basket-item-highlighted');
                    break;
                case 'SUM_PRICE':
                    entity = BX(this.component.ids.sumPrice + itemData.ID);
                    BX.addClass(entity, 'basket-item-highlighted');
                    break;
                case 'PROPS':
                    entity = this.component.getEntities(BX(this.component.ids.item + itemData.ID), 'basket-item-property-value');
                    for(i = 0; i < entity.length; i++){
                        code = entity[i].getAttribute('data-property-code');
                        for(k in itemData.PROPS)if (itemData.PROPS.hasOwnProperty(k) && itemData.PROPS[k].CODE === code) entity[i].innerHTML = itemData.PROPS[k].VALUE.replace(new RegExp('(' + this.currentFilter.query + ')', 'gi'), '<span class="basket-item-highlighted">$1</span>');
                    }
                    break;
                case 'COLUMNS':
                    entity = this.component.getEntities(BX(this.component.ids.item + itemData.ID), 'basket-item-property-column-value');
                    for(i = 0; i < entity.length; i++){
                        code = entity[i].getAttribute('data-column-property-code');
                        for(k in itemData.COLUMN_LIST)if (itemData.COLUMN_LIST.hasOwnProperty(k) && itemData.COLUMN_LIST[k].CODE === code) entity[i].innerHTML = itemData.COLUMN_LIST[k].VALUE.replace(new RegExp('(' + this.currentFilter.query + ')', 'gi'), '<span class="basket-item-highlighted">$1</span>');
                    }
                    break;
            }
        }
    };
    BX.Sale.BasketFilter.prototype.showEmptyFilterResult = function() {
        var itemListNode = this.component.getCacheNode(this.component.ids.itemList);
        if (BX.type.isDomNode(itemListNode) && itemListNode.clientHeight >= 500) {
            var emptyResultNode = this.component.getCacheNode(this.component.ids.itemListEmptyResult);
            if (BX.type.isDomNode(emptyResultNode)) emptyResultNode.style.display = '';
        }
    };
    BX.Sale.BasketFilter.prototype.hideEmptyFilterResult = function() {
        var emptyResultNode = this.component.getCacheNode(this.component.ids.itemListEmptyResult);
        if (BX.type.isDomNode(emptyResultNode)) emptyResultNode.style.display = 'none';
    };
})();


/* global BX, Mustache */ /* eslint-disable no-prototype-builtins */ (function() {
    'use strict';
    BX.namespace('BX.Sale.BasketComponent');
    BX.Sale.BasketComponent = {
        maxItemsShowCount: 30,
        minOrderPrice: 500,
        precisionFactor: Math.pow(10, 6),
        stickyHeaderOffset: 0,
        duration: {
            priceAnimation: 300,
            filterTimer: 300
        },
        ids: {
            item: 'basket-item-',
            quantity: 'basket-item-quantity-',
            price: 'basket-item-price-',
            sumPrice: 'basket-item-sum-price-',
            sumPriceOld: 'basket-item-sum-price-old-',
            sumPriceDiff: 'basket-item-sum-price-difference-',
            itemHeightAligner: 'basket-item-height-aligner-',
            total: 'basket-total-price',
            basketRoot: 'basket-root',
            itemListWrapper: 'basket-items-list-wrapper',
            itemListContainer: 'basket-items-list-container',
            itemList: 'basket-item-list',
            itemListTable: 'basket-item-table',
            itemListEmptyResult: 'basket-item-list-empty-result',
            itemListOverlay: 'basket-items-list-overlay',
            warning: 'basket-warning'
        },
        initializePrimaryFields: function() {
            this.templates = {};
            this.nodes = {};
            /** Object of all basket items (itemId => itemArray) */ this.items = {};
            /** Array of all basket items to show sorted by field SORT */ this.sortedItems = [];
            /** Array of basket items showed on screen */ this.shownItems = [];
            /** Array of basket items changed since last request */ this.changedItems = [];
            /** Array of basket items postponed by pool to edit */ this.postponedItems = [];
            /** Array of basket items with warnings */ this.warningItems = [];
            this.isMobile = BX.browser.IsMobile();
            this.isTouch = BX.hasClass(document.documentElement, 'bx-touch');
            this.lastAction = 'initialLoad';
            this.coupons = null;
            this.imagePopup = null;
            this.loadingScreen = null;
            this.quantityDelay = null;
            this.quantityTimer = null;
        },
        init: function(parameters) {
            this.initializePrimaryFields();
            this.params = parameters.params || {};
            this.template = parameters.template || '';
            this.signedParamsString = parameters.signedParamsString || '';
            this.siteId = parameters.siteId || '';
            this.siteTemplateId = parameters.siteTemplateId || '';
            this.ajaxUrl = this.params.AJAX_PATH || '';
            this.templateFolder = parameters.templateFolder || '';
            this.useDynamicScroll = this.params.USE_DYNAMIC_SCROLL === 'Y';
            this.useItemsFilter = this.params.SHOW_FILTER === 'Y' && !this.isMobile;
            this.initializeFilter();
            this.applyBasketResult(parameters.result);
            this.initializeActionPool();
            if (this.useItemsFilter) {
                this.checkHeaderDisplay();
                this.bindHeaderEvents();
            }
            this.initializeBasketItems();
            this.editTotal();
            this.editWarnings();
            this.getCacheNode(this.ids.basketRoot).style.opacity = 1;
            this.bindInitialEvents();
        },
        getTemplate: function(templateName) {
            if (!this.templates.hasOwnProperty(templateName)) {
                var template = BX(templateName);
                this.templates[templateName] = BX.type.isDomNode(template) ? template.innerHTML : '';
            }
            return this.templates[templateName];
        },
        getCacheNode: function(id) {
            if (!this.nodes.hasOwnProperty(id)) this.nodes[id] = BX(id);
            return this.nodes[id];
        },
        getEntity: function(parent, entity, additionalFilter) {
            if (!parent || !entity) return null;
            additionalFilter = additionalFilter || '';
            return parent.querySelector(additionalFilter + '[data-entity="' + entity + '"]');
        },
        getEntities: function(parent, entity, additionalFilter) {
            if (!parent || !entity) return {
                length: 0
            };
            additionalFilter = additionalFilter || '';
            return parent.querySelectorAll(additionalFilter + '[data-entity="' + entity + '"]');
        },
        bindInitialEvents: function() {
            this.bindWarningEvents();
            BX.bind(window, 'scroll', BX.proxy(this.checkStickyHeaders, this));
            BX.bind(window, 'scroll', BX.proxy(this.lazyLoad, this));
            BX.bind(window, 'resize', BX.throttle(this.checkStickyHeaders, 20, this));
        },
        bindWarningEvents: function() {
            var showItemsNode = this.getEntity(BX(this.ids.warning), 'basket-items-warning-count');
            if (BX.type.isDomNode(showItemsNode)) {
                showItemsNode.style.display = '';
                BX.bind(showItemsNode, 'click', BX.delegate(function() {
                    this.toggleFilter('warning');
                }, this));
            }
            BX.bind(this.getEntity(BX(this.ids.warning), 'basket-items-warning-notification-close'), 'click', BX.proxy(this.removeAllWarnings, this));
        },
        toggleFilter: function(event) {
            var target = BX.type.isNotEmptyString(event) ? this.getEntity(this.getCacheNode(this.ids.itemListWrapper), 'basket-items-count', '[data-filter="' + event + '"]') : BX.getEventTarget(event);
            if (!BX.type.isDomNode(target) || BX.hasClass(target, 'active')) return;
            var entityName = target.getAttribute('data-filter');
            var entities = target.parentNode.querySelectorAll('[data-filter]');
            for(var i = 0; i < entities.length; i++){
                if (entities[i].getAttribute('data-filter') === entityName) BX.addClass(entities[i], 'active');
                else if (BX.hasClass(entities[i], 'active')) BX.removeClass(entities[i], 'active');
            }
            this.filter.showFilterByName(entityName);
        },
        scrollToFirstItem: function() {
            var headerNode = this.getEntity(this.getCacheNode(this.ids.itemListWrapper), 'basket-items-list-header');
            if (BX.type.isDomNode(headerNode)) {
                var itemListTopPosition = BX.pos(this.getCacheNode(this.ids.itemListContainer)).top;
                var headerBottomPosition = BX.pos(headerNode).bottom;
                if (itemListTopPosition < headerBottomPosition) window.scrollTo(0, itemListTopPosition - this.stickyHeaderOffset);
            }
        },
        showItemsOverlay: function() {
            var overlay = this.getCacheNode(this.ids.itemListOverlay);
            if (BX.type.isDomNode(overlay)) overlay.style.display = '';
        },
        hideItemsOverlay: function() {
            var overlay = this.getCacheNode(this.ids.itemListOverlay);
            if (BX.type.isDomNode(overlay)) overlay.style.display = 'none';
        },
        checkHeaderDisplay: function() {
            var header = this.getCacheNode(this.ids.itemListWrapper);
            if (BX.type.isDomNode(header)) BX.removeClass(header, 'basket-items-list-wrapper-light');
        },
        bindHeaderEvents: function() {
            var entities = this.getEntities(this.getCacheNode(this.ids.itemListWrapper), 'basket-items-count');
            for(var i = 0; i < entities.length; i++)BX.bind(entities[i], 'click', BX.proxy(this.toggleFilter, this));
        },
        checkStickyHeaders: function() {
            if (this.isMobile) return;
            var node, position;
            var border = 2, offset = 0;
            var scrollTop = this.getDocumentScrollTop();
            var basketPosition = BX.pos(this.getCacheNode(this.ids.basketRoot));
            var basketScrolledToEnd = scrollTop + 200 >= basketPosition.bottom;
            if (BX.util.in_array('top', this.params.TOTAL_BLOCK_DISPLAY)) {
                var totalBlockNode = this.getEntity(this.getCacheNode(this.ids.basketRoot), 'basket-total-block');
                if (BX.type.isDomNode(totalBlockNode)) {
                    node = this.getEntity(totalBlockNode, 'basket-checkout-aligner');
                    if (BX.type.isDomNode(node)) {
                        position = BX.pos(totalBlockNode);
                        if (scrollTop >= position.top) {
                            offset += node.clientHeight;
                            if (!BX.hasClass(node, 'basket-checkout-container-fixed')) {
                                totalBlockNode.style.height = position.height + 'px';
                                node.style.width = node.clientWidth + border + 'px';
                                BX.addClass(node, 'basket-checkout-container-fixed');
                            }
                        } else if (BX.hasClass(node, 'basket-checkout-container-fixed')) {
                            totalBlockNode.style.height = '';
                            node.style.width = '';
                            BX.removeClass(node, 'basket-checkout-container-fixed');
                        }
                        if (basketScrolledToEnd) {
                            if (!BX.hasClass(node, 'basket-checkout-container-fixed-hide')) BX.addClass(node, 'basket-checkout-container-fixed-hide');
                        } else if (BX.hasClass(node, 'basket-checkout-container-fixed-hide')) BX.removeClass(node, 'basket-checkout-container-fixed-hide');
                    }
                }
            }
            if (this.useItemsFilter) {
                var itemWrapperNode = this.getCacheNode(this.ids.itemListWrapper);
                node = this.getEntity(itemWrapperNode, 'basket-items-list-header');
                if (BX.type.isDomNode(node)) {
                    position = BX.pos(itemWrapperNode);
                    if (scrollTop + offset >= position.top && !basketScrolledToEnd) {
                        if (!BX.hasClass(node, 'basket-items-list-header-fixed')) {
                            node.style.width = node.clientWidth + border + 'px';
                            itemWrapperNode.style.paddingTop = node.clientHeight + 'px';
                            BX.addClass(node, 'basket-items-list-header-fixed');
                        }
                        if (offset) node.style.top = offset + 'px';
                        offset += node.clientHeight;
                    } else if (BX.hasClass(node, 'basket-items-list-header-fixed')) {
                        itemWrapperNode.style.paddingTop = '';
                        node.style.width = '';
                        node.style.top = '';
                        BX.removeClass(node, 'basket-items-list-header-fixed');
                    }
                }
            }
            this.stickyHeaderOffset = offset;
        },
        getDocumentScrollTop: function() {
            return window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);
        },
        lazyLoad: function() {
            var itemsNodePosition = BX.pos(this.getCacheNode(this.ids.itemListContainer));
            if (this.getDocumentScrollTop() + window.innerHeight >= itemsNodePosition.bottom - 400) {
                var itemIds = this.getItemsAfter();
                if (itemIds.length) this.editBasketItems(itemIds);
            }
        },
        fireCustomEvents: function() {
            if (this.result.EVENT_ONCHANGE_ON_START === 'Y') BX.onCustomEvent('OnBasketChange');
            if (this.params.HIDE_COUPON !== 'Y') {
                if (this.coupons !== null && this.coupons !== this.result.COUPON_LIST) BX.onCustomEvent('OnCouponApply');
                this.coupons = this.result.COUPON_LIST;
            }
        },
        editTotal: function() {
            this.fillTotalBlocks();
            this.showItemsCount();
            this.showWarningItemsCount();
            this.showNotAvailableItemsCount();
            this.showDelayedItemsCount();
        },
        fillTotalBlocks: function() {
            var totalNodes = this.getEntities(this.getCacheNode(this.ids.basketRoot), 'basket-total-block');
            if (totalNodes && totalNodes.length) {
                var totalTemplate = this.getTemplate('basket-total-template');
                if (totalTemplate) {
                    var totalRender = this.render(totalTemplate, this.result.TOTAL_RENDER_DATA);
                    for(var i in totalNodes)if (totalNodes.hasOwnProperty(i) && BX.type.isDomNode(totalNodes[i])) {
                        totalNodes[i].innerHTML = totalRender;
                        this.bindTotalEvents(totalNodes[i]);
                    }
                    BX.onCustomEvent('onCompleteAction', [
                        {
                            action: 'loadBasket'
                        }
                    ]);
                }
            }
            this.checkStickyHeaders();
        },
        getAllSortedItems: function() {
            return this.filter && this.filter.isActive() ? this.filter.realSortedItems : this.sortedItems;
        },
        showItemsCount: function() {
            var itemCountNode = this.getEntity(this.getCacheNode(this.ids.itemListWrapper), 'basket-items-count', '[data-filter="all"]');
            if (BX.type.isDomNode(itemCountNode)) {
                var basketItemCount = 0;
                var sortedItems = this.getAllSortedItems();
                for(var i = 0; i < sortedItems.length; i++)if (this.items[sortedItems[i]] && !this.items[sortedItems[i]].DELAYED) basketItemCount++;
                itemCountNode.innerHTML = "\u0412 \u043A\u043E\u0440\u0437\u0438\u043D\u0435 " + basketItemCount + ' ' + this.getGoodsMessage(basketItemCount);
                itemCountNode.style.display = '';
            }
        },
        showSimilarCount: function(state) {
            var itemCountNode = this.getEntity(this.getCacheNode(this.ids.itemListWrapper), 'basket-items-count', '[data-filter="similar"]');
            if (BX.type.isDomNode(itemCountNode)) {
                if (state) {
                    itemCountNode.innerHTML = this.sortedItems.length + ' ' + this.getGoodsMessage(this.result.BASKET_ITEMS_COUNT, 'SBB_SIMILAR_ITEM');
                    itemCountNode.style.display = '';
                } else itemCountNode.style.display = 'none';
            }
        },
        showWarningItemsCount: function() {
            var itemCountNode = this.getEntity(this.getCacheNode(this.ids.itemListWrapper), 'basket-items-count', '[data-filter="warning"]');
            if (BX.type.isDomNode(itemCountNode)) {
                if (this.warningItems.length) {
                    itemCountNode.innerHTML = this.warningItems.length + ' ' + BX.message('SBB_BASKET_ITEMS_WARNING');
                    itemCountNode.style.display = '';
                } else itemCountNode.style.display = 'none';
            }
        },
        showNotAvailableItemsCount: function() {
            var itemCountNode = this.getEntity(this.getCacheNode(this.ids.itemListWrapper), 'basket-items-count', '[data-filter="not-available"]');
            if (BX.type.isDomNode(itemCountNode)) {
                if (parseInt(this.result.NOT_AVAILABLE_BASKET_ITEMS_COUNT)) {
                    itemCountNode.innerHTML = this.result.NOT_AVAILABLE_BASKET_ITEMS_COUNT + ' ' + this.getGoodsMessage(this.result.NOT_AVAILABLE_BASKET_ITEMS_COUNT, 'SBB_NOT_AVAILABLE_ITEM');
                    itemCountNode.style.display = '';
                } else itemCountNode.style.display = 'none';
            }
        },
        showDelayedItemsCount: function() {
            var itemCountNode = this.getEntity(this.getCacheNode(this.ids.itemListWrapper), 'basket-items-count', '[data-filter="delayed"]');
            if (BX.type.isDomNode(itemCountNode)) {
                var delayedItemCount = 0;
                var sortedItems = this.getAllSortedItems();
                for(var i = 0; i < sortedItems.length; i++)if (this.items[sortedItems[i]] && this.items[sortedItems[i]].DELAYED) delayedItemCount++;
                itemCountNode.innerHTML = delayedItemCount + ' ' + this.getFavoriteMessage(delayedItemCount);
                itemCountNode.style.display = '';
            }
        },
        getGoodsMessage: function(count, customMessage) {
            var mesCode;
            var countReminder = count > 10 && count < 20 ? 0 : count % 10;
            if (countReminder === 1) mesCode = customMessage || "\u0442\u043E\u0432\u0430\u0440";
            else if (countReminder >= 2 && countReminder <= 4) mesCode = customMessage ? customMessage + '_2' : "\u0442\u043E\u0432\u0430\u0440\u0430";
            else mesCode = customMessage ? customMessage + 'S' : "\u0442\u043E\u0432\u0430\u0440\u043E\u0432";
            return mesCode;
        },
        getFavoriteMessage: function(count) {
            count = Math.abs(parseInt(count, 10)) || 0;
            var lastTwoDigits = count % 100;
            var lastDigit = count % 10;
            if (lastTwoDigits < 11 || lastTwoDigits > 19) {
                if (lastDigit === 1) return "\u0438\u0437\u0431\u0440\u0430\u043D\u043D\u044B\u0439";
            }
            return "\u0438\u0437\u0431\u0440\u0430\u043D\u043D\u044B\u0445";
        },
        bindTotalEvents: function(node) {
            if (!this.result.TOTAL_RENDER_DATA.DISABLE_CHECKOUT) BX.bind(this.getEntity(node, 'basket-checkout-button'), 'click', BX.proxy(this.checkOutAction, this));
            BX.bind(this.getEntity(node, 'basket-coupon-input'), 'change', BX.proxy(this.addCouponAction, this));
            BX.bind(this.getEntity(node, 'basket-coupon-input'), 'paste', BX.proxy(this.pasteCouponAction, this));
            var couponNodes = this.getEntities(node, 'basket-coupon-delete');
            for(var i = 0, l = couponNodes.length; i < l; i++)BX.bind(couponNodes[i], 'click', BX.proxy(this.removeCouponAction, this));
        },
        checkOutAction: function() {
            document.location.href = this.params.PATH_TO_ORDER;
        },
        addCouponAction: function(event) {
            var target = BX.getEventTarget(event);
            if (target && target.value) {
                this.actionPool.addCoupon(target.value);
                target.disabled = true;
            }
        },
        pasteCouponAction: function(event) {
            setTimeout(BX.delegate(function() {
                this.addCouponAction(event);
            }, this), 10);
        },
        removeCouponAction: function() {
            var value = BX.proxy_context && BX.util.trim(BX.proxy_context.getAttribute('data-coupon'));
            if (value) this.actionPool.removeCoupon(value);
        },
        initializeActionPool: function() {
            this.actionPool = new BX.Sale.BasketActionPool(this);
        },
        initializeFilter: function() {
            this.filter = new BX.Sale.BasketFilter(this);
        },
        /**
         * Send ajax request with basket data and executes callback by action
         */ sendRequest: function(action, data) {
            this.lastAction = action;
            if (this.lastAction === 'recalculateAjax') {
                // we use it to reload all items if applied discounts changed
                data.lastAppliedDiscounts = BX.util.array_keys(this.result.FULL_DISCOUNT_LIST).join(',');
                if (this.params.USE_ENHANCED_ECOMMERCE === 'Y') this.checkAnalytics(data);
            }
            BX.ajax({
                method: 'POST',
                dataType: 'json',
                url: this.ajaxUrl,
                data: this.getData(data),
                onsuccess: BX.delegate(function(result) {
                    this.actionPool.doProcessing(false);
                    if (!BX.type.isPlainObject(result)) return;
                    this.actionPool.setRefreshStatus(result.BASKET_REFRESHED);
                    if (result.RESTORED_BASKET_ITEMS) this.restoreBasketItems(result.RESTORED_BASKET_ITEMS);
                    if (result.DELETED_BASKET_ITEMS) this.deleteBasketItems(result.DELETED_BASKET_ITEMS, this.params.SHOW_RESTORE === 'Y');
                    if (result.MERGED_BASKET_ITEMS) this.deleteBasketItems(result.MERGED_BASKET_ITEMS, false, true);
                    this.applyBasketResult(result.BASKET_DATA);
                    this.editBasketItems(this.getItemsToEdit());
                    this.editTotal();
                    this.applyPriceAnimation();
                    this.editWarnings();
                    this.actionPool.switchTimer();
                    if (this.isBasketIntegrated() && this.isBasketChanged()) BX.Sale.OrderAjaxComponent.sendRequest();
                }, this),
                onfailure: BX.delegate(function() {
                    this.actionPool.doProcessing(false);
                }, this)
            });
        },
        isBasketIntegrated: function() {
            return this.params.BASKET_WITH_ORDER_INTEGRATION === 'Y';
        },
        isBasketChanged: function() {
            return this.changedItems.length;
        },
        addPriceAnimationData: function(nodeId, start, finish, currency) {
            if (!BX.type.isPlainObject(this.priceAnimationData)) this.clearPriceAnimationData();
            this.priceAnimationData.start[nodeId] = parseFloat(start);
            this.priceAnimationData.finish[nodeId] = parseFloat(finish);
            this.priceAnimationData.currency[nodeId] = currency;
            this.priceAnimationData.int[nodeId] = parseFloat(start) === parseInt(start) && parseFloat(finish) === parseInt(finish);
        },
        clearPriceAnimationData: function() {
            this.priceAnimationData = {
                start: {},
                finish: {},
                currency: {},
                int: {}
            };
        },
        applyBasketResult: function(result) {
            this.changedItems = [];
            this.clearPriceAnimationData();
            if (!BX.type.isPlainObject(result)) return;
            if (result.BASKET_ITEM_RENDER_DATA) {
                var i, newData;
                for(i in result.BASKET_ITEM_RENDER_DATA)if (result.BASKET_ITEM_RENDER_DATA.hasOwnProperty(i)) {
                    newData = result.BASKET_ITEM_RENDER_DATA[i];
                    newData.WARNINGS = this.checkBasketItemWarnings(newData, result.WARNING_MESSAGE_WITH_CODE);
                    if (this.items[newData.ID]) {
                        if (JSON.stringify(this.items[newData.ID]) === JSON.stringify(newData)) continue;
                    } else this.addSortedItem(newData.ID, true);
                    this.changedItems.push(newData.ID);
                    newData = this.checkBasketItemsAnimation(newData);
                    this.items[newData.ID] = newData;
                }
                this.changedItems = BX.util.array_unique(this.changedItems.concat(this.getChangedSimilarOffers()));
                if (this.isBasketChanged()) this.sortSortedItems(true);
            }
            if (result.TOTAL_RENDER_DATA) {
                result.TOTAL_RENDER_DATA = this.checkCheckoutRestrictions(result.TOTAL_RENDER_DATA);
                result.TOTAL_RENDER_DATA = this.checkTotalAnimation(result.TOTAL_RENDER_DATA);
            }
            this.result = result;
        },
        itemSortFunction: function(a, b) {
            if (!this.items.hasOwnProperty(a) || !this.items.hasOwnProperty(b)) return 0;
            return parseFloat(this.items[a].SORT) - parseFloat(this.items[b].SORT);
        },
        getChangedSimilarOffers: function() {
            var changedSimilarOffers = [];
            var otherSimilarItemsQuantity, totalSimilarItemsQuantity;
            var hashMap = this.getHashMap();
            for(var hash in hashMap)if (hashMap.hasOwnProperty(hash)) {
                if (hashMap[hash].length > 1) for(var i = 0; i < hashMap[hash].length; i++){
                    otherSimilarItemsQuantity = 0;
                    totalSimilarItemsQuantity = 0;
                    for(var k = 0; k < hashMap[hash].length; k++){
                        if (hashMap[hash][k] != hashMap[hash][i]) otherSimilarItemsQuantity += parseFloat(this.items[hashMap[hash][k]].QUANTITY);
                        totalSimilarItemsQuantity += parseFloat(this.items[hashMap[hash][k]].QUANTITY);
                    }
                    if (!this.items[hashMap[hash][i]].HAS_SIMILAR_ITEMS || this.items[hashMap[hash][i]].SIMILAR_ITEMS_QUANTITY != otherSimilarItemsQuantity || this.items[hashMap[hash][i]].TOTAL_SIMILAR_ITEMS_QUANTITY != totalSimilarItemsQuantity) {
                        changedSimilarOffers.push(hashMap[hash][i]);
                        this.items[hashMap[hash][i]].HAS_SIMILAR_ITEMS = true;
                        this.items[hashMap[hash][i]].SIMILAR_ITEMS_QUANTITY = otherSimilarItemsQuantity;
                        this.items[hashMap[hash][i]].TOTAL_SIMILAR_ITEMS_QUANTITY = totalSimilarItemsQuantity;
                        this.items[hashMap[hash][i]].ALL_AVAILABLE_QUANTITY = this.items[hashMap[hash][i]].AVAILABLE_QUANTITY;
                        this.items[hashMap[hash][i]].AVAILABLE_QUANTITY = this.items[hashMap[hash][i]].ALL_AVAILABLE_QUANTITY - otherSimilarItemsQuantity;
                    }
                }
                else if (hashMap[hash][0] && this.items[hashMap[hash][0]].HAS_SIMILAR_ITEMS) {
                    changedSimilarOffers.push(hashMap[hash][0]);
                    delete this.items[hashMap[hash][0]].HAS_SIMILAR_ITEMS;
                    delete this.items[hashMap[hash][0]].SIMILAR_ITEMS_QUANTITY;
                    delete this.items[hashMap[hash][0]].TOTAL_SIMILAR_ITEMS_QUANTITY;
                    this.items[hashMap[hash][0]].AVAILABLE_QUANTITY = this.items[hashMap[hash][0]].ALL_AVAILABLE_QUANTITY;
                    delete this.items[hashMap[hash][0]].ALL_AVAILABLE_QUANTITY;
                }
            }
            return changedSimilarOffers;
        },
        getHashMap: function() {
            var hashMap = {};
            for(var id in this.items)if (this.items.hasOwnProperty(id) && this.isItemAvailable(id)) {
                if (!hashMap.hasOwnProperty(this.items[id].HASH)) hashMap[this.items[id].HASH] = [];
                hashMap[this.items[id].HASH].push(id);
            }
            return hashMap;
        },
        isItemAvailable: function(itemId) {
            var sortedItems = this.filter.isActive() ? this.filter.realSortedItems : this.sortedItems;
            return !this.items[itemId].NOT_AVAILABLE && !this.items[itemId].SHOW_RESTORE && BX.util.in_array(itemId, sortedItems);
        },
        checkCheckoutRestrictions: function(totalData) {
            if (!BX.type.isPlainObject(totalData)) return totalData;
            var price = parseFloat(totalData.PRICE);
            if (!isNaN(price) && price < this.minOrderPrice) totalData.DISABLE_CHECKOUT = true;
            return totalData;
        },
        checkTotalAnimation: function(totalData) {
            if (this.result && this.result.TOTAL_RENDER_DATA && parseFloat(this.result.TOTAL_RENDER_DATA.PRICE) > parseFloat(totalData.PRICE)) {
                totalData.PRICE_NEW = totalData.PRICE;
                totalData.PRICE = this.result.TOTAL_RENDER_DATA.PRICE;
                totalData.PRICE_FORMATED_NEW = totalData.PRICE_FORMATED;
                totalData.PRICE_FORMATED = this.result.TOTAL_RENDER_DATA.PRICE_FORMATED;
                this.addPriceAnimationData(this.ids.total, totalData.PRICE, totalData.PRICE_NEW, totalData.CURRENCY);
            }
            return totalData;
        },
        checkBasketItemsAnimation: function(itemData) {
            var itemId = itemData.ID;
            if (this.items[itemId]) {
                var quantityNode = BX(this.ids.quantity + itemId);
                if (BX.type.isDomNode(quantityNode) && !this.actionPool.isItemInPool(itemId) && parseFloat(quantityNode.value) !== parseFloat(itemData.QUANTITY)) {
                    itemData.QUANTITY_ANIMATION = true;
                    this.actionPool.clearLastActualQuantityPool(itemId);
                }
                if (parseFloat(this.items[itemId].PRICE) > parseFloat(itemData.PRICE)) {
                    itemData.PRICE_NEW = itemData.PRICE;
                    itemData.PRICE = this.items[itemId].PRICE;
                    itemData.PRICE_FORMATED_NEW = itemData.PRICE_FORMATED;
                    itemData.PRICE_FORMATED = this.items[itemId].PRICE_FORMATED;
                    this.addPriceAnimationData(this.ids.price + itemId, itemData.PRICE, itemData.PRICE_NEW, itemData.CURRENCY);
                }
                if (BX.util.in_array('SUM', this.params.COLUMNS_LIST) && parseFloat(this.items[itemId].SUM_PRICE) > parseFloat(itemData.SUM_PRICE) && parseFloat(this.items[itemId].QUANTITY) === parseFloat(itemData.QUANTITY)) {
                    itemData.SUM_PRICE_NEW = itemData.SUM_PRICE;
                    itemData.SUM_PRICE = this.items[itemId].SUM_PRICE;
                    itemData.SUM_PRICE_FORMATED_NEW = itemData.SUM_PRICE_FORMATED;
                    itemData.SUM_PRICE_FORMATED = this.items[itemId].SUM_PRICE_FORMATED;
                    this.addPriceAnimationData(this.ids.sumPrice + itemId, itemData.SUM_PRICE, itemData.SUM_PRICE_NEW, itemData.CURRENCY);
                }
            }
            return itemData;
        },
        getData: function(data) {
            data = data || {};
            data[this.params.ACTION_VARIABLE] = this.lastAction;
            data.via_ajax = 'Y';
            data.site_id = this.siteId;
            data.site_template_id = this.siteTemplateId;
            data.sessid = BX.bitrix_sessid();
            data.template = this.template;
            data.signedParamsString = this.signedParamsString;
            return data;
        },
        startLoader: function() {
        // if (!this.loadingScreen)
        // {
        // 	this.loadingScreen = new BX.PopupWindow('loading_screen', null, {
        // 		events: {
        // 			onAfterPopupShow: BX.delegate(function() {
        // 				BX.cleanNode(this.loadingScreen.popupContainer);
        // 				BX.removeClass(this.loadingScreen.popupContainer, 'popup-window');
        // 				this.loadingScreen.popupContainer.appendChild(
        // 					BX.create('IMG', {props: {src: this.templateFolder + '/images/loader.gif'}})
        // 				);
        // 				this.loadingScreen.popupContainer.removeAttribute('style');
        // 				this.loadingScreen.popupContainer.style.display = 'block';
        // 			}, this)
        // 		}
        // 	});
        // 	BX.addClass(this.loadingScreen.popupContainer, 'bx-step-opacity');
        // }
        //
        // this.loadingScreen.show();
        },
        /**
         * Hiding loader image with overlay.
         */ endLoader: function() {
        // if (this.loadingScreen && this.loadingScreen.isShown())
        // {
        // 	this.loadingScreen.close();
        // }
        },
        editWarnings: function() {
            this.editGeneralWarnings();
            this.editBasketItemWarnings();
            this.toggleWarningBlock();
            this.showWarningItemsCount();
        },
        editGeneralWarnings: function() {
            var warningsNode = this.getEntity(this.getCacheNode(this.ids.warning), 'basket-general-warnings');
            if (BX.type.isDomNode(warningsNode)) {
                var generalWarningText = warningsNode.innerHTML;
                if (this.result.WARNING_MESSAGE_WITH_CODE) for(var code in this.result.WARNING_MESSAGE_WITH_CODE){
                    if (this.result.WARNING_MESSAGE_WITH_CODE.hasOwnProperty(code)) {
                        if (!this.items[code] && generalWarningText.indexOf(this.result.WARNING_MESSAGE_WITH_CODE[code]) === -1) generalWarningText += this.result.WARNING_MESSAGE_WITH_CODE[code] + '<br/>';
                    }
                }
                if (generalWarningText) {
                    warningsNode.innerHTML = generalWarningText;
                    warningsNode.style.display = '';
                } else {
                    warningsNode.style.display = 'none';
                    warningsNode.innerHTML = '';
                }
            }
        },
        editBasketItemWarnings: function() {
            var itemsWarningsNode = this.getEntity(this.getCacheNode(this.ids.warning), 'basket-item-warnings');
            if (BX.type.isDomNode(itemsWarningsNode)) {
                if (this.warningItems.length) {
                    var warningCount = this.getEntity(itemsWarningsNode, 'basket-items-warning-count');
                    if (BX.type.isDomNode(warningCount)) warningCount.innerHTML = this.warningItems.length + ' ' + this.getGoodsMessage(this.warningItems.length);
                    itemsWarningsNode.style.display = '';
                } else if (itemsWarningsNode.style.display !== 'none') {
                    itemsWarningsNode.style.display = 'none';
                    if (this.filter.isActive()) this.toggleFilter('all');
                }
            }
        },
        toggleWarningBlock: function() {
            var warningNode = this.getCacheNode(this.ids.warning);
            if (BX.type.isDomNode(warningNode)) {
                var generalWarningNode = this.getEntity(warningNode, 'basket-general-warnings');
                var itemsWarningsNode = this.getEntity(warningNode, 'basket-item-warnings');
                if ((!BX.type.isDomNode(generalWarningNode) || generalWarningNode.style.display === 'none') && (!BX.type.isDomNode(itemsWarningsNode) || itemsWarningsNode.style.display === 'none')) warningNode.style.display = '';
                else warningNode.style.display = 'flex';
            }
        },
        checkBasketItemWarnings: function(itemData, warnings) {
            if (!itemData) return;
            var itemWarnings;
            if (this.items[itemData.ID] && this.lastAction === 'refreshAjax') itemWarnings = this.items[itemData.ID].WARNINGS;
            else itemWarnings = [];
            if (BX.type.isArray(warnings[itemData.ID]) && warnings[itemData.ID].length) {
                for(var i in warnings[itemData.ID])if (warnings[itemData.ID].hasOwnProperty(i) && !BX.util.in_array(warnings[itemData.ID][i], itemWarnings)) itemWarnings.push(warnings[itemData.ID][i]);
            }
            if (itemWarnings.length) {
                if (!BX.util.in_array(itemData.ID, this.warningItems)) this.warningItems.push(itemData.ID);
            } else if (BX.util.in_array(itemData.ID, this.warningItems)) this.warningItems.splice(BX.util.array_search(itemData.ID, this.warningItems), 1);
            return itemWarnings;
        },
        removeAllWarnings: function(event) {
            this.clearGeneralWarnings();
            this.clearBasketItemsWarnings();
            this.editWarnings();
            event && event.preventDefault();
        },
        clearGeneralWarnings: function() {
            this.result.WARNING_MESSAGE_WITH_CODE = {};
            var generalWarningNode = this.getEntity(this.getCacheNode(this.ids.warning), 'basket-general-warnings');
            if (BX.type.isDomNode(generalWarningNode)) generalWarningNode.innerHTML = '';
        },
        clearBasketItemsWarnings: function() {
            var itemsToEdit = [];
            for(var i in this.warningItems)if (this.warningItems.hasOwnProperty(i)) {
                this.items[this.warningItems[i]].WARNINGS = [];
                if (this.isItemShown(this.warningItems[i])) itemsToEdit.push(this.warningItems[i]);
            }
            this.warningItems = [];
            this.editBasketItems(itemsToEdit);
        },
        isItemShown: function(itemId) {
            return BX.util.in_array(itemId, this.shownItems);
        },
        initializeBasketItems: function() {
            if (Object.keys(this.items).length === 0) return;
            for(var i = 0; i < this.sortedItems.length; i++){
                if (this.useDynamicScroll && this.shownItems.length >= this.maxItemsShowCount) break;
                this.createBasketItem(this.sortedItems[i]);
            }
        },
        createBasketItem: function(itemId) {
            if (!this.items[itemId]) return;
            var basketItemTemplate = this.getTemplate('basket-item-template');
            if (basketItemTemplate) {
                var basketItemHtml = this.renderBasketItem(basketItemTemplate, this.items[itemId]);
                var sortIndex = BX.util.array_search(itemId, this.sortedItems);
                if (this.shownItems.length && sortIndex >= 0) {
                    if (sortIndex < BX.util.array_search(this.shownItems[0], this.sortedItems)) {
                        // insert before
                        BX(this.ids.item + this.shownItems[0]).insertAdjacentHTML('beforebegin', basketItemHtml);
                        this.shownItems.unshift(itemId);
                    } else if (sortIndex > BX.util.array_search(this.shownItems[this.shownItems.length - 1], this.sortedItems)) {
                        // insert after
                        BX(this.ids.item + this.shownItems[this.shownItems.length - 1]).insertAdjacentHTML('afterend', basketItemHtml);
                        this.shownItems.push(itemId);
                    } else {
                        // insert between
                        BX(this.ids.item + this.sortedItems[sortIndex + 1]).insertAdjacentHTML('beforebegin', basketItemHtml);
                        this.shownItems.splice(sortIndex + 1, 0, itemId);
                    }
                } else {
                    this.getCacheNode(this.ids.itemListTable).insertAdjacentHTML('beforeend', basketItemHtml);
                    this.shownItems.push(itemId);
                }
                this.bindBasketItemEvents(this.items[itemId]);
                if (this.filter.isActive()) this.filter.highlightSearchMatch(this.items[itemId]);
            }
        },
        getItemsToEdit: function() {
            var itemIds = [];
            if (this.isBasketChanged()) {
                for(var i in this.changedItems)if (this.changedItems.hasOwnProperty(i) && this.isItemShown(this.changedItems[i])) itemIds.push(this.changedItems[i]);
            }
            return itemIds;
        },
        getItemsAfter: function() {
            var itemIdsAfter = [];
            if (this.useDynamicScroll) {
                var lastShownItemId = this.shownItems[this.shownItems.length - 1] || false;
                if (lastShownItemId) {
                    var i = 0;
                    var index = BX.util.array_search(lastShownItemId, this.sortedItems);
                    while(this.sortedItems[++index] && i++ < this.maxItemsShowCount)itemIdsAfter.push(this.sortedItems[index]);
                }
            }
            return itemIdsAfter;
        },
        editBasketItems: function(itemIds) {
            if (!itemIds || itemIds.length === 0) return;
            var i, item;
            for(i in itemIds){
                if (!itemIds.hasOwnProperty(i) || !BX.type.isPlainObject(this.items[itemIds[i]])) continue;
                item = this.items[itemIds[i]];
                if (this.actionPool.isItemInPool(item.ID)) {
                    if (!BX.util.in_array(item.ID, this.postponedItems)) this.postponedItems.push(item.ID);
                    continue;
                }
                if (BX.type.isDomNode(BX(this.ids.item + item.ID))) {
                    this.redrawBasketItemNode(item.ID);
                    this.applyQuantityAnimation(item.ID);
                } else this.createBasketItem(item.ID);
            }
        },
        editPostponedBasketItems: function() {
            if (!this.postponedItems.length) return;
            var itemsToEdit = [];
            for(var i in this.postponedItems)if (this.postponedItems.hasOwnProperty(i) && this.isItemShown(this.postponedItems[i])) itemsToEdit.push(this.postponedItems[i]);
            this.postponedItems = [];
            this.editBasketItems(itemsToEdit);
        },
        applyQuantityAnimation: function(itemId) {
            var basketItemNode = BX(this.ids.item + itemId);
            if (BX.type.isDomNode(basketItemNode) && this.items[itemId]) {
                if (this.items[itemId].QUANTITY_ANIMATION) BX.addClass(BX(this.ids.quantity + itemId), 'basket-updated');
            }
        },
        applyPriceAnimation: function() {
            if (!this.priceAnimationData || Object.keys(this.priceAnimationData.start).length === 0) return;
            var animationData = this.priceAnimationData, nodeCache = {};
            new BX.easing({
                duration: this.params.USE_PRICE_ANIMATION === 'Y' ? this.duration.priceAnimation : 1,
                start: animationData.start,
                finish: animationData.finish,
                transition: BX.easing.makeEaseOut(BX.easing.transitions.quad),
                step: BX.delegate(function(state) {
                    for(var nodeId in animationData.start)if (animationData.start.hasOwnProperty(nodeId)) {
                        if (!nodeCache[nodeId]) {
                            if (nodeId === this.ids.total) nodeCache[nodeId] = this.getEntities(this.getCacheNode(this.ids.basketRoot), this.ids.total);
                            else {
                                var node = BX(nodeId);
                                nodeCache[nodeId] = node ? [
                                    node
                                ] : [];
                            }
                        }
                        if (!animationData.int[nodeId]) // fix price blinking
                        state[nodeId] = (state[nodeId] + state[nodeId] % 1000 / 1000).toFixed(5);
                        for(var i = 0; i < nodeCache[nodeId].length; i++)nodeCache[nodeId][i].innerHTML = this.getFormatPrice(state[nodeId], animationData.currency[nodeId]);
                    }
                }, this),
                complete: BX.delegate(function() {
                    var nodeId, formattedPrice, itemId, type;
                    for(nodeId in animationData.start)if (animationData.start.hasOwnProperty(nodeId)) {
                        formattedPrice = this.getFormatPrice(animationData.finish[nodeId], animationData.currency[nodeId]);
                        for(var i = 0; i < nodeCache[nodeId].length; i++)nodeCache[nodeId][i].innerHTML = formattedPrice;
                        if (nodeId.indexOf(this.ids.sumPrice) !== -1) {
                            type = 'SUM_PRICE';
                            itemId = nodeId.substr(this.ids.sumPrice.length);
                        } else if (nodeId.indexOf(this.ids.price) !== -1) {
                            type = 'PRICE';
                            itemId = nodeId.substr(this.ids.price.length);
                        } else if (nodeId.indexOf(this.ids.total) !== -1) {
                            type = 'TOTAL';
                            itemId = '';
                        } else {
                            itemId = '';
                            type = '';
                        }
                        if (BX.type.isNotEmptyString(type)) {
                            if (itemId) {
                                this.items[itemId][type] = animationData.finish[nodeId];
                                delete this.items[itemId][type + '_NEW'];
                                this.items[itemId][type + '_FORMATED'] = formattedPrice;
                                delete this.items[itemId][type + '_FORMATED_NEW'];
                            } else if (type === 'TOTAL') {
                                this.result.TOTAL_RENDER_DATA.PRICE = animationData.finish[nodeId];
                                delete this.result.TOTAL_RENDER_DATA.PRICE_NEW;
                                this.result.TOTAL_RENDER_DATA.PRICE_FORMATED = formattedPrice;
                                delete this.result.TOTAL_RENDER_DATA.PRICE_FORMATED_NEW;
                            }
                        }
                    }
                    this.filter.highlightFoundItems();
                }, this)
            }).animate();
        },
        getFormatPrice: function(price, currency) {
            return BX.Currency.currencyFormat(price, currency, true);
        },
        deleteBasketItems: function(items, restore, final) {
            if (!items || !items.length) return;
            for(var i in items)if (items.hasOwnProperty(i)) this.deleteBasketItem(items[i], restore, final);
        },
        deleteBasketItem: function(itemId, restore, final) {
            // delete not available item with no chance to restore
            if (this.items[itemId].NOT_AVAILABLE && restore) {
                restore = false;
                final = true;
            }
            if (restore) {
                this.items[itemId].SHOW_RESTORE = true;
                this.items[itemId].SHOW_LOADING = false;
                this.redrawBasketItemNode(itemId);
            } else {
                this.changeShownItem(itemId);
                BX.remove(BX(this.ids.item + itemId));
            }
            if (final) {
                this.changeSortedItem(itemId, false, true);
                this.changeShownItem(itemId, false, true);
            }
        },
        addSortedItem: function(itemId, all) {
            this.sortedItems.push(itemId.toString());
            if (all && this.filter.isActive()) this.filter.realSortedItems.push(itemId.toString());
        },
        changeSortedItem: function(itemId, newItemId, all) {
            var index = BX.util.array_search(itemId, this.sortedItems);
            if (index >= 0) {
                if (newItemId) this.sortedItems.splice(index, 1, newItemId.toString());
                else this.sortedItems.splice(index, 1);
            }
            if (all && this.filter.isActive()) {
                index = BX.util.array_search(itemId, this.filter.realSortedItems);
                if (index >= 0) {
                    if (newItemId) this.filter.realSortedItems.splice(index, 1, newItemId.toString());
                    else this.filter.realSortedItems.splice(index, 1);
                }
            }
        },
        sortSortedItems: function(all) {
            this.sortedItems.sort(BX.proxy(this.itemSortFunction, this));
            if (all && this.filter.isActive()) this.filter.realSortedItems.sort(BX.proxy(this.itemSortFunction, this));
        },
        changeShownItem: function(itemId, newItemId, all) {
            var index = BX.util.array_search(itemId, this.shownItems);
            if (index >= 0) {
                if (newItemId) this.shownItems.splice(index, 1, newItemId.toString());
                else this.shownItems.splice(index, 1);
            }
            if (all && this.filter.isActive()) {
                index = BX.util.array_search(itemId, this.filter.realShownItems);
                if (index >= 0) {
                    if (newItemId) this.filter.realShownItems.splice(index, 1, newItemId.toString());
                    else this.filter.realShownItems.splice(index, 1);
                }
            }
        },
        redrawBasketItemNode: function(itemId) {
            var basketItemNode = BX(this.ids.item + itemId);
            if (!this.items[itemId] || !BX.type.isDomNode(basketItemNode)) return;
            var basketItemTemplate = this.getTemplate('basket-item-template');
            if (basketItemTemplate) {
                var nodeAligner = BX(this.ids.itemHeightAligner + itemId), oldHeight;
                if (BX.type.isDomNode(nodeAligner)) oldHeight = nodeAligner.clientHeight;
                var basketItemHtml = this.renderBasketItem(basketItemTemplate, this.items[itemId]);
                basketItemNode.insertAdjacentHTML('beforebegin', basketItemHtml);
                BX.remove(basketItemNode);
                if (oldHeight) {
                    nodeAligner = BX(this.ids.itemHeightAligner + itemId);
                    if (BX.type.isDomNode(nodeAligner) && nodeAligner.clientHeight < oldHeight) {
                        nodeAligner.style.minHeight = oldHeight + 'px';
                        setTimeout(function() {
                            nodeAligner.style.minHeight = '0px';
                        }, 1);
                    }
                }
                this.bindBasketItemEvents(this.items[itemId]);
                if (this.filter.isActive()) this.filter.highlightSearchMatch(this.items[itemId]);
            }
        },
        restoreBasketItems: function(items) {
            if (!items || Object.keys(items).length === 0) return;
            var oldItemId, newItemId, basketItemNode;
            for(oldItemId in items)if (items.hasOwnProperty(oldItemId)) {
                newItemId = items[oldItemId];
                if (this.isItemShown(oldItemId)) {
                    this.changeShownItem(oldItemId, newItemId, true);
                    basketItemNode = BX(this.ids.item + oldItemId);
                    if (BX.type.isDomNode(basketItemNode)) {
                        basketItemNode.id = this.ids.item + newItemId;
                        basketItemNode.setAttribute('data-id', newItemId);
                    }
                }
                this.changeSortedItem(oldItemId, false, true);
            }
            this.renderDeletedItems();
        },
        bindBasketItemEvents: function(itemData) {
            if (!itemData) return;
            var itemNode = BX(this.ids.item + itemData.ID);
            if (BX.type.isDomNode(itemNode)) {
                this.bindQuantityEvents(itemNode, itemData);
                this.bindSkuEvents(itemNode, itemData);
                this.bindImageEvents(itemNode, itemData);
                this.bindActionEvents(itemNode, itemData);
                this.bindRestoreAction(itemNode, itemData);
                this.bindItemWarningEvents(itemNode, itemData);
            }
        },
        bindQuantityEvents: function(node, data) {
            if (!node || !data || !this.isItemAvailable(data.ID)) return;
            var entity;
            var block = this.getEntity(node, 'basket-item-quantity-block');
            if (block) {
                var startEventName = this.isTouch ? 'touchstart' : 'mousedown';
                var endEventName = this.isTouch ? 'touchend' : 'mouseup';
                entity = this.getEntity(block, 'basket-item-quantity-minus');
                BX.bind(entity, startEventName, BX.proxy(this.startQuantityInterval, this));
                BX.bind(entity, endEventName, BX.proxy(this.clearQuantityInterval, this));
                BX.bind(entity, 'mouseout', BX.proxy(this.clearQuantityInterval, this));
                BX.bind(entity, 'click', BX.proxy(this.quantityMinus, this));
                entity = this.getEntity(block, 'basket-item-quantity-plus');
                BX.bind(entity, startEventName, BX.proxy(this.startQuantityInterval, this));
                BX.bind(entity, endEventName, BX.proxy(this.clearQuantityInterval, this));
                BX.bind(entity, 'mouseout', BX.proxy(this.clearQuantityInterval, this));
                BX.bind(entity, 'click', BX.proxy(this.quantityPlus, this));
                entity = this.getEntity(block, 'basket-item-quantity-field');
                BX.bind(entity, 'change', BX.proxy(this.quantityChange, this));
            }
        },
        startQuantityInterval: function() {
            var target = BX.proxy_context;
            var func = target.getAttribute('data-entity') === 'basket-item-quantity-minus' ? BX.proxy(this.quantityMinus, this) : BX.proxy(this.quantityPlus, this);
            this.quantityDelay = setTimeout(BX.delegate(function() {
                this.quantityTimer = setInterval(function() {
                    func(target);
                }, 150);
            }, this), 300);
        },
        clearQuantityInterval: function() {
            clearTimeout(this.quantityDelay);
            clearInterval(this.quantityTimer);
        },
        quantityPlus: function(target) {
            if (!BX.type.isDomNode(target)) {
                target = BX.proxy_context;
                this.clearQuantityInterval();
            }
            var itemData = this.getItemDataByTarget(target);
            if (itemData) {
                var quantityField = BX(this.ids.quantity + itemData.ID);
                var isQuantityFloat = this.isQuantityFloat(itemData);
                var currentQuantity = isQuantityFloat ? parseFloat(quantityField.value) : Math.round(quantityField.value);
                var measureRatio = isQuantityFloat ? parseFloat(itemData.MEASURE_RATIO) : parseInt(itemData.MEASURE_RATIO);
                var quantity = parseFloat((currentQuantity + measureRatio).toFixed(5));
                quantity = this.getCorrectQuantity(itemData, quantity);
                this.setQuantity(itemData, quantity);
            }
        },
        quantityMinus: function(target) {
            target = BX.type.isDomNode(target) ? target : BX.proxy_context;
            var itemData = this.getItemDataByTarget(target);
            if (itemData) {
                var quantityField = BX(this.ids.quantity + itemData.ID);
                var isQuantityFloat = this.isQuantityFloat(itemData);
                var currentQuantity = isQuantityFloat ? parseFloat(quantityField.value) : Math.round(quantityField.value);
                var measureRatio = isQuantityFloat ? parseFloat(itemData.MEASURE_RATIO) : parseInt(itemData.MEASURE_RATIO);
                var quantity = parseFloat((currentQuantity - measureRatio).toFixed(5));
                quantity = this.getCorrectQuantity(itemData, quantity);
                this.setQuantity(itemData, quantity);
            }
        },
        quantityChange: function() {
            var itemData = this.getItemDataByTarget(BX.proxy_context);
            if (itemData) {
                var quantityField, quantity;
                quantityField = BX(this.ids.quantity + itemData.ID);
                quantity = this.getCorrectQuantity(itemData, quantityField.value);
                this.setQuantity(itemData, quantity);
            }
        },
        isQuantityFloat: function(item) {
            return this.params.QUANTITY_FLOAT === 'Y' || parseInt(item.MEASURE_RATIO) !== parseFloat(item.MEASURE_RATIO);
        },
        getCorrectQuantity: function(itemData, quantity) {
            var isQuantityFloat = this.isQuantityFloat(itemData), measureRatio = isQuantityFloat ? parseFloat(itemData.MEASURE_RATIO) : parseInt(itemData.MEASURE_RATIO), availableQuantity = 0;
            quantity = (isQuantityFloat ? parseFloat(quantity) : parseInt(quantity, 10)) || 0;
            if (quantity < 0) quantity = 0;
            if (measureRatio > 0 && quantity < measureRatio) quantity = measureRatio;
            if (itemData.CHECK_MAX_QUANTITY === 'Y') {
                availableQuantity = isQuantityFloat ? parseFloat(itemData.AVAILABLE_QUANTITY) : parseInt(itemData.AVAILABLE_QUANTITY);
                if (availableQuantity > 0 && quantity > availableQuantity) quantity = availableQuantity;
            }
            var reminder = (quantity / measureRatio - (quantity / measureRatio).toFixed(0)).toFixed(5), remain;
            if (parseFloat(reminder) === 0) return quantity;
            if (measureRatio !== 0 && measureRatio !== 1) {
                remain = quantity * this.precisionFactor % (measureRatio * this.precisionFactor) / this.precisionFactor;
                if (measureRatio > 0 && remain > 0) {
                    if (remain >= measureRatio / 2 && (availableQuantity === 0 || quantity + measureRatio - remain <= availableQuantity)) quantity += measureRatio - remain;
                    else quantity -= remain;
                }
            }
            quantity = isQuantityFloat ? parseFloat(quantity) : parseInt(quantity, 10);
            return quantity;
        },
        setQuantity: function(itemData, quantity) {
            var quantityField = BX(this.ids.quantity + itemData.ID), currentQuantity;
            if (quantityField) {
                quantity = parseFloat(quantity);
                currentQuantity = parseFloat(quantityField.getAttribute('data-value'));
                quantityField.value = quantity;
                if (parseFloat(itemData.QUANTITY) !== parseFloat(quantity)) {
                    this.animatePriceByQuantity(itemData, quantity);
                    this.actionPool.changeQuantity(itemData.ID, quantity, currentQuantity);
                }
            }
        },
        animatePriceByQuantity: function(itemData, quantity) {
            var priceNode = BX(this.ids.sumPrice + itemData.ID);
            if (!BX.type.isDomNode(priceNode)) return;
            var quantityMultiplier = quantity / parseFloat(itemData.MEASURE_RATIO);
            var startPrice = parseFloat(itemData.SUM_PRICE), finalPrice = parseFloat(itemData.PRICE) * quantityMultiplier, isInt = parseInt(startPrice) === parseFloat(startPrice) && parseInt(finalPrice) === parseFloat(finalPrice);
            if (startPrice !== finalPrice) {
                this.items[itemData.ID].QUANTITY = quantity;
                this.items[itemData.ID].SUM_PRICE = finalPrice;
                new BX.easing({
                    duration: this.params.USE_PRICE_ANIMATION === 'Y' ? this.duration.priceAnimation : 1,
                    start: {
                        price: startPrice
                    },
                    finish: {
                        price: finalPrice
                    },
                    transition: BX.easing.makeEaseOut(BX.easing.transitions.quad),
                    step: BX.delegate(function(state) {
                        if (!isInt) // fix price blinking
                        state.price = (state.price + state.price % 1000 / 1000).toFixed(5);
                        priceNode.innerHTML = this.getFormatPrice(state.price, itemData.CURRENCY);
                    }, this),
                    complete: BX.delegate(function() {
                        var node, price;
                        priceNode.innerHTML = this.getFormatPrice(finalPrice, itemData.CURRENCY);
                        node = BX(this.ids.sumPriceOld + itemData.ID);
                        if (BX.type.isDomNode(node)) {
                            price = parseFloat(itemData.FULL_PRICE) * quantityMultiplier;
                            node.innerHTML = this.getFormatPrice(price, itemData.CURRENCY);
                        }
                        node = BX(this.ids.sumPriceDiff + itemData.ID);
                        if (BX.type.isDomNode(node)) {
                            price = parseFloat(itemData.DISCOUNT_PRICE) * quantityMultiplier;
                            node.innerHTML = this.getFormatPrice(price, itemData.CURRENCY);
                        }
                    }, this)
                }).animate();
            }
        },
        getItemDataByTarget: function(target) {
            var data = false;
            var id;
            var itemNode = BX.findParent(target, {
                attrs: {
                    'data-entity': 'basket-item'
                }
            });
            if (itemNode) {
                id = itemNode.getAttribute('data-id');
                data = this.items[id];
            }
            return data;
        },
        bindSkuEvents: function(node, data) {
            if (!node || !data) return;
            var blocks = this.getEntities(node, 'basket-item-sku-block');
            var blockEntities, i, l, ii, ll;
            for(i = 0, l = blocks.length; i < l; i++){
                blockEntities = this.getEntities(blocks[i], 'basket-item-sku-field');
                for(ii = 0, ll = blockEntities.length; ii < ll; ii++)BX.bind(blockEntities[ii], 'click', BX.proxy(this.changeSku, this));
            }
        },
        changeSku: function() {
            var i, l;
            var target = BX.proxy_context;
            if (BX.hasClass(target, 'selected')) return;
            var itemData = this.getItemDataByTarget(target);
            if (itemData) {
                var basketItemNode = BX(this.ids.item + itemData.ID);
                if (basketItemNode) {
                    var currentSkuListNodes = this.getEntities(target.parentNode, 'basket-item-sku-field');
                    for(i = 0, l = currentSkuListNodes.length; i < l; i++)if (currentSkuListNodes[i].isEqualNode(target)) BX.addClass(currentSkuListNodes[i], 'selected');
                    else BX.removeClass(currentSkuListNodes[i], 'selected');
                    this.actionPool.changeSku(itemData.ID, this.getSkuPropertyValues(basketItemNode), this.getInitialSkuPropertyValues(basketItemNode));
                }
            }
        },
        getSkuPropertyValues: function(basketItemNode) {
            var propertyValues = {};
            var propNodes = this.getEntities(basketItemNode, 'basket-item-sku-field', '.selected');
            for(var i = 0, l = propNodes.length; i < l; i++)propertyValues[propNodes[i].getAttribute('data-property')] = BX.util.htmlspecialcharsback(propNodes[i].getAttribute('data-value-id'));
            return propertyValues;
        },
        getInitialSkuPropertyValues: function(basketItemNode) {
            var propertyValues = {};
            var propNodes = this.getEntities(basketItemNode, 'basket-item-sku-field', '[data-initial="true"]');
            for(var i = 0, l = propNodes.length; i < l; i++)propertyValues[propNodes[i].getAttribute('data-property')] = BX.util.htmlspecialcharsback(propNodes[i].getAttribute('data-value-id'));
            return propertyValues;
        },
        bindImageEvents: function(node, data) {
            if (!node || !data) return;
            var images = node.querySelectorAll('.basket-item-custom-block-photo-item');
            for(var i = 0, l = images.length; i < l; i++)BX.bind(images[i], 'click', BX.proxy(this.showPropertyImagePopup, this));
        },
        showPropertyImagePopup: function() {
            var target, propertyCode, imageIndex, item, imageSrc, i;
            target = BX.proxy_context;
            item = this.getItemDataByTarget(target);
            propertyCode = target.getAttribute('data-column-property-code');
            imageIndex = target.getAttribute('data-image-index');
            if (item && item.COLUMN_LIST) {
                for(i in item.COLUMN_LIST)if (item.COLUMN_LIST.hasOwnProperty(i) && item.COLUMN_LIST[i].CODE === propertyCode && item.COLUMN_LIST[i].VALUE[imageIndex]) {
                    imageSrc = item.COLUMN_LIST[i].VALUE[imageIndex].IMAGE_SRC_ORIGINAL;
                    break;
                }
            }
            if (!imageSrc) return;
            if (this.imagePopup) this.imagePopup.destroy();
            var imageId = 'bx-soa-image-popup-content';
            var that = this;
            this.imagePopup = new BX.PopupWindow('bx-soa-image-popup', null, {
                lightShadow: true,
                offsetTop: 0,
                offsetLeft: 0,
                closeIcon: {
                    top: '3px',
                    right: '10px'
                },
                autoHide: true,
                bindOptions: {
                    position: 'bottom'
                },
                closeByEsc: true,
                zIndex: 100,
                events: {
                    onPopupShow: function() {
                        BX.create('IMG', {
                            props: {
                                src: imageSrc
                            },
                            events: {
                                load: function() {
                                    var content = BX(imageId);
                                    if (content) {
                                        var windowSize = BX.GetWindowInnerSize(), ratio = that.isMobile ? 0.5 : 0.9, contentHeight, contentWidth;
                                        BX.cleanNode(content);
                                        content.appendChild(this);
                                        contentHeight = content.offsetHeight;
                                        contentWidth = content.offsetWidth;
                                        if (contentHeight > windowSize.innerHeight * ratio) {
                                            content.style.height = windowSize.innerHeight * ratio + 'px';
                                            content.style.width = contentWidth * (windowSize.innerHeight * ratio / contentHeight) + 'px';
                                            contentHeight = content.offsetHeight;
                                            contentWidth = content.offsetWidth;
                                        }
                                        if (contentWidth > windowSize.innerWidth * ratio) {
                                            content.style.width = windowSize.innerWidth * ratio + 'px';
                                            content.style.height = contentHeight * (windowSize.innerWidth * ratio / contentWidth) + 'px';
                                        }
                                        content.style.height = content.offsetHeight + 'px';
                                        content.style.width = content.offsetWidth + 'px';
                                        that.imagePopup.adjustPosition();
                                    }
                                }
                            }
                        });
                    },
                    onPopupClose: function() {
                        this.destroy();
                    }
                },
                content: BX.create('DIV', {
                    props: {
                        id: imageId
                    }
                })
            });
            this.imagePopup.show();
        },
        bindActionEvents: function(node, data) {
            if (!node || !data) return;
            var entity;
            if (BX.util.in_array('DELETE', this.params.COLUMNS_LIST)) {
                entity = this.getEntities(node, 'basket-item-delete');
                for(var i = 0, l = entity.length; i < l; i++)BX.bind(entity[i], 'click', BX.proxy(this.deleteAction, this));
            }
            if (BX.util.in_array('DELAY', this.params.COLUMNS_LIST)) {
                entity = this.getEntity(node, 'basket-item-add-delayed');
                BX.bind(entity, 'click', BX.proxy(this.addDelayedAction, this));
            }
            entity = this.getEntity(node, 'basket-item-remove-delayed');
            BX.bind(entity, 'click', BX.proxy(this.removeDelayedAction, this));
            entity = this.getEntity(node, 'basket-item-merge-sku-link');
            BX.bind(entity, 'click', BX.proxy(this.mergeAction, this));
            entity = this.getEntity(node, 'basket-item-show-similar-link');
            BX.bind(entity, 'click', BX.delegate(function() {
                this.toggleFilter('similar');
            }, this));
        },
        deleteAction: function() {
            var itemData = this.getItemDataByTarget(BX.proxy_context);
            if (itemData) {
                this.actionPool.deleteItem(itemData.ID);
                this.items[itemData.ID].SHOW_LOADING = true;
                if (this.params.SHOW_RESTORE === 'Y' && this.isItemAvailable(itemData.ID)) this.items[itemData.ID].SHOW_RESTORE = true;
                this.redrawBasketItemNode(itemData.ID);
                this.renderDeletedItems();
            }
        },
        addDelayedAction: function() {
            var itemData = this.getItemDataByTarget(BX.proxy_context);
            if (itemData) {
                this.actionPool.addDelayed(itemData.ID);
                this.items[itemData.ID].SHOW_LOADING = true;
                this.redrawBasketItemNode(itemData.ID);
            }
        },
        removeDelayedAction: function() {
            var itemData = this.getItemDataByTarget(BX.proxy_context);
            if (itemData) {
                this.actionPool.removeDelayed(itemData.ID);
                this.items[itemData.ID].SHOW_LOADING = true;
                this.redrawBasketItemNode(itemData.ID);
            }
        },
        mergeAction: function() {
            var itemData = this.getItemDataByTarget(BX.proxy_context);
            if (itemData) this.actionPool.mergeSku(itemData.ID);
        },
        bindRestoreAction: function(node, itemData) {
            if (!node || !itemData || this.params.SHOW_RESTORE !== 'Y') return;
            BX.bind(this.getEntity(node, 'basket-item-restore-button'), 'click', BX.delegate(function() {
                this.actionPool.restoreItem(itemData.ID, {
                    PRODUCT_ID: itemData.PRODUCT_ID,
                    QUANTITY: itemData.QUANTITY,
                    PROPS: itemData.PROPS_ALL,
                    SORT: itemData.SORT,
                    MODULE: itemData.MODULE,
                    PRODUCT_PROVIDER_CLASS: itemData.PRODUCT_PROVIDER_CLASS
                });
                this.items[itemData.ID].SHOW_RESTORE = false;
                this.items[itemData.ID].SHOW_LOADING = true;
                this.redrawBasketItemNode(itemData.ID);
            }, this));
            BX.bind(this.getEntity(node, 'basket-item-close-restore-button'), 'click', BX.delegate(function() {
                this.deleteBasketItem(itemData.ID, false, true);
            }, this));
        },
        renderDeletedItems: function() {
            var node = this.getEntity(this.getCacheNode(this.ids.basketRoot), 'basket-deleted-items');
            if (!BX.type.isDomNode(node)) return;
            var items = [];
            for(var id in this.items)if (this.items.hasOwnProperty(id) && this.items[id].SHOW_RESTORE) items.push(this.items[id]);
            node.innerHTML = this.render(this.getTemplate('basket-deleted-items-template'), {
                ITEMS: items
            });
            this.bindDeletedItemsEvents(node);
        },
        bindDeletedItemsEvents: function(node) {
            var restoreNodes = this.getEntities(node, 'basket-deleted-item-restore');
            for(var i = 0; i < restoreNodes.length; i++)BX.bind(restoreNodes[i], 'click', BX.proxy(this.restoreDeletedItemAction, this));
            var closeNodes = this.getEntities(node, 'basket-deleted-item-close');
            for(var j = 0; j < closeNodes.length; j++)BX.bind(closeNodes[j], 'click', BX.proxy(this.closeDeletedItemAction, this));
        },
        restoreDeletedItemAction: function(event) {
            var target = BX.getEventTarget(event);
            var itemId = target && target.getAttribute('data-id');
            var itemData = this.items[itemId];
            if (!itemData) return;
            this.actionPool.restoreItem(itemData.ID, {
                PRODUCT_ID: itemData.PRODUCT_ID,
                QUANTITY: itemData.QUANTITY,
                PROPS: itemData.PROPS_ALL,
                SORT: itemData.SORT,
                MODULE: itemData.MODULE,
                PRODUCT_PROVIDER_CLASS: itemData.PRODUCT_PROVIDER_CLASS
            });
            this.items[itemData.ID].SHOW_RESTORE = false;
            this.items[itemData.ID].SHOW_LOADING = true;
            this.redrawBasketItemNode(itemData.ID);
            this.renderDeletedItems();
        },
        closeDeletedItemAction: function(event) {
            var target = BX.getEventTarget(event);
            var itemId = target && target.getAttribute('data-id');
            if (!this.items[itemId]) return;
            this.deleteBasketItem(itemId, false, true);
            this.renderDeletedItems();
        },
        bindItemWarningEvents: function(node, data) {
            if (!node || !data) return;
            BX.bind(this.getEntity(BX(this.ids.item + data.ID), 'basket-item-warning-close'), 'click', BX.proxy(this.closeItemWarnings, this));
        },
        closeItemWarnings: function() {
            var target = BX.proxy_context;
            if (BX.type.isDomNode(target)) {
                var itemData = this.getItemDataByTarget(target);
                this.items[itemData.ID].WARNINGS = [];
                this.warningItems.splice(BX.util.array_search(itemData.ID, this.warningItems), 1);
                this.redrawBasketItemNode(itemData.ID);
                this.editWarnings();
            }
        },
        renderBasketItem: function(template, data) {
            var clonedData = BX.clone(data);
            if (BX.type.isPlainObject(clonedData)) clonedData.USE_FILTER = this.useItemsFilter && !this.filter.currentFilter.similarHash.length;
            return Mustache.render(template, clonedData);
        },
        render: function(template, data) {
            return Mustache.render(template, data);
        },
        checkAnalytics: function(data) {
            if (!data || !data.basket) return;
            var itemId, itemsDiff = {};
            for(var i in data.basket)if (data.basket.hasOwnProperty(i)) {
                if (i.indexOf('QUANTITY_') >= 0) {
                    itemId = i.substr(9);
                    if (this.items[itemId]) itemsDiff[itemId] = parseFloat(data.basket[i]) - parseFloat(BX(this.ids.quantity + itemId).getAttribute('data-value'));
                } else if (i.indexOf('DELETE_') >= 0) {
                    itemId = i.substr(7);
                    if (this.items[itemId]) itemsDiff[itemId] = -parseFloat(this.items[itemId].QUANTITY);
                } else if (i.indexOf('RESTORE_') >= 0) {
                    itemId = i.substr(8);
                    if (this.items[itemId]) itemsDiff[itemId] = parseFloat(this.items[itemId].QUANTITY);
                }
            }
            this.setAnalyticsDataLayer(itemsDiff);
        },
        setAnalyticsDataLayer: function(itemsDiff) {
            if (!itemsDiff || Object.keys(itemsDiff).length === 0) return;
            window[this.params.DATA_LAYER_NAME] = window[this.params.DATA_LAYER_NAME] || [];
            var plus = [], minus = [];
            for(var itemId in itemsDiff)if (itemsDiff.hasOwnProperty(itemId)) {
                if (itemsDiff[itemId] > 0) plus.push(this.getItemAnalyticsInfo(itemId, itemsDiff[itemId]));
                else if (itemsDiff[itemId] < 0) minus.push(this.getItemAnalyticsInfo(itemId, itemsDiff[itemId]));
            }
            if (plus.length) window[this.params.DATA_LAYER_NAME].push({
                event: 'addToCart',
                ecommerce: {
                    currencyCode: this.items[itemId].CURRENCY || '',
                    add: {
                        products: plus
                    }
                }
            });
            if (minus.length) window[this.params.DATA_LAYER_NAME].push({
                event: 'removeFromCart',
                ecommerce: {
                    currencyCode: this.items[itemId].CURRENCY || '',
                    remove: {
                        products: minus
                    }
                }
            });
        },
        getItemAnalyticsInfo: function(itemId, diff) {
            if (!this.items[itemId]) return {};
            var brand = (this.items[itemId].BRAND || '').split(',  ').join('/');
            var variants = [];
            var selectedSku = this.getEntities(BX(this.ids.item + itemId), 'basket-item-sku-field', '.selected');
            for(var i = 0, l = selectedSku.length; i < l; i++)variants.push(selectedSku[i].getAttribute('data-sku-name'));
            return {
                name: this.items[itemId].NAME || '',
                id: this.items[itemId].PRODUCT_ID || '',
                price: this.items[itemId].PRICE || 0,
                brand: brand,
                variant: variants.join('/'),
                quantity: Math.abs(diff)
            };
        }
    };
})();


(function() {
    function clearBasketViewBeforeReload(basket) {
        basket.sortedItems = [];
        basket.shownItems = [];
        basket.items = {};
        if (typeof basket.editTotal === 'function') basket.editTotal();
        const basketItemNodes = document.querySelectorAll('[data-entity="basket-item"]');
        basketItemNodes.forEach(function(node) {
            node.remove();
        });
        const countNode = document.querySelector('[data-entity="basket-items-count"][data-filter="all"]');
        if (countNode) countNode.textContent = '';
        const vatNode = document.querySelector('.basket__checkout-block-vat-value');
        if (vatNode) vatNode.textContent = '';
        const totalPriceNodes = document.querySelectorAll('[data-entity="basket-total-price"]');
        totalPriceNodes.forEach(function(node) {
            node.textContent = '';
        });
    }
    function clearBasket() {
        const basket = window.BX && window.BX.Sale && window.BX.Sale.BasketComponent;
        if (!basket || !basket.items || !basket.actionPool) return;
        const itemIds = Object.keys(basket.items);
        if (!itemIds.length) return;
        itemIds.forEach(function(itemId) {
            if (basket.items[itemId]) basket.actionPool.deleteItem(itemId);
        });
        clearBasketViewBeforeReload(basket);
        basket.actionPool.trySendPool();
        setTimeout(function() {
            window.location.reload();
        }, 700);
    }
    document.addEventListener('click', function(event) {
        const button = event.target.closest('#basket__button-clear');
        if (!button) return;
        event.preventDefault();
        clearBasket();
    });
})();


(function() {
    const basketViewKey = 'basket_state';
    if (!sessionStorage.getItem(basketViewKey)) sessionStorage.setItem(basketViewKey, 'basket');
    let buttonBasket = document?.querySelectorAll('[data-type-basket]');
    if (!buttonBasket) return;
    function getBasketProducts() {
        return document.querySelectorAll('#basket-item-table [data-entity="basket-item"]');
    }
    function hasRenderedProducts() {
        return getBasketProducts().length > 0;
    }
    function hasDelayedProducts() {
        return document.querySelectorAll('#basket-item-table [data-entity="basket-item"][data-delay]').length > 0;
    }
    function hasBasketProducts() {
        return document.querySelectorAll('#basket-item-table [data-entity="basket-item"]:not([data-delay])').length > 0;
    }
    function resolveCurrentView() {
        let currentView = sessionStorage.getItem(basketViewKey);
        if (!hasRenderedProducts()) return currentView;
        if (currentView === 'basket' && !hasBasketProducts() && hasDelayedProducts()) {
            currentView = 'delay';
            sessionStorage.setItem(basketViewKey, currentView);
        }
        if (currentView === 'delay' && !hasDelayedProducts() && hasBasketProducts()) {
            currentView = 'basket';
            sessionStorage.setItem(basketViewKey, currentView);
        }
        return currentView;
    }
    function hiddenBasketProduct() {
        getBasketProducts().forEach((item)=>{
            item.classList.add('none');
        });
    }
    function setActiveButton(currentView) {
        buttonBasket.forEach((button)=>{
            const buttonType = button.dataset['typeBasket'];
            button.classList.toggle('basket__items-list-header-filter-item_active', buttonType === currentView);
        });
    }
    function viewTypeProduct() {
        const basketProducts = getBasketProducts();
        if (!basketProducts.length) return;
        const currentView = resolveCurrentView();
        hiddenBasketProduct();
        setActiveButton(currentView);
        basketProducts.forEach((item)=>{
            const isDelayed = item.hasAttribute('data-delay');
            if (currentView === 'delay' && isDelayed) item.classList.remove('none');
            if (currentView === 'basket' && !isDelayed) item.classList.remove('none');
        });
    }
    function changeBasketState(button) {
        const btnType = button.dataset['typeBasket'];
        if (btnType === 'delay' && hasRenderedProducts() && !hasDelayedProducts()) {
            sessionStorage.setItem(basketViewKey, 'basket');
            viewTypeProduct();
            return;
        }
        if (btnType === 'basket' && hasRenderedProducts() && !hasBasketProducts()) {
            sessionStorage.setItem(basketViewKey, 'delay');
            viewTypeProduct();
            return;
        }
        sessionStorage.setItem(basketViewKey, btnType);
        viewTypeProduct();
    }
    function initObserver() {
        const basketTable = document.getElementById('basket-item-table');
        if (!basketTable) return;
        const observer = new MutationObserver(()=>{
            viewTypeProduct();
        });
        observer.observe(basketTable, {
            childList: true,
            subtree: true
        });
    }
    function initBasketState() {
        viewTypeProduct();
        buttonBasket.forEach((btn)=>{
            btn.addEventListener('click', (e)=>{
                e.preventDefault();
                changeBasketState(btn);
                const href = btn.getAttribute('href');
                if (href && href !== '#') window.location.href = href;
            });
        });
    }
    initObserver();
    initBasketState();
})();




/* global BX, bitrix_sessid, FormUtils */ (function() {
    if (typeof BX === 'undefined' || typeof FormUtils === 'undefined') return;
    const modalId = 'order-service-modal-overlay';
    const closeBtnId = 'order-service-form-header-btn';
    const submitBtn = document.getElementById('order-service-submit-btn');
    const commonErrorsBlock = document.getElementById('order-service-form-common-errors');
    const captchaContainerId = 'captcha-container-order-service';
    const containerSelector = '';
    const fullname = document.getElementById('fullname-order-service');
    const phone = document.getElementById('phone-order-service');
    const email = document.getElementById('email-order-service');
    const message = document.getElementById('message-order-service');
    const nameService = document.getElementById('name-service');
    const service = document.getElementById('service-order-service');
    if (!nameService) return;
    service.value = nameService.value;
    if (!document.getElementById(modalId) || !submitBtn) return;
    FormUtils.setupPhoneMask(phone);
    const initCaptcha = ()=>FormUtils.initCaptcha(captchaContainerId);
    const resetCaptcha = ()=>FormUtils.resetCaptcha();
    const clearFields = ()=>{
        fullname.value = '';
        phone.value = '';
        email.value = '';
        message.value = '';
    };
    const hideErrors = ()=>{
        FormUtils.clearFieldErrors(containerSelector);
        FormUtils.hideCommonError(commonErrorsBlock);
    };
    const validate = ()=>{
        let isValid = true;
        hideErrors();
        if (!FormUtils.validateRequired(fullname.value)) {
            FormUtils.showFieldError(fullname, "*\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
            isValid = false;
        }
        const phoneDigits = phone.value.replace(/\D/g, '');
        if (!FormUtils.validateRequired(phone.value)) {
            FormUtils.showFieldError(phone, "*\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
            isValid = false;
        } else if (!FormUtils.validatePhoneDigits(phoneDigits)) {
            FormUtils.showFieldError(phone, "*\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 (\u043D\u0435 \u043C\u0435\u043D\u0435\u0435 10 \u0446\u0438\u0444\u0440)");
            isValid = false;
        }
        if (!FormUtils.validateRequired(email.value)) {
            FormUtils.showFieldError(email, "*\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
            isValid = false;
        } else if (!FormUtils.validateEmail(email.value)) {
            FormUtils.showFieldError(email, "*\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 E-mail");
            isValid = false;
        }
        if (!FormUtils.validateRequired(service.value)) {
            FormUtils.showFieldError(service, "*\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
            isValid = false;
        }
        const captchaToken = document.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        if (!captchaToken || !captchaToken.value) {
            FormUtils.showCommonError(commonErrorsBlock, "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435, \u0447\u0442\u043E \u0432\u044B \u043D\u0435 \u0440\u043E\u0431\u043E\u0442");
            isValid = false;
        }
        if (!isValid) FormUtils.scrollToFirstError(containerSelector, commonErrorsBlock);
        return isValid;
    };
    const send = async ()=>{
        if (!validate()) return;
        const captchaToken = document.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        const token = typeof bitrix_sessid === 'function' ? bitrix_sessid() : BX.bitrix_sessid ? BX.bitrix_sessid() : '';
        const payload = {
            fullname: fullname.value,
            phone: phone.value,
            email: email.value,
            service: service.value,
            message: message.value,
            smart_token: captchaToken ? captchaToken.value : ''
        };
        if (submitBtn) submitBtn.disabled = true;
        try {
            await FormUtils.sendFormData({
                url: '/api/v1/form/order-service',
                payload: payload,
                headers: {
                    'Session-Id': token,
                    'X-Requested-With': 'XMLHttpRequest'
                },
                submitBtn: submitBtn,
                commonErrorsBlock: commonErrorsBlock,
                containerSelector: containerSelector,
                onSuccess: (result)=>{
                    alert(result.message || "\u0421\u043F\u0430\u0441\u0438\u0431\u043E! \u0412\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E.");
                    close();
                },
                onFieldError: (field, msg)=>{
                    const el = document.getElementById(field);
                    if (el) FormUtils.showFieldError(el, msg);
                }
            });
        } finally{
            if (submitBtn) submitBtn.disabled = false;
        }
    };
    const open = ()=>{
        document.getElementById(modalId).style.display = 'flex';
        document.body.style.overflow = 'hidden';
        hideErrors();
        initCaptcha();
        resetCaptcha();
    };
    const close = ()=>{
        document.getElementById(modalId).style.display = 'none';
        document.body.style.overflow = '';
        clearFields();
        hideErrors();
        resetCaptcha();
    };
    FormUtils.createModal({
        modalId: modalId,
        closeBtnId: closeBtnId,
        openBtnClass: '.open-order-service',
        onOpen: open,
        onClose: close
    });
    submitBtn.addEventListener('click', send);
})();


document.addEventListener('DOMContentLoaded', ()=>{
    $cbd96c0810f64220$var$bindAuthOpen();
});
let $cbd96c0810f64220$var$escHandler = null;
function $cbd96c0810f64220$var$bindAuthOpen() {
    const openBtns = document.querySelectorAll('.auth-open-btn');
    if (!openBtns.length) return;
    openBtns.forEach((btn)=>{
        btn.addEventListener('click', async (e)=>{
            e.preventDefault();
            const existingModal = document.querySelector('.auth-modal');
            if (existingModal) {
                $cbd96c0810f64220$var$openModal(existingModal);
                return;
            }
            const formData = new FormData();
            formData.append('POPUP_AUTH', 'Y');
            const response = await fetch('/auth/', {
                method: 'POST',
                body: formData,
                credentials: 'same-origin'
            });
            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const modal = doc.querySelector('.auth-modal');
            if (!modal) return;
            document.body.insertAdjacentHTML('beforeend', modal.outerHTML);
            const insertedModal = document.querySelector('.auth-modal');
            const burgerButton = document.getElementById('header-mobile__burger_check');
            if (burgerButton && btn.classList.contains('auth-open-btn__mobile')) burgerButton.click();
            $cbd96c0810f64220$var$openModal(insertedModal);
        });
    });
}
function $cbd96c0810f64220$var$openModal(modal) {
    $cbd96c0810f64220$var$bindAuthModal(modal);
    $cbd96c0810f64220$var$bindForgotPasswordLink(modal);
    $cbd96c0810f64220$var$bindAuthForm(modal);
    document.body.style.overflow = 'hidden';
    modal.classList.add('is-open');
}
function $cbd96c0810f64220$var$bindAuthModal(modal) {
    if (!modal) return;
    const closeBtn = modal.querySelector('#auth-modal-close');
    closeBtn?.addEventListener('click', ()=>$cbd96c0810f64220$var$closeModal(modal));
    if ($cbd96c0810f64220$var$escHandler) document.removeEventListener('keydown', $cbd96c0810f64220$var$escHandler);
    $cbd96c0810f64220$var$escHandler = (e)=>{
        if (e.key === 'Escape') $cbd96c0810f64220$var$closeModal(modal);
    };
    document.addEventListener('keydown', $cbd96c0810f64220$var$escHandler);
}
function $cbd96c0810f64220$var$closeModal(modal) {
    if (!modal) return;
    const isChangePasswordSuccess = modal.querySelector('#auth-change-pass__suc');
    modal.remove();
    document.body.style.overflow = '';
    if ($cbd96c0810f64220$var$escHandler) {
        document.removeEventListener('keydown', $cbd96c0810f64220$var$escHandler);
        $cbd96c0810f64220$var$escHandler = null;
    }
    if (isChangePasswordSuccess) window.location.replace('/');
}
function $cbd96c0810f64220$var$bindAuthForm(modal) {
    const form = modal.querySelector('#authorization-form');
    if (!form) return;
    form.onsubmit = async (event)=>{
        event.preventDefault();
        const submitButton = form.querySelector('[type="submit"]');
        if (!submitButton || submitButton.disabled) return;
        submitButton.disabled = true;
        try {
            const response = await fetch(form.action, {
                method: 'POST',
                body: new FormData(form),
                credentials: 'same-origin'
            });
            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const hasErrors = doc.querySelector('.auth-common-errors') !== null;
            if (hasErrors) {
                const newAuthBlock = doc.querySelector('#ajax_auth');
                const currentAuthBlock = document.querySelector('#ajax_auth');
                if (currentAuthBlock && newAuthBlock) {
                    currentAuthBlock.innerHTML = newAuthBlock.innerHTML;
                    const newForm = document.querySelector('#authorization-form');
                    if (newForm) $cbd96c0810f64220$var$bindAuthForm(modal);
                }
            } else window.location.reload();
        } catch (error) {
            submitButton.disabled = false;
        }
    };
}
function $cbd96c0810f64220$var$bindForgotPasswordLink(modal) {
    const link = modal.querySelector('.forgot-password-link');
    if (!link) return;
    link.onclick = async (e)=>{
        e.preventDefault();
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('POPUP_AUTH', 'Y');
        const response = await fetch(url.toString(), {
            credentials: 'same-origin'
        });
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newModal = doc.querySelector('.auth-modal');
        if (!newModal) {
            window.location.href = link.href;
            return;
        }
        modal.outerHTML = newModal.outerHTML;
        const insertedModal = document.querySelector('.auth-modal');
        $cbd96c0810f64220$var$bindAuthModal(insertedModal);
        $cbd96c0810f64220$var$bindForgotPasswordForm(insertedModal);
    };
}
function $cbd96c0810f64220$var$bindForgotPasswordForm(modal) {
    const form = modal.querySelector('#forgot-password-form');
    if (!form) return;
    form.onsubmit = async (event)=>{
        event.preventDefault();
        const submitButton = form.querySelector('[type="submit"]');
        if (!submitButton || submitButton.disabled) return;
        submitButton.disabled = true;
        try {
            const response = await fetch(form.action, {
                method: 'POST',
                body: new FormData(form),
                credentials: 'same-origin'
            });
            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newBlock = doc.querySelector('#ajax_forgot_password');
            const currentBlock = modal.querySelector('#ajax_forgot_password');
            if (currentBlock && newBlock) {
                currentBlock.innerHTML = newBlock.innerHTML;
                $cbd96c0810f64220$var$bindForgotPasswordForm(modal);
            }
            const header = document.querySelector('.form-header__title');
            if (header) header.textContent = "\u0423\u0441\u043F\u0435\u0448\u043D\u043E!";
        } catch (error) {
            submitButton.disabled = false;
        }
    };
}
document.addEventListener('DOMContentLoaded', ()=>{
    const modal = document.querySelector('.auth-modal');
    if (modal) $cbd96c0810f64220$var$bindAuthModal(modal);
});


/* global BX, FormUtils */ window.initRegistrationForm = function(formId) {
    const formSelector = '#' + formId;
    const registrationForm = document.getElementById(formId);
    if (!registrationForm) return null;
    let activeTimer = false;
    const phoneInput = registrationForm.querySelector('#input_PERSONAL_PHONE');
    const checkBtn = registrationForm.querySelector('#check_phone');
    const form = registrationForm;
    const smsInputWrapper = registrationForm.querySelector('.input_phone');
    const smsInput = registrationForm.querySelector('#input_check_phone');
    const smsAlert = registrationForm.querySelector('.sms_alert');
    const timerNode = registrationForm.querySelector('.time_to_end');
    const submitBtn = registrationForm.querySelector('#main_submit_btn');
    let errorBlock = document.querySelector('.form-common-errors');
    const confirmedHiddenInput = registrationForm.querySelector('#input_PHONE_CONFIRMED');
    const isPhoneConfirmed = confirmedHiddenInput && confirmedHiddenInput.value === 'Y';
    function clearPhoneState() {
        FormUtils.clearFieldError(phoneInput);
        clearCommonError();
        registrationForm.querySelectorAll('.phone-success').forEach((el)=>el.remove());
    }
    function clearCommonError() {
        if (!errorBlock) return;
        while(errorBlock.lastChild)errorBlock.removeChild(errorBlock.lastChild);
        errorBlock.style.display = 'none';
    }
    function clearAll() {
        FormUtils.clearFieldErrors(formSelector);
        clearCommonError();
    }
    function phoneSuccess() {
        if (!phoneInput) return;
        FormUtils.clearFieldError(phoneInput);
        const wrap = phoneInput.closest('div[style*="position: relative"]') || phoneInput.closest('div');
        if (!wrap) return;
        registrationForm.querySelectorAll('.phone-success').forEach((el)=>el.remove());
        const ok = document.createElement('span');
        ok.className = 'phone-success';
        ok.innerHTML = '<i class="fa big-icon s25 fa-check-square"></i>';
        wrap.appendChild(ok);
    }
    if (isPhoneConfirmed && phoneInput) {
        phoneInput.setAttribute('readonly', 'readonly');
        phoneInput.disabled = false;
        phoneSuccess();
        if (submitBtn) submitBtn.disabled = false;
    } else if (phoneInput) {
        FormUtils.setupPhoneMask(phoneInput);
        phoneInput.addEventListener('input', ()=>{
            FormUtils.clearFieldErrors(formSelector);
        });
    }
    function validatePhone(phone) {
        const digits = phone.replace(/\D/g, '');
        return digits.length === 11 && digits.startsWith('7');
    }
    function startTimer() {
        let count = 180;
        smsInputWrapper?.classList.remove('hidden');
        if (checkBtn) checkBtn.disabled = true;
        activeTimer = true;
        if (phoneInput) phoneInput.readOnly = true;
        if (smsAlert) smsAlert.classList.remove('hidden');
        if (timerNode) timerNode.textContent = count;
        const timer = setInterval(()=>{
            count--;
            if (timerNode) timerNode.textContent = count;
            if (count <= 0) {
                clearInterval(timer);
                activeTimer = false;
                if (checkBtn) checkBtn.disabled = false;
                if (phoneInput) phoneInput.readOnly = false;
                if (smsAlert) smsAlert.classList.add('hidden');
            }
        }, 1000);
    }
    checkBtn?.addEventListener('click', function() {
        if (activeTimer) return;
        clearPhoneState();
        const phone = phoneInput?.value || '';
        if (!phone) {
            FormUtils.showFieldError(phoneInput, "*\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
            return;
        }
        if (!validatePhone(phone)) {
            FormUtils.showFieldError(phoneInput, "*\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442");
            return;
        }
        BX.ajax({
            url: '/ajax/verification_sms.php',
            method: 'POST',
            dataType: 'json',
            data: {
                phone: phone,
                stoken: window?.token1 ?? null,
                hashKey: window?.[window.functionName]?.(BX.bitrix_sessid),
                sessid: BX.bitrix_sessid()
            },
            onsuccess: function(res) {
                if (!res || res.success !== true) {
                    let errorText = "*\u041E\u0448\u0438\u0431\u043A\u0430";
                    switch(res?.error){
                        case 'exist':
                            errorText = "*\u041D\u043E\u043C\u0435\u0440 \u0443\u0436\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F";
                            break;
                        case 'processed or banned':
                            errorText = "*\u0417\u0430\u043F\u0440\u043E\u0441 \u0432 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435";
                            break;
                        case 'format error':
                            errorText = "*\u041D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u043E\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435";
                            break;
                    }
                    FormUtils.showFieldError(phoneInput, errorText);
                    return;
                }
                startTimer();
            },
            onfailure: function() {
                FormUtils.showFieldError(phoneInput, "*\u041E\u0448\u0438\u0431\u043A\u0430 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0438 SMS");
            }
        });
    });
    smsInput?.addEventListener('blur', function(e) {
        clearPhoneState();
        const code = e.target.value;
        const phone = phoneInput?.value;
        if (!code || !phone) return;
        if (code.length !== 6) {
            FormUtils.showFieldError(smsInput, "*\u041A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u0441\u043E\u0441\u0442\u043E\u0438\u0442 \u0438\u0437 6 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432");
            return;
        }
        BX.ajax({
            url: '/ajax/verification_sms.php',
            method: 'POST',
            dataType: 'json',
            data: {
                phone: phone,
                vtoken: window?.token2 ?? null,
                verificationCode: code,
                hashKey: window?.[window.functionName]?.(BX.bitrix_sessid),
                sessid: BX.bitrix_sessid()
            },
            onsuccess: function(res) {
                if (res?.success === true) {
                    phoneSuccess();
                    if (confirmedHiddenInput) confirmedHiddenInput.value = 'Y';
                    if (submitBtn) {
                        submitBtn.disabled = false;
                        submitBtn.removeAttribute('disabled');
                    }
                    smsInputWrapper?.remove();
                    const parent = checkBtn?.closest('.registration-form__row--poz');
                    if (parent) parent.remove();
                    else checkBtn?.remove();
                    smsAlert?.remove();
                    phoneInput?.setAttribute('readonly', 'readonly');
                } else {
                    FormUtils.showFieldError(smsInput, "*\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u043A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F");
                    e.target.focus();
                }
            },
            onfailure: function() {
                FormUtils.showFieldError(smsInput, "*\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438 \u043A\u043E\u0434\u0430");
            }
        });
    });
    form?.addEventListener('input', function(e) {
        if (e.target.name !== 'input_check_phone') return;
        if (e.target.value.length === 6) e.target.blur();
    });
    return {
        validateBaseFields: function() {
            clearAll();
            let hasError = false;
            let commonError = false;
            const isConfirmedNow = confirmedHiddenInput && confirmedHiddenInput.value === 'Y';
            if (!isConfirmedNow) {
                hasError = true;
                if (errorBlock) {
                    commonError = true;
                    FormUtils.showCommonError(errorBlock, "*\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u0442\u0435\u043B\u0435\u0444\u043E\u043D");
                }
            }
            const passInp = registrationForm.querySelector('#input_PASSWORD');
            const confirmInp = registrationForm.querySelector('#input_CONFIRM_PASSWORD');
            if (passInp && passInp.value.length < 6) {
                hasError = true;
                FormUtils.showFieldError(passInp, "*\u041F\u0430\u0440\u043E\u043B\u044C \u0434\u043E\u043B\u0436\u0435\u043D \u0431\u044B\u0442\u044C \u043D\u0435 \u043C\u0435\u043D\u0435\u0435 6 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432");
            }
            if (confirmInp && confirmInp.value.length < 6) {
                hasError = true;
                FormUtils.showFieldError(confirmInp, "*\u041F\u0430\u0440\u043E\u043B\u044C \u0434\u043E\u043B\u0436\u0435\u043D \u0431\u044B\u0442\u044C \u043D\u0435 \u043C\u0435\u043D\u0435\u0435 6 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432");
            }
            if (passInp && confirmInp && passInp.value !== confirmInp.value) {
                hasError = true;
                FormUtils.showFieldError(confirmInp, "*\u041F\u0430\u0440\u043E\u043B\u0438 \u043D\u0435 \u0441\u043E\u0432\u043F\u0430\u0434\u0430\u044E\u0442");
            }
            if (hasError && errorBlock && commonError) errorBlock.style.display = 'block';
            return !hasError;
        }
    };
};
document.addEventListener('DOMContentLoaded', function() {
    const subscribe = document.getElementById('input_subscribe_status');
    subscribe?.addEventListener('change', function(e) {
        const hidden = document.getElementById('input_UF_SUBSCRIBE_STATUS');
        if (!hidden) return;
        hidden.value = e.target.checked ? 'Y' : 'N';
    });
});


document.addEventListener('DOMContentLoaded', function() {
    const physicalFormLogic = window.initRegistrationForm('registraion-physical-form');
    if (!physicalFormLogic) return;
    const formElement = document.getElementById('registraion-physical-form');
    formElement.addEventListener('submit', function(e) {
        const isValid = physicalFormLogic.validateBaseFields();
        if (!isValid) e.preventDefault();
    });
});


/* global FormUtils */ document.addEventListener('DOMContentLoaded', function() {
    const legalFormLogic = window.initRegistrationForm('registraion-legal-form');
    if (!legalFormLogic) return;
    const formElement = document.getElementById('registraion-legal-form');
    formElement.addEventListener('submit', function(e) {
        let isValid = legalFormLogic.validateBaseFields();
        const innInp = document.getElementById('input_UF_LEGAL_INN');
        if (innInp) {
            if (!/^(\d{10}|\d{12})$/.test(innInp.value)) {
                isValid = false;
                FormUtils.showFieldError(innInp, "*\u0418\u041D\u041D \u0434\u043E\u043B\u0436\u0435\u043D \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C 10 \u0438\u043B\u0438 12 \u0446\u0438\u0444\u0440");
            }
        }
        const kppInp = document.getElementById('input_UF_LEGAL_KPP');
        if (kppInp) {
            if (!/^[\d]{9}$/.test(kppInp.value)) {
                isValid = false;
                FormUtils.showFieldError(kppInp, "*\u041A\u041F\u041F \u0434\u043E\u043B\u0436\u0435\u043D \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C \u0440\u043E\u0432\u043D\u043E 9 \u0446\u0438\u0444\u0440");
            }
        }
        if (!isValid) e.preventDefault();
    });
});


/* global BX, FormUtils, Inputmask */ document.addEventListener('DOMContentLoaded', ()=>{
    const mainButtons = document.querySelectorAll('.profile-personal__nav-btn');
    const mainContents = document.querySelectorAll('.profile-personal-tab-content');
    const orderButtons = document.querySelectorAll('.cp-orders-nav__link');
    const orderContents = document.querySelectorAll('.cp-orders-tab-wrapper .cp-orders-subtab-content');
    const orderSubTabs = [
        'all',
        'current',
        'finished',
        'canceled'
    ];
    const switchMainTab = (targetTab)=>{
        if (targetTab === 'exit') {
            window.location.href = '/personal/?logout=yes&clear_cache=Y';
            return;
        }
        if (targetTab) {
            mainButtons.forEach((btn)=>btn.classList.remove('filter-nav__link--active'));
            mainContents.forEach((content)=>{
                content.classList.remove('is-active');
                content.style.display = 'none';
            });
            const activeBtn = document.querySelector(`.profile-personal__nav-btn[data-tab="${targetTab}"]`);
            if (activeBtn) activeBtn.classList.add('filter-nav__link--active');
            const targetContent = document.getElementById(`tab-${targetTab}`);
            if (targetContent) {
                targetContent.classList.add('is-active');
                targetContent.style.display = 'block';
            }
        }
    };
    const switchOrderTab = (targetTab)=>{
        const activeTab = orderSubTabs.includes(targetTab) ? targetTab : 'all';
        orderButtons.forEach((btn)=>{
            if (btn.getAttribute('data-order-tab') === activeTab) btn.classList.add('filter-nav__link--active');
            else btn.classList.remove('filter-nav__link--active');
        });
        orderContents.forEach((content)=>{
            if (content.id === `order-tab-${activeTab}`) content.style.setProperty('display', 'flex');
            else content.style.setProperty('display', 'none');
        });
    };
    mainButtons.forEach((button)=>{
        button.addEventListener('click', (e)=>{
            const targetTab = button.dataset.tab;
            if (targetTab !== 'exit') {
                e.preventDefault();
                window.location.hash = targetTab === 'orders' ? 'all' : targetTab;
            } else switchMainTab(targetTab);
        });
    });
    if (orderButtons.length > 0) orderButtons.forEach((button)=>{
        button.addEventListener('click', (e)=>{
            e.preventDefault();
            const targetTab = button.dataset.orderTab;
            window.location.hash = targetTab;
        });
    });
    const checkAllHashes = ()=>{
        const currentHash = window.location.hash.replace('#', '');
        if (orderSubTabs.includes(currentHash)) {
            switchMainTab('orders');
            switchOrderTab(currentHash);
            return;
        }
        const isValidMainTab = document.querySelector(`.profile-personal__nav-btn[data-tab="${currentHash}"]`);
        if (currentHash && isValidMainTab) switchMainTab(currentHash);
        else switchMainTab('private');
    };
    checkAllHashes();
    window.addEventListener('hashchange', checkAllHashes);
});
document.addEventListener('DOMContentLoaded', ()=>{
    const actions = {
        inputName: 'setName',
        inputEmail: 'setEmail',
        inputEmailConfirm: 'checkEmailCode',
        inputPhone: 'setTelephone',
        inputPhoneConfirm: 'checkSmsCode'
    };
    function isProfileLocked() {
        return !!document.getElementById('editPermText');
    }
    function checkLockStatus() {
        const locked = isProfileLocked();
        const targets = document.querySelectorAll('.js-edit-trigger, #js-pass-toggle-btn');
        targets.forEach((el)=>{
            if (locked) el.classList.add('cp-disabled');
            else el.classList.remove('cp-disabled');
        });
    }
    checkLockStatus();
    function setFieldError(inputElement, message) {
        if (!inputElement || !message) return;
        const group = inputElement.closest('.form-content__group');
        if (group) {
            group.classList.add('error');
            const errorNode = group.querySelector('.form-content__error');
            if (errorNode) {
                errorNode.style.color = '';
                errorNode.textContent = message.trim().startsWith('*') ? message : `*${message}`;
            }
        }
    }
    function clearFieldError(inputElement) {
        if (!inputElement) return;
        const group = inputElement.closest('.form-content__group');
        if (group) {
            group.classList.remove('error');
            const errorNode = group.querySelector('.form-content__error');
            if (errorNode) errorNode.textContent = '';
        }
    }
    function setFieldSuccess(inputElement, customMessage = "\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043E!") {
        if (!inputElement) return;
        clearFieldError(inputElement);
        const group = inputElement.closest('.form-content__group');
        if (group) {
            const errorNode = group.querySelector('.form-content__error');
            if (errorNode) {
                errorNode.style.color = 'var(--color-green, #4FAD00)';
                errorNode.textContent = customMessage;
                setTimeout(()=>{
                    errorNode.textContent = '';
                    errorNode.style.color = '';
                }, 5000);
            }
        }
    }
    document.querySelectorAll('.js-edit-trigger').forEach((btn)=>{
        btn.addEventListener('click', (e)=>{
            if (isProfileLocked()) {
                e.preventDefault();
                return;
            }
            const targetId = btn.dataset.target;
            const input = document.getElementById(targetId);
            if (!input) return;
            const isEditing = btn.dataset.edit === 'true';
            if (!isEditing) {
                btn.dataset.edit = 'true';
                btn.textContent = "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C";
                btn.classList.remove('cp-btn-blue');
                btn.classList.add('cp-btn-green');
                input.removeAttribute('disabled');
                input.focus();
                const confirmBlock = document.getElementById(`${targetId}ConfirmBlock`);
                if (confirmBlock) confirmBlock.classList.add('hidden');
            } else {
                const val = input.value.trim();
                if (!val) {
                    setFieldError(input, "\u041F\u043E\u043B\u0435 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0443\u0441\u0442\u044B\u043C");
                    return;
                }
                if (targetId === 'inputUIN' && !/^(\d{10}|\d{12})$/.test(val)) {
                    setFieldError(input, "\u0418\u041D\u041D \u0434\u043E\u043B\u0436\u0435\u043D \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C 10 \u0438\u043B\u0438 12 \u0446\u0438\u0444\u0440");
                    return;
                }
                clearFieldError(input);
                const resetBtnToDefault = ()=>{
                    btn.dataset.edit = 'false';
                    btn.textContent = "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C";
                    btn.classList.remove('cp-btn-green');
                    btn.classList.add('cp-btn-blue');
                    input.setAttribute('disabled', 'disabled');
                };
                if (targetId === 'inputUIN') BX.ajax.runAction('compuproject:personal.api.actions.setLegalEntityData', {
                    data: {
                        uin: val,
                        name: document.getElementById('inputCompanyName').value,
                        fullName: document.getElementById('inputCompanyFullName').value,
                        kpp: document.getElementById('inputCompanyKPP').value,
                        address: document.getElementById('inputCompanyAddress').value
                    }
                }).then((res)=>{
                    if (res.status === 'success' && res.data && res.data.status === 'success') {
                        setFieldSuccess(input);
                        resetBtnToDefault();
                    } else {
                        const msg = res.data && res.data.message || "\u041E\u0448\u0438\u0431\u043A\u0430 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F";
                        setFieldError(input, msg);
                    }
                }).catch((err)=>{
                    console.error(err);
                    setFieldError(input, "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0435 \u0437\u0430\u043F\u0440\u043E\u0441\u0430");
                });
                else {
                    let postData = {};
                    if (targetId === 'inputName') {
                        const parts = val.split(/ +/g);
                        postData = {
                            name: parts[0],
                            lastName: parts[1] || ''
                        };
                    }
                    if (targetId === 'inputEmail') postData = {
                        email: val
                    };
                    if (targetId === 'inputPhone') postData = {
                        phone: val
                    };
                    BX.ajax.runAction(`compuproject:personal.api.actions.${actions[targetId]}`, {
                        data: postData
                    }).then((res)=>{
                        if (res.status === 'success' && res.data && res.data.status === 'success') {
                            const confirmBlock = document.getElementById(`${targetId}ConfirmBlock`);
                            if (confirmBlock) {
                                confirmBlock.classList.remove('hidden');
                                setFieldSuccess(input, "\u041A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D!");
                            } else {
                                setFieldSuccess(input);
                                resetBtnToDefault();
                            }
                        } else {
                            const msg = res.data && res.data.message || "\u041E\u0448\u0438\u0431\u043A\u0430 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0434\u0430\u043D\u043D\u044B\u0445";
                            setFieldError(input, msg);
                        }
                    }).catch((err)=>{
                        console.error(err);
                        setFieldError(input, "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u0437\u0430\u043F\u0440\u043E\u0441\u0430");
                    });
                }
            }
        });
    });
    function submitConfirmCode(input) {
        const val = input.value.trim();
        if (val.length < 4) {
            setFieldError(input, "\u041A\u043E\u0434 \u0441\u043B\u0438\u0448\u043A\u043E\u043C \u043A\u043E\u0440\u043E\u0442\u043A\u0438\u0439");
            return;
        }
        clearFieldError(input);
        BX.ajax.runAction(`compuproject:personal.api.actions.${actions[input.id]}`, {
            data: {
                code: val
            }
        }).then((res)=>{
            if (res.status === 'success' && res.data && res.data.status === 'success') {
                const block = input.closest('.cp-confirm-wrapper');
                if (block) block.classList.add('hidden');
                const mainInputId = input.id.replace('Confirm', '');
                const mainInput = document.getElementById(mainInputId);
                if (mainInput) {
                    setFieldSuccess(mainInput, "\u0414\u0430\u043D\u043D\u044B\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u044B \u0438 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u044B!");
                    mainInput.setAttribute('disabled', 'disabled');
                    const row = mainInput.closest('.registration-form__row');
                    if (row) {
                        const triggerBtn = row.querySelector('.js-edit-trigger');
                        if (triggerBtn) {
                            triggerBtn.dataset.edit = 'false';
                            triggerBtn.textContent = "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C";
                            triggerBtn.classList.remove('cp-btn-green');
                            triggerBtn.classList.add('cp-btn-blue');
                        }
                    }
                }
                input.value = '';
            } else {
                const errorMsg = res.data && res.data.message || "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u043A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F!";
                setFieldError(input, errorMsg);
            }
        }).catch((err)=>{
            console.error(err);
            setFieldError(input, "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438 \u043A\u043E\u0434\u0430");
        });
    }
    document.querySelectorAll('#inputEmailConfirm, #inputPhoneConfirm').forEach((input)=>{
        input.addEventListener('input', (e)=>{
            let val = e.target.value.replace(/\D/g, '');
            if (val.length > 8) val = val.slice(0, 8);
            e.target.value = val;
        });
        input.addEventListener('keydown', (e)=>{
            if (e.key === 'Enter') {
                e.preventDefault();
                submitConfirmCode(input);
            }
        });
    });
    document.querySelectorAll('.js-confirm-submit').forEach((btn)=>{
        btn.addEventListener('click', ()=>{
            const targetId = btn.dataset.target;
            const input = document.getElementById(targetId);
            if (input) submitConfirmCode(input);
        });
    });
    const uinInput = document.getElementById('inputUIN');
    if (uinInput && window.DADATA_CONFIG && typeof window.fetch === 'function') {
        const dl = document.createElement('datalist');
        dl.id = 'uinSuggestionsList';
        document.body.appendChild(dl);
        uinInput.setAttribute('list', dl.id);
        let timer = null;
        const cache = new Map();
        uinInput.addEventListener('input', ()=>{
            if (isProfileLocked()) return;
            const query = uinInput.value.trim();
            if (query.length < 3) {
                dl.innerHTML = '';
                return;
            }
            clearTimeout(timer);
            timer = setTimeout(()=>{
                window.fetch(window.DADATA_CONFIG.url, {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        Authorization: `Token ${window.DADATA_CONFIG.token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        query: query
                    })
                }).then((r)=>r.json()).then((res)=>{
                    dl.innerHTML = '';
                    if (!res.suggestions) return;
                    res.suggestions.forEach((s)=>{
                        if (!s.data || !s.data.inn) return;
                        const opt = document.createElement('option');
                        opt.value = s.data.inn;
                        opt.label = s.value;
                        dl.appendChild(opt);
                        cache.set(s.data.inn, s);
                    });
                }).catch((err)=>console.error(err));
            }, 350);
        });
        const fillFields = (inn)=>{
            const s = cache.get(inn);
            if (!s) return;
            document.getElementById('inputCompanyName').value = s.value || '';
            document.getElementById('inputCompanyFullName').value = s.data.name?.full_with_opf?.replace('/', '') || '';
            document.getElementById('inputCompanyKPP').value = s.data.kpp || '';
            document.getElementById('inputCompanyAddress').value = s.data.address?.value || '';
        };
        uinInput.addEventListener('change', ()=>{
            if (!isProfileLocked()) fillFields(uinInput.value.trim());
        });
    }
    const phoneInput = document.getElementById('inputPhone');
    FormUtils.setupPhoneMask(phoneInput);
    if (phoneInput && typeof Inputmask === 'function') Inputmask({
        regex: '^\\+7 \\([0-9]{3}\\) [0-9]{3}-[0-9]{2}-[0-9]{2}$'
    }).mask(phoneInput);
    const passToggleBtn = document.getElementById('js-pass-toggle-btn');
    const passForm = document.querySelector('.cp_profile__pass-from');
    if (passToggleBtn && passForm) passToggleBtn.addEventListener('click', (e)=>{
        if (isProfileLocked()) {
            e.preventDefault();
            return;
        }
        passForm.classList.toggle('hidden');
    });
    document.querySelectorAll('.js-eye-toggle').forEach((eye)=>{
        eye.addEventListener('click', ()=>{
            const input = eye.previousElementSibling;
            if (input) {
                const isPassword = input.type === 'password';
                input.type = isPassword ? 'text' : 'password';
                const icon = eye.querySelector('i');
                if (icon) {
                    if (isPassword) {
                        icon.classList.remove('fa-eye-slash');
                        icon.classList.add('fa-eye');
                    } else {
                        icon.classList.remove('fa-eye');
                        icon.classList.add('fa-eye-slash');
                    }
                }
            }
        });
    });
    const savePassBtn = document.getElementById('js-save-pass-btn');
    if (savePassBtn) savePassBtn.addEventListener('click', ()=>{
        if (isProfileLocked()) return;
        const cur = document.getElementById('inputCurrentPass');
        const n1 = document.getElementById('inputNewPass');
        const n2 = document.getElementById('inputConfirmPass');
        if (!cur.value) {
            setFieldError(cur, "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0442\u0435\u043A\u0443\u0449\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C");
            return;
        } else clearFieldError(cur);
        if (n1.value.length < 6) {
            setFieldError(n1, "\u041C\u0438\u043D\u0438\u043C\u0443\u043C 6 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432");
            return;
        } else clearFieldError(n1);
        if (n1.value !== n2.value) {
            setFieldError(n2, "\u041F\u0430\u0440\u043E\u043B\u0438 \u043D\u0435 \u0441\u043E\u0432\u043F\u0430\u0434\u0430\u044E\u0442");
            return;
        } else clearFieldError(n2);
        BX.ajax.runAction('compuproject:personal.api.actions.setPass', {
            data: {
                currentPass: cur.value,
                newPass: n1.value,
                confirmPass: n2.value
            }
        }).then((res)=>{
            if (res.status === 'success' && res.data && res.data.status === 'success') {
                cur.value = '';
                n1.value = '';
                n2.value = '';
                passForm.classList.add('hidden');
                const successBlock = document.getElementById('js-pass-success-block');
                successBlock.classList.remove('hidden');
                setTimeout(()=>successBlock.classList.add('hidden'), 5000);
            } else {
                const msg = res.data && res.data.message || "\u041E\u0448\u0438\u0431\u043A\u0430 \u0441\u043C\u0435\u043D\u044B \u043F\u0430\u0440\u043E\u043B\u044F";
                setFieldError(n2, msg);
            }
        }).catch((err)=>console.error(err));
    });
    const unblockBtn = document.getElementById('editUnblockButton');
    if (unblockBtn && typeof BX.PopupWindowManager !== 'undefined') unblockBtn.addEventListener('click', ()=>{
        const popup = BX.PopupWindowManager.create('editUnblockPopup', null, {
            zIndex: 100,
            closeIcon: true,
            titleBar: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u043F\u0430\u0440\u043E\u043B\u044F",
            content: `
                    <div class="form-content__group cp-popup-group">
                        <input class="form-content__input" id="inputEditConfirm" type="password" placeholder="\u{412}\u{432}\u{435}\u{434}\u{438}\u{442}\u{435} \u{432}\u{430}\u{448} \u{442}\u{435}\u{43A}\u{443}\u{449}\u{438}\u{439} \u{43F}\u{430}\u{440}\u{43E}\u{43B}\u{44C}*">
                        <span class="form-content__error cp-block" id="inputEditConfirmHelp"></span>
                    </div>
                `,
            closeByEsc: true,
            autoHide: true,
            overlay: {
                backgroundColor: 'black',
                opacity: 500
            },
            buttons: [
                new BX.PopupWindowButton({
                    text: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C",
                    className: 'cp-btn-text cp-btn-blue',
                    events: {
                        click: function() {
                            const inp = document.getElementById('inputEditConfirm');
                            const help = document.getElementById('inputEditConfirmHelp');
                            if (!inp.value) {
                                help.textContent = "*\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435";
                                return;
                            }
                            BX.ajax.runAction('compuproject:personal.api.actions.confirmEditPerm', {
                                data: {
                                    pass: inp.value
                                }
                            }).then((res)=>{
                                if (res.status === 'success' && res.data === true) {
                                    popup.close();
                                    const banner = document.getElementById('editPermText');
                                    if (banner) banner.remove();
                                    checkLockStatus();
                                } else help.textContent = "*\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C";
                            }).catch((err)=>console.error(err));
                        }
                    }
                })
            ]
        });
        popup.show();
    });
});


(function() {
    setInterval(()=>{
        const locationLabel = document.querySelector('.cp-location-label-stub');
        if (locationLabel && locationLabel.style.display !== 'none') locationLabel.style.setProperty('display', 'none');
        const textareaLabel = document.querySelector('.cp-textarea-label-stub');
        if (textareaLabel && textareaLabel.style.display !== 'none') textareaLabel.style.setProperty('display', 'none');
        const wrapper = document.querySelector('.cp-location-wrapper');
        if (!wrapper) return;
        const inputBlock = wrapper.querySelector('.bx-ui-sls-input-block');
        if (inputBlock) {
            inputBlock.style.setProperty('position', 'relative');
            inputBlock.style.setProperty('display', 'flex');
            inputBlock.style.setProperty('align-items', 'center');
            inputBlock.style.setProperty('height', '48px');
            inputBlock.style.setProperty('background-color', 'var(--color-background-light)');
            inputBlock.style.setProperty('border', '1px solid var(--color-border-default)');
            inputBlock.style.setProperty('border-radius', '8px');
            inputBlock.style.setProperty('box-sizing', 'border-box');
            inputBlock.style.setProperty('width', '100%');
        }
        const container = wrapper.querySelector('.bx-ui-sls-container');
        if (container) {
            container.style.setProperty('position', 'static');
            container.style.setProperty('height', '100%');
            container.style.setProperty('width', 'calc(100% - 40px)');
            container.style.setProperty('border', 'none');
            container.style.setProperty('padding', '0');
            container.style.setProperty('margin', '0 0 0 12px');
        }
        const fakeInput = wrapper.querySelector('.bx-ui-sls-fake');
        const routeInput = wrapper.querySelector('.bx-ui-sls-route');
        if (fakeInput) {
            if (fakeInput.getAttribute('placeholder') !== "\u041C\u0435\u0441\u0442\u043E\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435 *") fakeInput.setAttribute('placeholder', "\u041C\u0435\u0441\u0442\u043E\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435 *");
            fakeInput.style.setProperty('height', '100%');
            fakeInput.style.setProperty('width', '100%');
            fakeInput.style.setProperty('border', 'none');
            fakeInput.style.setProperty('box-sizing', 'border-box');
            fakeInput.style.setProperty('background', 'transparent');
            fakeInput.style.setProperty('padding', '0 10px 0 0');
            fakeInput.style.setProperty('font-size', '14px');
            fakeInput.style.setProperty('font-weight', '500');
            fakeInput.style.setProperty('color', 'transparent');
            fakeInput.style.setProperty('caret-color', 'var(--color-text-dark, #000000)');
            fakeInput.style.setProperty('position', 'relative');
            fakeInput.style.setProperty('z-index', '2');
        }
        if (routeInput && fakeInput) {
            routeInput.style.removeProperty('display');
            routeInput.style.setProperty('height', '100%');
            routeInput.style.setProperty('width', '100%');
            routeInput.style.setProperty('border', 'none');
            routeInput.style.setProperty('box-sizing', 'border-box');
            routeInput.style.setProperty('background', 'transparent');
            routeInput.style.setProperty('padding', '0 10px 0 0');
            routeInput.style.setProperty('font-size', '14px');
            routeInput.style.setProperty('font-weight', '500');
            routeInput.style.setProperty('color', 'var(--color-text-dark, #000000)');
            routeInput.style.setProperty('position', 'absolute');
            routeInput.style.setProperty('left', '0');
            routeInput.style.setProperty('top', '0');
            routeInput.style.setProperty('z-index', '1');
            routeInput.style.setProperty('pointer-events', 'none');
            if (!fakeInput.value) routeInput.value = '';
        }
        const icon = wrapper.querySelector('.dropdown-icon');
        if (icon) icon.remove();
        const clearBtn = wrapper.querySelector('.bx-ui-sls-clear');
        if (clearBtn) {
            clearBtn.style.setProperty('position', 'absolute');
            clearBtn.style.setProperty('right', '14px');
            clearBtn.style.setProperty('top', '50%');
            clearBtn.style.setProperty('transform', 'translateY(-50%)');
            clearBtn.style.setProperty('margin-top', '0');
            clearBtn.style.setProperty('z-index', '999');
            clearBtn.style.setProperty('pointer-events', 'auto');
            clearBtn.style.setProperty('cursor', 'pointer');
        }
        if (inputBlock && !inputBlock.dataset.focusBound) {
            inputBlock.dataset.focusBound = 'true';
            inputBlock.addEventListener('focusin', ()=>{
                inputBlock.style.setProperty('border-color', 'var(--color-brand-blue)');
                inputBlock.style.setProperty('background-color', 'var(--color-white)');
            });
            inputBlock.addEventListener('focusout', ()=>{
                inputBlock.style.setProperty('border-color', 'var(--color-border-default)');
                inputBlock.style.setProperty('background-color', 'var(--color-background-light)');
            });
        }
    }, 100);
})();


/* global FormUtils */ (function() {
    const state = {
        ajaxHandlersBound: false,
        captchaSubmitHandlerBound: false,
        licenceClickBound: false,
        offerClickBound: false,
        licenceConditionClickBound: false,
        quickLocationsClickBound: false
    };
    const buyerBlock = document?.querySelector('.order__buyer-block');
    if (buyerBlock) {
        const phoneInput = buyerBlock.querySelector('input[autocomplete="tel"]');
        FormUtils.setupPhoneMask(phoneInput);
    }
    const bx = ()=>window.BX;
    const orderComponent = ()=>window.BX?.Sale?.OrderAjaxComponent;
    const options = ()=>window.arNextOptions || {};
    const theme = ()=>options().THEME || {};
    const prices = ()=>options().PRICES || {};
    const message = (code)=>{
        const bitrix = bx();
        return bitrix && typeof bitrix.message === 'function' ? bitrix.message(code) : '';
    };
    const appendHtml = (node, html)=>{
        const template = document.createElement('template');
        template.innerHTML = html.trim();
        node.appendChild(template.content);
    };
    const inputByName = (name)=>{
        if (!name) return null;
        return Array.from(document.getElementsByName(name)).find((node)=>node.tagName === 'INPUT') || null;
    };
    const addRedisignedMarker = (node)=>{
        const marker = document.createElement('div');
        marker.className = 'redisigned hidden';
        node.appendChild(marker);
    };
    const addRequiredStar = (input)=>{
        const label = input?.closest('.bx-authform-formgroup-container')?.querySelector('.bx-authform-label-container');
        if (label && !label.querySelector('.bx-authform-starrequired')) label.insertAdjacentHTML('beforeend', '<span class="bx-authform-starrequired"> *</span>');
    };
    const wrapFormGroups = (firstInput, secondInput)=>{
        const firstGroup = firstInput?.closest('.bx-authform-formgroup-container');
        const secondGroup = secondInput?.closest('.bx-authform-formgroup-container');
        if (!firstGroup || !secondGroup || firstGroup.classList.contains('col-md-6')) return;
        firstGroup.classList.add('col-md-6');
        secondGroup.classList.add('col-md-6');
        const row = document.createElement('div');
        row.className = 'row';
        firstGroup.before(row);
        row.appendChild(firstGroup);
        row.appendChild(secondGroup);
    };
    const addChangeBasket = ()=>{
        const totals = document.querySelectorAll('.bx-soa-cart-total');
        if (!totals.length || document.querySelector('.change_basket')) return;
        totals.forEach((total)=>{
            const block = document.createElement('div');
            block.className = 'change_basket';
            const name = document.createElement('p');
            name.className = 'change_name';
            name.textContent = "\u0412\u0430\u0448 \u0437\u0430\u043A\u0430\u0437";
            block.appendChild(name);
            const link = document.createElement('a');
            link.href = `${options().SITE_DIR || '/'}basket/`;
            link.className = 'change_link';
            link.textContent = "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C";
            block.appendChild(link);
            total.prepend(block);
        });
    };
    const updateChangeBasketLink = (component)=>{
        if (!component.params) return;
        document.querySelectorAll('.bx-soa-cart-total .change_link').forEach((link)=>{
            link.href = component.params.PATH_TO_BASKET;
        });
        if (prices().MIN_PRICE && Number(prices().MIN_PRICE) > Number(component.result?.TOTAL?.ORDER_PRICE)) {
            const fadeMask = document.createElement('div');
            fadeMask.className = 'fademask_ext';
            document.body.appendChild(fadeMask);
            window.location.href = component.params.PATH_TO_BASKET;
        }
    };
    const sendBeginOrderGoal = (component)=>{
        if (options().COUNTERS?.USE_FULLORDER_GOALS === 'N' || typeof component.reachgoalbegin !== 'undefined') return;
        component.reachgoalbegin = true;
        if (bx() && typeof bx().onCustomEvent === 'function') bx().onCustomEvent('onCounterGoals', [
            {
                goal: 'goal_order_begin'
            }
        ]);
    };
    const sendCheckoutCounterGoal = (component)=>{
        if (component.ecomCheckoutSent) return;
        component.ecomCheckoutSent = true;
        if (typeof window.checkoutCounter === 'function') window.checkoutCounter(1, "\u041E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0435 \u0437\u0430\u043A\u0430\u0437\u0430");
    };
    const updateAuthForm = ()=>{
        const auth = document.getElementById('bx-soa-auth');
        if (!auth || auth.querySelector('.redisigned')) return;
        addRequiredStar(auth.querySelector('input[name="USER_LOGIN"]'));
        addRequiredStar(auth.querySelector('input[name="USER_PASSWORD"]'));
        const rememberInput = auth.querySelector('input[name="USER_REMEMBER"]');
        if (rememberInput) {
            rememberInput.id = 'ORDER_AUTH_USER_REMEMBER';
            const label = rememberInput.closest('label');
            if (label) {
                const labelText = label.textContent;
                label.setAttribute('for', 'ORDER_AUTH_USER_REMEMBER');
                label.textContent = labelText;
                label.before(rememberInput);
                rememberInput.closest('.bx-authform-formgroup-container')?.classList.add('filter');
                const forgot = auth.querySelector('.bx-authform > a');
                const checkbox = label.closest('.checkbox');
                if (forgot && checkbox) {
                    forgot.classList.add('pull-right', 'forgot');
                    checkbox.before(forgot);
                }
            }
        }
        auth.querySelectorAll('.bx-soa-reg-block .btn').forEach((button)=>{
            button.classList.remove('btn-default', 'btn-lg');
            button.classList.add('transparent');
            button.textContent = message('ORDER_REGISTER_BUTTON');
        });
        addRedisignedMarker(auth);
    };
    const bindRegisterSubmit = ()=>{
        const component = orderComponent();
        const submit = document.querySelector('#do_register~input[type=submit]');
        if (!component || !submit) return;
        if (bx() && typeof bx().unbindAll === 'function') bx().unbindAll(submit);
        submit.addEventListener('click', (event)=>{
            event.preventDefault();
            event.stopImmediatePropagation();
            if (theme().LOGIN_EQUAL_EMAIL === 'Y') {
                const email = document.querySelector('#bx-soa-auth input[name="NEW_EMAIL"]');
                const login = document.querySelector('#bx-soa-auth input[name="NEW_LOGIN"]');
                if (login && email) login.value = email.value;
            }
            const doRegister = document.getElementById('do_register');
            if (doRegister) doRegister.value = 'Y';
            component.sendRequest('showAuthForm');
        });
    };
    const updateCaptcha = (regContent)=>{
        const captcha = regContent.querySelector('.bx-captcha');
        if (!captcha) return;
        captcha.classList.add('captcha_image');
        appendHtml(captcha, '<div class="captcha_reload"></div>');
        const group = captcha.closest('.bx-authform-formgroup-container');
        group?.classList.add('captcha-row');
        group?.querySelector('input[name=captcha_word]')?.closest('.bx-authform-input-container')?.classList.add('captcha_input');
    };
    const updatePhoneInput = (regContent)=>{
        const phoneInputs = regContent.querySelectorAll('input[name=PHONE_NUMBER]');
        if (phoneInputs.length !== 1) return;
        const input = phoneInputs[0];
        const telInput = input.cloneNode(true);
        telInput.type = 'tel';
        telInput.value = input.value;
        input.style.display = 'none';
        input.after(telInput);
        if (typeof window.showPhoneMask === 'function') window.showPhoneMask('input[name=PHONE_NUMBER][type=tel]');
        telInput.addEventListener('blur', ()=>{
            const textInput = telInput.parentNode?.querySelector('input[name=PHONE_NUMBER][type=text]');
            if (textInput) textInput.value = telInput.value;
        });
        const label = telInput.closest('.bx-authform-formgroup-container')?.querySelector('.bx-authform-label-container');
        if (label) label.innerHTML = message('ORDER_PHONE_LABEL') + (label.querySelector('.bx-authform-starrequired') ? '<span class="bx-authform-starrequired"> *</span>' : '');
    };
    const updateRegisterForm = ()=>{
        const regContent = document.querySelector('.bx-soa-section-content.reg');
        if (!regContent || regContent.querySelector('.redisigned')) return;
        let rebindRegSubmit = false;
        const newLogin = regContent.querySelector('input[name="NEW_LOGIN"]');
        const newName = regContent.querySelector('input[name="NEW_NAME"]');
        const newLastName = regContent.querySelector('input[name="NEW_LAST_NAME"]');
        const newEmail = regContent.querySelector('input[name=NEW_EMAIL]');
        const phoneNumber = regContent.querySelector('input[name=PHONE_NUMBER]');
        const newPassword = regContent.querySelector('input[name=NEW_PASSWORD]');
        const newPasswordConfirm = regContent.querySelector('input[name=NEW_PASSWORD_CONFIRM]');
        if (theme().LOGIN_EQUAL_EMAIL === 'Y') {
            rebindRegSubmit = true;
            newLogin?.closest('.bx-authform-formgroup-container')?.style.setProperty('display', 'none');
        }
        if (theme().PERSONAL_ONEFIO === 'Y') {
            rebindRegSubmit = true;
            const label = newName?.closest('.bx-authform-formgroup-container')?.querySelector('.bx-authform-label-container');
            if (label) label.innerHTML = `${message('ORDER_FIO_LABEL')}<span class="bx-authform-starrequired"> *</span>`;
            newLastName?.closest('.bx-authform-formgroup-container')?.style.setProperty('display', 'none');
            if (newLastName) newLastName.value = ' ';
        }
        if (rebindRegSubmit) bindRegisterSubmit();
        updateCaptcha(regContent);
        if (newName && newLastName && theme().PERSONAL_ONEFIO !== 'Y') wrapFormGroups(newName, newLastName);
        if (newEmail && phoneNumber) wrapFormGroups(newEmail, phoneNumber);
        if (newPassword && newPasswordConfirm) wrapFormGroups(newPassword, newPasswordConfirm);
        updatePhoneInput(regContent);
        addRedisignedMarker(regContent);
    };
    const toggleNamedInput = (name, component, stateKey)=>{
        const input = inputByName(name);
        const checked = !input?.checked;
        if (input) input.checked = checked;
        component[stateKey] = checked ? 'checked' : '';
    };
    const bindLicenceClicks = (component, showLicence, showOffer)=>{
        if (showLicence && !state.licenceClickBound) {
            state.licenceClickBound = true;
            document.addEventListener('click', (event)=>{
                const label = event.target.closest('.bx-soa .licence_block label.license');
                if (!label) return;
                document.querySelectorAll('.bx-soa .licence_block label.error').forEach((error)=>{
                    error.classList.add('hidden');
                });
                toggleNamedInput(label.dataset.for, component, 'state_licence');
            });
        }
        if (showOffer && !state.offerClickBound) {
            state.offerClickBound = true;
            document.addEventListener('click', (event)=>{
                const label = event.target.closest('.bx-soa .offer_block label.offer_pub');
                if (!label) return;
                document.querySelectorAll('.bx-soa .offer_block label.error').forEach((error)=>{
                    error.classList.add('hidden');
                });
                toggleNamedInput(label.dataset.for, component, 'state_offer');
            });
        }
        if (!state.licenceConditionClickBound) {
            state.licenceConditionClickBound = true;
            document.addEventListener('click', (event)=>{
                const link = event.target.closest('.lic_condition a');
                if (!link) return;
                const currentComponent = orderComponent();
                const orderNode = document.getElementById('bx-soa-order');
                if (!currentComponent) return;
                if (bx()?.hasClass?.(orderNode, 'orderform--v1')) {
                    currentComponent.isValidForm?.();
                    return;
                }
                const errors = currentComponent.isValidPropertiesBlock?.() || [];
                if (!currentComponent.activeSectionId || !errors.length) {
                    const target = document.querySelector('.licence_block, .offer_block');
                    currentComponent.animateScrollTo?.(target, 800, 50);
                }
            });
        }
    };
    const renderLicenceBlocks = (component, showLicence, showOffer)=>{
        if (typeof component.state_licence === 'undefined') component.state_licence = theme().LICENCE_CHECKED === 'Y' ? 'checked' : '';
        if (typeof component.state_offer === 'undefined') component.state_offer = theme().OFFER_CHECKED === 'Y' ? 'checked' : '';
        if (document.querySelector('.bx-soa-auth.bx-active') || (document.querySelector('.licence_block.filter') || !showLicence) && (document.querySelector('.offer_block.filter') || !showOffer)) return;
        const orderSave = document.getElementById('bx-soa-orderSave');
        if (!orderSave) return;
        const form = document.createElement('div');
        form.className = 'form';
        const wrapper = document.createElement('div');
        wrapper.className = 'license_order_wrap';
        form.appendChild(wrapper);
        orderSave.before(form);
        if (!document.querySelector('.licence_block.filter') && showLicence) appendHtml(wrapper, `<div class="licence_block filter label_block"><span class="hidden error">${message('JS_REQUIRED_LICENSES')}</span><input type="checkbox" name="licenses_order" checked required ${component.state_licence} value="Y"><span class="license page-text--base">${message('LICENSES_TEXT_ORDER')}</span></div>`);
        if (!document.querySelector('.offer_block.filter') && showOffer) appendHtml(wrapper, `<div class="offer_block filter label_block"><label data-for="offer_order" class="hidden error">${message('JS_REQUIRED_OFFER')}</label><input type="checkbox" name="offer_order" required ${component.state_offer} value="Y"><label data-for="offer_order" class="offer_pub">${message('OFFER_TEXT')}</label></div>`);
        bindLicenceClicks(component, showLicence, showOffer);
    };
    const bindBxClick = (node, component)=>{
        if (!node || !bx() || typeof bx().bind !== 'function') return;
        if (typeof bx().unbindAll === 'function') bx().unbindAll(node);
        const handler = typeof bx().proxy === 'function' ? bx().proxy(component.clickOrderSaveAction, component) : component.clickOrderSaveAction.bind(component);
        bx().bind(node, 'click', handler);
    };
    const wrapOrderSaveAction = (component)=>{
        if (typeof component.oldClickOrderSaveAction !== 'undefined' || typeof component.clickOrderSaveAction === 'undefined') return;
        component.oldClickOrderSaveAction = component.clickOrderSaveAction;
        component.clickOrderSaveAction = function(event) {
            const licenceChecked = inputByName('licenses_order')?.checked || theme().SHOW_LICENCE !== 'Y';
            const offerChecked = inputByName('offer_order')?.checked || theme().SHOW_OFFER !== 'Y';
            if (licenceChecked && offerChecked) {
                document.querySelectorAll('.bx-soa .licence_block label.error').forEach((error)=>{
                    error.classList.add('hidden');
                });
                document.querySelectorAll('.bx-soa .offer_block label.error').forEach((error)=>{
                    error.classList.add('hidden');
                });
                if (component.isValidForm?.()) {
                    component.allowOrderSave?.();
                    if (typeof component.doSaveAction === 'function') component.doSaveAction();
                    else component.oldClickOrderSaveAction.call(component, event);
                }
                return;
            }
            if (!inputByName('licenses_order')?.checked) document.querySelectorAll('.bx-soa .licence_block label.error').forEach((error)=>{
                error.classList.remove('hidden');
            });
            if (!inputByName('offer_order')?.checked) document.querySelectorAll('.bx-soa .offer_block label.error').forEach((error)=>{
                error.classList.remove('hidden');
            });
        };
        const checkbox = component.orderSaveBlockNode?.querySelector('.checkbox');
        if (checkbox && typeof window.browser === 'object') checkbox.remove();
        bindBxClick(component.totalInfoBlockNode?.querySelector('a.btn-order-save'), component);
        bindBxClick(component.mobileTotalBlockNode?.querySelector('a.btn-order-save'), component);
        bindBxClick(component.orderSaveBlockNode?.querySelector('a'), component);
    };
    const updateLicenceAndOffer = (component)=>{
        const showLicence = theme().SHOW_LICENCE === 'Y';
        const showOffer = theme().SHOW_OFFER === 'Y';
        if (!document.querySelector('.bx-soa-cart-total-line-total') || !showLicence && !showOffer) return;
        renderLicenceBlocks(component, showLicence, showOffer);
        document.querySelectorAll('#bx-soa-orderSave, .bx-soa-cart-total-button-container').forEach((node)=>{
            node.classList.add('lic_condition');
        });
        wrapOrderSaveAction(component);
    };
    const parseResult = (result)=>{
        if (result && typeof result === 'object') return result;
        if (typeof result !== 'string') return null;
        if (bx() && typeof bx().parseJSON === 'function') return bx().parseJSON(result);
        try {
            return JSON.parse(result);
        } catch  {
            return null;
        }
    };
    const callOldSaveOrder = (component, result)=>{
        component.oldSaveOrder.call(component, result);
    };
    const checkOrderBeforeSave = (component, orderId, result)=>{
        fetch(`${options().SITE_DIR || '/'}ajax/check_order.php`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: new URLSearchParams({
                ID: orderId
            })
        }).then((response)=>response.json()).then((id)=>{
            const parsedId = parseInt(id, 10);
            if (parsedId && typeof window.purchaseCounter === 'function') window.purchaseCounter(parsedId, message('FULL_ORDER'), (data)=>{
                if (typeof window.localStorage !== 'undefined' && typeof data === 'object') window.localStorage.setItem(`gtm_e_${orderId}`, JSON.stringify(data));
                callOldSaveOrder(component, result);
            });
            else callOldSaveOrder(component, result);
        }).catch(()=>{
            callOldSaveOrder(component, result);
        });
    };
    const wrapSaveOrder = (component)=>{
        if (typeof window.checkCounters !== 'function' || !window.checkCounters() || typeof component.oldSaveOrder !== 'undefined') return;
        const saveFunc = typeof component.saveOrder !== 'undefined' ? 'saveOrder' : 'saveOrderWithJson';
        if (typeof component[saveFunc] === 'undefined') return;
        component.oldSaveOrder = component[saveFunc];
        component[saveFunc] = function(result) {
            const parsed = parseResult(result);
            const order = parsed?.order;
            if (!order || order.SHOW_AUTH || !order.REDIRECT_URL || order.REDIRECT_URL.length < 1 || order.ERROR && Object.keys(order.ERROR).length) {
                callOldSaveOrder(component, result);
                return;
            }
            const matches = order.REDIRECT_URL.match(/ORDER_ID=[^&=]*/g);
            const orderId = matches?.length ? matches[0].replace(/ORDER_ID=/g, '') : '';
            if (orderId) checkOrderBeforeSave(component, orderId, result);
            else callOldSaveOrder(component, result);
        };
    };
    const setupInvisibleCaptcha = (component)=>{
        const captchaRows = document.querySelectorAll('#bx-soa-order-form .captcha-row');
        if (!captchaRows.length) return;
        if (window.asproRecaptcha && window.asproRecaptcha.key && window.asproRecaptcha.params?.recaptchaSize === 'invisible') captchaRows.forEach((row)=>{
            row.classList.add('invisible');
            if (window.asproRecaptcha.params.recaptchaLogoShow === 'n') row.classList.add('logo_captcha_n');
        });
        if (!document.querySelector('#bx-soa-order-form .captcha-row.invisible') || typeof component.oldSendRequest !== 'undefined' || typeof component.sendRequest === 'undefined') return;
        let tmpAction;
        let tmpActionData;
        component.oldSendRequest = component.sendRequest;
        component.sendRequest = function(action, actionData) {
            let send = true;
            if (document.querySelector('#bx-soa-order-form .captcha-row.invisible') && window.renderRecaptchaById && window.asproRecaptcha && window.asproRecaptcha.key && window.asproRecaptcha.params?.recaptchaSize === 'invisible') {
                const form = document.getElementById('bx-soa-order-form');
                const recaptcha = form?.querySelector('.g-recaptcha');
                const response = form?.querySelector('.g-recaptcha-response');
                if (recaptcha && !response?.value) {
                    if (typeof window.grecaptcha !== 'undefined') window.grecaptcha.execute(recaptcha.dataset.widgetid);
                    send = false;
                }
            }
            if (send) component.oldSendRequest.call(component, action, actionData);
            else {
                tmpAction = action;
                tmpActionData = actionData;
            }
        };
        if (!state.captchaSubmitHandlerBound) {
            state.captchaSubmitHandlerBound = true;
            document.addEventListener('submit', (event)=>{
                if (!event.target.matches('#bx-soa-order-form')) return;
                event.preventDefault();
                if (typeof tmpAction !== 'undefined' || typeof tmpActionData !== 'undefined') {
                    component.sendRequest(tmpAction, tmpActionData);
                    tmpAction = undefined;
                    tmpActionData = undefined;
                }
            });
        }
    };
    const bindQuickLocations = ()=>{
        if (state.quickLocationsClickBound) return;
        state.quickLocationsClickBound = true;
        document.addEventListener('click', (event)=>{
            const location = event.target.closest('.bx-ui-sls-quick-locations.quick-locations');
            if (!location) return;
            Array.from(location.parentNode?.children || []).forEach((sibling)=>{
                if (sibling !== location) sibling.classList.remove('active');
            });
            location.classList.add('active');
        });
    };
    const runOrderActions = ()=>{
        if (!options().PAGES?.ORDER_PAGE || !document.querySelector('.bx-soa-cart-total')) return;
        addChangeBasket();
        const component = orderComponent();
        if (component && typeof component === 'object') {
            sendBeginOrderGoal(component);
            sendCheckoutCounterGoal(component);
            updateChangeBasketLink(component);
            updateAuthForm();
            updateRegisterForm();
            updateLicenceAndOffer(component);
            window.dispatchEvent(new Event('scroll'));
            wrapSaveOrder(component);
            setupInvisibleCaptcha(component);
        }
        bindQuickLocations();
    };
    const bindAjaxHandlers = ()=>{
        if (state.ajaxHandlersBound || !bx() || typeof bx().addCustomEvent !== 'function') return;
        state.ajaxHandlersBound = true;
        bx().addCustomEvent('onAjaxSuccess', runOrderActions);
    };
    const start = ()=>{
        runOrderActions();
        bindAjaxHandlers();
        if (bx() && typeof bx().ready === 'function') bx().ready(runOrderActions);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
})();


document.addEventListener('DOMContentLoaded', ()=>{
    const form = document.querySelector('.cp-pass-edit__form');
    if (!form) return;
    const passwordInput = form.querySelector('#pass');
    const confirmInput = form.querySelector('#pass_confirm');
    const errorMessage = form.dataset.passwordMatchError || "\u041F\u0430\u0440\u043E\u043B\u0438 \u043D\u0435 \u0441\u043E\u0432\u043F\u0430\u0434\u0430\u044E\u0442";
    form.addEventListener('submit', (e)=>{
        const confirmGroup = confirmInput.closest('.form-content__group');
        if (confirmGroup) {
            confirmGroup.classList.remove('error');
            const errorSpan = confirmGroup.querySelector('.form-content__error');
            if (errorSpan) errorSpan.textContent = '';
        }
        if (passwordInput.value !== confirmInput.value) {
            e.preventDefault();
            if (confirmGroup) {
                confirmGroup.classList.add('error');
                const errorSpan = confirmGroup.querySelector('.form-content__error');
                if (errorSpan) {
                    const msg = errorMessage.trim();
                    errorSpan.textContent = msg.startsWith('*') ? msg : `*${msg}`;
                }
            }
            confirmInput.focus();
        }
    });
    confirmInput.addEventListener('input', ()=>{
        if (passwordInput.value === confirmInput.value) {
            const confirmGroup = confirmInput.closest('.form-content__group');
            if (confirmGroup) {
                confirmGroup.classList.remove('error');
                const errorSpan = confirmGroup.querySelector('.form-content__error');
                if (errorSpan) errorSpan.textContent = '';
            }
        }
    });
});


/* global BX, jsAjaxUtil */ 

BX.namespace('BX.Sale.PersonalOrderComponent');
(function() {
    BX.Sale.PersonalOrderComponent.PersonalOrderDetail = {
        init: function(params) {
            var linkMoreOrderInformation = document.getElementsByClassName('sale-order-detail-about-order-inner-container-name-read-more')[0];
            var linkLessOrderInformation = document.getElementsByClassName('sale-order-detail-about-order-inner-container-name-read-less')[0];
            var clientInformation = document.getElementsByClassName('sale-order-detail-about-order-inner-container-details')[0];
            var listShipmentWrapper = document.getElementsByClassName('sale-order-detail-payment-options-shipment');
            var listPaymentWrapper = document.getElementsByClassName('sale-order-detail-payment-options-methods');
            var shipmentTrackingId = document.getElementsByClassName('sale-order-detail-shipment-id');
            if (shipmentTrackingId[0]) Array.prototype.forEach.call(shipmentTrackingId, function(blockId) {
                var clipboard = blockId.parentNode.getElementsByClassName('sale-order-detail-shipment-id-icon')[0];
                if (clipboard) BX.clipboard.bindCopyClick(clipboard, {
                    text: blockId.innerHTML
                });
            });
            BX.bind(linkMoreOrderInformation, 'click', function() {
                clientInformation.style.display = 'inline-block';
                linkMoreOrderInformation.style.display = 'none';
                linkLessOrderInformation.style.display = 'inline-block';
            }, this);
            BX.bind(linkLessOrderInformation, 'click', function() {
                clientInformation.style.display = 'none';
                linkMoreOrderInformation.style.display = 'inline-block';
                linkLessOrderInformation.style.display = 'none';
            }, this);
            Array.prototype.forEach.call(listShipmentWrapper, function(shipmentWrapper) {
                var detailShipmentBlock = shipmentWrapper.getElementsByClassName('sale-order-detail-payment-options-shipment-composition-map')[0];
                var showInformation = shipmentWrapper.getElementsByClassName('sale-order-detail-show-link')[0];
                var hideInformation = shipmentWrapper.getElementsByClassName('sale-order-detail-hide-link')[0];
                BX.bindDelegate(shipmentWrapper, 'click', {
                    class: 'sale-order-detail-show-link'
                }, BX.proxy(function() {
                    showInformation.style.display = 'none';
                    hideInformation.style.display = 'inline-block';
                    detailShipmentBlock.style.display = 'block';
                }, this));
                BX.bindDelegate(shipmentWrapper, 'click', {
                    class: 'sale-order-detail-hide-link'
                }, BX.proxy(function() {
                    showInformation.style.display = 'inline-block';
                    hideInformation.style.display = 'none';
                    detailShipmentBlock.style.display = 'none';
                }, this));
            });
            Array.prototype.forEach.call(listPaymentWrapper, function(paymentWrapper) {
                var rowPayment = paymentWrapper.getElementsByClassName('sale-order-detail-payment-options-methods-info')[0];
                BX.bindDelegate(paymentWrapper, 'click', {
                    class: 'active-button'
                }, BX.proxy(function() {
                    BX.toggleClass(paymentWrapper, 'sale-order-detail-active-event');
                }, this));
                BX.bindDelegate(rowPayment, 'click', {
                    class: 'sale-order-detail-payment-options-methods-info-change-link'
                }, BX.proxy(function(event) {
                    event.preventDefault();
                    var btn = rowPayment.parentNode.getElementsByClassName('sale-order-detail-payment-options-methods-button-container')[0];
                    var linkReturn = rowPayment.parentNode.getElementsByClassName('sale-order-detail-payment-inner-row-template')[0];
                    BX.ajax({
                        method: 'POST',
                        dataType: 'html',
                        url: params.url,
                        data: {
                            sessid: BX.bitrix_sessid(),
                            orderData: params.paymentList[event.target.id],
                            templateName: params.templateName
                        },
                        onsuccess: BX.proxy(function(result) {
                            rowPayment.innerHTML = result;
                            if (btn) btn.parentNode.removeChild(btn);
                            linkReturn.style.display = 'block';
                            BX.bind(linkReturn, 'click', function() {
                                window.location.reload();
                            }, this);
                        }, this),
                        onfailure: BX.proxy(function() {
                            return this;
                        }, this)
                    }, this);
                }, this));
            });
        }
    };
})();
function $c5fc9721163636d4$var$markProductToBasket(element) {
    const toCartTitle = element.querySelector('span');
    toCartTitle.textContent = "\u0412 \u043A\u043E\u0440\u0437\u0438\u043D\u0435";
    element.classList.add('in-basket');
}
function $c5fc9721163636d4$var$openBasketFly() {
    const basket = document.querySelector('#basket_line .basket_fly, .basket_fly.basket-fly');
    if (!basket) return;
    basket.classList.add('basket-fly--opened');
    basket.classList.remove('basket-fly--closed');
    basket.setAttribute('aria-hidden', 'false');
    (0, $1447ccd9a012ced8$export$696425601a52f2e4)(basket, 'AnDelCanBuy');
}
const $c5fc9721163636d4$var$activeCompareSvg = '<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="34" height="34" rx="17" fill="#2059B0"/><path d="M12.92 22.4399L12.92 11.5599M17 22.4399L17 15.6399M21.08 22.4399L21.08 19.7199" stroke="white" stroke-width="1.36" stroke-linecap="round" stroke-linejoin="round"/></svg>';
function $c5fc9721163636d4$var$getCompareButtonElement(element) {
    return element.querySelector('.catalog-card__compare') || element;
}
function $c5fc9721163636d4$var$storeOriginalCompareSvg(element) {
    if (!element.originalSvgStored) {
        const svgElement = element.querySelector('svg');
        if (svgElement) {
            element.originalSvg = svgElement.outerHTML;
            element.originalSvgStored = true;
        }
    }
}
function $c5fc9721163636d4$var$setCompareActive(element, isActive) {
    $c5fc9721163636d4$var$storeOriginalCompareSvg(element);
    if (isActive) {
        element.classList.add('active');
        element.innerHTML = $c5fc9721163636d4$var$activeCompareSvg;
    } else {
        element.classList.remove('active');
        if (element.originalSvg) element.innerHTML = element.originalSvg;
    }
}
document.addEventListener('DOMContentLoaded', ()=>{
    const viewMoreButtons = document.querySelectorAll('.cp_orders__more');
    viewMoreButtons.forEach((button)=>{
        button.addEventListener('click', ()=>{
            const order = button.closest('.cp_orders__item');
            const productsList = order ? order.querySelector('.cp_orders__item-products') : null;
            button.classList.toggle('cp_orders__more--active');
            if (productsList) productsList.classList.toggle('cp_orders__item-products_active');
        });
    });
    const products = document.querySelectorAll('.cp_orders__item-product');
    function markProductsToBasket(productId) {
        products.forEach((product)=>{
            const toCart = product.querySelector('.cp_orders__item-product__controls-cart');
            if (toCart && toCart.dataset.item === productId) $c5fc9721163636d4$var$markProductToBasket(toCart);
        });
    }
    function markProductsToCompare(productId) {
        products.forEach((product)=>{
            const toCart = product.querySelector('.cp_orders__item-product__controls-cart');
            const toCompare = product.querySelector('.cp_orders__item-product__controls-compare');
            if (toCart && toCompare && toCart.dataset.item === productId) $c5fc9721163636d4$var$setCompareActive($c5fc9721163636d4$var$getCompareButtonElement(toCompare), true);
        });
    }
    function syncCompareButtons() {
        if (!window.CatalogCardState) return;
        products.forEach((product)=>{
            const toCart = product.querySelector('.cp_orders__item-product__controls-cart');
            const toCompare = product.querySelector('.cp_orders__item-product__controls-compare');
            if (!toCart || !toCompare) return;
            const productId = toCart.dataset.item;
            const compareButton = $c5fc9721163636d4$var$getCompareButtonElement(toCompare);
            $c5fc9721163636d4$var$setCompareActive(compareButton, productId in window.CatalogCardState.compare);
        });
    }
    products.forEach((product)=>{
        const toCart = product.querySelector('.cp_orders__item-product__controls-cart');
        if (!toCart) return;
        const productId = toCart.dataset.item;
        fetch(`/api/v1/basket/item/${productId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Session-Id': BX.bitrix_sessid()
            }
        }).then((res)=>res.json()).then(function(result) {
            if (result.isProductFromBasket) markProductsToBasket(productId);
        }).catch((err)=>console.error(err));
        toCart.addEventListener('click', (event)=>{
            event.preventDefault();
            fetch('/api/v1/basket', {
                method: 'POST',
                body: JSON.stringify({
                    productId: productId
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Session-Id': BX.bitrix_sessid()
                }
            }).then((res)=>res.json()).then(async function(result) {
                if (result.success === false) return;
                try {
                    await (0, $d6bc0afe1a05eefb$export$37001b2ee4aaacfe)();
                    $c5fc9721163636d4$var$openBasketFly();
                } catch (err) {
                    console.error(err);
                }
                markProductsToBasket(productId);
                BX.onCustomEvent('onCompleteAction', [
                    {
                        action: 'loadBasket'
                    }
                ]);
            }).catch((err)=>console.error(err));
        });
        const toCompare = product.querySelector('.cp_orders__item-product__controls-compare');
        if (!toCompare) return;
        toCompare.addEventListener('click', (event)=>{
            event.preventDefault();
            fetch('/api/v1/compare', {
                method: 'POST',
                body: JSON.stringify({
                    productId: productId
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Session-Id': BX.bitrix_sessid()
                }
            }).then((res)=>res.json()).then(function(result) {
                if (result.success === false) return;
                jsAjaxUtil.InsertDataToNode('/ajax/show_compare_preview_fly.php', 'compare_fly', false);
                markProductsToCompare(productId);
                BX.onCustomEvent('onCompleteAction', [
                    {
                        action: 'loadBasket'
                    }
                ]);
            }).catch((err)=>console.error(err));
        });
    });
    if (window.CatalogCardState) {
        window.CatalogCardState.onReady(syncCompareButtons);
        window.CatalogCardState.addUpdateListener(syncCompareButtons);
    }
});


/* global BX, FormUtils */ (function() {
    'use strict';
    if (typeof BX === 'undefined' || typeof FormUtils === 'undefined') return;
    const form = document.getElementById('catalog-detail__question');
    if (!form) return;
    const submitBtn = form.querySelector('#submit-feedback-btn');
    const commonErrorsBlock = form.querySelector('#question-form-common-errors');
    const captchaContainerId = 'captcha-container-static-question';
    const containerSelector = '#catalog-detail__question';
    const fullname = form.querySelector('#fullname-question');
    const phone = form.querySelector('#phone-question');
    const email = form.querySelector('#email-question');
    const message = form.querySelector('#message-question');
    const productName = form.querySelector('#product-name');
    let staticCaptchaWidgetId = null;
    FormUtils.setupPhoneMask(phone);
    const renderCaptcha = ()=>{
        const container = document.getElementById(captchaContainerId);
        if (!container || staticCaptchaWidgetId !== null) return;
        try {
            staticCaptchaWidgetId = window.smartCaptcha.render(captchaContainerId, {
                sitekey: container.getAttribute('data-sitekey'),
                style: 'adaptive'
            });
        } catch (e) {
            console.error("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u0440\u0435\u043D\u0434\u0435\u0440\u0438\u0442\u044C \u043A\u0430\u043F\u0447\u0443:", e);
        }
    };
    const initStaticCaptcha = ()=>{
        if (window.smartCaptcha) renderCaptcha();
        else {
            const checkInterval = setInterval(()=>{
                if (window.smartCaptcha) {
                    clearInterval(checkInterval);
                    renderCaptcha();
                }
            }, 100);
            setTimeout(()=>clearInterval(checkInterval), 10000);
        }
    };
    initStaticCaptcha();
    const hideErrors = ()=>{
        FormUtils.clearFieldErrors(containerSelector);
        FormUtils.hideCommonError(commonErrorsBlock);
    };
    const validate = ()=>{
        let isValid = true;
        hideErrors();
        if (!FormUtils.validateRequired(fullname.value)) {
            FormUtils.showFieldError(fullname, "*\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
            isValid = false;
        }
        const phoneDigits = phone.value.replace(/\D/g, '');
        if (!FormUtils.validateRequired(phone.value)) {
            FormUtils.showFieldError(phone, "*\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
            isValid = false;
        } else if (!FormUtils.validatePhoneDigits(phoneDigits)) {
            FormUtils.showFieldError(phone, "*\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 (\u043D\u0435 \u043C\u0435\u043D\u0435\u0435 10 \u0446\u0438\u0444\u0440)");
            isValid = false;
        }
        if (!FormUtils.validateRequired(email.value)) {
            FormUtils.showFieldError(email, "*\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
            isValid = false;
        } else if (!FormUtils.validateEmail(email.value)) {
            FormUtils.showFieldError(email, "*\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 E-mail");
            isValid = false;
        }
        const captchaToken = form.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        if (!captchaToken || !captchaToken.value) {
            FormUtils.showCommonError(commonErrorsBlock, "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435, \u0447\u0442\u043E \u0432\u044B \u043D\u0435 \u0440\u043E\u0431\u043E\u0442");
            isValid = false;
        }
        if (!isValid) FormUtils.scrollToFirstError(containerSelector, commonErrorsBlock);
        return isValid;
    };
    const clearFields = ()=>{
        fullname.value = '';
        phone.value = '';
        email.value = '';
        message.value = '';
        if (window.smartCaptcha) {
            if (staticCaptchaWidgetId !== null) try {
                window.smartCaptcha.reset(staticCaptchaWidgetId);
                return;
            } catch (e) {
                console.warn("\u0421\u0431\u0440\u043E\u0441 \u043F\u043E ID \u043D\u0435 \u0443\u0434\u0430\u043B\u0441\u044F, \u043F\u0440\u043E\u0431\u0443\u0435\u043C \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u044B\u0439 \u043C\u0435\u0442\u043E\u0434...");
            }
            try {
                const dynamicWidgetId = window.smartCaptcha.getResponse(captchaContainerId);
                window.smartCaptcha.reset(dynamicWidgetId);
            } catch (e) {
                window.smartCaptcha.reset();
            }
        }
    };
    const sendQuestion = async ()=>{
        if (!validate()) return;
        const captchaToken = form.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        const token = typeof BX.bitrix_sessid === 'function' ? BX.bitrix_sessid() : '';
        const payload = {
            fullname: fullname.value,
            phone: phone.value,
            email: email.value,
            message: message.value,
            product_name: productName ? productName.value : '',
            smart_token: captchaToken ? captchaToken.value : ''
        };
        if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.innerText = "\u041E\u0442\u043F\u0440\u0430\u0432\u043A\u0430...";
        }
        try {
            await FormUtils.sendFormData({
                url: '/api/v1/form/ask-question',
                payload: payload,
                headers: {
                    'Session-Id': token,
                    'X-Requested-With': 'XMLHttpRequest'
                },
                submitBtn: submitBtn,
                commonErrorsBlock: commonErrorsBlock,
                containerSelector: containerSelector,
                onSuccess: (result)=>{
                    alert(result.message || "\u0421\u043F\u0430\u0441\u0438\u0431\u043E! \u0412\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E.");
                    clearFields();
                },
                onFieldError: (field, msg)=>{
                    const el = form.querySelector(`#${field}`);
                    if (el) FormUtils.showFieldError(el, msg);
                }
            });
        } catch (e) {
            console.error(e);
        } finally{
            if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.innerText = "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C";
            }
        }
    };
    if (submitBtn) submitBtn.addEventListener('click', sendQuestion);
})();


/**
 * Отслеживание электронной коммерции (Enhanced Ecommerce) -> dataLayer.
 * Глобальные функции для совместимости со старыми вызовами Аспро.
 */ if (typeof window.EcommerceTracker === 'undefined') window.EcommerceTracker = class EcommerceTracker {
    constructor(){
        window.dataLayer = window.dataLayer || [];
        this.exposeGlobals();
    }
    logError(methodName, error) {
        console.error(`[EcommerceTracker.${methodName}]`, error);
    }
    // Регистрация глобальных функций Аспро в window
    exposeGlobals() {
        window.checkCounters = this.safeCheckCounters.bind(this);
        window.addBasketCounter = this.safeAddBasketCounter.bind(this);
        window.purchaseCounter = this.safePurchaseCounter.bind(this);
        window.viewItemCounter = this.safeViewItemCounter.bind(this);
        window.delFromBasketCounter = this.safeDelFromBasketCounter.bind(this);
        window.checkoutCounter = this.safeCheckoutCounter.bind(this);
    }
    getCounters() {
        return window.arNextOptions.COUNTERS;
    }
    getSiteDir() {
        return window.arNextOptions.SITE_DIR;
    }
    getEvents() {
        return this.getCounters().GOOGLE_EVENTS;
    }
    // Проверка активности счетчиков
    checkCounters(name) {
        const counters = this.getCounters();
        if (typeof name !== 'undefined') {
            if (name === 'google') return counters.GOOGLE_ECOMERCE === 'Y' && counters.GOOGLE_COUNTER > 0;
            if (name === 'yandex') return counters.YANDEX_ECOMERCE === 'Y' && counters.YANDEX_COUNTER > 0;
            return false;
        }
        return counters.YANDEX_ECOMERCE === 'Y' && counters.YANDEX_COUNTER > 0 || counters.GOOGLE_ECOMERCE === 'Y' && counters.GOOGLE_COUNTER > 0;
    }
    safeCheckCounters(name) {
        try {
            return this.checkCounters(name);
        } catch (error) {
            this.logError('checkCounters', error);
            return false;
        }
    }
    waitDataLayer(callback) {
        if (typeof window.dataLayer !== 'undefined') {
            callback();
            return;
        }
        window.setTimeout(()=>{
            this.waitDataLayer(callback);
        }, 100);
    }
    // Запрос данных о товаре/заказе через ajax/goals.php
    fetchGoals(payload) {
        return window.fetch(`${this.getSiteDir()}ajax/goals.php`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: new URLSearchParams(payload)
        }).then((response)=>response.json());
    }
    mapBasketProducts(items) {
        const products = [];
        for(const key in items){
            const row = items[key];
            products.push({
                id: row.ID,
                sku: row.ID,
                name: row.NAME,
                price: row.PRICE,
                brand: row.BRAND,
                category: row.CATEGORY,
                quantity: row.QUANTITY
            });
        }
        return products;
    }
    // Добавление в корзину (addToCart)
    addBasketCounter(id) {
        if (this.getCounters().USE_BASKET_GOALS !== 'N') window.BX.onCustomEvent('onCounterGoals', [
            {
                goal: 'goal_basket_add',
                params: {
                    id: id
                }
            }
        ]);
        return this.fetchGoals({
            ID: id
        }).then((item)=>{
            this.waitDataLayer(()=>{
                window.dataLayer.push({
                    event: this.getEvents().ADD2BASKET,
                    ecommerce: {
                        currencyCode: item.CURRENCY,
                        add: {
                            products: [
                                {
                                    id: item.ID,
                                    name: item.NAME,
                                    price: item.PRICE,
                                    brand: item.BRAND,
                                    category: item.CATEGORY,
                                    quantity: item.QUANTITY
                                }
                            ]
                        }
                    }
                });
            });
        });
    }
    safeAddBasketCounter(id) {
        try {
            const request = this.addBasketCounter(id);
            if (request && typeof request.catch === 'function') request.catch((error)=>this.logError('addBasketCounter', error));
        } catch (error) {
            this.logError('addBasketCounter', error);
        }
    }
    // Оформление заказа (purchase)
    purchaseCounter(orderId, type, callback) {
        return this.fetchGoals({
            ORDER_ID: orderId,
            TYPE: type
        }).then((order)=>{
            const products = this.mapBasketProducts(order.ITEMS);
            this.waitDataLayer(()=>{
                const ecommerce = {
                    purchase: {
                        actionField: {
                            id: order.ACCOUNT_NUMBER,
                            shipping: order.PRICE_DELIVERY,
                            tax: order.TAX_VALUE,
                            list: type,
                            revenue: order.PRICE
                        },
                        products: products
                    }
                };
                window.dataLayer.push({
                    event: this.getEvents().PURCHASE,
                    ecommerce: ecommerce
                });
                callback(ecommerce);
            });
        });
    }
    safePurchaseCounter(orderId, type, callback) {
        const done = typeof callback === 'function' ? callback : function() {};
        try {
            const request = this.purchaseCounter(orderId, type, done);
            if (request && typeof request.catch === 'function') request.catch((error)=>{
                this.logError('purchaseCounter', error);
                done();
            });
        } catch (error) {
            this.logError('purchaseCounter', error);
            done();
        }
    }
    // Просмотр карточки товара (detail)
    viewItemCounter(id, priceId) {
        return this.fetchGoals({
            PRODUCT_ID: id,
            PRICE_ID: priceId
        }).then((item)=>{
            this.waitDataLayer(()=>{
                window.dataLayer.push({
                    ecommerce: {
                        detail: {
                            products: [
                                {
                                    id: item.ID,
                                    name: item.NAME,
                                    price: item.PRICE,
                                    brand: item.BRAND,
                                    category: item.CATEGORY
                                }
                            ]
                        }
                    }
                });
            });
        });
    }
    safeViewItemCounter(id, priceId) {
        try {
            const request = this.viewItemCounter(id, priceId);
            if (request && typeof request.catch === 'function') request.catch((error)=>this.logError('viewItemCounter', error));
        } catch (error) {
            this.logError('viewItemCounter', error);
        }
    }
    // Удаление из корзины (removeFromCart)
    delFromBasketCounter(id, callback = function() {}) {
        return this.fetchGoals({
            ID: id
        }).then((item)=>{
            this.waitDataLayer(()=>{
                window.dataLayer.push({
                    event: this.getEvents().REMOVE_BASKET,
                    ecommerce: {
                        remove: {
                            products: [
                                {
                                    id: item.ID,
                                    name: item.NAME,
                                    category: item.CATEGORY
                                }
                            ]
                        }
                    }
                });
                callback();
            });
        });
    }
    safeDelFromBasketCounter(id, callback) {
        const done = typeof callback === 'function' ? callback : function() {};
        try {
            const request = this.delFromBasketCounter(id, done);
            if (request && typeof request.catch === 'function') request.catch((error)=>{
                this.logError('delFromBasketCounter', error);
                done();
            });
        } catch (error) {
            this.logError('delFromBasketCounter', error);
            done();
        }
    }
    // Переход к оформлению заказа (checkout)
    checkoutCounter(step, option) {
        return this.fetchGoals({
            BASKET: 'Y'
        }).then((basket)=>{
            const products = this.mapBasketProducts(basket.ITEMS);
            this.waitDataLayer(()=>{
                window.dataLayer.push({
                    event: this.getEvents().CHECKOUT_ORDER,
                    ecommerce: {
                        checkout: {
                            actionField: {
                                step: step,
                                option: option
                            },
                            products: products
                        }
                    }
                });
            });
        });
    }
    safeCheckoutCounter(step, option) {
        try {
            const request = this.checkoutCounter(step, option);
            if (request && typeof request.catch === 'function') request.catch((error)=>this.logError('checkoutCounter', error));
        } catch (error) {
            this.logError('checkoutCounter', error);
        }
    }
};
try {
    new window.EcommerceTracker();
} catch (error) {
    console.error('[EcommerceTracker.init]', error);
}


const $e6c0450a86c01bf1$var$TAB_IDS = [
    'tools',
    'rules',
    'sales'
];
function $e6c0450a86c01bf1$var$setToolRentalTab(root, tabId, updateHash = true) {
    if (!$e6c0450a86c01bf1$var$TAB_IDS.includes(tabId)) return;
    root.querySelectorAll('[data-tool-rental-tab]').forEach((tabButton)=>{
        const isActive = tabButton.dataset.toolRentalTab === tabId;
        tabButton.classList.toggle('tool-rental__tab--active', isActive);
        tabButton.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    root.querySelectorAll('[data-tool-rental-panel]').forEach((panel)=>{
        const isActive = panel.dataset.toolRentalPanel === tabId;
        panel.classList.toggle('tool-rental__panel--active', isActive);
        panel.hidden = !isActive;
    });
    if (updateHash) {
        const url = new URL(window.location.href);
        url.searchParams.set('tab', tabId);
        window.history.replaceState(null, '', url);
    }
}
function $e6c0450a86c01bf1$var$getTabFromHash() {
    const hash = window.location.hash.replace('#', '');
    return $e6c0450a86c01bf1$var$TAB_IDS.includes(hash) ? hash : null;
}
function $e6c0450a86c01bf1$var$getTabFromQuery() {
    const tab = new URLSearchParams(window.location.search).get('tab');
    return $e6c0450a86c01bf1$var$TAB_IDS.includes(tab) ? tab : null;
}
function $e6c0450a86c01bf1$export$3caf05f86a056cb3() {
    const root = document.querySelector('[data-tool-rental-tabs]');
    if (!root) return;
    const defaultTab = root.dataset.toolRentalDefaultTab || 'rules';
    const initialTab = $e6c0450a86c01bf1$var$getTabFromHash() || $e6c0450a86c01bf1$var$getTabFromQuery() || defaultTab;
    $e6c0450a86c01bf1$var$setToolRentalTab(root, initialTab, false);
    root.querySelectorAll('[data-tool-rental-tab]').forEach((tabButton)=>{
        tabButton.addEventListener('click', ()=>{
            $e6c0450a86c01bf1$var$setToolRentalTab(root, tabButton.dataset.toolRentalTab);
        });
    });
    window.addEventListener('hashchange', ()=>{
        const tabId = $e6c0450a86c01bf1$var$getTabFromHash();
        if (tabId) $e6c0450a86c01bf1$var$setToolRentalTab(root, tabId, false);
    });
    root.querySelectorAll('[data-tool-rental-accordion-head]').forEach((head)=>{
        head.addEventListener('click', ()=>{
            if (head.disabled) return;
            const bodyId = head.getAttribute('aria-controls');
            const body = bodyId ? document.getElementById(bodyId) : null;
            if (!body) return;
            const isExpanded = head.getAttribute('aria-expanded') === 'true';
            const nextExpanded = !isExpanded;
            head.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
            body.hidden = !nextExpanded;
            const item = head.closest('.tool-rental__accordion-item');
            if (item) item.classList.toggle('tool-rental__accordion-item--open', nextExpanded);
        });
    });
}


function $b089cdbee9da5cef$var$setDeliveryRatesExpanded(root, expanded) {
    const toggle = root.querySelector('[data-delivery-rates-toggle]');
    const collapse = root.querySelector('[data-delivery-rates-collapse]');
    if (!toggle || !collapse) return;
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    collapse.setAttribute('aria-hidden', expanded ? 'false' : 'true');
    root.classList.toggle('delivery-rates--open', expanded);
}
function $b089cdbee9da5cef$var$initDeliveryRatesRoot(root) {
    const toggle = root.querySelector('[data-delivery-rates-toggle]');
    if (!toggle) return;
    const openFromHash = ()=>window.location.hash === '#rate';
    const shouldOpen = openFromHash();
    $b089cdbee9da5cef$var$setDeliveryRatesExpanded(root, shouldOpen);
    if (shouldOpen) root.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
    toggle.addEventListener('click', (event)=>{
        event.preventDefault();
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        $b089cdbee9da5cef$var$setDeliveryRatesExpanded(root, !isExpanded);
    });
}
function $b089cdbee9da5cef$export$f6efd7ffac56f434() {
    document.querySelectorAll('[data-delivery-rates]').forEach($b089cdbee9da5cef$var$initDeliveryRatesRoot);
    window.addEventListener('hashchange', ()=>{
        if (window.location.hash !== '#rate') return;
        document.querySelectorAll('[data-delivery-rates]').forEach((root)=>{
            $b089cdbee9da5cef$var$setDeliveryRatesExpanded(root, true);
            root.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        });
    });
}




/* global BX */ if (typeof window.B2bCalculationApi === 'undefined') window.B2bCalculationApi = class B2bCalculationApi {
    collect() {
        const fields = document.querySelectorAll('[data-b2b-form] [data-field]');
        const data = {};
        for (const field of fields){
            if (field.disabled || field.hidden || field.closest('[hidden]')) continue;
            data[field.dataset.field] = field.value.trim();
        }
        const captchaInput = document.querySelector('[data-b2b-captcha] input[name="smart-token"]');
        data.smart_token = captchaInput ? captchaInput.value : '';
        return data;
    }
    async send(payload) {
        const response = await fetch('/api/v1/form/b2b-calculation', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'Session-Id': typeof BX !== 'undefined' && typeof BX.bitrix_sessid === 'function' ? BX.bitrix_sessid() : ''
            },
            body: JSON.stringify(payload)
        });
        const result = await response.json();
        if (!response.ok || result.success === false) throw new Error(result.message || "\u041E\u0448\u0438\u0431\u043A\u0430 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0438 \u0444\u043E\u0440\u043C\u044B");
        return result;
    }
};


/** Checks if value is string */ function $93906f2a377dc74e$export$844ec244b1367d54(str) {
    return typeof str === 'string' || str instanceof String;
}
/** Checks if value is object */ function $93906f2a377dc74e$export$a6cdc56e425d0d0a(obj) {
    var _obj$constructor;
    return typeof obj === 'object' && obj != null && (obj == null || (_obj$constructor = obj.constructor) == null ? void 0 : _obj$constructor.name) === 'Object';
}
function $93906f2a377dc74e$export$357523c63a2253b9(obj, keys) {
    if (Array.isArray(keys)) return $93906f2a377dc74e$export$357523c63a2253b9(obj, (_, k)=>keys.includes(k));
    return Object.entries(obj).reduce((acc, _ref)=>{
        let [k, v] = _ref;
        if (keys(v, k)) acc[k] = v;
        return acc;
    }, {});
}
/** Direction */ const $93906f2a377dc74e$export$9106728c49045482 = {
    NONE: 'NONE',
    LEFT: 'LEFT',
    FORCE_LEFT: 'FORCE_LEFT',
    RIGHT: 'RIGHT',
    FORCE_RIGHT: 'FORCE_RIGHT'
};
/** Direction */ function $93906f2a377dc74e$export$32af4dafed14c8ce(direction) {
    switch(direction){
        case $93906f2a377dc74e$export$9106728c49045482.LEFT:
            return $93906f2a377dc74e$export$9106728c49045482.FORCE_LEFT;
        case $93906f2a377dc74e$export$9106728c49045482.RIGHT:
            return $93906f2a377dc74e$export$9106728c49045482.FORCE_RIGHT;
        default:
            return direction;
    }
}
/** Escapes regular expression control chars */ function $93906f2a377dc74e$export$7c57da42ce8e346f(str) {
    return str.replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1');
}
// cloned from https://github.com/epoberezkin/fast-deep-equal with small changes
function $93906f2a377dc74e$export$7aeb68f71172641d(b, a) {
    if (a === b) return true;
    const arrA = Array.isArray(a), arrB = Array.isArray(b);
    let i;
    if (arrA && arrB) {
        if (a.length != b.length) return false;
        for(i = 0; i < a.length; i++)if (!$93906f2a377dc74e$export$7aeb68f71172641d(a[i], b[i])) return false;
        return true;
    }
    if (arrA != arrB) return false;
    if (a && b && typeof a === 'object' && typeof b === 'object') {
        const dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA && dateB) return a.getTime() == b.getTime();
        if (dateA != dateB) return false;
        const regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA && regexpB) return a.toString() == b.toString();
        if (regexpA != regexpB) return false;
        const keys = Object.keys(a);
        // if (keys.length !== Object.keys(b).length) return false;
        for(i = 0; i < keys.length; i++)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = 0; i < keys.length; i++)if (!$93906f2a377dc74e$export$7aeb68f71172641d(b[keys[i]], a[keys[i]])) return false;
        return true;
    } else if (a && b && typeof a === 'function' && typeof b === 'function') return a.toString() === b.toString();
    return false;
}



/** Provides details of changing input */ class $61d1aadea9846d62$export$2e2bcd8739ae039 {
    /** Current input value */ /** Current cursor position */ /** Old input value */ /** Old selection */ constructor(opts){
        Object.assign(this, opts);
        // double check if left part was changed (autofilling, other non-standard input triggers)
        while(this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos))--this.oldSelection.start;
        if (this.insertedCount) {
            // double check right part
            while(this.value.slice(this.cursorPos) !== this.oldValue.slice(this.oldSelection.end))if (this.value.length - this.cursorPos < this.oldValue.length - this.oldSelection.end) ++this.oldSelection.end;
            else ++this.cursorPos;
        }
    }
    /** Start changing position */ get startChangePos() {
        return Math.min(this.cursorPos, this.oldSelection.start);
    }
    /** Inserted symbols count */ get insertedCount() {
        return this.cursorPos - this.startChangePos;
    }
    /** Inserted symbols */ get inserted() {
        return this.value.substr(this.startChangePos, this.insertedCount);
    }
    /** Removed symbols count */ get removedCount() {
        // Math.max for opposite operation
        return Math.max(this.oldSelection.end - this.startChangePos || // for Delete
        this.oldValue.length - this.value.length, 0);
    }
    /** Removed symbols */ get removed() {
        return this.oldValue.substr(this.startChangePos, this.removedCount);
    }
    /** Unchanged head symbols */ get head() {
        return this.value.substring(0, this.startChangePos);
    }
    /** Unchanged tail symbols */ get tail() {
        return this.value.substring(this.startChangePos + this.insertedCount);
    }
    /** Remove direction */ get removeDirection() {
        if (!this.removedCount || this.insertedCount) return (0, $93906f2a377dc74e$export$9106728c49045482).NONE;
        // align right if delete at right
        return (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) && // if not range removed (event with backspace)
        this.oldSelection.end === this.oldSelection.start ? (0, $93906f2a377dc74e$export$9106728c49045482).RIGHT : (0, $93906f2a377dc74e$export$9106728c49045482).LEFT;
    }
}



/** Applies mask on element */ function $9f3c06206bc5b9fe$export$2e2bcd8739ae039(el, opts) {
    // currently available only for input-like elements
    return new $9f3c06206bc5b9fe$export$2e2bcd8739ae039.InputMask(el, opts);
}


// TODO can't use overloads here because of https://github.com/microsoft/TypeScript/issues/50754
// export function maskedClass(mask: string): typeof MaskedPattern;
// export function maskedClass(mask: DateConstructor): typeof MaskedDate;
// export function maskedClass(mask: NumberConstructor): typeof MaskedNumber;
// export function maskedClass(mask: Array<any> | ArrayConstructor): typeof MaskedDynamic;
// export function maskedClass(mask: MaskedDate): typeof MaskedDate;
// export function maskedClass(mask: MaskedNumber): typeof MaskedNumber;
// export function maskedClass(mask: MaskedEnum): typeof MaskedEnum;
// export function maskedClass(mask: MaskedRange): typeof MaskedRange;
// export function maskedClass(mask: MaskedRegExp): typeof MaskedRegExp;
// export function maskedClass(mask: MaskedFunction): typeof MaskedFunction;
// export function maskedClass(mask: MaskedPattern): typeof MaskedPattern;
// export function maskedClass(mask: MaskedDynamic): typeof MaskedDynamic;
// export function maskedClass(mask: Masked): typeof Masked;
// export function maskedClass(mask: typeof Masked): typeof Masked;
// export function maskedClass(mask: typeof MaskedDate): typeof MaskedDate;
// export function maskedClass(mask: typeof MaskedNumber): typeof MaskedNumber;
// export function maskedClass(mask: typeof MaskedEnum): typeof MaskedEnum;
// export function maskedClass(mask: typeof MaskedRange): typeof MaskedRange;
// export function maskedClass(mask: typeof MaskedRegExp): typeof MaskedRegExp;
// export function maskedClass(mask: typeof MaskedFunction): typeof MaskedFunction;
// export function maskedClass(mask: typeof MaskedPattern): typeof MaskedPattern;
// export function maskedClass(mask: typeof MaskedDynamic): typeof MaskedDynamic;
// export function maskedClass<Mask extends typeof Masked> (mask: Mask): Mask;
// export function maskedClass(mask: RegExp): typeof MaskedRegExp;
// export function maskedClass(mask: (value: string, ...args: any[]) => boolean): typeof MaskedFunction;
/** Get Masked class by mask type */ function $14fa5ae7a370b810$export$81ad4b1539a22420(mask) /* TODO */ {
    if (mask == null) throw new Error('mask property should be defined');
    if (mask instanceof RegExp) return (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedRegExp;
    if ((0, $93906f2a377dc74e$export$844ec244b1367d54)(mask)) return (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedPattern;
    if (mask === Date) return (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedDate;
    if (mask === Number) return (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedNumber;
    if (Array.isArray(mask) || mask === Array) return (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedDynamic;
    if ((0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).Masked && mask.prototype instanceof (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).Masked) return mask;
    if ((0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).Masked && mask instanceof (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).Masked) return mask.constructor;
    if (mask instanceof Function) return (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedFunction;
    console.warn('Mask not found for mask', mask); // eslint-disable-line no-console
    return (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).Masked;
}
function $14fa5ae7a370b810$export$a213ae1c699d7230(opts) {
    if (!opts) throw new Error('Options in not defined');
    if ((0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).Masked) {
        if (opts.prototype instanceof (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).Masked) return {
            mask: opts
        };
        /*
      handle cases like:
      1) opts = Masked
      2) opts = { mask: Masked, ...instanceOpts }
    */ const { mask: mask, ...instanceOpts } = opts instanceof (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).Masked ? {
            mask: opts
        } : (0, $93906f2a377dc74e$export$a6cdc56e425d0d0a)(opts) && opts.mask instanceof (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).Masked ? opts : {};
        if (mask) {
            const _mask = mask.mask;
            return {
                ...(0, $93906f2a377dc74e$export$357523c63a2253b9)(mask, (_, k)=>!k.startsWith('_')),
                mask: mask.constructor,
                _mask: _mask,
                ...instanceOpts
            };
        }
    }
    if (!(0, $93906f2a377dc74e$export$a6cdc56e425d0d0a)(opts)) return {
        mask: opts
    };
    return {
        ...opts
    };
}
// TODO can't use overloads here because of https://github.com/microsoft/TypeScript/issues/50754
// From masked
// export default function createMask<Opts extends Masked, ReturnMasked=Opts> (opts: Opts): ReturnMasked;
// // From masked class
// export default function createMask<Opts extends MaskedOptions<typeof Masked>, ReturnMasked extends Masked=InstanceType<Opts['mask']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedDate>, ReturnMasked extends MaskedDate=MaskedDate<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedNumber>, ReturnMasked extends MaskedNumber=MaskedNumber<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedEnum>, ReturnMasked extends MaskedEnum=MaskedEnum<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedRange>, ReturnMasked extends MaskedRange=MaskedRange<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedRegExp>, ReturnMasked extends MaskedRegExp=MaskedRegExp<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedFunction>, ReturnMasked extends MaskedFunction=MaskedFunction<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedPattern>, ReturnMasked extends MaskedPattern=MaskedPattern<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedDynamic>, ReturnMasked extends MaskedDynamic=MaskedDynamic<Opts['parent']>> (opts: Opts): ReturnMasked;
// // From mask opts
// export default function createMask<Opts extends MaskedOptions<Masked>, ReturnMasked=Opts extends MaskedOptions<infer M> ? M : never> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedNumberOptions, ReturnMasked extends MaskedNumber=MaskedNumber<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedDateFactoryOptions, ReturnMasked extends MaskedDate=MaskedDate<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedEnumOptions, ReturnMasked extends MaskedEnum=MaskedEnum<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedRangeOptions, ReturnMasked extends MaskedRange=MaskedRange<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedPatternOptions, ReturnMasked extends MaskedPattern=MaskedPattern<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedDynamicOptions, ReturnMasked extends MaskedDynamic=MaskedDynamic<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<RegExp>, ReturnMasked extends MaskedRegExp=MaskedRegExp<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<Function>, ReturnMasked extends MaskedFunction=MaskedFunction<Opts['parent']>> (opts: Opts): ReturnMasked;
/** Creates new {@link Masked} depending on mask type */ function $14fa5ae7a370b810$export$2e2bcd8739ae039(opts) {
    if ((0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).Masked && opts instanceof (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).Masked) return opts;
    const nOpts = $14fa5ae7a370b810$export$a213ae1c699d7230(opts);
    const MaskedClass = $14fa5ae7a370b810$export$81ad4b1539a22420(nOpts.mask);
    if (!MaskedClass) throw new Error("Masked class is not found for provided mask " + nOpts.mask + ", appropriate module needs to be imported manually before creating mask.");
    if (nOpts.mask === MaskedClass) delete nOpts.mask;
    if (nOpts._mask) {
        nOpts.mask = nOpts._mask;
        delete nOpts._mask;
    }
    return new MaskedClass(nOpts);
}
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).createMask = $14fa5ae7a370b810$export$2e2bcd8739ae039;



/**  Generic element API to use with mask */ class $e44dc73cca9b04dc$export$2e2bcd8739ae039 {
    /** */ /** */ /** */ /** Safely returns selection start */ get selectionStart() {
        let start;
        try {
            start = this._unsafeSelectionStart;
        } catch  {}
        return start != null ? start : this.value.length;
    }
    /** Safely returns selection end */ get selectionEnd() {
        let end;
        try {
            end = this._unsafeSelectionEnd;
        } catch  {}
        return end != null ? end : this.value.length;
    }
    /** Safely sets element selection */ select(start, end) {
        if (start == null || end == null || start === this.selectionStart && end === this.selectionEnd) return;
        try {
            this._unsafeSelect(start, end);
        } catch  {}
    }
    /** */ get isActive() {
        return false;
    }
}
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskElement = $e44dc73cca9b04dc$export$2e2bcd8739ae039;




const $848bd4079eb9bf5d$var$KEY_Z = 90;
const $848bd4079eb9bf5d$var$KEY_Y = 89;
/** Bridge between HTMLElement and {@link Masked} */ class $848bd4079eb9bf5d$export$2e2bcd8739ae039 extends (0, $e44dc73cca9b04dc$export$2e2bcd8739ae039) {
    /** HTMLElement to use mask on */ constructor(input){
        super();
        this.input = input;
        this._onKeydown = this._onKeydown.bind(this);
        this._onInput = this._onInput.bind(this);
        this._onBeforeinput = this._onBeforeinput.bind(this);
        this._onCompositionEnd = this._onCompositionEnd.bind(this);
    }
    get rootElement() {
        var _this$input$getRootNo, _this$input$getRootNo2, _this$input;
        return (_this$input$getRootNo = (_this$input$getRootNo2 = (_this$input = this.input).getRootNode) == null ? void 0 : _this$input$getRootNo2.call(_this$input)) != null ? _this$input$getRootNo : document;
    }
    /** Is element in focus */ get isActive() {
        return this.input === this.rootElement.activeElement;
    }
    /** Binds HTMLElement events to mask internal events */ bindEvents(handlers) {
        this.input.addEventListener('keydown', this._onKeydown);
        this.input.addEventListener('input', this._onInput);
        this.input.addEventListener('beforeinput', this._onBeforeinput);
        this.input.addEventListener('compositionend', this._onCompositionEnd);
        this.input.addEventListener('drop', handlers.drop);
        this.input.addEventListener('click', handlers.click);
        this.input.addEventListener('focus', handlers.focus);
        this.input.addEventListener('blur', handlers.commit);
        this._handlers = handlers;
    }
    _onKeydown(e) {
        if (this._handlers.redo && (e.keyCode === $848bd4079eb9bf5d$var$KEY_Z && e.shiftKey && (e.metaKey || e.ctrlKey) || e.keyCode === $848bd4079eb9bf5d$var$KEY_Y && e.ctrlKey)) {
            e.preventDefault();
            return this._handlers.redo(e);
        }
        if (this._handlers.undo && e.keyCode === $848bd4079eb9bf5d$var$KEY_Z && (e.metaKey || e.ctrlKey)) {
            e.preventDefault();
            return this._handlers.undo(e);
        }
        if (!e.isComposing) this._handlers.selectionChange(e);
    }
    _onBeforeinput(e) {
        if (e.inputType === 'historyUndo' && this._handlers.undo) {
            e.preventDefault();
            return this._handlers.undo(e);
        }
        if (e.inputType === 'historyRedo' && this._handlers.redo) {
            e.preventDefault();
            return this._handlers.redo(e);
        }
    }
    _onCompositionEnd(e) {
        this._handlers.input(e);
    }
    _onInput(e) {
        if (!e.isComposing) this._handlers.input(e);
    }
    /** Unbinds HTMLElement events to mask internal events */ unbindEvents() {
        this.input.removeEventListener('keydown', this._onKeydown);
        this.input.removeEventListener('input', this._onInput);
        this.input.removeEventListener('beforeinput', this._onBeforeinput);
        this.input.removeEventListener('compositionend', this._onCompositionEnd);
        this.input.removeEventListener('drop', this._handlers.drop);
        this.input.removeEventListener('click', this._handlers.click);
        this.input.removeEventListener('focus', this._handlers.focus);
        this.input.removeEventListener('blur', this._handlers.commit);
        this._handlers = {};
    }
}
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).HTMLMaskElement = $848bd4079eb9bf5d$export$2e2bcd8739ae039;




/** Bridge between InputElement and {@link Masked} */ class $19dd1dae5da417e0$export$2e2bcd8739ae039 extends (0, $848bd4079eb9bf5d$export$2e2bcd8739ae039) {
    /** InputElement to use mask on */ constructor(input){
        super(input);
        this.input = input;
    }
    /** Returns InputElement selection start */ get _unsafeSelectionStart() {
        return this.input.selectionStart != null ? this.input.selectionStart : this.value.length;
    }
    /** Returns InputElement selection end */ get _unsafeSelectionEnd() {
        return this.input.selectionEnd;
    }
    /** Sets InputElement selection */ _unsafeSelect(start, end) {
        this.input.setSelectionRange(start, end);
    }
    get value() {
        return this.input.value;
    }
    set value(value) {
        this.input.value = value;
    }
}
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).HTMLMaskElement = (0, $848bd4079eb9bf5d$export$2e2bcd8739ae039);





class $a9ad28f650e1e6f1$export$2e2bcd8739ae039 extends (0, $848bd4079eb9bf5d$export$2e2bcd8739ae039) {
    /** Returns HTMLElement selection start */ get _unsafeSelectionStart() {
        const root = this.rootElement;
        const selection = root.getSelection && root.getSelection();
        const anchorOffset = selection && selection.anchorOffset;
        const focusOffset = selection && selection.focusOffset;
        if (focusOffset == null || anchorOffset == null || anchorOffset < focusOffset) return anchorOffset;
        return focusOffset;
    }
    /** Returns HTMLElement selection end */ get _unsafeSelectionEnd() {
        const root = this.rootElement;
        const selection = root.getSelection && root.getSelection();
        const anchorOffset = selection && selection.anchorOffset;
        const focusOffset = selection && selection.focusOffset;
        if (focusOffset == null || anchorOffset == null || anchorOffset > focusOffset) return anchorOffset;
        return focusOffset;
    }
    /** Sets HTMLElement selection */ _unsafeSelect(start, end) {
        if (!this.rootElement.createRange) return;
        const range = this.rootElement.createRange();
        range.setStart(this.input.firstChild || this.input, start);
        range.setEnd(this.input.lastChild || this.input, end);
        const root = this.rootElement;
        const selection = root.getSelection && root.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }
    /** HTMLElement value */ get value() {
        return this.input.textContent || '';
    }
    set value(value) {
        this.input.textContent = value;
    }
}
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).HTMLContenteditableMaskElement = $a9ad28f650e1e6f1$export$2e2bcd8739ae039;



class $e1bccc8c26586292$export$2e2bcd8739ae039 {
    constructor(){
        this.states = [];
        this.currentIndex = 0;
    }
    get currentState() {
        return this.states[this.currentIndex];
    }
    get isEmpty() {
        return this.states.length === 0;
    }
    push(state) {
        // if current index points before the last element then remove the future
        if (this.currentIndex < this.states.length - 1) this.states.length = this.currentIndex + 1;
        this.states.push(state);
        if (this.states.length > $e1bccc8c26586292$export$2e2bcd8739ae039.MAX_LENGTH) this.states.shift();
        this.currentIndex = this.states.length - 1;
    }
    go(steps) {
        this.currentIndex = Math.min(Math.max(this.currentIndex + steps, 0), this.states.length - 1);
        return this.currentState;
    }
    undo() {
        return this.go(-1);
    }
    redo() {
        return this.go(1);
    }
    clear() {
        this.states.length = 0;
        this.currentIndex = 0;
    }
}
$e1bccc8c26586292$export$2e2bcd8739ae039.MAX_LENGTH = 100;



/** Listens to element events and controls changes between element and {@link Masked} */ class $426ce1bac78b56b7$export$2e2bcd8739ae039 {
    /**
    View element
  */ /** Internal {@link Masked} model */ constructor(el, opts){
        this.el = el instanceof (0, $e44dc73cca9b04dc$export$2e2bcd8739ae039) ? el : el.isContentEditable && el.tagName !== 'INPUT' && el.tagName !== 'TEXTAREA' ? new (0, $a9ad28f650e1e6f1$export$2e2bcd8739ae039)(el) : new (0, $19dd1dae5da417e0$export$2e2bcd8739ae039)(el);
        this.masked = (0, $14fa5ae7a370b810$export$2e2bcd8739ae039)(opts);
        this._listeners = {};
        this._value = '';
        this._unmaskedValue = '';
        this._rawInputValue = '';
        this.history = new (0, $e1bccc8c26586292$export$2e2bcd8739ae039)();
        this._saveSelection = this._saveSelection.bind(this);
        this._onInput = this._onInput.bind(this);
        this._onChange = this._onChange.bind(this);
        this._onDrop = this._onDrop.bind(this);
        this._onFocus = this._onFocus.bind(this);
        this._onClick = this._onClick.bind(this);
        this._onUndo = this._onUndo.bind(this);
        this._onRedo = this._onRedo.bind(this);
        this.alignCursor = this.alignCursor.bind(this);
        this.alignCursorFriendly = this.alignCursorFriendly.bind(this);
        this._bindEvents();
        // refresh
        this.updateValue();
        this._onChange();
    }
    maskEquals(mask) {
        var _this$masked;
        return mask == null || ((_this$masked = this.masked) == null ? void 0 : _this$masked.maskEquals(mask));
    }
    /** Masked */ get mask() {
        return this.masked.mask;
    }
    set mask(mask) {
        if (this.maskEquals(mask)) return;
        if (!(mask instanceof (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).Masked) && this.masked.constructor === (0, $14fa5ae7a370b810$export$81ad4b1539a22420)(mask)) {
            // TODO "any" no idea
            this.masked.updateOptions({
                mask: mask
            });
            return;
        }
        const masked = mask instanceof (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).Masked ? mask : (0, $14fa5ae7a370b810$export$2e2bcd8739ae039)({
            mask: mask
        });
        masked.unmaskedValue = this.masked.unmaskedValue;
        this.masked = masked;
    }
    /** Raw value */ get value() {
        return this._value;
    }
    set value(str) {
        if (this.value === str) return;
        this.masked.value = str;
        this.updateControl('auto');
    }
    /** Unmasked value */ get unmaskedValue() {
        return this._unmaskedValue;
    }
    set unmaskedValue(str) {
        if (this.unmaskedValue === str) return;
        this.masked.unmaskedValue = str;
        this.updateControl('auto');
    }
    /** Raw input value */ get rawInputValue() {
        return this._rawInputValue;
    }
    set rawInputValue(str) {
        if (this.rawInputValue === str) return;
        this.masked.rawInputValue = str;
        this.updateControl();
        this.alignCursor();
    }
    /** Typed unmasked value */ get typedValue() {
        return this.masked.typedValue;
    }
    set typedValue(val) {
        if (this.masked.typedValueEquals(val)) return;
        this.masked.typedValue = val;
        this.updateControl('auto');
    }
    /** Display value */ get displayValue() {
        return this.masked.displayValue;
    }
    /** Starts listening to element events */ _bindEvents() {
        this.el.bindEvents({
            selectionChange: this._saveSelection,
            input: this._onInput,
            drop: this._onDrop,
            click: this._onClick,
            focus: this._onFocus,
            commit: this._onChange,
            undo: this._onUndo,
            redo: this._onRedo
        });
    }
    /** Stops listening to element events */ _unbindEvents() {
        if (this.el) this.el.unbindEvents();
    }
    /** Fires custom event */ _fireEvent(ev, e) {
        const listeners = this._listeners[ev];
        if (!listeners) return;
        listeners.forEach((l)=>l(e));
    }
    /** Current selection start */ get selectionStart() {
        return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
    }
    /** Current cursor position */ get cursorPos() {
        return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
    }
    set cursorPos(pos) {
        if (!this.el || !this.el.isActive) return;
        this.el.select(pos, pos);
        this._saveSelection();
    }
    /** Stores current selection */ _saveSelection() {
        if (this.displayValue !== this.el.value) console.warn('Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly.'); // eslint-disable-line no-console
        this._selection = {
            start: this.selectionStart,
            end: this.cursorPos
        };
    }
    /** Syncronizes model value from view */ updateValue() {
        this.masked.value = this.el.value;
        this._value = this.masked.value;
        this._unmaskedValue = this.masked.unmaskedValue;
        this._rawInputValue = this.masked.rawInputValue;
    }
    /** Syncronizes view from model value, fires change events */ updateControl(cursorPos) {
        const newUnmaskedValue = this.masked.unmaskedValue;
        const newValue = this.masked.value;
        const newRawInputValue = this.masked.rawInputValue;
        const newDisplayValue = this.displayValue;
        const isChanged = this.unmaskedValue !== newUnmaskedValue || this.value !== newValue || this._rawInputValue !== newRawInputValue;
        this._unmaskedValue = newUnmaskedValue;
        this._value = newValue;
        this._rawInputValue = newRawInputValue;
        if (this.el.value !== newDisplayValue) this.el.value = newDisplayValue;
        if (cursorPos === 'auto') this.alignCursor();
        else if (cursorPos != null) this.cursorPos = cursorPos;
        if (isChanged) this._fireChangeEvents();
        if (!this._historyChanging && (isChanged || this.history.isEmpty)) this.history.push({
            unmaskedValue: newUnmaskedValue,
            selection: {
                start: this.selectionStart,
                end: this.cursorPos
            }
        });
    }
    /** Updates options with deep equal check, recreates {@link Masked} model if mask type changes */ updateOptions(opts) {
        const { mask: mask, ...restOpts } = opts; // TODO types, yes, mask is optional
        const updateMask = !this.maskEquals(mask);
        const updateOpts = this.masked.optionsIsChanged(restOpts);
        if (updateMask) this.mask = mask;
        if (updateOpts) this.masked.updateOptions(restOpts); // TODO
        if (updateMask || updateOpts) this.updateControl();
    }
    /** Updates cursor */ updateCursor(cursorPos) {
        if (cursorPos == null) return;
        this.cursorPos = cursorPos;
        // also queue change cursor for mobile browsers
        this._delayUpdateCursor(cursorPos);
    }
    /** Delays cursor update to support mobile browsers */ _delayUpdateCursor(cursorPos) {
        this._abortUpdateCursor();
        this._changingCursorPos = cursorPos;
        this._cursorChanging = setTimeout(()=>{
            if (!this.el) return; // if was destroyed
            this.cursorPos = this._changingCursorPos;
            this._abortUpdateCursor();
        }, 10);
    }
    /** Fires custom events */ _fireChangeEvents() {
        this._fireEvent('accept', this._inputEvent);
        if (this.masked.isComplete) this._fireEvent('complete', this._inputEvent);
    }
    /** Aborts delayed cursor update */ _abortUpdateCursor() {
        if (this._cursorChanging) {
            clearTimeout(this._cursorChanging);
            delete this._cursorChanging;
        }
    }
    /** Aligns cursor to nearest available position */ alignCursor() {
        this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, (0, $93906f2a377dc74e$export$9106728c49045482).LEFT));
    }
    /** Aligns cursor only if selection is empty */ alignCursorFriendly() {
        if (this.selectionStart !== this.cursorPos) return; // skip if range is selected
        this.alignCursor();
    }
    /** Adds listener on custom event */ on(ev, handler) {
        if (!this._listeners[ev]) this._listeners[ev] = [];
        this._listeners[ev].push(handler);
        return this;
    }
    /** Removes custom event listener */ off(ev, handler) {
        if (!this._listeners[ev]) return this;
        if (!handler) {
            delete this._listeners[ev];
            return this;
        }
        const hIndex = this._listeners[ev].indexOf(handler);
        if (hIndex >= 0) this._listeners[ev].splice(hIndex, 1);
        return this;
    }
    /** Handles view input event */ _onInput(e) {
        this._inputEvent = e;
        this._abortUpdateCursor();
        const details = new (0, $61d1aadea9846d62$export$2e2bcd8739ae039)({
            // new state
            value: this.el.value,
            cursorPos: this.cursorPos,
            // old state
            oldValue: this.displayValue,
            oldSelection: this._selection
        });
        const oldRawValue = this.masked.rawInputValue;
        const offset = this.masked.splice(details.startChangePos, details.removed.length, details.inserted, details.removeDirection, {
            input: true,
            raw: true
        }).offset;
        // force align in remove direction only if no input chars were removed
        // otherwise we still need to align with NONE (to get out from fixed symbols for instance)
        const removeDirection = oldRawValue === this.masked.rawInputValue ? details.removeDirection : (0, $93906f2a377dc74e$export$9106728c49045482).NONE;
        let cursorPos = this.masked.nearestInputPos(details.startChangePos + offset, removeDirection);
        if (removeDirection !== (0, $93906f2a377dc74e$export$9106728c49045482).NONE) cursorPos = this.masked.nearestInputPos(cursorPos, (0, $93906f2a377dc74e$export$9106728c49045482).NONE);
        this.updateControl(cursorPos);
        delete this._inputEvent;
    }
    /** Handles view change event and commits model value */ _onChange() {
        if (this.displayValue !== this.el.value) this.updateValue();
        this.masked.doCommit();
        this.updateControl();
        this._saveSelection();
    }
    /** Handles view drop event, prevents by default */ _onDrop(ev) {
        ev.preventDefault();
        ev.stopPropagation();
    }
    /** Restore last selection on focus */ _onFocus(ev) {
        this.alignCursorFriendly();
    }
    /** Restore last selection on focus */ _onClick(ev) {
        this.alignCursorFriendly();
    }
    _onUndo() {
        this._applyHistoryState(this.history.undo());
    }
    _onRedo() {
        this._applyHistoryState(this.history.redo());
    }
    _applyHistoryState(state) {
        if (!state) return;
        this._historyChanging = true;
        this.unmaskedValue = state.unmaskedValue;
        this.el.select(state.selection.start, state.selection.end);
        this._saveSelection();
        this._historyChanging = false;
    }
    /** Unbind view events and removes element reference */ destroy() {
        this._unbindEvents();
        this._listeners.length = 0;
        delete this.el;
    }
}
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).InputMask = $426ce1bac78b56b7$export$2e2bcd8739ae039;








/** Provides details of changing model value */ class $ef0ad9fa705f5579$export$2e2bcd8739ae039 {
    /** Inserted symbols */ /** Additional offset if any changes occurred before tail */ /** Raw inserted is used by dynamic mask */ /** Can skip chars */ static normalize(prep) {
        return Array.isArray(prep) ? prep : [
            prep,
            new $ef0ad9fa705f5579$export$2e2bcd8739ae039()
        ];
    }
    constructor(details){
        Object.assign(this, {
            inserted: '',
            rawInserted: '',
            tailShift: 0,
            skip: false
        }, details);
    }
    /** Aggregate changes */ aggregate(details) {
        this.inserted += details.inserted;
        this.rawInserted += details.rawInserted;
        this.tailShift += details.tailShift;
        this.skip = this.skip || details.skip;
        return this;
    }
    /** Total offset considering all changes */ get offset() {
        return this.tailShift + this.inserted.length;
    }
    get consumed() {
        return Boolean(this.rawInserted) || this.skip;
    }
    equals(details) {
        return this.inserted === details.inserted && this.tailShift === details.tailShift && this.rawInserted === details.rawInserted && this.skip === details.skip;
    }
}
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).ChangeDetails = $ef0ad9fa705f5579$export$2e2bcd8739ae039;




/** Provides details of continuous extracted tail */ class $c9d9fedd20e4a1e7$export$2e2bcd8739ae039 {
    /** Tail value as string */ /** Tail start position */ /** Start position */ constructor(value, from, stop){
        if (value === void 0) value = '';
        if (from === void 0) from = 0;
        this.value = value;
        this.from = from;
        this.stop = stop;
    }
    toString() {
        return this.value;
    }
    extend(tail) {
        this.value += String(tail);
    }
    appendTo(masked) {
        return masked.append(this.toString(), {
            tail: true
        }).aggregate(masked._appendPlaceholder());
    }
    get state() {
        return {
            value: this.value,
            from: this.from,
            stop: this.stop
        };
    }
    set state(state) {
        Object.assign(this, state);
    }
    unshift(beforePos) {
        if (!this.value.length || beforePos != null && this.from >= beforePos) return '';
        const shiftChar = this.value[0];
        this.value = this.value.slice(1);
        return shiftChar;
    }
    shift() {
        if (!this.value.length) return '';
        const shiftChar = this.value[this.value.length - 1];
        this.value = this.value.slice(0, -1);
        return shiftChar;
    }
}




/** Append flags */ /** Extract flags */ // see https://github.com/microsoft/TypeScript/issues/6223
/** Provides common masking stuff */ class $e23198c8dcc9cc5a$export$2e2bcd8739ae039 {
    /** */ /** */ /** Transforms value before mask processing */ /** Transforms each char before mask processing */ /** Validates if value is acceptable */ /** Does additional processing at the end of editing */ /** Format typed value to string */ /** Parse string to get typed value */ /** Enable characters overwriting */ /** */ /** */ /** */ /** */ constructor(opts){
        this._value = '';
        this._update({
            ...$e23198c8dcc9cc5a$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        });
        this._initialized = true;
    }
    /** Sets and applies new options */ updateOptions(opts) {
        if (!this.optionsIsChanged(opts)) return;
        this.withValueRefresh(this._update.bind(this, opts));
    }
    /** Sets new options */ _update(opts) {
        Object.assign(this, opts);
    }
    /** Mask state */ get state() {
        return {
            _value: this.value,
            _rawInputValue: this.rawInputValue
        };
    }
    set state(state) {
        this._value = state._value;
    }
    /** Resets value */ reset() {
        this._value = '';
    }
    get value() {
        return this._value;
    }
    set value(value) {
        this.resolve(value, {
            input: true
        });
    }
    /** Resolve new value */ resolve(value, flags) {
        if (flags === void 0) flags = {
            input: true
        };
        this.reset();
        this.append(value, flags, '');
        this.doCommit();
    }
    get unmaskedValue() {
        return this.value;
    }
    set unmaskedValue(value) {
        this.resolve(value, {});
    }
    get typedValue() {
        return this.parse ? this.parse(this.value, this) : this.unmaskedValue;
    }
    set typedValue(value) {
        if (this.format) this.value = this.format(value, this);
        else this.unmaskedValue = String(value);
    }
    /** Value that includes raw user input */ get rawInputValue() {
        return this.extractInput(0, this.displayValue.length, {
            raw: true
        });
    }
    set rawInputValue(value) {
        this.resolve(value, {
            raw: true
        });
    }
    get displayValue() {
        return this.value;
    }
    get isComplete() {
        return true;
    }
    get isFilled() {
        return this.isComplete;
    }
    /** Finds nearest input position in direction */ nearestInputPos(cursorPos, direction) {
        return cursorPos;
    }
    totalInputPositions(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        return Math.min(this.displayValue.length, toPos - fromPos);
    }
    /** Extracts value in range considering flags */ extractInput(fromPos, toPos, flags) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        return this.displayValue.slice(fromPos, toPos);
    }
    /** Extracts tail in range */ extractTail(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        return new (0, $c9d9fedd20e4a1e7$export$2e2bcd8739ae039)(this.extractInput(fromPos, toPos), fromPos);
    }
    /** Appends tail */ appendTail(tail) {
        if ((0, $93906f2a377dc74e$export$844ec244b1367d54)(tail)) tail = new (0, $c9d9fedd20e4a1e7$export$2e2bcd8739ae039)(String(tail));
        return tail.appendTo(this);
    }
    /** Appends char */ _appendCharRaw(ch, flags) {
        if (!ch) return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        this._value += ch;
        return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)({
            inserted: ch,
            rawInserted: ch
        });
    }
    /** Appends char */ _appendChar(ch, flags, checkTail) {
        if (flags === void 0) flags = {};
        const consistentState = this.state;
        let details;
        [ch, details] = this.doPrepareChar(ch, flags);
        if (ch) {
            details = details.aggregate(this._appendCharRaw(ch, flags));
            // TODO handle `skip`?
            // try `autofix` lookahead
            if (!details.rawInserted && this.autofix === 'pad') {
                const noFixState = this.state;
                this.state = consistentState;
                let fixDetails = this.pad(flags);
                const chDetails = this._appendCharRaw(ch, flags);
                fixDetails = fixDetails.aggregate(chDetails);
                // if fix was applied or
                // if details are equal use skip restoring state optimization
                if (chDetails.rawInserted || fixDetails.equals(details)) details = fixDetails;
                else this.state = noFixState;
            }
        }
        if (details.inserted) {
            let consistentTail;
            let appended = this.doValidate(flags) !== false;
            if (appended && checkTail != null) {
                // validation ok, check tail
                const beforeTailState = this.state;
                if (this.overwrite === true) {
                    consistentTail = checkTail.state;
                    for(let i = 0; i < details.rawInserted.length; ++i)checkTail.unshift(this.displayValue.length - details.tailShift);
                }
                let tailDetails = this.appendTail(checkTail);
                appended = tailDetails.rawInserted.length === checkTail.toString().length;
                // not ok, try shift
                if (!(appended && tailDetails.inserted) && this.overwrite === 'shift') {
                    this.state = beforeTailState;
                    consistentTail = checkTail.state;
                    for(let i = 0; i < details.rawInserted.length; ++i)checkTail.shift();
                    tailDetails = this.appendTail(checkTail);
                    appended = tailDetails.rawInserted.length === checkTail.toString().length;
                }
                // if ok, rollback state after tail
                if (appended && tailDetails.inserted) this.state = beforeTailState;
            }
            // revert all if something went wrong
            if (!appended) {
                details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
                this.state = consistentState;
                if (checkTail && consistentTail) checkTail.state = consistentTail;
            }
        }
        return details;
    }
    /** Appends optional placeholder at the end */ _appendPlaceholder() {
        return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
    }
    /** Appends optional eager placeholder at the end */ _appendEager() {
        return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
    }
    /** Appends symbols considering flags */ append(str, flags, tail) {
        if (!(0, $93906f2a377dc74e$export$844ec244b1367d54)(str)) throw new Error('value should be string');
        const checkTail = (0, $93906f2a377dc74e$export$844ec244b1367d54)(tail) ? new (0, $c9d9fedd20e4a1e7$export$2e2bcd8739ae039)(String(tail)) : tail;
        if (flags != null && flags.tail) flags._beforeTailState = this.state;
        let details;
        [str, details] = this.doPrepare(str, flags);
        for(let ci = 0; ci < str.length; ++ci){
            const d = this._appendChar(str[ci], flags, checkTail);
            if (!d.rawInserted && !this.doSkipInvalid(str[ci], flags, checkTail)) break;
            details.aggregate(d);
        }
        if ((this.eager === true || this.eager === 'append') && flags != null && flags.input && str) details.aggregate(this._appendEager());
        // append tail but aggregate only tailShift
        if (checkTail != null) details.tailShift += this.appendTail(checkTail).tailShift;
        return details;
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        this._value = this.displayValue.slice(0, fromPos) + this.displayValue.slice(toPos);
        return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
    }
    /** Calls function and reapplies current value */ withValueRefresh(fn) {
        if (this._refreshing || !this._initialized) return fn();
        this._refreshing = true;
        const rawInput = this.rawInputValue;
        const value = this.value;
        const ret = fn();
        this.rawInputValue = rawInput;
        // append lost trailing chars at the end
        if (this.value && this.value !== value && value.indexOf(this.value) === 0) {
            this.append(value.slice(this.displayValue.length), {}, '');
            this.doCommit();
        }
        delete this._refreshing;
        return ret;
    }
    runIsolated(fn) {
        if (this._isolated || !this._initialized) return fn(this);
        this._isolated = true;
        const state = this.state;
        const ret = fn(this);
        this.state = state;
        delete this._isolated;
        return ret;
    }
    doSkipInvalid(ch, flags, checkTail) {
        return Boolean(this.skipInvalid);
    }
    /** Prepares string before mask processing */ doPrepare(str, flags) {
        if (flags === void 0) flags = {};
        return (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039).normalize(this.prepare ? this.prepare(str, this, flags) : str);
    }
    /** Prepares each char before mask processing */ doPrepareChar(str, flags) {
        if (flags === void 0) flags = {};
        return (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039).normalize(this.prepareChar ? this.prepareChar(str, this, flags) : str);
    }
    /** Validates if value is acceptable */ doValidate(flags) {
        return (!this.validate || this.validate(this.value, this, flags)) && (!this.parent || this.parent.doValidate(flags));
    }
    /** Does additional processing at the end of editing */ doCommit() {
        if (this.commit) this.commit(this.value, this);
    }
    splice(start, deleteCount, inserted, removeDirection, flags) {
        if (inserted === void 0) inserted = '';
        if (removeDirection === void 0) removeDirection = (0, $93906f2a377dc74e$export$9106728c49045482).NONE;
        if (flags === void 0) flags = {
            input: true
        };
        const tailPos = start + deleteCount;
        const tail = this.extractTail(tailPos);
        const eagerRemove = this.eager === true || this.eager === 'remove';
        let oldRawValue;
        if (eagerRemove) {
            removeDirection = (0, $93906f2a377dc74e$export$32af4dafed14c8ce)(removeDirection);
            oldRawValue = this.extractInput(0, tailPos, {
                raw: true
            });
        }
        let startChangePos = start;
        const details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        // if it is just deletion without insertion
        if (removeDirection !== (0, $93906f2a377dc74e$export$9106728c49045482).NONE) {
            startChangePos = this.nearestInputPos(start, deleteCount > 1 && start !== 0 && !eagerRemove ? (0, $93906f2a377dc74e$export$9106728c49045482).NONE : removeDirection);
            // adjust tailShift if start was aligned
            details.tailShift = startChangePos - start;
        }
        details.aggregate(this.remove(startChangePos));
        if (eagerRemove && removeDirection !== (0, $93906f2a377dc74e$export$9106728c49045482).NONE && oldRawValue === this.rawInputValue) {
            if (removeDirection === (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_LEFT) {
                let valLength;
                while(oldRawValue === this.rawInputValue && (valLength = this.displayValue.length))details.aggregate(new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)({
                    tailShift: -1
                })).aggregate(this.remove(valLength - 1));
            } else if (removeDirection === (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_RIGHT) tail.unshift();
        }
        return details.aggregate(this.append(inserted, flags, tail));
    }
    maskEquals(mask) {
        return this.mask === mask;
    }
    optionsIsChanged(opts) {
        return !(0, $93906f2a377dc74e$export$7aeb68f71172641d)(this, opts);
    }
    typedValueEquals(value) {
        const tval = this.typedValue;
        return value === tval || $e23198c8dcc9cc5a$export$2e2bcd8739ae039.EMPTY_VALUES.includes(value) && $e23198c8dcc9cc5a$export$2e2bcd8739ae039.EMPTY_VALUES.includes(tval) || (this.format ? this.format(value, this) === this.format(this.typedValue, this) : false);
    }
    pad(flags) {
        return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
    }
}
$e23198c8dcc9cc5a$export$2e2bcd8739ae039.DEFAULTS = {
    skipInvalid: true
};
$e23198c8dcc9cc5a$export$2e2bcd8739ae039.EMPTY_VALUES = [
    undefined,
    null,
    ''
];
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).Masked = $e23198c8dcc9cc5a$export$2e2bcd8739ae039;











class $28324efa3f559998$export$2e2bcd8739ae039 {
    /** */ constructor(chunks, from){
        if (chunks === void 0) chunks = [];
        if (from === void 0) from = 0;
        this.chunks = chunks;
        this.from = from;
    }
    toString() {
        return this.chunks.map(String).join('');
    }
    extend(tailChunk) {
        if (!String(tailChunk)) return;
        tailChunk = (0, $93906f2a377dc74e$export$844ec244b1367d54)(tailChunk) ? new (0, $c9d9fedd20e4a1e7$export$2e2bcd8739ae039)(String(tailChunk)) : tailChunk;
        const lastChunk = this.chunks[this.chunks.length - 1];
        const extendLast = lastChunk && // if stops are same or tail has no stop
        (lastChunk.stop === tailChunk.stop || tailChunk.stop == null) && // if tail chunk goes just after last chunk
        tailChunk.from === lastChunk.from + lastChunk.toString().length;
        if (tailChunk instanceof (0, $c9d9fedd20e4a1e7$export$2e2bcd8739ae039)) {
            // check the ability to extend previous chunk
            if (extendLast) // extend previous chunk
            lastChunk.extend(tailChunk.toString());
            else // append new chunk
            this.chunks.push(tailChunk);
        } else if (tailChunk instanceof $28324efa3f559998$export$2e2bcd8739ae039) {
            if (tailChunk.stop == null) {
                // unwrap floating chunks to parent, keeping `from` pos
                let firstTailChunk;
                while(tailChunk.chunks.length && tailChunk.chunks[0].stop == null){
                    firstTailChunk = tailChunk.chunks.shift(); // not possible to be `undefined` because length was checked above
                    firstTailChunk.from += tailChunk.from;
                    this.extend(firstTailChunk);
                }
            }
            // if tail chunk still has value
            if (tailChunk.toString()) {
                // if chunks contains stops, then popup stop to container
                tailChunk.stop = tailChunk.blockIndex;
                this.chunks.push(tailChunk);
            }
        }
    }
    appendTo(masked) {
        if (!(masked instanceof (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedPattern)) {
            const tail = new (0, $c9d9fedd20e4a1e7$export$2e2bcd8739ae039)(this.toString());
            return tail.appendTo(masked);
        }
        const details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        for(let ci = 0; ci < this.chunks.length; ++ci){
            const chunk = this.chunks[ci];
            const lastBlockIter = masked._mapPosToBlock(masked.displayValue.length);
            const stop = chunk.stop;
            let chunkBlock;
            if (stop != null && // if block not found or stop is behind lastBlock
            (!lastBlockIter || lastBlockIter.index <= stop)) {
                if (chunk instanceof $28324efa3f559998$export$2e2bcd8739ae039 || // for continuous block also check if stop is exist
                masked._stops.indexOf(stop) >= 0) details.aggregate(masked._appendPlaceholder(stop));
                chunkBlock = chunk instanceof $28324efa3f559998$export$2e2bcd8739ae039 && masked._blocks[stop];
            }
            if (chunkBlock) {
                const tailDetails = chunkBlock.appendTail(chunk);
                details.aggregate(tailDetails);
                // get not inserted chars
                const remainChars = chunk.toString().slice(tailDetails.rawInserted.length);
                if (remainChars) details.aggregate(masked.append(remainChars, {
                    tail: true
                }));
            } else details.aggregate(masked.append(chunk.toString(), {
                tail: true
            }));
        }
        return details;
    }
    get state() {
        return {
            chunks: this.chunks.map((c)=>c.state),
            from: this.from,
            stop: this.stop,
            blockIndex: this.blockIndex
        };
    }
    set state(state) {
        const { chunks: chunks, ...props } = state;
        Object.assign(this, props);
        this.chunks = chunks.map((cstate)=>{
            const chunk = "chunks" in cstate ? new $28324efa3f559998$export$2e2bcd8739ae039() : new (0, $c9d9fedd20e4a1e7$export$2e2bcd8739ae039)();
            chunk.state = cstate;
            return chunk;
        });
    }
    unshift(beforePos) {
        if (!this.chunks.length || beforePos != null && this.from >= beforePos) return '';
        const chunkShiftPos = beforePos != null ? beforePos - this.from : beforePos;
        let ci = 0;
        while(ci < this.chunks.length){
            const chunk = this.chunks[ci];
            const shiftChar = chunk.unshift(chunkShiftPos);
            if (chunk.toString()) {
                // chunk still contains value
                // but not shifted - means no more available chars to shift
                if (!shiftChar) break;
                ++ci;
            } else // clean if chunk has no value
            this.chunks.splice(ci, 1);
            if (shiftChar) return shiftChar;
        }
        return '';
    }
    shift() {
        if (!this.chunks.length) return '';
        let ci = this.chunks.length - 1;
        while(0 <= ci){
            const chunk = this.chunks[ci];
            const shiftChar = chunk.shift();
            if (chunk.toString()) {
                // chunk still contains value
                // but not shifted - means no more available chars to shift
                if (!shiftChar) break;
                --ci;
            } else // clean if chunk has no value
            this.chunks.splice(ci, 1);
            if (shiftChar) return shiftChar;
        }
        return '';
    }
}



class $50f71afd352b9d43$export$2e2bcd8739ae039 {
    constructor(masked, pos){
        this.masked = masked;
        this._log = [];
        const { offset: offset, index: index } = masked._mapPosToBlock(pos) || (pos < 0 ? // first
        {
            index: 0,
            offset: 0
        } : // last
        {
            index: this.masked._blocks.length,
            offset: 0
        });
        this.offset = offset;
        this.index = index;
        this.ok = false;
    }
    get block() {
        return this.masked._blocks[this.index];
    }
    get pos() {
        return this.masked._blockStartPos(this.index) + this.offset;
    }
    get state() {
        return {
            index: this.index,
            offset: this.offset,
            ok: this.ok
        };
    }
    set state(s) {
        Object.assign(this, s);
    }
    pushState() {
        this._log.push(this.state);
    }
    popState() {
        const s = this._log.pop();
        if (s) this.state = s;
        return s;
    }
    bindBlock() {
        if (this.block) return;
        if (this.index < 0) {
            this.index = 0;
            this.offset = 0;
        }
        if (this.index >= this.masked._blocks.length) {
            this.index = this.masked._blocks.length - 1;
            this.offset = this.block.displayValue.length; // TODO this is stupid type error, `block` depends on index that was changed above
        }
    }
    _pushLeft(fn) {
        this.pushState();
        for(this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((_this$block = this.block) == null ? void 0 : _this$block.displayValue.length) || 0){
            var _this$block;
            if (fn()) return this.ok = true;
        }
        return this.ok = false;
    }
    _pushRight(fn) {
        this.pushState();
        for(this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0){
            if (fn()) return this.ok = true;
        }
        return this.ok = false;
    }
    pushLeftBeforeFilled() {
        return this._pushLeft(()=>{
            if (this.block.isFixed || !this.block.value) return;
            this.offset = this.block.nearestInputPos(this.offset, (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_LEFT);
            if (this.offset !== 0) return true;
        });
    }
    pushLeftBeforeInput() {
        // cases:
        // filled input: 00|
        // optional empty input: 00[]|
        // nested block: XX<[]>|
        return this._pushLeft(()=>{
            if (this.block.isFixed) return;
            this.offset = this.block.nearestInputPos(this.offset, (0, $93906f2a377dc74e$export$9106728c49045482).LEFT);
            return true;
        });
    }
    pushLeftBeforeRequired() {
        return this._pushLeft(()=>{
            if (this.block.isFixed || this.block.isOptional && !this.block.value) return;
            this.offset = this.block.nearestInputPos(this.offset, (0, $93906f2a377dc74e$export$9106728c49045482).LEFT);
            return true;
        });
    }
    pushRightBeforeFilled() {
        return this._pushRight(()=>{
            if (this.block.isFixed || !this.block.value) return;
            this.offset = this.block.nearestInputPos(this.offset, (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_RIGHT);
            if (this.offset !== this.block.value.length) return true;
        });
    }
    pushRightBeforeInput() {
        return this._pushRight(()=>{
            if (this.block.isFixed) return;
            // const o = this.offset;
            this.offset = this.block.nearestInputPos(this.offset, (0, $93906f2a377dc74e$export$9106728c49045482).NONE);
            // HACK cases like (STILL DOES NOT WORK FOR NESTED)
            // aa|X
            // aa<X|[]>X_    - this will not work
            // if (o && o === this.offset && this.block instanceof PatternInputDefinition) continue;
            return true;
        });
    }
    pushRightBeforeRequired() {
        return this._pushRight(()=>{
            if (this.block.isFixed || this.block.isOptional && !this.block.value) return;
            // TODO check |[*]XX_
            this.offset = this.block.nearestInputPos(this.offset, (0, $93906f2a377dc74e$export$9106728c49045482).NONE);
            return true;
        });
    }
}






class $29e919e8e196db5e$export$2e2bcd8739ae039 {
    /** */ /** */ /** */ /** */ /** */ /** */ constructor(opts){
        Object.assign(this, opts);
        this._value = '';
        this.isFixed = true;
    }
    get value() {
        return this._value;
    }
    get unmaskedValue() {
        return this.isUnmasking ? this.value : '';
    }
    get rawInputValue() {
        return this._isRawInput ? this.value : '';
    }
    get displayValue() {
        return this.value;
    }
    reset() {
        this._isRawInput = false;
        this._value = '';
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this._value.length;
        this._value = this._value.slice(0, fromPos) + this._value.slice(toPos);
        if (!this._value) this._isRawInput = false;
        return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
    }
    nearestInputPos(cursorPos, direction) {
        if (direction === void 0) direction = (0, $93906f2a377dc74e$export$9106728c49045482).NONE;
        const minPos = 0;
        const maxPos = this._value.length;
        switch(direction){
            case (0, $93906f2a377dc74e$export$9106728c49045482).LEFT:
            case (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_LEFT:
                return minPos;
            case (0, $93906f2a377dc74e$export$9106728c49045482).NONE:
            case (0, $93906f2a377dc74e$export$9106728c49045482).RIGHT:
            case (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_RIGHT:
            default:
                return maxPos;
        }
    }
    totalInputPositions(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this._value.length;
        return this._isRawInput ? toPos - fromPos : 0;
    }
    extractInput(fromPos, toPos, flags) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this._value.length;
        if (flags === void 0) flags = {};
        return flags.raw && this._isRawInput && this._value.slice(fromPos, toPos) || '';
    }
    get isComplete() {
        return true;
    }
    get isFilled() {
        return Boolean(this._value);
    }
    _appendChar(ch, flags) {
        if (flags === void 0) flags = {};
        if (this.isFilled) return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        const appendEager = this.eager === true || this.eager === 'append';
        const appended = this.char === ch;
        const isResolved = appended && (this.isUnmasking || flags.input || flags.raw) && (!flags.raw || !appendEager) && !flags.tail;
        const details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)({
            inserted: this.char,
            rawInserted: isResolved ? this.char : ''
        });
        this._value = this.char;
        this._isRawInput = isResolved && (flags.raw || flags.input);
        return details;
    }
    _appendEager() {
        return this._appendChar(this.char, {
            tail: true
        });
    }
    _appendPlaceholder() {
        const details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        if (this.isFilled) return details;
        this._value = details.inserted = this.char;
        return details;
    }
    extractTail() {
        return new (0, $c9d9fedd20e4a1e7$export$2e2bcd8739ae039)('');
    }
    appendTail(tail) {
        if ((0, $93906f2a377dc74e$export$844ec244b1367d54)(tail)) tail = new (0, $c9d9fedd20e4a1e7$export$2e2bcd8739ae039)(String(tail));
        return tail.appendTo(this);
    }
    append(str, flags, tail) {
        const details = this._appendChar(str[0], flags);
        if (tail != null) details.tailShift += this.appendTail(tail).tailShift;
        return details;
    }
    doCommit() {}
    get state() {
        return {
            _value: this._value,
            _rawInputValue: this.rawInputValue
        };
    }
    set state(state) {
        this._value = state._value;
        this._isRawInput = Boolean(state._rawInputValue);
    }
    pad(flags) {
        return this._appendPlaceholder();
    }
}






class $4829a4cac6c619fb$export$2e2bcd8739ae039 {
    /** */ /** */ /** */ /** */ /** */ /** */ /** */ /** */ constructor(opts){
        const { parent: parent, isOptional: isOptional, placeholderChar: placeholderChar, displayChar: displayChar, lazy: lazy, eager: eager, ...maskOpts } = opts;
        this.masked = (0, $14fa5ae7a370b810$export$2e2bcd8739ae039)(maskOpts);
        Object.assign(this, {
            parent: parent,
            isOptional: isOptional,
            placeholderChar: placeholderChar,
            displayChar: displayChar,
            lazy: lazy,
            eager: eager
        });
    }
    reset() {
        this.isFilled = false;
        this.masked.reset();
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.value.length;
        if (fromPos === 0 && toPos >= 1) {
            this.isFilled = false;
            return this.masked.remove(fromPos, toPos);
        }
        return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
    }
    get value() {
        return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : '');
    }
    get unmaskedValue() {
        return this.masked.unmaskedValue;
    }
    get rawInputValue() {
        return this.masked.rawInputValue;
    }
    get displayValue() {
        return this.masked.value && this.displayChar || this.value;
    }
    get isComplete() {
        return Boolean(this.masked.value) || this.isOptional;
    }
    _appendChar(ch, flags) {
        if (flags === void 0) flags = {};
        if (this.isFilled) return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        const state = this.masked.state;
        // simulate input
        let details = this.masked._appendChar(ch, this.currentMaskFlags(flags));
        if (details.inserted && this.doValidate(flags) === false) {
            details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
            this.masked.state = state;
        }
        if (!details.inserted && !this.isOptional && !this.lazy && !flags.input) details.inserted = this.placeholderChar;
        details.skip = !details.inserted && !this.isOptional;
        this.isFilled = Boolean(details.inserted);
        return details;
    }
    append(str, flags, tail) {
        // TODO probably should be done via _appendChar
        return this.masked.append(str, this.currentMaskFlags(flags), tail);
    }
    _appendPlaceholder() {
        if (this.isFilled || this.isOptional) return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        this.isFilled = true;
        return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)({
            inserted: this.placeholderChar
        });
    }
    _appendEager() {
        return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
    }
    extractTail(fromPos, toPos) {
        return this.masked.extractTail(fromPos, toPos);
    }
    appendTail(tail) {
        return this.masked.appendTail(tail);
    }
    extractInput(fromPos, toPos, flags) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.value.length;
        return this.masked.extractInput(fromPos, toPos, flags);
    }
    nearestInputPos(cursorPos, direction) {
        if (direction === void 0) direction = (0, $93906f2a377dc74e$export$9106728c49045482).NONE;
        const minPos = 0;
        const maxPos = this.value.length;
        const boundPos = Math.min(Math.max(cursorPos, minPos), maxPos);
        switch(direction){
            case (0, $93906f2a377dc74e$export$9106728c49045482).LEFT:
            case (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_LEFT:
                return this.isComplete ? boundPos : minPos;
            case (0, $93906f2a377dc74e$export$9106728c49045482).RIGHT:
            case (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_RIGHT:
                return this.isComplete ? boundPos : maxPos;
            case (0, $93906f2a377dc74e$export$9106728c49045482).NONE:
            default:
                return boundPos;
        }
    }
    totalInputPositions(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.value.length;
        return this.value.slice(fromPos, toPos).length;
    }
    doValidate(flags) {
        return this.masked.doValidate(this.currentMaskFlags(flags)) && (!this.parent || this.parent.doValidate(this.currentMaskFlags(flags)));
    }
    doCommit() {
        this.masked.doCommit();
    }
    get state() {
        return {
            _value: this.value,
            _rawInputValue: this.rawInputValue,
            masked: this.masked.state,
            isFilled: this.isFilled
        };
    }
    set state(state) {
        this.masked.state = state.masked;
        this.isFilled = state.isFilled;
    }
    currentMaskFlags(flags) {
        var _flags$_beforeTailSta;
        return {
            ...flags,
            _beforeTailState: (flags == null || (_flags$_beforeTailSta = flags._beforeTailState) == null ? void 0 : _flags$_beforeTailSta.masked) || (flags == null ? void 0 : flags._beforeTailState)
        };
    }
    pad(flags) {
        return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
    }
}
$4829a4cac6c619fb$export$2e2bcd8739ae039.DEFAULT_DEFINITIONS = {
    '0': /\d/,
    'a': /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
    // http://stackoverflow.com/a/22075070
    '*': /./
};







/** Masking by RegExp */ class $d997fae97fd92d7a$export$2e2bcd8739ae039 extends (0, $e23198c8dcc9cc5a$export$2e2bcd8739ae039) {
    /** */ /** Enable characters overwriting */ /** */ /** */ /** */ updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        const mask = opts.mask;
        if (mask) opts.validate = (value)=>value.search(mask) >= 0;
        super._update(opts);
    }
}
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedRegExp = $d997fae97fd92d7a$export$2e2bcd8739ae039;



/** Pattern mask */ class $836f3f1cf9656cb9$export$2e2bcd8739ae039 extends (0, $e23198c8dcc9cc5a$export$2e2bcd8739ae039) {
    /** */ /** */ /** Single char for empty input */ /** Single char for filled input */ /** Show placeholder only when needed */ /** Enable characters overwriting */ /** */ /** */ /** */ constructor(opts){
        super({
            ...$836f3f1cf9656cb9$export$2e2bcd8739ae039.DEFAULTS,
            ...opts,
            definitions: Object.assign({}, (0, $4829a4cac6c619fb$export$2e2bcd8739ae039).DEFAULT_DEFINITIONS, opts == null ? void 0 : opts.definitions)
        });
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        opts.definitions = Object.assign({}, this.definitions, opts.definitions);
        super._update(opts);
        this._rebuildMask();
    }
    _rebuildMask() {
        const defs = this.definitions;
        this._blocks = [];
        this.exposeBlock = undefined;
        this._stops = [];
        this._maskedBlocks = {};
        const pattern = this.mask;
        if (!pattern || !defs) return;
        let unmaskingBlock = false;
        let optionalBlock = false;
        for(let i = 0; i < pattern.length; ++i){
            if (this.blocks) {
                const p = pattern.slice(i);
                const bNames = Object.keys(this.blocks).filter((bName)=>p.indexOf(bName) === 0);
                // order by key length
                bNames.sort((a, b)=>b.length - a.length);
                // use block name with max length
                const bName = bNames[0];
                if (bName) {
                    const { expose: expose, repeat: repeat, ...bOpts } = (0, $14fa5ae7a370b810$export$a213ae1c699d7230)(this.blocks[bName]); // TODO type Opts<Arg & Extra>
                    const blockOpts = {
                        lazy: this.lazy,
                        eager: this.eager,
                        placeholderChar: this.placeholderChar,
                        displayChar: this.displayChar,
                        overwrite: this.overwrite,
                        autofix: this.autofix,
                        ...bOpts,
                        repeat: repeat,
                        parent: this
                    };
                    const maskedBlock = repeat != null ? new (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).RepeatBlock(blockOpts /* TODO */ ) : (0, $14fa5ae7a370b810$export$2e2bcd8739ae039)(blockOpts);
                    if (maskedBlock) {
                        this._blocks.push(maskedBlock);
                        if (expose) this.exposeBlock = maskedBlock;
                        // store block index
                        if (!this._maskedBlocks[bName]) this._maskedBlocks[bName] = [];
                        this._maskedBlocks[bName].push(this._blocks.length - 1);
                    }
                    i += bName.length - 1;
                    continue;
                }
            }
            let char = pattern[i];
            let isInput = char in defs;
            if (char === $836f3f1cf9656cb9$export$2e2bcd8739ae039.STOP_CHAR) {
                this._stops.push(this._blocks.length);
                continue;
            }
            if (char === '{' || char === '}') {
                unmaskingBlock = !unmaskingBlock;
                continue;
            }
            if (char === '[' || char === ']') {
                optionalBlock = !optionalBlock;
                continue;
            }
            if (char === $836f3f1cf9656cb9$export$2e2bcd8739ae039.ESCAPE_CHAR) {
                ++i;
                char = pattern[i];
                if (!char) break;
                isInput = false;
            }
            const def = isInput ? new (0, $4829a4cac6c619fb$export$2e2bcd8739ae039)({
                isOptional: optionalBlock,
                lazy: this.lazy,
                eager: this.eager,
                placeholderChar: this.placeholderChar,
                displayChar: this.displayChar,
                ...(0, $14fa5ae7a370b810$export$a213ae1c699d7230)(defs[char]),
                parent: this
            }) : new (0, $29e919e8e196db5e$export$2e2bcd8739ae039)({
                char: char,
                eager: this.eager,
                isUnmasking: unmaskingBlock
            });
            this._blocks.push(def);
        }
    }
    get state() {
        return {
            ...super.state,
            _blocks: this._blocks.map((b)=>b.state)
        };
    }
    set state(state) {
        if (!state) {
            this.reset();
            return;
        }
        const { _blocks: _blocks, ...maskedState } = state;
        this._blocks.forEach((b, bi)=>b.state = _blocks[bi]);
        super.state = maskedState;
    }
    reset() {
        super.reset();
        this._blocks.forEach((b)=>b.reset());
    }
    get isComplete() {
        return this.exposeBlock ? this.exposeBlock.isComplete : this._blocks.every((b)=>b.isComplete);
    }
    get isFilled() {
        return this._blocks.every((b)=>b.isFilled);
    }
    get isFixed() {
        return this._blocks.every((b)=>b.isFixed);
    }
    get isOptional() {
        return this._blocks.every((b)=>b.isOptional);
    }
    doCommit() {
        this._blocks.forEach((b)=>b.doCommit());
        super.doCommit();
    }
    get unmaskedValue() {
        return this.exposeBlock ? this.exposeBlock.unmaskedValue : this._blocks.reduce((str, b)=>str += b.unmaskedValue, '');
    }
    set unmaskedValue(unmaskedValue) {
        if (this.exposeBlock) {
            const tail = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
            this.exposeBlock.unmaskedValue = unmaskedValue;
            this.appendTail(tail);
            this.doCommit();
        } else super.unmaskedValue = unmaskedValue;
    }
    get value() {
        return this.exposeBlock ? this.exposeBlock.value : // TODO return _value when not in change?
        this._blocks.reduce((str, b)=>str += b.value, '');
    }
    set value(value) {
        if (this.exposeBlock) {
            const tail = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
            this.exposeBlock.value = value;
            this.appendTail(tail);
            this.doCommit();
        } else super.value = value;
    }
    get typedValue() {
        return this.exposeBlock ? this.exposeBlock.typedValue : super.typedValue;
    }
    set typedValue(value) {
        if (this.exposeBlock) {
            const tail = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
            this.exposeBlock.typedValue = value;
            this.appendTail(tail);
            this.doCommit();
        } else super.typedValue = value;
    }
    get displayValue() {
        return this._blocks.reduce((str, b)=>str += b.displayValue, '');
    }
    appendTail(tail) {
        return super.appendTail(tail).aggregate(this._appendPlaceholder());
    }
    _appendEager() {
        var _this$_mapPosToBlock;
        const details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        let startBlockIndex = (_this$_mapPosToBlock = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : _this$_mapPosToBlock.index;
        if (startBlockIndex == null) return details;
        // TODO test if it works for nested pattern masks
        if (this._blocks[startBlockIndex].isFilled) ++startBlockIndex;
        for(let bi = startBlockIndex; bi < this._blocks.length; ++bi){
            const d = this._blocks[bi]._appendEager();
            if (!d.inserted) break;
            details.aggregate(d);
        }
        return details;
    }
    _appendCharRaw(ch, flags) {
        if (flags === void 0) flags = {};
        const blockIter = this._mapPosToBlock(this.displayValue.length);
        const details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        if (!blockIter) return details;
        for(let bi = blockIter.index, block; block = this._blocks[bi]; ++bi){
            var _flags$_beforeTailSta;
            const blockDetails = block._appendChar(ch, {
                ...flags,
                _beforeTailState: (_flags$_beforeTailSta = flags._beforeTailState) == null || (_flags$_beforeTailSta = _flags$_beforeTailSta._blocks) == null ? void 0 : _flags$_beforeTailSta[bi]
            });
            details.aggregate(blockDetails);
            if (blockDetails.consumed) break; // go next char
        }
        return details;
    }
    extractTail(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        const chunkTail = new (0, $28324efa3f559998$export$2e2bcd8739ae039)();
        if (fromPos === toPos) return chunkTail;
        this._forEachBlocksInRange(fromPos, toPos, (b, bi, bFromPos, bToPos)=>{
            const blockChunk = b.extractTail(bFromPos, bToPos);
            blockChunk.stop = this._findStopBefore(bi);
            blockChunk.from = this._blockStartPos(bi);
            if (blockChunk instanceof (0, $28324efa3f559998$export$2e2bcd8739ae039)) blockChunk.blockIndex = bi;
            chunkTail.extend(blockChunk);
        });
        return chunkTail;
    }
    extractInput(fromPos, toPos, flags) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        if (flags === void 0) flags = {};
        if (fromPos === toPos) return '';
        let input = '';
        this._forEachBlocksInRange(fromPos, toPos, (b, _, fromPos, toPos)=>{
            input += b.extractInput(fromPos, toPos, flags);
        });
        return input;
    }
    _findStopBefore(blockIndex) {
        let stopBefore;
        for(let si = 0; si < this._stops.length; ++si){
            const stop = this._stops[si];
            if (stop <= blockIndex) stopBefore = stop;
            else break;
        }
        return stopBefore;
    }
    /** Appends placeholder depending on laziness */ _appendPlaceholder(toBlockIndex) {
        const details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        if (this.lazy && toBlockIndex == null) return details;
        const startBlockIter = this._mapPosToBlock(this.displayValue.length);
        if (!startBlockIter) return details;
        const startBlockIndex = startBlockIter.index;
        const endBlockIndex = toBlockIndex != null ? toBlockIndex : this._blocks.length;
        this._blocks.slice(startBlockIndex, endBlockIndex).forEach((b)=>{
            if (!b.lazy || toBlockIndex != null) {
                var _blocks2;
                details.aggregate(b._appendPlaceholder((_blocks2 = b._blocks) == null ? void 0 : _blocks2.length));
            }
        });
        return details;
    }
    /** Finds block in pos */ _mapPosToBlock(pos) {
        let accVal = '';
        for(let bi = 0; bi < this._blocks.length; ++bi){
            const block = this._blocks[bi];
            const blockStartPos = accVal.length;
            accVal += block.displayValue;
            if (pos <= accVal.length) return {
                index: bi,
                offset: pos - blockStartPos
            };
        }
    }
    _blockStartPos(blockIndex) {
        return this._blocks.slice(0, blockIndex).reduce((pos, b)=>pos += b.displayValue.length, 0);
    }
    _forEachBlocksInRange(fromPos, toPos, fn) {
        if (toPos === void 0) toPos = this.displayValue.length;
        const fromBlockIter = this._mapPosToBlock(fromPos);
        if (fromBlockIter) {
            const toBlockIter = this._mapPosToBlock(toPos);
            // process first block
            const isSameBlock = toBlockIter && fromBlockIter.index === toBlockIter.index;
            const fromBlockStartPos = fromBlockIter.offset;
            const fromBlockEndPos = toBlockIter && isSameBlock ? toBlockIter.offset : this._blocks[fromBlockIter.index].displayValue.length;
            fn(this._blocks[fromBlockIter.index], fromBlockIter.index, fromBlockStartPos, fromBlockEndPos);
            if (toBlockIter && !isSameBlock) {
                // process intermediate blocks
                for(let bi = fromBlockIter.index + 1; bi < toBlockIter.index; ++bi)fn(this._blocks[bi], bi, 0, this._blocks[bi].displayValue.length);
                // process last block
                fn(this._blocks[toBlockIter.index], toBlockIter.index, 0, toBlockIter.offset);
            }
        }
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        const removeDetails = super.remove(fromPos, toPos);
        this._forEachBlocksInRange(fromPos, toPos, (b, _, bFromPos, bToPos)=>{
            removeDetails.aggregate(b.remove(bFromPos, bToPos));
        });
        return removeDetails;
    }
    nearestInputPos(cursorPos, direction) {
        if (direction === void 0) direction = (0, $93906f2a377dc74e$export$9106728c49045482).NONE;
        if (!this._blocks.length) return 0;
        const cursor = new (0, $50f71afd352b9d43$export$2e2bcd8739ae039)(this, cursorPos);
        if (direction === (0, $93906f2a377dc74e$export$9106728c49045482).NONE) {
            // -------------------------------------------------
            // NONE should only go out from fixed to the right!
            // -------------------------------------------------
            if (cursor.pushRightBeforeInput()) return cursor.pos;
            cursor.popState();
            if (cursor.pushLeftBeforeInput()) return cursor.pos;
            return this.displayValue.length;
        }
        // FORCE is only about a|* otherwise is 0
        if (direction === (0, $93906f2a377dc74e$export$9106728c49045482).LEFT || direction === (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_LEFT) {
            // try to break fast when *|a
            if (direction === (0, $93906f2a377dc74e$export$9106728c49045482).LEFT) {
                cursor.pushRightBeforeFilled();
                if (cursor.ok && cursor.pos === cursorPos) return cursorPos;
                cursor.popState();
            }
            // forward flow
            cursor.pushLeftBeforeInput();
            cursor.pushLeftBeforeRequired();
            cursor.pushLeftBeforeFilled();
            // backward flow
            if (direction === (0, $93906f2a377dc74e$export$9106728c49045482).LEFT) {
                cursor.pushRightBeforeInput();
                cursor.pushRightBeforeRequired();
                if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
                cursor.popState();
                if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
                cursor.popState();
            }
            if (cursor.ok) return cursor.pos;
            if (direction === (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_LEFT) return 0;
            cursor.popState();
            if (cursor.ok) return cursor.pos;
            cursor.popState();
            if (cursor.ok) return cursor.pos;
            return 0;
        }
        if (direction === (0, $93906f2a377dc74e$export$9106728c49045482).RIGHT || direction === (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_RIGHT) {
            // forward flow
            cursor.pushRightBeforeInput();
            cursor.pushRightBeforeRequired();
            if (cursor.pushRightBeforeFilled()) return cursor.pos;
            if (direction === (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_RIGHT) return this.displayValue.length;
            // backward flow
            cursor.popState();
            if (cursor.ok) return cursor.pos;
            cursor.popState();
            if (cursor.ok) return cursor.pos;
            return this.nearestInputPos(cursorPos, (0, $93906f2a377dc74e$export$9106728c49045482).LEFT);
        }
        return cursorPos;
    }
    totalInputPositions(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        let total = 0;
        this._forEachBlocksInRange(fromPos, toPos, (b, _, bFromPos, bToPos)=>{
            total += b.totalInputPositions(bFromPos, bToPos);
        });
        return total;
    }
    /** Get block by name */ maskedBlock(name) {
        return this.maskedBlocks(name)[0];
    }
    /** Get all blocks by name */ maskedBlocks(name) {
        const indices = this._maskedBlocks[name];
        if (!indices) return [];
        return indices.map((gi)=>this._blocks[gi]);
    }
    pad(flags) {
        const details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        this._forEachBlocksInRange(0, this.displayValue.length, (b)=>details.aggregate(b.pad(flags)));
        return details;
    }
}
$836f3f1cf9656cb9$export$2e2bcd8739ae039.DEFAULTS = {
    ...(0, $e23198c8dcc9cc5a$export$2e2bcd8739ae039).DEFAULTS,
    lazy: true,
    placeholderChar: '_'
};
$836f3f1cf9656cb9$export$2e2bcd8739ae039.STOP_CHAR = '`';
$836f3f1cf9656cb9$export$2e2bcd8739ae039.ESCAPE_CHAR = '\\';
$836f3f1cf9656cb9$export$2e2bcd8739ae039.InputDefinition = (0, $4829a4cac6c619fb$export$2e2bcd8739ae039);
$836f3f1cf9656cb9$export$2e2bcd8739ae039.FixedDefinition = (0, $29e919e8e196db5e$export$2e2bcd8739ae039);
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedPattern = $836f3f1cf9656cb9$export$2e2bcd8739ae039;














/** Pattern which accepts ranges */ class $64d8260964bbd131$export$2e2bcd8739ae039 extends (0, $836f3f1cf9656cb9$export$2e2bcd8739ae039) {
    /**
    Optionally sets max length of pattern.
    Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
  */ /** Min bound */ /** Max bound */ get _matchFrom() {
        return this.maxLength - String(this.from).length;
    }
    constructor(opts){
        super(opts); // mask will be created in _update
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        const { to: to = this.to || 0, from: from = this.from || 0, maxLength: maxLength = this.maxLength || 0, autofix: autofix = this.autofix, ...patternOpts } = opts;
        this.to = to;
        this.from = from;
        this.maxLength = Math.max(String(to).length, maxLength);
        this.autofix = autofix;
        const fromStr = String(this.from).padStart(this.maxLength, '0');
        const toStr = String(this.to).padStart(this.maxLength, '0');
        let sameCharsCount = 0;
        while(sameCharsCount < toStr.length && toStr[sameCharsCount] === fromStr[sameCharsCount])++sameCharsCount;
        patternOpts.mask = toStr.slice(0, sameCharsCount).replace(/0/g, '\\0') + '0'.repeat(this.maxLength - sameCharsCount);
        super._update(patternOpts);
    }
    get isComplete() {
        return super.isComplete && Boolean(this.value);
    }
    boundaries(str) {
        let minstr = '';
        let maxstr = '';
        const [, placeholder, num] = str.match(/^(\D*)(\d*)(\D*)/) || [];
        if (num) {
            minstr = '0'.repeat(placeholder.length) + num;
            maxstr = '9'.repeat(placeholder.length) + num;
        }
        minstr = minstr.padEnd(this.maxLength, '0');
        maxstr = maxstr.padEnd(this.maxLength, '9');
        return [
            minstr,
            maxstr
        ];
    }
    doPrepareChar(ch, flags) {
        if (flags === void 0) flags = {};
        let details;
        [ch, details] = super.doPrepareChar(ch.replace(/\D/g, ''), flags);
        if (!ch) details.skip = !this.isComplete;
        return [
            ch,
            details
        ];
    }
    _appendCharRaw(ch, flags) {
        if (flags === void 0) flags = {};
        if (!this.autofix || this.value.length + 1 > this.maxLength) return super._appendCharRaw(ch, flags);
        const fromStr = String(this.from).padStart(this.maxLength, '0');
        const toStr = String(this.to).padStart(this.maxLength, '0');
        const [minstr, maxstr] = this.boundaries(this.value + ch);
        if (Number(maxstr) < this.from) return super._appendCharRaw(fromStr[this.value.length], flags);
        if (Number(minstr) > this.to) {
            if (!flags.tail && this.autofix === 'pad' && this.value.length + 1 < this.maxLength) return super._appendCharRaw(fromStr[this.value.length], flags).aggregate(this._appendCharRaw(ch, flags));
            return super._appendCharRaw(toStr[this.value.length], flags);
        }
        return super._appendCharRaw(ch, flags);
    }
    doValidate(flags) {
        const str = this.value;
        const firstNonZero = str.search(/[^0]/);
        if (firstNonZero === -1 && str.length <= this._matchFrom) return true;
        const [minstr, maxstr] = this.boundaries(str);
        return this.from <= Number(maxstr) && Number(minstr) <= this.to && super.doValidate(flags);
    }
    pad(flags) {
        const details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        if (this.value.length === this.maxLength) return details;
        const value = this.value;
        const padLength = this.maxLength - this.value.length;
        if (padLength) {
            this.reset();
            for(let i = 0; i < padLength; ++i)details.aggregate(super._appendCharRaw('0', flags));
            // append tail
            value.split('').forEach((ch)=>this._appendCharRaw(ch));
        }
        return details;
    }
}
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedRange = $64d8260964bbd131$export$2e2bcd8739ae039;













const $bf0c0fae3831ac7d$var$DefaultPattern = 'd{.}`m{.}`Y';
// Make format and parse required when pattern is provided
/** Date mask */ class $bf0c0fae3831ac7d$export$2e2bcd8739ae039 extends (0, $836f3f1cf9656cb9$export$2e2bcd8739ae039) {
    static extractPatternOptions(opts) {
        const { mask: mask, pattern: pattern, ...patternOpts } = opts;
        return {
            ...patternOpts,
            mask: (0, $93906f2a377dc74e$export$844ec244b1367d54)(mask) ? mask : pattern
        };
    }
    /** Pattern mask for date according to {@link MaskedDate#format} */ /** Start date */ /** End date */ /** Format typed value to string */ /** Parse string to get typed value */ constructor(opts){
        super($bf0c0fae3831ac7d$export$2e2bcd8739ae039.extractPatternOptions({
            ...$bf0c0fae3831ac7d$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        }));
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        const { mask: mask, pattern: pattern, blocks: blocks, ...patternOpts } = {
            ...$bf0c0fae3831ac7d$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        };
        const patternBlocks = Object.assign({}, $bf0c0fae3831ac7d$export$2e2bcd8739ae039.GET_DEFAULT_BLOCKS());
        // adjust year block
        if (opts.min) patternBlocks.Y.from = opts.min.getFullYear();
        if (opts.max) patternBlocks.Y.to = opts.max.getFullYear();
        if (opts.min && opts.max && patternBlocks.Y.from === patternBlocks.Y.to) {
            patternBlocks.m.from = opts.min.getMonth() + 1;
            patternBlocks.m.to = opts.max.getMonth() + 1;
            if (patternBlocks.m.from === patternBlocks.m.to) {
                patternBlocks.d.from = opts.min.getDate();
                patternBlocks.d.to = opts.max.getDate();
            }
        }
        Object.assign(patternBlocks, this.blocks, blocks);
        super._update({
            ...patternOpts,
            mask: (0, $93906f2a377dc74e$export$844ec244b1367d54)(mask) ? mask : pattern,
            blocks: patternBlocks
        });
    }
    doValidate(flags) {
        const date = this.date;
        return super.doValidate(flags) && (!this.isComplete || this.isDateExist(this.value) && date != null && (this.min == null || this.min <= date) && (this.max == null || date <= this.max));
    }
    /** Checks if date is exists */ isDateExist(str) {
        return this.format(this.parse(str, this), this).indexOf(str) >= 0;
    }
    /** Parsed Date */ get date() {
        return this.typedValue;
    }
    set date(date) {
        this.typedValue = date;
    }
    get typedValue() {
        return this.isComplete ? super.typedValue : null;
    }
    set typedValue(value) {
        super.typedValue = value;
    }
    maskEquals(mask) {
        return mask === Date || super.maskEquals(mask);
    }
    optionsIsChanged(opts) {
        return super.optionsIsChanged($bf0c0fae3831ac7d$export$2e2bcd8739ae039.extractPatternOptions(opts));
    }
}
$bf0c0fae3831ac7d$export$2e2bcd8739ae039.GET_DEFAULT_BLOCKS = ()=>({
        d: {
            mask: (0, $64d8260964bbd131$export$2e2bcd8739ae039),
            from: 1,
            to: 31,
            maxLength: 2
        },
        m: {
            mask: (0, $64d8260964bbd131$export$2e2bcd8739ae039),
            from: 1,
            to: 12,
            maxLength: 2
        },
        Y: {
            mask: (0, $64d8260964bbd131$export$2e2bcd8739ae039),
            from: 1900,
            to: 9999
        }
    });
$bf0c0fae3831ac7d$export$2e2bcd8739ae039.DEFAULTS = {
    ...(0, $836f3f1cf9656cb9$export$2e2bcd8739ae039).DEFAULTS,
    mask: Date,
    pattern: $bf0c0fae3831ac7d$var$DefaultPattern,
    format: (date, masked)=>{
        if (!date) return '';
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return [
            day,
            month,
            year
        ].join('.');
    },
    parse: (str, masked)=>{
        const [day, month, year] = str.split('.').map(Number);
        return new Date(year, month - 1, day);
    }
};
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedDate = $bf0c0fae3831ac7d$export$2e2bcd8739ae039;








/** Dynamic mask for choosing appropriate mask in run-time */ class $e5831edf0b46fed9$export$2e2bcd8739ae039 extends (0, $e23198c8dcc9cc5a$export$2e2bcd8739ae039) {
    constructor(opts){
        super({
            ...$e5831edf0b46fed9$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        });
        this.currentMask = undefined;
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        super._update(opts);
        if ('mask' in opts) {
            this.exposeMask = undefined;
            // mask could be totally dynamic with only `dispatch` option
            this.compiledMasks = Array.isArray(opts.mask) ? opts.mask.map((m)=>{
                const { expose: expose, ...maskOpts } = (0, $14fa5ae7a370b810$export$a213ae1c699d7230)(m);
                const masked = (0, $14fa5ae7a370b810$export$2e2bcd8739ae039)({
                    overwrite: this._overwrite,
                    eager: this._eager,
                    skipInvalid: this._skipInvalid,
                    ...maskOpts
                });
                if (expose) this.exposeMask = masked;
                return masked;
            }) : [];
        // this.currentMask = this.doDispatch(''); // probably not needed but lets see
        }
    }
    _appendCharRaw(ch, flags) {
        if (flags === void 0) flags = {};
        const details = this._applyDispatch(ch, flags);
        if (this.currentMask) details.aggregate(this.currentMask._appendChar(ch, this.currentMaskFlags(flags)));
        return details;
    }
    _applyDispatch(appended, flags, tail) {
        if (appended === void 0) appended = '';
        if (flags === void 0) flags = {};
        if (tail === void 0) tail = '';
        const prevValueBeforeTail = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._value : this.value;
        const inputValue = this.rawInputValue;
        const insertValue = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._rawInputValue : inputValue;
        const tailValue = inputValue.slice(insertValue.length);
        const prevMask = this.currentMask;
        const details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        const prevMaskState = prevMask == null ? void 0 : prevMask.state;
        // clone flags to prevent overwriting `_beforeTailState`
        this.currentMask = this.doDispatch(appended, {
            ...flags
        }, tail);
        // restore state after dispatch
        if (this.currentMask) {
            if (this.currentMask !== prevMask) {
                // if mask changed reapply input
                this.currentMask.reset();
                if (insertValue) {
                    this.currentMask.append(insertValue, {
                        raw: true
                    });
                    details.tailShift = this.currentMask.value.length - prevValueBeforeTail.length;
                }
                if (tailValue) details.tailShift += this.currentMask.append(tailValue, {
                    raw: true,
                    tail: true
                }).tailShift;
            } else if (prevMaskState) // Dispatch can do something bad with state, so
            // restore prev mask state
            this.currentMask.state = prevMaskState;
        }
        return details;
    }
    _appendPlaceholder() {
        const details = this._applyDispatch();
        if (this.currentMask) details.aggregate(this.currentMask._appendPlaceholder());
        return details;
    }
    _appendEager() {
        const details = this._applyDispatch();
        if (this.currentMask) details.aggregate(this.currentMask._appendEager());
        return details;
    }
    appendTail(tail) {
        const details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        if (tail) details.aggregate(this._applyDispatch('', {}, tail));
        return details.aggregate(this.currentMask ? this.currentMask.appendTail(tail) : super.appendTail(tail));
    }
    currentMaskFlags(flags) {
        var _flags$_beforeTailSta, _flags$_beforeTailSta2;
        return {
            ...flags,
            _beforeTailState: ((_flags$_beforeTailSta = flags._beforeTailState) == null ? void 0 : _flags$_beforeTailSta.currentMaskRef) === this.currentMask && ((_flags$_beforeTailSta2 = flags._beforeTailState) == null ? void 0 : _flags$_beforeTailSta2.currentMask) || flags._beforeTailState
        };
    }
    doDispatch(appended, flags, tail) {
        if (flags === void 0) flags = {};
        if (tail === void 0) tail = '';
        return this.dispatch(appended, this, flags, tail);
    }
    doValidate(flags) {
        return super.doValidate(flags) && (!this.currentMask || this.currentMask.doValidate(this.currentMaskFlags(flags)));
    }
    doPrepare(str, flags) {
        if (flags === void 0) flags = {};
        let [s, details] = super.doPrepare(str, flags);
        if (this.currentMask) {
            let currentDetails;
            [s, currentDetails] = super.doPrepare(s, this.currentMaskFlags(flags));
            details = details.aggregate(currentDetails);
        }
        return [
            s,
            details
        ];
    }
    doPrepareChar(str, flags) {
        if (flags === void 0) flags = {};
        let [s, details] = super.doPrepareChar(str, flags);
        if (this.currentMask) {
            let currentDetails;
            [s, currentDetails] = super.doPrepareChar(s, this.currentMaskFlags(flags));
            details = details.aggregate(currentDetails);
        }
        return [
            s,
            details
        ];
    }
    reset() {
        var _this$currentMask;
        (_this$currentMask = this.currentMask) == null || _this$currentMask.reset();
        this.compiledMasks.forEach((m)=>m.reset());
    }
    get value() {
        return this.exposeMask ? this.exposeMask.value : this.currentMask ? this.currentMask.value : '';
    }
    set value(value) {
        if (this.exposeMask) {
            this.exposeMask.value = value;
            this.currentMask = this.exposeMask;
            this._applyDispatch();
        } else super.value = value;
    }
    get unmaskedValue() {
        return this.exposeMask ? this.exposeMask.unmaskedValue : this.currentMask ? this.currentMask.unmaskedValue : '';
    }
    set unmaskedValue(unmaskedValue) {
        if (this.exposeMask) {
            this.exposeMask.unmaskedValue = unmaskedValue;
            this.currentMask = this.exposeMask;
            this._applyDispatch();
        } else super.unmaskedValue = unmaskedValue;
    }
    get typedValue() {
        return this.exposeMask ? this.exposeMask.typedValue : this.currentMask ? this.currentMask.typedValue : '';
    }
    set typedValue(typedValue) {
        if (this.exposeMask) {
            this.exposeMask.typedValue = typedValue;
            this.currentMask = this.exposeMask;
            this._applyDispatch();
            return;
        }
        let unmaskedValue = String(typedValue);
        // double check it
        if (this.currentMask) {
            this.currentMask.typedValue = typedValue;
            unmaskedValue = this.currentMask.unmaskedValue;
        }
        this.unmaskedValue = unmaskedValue;
    }
    get displayValue() {
        return this.currentMask ? this.currentMask.displayValue : '';
    }
    get isComplete() {
        var _this$currentMask2;
        return Boolean((_this$currentMask2 = this.currentMask) == null ? void 0 : _this$currentMask2.isComplete);
    }
    get isFilled() {
        var _this$currentMask3;
        return Boolean((_this$currentMask3 = this.currentMask) == null ? void 0 : _this$currentMask3.isFilled);
    }
    remove(fromPos, toPos) {
        const details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        if (this.currentMask) details.aggregate(this.currentMask.remove(fromPos, toPos))// update with dispatch
        .aggregate(this._applyDispatch());
        return details;
    }
    get state() {
        var _this$currentMask4;
        return {
            ...super.state,
            _rawInputValue: this.rawInputValue,
            compiledMasks: this.compiledMasks.map((m)=>m.state),
            currentMaskRef: this.currentMask,
            currentMask: (_this$currentMask4 = this.currentMask) == null ? void 0 : _this$currentMask4.state
        };
    }
    set state(state) {
        const { compiledMasks: compiledMasks, currentMaskRef: currentMaskRef, currentMask: currentMask, ...maskedState } = state;
        if (compiledMasks) this.compiledMasks.forEach((m, mi)=>m.state = compiledMasks[mi]);
        if (currentMaskRef != null) {
            this.currentMask = currentMaskRef;
            this.currentMask.state = currentMask;
        }
        super.state = maskedState;
    }
    extractInput(fromPos, toPos, flags) {
        return this.currentMask ? this.currentMask.extractInput(fromPos, toPos, flags) : '';
    }
    extractTail(fromPos, toPos) {
        return this.currentMask ? this.currentMask.extractTail(fromPos, toPos) : super.extractTail(fromPos, toPos);
    }
    doCommit() {
        if (this.currentMask) this.currentMask.doCommit();
        super.doCommit();
    }
    nearestInputPos(cursorPos, direction) {
        return this.currentMask ? this.currentMask.nearestInputPos(cursorPos, direction) : super.nearestInputPos(cursorPos, direction);
    }
    get overwrite() {
        return this.currentMask ? this.currentMask.overwrite : this._overwrite;
    }
    set overwrite(overwrite) {
        this._overwrite = overwrite;
    }
    get eager() {
        return this.currentMask ? this.currentMask.eager : this._eager;
    }
    set eager(eager) {
        this._eager = eager;
    }
    get skipInvalid() {
        return this.currentMask ? this.currentMask.skipInvalid : this._skipInvalid;
    }
    set skipInvalid(skipInvalid) {
        this._skipInvalid = skipInvalid;
    }
    get autofix() {
        return this.currentMask ? this.currentMask.autofix : this._autofix;
    }
    set autofix(autofix) {
        this._autofix = autofix;
    }
    maskEquals(mask) {
        return Array.isArray(mask) ? this.compiledMasks.every((m, mi)=>{
            if (!mask[mi]) return;
            const { mask: oldMask, ...restOpts } = mask[mi];
            return (0, $93906f2a377dc74e$export$7aeb68f71172641d)(m, restOpts) && m.maskEquals(oldMask);
        }) : super.maskEquals(mask);
    }
    typedValueEquals(value) {
        var _this$currentMask5;
        return Boolean((_this$currentMask5 = this.currentMask) == null ? void 0 : _this$currentMask5.typedValueEquals(value));
    }
}
/** Currently chosen mask */ /** Currently chosen mask */ /** Compliled {@link Masked} options */ /** Chooses {@link Masked} depending on input value */ $e5831edf0b46fed9$export$2e2bcd8739ae039.DEFAULTS = {
    ...(0, $e23198c8dcc9cc5a$export$2e2bcd8739ae039).DEFAULTS,
    dispatch: (appended, masked, flags, tail)=>{
        if (!masked.compiledMasks.length) return;
        const inputValue = masked.rawInputValue;
        // simulate input
        const inputs = masked.compiledMasks.map((m, index)=>{
            const isCurrent = masked.currentMask === m;
            const startInputPos = isCurrent ? m.displayValue.length : m.nearestInputPos(m.displayValue.length, (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_LEFT);
            if (m.rawInputValue !== inputValue) {
                m.reset();
                m.append(inputValue, {
                    raw: true
                });
            } else if (!isCurrent) m.remove(startInputPos);
            m.append(appended, masked.currentMaskFlags(flags));
            m.appendTail(tail);
            return {
                index: index,
                weight: m.rawInputValue.length,
                totalInputPositions: m.totalInputPositions(0, Math.max(startInputPos, m.nearestInputPos(m.displayValue.length, (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_LEFT)))
            };
        });
        // pop masks with longer values first
        inputs.sort((i1, i2)=>i2.weight - i1.weight || i2.totalInputPositions - i1.totalInputPositions);
        return masked.compiledMasks[inputs[0].index];
    }
};
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedDynamic = $e5831edf0b46fed9$export$2e2bcd8739ae039;














/** Pattern which validates enum values */ class $99ea44ae76da8219$export$2e2bcd8739ae039 extends (0, $836f3f1cf9656cb9$export$2e2bcd8739ae039) {
    constructor(opts){
        super({
            ...$99ea44ae76da8219$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        }); // mask will be created in _update
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        const { enum: enum_, ...eopts } = opts;
        if (enum_) {
            const lengths = enum_.map((e)=>e.length);
            const requiredLength = Math.min(...lengths);
            const optionalLength = Math.max(...lengths) - requiredLength;
            eopts.mask = '*'.repeat(requiredLength);
            if (optionalLength) eopts.mask += '[' + '*'.repeat(optionalLength) + ']';
            this.enum = enum_;
        }
        super._update(eopts);
    }
    _appendCharRaw(ch, flags) {
        if (flags === void 0) flags = {};
        const matchFrom = Math.min(this.nearestInputPos(0, (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_RIGHT), this.value.length);
        const matches = this.enum.filter((e)=>this.matchValue(e, this.unmaskedValue + ch, matchFrom));
        if (matches.length) {
            if (matches.length === 1) this._forEachBlocksInRange(0, this.value.length, (b, bi)=>{
                const mch = matches[0][bi];
                if (bi >= this.value.length || mch === b.value) return;
                b.reset();
                b._appendChar(mch, flags);
            });
            const d = super._appendCharRaw(matches[0][this.value.length], flags);
            if (matches.length === 1) matches[0].slice(this.unmaskedValue.length).split('').forEach((mch)=>d.aggregate(super._appendCharRaw(mch)));
            return d;
        }
        return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)({
            skip: !this.isComplete
        });
    }
    extractTail(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        // just drop tail
        return new (0, $c9d9fedd20e4a1e7$export$2e2bcd8739ae039)('', fromPos);
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        if (fromPos === toPos) return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        const matchFrom = Math.min(super.nearestInputPos(0, (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_RIGHT), this.value.length);
        let pos;
        for(pos = fromPos; pos >= 0; --pos){
            const matches = this.enum.filter((e)=>this.matchValue(e, this.value.slice(matchFrom, pos), matchFrom));
            if (matches.length > 1) break;
        }
        const details = super.remove(pos, toPos);
        details.tailShift += pos - fromPos;
        return details;
    }
    get isComplete() {
        return this.enum.indexOf(this.value) >= 0;
    }
}
/** Match enum value */ $99ea44ae76da8219$export$2e2bcd8739ae039.DEFAULTS = {
    ...(0, $836f3f1cf9656cb9$export$2e2bcd8739ae039).DEFAULTS,
    matchValue: (estr, istr, matchFrom)=>estr.indexOf(istr, matchFrom) === matchFrom
};
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedEnum = $99ea44ae76da8219$export$2e2bcd8739ae039;








/** Masking by custom Function */ class $4d81b642b6b84d27$export$2e2bcd8739ae039 extends (0, $e23198c8dcc9cc5a$export$2e2bcd8739ae039) {
    /** */ /** Enable characters overwriting */ /** */ /** */ /** */ updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        super._update({
            ...opts,
            validate: opts.mask
        });
    }
}
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedFunction = $4d81b642b6b84d27$export$2e2bcd8739ae039;







var $282132fc7196c51f$var$_MaskedNumber;
/** Number mask */ class $282132fc7196c51f$export$2e2bcd8739ae039 extends (0, $e23198c8dcc9cc5a$export$2e2bcd8739ae039) {
    /** Single char */ /** Single char */ /** Array of single chars */ /** */ /** */ /** Digits after point */ /** Flag to remove leading and trailing zeros in the end of editing */ /** Flag to pad trailing zeros after point in the end of editing */ /** Enable characters overwriting */ /** */ /** */ /** */ /** Format typed value to string */ /** Parse string to get typed value */ constructor(opts){
        super({
            ...$282132fc7196c51f$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        });
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        super._update(opts);
        this._updateRegExps();
    }
    _updateRegExps() {
        const start = '^' + (this.allowNegative ? '[+|\\-]?' : '');
        const mid = '\\d*';
        const end = (this.scale ? "(" + (0, $93906f2a377dc74e$export$7c57da42ce8e346f)(this.radix) + "\\d{0," + this.scale + "})?" : '') + '$';
        this._numberRegExp = new RegExp(start + mid + end);
        this._mapToRadixRegExp = new RegExp("[" + this.mapToRadix.map((0, $93906f2a377dc74e$export$7c57da42ce8e346f)).join('') + "]", 'g');
        this._thousandsSeparatorRegExp = new RegExp((0, $93906f2a377dc74e$export$7c57da42ce8e346f)(this.thousandsSeparator), 'g');
    }
    _removeThousandsSeparators(value) {
        return value.replace(this._thousandsSeparatorRegExp, '');
    }
    _insertThousandsSeparators(value) {
        // https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
        const parts = value.split(this.radix);
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator);
        return parts.join(this.radix);
    }
    doPrepareChar(ch, flags) {
        if (flags === void 0) flags = {};
        const [prepCh, details] = super.doPrepareChar(this._removeThousandsSeparators(this.scale && this.mapToRadix.length && /*
      radix should be mapped when
      1) input is done from keyboard = flags.input && flags.raw
      2) unmasked value is set = !flags.input && !flags.raw
      and should not be mapped when
      1) value is set = flags.input && !flags.raw
      2) raw value is set = !flags.input && flags.raw
    */ (flags.input && flags.raw || !flags.input && !flags.raw) ? ch.replace(this._mapToRadixRegExp, this.radix) : ch), flags);
        if (ch && !prepCh) details.skip = true;
        if (prepCh && !this.allowPositive && !this.value && prepCh !== '-') details.aggregate(this._appendChar('-'));
        return [
            prepCh,
            details
        ];
    }
    _separatorsCount(to, extendOnSeparators) {
        if (extendOnSeparators === void 0) extendOnSeparators = false;
        let count = 0;
        for(let pos = 0; pos < to; ++pos)if (this._value.indexOf(this.thousandsSeparator, pos) === pos) {
            ++count;
            if (extendOnSeparators) to += this.thousandsSeparator.length;
        }
        return count;
    }
    _separatorsCountFromSlice(slice) {
        if (slice === void 0) slice = this._value;
        return this._separatorsCount(this._removeThousandsSeparators(slice).length, true);
    }
    extractInput(fromPos, toPos, flags) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        [fromPos, toPos] = this._adjustRangeWithSeparators(fromPos, toPos);
        return this._removeThousandsSeparators(super.extractInput(fromPos, toPos, flags));
    }
    _appendCharRaw(ch, flags) {
        if (flags === void 0) flags = {};
        const prevBeforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;
        const prevBeforeTailSeparatorsCount = this._separatorsCountFromSlice(prevBeforeTailValue);
        this._value = this._removeThousandsSeparators(this.value);
        const oldValue = this._value;
        this._value += ch;
        const num = this.number;
        let accepted = !isNaN(num);
        let skip = false;
        if (accepted) {
            let fixedNum;
            if (this.min != null && this.min < 0 && this.number < this.min) fixedNum = this.min;
            if (this.max != null && this.max > 0 && this.number > this.max) fixedNum = this.max;
            if (fixedNum != null) {
                if (this.autofix) {
                    this._value = this.format(fixedNum, this).replace($282132fc7196c51f$export$2e2bcd8739ae039.UNMASKED_RADIX, this.radix);
                    skip || (skip = oldValue === this._value && !flags.tail); // if not changed on tail it's still ok to proceed
                } else accepted = false;
            }
            accepted && (accepted = Boolean(this._value.match(this._numberRegExp)));
        }
        let appendDetails;
        if (!accepted) {
            this._value = oldValue;
            appendDetails = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        } else appendDetails = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)({
            inserted: this._value.slice(oldValue.length),
            rawInserted: skip ? '' : ch,
            skip: skip
        });
        this._value = this._insertThousandsSeparators(this._value);
        const beforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;
        const beforeTailSeparatorsCount = this._separatorsCountFromSlice(beforeTailValue);
        appendDetails.tailShift += (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length;
        return appendDetails;
    }
    _findSeparatorAround(pos) {
        if (this.thousandsSeparator) {
            const searchFrom = pos - this.thousandsSeparator.length + 1;
            const separatorPos = this.value.indexOf(this.thousandsSeparator, searchFrom);
            if (separatorPos <= pos) return separatorPos;
        }
        return -1;
    }
    _adjustRangeWithSeparators(from, to) {
        const separatorAroundFromPos = this._findSeparatorAround(from);
        if (separatorAroundFromPos >= 0) from = separatorAroundFromPos;
        const separatorAroundToPos = this._findSeparatorAround(to);
        if (separatorAroundToPos >= 0) to = separatorAroundToPos + this.thousandsSeparator.length;
        return [
            from,
            to
        ];
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        [fromPos, toPos] = this._adjustRangeWithSeparators(fromPos, toPos);
        const valueBeforePos = this.value.slice(0, fromPos);
        const valueAfterPos = this.value.slice(toPos);
        const prevBeforeTailSeparatorsCount = this._separatorsCount(valueBeforePos.length);
        this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(valueBeforePos + valueAfterPos));
        const beforeTailSeparatorsCount = this._separatorsCountFromSlice(valueBeforePos);
        return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)({
            tailShift: (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length
        });
    }
    nearestInputPos(cursorPos, direction) {
        if (!this.thousandsSeparator) return cursorPos;
        switch(direction){
            case (0, $93906f2a377dc74e$export$9106728c49045482).NONE:
            case (0, $93906f2a377dc74e$export$9106728c49045482).LEFT:
            case (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_LEFT:
                {
                    const separatorAtLeftPos = this._findSeparatorAround(cursorPos - 1);
                    if (separatorAtLeftPos >= 0) {
                        const separatorAtLeftEndPos = separatorAtLeftPos + this.thousandsSeparator.length;
                        if (cursorPos < separatorAtLeftEndPos || this.value.length <= separatorAtLeftEndPos || direction === (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_LEFT) return separatorAtLeftPos;
                    }
                    break;
                }
            case (0, $93906f2a377dc74e$export$9106728c49045482).RIGHT:
            case (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_RIGHT:
                {
                    const separatorAtRightPos = this._findSeparatorAround(cursorPos);
                    if (separatorAtRightPos >= 0) return separatorAtRightPos + this.thousandsSeparator.length;
                }
        }
        return cursorPos;
    }
    doCommit() {
        if (this.value) {
            const number = this.number;
            let validnum = number;
            // check bounds
            if (this.min != null) validnum = Math.max(validnum, this.min);
            if (this.max != null) validnum = Math.min(validnum, this.max);
            if (validnum !== number) this.unmaskedValue = this.format(validnum, this);
            let formatted = this.value;
            if (this.normalizeZeros) formatted = this._normalizeZeros(formatted);
            if (this.padFractionalZeros && this.scale > 0) formatted = this._padFractionalZeros(formatted);
            this._value = formatted;
        }
        super.doCommit();
    }
    _normalizeZeros(value) {
        const parts = this._removeThousandsSeparators(value).split(this.radix);
        // remove leading zeros
        parts[0] = parts[0].replace(/^(\D*)(0*)(\d*)/, (match, sign, zeros, num)=>sign + num);
        // add leading zero
        if (value.length && !/\d$/.test(parts[0])) parts[0] = parts[0] + '0';
        if (parts.length > 1) {
            parts[1] = parts[1].replace(/0*$/, ''); // remove trailing zeros
            if (!parts[1].length) parts.length = 1; // remove fractional
        }
        return this._insertThousandsSeparators(parts.join(this.radix));
    }
    _padFractionalZeros(value) {
        if (!value) return value;
        const parts = value.split(this.radix);
        if (parts.length < 2) parts.push('');
        parts[1] = parts[1].padEnd(this.scale, '0');
        return parts.join(this.radix);
    }
    doSkipInvalid(ch, flags, checkTail) {
        if (flags === void 0) flags = {};
        const dropFractional = this.scale === 0 && ch !== this.thousandsSeparator && (ch === this.radix || ch === $282132fc7196c51f$export$2e2bcd8739ae039.UNMASKED_RADIX || this.mapToRadix.includes(ch));
        return super.doSkipInvalid(ch, flags, checkTail) && !dropFractional;
    }
    get unmaskedValue() {
        return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, $282132fc7196c51f$export$2e2bcd8739ae039.UNMASKED_RADIX);
    }
    set unmaskedValue(unmaskedValue) {
        super.unmaskedValue = unmaskedValue;
    }
    get typedValue() {
        return this.parse(this.unmaskedValue, this);
    }
    set typedValue(n) {
        this.rawInputValue = this.format(n, this).replace($282132fc7196c51f$export$2e2bcd8739ae039.UNMASKED_RADIX, this.radix);
    }
    /** Parsed Number */ get number() {
        return this.typedValue;
    }
    set number(number) {
        this.typedValue = number;
    }
    get allowNegative() {
        return this.min != null && this.min < 0 || this.max != null && this.max < 0;
    }
    get allowPositive() {
        return this.min != null && this.min > 0 || this.max != null && this.max > 0;
    }
    typedValueEquals(value) {
        // handle  0 -> '' case (typed = 0 even if value = '')
        // for details see https://github.com/uNmAnNeR/imaskjs/issues/134
        return (super.typedValueEquals(value) || $282132fc7196c51f$export$2e2bcd8739ae039.EMPTY_VALUES.includes(value) && $282132fc7196c51f$export$2e2bcd8739ae039.EMPTY_VALUES.includes(this.typedValue)) && !(value === 0 && this.value === '');
    }
}
$282132fc7196c51f$var$_MaskedNumber = $282132fc7196c51f$export$2e2bcd8739ae039;
$282132fc7196c51f$export$2e2bcd8739ae039.UNMASKED_RADIX = '.';
$282132fc7196c51f$export$2e2bcd8739ae039.EMPTY_VALUES = [
    ...(0, $e23198c8dcc9cc5a$export$2e2bcd8739ae039).EMPTY_VALUES,
    0
];
$282132fc7196c51f$export$2e2bcd8739ae039.DEFAULTS = {
    ...(0, $e23198c8dcc9cc5a$export$2e2bcd8739ae039).DEFAULTS,
    mask: Number,
    radix: ',',
    thousandsSeparator: '',
    mapToRadix: [
        $282132fc7196c51f$var$_MaskedNumber.UNMASKED_RADIX
    ],
    min: Number.MIN_SAFE_INTEGER,
    max: Number.MAX_SAFE_INTEGER,
    scale: 2,
    normalizeZeros: true,
    padFractionalZeros: false,
    parse: Number,
    format: (n)=>n.toLocaleString('en-US', {
            useGrouping: false,
            maximumFractionDigits: 20
        })
};
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedNumber = $282132fc7196c51f$export$2e2bcd8739ae039;









/** Mask pipe source and destination types */ const $2226a75bb81f0562$export$90dab59c3d4b6e03 = {
    MASKED: 'value',
    UNMASKED: 'unmaskedValue',
    TYPED: 'typedValue'
};
/** Creates new pipe function depending on mask type, source and destination options */ function $2226a75bb81f0562$export$a504d53a5b99e1b9(arg, from, to) {
    if (from === void 0) from = $2226a75bb81f0562$export$90dab59c3d4b6e03.MASKED;
    if (to === void 0) to = $2226a75bb81f0562$export$90dab59c3d4b6e03.MASKED;
    const masked = (0, $14fa5ae7a370b810$export$2e2bcd8739ae039)(arg);
    return (value)=>masked.runIsolated((m)=>{
            m[from] = value;
            return m[to];
        });
}
/** Pipes value through mask depending on mask type, source and destination options */ function $2226a75bb81f0562$export$a4627e546088548d(value, mask, from, to) {
    return $2226a75bb81f0562$export$a504d53a5b99e1b9(mask, from, to)(value);
}
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).PIPE_TYPE = $2226a75bb81f0562$export$90dab59c3d4b6e03;
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).createPipe = $2226a75bb81f0562$export$a504d53a5b99e1b9;
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).pipe = $2226a75bb81f0562$export$a4627e546088548d;
















/** Pattern mask */ class $d7a345ba913aa7ee$export$2e2bcd8739ae039 extends (0, $836f3f1cf9656cb9$export$2e2bcd8739ae039) {
    get repeatFrom() {
        var _ref;
        return (_ref = Array.isArray(this.repeat) ? this.repeat[0] : this.repeat === Infinity ? 0 : this.repeat) != null ? _ref : 0;
    }
    get repeatTo() {
        var _ref2;
        return (_ref2 = Array.isArray(this.repeat) ? this.repeat[1] : this.repeat) != null ? _ref2 : Infinity;
    }
    constructor(opts){
        super(opts);
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        var _ref3, _ref4, _this$_blocks;
        const { repeat: repeat, ...blockOpts } = (0, $14fa5ae7a370b810$export$a213ae1c699d7230)(opts); // TODO type
        this._blockOpts = Object.assign({}, this._blockOpts, blockOpts);
        const block = (0, $14fa5ae7a370b810$export$2e2bcd8739ae039)(this._blockOpts);
        this.repeat = (_ref3 = (_ref4 = repeat != null ? repeat : block.repeat) != null ? _ref4 : this.repeat) != null ? _ref3 : Infinity; // TODO type
        super._update({
            mask: 'm'.repeat(Math.max(this.repeatTo === Infinity && ((_this$_blocks = this._blocks) == null ? void 0 : _this$_blocks.length) || 0, this.repeatFrom)),
            blocks: {
                m: block
            },
            eager: block.eager,
            overwrite: block.overwrite,
            skipInvalid: block.skipInvalid,
            lazy: block.lazy,
            placeholderChar: block.placeholderChar,
            displayChar: block.displayChar
        });
    }
    _allocateBlock(bi) {
        if (bi < this._blocks.length) return this._blocks[bi];
        if (this.repeatTo === Infinity || this._blocks.length < this.repeatTo) {
            this._blocks.push((0, $14fa5ae7a370b810$export$2e2bcd8739ae039)(this._blockOpts));
            this.mask += 'm';
            return this._blocks[this._blocks.length - 1];
        }
    }
    _appendCharRaw(ch, flags) {
        if (flags === void 0) flags = {};
        const details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        for(let bi = (_this$_mapPosToBlock$ = (_this$_mapPosToBlock = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : _this$_mapPosToBlock.index) != null ? _this$_mapPosToBlock$ : Math.max(this._blocks.length - 1, 0), block, allocated; // try to get a block or
        // try to allocate a new block if not allocated already
        block = (_this$_blocks$bi = this._blocks[bi]) != null ? _this$_blocks$bi : allocated = !allocated && this._allocateBlock(bi); ++bi){
            var _this$_mapPosToBlock$, _this$_mapPosToBlock, _this$_blocks$bi, _flags$_beforeTailSta;
            const blockDetails = block._appendChar(ch, {
                ...flags,
                _beforeTailState: (_flags$_beforeTailSta = flags._beforeTailState) == null || (_flags$_beforeTailSta = _flags$_beforeTailSta._blocks) == null ? void 0 : _flags$_beforeTailSta[bi]
            });
            if (blockDetails.skip && allocated) {
                // remove the last allocated block and break
                this._blocks.pop();
                this.mask = this.mask.slice(1);
                break;
            }
            details.aggregate(blockDetails);
            if (blockDetails.consumed) break; // go next char
        }
        return details;
    }
    _trimEmptyTail(fromPos, toPos) {
        var _this$_mapPosToBlock2, _this$_mapPosToBlock3;
        if (fromPos === void 0) fromPos = 0;
        const firstBlockIndex = Math.max(((_this$_mapPosToBlock2 = this._mapPosToBlock(fromPos)) == null ? void 0 : _this$_mapPosToBlock2.index) || 0, this.repeatFrom, 0);
        let lastBlockIndex;
        if (toPos != null) lastBlockIndex = (_this$_mapPosToBlock3 = this._mapPosToBlock(toPos)) == null ? void 0 : _this$_mapPosToBlock3.index;
        if (lastBlockIndex == null) lastBlockIndex = this._blocks.length - 1;
        let removeCount = 0;
        for(let blockIndex = lastBlockIndex; firstBlockIndex <= blockIndex; --blockIndex, ++removeCount){
            if (this._blocks[blockIndex].unmaskedValue) break;
        }
        if (removeCount) {
            this._blocks.splice(lastBlockIndex - removeCount + 1, removeCount);
            this.mask = this.mask.slice(removeCount);
        }
    }
    reset() {
        super.reset();
        this._trimEmptyTail();
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        const removeDetails = super.remove(fromPos, toPos);
        this._trimEmptyTail(fromPos, toPos);
        return removeDetails;
    }
    totalInputPositions(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos == null && this.repeatTo === Infinity) return Infinity;
        return super.totalInputPositions(fromPos, toPos);
    }
    get state() {
        return super.state;
    }
    set state(state) {
        this._blocks.length = state._blocks.length;
        this.mask = this.mask.slice(0, this._blocks.length);
        super.state = state;
    }
}
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).RepeatBlock = $d7a345ba913aa7ee$export$2e2bcd8739ae039;






try {
    globalThis.IMask = (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039);
} catch  {}


if (typeof window.Field === 'undefined') window.Field = class Field {
    constructor(input){
        this.input = input;
    }
    validate() {
        const isValid = this.input.checkValidity();
        this.input.classList.toggle('is-invalid', !isValid);
        return isValid;
    }
    report() {
        this.input.reportValidity();
    }
};


if (typeof window.IMask === 'undefined') window.IMask = (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039);
if (typeof window.Phone === 'undefined') window.Phone = class Phone extends window.Field {
    constructor(input){
        super(input);
        this.mask = window.IMask(input, {
            mask: '+{7} (000) 000-00-00'
        });
        input.imask = this.mask;
    }
};


if (typeof window.MaskApplicator === 'undefined') window.MaskApplicator = class MaskApplicator {
    constructor(container){
        this.types = {
            phone: window.Phone
        };
        this.apply(container || document);
    }
    apply(container) {
        const fields = container.querySelectorAll('[data-mask]');
        for (const input of fields){
            if (input.dataset.maskApplied === '1') continue;
            new this.types[input.dataset.mask](input);
            input.dataset.maskApplied = '1';
        }
    }
};


if (typeof window.B2bCalculationForm === 'undefined') window.B2bCalculationForm = class B2bCalculationForm {
    constructor(){
        this.isSaving = false;
        this.captchaWidgetId = null;
        this.api = new window.B2bCalculationApi();
        this.eventRegister();
        new window.MaskApplicator(document.querySelector('[data-b2b-form]'));
        this.initCaptcha();
    }
    eventRegister() {
        const form = document.querySelector('[data-b2b-form]');
        form.onsubmit = this.handleSubmit.bind(this);
        const fields = document.querySelectorAll('[data-b2b-form] [data-field]');
        for (const field of fields){
            field.oninput = this.clearFieldError.bind(this, field);
            field.onchange = this.clearFieldError.bind(this, field);
        }
    }
    initCaptcha() {
        const scriptSrc = 'https://smartcaptcha.yandexcloud.net/captcha.js';
        if (window.smartCaptcha) {
            this.renderCaptcha();
            return;
        }
        if (!document.querySelector(`script[src*="smartcaptcha.yandexcloud.net"]`)) {
            const script = document.createElement('script');
            script.src = scriptSrc;
            script.async = true;
            script.onload = this.renderCaptcha.bind(this);
            document.head.appendChild(script);
            return;
        }
        const waitForCaptcha = ()=>{
            if (window.smartCaptcha) {
                this.renderCaptcha();
                return;
            }
            window.setTimeout(waitForCaptcha, 100);
        };
        waitForCaptcha();
    }
    renderCaptcha() {
        const container = document.querySelector('[data-b2b-captcha]');
        if (this.captchaWidgetId !== null) return;
        this.captchaWidgetId = window.smartCaptcha.render(container.id, {
            sitekey: container.getAttribute('data-sitekey')
        });
    }
    resetCaptcha() {
        if (!window.smartCaptcha) return;
        if (this.captchaWidgetId !== null) {
            window.smartCaptcha.reset(this.captchaWidgetId);
            return;
        }
        window.smartCaptcha.reset();
    }
    validate() {
        const fields = document.querySelectorAll('[data-b2b-form] [data-field]');
        for (const field of fields){
            if (field.disabled || field.hidden || field.closest('[hidden]')) continue;
            const valid = field.checkValidity();
            field.classList.toggle('is-invalid', !valid);
            if (!valid) {
                field.reportValidity();
                return false;
            }
        }
        const captchaInput = document.querySelector('[data-b2b-captcha] input[name="smart-token"]');
        if (!captchaInput || captchaInput.value === '') {
            this.showStatus("\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435, \u0447\u0442\u043E \u0432\u044B \u043D\u0435 \u0440\u043E\u0431\u043E\u0442", true);
            return false;
        }
        return true;
    }
    clearFieldError(field) {
        field.classList.remove('is-invalid');
    }
    showStatus(message, isError) {
        const status = document.querySelector('[data-b2b-form-status]');
        status.hidden = false;
        status.textContent = message;
        status.classList.toggle('b2b-form__status--error', isError);
        status.classList.toggle('b2b-form__status--success', !isError);
    }
    hideStatus() {
        const status = document.querySelector('[data-b2b-form-status]');
        status.hidden = true;
        status.textContent = '';
    }
    async handleSubmit(event) {
        event.preventDefault();
        if (this.isSaving) return;
        this.hideStatus();
        if (!this.validate()) return;
        this.isSaving = true;
        const submit = document.querySelector('[data-b2b-form-submit]');
        submit.disabled = true;
        try {
            await this.api.send(this.api.collect());
            document.querySelector('[data-b2b-form]').reset();
            document.querySelector('[data-b2b-form] [data-mask="phone"]').imask.value = '';
            this.resetCaptcha();
            this.showStatus("\u0417\u0430\u044F\u0432\u043A\u0430 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0430", false);
        } catch (error) {
            this.showStatus(error.message, true);
            this.resetCaptcha();
        } finally{
            this.isSaving = false;
            submit.disabled = false;
        }
    }
};


if (typeof window.B2bOffersSlider === 'undefined') window.B2bOffersSlider = class B2bOffersSlider {
    constructor(){
        this.slider = null;
        this.eventRegister();
        this.initSlider();
    }
    eventRegister() {
    // кнопки prev/next передаются в Swiper Navigation
    }
    initSlider() {
        const viewport = document.querySelector('[data-b2b-offers-viewport]');
        this.slider = new (0, $029bc59d811a92d7$export$25ce5a424b770e84)(viewport, {
            modules: [
                (0, $9dcb69c205fd1703$export$2e2bcd8739ae039)
            ],
            wrapperClass: 'b2b-offers__list',
            slideClass: 'b2b-offers__slide',
            navigation: {
                prevEl: document.querySelector('[data-b2b-offers-prev]'),
                nextEl: document.querySelector('[data-b2b-offers-next]')
            },
            slidesPerView: 'auto',
            spaceBetween: 20,
            watchOverflow: true,
            loop: false
        });
    }
};
function $769fd1470e97cf46$export$be0182c2e8635a31() {
    if (document.querySelector('[data-b2b-offers]')) window.b2bOffersSlider = new window.B2bOffersSlider();
    if (document.querySelector('[data-b2b-form]')) window.b2bCalculationForm = new window.B2bCalculationForm();
}


function $20dfc54738b420cf$var$initPageComponents() {
    (0, $e6c0450a86c01bf1$export$3caf05f86a056cb3)();
    (0, $b089cdbee9da5cef$export$f6efd7ffac56f434)();
    (0, $769fd1470e97cf46$export$be0182c2e8635a31)();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $20dfc54738b420cf$var$initPageComponents);
else $20dfc54738b420cf$var$initPageComponents();



})();
//# sourceMappingURL=index.js.map
